webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cDNt");


/***/ }),

/***/ "8Sw2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "FQor",
	"./af.js": "FQor",
	"./ar": "EcI0",
	"./ar-dz": "cw72",
	"./ar-dz.js": "cw72",
	"./ar-kw": "fu+8",
	"./ar-kw.js": "fu+8",
	"./ar-ly": "7CVz",
	"./ar-ly.js": "7CVz",
	"./ar-ma": "1dFW",
	"./ar-ma.js": "1dFW",
	"./ar-sa": "UxV2",
	"./ar-sa.js": "UxV2",
	"./ar-tn": "nm31",
	"./ar-tn.js": "nm31",
	"./ar.js": "EcI0",
	"./az": "EbpX",
	"./az.js": "EbpX",
	"./be": "SQlX",
	"./be.js": "SQlX",
	"./bg": "R3V+",
	"./bg.js": "R3V+",
	"./bm": "mH+W",
	"./bm.js": "mH+W",
	"./bn": "cAX3",
	"./bn.js": "cAX3",
	"./bo": "dHgA",
	"./bo.js": "dHgA",
	"./br": "W7ww",
	"./br.js": "W7ww",
	"./bs": "lZ6K",
	"./bs.js": "lZ6K",
	"./ca": "udbC",
	"./ca.js": "udbC",
	"./cs": "oSQb",
	"./cs.js": "oSQb",
	"./cv": "yPEm",
	"./cv.js": "yPEm",
	"./cy": "PpYB",
	"./cy.js": "PpYB",
	"./da": "oiZG",
	"./da.js": "oiZG",
	"./de": "LYe6",
	"./de-at": "KOG5",
	"./de-at.js": "KOG5",
	"./de-ch": "o3JY",
	"./de-ch.js": "o3JY",
	"./de.js": "LYe6",
	"./dv": "OkYT",
	"./dv.js": "OkYT",
	"./el": "QFnp",
	"./el.js": "QFnp",
	"./en-au": "dBGl",
	"./en-au.js": "dBGl",
	"./en-ca": "vv0C",
	"./en-ca.js": "vv0C",
	"./en-gb": "IoCy",
	"./en-gb.js": "IoCy",
	"./en-ie": "qVAg",
	"./en-ie.js": "qVAg",
	"./en-il": "plqA",
	"./en-il.js": "plqA",
	"./en-nz": "FbT0",
	"./en-nz.js": "FbT0",
	"./eo": "y/6j",
	"./eo.js": "y/6j",
	"./es": "ivpd",
	"./es-do": "DBbP",
	"./es-do.js": "DBbP",
	"./es-us": "RJPF",
	"./es-us.js": "RJPF",
	"./es.js": "ivpd",
	"./et": "FrUj",
	"./et.js": "FrUj",
	"./eu": "LAVD",
	"./eu.js": "LAVD",
	"./fa": "J2cK",
	"./fa.js": "J2cK",
	"./fi": "5FCP",
	"./fi.js": "5FCP",
	"./fo": "jIZb",
	"./fo.js": "jIZb",
	"./fr": "Lq8I",
	"./fr-ca": "ICRA",
	"./fr-ca.js": "ICRA",
	"./fr-ch": "QWmo",
	"./fr-ch.js": "QWmo",
	"./fr.js": "Lq8I",
	"./fy": "Fbnp",
	"./fy.js": "Fbnp",
	"./gd": "zhFu",
	"./gd.js": "zhFu",
	"./gl": "o10m",
	"./gl.js": "o10m",
	"./gom-latn": "UoXv",
	"./gom-latn.js": "UoXv",
	"./gu": "yUwm",
	"./gu.js": "yUwm",
	"./he": "gbvS",
	"./he.js": "gbvS",
	"./hi": "+UQz",
	"./hi.js": "+UQz",
	"./hr": "qGYH",
	"./hr.js": "qGYH",
	"./hu": "hGGh",
	"./hu.js": "hGGh",
	"./hy-am": "1AR5",
	"./hy-am.js": "1AR5",
	"./id": "Ie9h",
	"./id.js": "Ie9h",
	"./is": "piS+",
	"./is.js": "piS+",
	"./it": "5P9/",
	"./it.js": "5P9/",
	"./ja": "3cRe",
	"./ja.js": "3cRe",
	"./jv": "vwCJ",
	"./jv.js": "vwCJ",
	"./ka": "R7aq",
	"./ka.js": "R7aq",
	"./kk": "d8hV",
	"./kk.js": "d8hV",
	"./km": "nCdc",
	"./km.js": "nCdc",
	"./kn": "5K8n",
	"./kn.js": "5K8n",
	"./ko": "1jN3",
	"./ko.js": "1jN3",
	"./ky": "74/W",
	"./ky.js": "74/W",
	"./lb": "XAyT",
	"./lb.js": "XAyT",
	"./lo": "w/Mz",
	"./lo.js": "w/Mz",
	"./lt": "IetG",
	"./lt.js": "IetG",
	"./lv": "CRPd",
	"./lv.js": "CRPd",
	"./me": "1mee",
	"./me.js": "1mee",
	"./mi": "yRr3",
	"./mi.js": "yRr3",
	"./mk": "bfn1",
	"./mk.js": "bfn1",
	"./ml": "r1ky",
	"./ml.js": "r1ky",
	"./mn": "CmNS",
	"./mn.js": "CmNS",
	"./mr": "+K6p",
	"./mr.js": "+K6p",
	"./ms": "asMk",
	"./ms-my": "IcWU",
	"./ms-my.js": "IcWU",
	"./ms.js": "asMk",
	"./mt": "yJmD",
	"./mt.js": "yJmD",
	"./my": "Isng",
	"./my.js": "Isng",
	"./nb": "FjNp",
	"./nb.js": "FjNp",
	"./ne": "P9zQ",
	"./ne.js": "P9zQ",
	"./nl": "pejQ",
	"./nl-be": "c3/i",
	"./nl-be.js": "c3/i",
	"./nl.js": "pejQ",
	"./nn": "ALD8",
	"./nn.js": "ALD8",
	"./pa-in": "1YTd",
	"./pa-in.js": "1YTd",
	"./pl": "Gs99",
	"./pl.js": "Gs99",
	"./pt": "eunO",
	"./pt-br": "uHKL",
	"./pt-br.js": "uHKL",
	"./pt.js": "eunO",
	"./ro": "1FZw",
	"./ro.js": "1FZw",
	"./ru": "Cy48",
	"./ru.js": "Cy48",
	"./sd": "+28k",
	"./sd.js": "+28k",
	"./se": "EiHj",
	"./se.js": "EiHj",
	"./si": "77bI",
	"./si.js": "77bI",
	"./sk": "BgyH",
	"./sk.js": "BgyH",
	"./sl": "K7sG",
	"./sl.js": "K7sG",
	"./sq": "pwQJ",
	"./sq.js": "pwQJ",
	"./sr": "N0T2",
	"./sr-cyrl": "9OoP",
	"./sr-cyrl.js": "9OoP",
	"./sr.js": "N0T2",
	"./ss": "Mh9L",
	"./ss.js": "Mh9L",
	"./sv": "YZAt",
	"./sv.js": "YZAt",
	"./sw": "/7jV",
	"./sw.js": "/7jV",
	"./ta": "VKBt",
	"./ta.js": "VKBt",
	"./te": "TIcV",
	"./te.js": "TIcV",
	"./tet": "BlC1",
	"./tet.js": "BlC1",
	"./tg": "Ws1e",
	"./tg.js": "Ws1e",
	"./th": "Zi3L",
	"./th.js": "Zi3L",
	"./tl-ph": "D4Y9",
	"./tl-ph.js": "D4Y9",
	"./tlh": "muBP",
	"./tlh.js": "muBP",
	"./tr": "82s3",
	"./tr.js": "82s3",
	"./tzl": "vjXv",
	"./tzl.js": "vjXv",
	"./tzm": "Vhfe",
	"./tzm-latn": "m0Pg",
	"./tzm-latn.js": "m0Pg",
	"./tzm.js": "Vhfe",
	"./ug-cn": "ywOB",
	"./ug-cn.js": "ywOB",
	"./uk": "Y3Ex",
	"./uk.js": "Y3Ex",
	"./ur": "4DIg",
	"./ur.js": "4DIg",
	"./uz": "wDue",
	"./uz-latn": "Li28",
	"./uz-latn.js": "Li28",
	"./uz.js": "wDue",
	"./vi": "UbP6",
	"./vi.js": "UbP6",
	"./x-pseudo": "fQLM",
	"./x-pseudo.js": "fQLM",
	"./yo": "evMD",
	"./yo.js": "evMD",
	"./zh-cn": "DV5H",
	"./zh-cn.js": "DV5H",
	"./zh-hk": "iEKH",
	"./zh-hk.js": "iEKH",
	"./zh-tw": "X9uL",
	"./zh-tw.js": "X9uL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Sw2";

/***/ }),

/***/ "cDNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/environments/environment.ts
var environment = {
    // This should be an ENV var
    // https://github.com/angular/angular-cli/issues/4318
    production: true,
};
//# sourceMappingURL=environment.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/app.module.ts
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());

//# sourceMappingURL=app.module.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular2-token/angular2-token.es5.js
var angular2_token_es5 = __webpack_require__("bENW");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/app.component.ts

var app_component_AppComponent = (function () {
    function AppComponent(tokenService) {
        this.tokenService = tokenService;
        this.tokenService.init({
            apiPath: '/api/v1',
        });
    }
    AppComponent.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/src/$$_gendir/node_modules/angular-calendar/dist/esm/src/directives/calendarTooltip.directive.ngfactory.ts
var calendarTooltip_directive_ngfactory = __webpack_require__("/sy+");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/index.js
var ng2_completer = __webpack_require__("TYyG");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/index.js
var _ngrx_store = __webpack_require__("JgC9");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/grades.ts
var GRADES = [
    { title: "Year 3", value: "3" },
    { title: "Year 4", value: "4" },
    { title: "Year 5", value: "5" },
    { title: "Year 6", value: "6" },
    { title: "Year 7", value: "7" },
    { title: "Year 8", value: "8" },
    { title: "Year 9", value: "9" },
    { title: "Year 10", value: "10" },
    { title: "Year 11", value: "11" },
    { title: "Year 12", value: "12" },
];
//# sourceMappingURL=grades.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/schools.ts
var SCHOOLS = [
    { title: "Abbotsleigh Senior School", value: "Abbotsleigh Senior School" },
    { title: "Al Amanah College", value: "Al Amanah College" },
    { title: "Al Faisal College", value: "Al Faisal College" },
    { title: "Al Hikma College", value: "Al Hikma College" },
    { title: "Al Noori Muslim School", value: "Al Noori Muslim School" },
    { title: "Al Sadiq College", value: "Al Sadiq College" },
    { title: "Al Zahra College", value: "Al Zahra College" },
    { title: "Alexandria Park Community School", value: "Alexandria Park Community School" },
    { title: "Alexandria Park High School", value: "Alexandria Park High School" },
    { title: "Al-Faisal College", value: "Al-Faisal College" },
    { title: "All Saints Grammar", value: "All Saints Grammar" },
    { title: "Alpha Omega Senior College", value: "Alpha Omega Senior College" },
    { title: "Amity College", value: "Amity College" },
    { title: "Aquinas Catholic College", value: "Aquinas Catholic College" },
    { title: "Arden Anglican School", value: "Arden Anglican School" },
    { title: "Armidale High School", value: "Armidale High School" },
    { title: "Arthur Phillip High School", value: "Arthur Phillip High School" },
    { title: "Ascham School", value: "Ascham School" },
    { title: "Ashfield Boys High School", value: "Ashfield Boys High School" },
    { title: "Asquith Boys High School", value: "Asquith Boys High School" },
    { title: "Asquith Girls High School", value: "Asquith Girls High School" },
    { title: "Auburn Girls High School", value: "Auburn Girls High School" },
    { title: "Australian Christian College", value: "Australian Christian College" },
    { title: "Australian Institute of Music", value: "Australian Institute of Music" },
    { title: "Australian International Academy", value: "Australian International Academy" },
    { title: "Australian Islamic College of Sydney", value: "Australian Islamic College of Sydney" },
    { title: "Australian Performing Arts Grammar School", value: "Australian Performing Arts Grammar School" },
    { title: "Avondale School", value: "Avondale School" },
    { title: "Balgowlah Boys High School", value: "Balgowlah Boys High School" },
    { title: "Bankstown Senior College", value: "Bankstown Senior College" },
    { title: "Barker College", value: "Barker College" },
    { title: "Barker High School", value: "Barker High School" },
    { title: "Bass High School", value: "Bass High School" },
    { title: "Baulkham Hills High School", value: "Baulkham Hills High School" },
    { title: "Bethany College", value: "Bethany College" },
    { title: "Bethlehem College", value: "Bethlehem College" },
    { title: "Beverly Hills Girls High School", value: "Beverly Hills Girls High School" },
    { title: "Birrong Boys High School", value: "Birrong Boys High School" },
    { title: "Birrong Girls High School", value: "Birrong Girls High School" },
    { title: "Bishop Tyrrell Anglican College", value: "Bishop Tyrrell Anglican College" },
    { title: "Blacktown Boys High School", value: "Blacktown Boys High School" },
    { title: "Blacktown Girls High School", value: "Blacktown Girls High School" },
    { title: "Blakehurst High School", value: "Blakehurst High School" },
    { title: "Blue Mountains Grammar School", value: "Blue Mountains Grammar School" },
    { title: "Bonnyrigg High School", value: "Bonnyrigg High School" },
    { title: "Bossley Park High School", value: "Bossley Park High School" },
    { title: "Brigidine College", value: "Brigidine College" },
    { title: "Brigidine College Randwick", value: "Brigidine College Randwick" },
    { title: "Burwood Girls High School", value: "Burwood Girls High School" },
    { title: "Cabramatta High School", value: "Cabramatta High School" },
    { title: "Cambridge Park High School", value: "Cambridge Park High School" },
    { title: "Cammeraygal High School", value: "Cammeraygal High School" },
    { title: "Campsie High School", value: "Campsie High School" },
    { title: "Canbarra Grammar School", value: "Canbarra Grammar School" },
    { title: "Canberra Girls Grammar School", value: "Canberra Girls Grammar School" },
    { title: "Canley Vale High School", value: "Canley Vale High School" },
    { title: "Canterbury Boys High School", value: "Canterbury Boys High School" },
    { title: "Canterbury Girls High School", value: "Canterbury Girls High School" },
    { title: "Caringbah High School", value: "Caringbah High School" },
    { title: "Carlingford High School", value: "Carlingford High School" },
    { title: "Caroline Chisholm College", value: "Caroline Chisholm College" },
    { title: "Caroline Chisholm School", value: "Caroline Chisholm School" },
    { title: "Casimir Catholic College", value: "Casimir Catholic College" },
    { title: "Castle Hill High School", value: "Castle Hill High School" },
    { title: "Casula High School", value: "Casula High School" },
    { title: "Catherine McAuley", value: "Catherine McAuley" },
    { title: "Central Coast Adventist", value: "Central Coast Adventist" },
    { title: "Central Coast Grammar School", value: "Central Coast Grammar School" },
    { title: "Cerdon College", value: "Cerdon College" },
    { title: "Chatswood High School", value: "Chatswood High School" },
    { title: "Cheltenham Girls High School", value: "Cheltenham Girls High School" },
    { title: "Cherrybrook Technology High School", value: "Cherrybrook Technology High School" },
    { title: "Chevalier College", value: "Chevalier College" },
    { title: "Chrestwood High School", value: "Chrestwood High School" },
    { title: "Christ The King School", value: "Christ The King School" },
    { title: "Christian Brothers High School Lewisham", value: "Christian Brothers High School Lewisham" },
    { title: "Concord High School", value: "Concord High School" },
    { title: "Conservatorium High School", value: "Conservatorium High School" },
    { title: "Covenant Christian School", value: "Covenant Christian School" },
    { title: "Cranbrook School", value: "Cranbrook School" },
    { title: "Crestwood High School", value: "Crestwood High School" },
    { title: "Croydon High School", value: "Croydon High School" },
    { title: "Cumberland High School", value: "Cumberland High School" },
    { title: "Danebank Anglican School for Girls", value: "Danebank Anglican School for Girls" },
    { title: "Davidson High School", value: "Davidson High School" },
    { title: "De La Salle Ashfield", value: "De La Salle Ashfield" },
    { title: "De La Salle Revesby", value: "De La Salle Revesby" },
    { title: "Delany College", value: "Delany College" },
    { title: "Denistone East Public School", value: "Denistone East Public School" },
    { title: "Domremy College", value: "Domremy College" },
    { title: "Dulwich Hill High", value: "Dulwich Hill High" },
    { title: "Dural Public School", value: "Dural Public School" },
    { title: "East Hills Boys High School", value: "East Hills Boys High School" },
    { title: "East Hills Girls Technology High School", value: "East Hills Girls Technology High School" },
    { title: "Epping Boys High School", value: "Epping Boys High School" },
    { title: "Erksine Park High School", value: "Erksine Park High School" },
    { title: "Evans High School", value: "Evans High School" },
    { title: "Fairvale High School", value: "Fairvale High School" },
    { title: "Fort Street High School", value: "Fort Street High School" },
    { title: "Freeman Catholic College", value: "Freeman Catholic College" },
    { title: "Frensham School", value: "Frensham School" },
    { title: "Freshwater Senior Campus", value: "Freshwater Senior Campus" },
    { title: "George Hall Public School", value: "George Hall Public School" },
    { title: "Georges River College Hurstville Boys Campus", value: "Georges River College Hurstville Boys Campus" },
    { title: "Georges River College Oatley Senior Campus", value: "Georges River College Oatley Senior Campus" },
    { title: "Georges River Grammar School", value: "Georges River Grammar School" },
    { title: "German International School Sydney", value: "German International School Sydney" },
    { title: "Girraween High School", value: "Girraween High School" },
    { title: "Gleenwood High School", value: "Gleenwood High School" },
    { title: "Glenaeon Rudolf Steiner School", value: "Glenaeon Rudolf Steiner School" },
    { title: "Glenmore Park High", value: "Glenmore Park High" },
    { title: "Glenwood High School", value: "Glenwood High School" },
    { title: "Good Samaritan Catholic College", value: "Good Samaritan Catholic College" },
    { title: "Gosford High School", value: "Gosford High School" },
    { title: "Granville Boys High School", value: "Granville Boys High School" },
    { title: "GRC Penshurst Campus", value: "GRC Penshurst Campus" },
    { title: "Green Point Christian College", value: "Green Point Christian College" },
    { title: "Greenacre Baptist Christian Community School", value: "Greenacre Baptist Christian Community School" },
    { title: "Greenwood School for Girls", value: "Greenwood School for Girls" },
    { title: "Greystanes High School", value: "Greystanes High School" },
    { title: "Gymea Technology High School", value: "Gymea Technology High School" },
    { title: "Hanyong Foreign Language High School", value: "Hanyong Foreign Language High School" },
    { title: "Heathcote High School", value: "Heathcote High School" },
    { title: "Hills Adventist College", value: "Hills Adventist College" },
    { title: "Holroyd High School", value: "Holroyd High School" },
    { title: "Holsworthy High School", value: "Holsworthy High School" },
    { title: "Holy Cross College Ryde", value: "Holy Cross College Ryde" },
    { title: "Holy Spirit Collage Lakemba", value: "Holy Spirit Collage Lakemba" },
    { title: "Homebush Boys High School", value: "Homebush Boys High School" },
    { title: "Hornsby Girls High School", value: "Hornsby Girls High School" },
    { title: "Hoxton Park High School", value: "Hoxton Park High School" },
    { title: "Hunters Hill High School", value: "Hunters Hill High School" },
    { title: "Hurlstone Agricultural High School", value: "Hurlstone Agricultural High School" },
    { title: "Illawarra Grammar School", value: "Illawarra Grammar School" },
    { title: "Inaburra School", value: "Inaburra School" },
    { title: "Innabura High School", value: "Innabura High School" },
    { title: "International Grammar School", value: "International Grammar School" },
    { title: "James Busby High School", value: "James Busby High School" },
    { title: "James Cook Boys High School", value: "James Cook Boys High School" },
    { title: "James Ruse Agricultural High School", value: "James Ruse Agricultural High School" },
    { title: "Jamison High School", value: "Jamison High School" },
    { title: "John Edmondson High School", value: "John Edmondson High School" },
    { title: "John Therry Catholic High School", value: "John Therry Catholic High School" },
    { title: "Kambala School", value: "Kambala School" },
    { title: "Kellyville High School", value: "Kellyville High School" },
    { title: "Killara High School", value: "Killara High School" },
    { title: "Killarney Heights High School", value: "Killarney Heights High School" },
    { title: "Kincoppal Rose Bay", value: "Kincoppal Rose Bay" },
    { title: "Kingsgrove High School", value: "Kingsgrove High School" },
    { title: "Kingsgrove North High School", value: "Kingsgrove North High School" },
    { title: "Kinross Wolaroi School", value: "Kinross Wolaroi School" },
    { title: "Kirrawee High School", value: "Kirrawee High School" },
    { title: "Knox Grammar School", value: "Knox Grammar School" },
    { title: "Kogarah High School", value: "Kogarah High School" },
    { title: "Ku-ring-gai High School", value: "Ku-ring-gai High School" },
    { title: "Lambton High School", value: "Lambton High School" },
    { title: "La Salle Catholic College", value: "La Salle Catholic College" },
    { title: "Lindfield Public School", value: "Lindfield Public School" },
    { title: "Loreto High School", value: "Loreto High School" },
    { title: "Loreto Kirribilli", value: "Loreto Kirribilli" },
    { title: "Loreto Normanhurst", value: "Loreto Normanhurst" },
    { title: "Macarthur Anglican School", value: "Macarthur Anglican School" },
    { title: "Macarthur Girls High School", value: "Macarthur Girls High School" },
    { title: "Macquarie Fields High School", value: "Macquarie Fields High School" },
    { title: "Macquarie University", value: "Macquarie University" },
    { title: "Magdalene Catholic High School", value: "Magdalene Catholic High School" },
    { title: "Malek Fahd Islamic School", value: "Malek Fahd Islamic School" },
    { title: "Marcellin College", value: "Marcellin College" },
    { title: "Marian Catholic College", value: "Marian Catholic College" },
    { title: "Marist Catholic College Penshurst", value: "Marist Catholic College Penshurst" },
    { title: "Marist College Eastwood", value: "Marist College Eastwood" },
    { title: "Marist College Kogarah", value: "Marist College Kogarah" },
    { title: "Marist College North Shore", value: "Marist College North Shore" },
    { title: "Marist Sisters College Woolwich", value: "Marist Sisters College Woolwich" },
    { title: "Marrickville High School", value: "Marrickville High School" },
    { title: "Marsden High School", value: "Marsden High School" },
    { title: "Mary Mackillop Catholic College Wakeley", value: "Mary Mackillop Catholic College Wakeley" },
    { title: "Masada College", value: "Masada College" },
    { title: "Mater Maria Catholic College Warriewood", value: "Mater Maria Catholic College Warriewood" },
    { title: "McMarthur Girls High School", value: "McMarthur Girls High School" },
    { title: "Menai High School", value: "Menai High School" },
    { title: "Mercy Catholic College", value: "Mercy Catholic College" },
    { title: "Mereweather High school", value: "Mereweather High school" },
    { title: "Meriden School", value: "Meriden School" },
    { title: "Merrylands High School", value: "Merrylands High School" },
    { title: "Mitchell High School", value: "Mitchell High School" },
    { title: "MLC School", value: "MLC School" },
    { title: "Model Farms High School", value: "Model Farms High School" },
    { title: "Monte Sant' Angelo Mercy College", value: "Monte Sant' Angelo Mercy College" },
    { title: "Moorebank High School", value: "Moorebank High School" },
    { title: "Mortlake Public School", value: "Mortlake Public School" },
    { title: "Mosman High School", value: "Mosman High School" },
    { title: "Mount Annan Christian College", value: "Mount Annan Christian College" },
    { title: "Mount St Benedict College", value: "Mount St Benedict College" },
    { title: "Mount St Joseph Milperra", value: "Mount St Joseph Milperra" },
    { title: "Nagle College", value: "Nagle College" },
    { title: "NBSC Cromer Campus", value: "NBSC Cromer Campus" },
    { title: "NBSC Mackellar Girls Campus", value: "NBSC Mackellar Girls Campus" },
    { title: "NBSC Manly Campus", value: "NBSC Manly Campus" },
    { title: "Newcastle Grammar School", value: "Newcastle Grammar School" },
    { title: "Newington College", value: "Newington College" },
    { title: "Newtown High School of the Performing Arts", value: "Newtown High School of the Performing Arts" },
    { title: "Normanhurst Boys High School", value: "Normanhurst Boys High School" },
    { title: "North Sydney Boys High School", value: "North Sydney Boys High School" },
    { title: "North Sydney Girls High School", value: "North Sydney Girls High School" },
    { title: "Northern Beaches Christian School", value: "Northern Beaches Christian School" },
    { title: "Northern Beaches Secondary College", value: "Northern Beaches Secondary College" },
    { title: "Northmead Creative and Performing Arts High School", value: "Northmead Creative and Performing Arts High School" },
    { title: "Northmead High School", value: "Northmead High School" },
    { title: "Norwest Christian College", value: "Norwest Christian College" },
    { title: "Oakhill College", value: "Oakhill College" },
    { title: "Oatley Senior Campus", value: "Oatley Senior Campus" },
    { title: "OTEN", value: "OTEN" },
    { title: "Our Lady of Mercy College Parramatta", value: "Our Lady of Mercy College Parramatta" },
    { title: "Our Lady of Sacred Heart College", value: "Our Lady of Sacred Heart College" },
    { title: "Oxford Falls Grammar School", value: "Oxford Falls Grammar School" },
    { title: "Pacific Hills Christian School", value: "Pacific Hills Christian School" },
    { title: "Parramatta High School", value: "Parramatta High School" },
    { title: "Parramatta Marist High School", value: "Parramatta Marist High School" },
    { title: "Parramatta West Public School", value: "Parramatta West Public School" },
    { title: "Patrician Brothers' College Blacktown", value: "Patrician Brothers' College Blacktown" },
    { title: "Patrician Brothers' College Fairfield", value: "Patrician Brothers' College Fairfield" },
    { title: "Pendle Hill High School", value: "Pendle Hill High School" },
    { title: "Pennant Hills High School", value: "Pennant Hills High School" },
    { title: "Penrith Academic High School", value: "Penrith Academic High School" },
    { title: "Penrith High School", value: "Penrith High School" },
    { title: "Penshurst Girls High School", value: "Penshurst Girls High School" },
    { title: "Picnic Point High School", value: "Picnic Point High School" },
    { title: "Pittwater House", value: "Pittwater House" },
    { title: "PLC Armidale", value: "PLC Armidale" },
    { title: "Plumpton High School", value: "Plumpton High School" },
    { title: "Port Hacking High School", value: "Port Hacking High School" },
    { title: "Prairiewood High School", value: "Prairiewood High School" },
    { title: "Presbyterian Ladies' College Sydney", value: "Presbyterian Ladies' College Sydney" },
    { title: "Pymble Ladies' College", value: "Pymble Ladies' College" },
    { title: "Quakers Hill High School", value: "Quakers Hill High School" },
    { title: "Queenswood School For Girls", value: "Queenswood School For Girls" },
    { title: "Randwick Boys High School", value: "Randwick Boys High School" },
    { title: "Randwick Girls High School", value: "Randwick Girls High School" },
    { title: "Ravenswood School for Girls", value: "Ravenswood School for Girls" },
    { title: "Reddam House", value: "Reddam House" },
    { title: "Redeemer Baptist School", value: "Redeemer Baptist School" },
    { title: "Redfield College", value: "Redfield College" },
    { title: "Redlands", value: "Redlands" },
    { title: "Regents Park Christian School", value: "Regents Park Christian School" },
    { title: "Richard Johnson Anglican School", value: "Richard Johnson Anglican School" },
    { title: "Riverside Girls High School", value: "Riverside Girls High School" },
    { title: "Riverview St Ignatius", value: "Riverview St Ignatius" },
    { title: "Rose Bay Secondary College", value: "Rose Bay Secondary College" },
    { title: "Rosebank College", value: "Rosebank College" },
    { title: "Roseville College", value: "Roseville College" },
    { title: "Rouse Hill Angelican College", value: "Rouse Hill Angelican College" },
    { title: "Rouse Hill High School", value: "Rouse Hill High School" },
    { title: "Ryde Secondary College", value: "Ryde Secondary College" },
    { title: "Saint Ignatius' College Riverview", value: "Saint Ignatius' College Riverview" },
    { title: "Saint Mark's Coptic Orthodox College", value: "Saint Mark's Coptic Orthodox College" },
    { title: "Saint Patrick's Dundas", value: "Saint Patrick's Dundas" },
    { title: "Santa Sabina College", value: "Santa Sabina College" },
    { title: "Sarah Redfern High School", value: "Sarah Redfern High School" },
    { title: "SCECGS Redlands", value: "SCECGS Redlands" },
    { title: "SCEGGS Darlinghurst", value: "SCEGGS Darlinghurst" },
    { title: "SCEGGS Darlinghurst", value: "SCEGGS Darlinghurst" },
    { title: "Scots College", value: "Scots College" },
    { title: "Sefton High School", value: "Sefton High School" },
    { title: "Sir Joseph Banks High School", value: "Sir Joseph Banks High School" },
    { title: "Smith's Hill High School", value: "Smith's Hill High School" },
    { title: "St Aloysius' College", value: "St Aloysius' College" },
    { title: "St Andrew's Cathedral Sydney", value: "St Andrew's Cathedral Sydney" },
    { title: "St Augustine's College", value: "St Augustine's College" },
    { title: "St Benedicts Catholic College", value: "St Benedicts Catholic College" },
    { title: "St Catherine's School", value: "St Catherine's School" },
    { title: "St Clare's College Waverley", value: "St Clare's College Waverley" },
    { title: "St Columba's Catholic College", value: "St Columba's Catholic College" },
    { title: "St Euphemia College", value: "St Euphemia College" },
    { title: "St George Christian School", value: "St George Christian School" },
    { title: "St George Girls High School", value: "St George Girls High School" },
    { title: "St Ignatius College Riverview", value: "St Ignatius College Riverview" },
    { title: "St Ives High School", value: "St Ives High School" },
    { title: "St John Paul II", value: "St John Paul II" },
    { title: "St Johns College Dubbo", value: "St Johns College Dubbo" },
    { title: "St Johns Park High School", value: "St Johns Park High School" },
    { title: "St Joseph's College", value: "St Joseph's College" },
    { title: "St Leo's Catholic College", value: "St Leo's Catholic College" },
    { title: "St Lukes Grammar School", value: "St Lukes Grammar School" },
    { title: "St Mark's Catholic College", value: "St Mark's Catholic College" },
    { title: "St Maroun's College", value: "St Maroun's College" },
    { title: "St Mary & St Mina's Coptic Orthodox College", value: "St Mary & St Mina's Coptic Orthodox College" },
    { title: "St Mary Star of the Sea College Wollongong", value: "St Mary Star of the Sea College Wollongong" },
    { title: "St Mary's Cathedral College Sydney", value: "St Mary's Cathedral College Sydney" },
    { title: "St Mary's Senior High School", value: "St Mary's Senior High School" },
    { title: "St Michael's Belfield", value: "St Michael's Belfield" },
    { title: "St Patrick's College Campbelltown", value: "St Patrick's College Campbelltown" },
    { title: "St Patrick's College Strathfield", value: "St Patrick's College Strathfield" },
    { title: "St Patrick's College Sutherland", value: "St Patrick's College Sutherland" },
    { title: "St Patrick's Marist College", value: "St Patrick's Marist College" },
    { title: "St Pauls Catholic College", value: "St Pauls Catholic College" },
    { title: "St Paul's Gramma School", value: "St Paul's Gramma School" },
    { title: "St Phillip's Christian College", value: "St Phillip's Christian College" },
    { title: "St Pius X College", value: "St Pius X College" },
    { title: "St Scholastica's College", value: "St Scholastica's College" },
    { title: "St Ursula's College Kingsgrove", value: "St Ursula's College Kingsgrove" },
    { title: "St Vincent's College", value: "St Vincent's College" },
    { title: "St Vincent's College", value: "St Vincent's College" },
    { title: "Stella Maris College", value: "Stella Maris College" },
    { title: "Strathfield Girls High School", value: "Strathfield Girls High School" },
    { title: "Strathfield South High School", value: "Strathfield South High School" },
    { title: "Sydney Boys High School", value: "Sydney Boys High School" },
    { title: "Sydney Church of England Grammar School", value: "Sydney Church of England Grammar School" },
    { title: "Sydney Girls High School", value: "Sydney Girls High School" },
    { title: "Sydney Grammar School", value: "Sydney Grammar School" },
    { title: "Sydney Secondary College Balmain Campus", value: "Sydney Secondary College Balmain Campus" },
    { title: "Sydney Secondary College Blackwattle Bay Campus", value: "Sydney Secondary College Blackwattle Bay Campus" },
    { title: "Sydney Secondary College Leichhardt Campus", value: "Sydney Secondary College Leichhardt Campus" },
    { title: "Sydney Technical High School", value: "Sydney Technical High School" },
    { title: "Tanagra School for Girls", value: "Tanagra School for Girls" },
    { title: "Tara Anglican School for Girls", value: "Tara Anglican School for Girls" },
    { title: "Taylors College", value: "Taylors College" },
    { title: "Tempe High School", value: "Tempe High School" },
    { title: "Terra Sancta College", value: "Terra Sancta College" },
    { title: "The Conservatorium High School", value: "The Conservatorium High School" },
    { title: "The Forest High School", value: "The Forest High School" },
    { title: "The Hills Grammar School", value: "The Hills Grammar School" },
    { title: "The Illawarra Grammar School", value: "The Illawarra Grammar School" },
    { title: "The King's School", value: "The King's School" },
    { title: "The McDonald College", value: "The McDonald College" },
    { title: "The Ponds High School", value: "The Ponds High School" },
    { title: "The Scots College", value: "The Scots College" },
    { title: "Thomas Hassall Anglican College", value: "Thomas Hassall Anglican College" },
    { title: "Toongabbie Christian School", value: "Toongabbie Christian School" },
    { title: "Trinity Anglican College - Albury", value: "Trinity Anglican College - Albury" },
    { title: "Trinity Catholic College", value: "Trinity Catholic College" },
    { title: "Trinity Grammar School", value: "Trinity Grammar School" },
    { title: "Turramurra High School", value: "Turramurra High School" },
    { title: "Tyndale Christian High School", value: "Tyndale Christian High School" },
    { title: "Unity Grammar College", value: "Unity Grammar College" },
    { title: "University of Newcastle", value: "University of Newcastle" },
    { title: "University of Sydney", value: "University of Sydney" },
    { title: "University of Western Sydney", value: "University of Western Sydney" },
    { title: "UNSW", value: "UNSW" },
    { title: "UTS Insearch", value: "UTS Insearch" },
    { title: "Waverley College", value: "Waverley College" },
    { title: "Wenona School", value: "Wenona School" },
    { title: "West Ryde Public School", value: "West Ryde Public School" },
    { title: "Westfields Sports High School", value: "Westfields Sports High School" },
    { title: "Wiley Park Public School", value: "Wiley Park Public School" },
    { title: "William Carey Christian School", value: "William Carey Christian School" },
    { title: "William Clarke College", value: "William Clarke College" },
    { title: "Willoughby Girls High School", value: "Willoughby Girls High School" },
    { title: "Wollemi College", value: "Wollemi College" },
    { title: "Wollongong High School of the Performing Arts", value: "Wollongong High School of the Performing Arts" },
    { title: "Wyndham College", value: "Wyndham College" },
    { title: "Xavier College", value: "Xavier College" },
    { title: "Xavier Catholic College Ballina", value: "Xavier Catholic College Ballina" },
    { title: "Unknown", value: "Unknown" },
];
//# sourceMappingURL=schools.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/states.ts
var STATES = [
    { title: "Australian Capital Territory", value: "Australian Capital Territory" },
    { title: "New South Wales", value: "New South Wales" },
    { title: "Northern Territory", value: "Northern Territory" },
    { title: "Queensland", value: "Queensland" },
    { title: "South Australia", value: "South Australia" },
    { title: "Tasmania", value: "Tasmania" },
    { title: "Victoria", value: "Victoria" },
    { title: "Western Australia", value: "Western Australia" },
];
//# sourceMappingURL=states.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/genders.ts
var GENDERS = [
    { title: "Male", value: "male" },
    { title: "Female", value: "female" },
    { title: "Other", value: "other" },
];
//# sourceMappingURL=genders.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/model.ts
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var Model = (function () {
    function Model() {
        this.errors = {};
    }
    Model.getJsonApiErrors = function (errors) {
        return errors.reduce(function (obj, _a) {
            var source = _a.source, detail = _a.detail;
            var key = source.pointer.split('/').pop();
            var value = typeof detail === 'string' ? { message: detail } : detail;
            return __assign({}, obj, (_b = {}, _b[key] = value, _b));
            var _b;
        }, {});
    };
    return Model;
}());

Model.serverError = {
    server: {
        message: 'An error occured processing your request.'
    },
};
//# sourceMappingURL=model.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/address.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var address_Address = (function (_super) {
    __extends(Address, _super);
    function Address(id, contactId, label, lineOne, lineTwo, state, suburb, postcode, uiState) {
        if (label === void 0) { label = ""; }
        if (lineOne === void 0) { lineOne = ""; }
        if (lineTwo === void 0) { lineTwo = ""; }
        if (state === void 0) { state = ""; }
        if (suburb === void 0) { suburb = ""; }
        if (postcode === void 0) { postcode = ""; }
        if (uiState === void 0) { uiState = {}; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.label = label;
        _this.lineOne = lineOne;
        _this.lineTwo = lineTwo;
        _this.state = state;
        _this.suburb = suburb;
        _this.postcode = postcode;
        _this.uiState = uiState;
        return _this;
    }
    Address.clone = function (obj) {
        var address = new this();
        if (obj.id) {
            address.id = obj.id;
        }
        if (obj.contactId) {
            address.contactId = obj.contactId;
        }
        if (obj.label) {
            address.label = obj.label;
        }
        if (obj.lineOne) {
            address.lineOne = obj.lineOne;
        }
        if (obj.lineTwo) {
            address.lineTwo = obj.lineTwo;
        }
        if (obj.state) {
            address.state = obj.state;
        }
        if (obj.suburb) {
            address.suburb = obj.suburb;
        }
        if (obj.postcode) {
            address.postcode = obj.postcode;
        }
        if (obj.errors && Object.keys(obj.errors).length > 0) {
            address.errors = Model.getJsonApiErrors(obj.errors);
        }
        if (obj.uiState) {
            address.uiState = obj.uiState;
        }
        return address;
    };
    Address.prototype.serializeForRails = function () {
    };
    Address.prototype.getFinalAddressLine = function () {
        var populatedItems = [];
        if (this.suburb) {
            populatedItems.push(this.suburb);
        }
        if (this.state) {
            populatedItems.push(this.state);
        }
        if (this.postcode) {
            populatedItems.push(this.postcode);
        }
        return populatedItems.join(", ");
    };
    return Address;
}(Model));

//# sourceMappingURL=address.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/phone.ts
var phone___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Phone = (function (_super) {
    phone___extends(Phone, _super);
    function Phone(id, contactId, label, value, uiState) {
        if (label === void 0) { label = ""; }
        if (value === void 0) { value = ""; }
        if (uiState === void 0) { uiState = {}; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.label = label;
        _this.value = value;
        _this.uiState = uiState;
        return _this;
    }
    Phone.clone = function (obj) {
        var phone = new this();
        if (obj.id) {
            phone.id = obj.id;
        }
        if (obj.contactId) {
            phone.contactId = obj.contactId;
        }
        if (obj.label) {
            phone.label = obj.label;
        }
        if (obj.value) {
            phone.value = obj.value;
        }
        if (obj.uiState) {
            phone.uiState = obj.uiState;
        }
        return phone;
    };
    Phone.prototype.serializeForRails = function () {
    };
    return Phone;
}(Model));

//# sourceMappingURL=phone.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/note.ts
var note___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Note = (function (_super) {
    note___extends(Note, _super);
    function Note(id, contactId, body, createdAt, updatedAt, uiState) {
        if (body === void 0) { body = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (uiState === void 0) { uiState = {}; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.body = body;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        _this.uiState = uiState;
        return _this;
    }
    Note.clone = function (obj) {
        var note = new this();
        if (obj.id) {
            note.id = obj.id;
        }
        if (obj.contactId) {
            note.contactId = obj.contactId;
        }
        if (obj.body) {
            note.body = obj.body;
        }
        if (obj.createdAt) {
            note.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            note.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.uiState) {
            note.uiState = obj.uiState;
        }
        return note;
    };
    Note.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Note;
}(Model));

//# sourceMappingURL=note.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/credit-card.ts
var credit_card___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var credit_card___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var CreditCard = (function (_super) {
    credit_card___extends(CreditCard, _super);
    function CreditCard(id, holder, cardNumber, cardType, expiryMonth, expiryYear, cvv) {
        if (holder === void 0) { holder = null; }
        if (cardNumber === void 0) { cardNumber = null; }
        if (cardType === void 0) { cardType = null; }
        if (expiryMonth === void 0) { expiryMonth = null; }
        if (expiryYear === void 0) { expiryYear = null; }
        if (cvv === void 0) { cvv = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.holder = holder;
        _this.cardNumber = cardNumber;
        _this.cardType = cardType;
        _this.expiryMonth = expiryMonth;
        _this.expiryYear = expiryYear;
        _this.cvv = cvv;
        return _this;
    }
    CreditCard.clone = function (obj) {
        return credit_card___assign({}, new this(), obj);
    };
    CreditCard.prototype.serializeForRails = function () {
        return {
            card_number: this.cardNumber,
            card_holder: this.holder,
            card_expiry: this.expiryMonth + "/" + this.expiryYear,
            cvv: this.cvv,
        };
    };
    return CreditCard;
}(Model));

//# sourceMappingURL=credit-card.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/document.ts
var document___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Document = (function (_super) {
    document___extends(Document, _super);
    function Document(id, contactId, fileName, url, note, docFileName, docContentType, doc, uiState) {
        if (fileName === void 0) { fileName = null; }
        if (url === void 0) { url = null; }
        if (note === void 0) { note = null; }
        if (docFileName === void 0) { docFileName = null; }
        if (docContentType === void 0) { docContentType = null; }
        if (doc === void 0) { doc = null; }
        if (uiState === void 0) { uiState = {}; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.fileName = fileName;
        _this.url = url;
        _this.note = note;
        _this.docFileName = docFileName;
        _this.docContentType = docContentType;
        _this.doc = doc;
        _this.uiState = uiState;
        return _this;
    }
    Document.clone = function (obj) {
        var result = new this();
        if (obj.id) {
            result.id = obj.id;
        }
        if (obj.fileName) {
            result.fileName = obj.fileName;
        }
        if (obj.url) {
            result.url = obj.url;
        }
        if (obj.note) {
            result.note = obj.note;
        }
        if (obj.docFileName) {
            result.docFileName = obj.docFileName;
        }
        if (obj.docContentType) {
            result.docContentType = obj.docContentType;
        }
        if (obj.doc) {
            result.doc = obj.doc;
        }
        if (obj.uiState) {
            result.uiState = obj.uiState;
        }
        return result;
    };
    Document.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Document;
}(Model));

//# sourceMappingURL=document.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/discount-type.ts
var discount_type___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DiscountType = (function (_super) {
    discount_type___extends(DiscountType, _super);
    function DiscountType(id, campusId, discountType, description, multiplier, createdAt, updatedAt) {
        if (discountType === void 0) { discountType = null; }
        if (description === void 0) { description = null; }
        if (multiplier === void 0) { multiplier = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.campusId = campusId;
        _this.discountType = discountType;
        _this.description = description;
        _this.multiplier = multiplier;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    DiscountType.clone = function (obj) {
        var o = new this();
        if (obj.id) {
            o.id = obj.id;
        }
        if (obj.campusId) {
            o.campusId = obj.campusId;
        }
        if (obj.description) {
            o.description = obj.description;
        }
        if (obj.discountType != undefined) {
            o.discountType = obj.discountType;
        }
        if (obj.multiplier != undefined) {
            o.multiplier = obj.multiplier;
        }
        if (obj.createdAt) {
            o.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            o.updatedAt = new Date(obj.updatedAt);
        }
        return o;
    };
    return DiscountType;
}(Model));

//# sourceMappingURL=discount-type.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/discount.ts
var discount___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var discount_Discount = (function (_super) {
    discount___extends(Discount, _super);
    function Discount(id, discountTypeId, contactId, description, startDate, endDate, fixedAmount, discountType, isMenuOpen, createdAt, updatedAt) {
        if (description === void 0) { description = null; }
        if (startDate === void 0) { startDate = null; }
        if (endDate === void 0) { endDate = null; }
        if (fixedAmount === void 0) { fixedAmount = null; }
        if (discountType === void 0) { discountType = null; }
        if (isMenuOpen === void 0) { isMenuOpen = false; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.discountTypeId = discountTypeId;
        _this.contactId = contactId;
        _this.description = description;
        _this.startDate = startDate;
        _this.endDate = endDate;
        _this.fixedAmount = fixedAmount;
        _this.discountType = discountType;
        _this.isMenuOpen = isMenuOpen;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Discount.clone = function (obj) {
        var o = new this();
        if (obj.id) {
            o.id = obj.id;
        }
        if (obj.discountTypeId) {
            o.discountTypeId = obj.discountTypeId;
        }
        if (obj.contactId) {
            o.contactId = obj.contactId;
        }
        if (obj.description) {
            o.description = obj.description;
        }
        if (obj.startDate) {
            o.startDate = new Date(obj.startDate);
        }
        if (obj.endDate) {
            o.endDate = new Date(obj.endDate);
        }
        if (obj.fixedAmount != undefined) {
            o.fixedAmount = obj.fixedAmount;
        }
        if (obj.discountType) {
            o.discountType = DiscountType.clone(obj.discountType);
        }
        if (obj.createdAt) {
            o.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            o.updatedAt = new Date(obj.updatedAt);
        }
        return o;
    };
    return Discount;
}(Model));

//# sourceMappingURL=discount.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/alternate-email.ts
var alternate_email___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AlternateEmail = (function (_super) {
    alternate_email___extends(AlternateEmail, _super);
    function AlternateEmail(id, contactId, value) {
        if (value === void 0) { value = ""; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.value = value;
        return _this;
    }
    AlternateEmail.clone = function (obj) {
        var email = new this();
        if (obj.id) {
            email.id = obj.id;
        }
        if (obj.value) {
            email.value = obj.value;
        }
        if (obj.contactId) {
            email.contactId = obj.contactId;
        }
        return email;
    };
    AlternateEmail.prototype.serializeForRails = function () {
    };
    return AlternateEmail;
}(Model));

//# sourceMappingURL=alternate-email.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/campus.ts
var campus___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Campus = (function (_super) {
    campus___extends(Campus, _super);
    function Campus(id, name, numberOfRooms, code, maxEnrolments, createdAt, updatedAt) {
        if (name === void 0) { name = ""; }
        if (numberOfRooms === void 0) { numberOfRooms = 0; }
        if (code === void 0) { code = ""; }
        if (maxEnrolments === void 0) { maxEnrolments = 0; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.name = name;
        _this.numberOfRooms = numberOfRooms;
        _this.code = code;
        _this.maxEnrolments = maxEnrolments;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Campus.clone = function (obj) {
        var campus = new this();
        if (obj.id) {
            campus.id = obj.id;
        }
        if (obj.name) {
            campus.name = obj.name;
        }
        if (obj.numberOfRooms) {
            campus.numberOfRooms = obj.numberOfRooms;
        }
        if (obj.code) {
            campus.code = obj.code;
        }
        if (obj.maxEnrolments) {
            campus.maxEnrolments = obj.maxEnrolments;
        }
        if (obj.createdAt) {
            campus.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            campus.updatedAt = new Date(obj.updatedAt);
        }
        return campus;
    };
    return Campus;
}(Model));

//# sourceMappingURL=campus.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/day.ts
var day___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Day = (function (_super) {
    day___extends(Day, _super);
    function Day(id, number, name, code) {
        if (number === void 0) { number = 0; }
        if (name === void 0) { name = ""; }
        if (code === void 0) { code = ""; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.number = number;
        _this.name = name;
        _this.code = code;
        return _this;
    }
    Day.clone = function (obj) {
        var day = new this();
        if (obj.id) {
            day.id = obj.id;
        }
        if (obj.number) {
            day.number = obj.number;
        }
        if (obj.name) {
            day.name = obj.name;
        }
        if (obj.code) {
            day.code = obj.code;
        }
        return day;
    };
    return Day;
}(Model));

//# sourceMappingURL=day.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/helpers/utilities.ts
var Utilities = (function () {
    function Utilities() {
    }
    Utilities.makeDate = function (input) {
        return new Date(new Date(input).setHours(0, 0, 0, 0));
    };
    Utilities.getDateInInputStringFormat = function (date) {
        var result = "";
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        result = [date.getFullYear(),
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd
        ].join('-');
        return result;
    };
    return Utilities;
}());

//# sourceMappingURL=utilities.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/moment/moment.js
var moment = __webpack_require__("ge1L");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/two-week-block.ts
var two_week_block___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TwoWeekBlock = (function (_super) {
    two_week_block___extends(TwoWeekBlock, _super);
    function TwoWeekBlock(termId, index, startDate, endDate, secondWeekStart, name) {
        if (termId === void 0) { termId = 0; }
        if (index === void 0) { index = 0; }
        if (startDate === void 0) { startDate = null; }
        if (endDate === void 0) { endDate = null; }
        if (secondWeekStart === void 0) { secondWeekStart = null; }
        if (name === void 0) { name = ""; }
        var _this = _super.call(this) || this;
        _this.termId = termId;
        _this.index = index;
        _this.startDate = startDate;
        _this.endDate = endDate;
        _this.secondWeekStart = secondWeekStart;
        _this.name = name;
        return _this;
    }
    TwoWeekBlock.clone = function (obj) {
        var wb = new this();
        if (obj.termId) {
            wb.termId = obj.termId;
        }
        if (obj.index) {
            wb.index = obj.index;
        }
        if (obj.startDate) {
            wb.startDate = obj.startDate;
        }
        if (obj.endDate) {
            wb.endDate = obj.endDate;
        }
        if (obj.secondWeekStart) {
            wb.secondWeekStart = new Date(obj.secondWeekStart);
        }
        if (obj.name) {
            wb.name = obj.name;
        }
        return wb;
    };
    TwoWeekBlock.prototype.serializeForRails = function () {
    };
    return TwoWeekBlock;
}(Model));

//# sourceMappingURL=two-week-block.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/public-holiday.ts
var public_holiday___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var public_holiday_PublicHoliday = (function (_super) {
    public_holiday___extends(PublicHoliday, _super);
    function PublicHoliday(id, name, date, state, isMatrixHoliday, updatedAt, createdAt) {
        if (name === void 0) { name = ""; }
        if (date === void 0) { date = null; }
        if (state === void 0) { state = ""; }
        if (isMatrixHoliday === void 0) { isMatrixHoliday = false; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.name = name;
        _this.date = date;
        _this.state = state;
        _this.isMatrixHoliday = isMatrixHoliday;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        return _this;
    }
    PublicHoliday.clone = function (obj) {
        var ph = new this();
        if (obj.id) {
            ph.id = obj.id;
        }
        if (obj.name) {
            ph.name = obj.name;
        }
        if (obj.date) {
            ph.date = Utilities.makeDate(obj.date);
        }
        if (obj.state) {
            ph.state = obj.state;
        }
        if (obj.isMatrixHoliday) {
            ph.isMatrixHoliday = !!obj.isMatrixHoliday;
        }
        if (obj.createdAt) {
            ph.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            ph.updatedAt = new Date(obj.updatedAt);
        }
        return ph;
    };
    PublicHoliday.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (this.date) {
            response.date = moment(this.date).format("YYYY-MM-DD");
        }
        return response;
    };
    return PublicHoliday;
}(Model));

//# sourceMappingURL=public-holiday.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/term-extra-day.ts
var term_extra_day___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var term_extra_day_TermExtraDay = (function (_super) {
    term_extra_day___extends(TermExtraDay, _super);
    function TermExtraDay(termId, date, name, publicHoliday) {
        if (date === void 0) { date = null; }
        if (name === void 0) { name = null; }
        if (publicHoliday === void 0) { publicHoliday = null; }
        var _this = _super.call(this) || this;
        _this.termId = termId;
        _this.date = date;
        _this.name = name;
        _this.publicHoliday = publicHoliday;
        return _this;
    }
    TermExtraDay.clone = function (obj) {
        var o = new this();
        if (obj.termId) {
            o.termId = obj.termId;
        }
        if (obj.date) {
            o.date = new Date(obj.date);
        }
        if (obj.publicHoliday) {
            o.publicHoliday = public_holiday_PublicHoliday.clone(obj.publicHoliday);
        }
        return o;
    };
    return TermExtraDay;
}(Model));

//# sourceMappingURL=term-extra-day.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/term.ts
var term___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var term_Term = (function (_super) {
    term___extends(Term, _super);
    function Term(id, name, startDate, endDate, isHoliday, isOnlineEnrolmentEnabled, number, isCurrentTerm, twoWeekBlocks, updatedAt, createdAt, extraDays) {
        if (name === void 0) { name = ""; }
        if (startDate === void 0) { startDate = null; }
        if (endDate === void 0) { endDate = null; }
        if (isHoliday === void 0) { isHoliday = false; }
        if (isOnlineEnrolmentEnabled === void 0) { isOnlineEnrolmentEnabled = false; }
        if (number === void 0) { number = 0; }
        if (isCurrentTerm === void 0) { isCurrentTerm = false; }
        if (twoWeekBlocks === void 0) { twoWeekBlocks = []; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (extraDays === void 0) { extraDays = []; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.name = name;
        _this.startDate = startDate;
        _this.endDate = endDate;
        _this.isHoliday = isHoliday;
        _this.isOnlineEnrolmentEnabled = isOnlineEnrolmentEnabled;
        _this.number = number;
        _this.isCurrentTerm = isCurrentTerm;
        _this.twoWeekBlocks = twoWeekBlocks;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        _this.extraDays = extraDays;
        return _this;
    }
    Term.clone = function (obj) {
        var term = new this();
        if (obj.id) {
            term.id = obj.id;
        }
        if (obj.name) {
            term.name = obj.name;
        }
        if (obj.startDate) {
            term.startDate = Utilities.makeDate(obj.startDate);
        }
        if (obj.endDate) {
            term.endDate = Utilities.makeDate(obj.endDate);
        }
        if (obj.isHoliday) {
            term.isHoliday = obj.isHoliday;
        }
        if (obj.isOnlineEnrolmentEnabled) {
            term.isOnlineEnrolmentEnabled = obj.isOnlineEnrolmentEnabled;
        }
        if (obj.isCurrentTerm) {
            term.isCurrentTerm = obj.isCurrentTerm;
        }
        if (obj.number) {
            term.number = obj.number;
        }
        if (obj.createdAt) {
            term.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            term.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.twoWeekBlocks && obj.twoWeekBlocks.length > 0) {
            term.twoWeekBlocks = obj.twoWeekBlocks.map(function (wb) {
                return TwoWeekBlock.clone(wb);
            });
        }
        if (obj.extraDays && obj.extraDays.length > 0) {
            term.extraDays = obj.extraDays.map(function (ted) {
                return term_extra_day_TermExtraDay.clone(ted);
            });
        }
        return term;
    };
    Term.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (this.startDate) {
            response.startDate = moment(this.startDate).format("YYYY-MM-DD");
        }
        if (this.endDate) {
            response.endDate = moment(this.endDate).format("YYYY-MM-DD");
        }
        this.twoWeekBlocks = null;
        this.extraDays = null;
        return response;
    };
    return Term;
}(Model));

//# sourceMappingURL=term.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/topic.ts
var topic___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Topic = (function (_super) {
    topic___extends(Topic, _super);
    function Topic(id, name, order, courseId) {
        if (name === void 0) { name = ""; }
        if (order === void 0) { order = 0; }
        if (courseId === void 0) { courseId = 0; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.name = name;
        _this.order = order;
        _this.courseId = courseId;
        return _this;
    }
    Topic.clone = function (obj) {
        var topic = new this();
        if (obj.id) {
            topic.id = obj.id;
        }
        if (obj.name) {
            topic.name = obj.name;
        }
        if (obj.order) {
            topic.order = obj.order;
        }
        if (obj.courseId) {
            topic.courseId = obj.courseId;
        }
        return topic;
    };
    Topic.prototype.serializeForRails = function () {
    };
    return Topic;
}(Model));

//# sourceMappingURL=topic.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/course.ts
var course___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var course_Course = (function (_super) {
    course___extends(Course, _super);
    function Course(id, subjectCode, code, name, humanised, grade, doublePeriod, cost, color, faculty, isConfirmingRemove, topics) {
        if (subjectCode === void 0) { subjectCode = ""; }
        if (code === void 0) { code = ""; }
        if (name === void 0) { name = ""; }
        if (humanised === void 0) { humanised = ""; }
        if (grade === void 0) { grade = 0; }
        if (doublePeriod === void 0) { doublePeriod = false; }
        if (cost === void 0) { cost = 0; }
        if (color === void 0) { color = null; }
        if (faculty === void 0) { faculty = null; }
        if (isConfirmingRemove === void 0) { isConfirmingRemove = false; }
        if (topics === void 0) { topics = []; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.subjectCode = subjectCode;
        _this.code = code;
        _this.name = name;
        _this.humanised = humanised;
        _this.grade = grade;
        _this.doublePeriod = doublePeriod;
        _this.cost = cost;
        _this.color = color;
        _this.faculty = faculty;
        _this.isConfirmingRemove = isConfirmingRemove;
        _this.topics = topics;
        return _this;
    }
    Course.clone = function (obj) {
        var course = new this();
        if (obj.id) {
            course.id = obj.id;
        }
        if (obj.subjectCode) {
            course.subjectCode = obj.subjectCode;
        }
        if (obj.humanised) {
            course.humanised = obj.humanised;
        }
        if (obj.code) {
            course.code = obj.code;
        }
        if (obj.name) {
            course.name = obj.name;
        }
        if (obj.grade) {
            course.grade = obj.grade;
        }
        if (obj.doublePeriod) {
            course.doublePeriod = obj.doublePeriod;
        }
        if (obj.cost) {
            course.cost = obj.cost;
        }
        if (obj.color) {
            course.color = obj.color;
        }
        if (obj.faculty) {
            course.faculty = obj.faculty;
        }
        if (obj.isConfirmingRemove) {
            course.isConfirmingRemove = obj.isConfirmingRemove;
        }
        if (obj.topics && obj.topics.length > 0) {
            obj.topics.forEach(function (t) {
                course.topics.push(Topic.clone(t));
            });
        }
        return course;
    };
    Course.prototype.serializeForRails = function () {
    };
    return Course;
}(Model));

course_Course.subjectStrings = ["Biology", "Physics", "Chemistry", "Science", "Math", "English"];
course_Course.FACULTIES = {
    0: "Mathematics",
    1: "Science",
    2: "English"
};
//# sourceMappingURL=course.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/periods.ts
var PERIODS_BY_CAMPUS = {
    "M": [
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "T": [
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "W": [
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "R": [
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "F": [
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "S": [
        "9:30AM - 11:00AM",
        "11:00AM - 12:30PM",
        "1:30PM - 3:00PM",
        "3:00PM - 4:30PM",
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "U": [
        "9:30AM - 11:00AM",
        "11:00AM - 12:30PM",
        "1:30PM - 3:00PM",
        "3:00PM - 4:30PM",
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
    "A": [
        "9:30AM - 11:00AM",
        "11:00AM - 12:30PM",
        "1:30PM - 3:00PM",
        "3:00PM - 4:30PM",
        "4:30PM - 6:00PM",
        "6:10PM - 7:40PM",
    ],
};
//# sourceMappingURL=periods.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/matrix_classes.ts
var NUMBER_OF_CLASSES_PER_TERM = 9;
var NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS = {
    "C": 15,
    "E": 15,
    "M": 15,
    "S": 14,
    "T": 15,
};
//# sourceMappingURL=matrix_classes.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/matrix-class.ts
var matrix_class___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var matrix_class_MatrixClass = (function (_super) {
    matrix_class___extends(MatrixClass, _super);
    function MatrixClass(id, campusId, termId, dayId, courseId, topicId, contactId, open, topicTest, 
        // NOTE: holidayWeek of 0 means it spans both weeks.
        holidayWeek, period, room, code, humanisedCode, campus, day, term, course, topic, contact, enrolments, updatedAt, createdAt) {
        if (open === void 0) { open = false; }
        if (topicTest === void 0) { topicTest = false; }
        if (holidayWeek === void 0) { holidayWeek = 1; }
        if (period === void 0) { period = 1; }
        if (room === void 0) { room = 1; }
        if (code === void 0) { code = null; }
        if (humanisedCode === void 0) { humanisedCode = null; }
        if (campus === void 0) { campus = null; }
        if (day === void 0) { day = null; }
        if (term === void 0) { term = null; }
        if (course === void 0) { course = null; }
        if (topic === void 0) { topic = null; }
        if (contact === void 0) { contact = null; }
        if (enrolments === void 0) { enrolments = []; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.campusId = campusId;
        _this.termId = termId;
        _this.dayId = dayId;
        _this.courseId = courseId;
        _this.topicId = topicId;
        _this.contactId = contactId;
        _this.open = open;
        _this.topicTest = topicTest;
        _this.holidayWeek = holidayWeek;
        _this.period = period;
        _this.room = room;
        _this.code = code;
        _this.humanisedCode = humanisedCode;
        _this.campus = campus;
        _this.day = day;
        _this.term = term;
        _this.course = course;
        _this.topic = topic;
        _this.contact = contact;
        _this.enrolments = enrolments;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        _this.maxPerCampus = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS;
        return _this;
    }
    MatrixClass.clone = function (obj) {
        var matrixClass = new this();
        if (obj.id) {
            matrixClass.id = obj.id;
        }
        if (obj.campusId) {
            matrixClass.campusId = obj.campusId;
        }
        if (obj.termId) {
            matrixClass.termId = obj.termId;
        }
        if (obj.dayId) {
            matrixClass.dayId = obj.dayId;
        }
        if (obj.courseId) {
            matrixClass.courseId = obj.courseId;
        }
        if (obj.topicId) {
            matrixClass.topicId = obj.topicId;
        }
        if (obj.contactId) {
            matrixClass.contactId = obj.contactId;
        }
        if (obj.open) {
            matrixClass.open = obj.open;
        }
        if (obj.topicTest) {
            matrixClass.topicTest = obj.topicTest;
        }
        if (obj.holidayWeek !== undefined) {
            matrixClass.holidayWeek = obj.holidayWeek;
        }
        if (obj.period) {
            matrixClass.period = obj.period;
        }
        if (obj.room) {
            matrixClass.room = obj.room;
        }
        if (obj.code) {
            matrixClass.code = obj.code;
        }
        if (obj.humanisedCode) {
            matrixClass.humanisedCode = obj.humanisedCode;
        }
        if (obj.updatedAt) {
            matrixClass.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.createdAt) {
            matrixClass.createdAt = new Date(obj.createdAt);
        }
        if (obj.campus) {
            matrixClass.campus = Campus.clone(obj.campus);
        }
        if (obj.day) {
            matrixClass.day = Day.clone(obj.day);
        }
        if (obj.term) {
            matrixClass.term = term_Term.clone(obj.term);
        }
        if (obj.course) {
            matrixClass.course = course_Course.clone(obj.course);
        }
        if (obj.topic) {
            matrixClass.topic = Topic.clone(obj.topic);
        }
        if (obj.contact) {
            matrixClass.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.enrolments && obj.enrolments.length > 0) {
            obj.enrolments.forEach(function (e) {
                matrixClass.enrolments.push(enrolment_Enrolment.clone(e));
            });
        }
        return matrixClass;
    };
    MatrixClass.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    MatrixClass.prototype.getClassTimeDisplay = function () {
        var allPeriods = PERIODS_BY_CAMPUS;
        var campusCode = this.campus.code;
        var dayCode = this.day.code;
        var period = this.period;
        var result = "";
        if (allPeriods[campusCode]) {
            if (allPeriods[campusCode][dayCode]) {
                result = allPeriods[campusCode][dayCode][period];
            }
        }
        return result;
    };
    MatrixClass.prototype.getEffectiveEnrolmentsCount = function () {
        return this.enrolments.filter(function (e) { return !e.isDisenroled; }).length;
    };
    MatrixClass.getMatrixClassIdsGroupedBySubject = function (classes) {
        var result = [];
        course_Course.subjectStrings.forEach(function (s) {
            var ids = [];
            classes.forEach(function (mc) {
                if (mc.course.name.indexOf(s) > -1) {
                    ids.push(mc.id);
                }
            });
            if (ids.length > 0) {
                result.push({ name: s, ids: ids });
            }
        });
        return result;
    };
    return MatrixClass;
}(Model));

//# sourceMappingURL=matrix-class.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/enrolment.ts
var enrolment___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var enrolment_Enrolment = (function (_super) {
    enrolment___extends(Enrolment, _super);
    function Enrolment(id, contactId, matrixClassId, cost, numberOfClasses, startDate, transactionDate, isCancelling, isPending, isDisenroled, disenrolmentReason, pendingEnrolment, matrixClass, contact, createdAt, updatedAt, isMenuOpen) {
        if (cost === void 0) { cost = 0; }
        if (numberOfClasses === void 0) { numberOfClasses = 0; }
        if (startDate === void 0) { startDate = null; }
        if (transactionDate === void 0) { transactionDate = null; }
        if (isCancelling === void 0) { isCancelling = false; }
        if (isPending === void 0) { isPending = false; }
        if (isDisenroled === void 0) { isDisenroled = false; }
        if (disenrolmentReason === void 0) { disenrolmentReason = null; }
        if (pendingEnrolment === void 0) { pendingEnrolment = null; }
        if (matrixClass === void 0) { matrixClass = null; }
        if (contact === void 0) { contact = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (isMenuOpen === void 0) { isMenuOpen = false; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.matrixClassId = matrixClassId;
        _this.cost = cost;
        _this.numberOfClasses = numberOfClasses;
        _this.startDate = startDate;
        _this.transactionDate = transactionDate;
        _this.isCancelling = isCancelling;
        _this.isPending = isPending;
        _this.isDisenroled = isDisenroled;
        _this.disenrolmentReason = disenrolmentReason;
        _this.pendingEnrolment = pendingEnrolment;
        _this.matrixClass = matrixClass;
        _this.contact = contact;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        _this.isMenuOpen = isMenuOpen;
        return _this;
    }
    Enrolment.clone = function (obj) {
        var enrolment = new this();
        if (obj.id) {
            enrolment.id = obj.id;
        }
        if (obj.contactId) {
            enrolment.contactId = obj.contactId;
        }
        if (obj.matrixClassId) {
            enrolment.matrixClassId = obj.matrixClassId;
        }
        if (obj.cost) {
            enrolment.cost = obj.cost;
        }
        if (obj.numberOfClasses) {
            enrolment.numberOfClasses = obj.numberOfClasses;
        }
        if (obj.startDate) {
            enrolment.startDate = Utilities.makeDate(obj.startDate);
        }
        if (obj.transactionDate) {
            enrolment.transactionDate = obj.transactionDate;
        }
        if (obj.isCancelling) {
            enrolment.isCancelling = obj.isCancelling;
        }
        if (obj.isPending) {
            enrolment.isPending = obj.isPending;
        }
        if (obj.isDisenroled) {
            enrolment.isDisenroled = obj.isDisenroled;
        }
        if (obj.disenrolmentReason) {
            enrolment.disenrolmentReason = obj.disenrolmentReason;
        }
        if (obj.pendingEnrolment) {
            enrolment.pendingEnrolment = Enrolment.clone(obj.pendingEnrolment);
        }
        if (obj.createdAt) {
            enrolment.createdAt = Utilities.makeDate(obj.createdAt);
        }
        if (obj.updatedAt) {
            enrolment.updatedAt = Utilities.makeDate(obj.updatedAt);
        }
        if (obj.matrixClass) {
            enrolment.matrixClass = matrix_class_MatrixClass.clone(obj.matrixClass);
        }
        if (obj.contact) {
            enrolment.contact = contact_Contact.clone(obj.contact);
        }
        return enrolment;
    };
    Enrolment.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Enrolment;
}(Model));

//# sourceMappingURL=enrolment.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/modified-class.ts
var modified_class___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var modified_class_ModifiedClass = (function (_super) {
    modified_class___extends(ModifiedClass, _super);
    function ModifiedClass(id, contactId, matrixClassId, absenceId, date, contact, matrixClass, absence) {
        if (date === void 0) { date = null; }
        if (contact === void 0) { contact = null; }
        if (matrixClass === void 0) { matrixClass = null; }
        if (absence === void 0) { absence = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.matrixClassId = matrixClassId;
        _this.absenceId = absenceId;
        _this.date = date;
        _this.contact = contact;
        _this.matrixClass = matrixClass;
        _this.absence = absence;
        return _this;
    }
    ModifiedClass.clone = function (obj) {
        var modifiedClass = new this();
        if (obj.id) {
            modifiedClass.id = obj.id;
        }
        if (obj.contactId) {
            modifiedClass.contactId = obj.contactId;
        }
        if (obj.matrixClassId) {
            modifiedClass.matrixClassId = obj.matrixClassId;
        }
        if (obj.absenceId) {
            modifiedClass.absenceId = obj.absenceId;
        }
        if (obj.date) {
            modifiedClass.date = new Date(obj.date);
        }
        if (obj.contact) {
            modifiedClass.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.matrixClass) {
            modifiedClass.matrixClass = matrix_class_MatrixClass.clone(obj.matrixClass);
        }
        if (obj.absence) {
            modifiedClass.absence = absence_Absence.clone(obj.absence);
        }
        return modifiedClass;
    };
    ModifiedClass.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (this.date) {
            response.date = moment(this.date).format("YYYY-MM-DD");
        }
        return response;
    };
    return ModifiedClass;
}(Model));

//# sourceMappingURL=modified-class.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/absence.ts
var absence___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var absence_Absence = (function (_super) {
    absence___extends(Absence, _super);
    function Absence(id, contactId, startDateTime, endDateTime, classesBetween, contact, modifiedClasses, uiState) {
        if (startDateTime === void 0) { startDateTime = null; }
        if (endDateTime === void 0) { endDateTime = null; }
        if (classesBetween === void 0) { classesBetween = []; }
        if (contact === void 0) { contact = null; }
        if (modifiedClasses === void 0) { modifiedClasses = []; }
        if (uiState === void 0) { uiState = {}; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.startDateTime = startDateTime;
        _this.endDateTime = endDateTime;
        _this.classesBetween = classesBetween;
        _this.contact = contact;
        _this.modifiedClasses = modifiedClasses;
        _this.uiState = uiState;
        return _this;
    }
    Absence.clone = function (obj) {
        var absence = new this();
        if (obj.id) {
            absence.id = obj.id;
        }
        if (obj.contactId) {
            absence.contactId = obj.contactId;
        }
        if (obj.startDateTime) {
            absence.startDateTime = obj.startDateTime;
        }
        if (obj.endDateTime) {
            absence.endDateTime = obj.endDateTime;
        }
        if (obj.classesBetween) {
            absence.classesBetween = obj.classesBetween;
        }
        if (obj.contact) {
            absence.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.modifiedClasses && obj.modifiedClasses.length > 0) {
            obj.modifiedClasses.forEach(function (mc) {
                absence.modifiedClasses.push(modified_class_ModifiedClass.clone(mc));
            });
        }
        if (obj.uiState) {
            absence.uiState = obj.uiState;
        }
        return absence;
    };
    Absence.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (this.startDateTime) {
            response.startDateTime = moment(this.startDateTime).format("YYYY-MM-DD h:mm:ss a");
        }
        if (this.endDateTime) {
            response.endDateTime = moment(this.endDateTime).format("YYYY-MM-DD h:mm:ss a");
        }
        if (response.modifiedClasses) {
            response.modifiedClassesAttributes = response.modifiedClasses.map(function (m) {
                return modified_class_ModifiedClass.clone(m).serializeForRails();
            });
        }
        response.modifiedClasses = null;
        response.contact = null;
        response.uiState = null;
        return response;
    };
    return Absence;
}(Model));

//# sourceMappingURL=absence.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/workshop.ts
var workshop___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var workshop_Workshop = (function (_super) {
    workshop___extends(Workshop, _super);
    function Workshop(id, termId, courseIds, windowIds, displayName, note, createdAt, updatedAt, term, courses, windows, uniqueCampuses) {
        if (courseIds === void 0) { courseIds = []; }
        if (windowIds === void 0) { windowIds = []; }
        if (displayName === void 0) { displayName = null; }
        if (note === void 0) { note = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (term === void 0) { term = null; }
        if (courses === void 0) { courses = []; }
        if (windows === void 0) { windows = []; }
        if (uniqueCampuses === void 0) { uniqueCampuses = []; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.termId = termId;
        _this.courseIds = courseIds;
        _this.windowIds = windowIds;
        _this.displayName = displayName;
        _this.note = note;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        _this.term = term;
        _this.courses = courses;
        _this.windows = windows;
        _this.uniqueCampuses = uniqueCampuses;
        return _this;
    }
    Workshop.clone = function (obj) {
        var workshop = new this();
        if (obj.id) {
            workshop.id = obj.id;
        }
        if (obj.termId) {
            workshop.termId = obj.termId;
        }
        if (obj.courseIds) {
            workshop.courseIds = obj.courseIds;
        }
        if (obj.windowIds) {
            workshop.windowIds = obj.windowIds;
        }
        if (obj.displayName) {
            workshop.displayName = obj.displayName;
        }
        if (obj.note) {
            workshop.note = obj.note;
        }
        if (obj.createdAt) {
            workshop.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            workshop.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.term) {
            workshop.term = term_Term.clone(obj.term);
        }
        if (obj.windows && obj.windows.length > 0) {
            obj.windows.forEach(function (w) {
                workshop.windows.push(window_Window.clone(w));
            });
        }
        if (obj.courses && obj.courses.length > 0) {
            obj.courses.forEach(function (c) {
                workshop.courses.push(course_Course.clone(c));
            });
        }
        workshop.windows.forEach(function (w) {
            var isPresent = workshop.uniqueCampuses.find(function (c) { return c.id == w.campusId; });
            if (!isPresent) {
                workshop.uniqueCampuses.push(w.campus);
            }
        });
        return workshop;
    };
    Workshop.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (response.windows && response.windows.length > 0) {
            response.windowsAttributes = response.windows.map(function (w) {
                return window_Window.clone(w).serializeForRails();
            });
        }
        delete response.windows;
        return response;
    };
    return Workshop;
}(Model));

//# sourceMappingURL=workshop.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/window.ts
var window___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var window_Window = (function (_super) {
    window___extends(Window, _super);
    function Window(id, workshopId, campusId, dayId, startTime, endTime, lunchStartTime, lunchEndTime, createdAt, updatedAt, hasLunchtime, isEditing, campus, day, workshop) {
        if (startTime === void 0) { startTime = null; }
        if (endTime === void 0) { endTime = null; }
        if (lunchStartTime === void 0) { lunchStartTime = null; }
        if (lunchEndTime === void 0) { lunchEndTime = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (hasLunchtime === void 0) { hasLunchtime = false; }
        if (isEditing === void 0) { isEditing = false; }
        if (campus === void 0) { campus = null; }
        if (day === void 0) { day = null; }
        if (workshop === void 0) { workshop = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.workshopId = workshopId;
        _this.campusId = campusId;
        _this.dayId = dayId;
        _this.startTime = startTime;
        _this.endTime = endTime;
        _this.lunchStartTime = lunchStartTime;
        _this.lunchEndTime = lunchEndTime;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        _this.hasLunchtime = hasLunchtime;
        _this.isEditing = isEditing;
        _this.campus = campus;
        _this.day = day;
        _this.workshop = workshop;
        return _this;
    }
    Window.clone = function (obj) {
        var window = new this();
        if (obj.id) {
            window.id = obj.id;
        }
        if (obj.workshopId) {
            window.workshopId = obj.workshopId;
        }
        if (obj.campusId) {
            window.campusId = obj.campusId;
        }
        if (obj.dayId) {
            window.dayId = obj.dayId;
        }
        if (obj.startTime) {
            window.startTime = new Date(obj.startTime);
        }
        if (obj.endTime) {
            window.endTime = new Date(obj.endTime);
        }
        if (obj.lunchStartTime) {
            window.lunchStartTime = new Date(obj.lunchStartTime);
        }
        if (obj.lunchEndTime) {
            window.lunchEndTime = new Date(obj.lunchEndTime);
        }
        if (obj.campus) {
            window.campus = Campus.clone(obj.campus);
        }
        if (obj.day) {
            window.day = Day.clone(obj.day);
        }
        if (obj.workshop) {
            window.workshop = workshop_Workshop.clone(obj.workshop);
        }
        if (obj.lunchStartTime && obj.lunchEndTime) {
            window.hasLunchtime = true;
        }
        if (obj.isEditing) {
            window.isEditing = obj.isEditing;
        }
        if (obj.createdAt) {
            window.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            window.updatedAt = new Date(obj.updatedAt);
        }
        return window;
    };
    Window.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (!response.hasLunchtime) {
            response.lunchStartTime = null;
            response.lunchEndTime = null;
        }
        delete response.hasLunchtime;
        return response;
    };
    Window.prototype.setStandardLunchtimes = function () {
        this.startTime = moment().set({ 'hour': 9, 'minute': 30, 'second': 0 }).toDate();
        this.endTime = moment().set({ 'hour': 17, 'minute': 30, 'second': 0 }).toDate();
        this.lunchStartTime = moment().set({ 'hour': 12, 'minute': 30, 'second': 0 }).toDate();
        this.lunchEndTime = moment().set({ 'hour': 13, 'minute': 30, 'second': 0 }).toDate();
    };
    return Window;
}(Model));

//# sourceMappingURL=window.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/tutor-allocation.ts
var tutor_allocation___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var tutor_allocation_TutorAllocation = (function (_super) {
    tutor_allocation___extends(TutorAllocation, _super);
    function TutorAllocation(id, contactId, windowIds, courseIds, contact, windows, courses) {
        if (contact === void 0) { contact = null; }
        if (windows === void 0) { windows = []; }
        if (courses === void 0) { courses = []; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.windowIds = windowIds;
        _this.courseIds = courseIds;
        _this.contact = contact;
        _this.windows = windows;
        _this.courses = courses;
        return _this;
    }
    TutorAllocation.clone = function (obj) {
        var ta = new this();
        if (obj.id) {
            ta.id = obj.id;
        }
        if (obj.contactId) {
            ta.contactId = obj.contactId;
        }
        if (obj.windowIds) {
            ta.windowIds = obj.windowIds;
        }
        if (obj.courseIds) {
            ta.courseIds = obj.courseIds;
        }
        if (obj.contact) {
            ta.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.windows && obj.windows.length > 0) {
            ta.windows = obj.windows.map(function (w) { return window_Window.clone(w); });
        }
        if (obj.courses && obj.courses.length > 0) {
            ta.courses = obj.courses.map(function (c) { return course_Course.clone(c); });
        }
        return ta;
    };
    TutorAllocation.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return TutorAllocation;
}(Model));

//# sourceMappingURL=tutor-allocation.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/workshop-absence.ts
var workshop_absence___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var workshop_absence_WorkshopAbsence = (function (_super) {
    workshop_absence___extends(WorkshopAbsence, _super);
    function WorkshopAbsence(id, contactId, replacementTutorId, startDateTime, endDateTime, contact, replacementTutor, isConfirmingDelete, updatedAt, createdAt) {
        if (startDateTime === void 0) { startDateTime = null; }
        if (endDateTime === void 0) { endDateTime = null; }
        if (contact === void 0) { contact = null; }
        if (replacementTutor === void 0) { replacementTutor = null; }
        if (isConfirmingDelete === void 0) { isConfirmingDelete = false; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.replacementTutorId = replacementTutorId;
        _this.startDateTime = startDateTime;
        _this.endDateTime = endDateTime;
        _this.contact = contact;
        _this.replacementTutor = replacementTutor;
        _this.isConfirmingDelete = isConfirmingDelete;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        return _this;
    }
    WorkshopAbsence.clone = function (obj) {
        var wa = new this();
        if (obj.id) {
            wa.id = obj.id;
        }
        if (obj.contactId) {
            wa.contactId = obj.contactId;
        }
        if (obj.startDateTime) {
            wa.startDateTime = new Date(obj.startDateTime);
        }
        if (obj.endDateTime) {
            wa.endDateTime = new Date(obj.endDateTime);
        }
        if (obj.contact) {
            wa.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.replacementTutor) {
            wa.replacementTutor = contact_Contact.clone(obj.replacementTutor);
        }
        if (obj.updatedAt) {
            wa.updatedAt = obj.updatedAt;
        }
        if (obj.createdAt) {
            wa.createdAt = obj.createdAt;
        }
        return wa;
    };
    WorkshopAbsence.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (response.id === 0) {
            delete response.id;
        }
        if (response.contact) {
            delete response.contact;
        }
        if (response.replacementTutor) {
            delete response.replacementTutor;
        }
        if (response.isConfirmingDelete) {
            delete response.isConfirmingDelete;
        }
        return response;
    };
    return WorkshopAbsence;
}(Model));

//# sourceMappingURL=workshop-absence.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/contact.ts
var contact___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















var contact_Contact = (function (_super) {
    contact___extends(Contact, _super);
    function Contact(id, tutorAllocationId, guardianId, firstName, lastName, fullName, email, gender, contactType, school, grade, joiningGrade, salutation, dob, medicalCondition, promoCode, marketingSource, newsletterSubscription, instalments, employmentStart, updatedAt, createdAt, avatar, avatarFileName, avatarUrl, guardian, students, creditCard, matrixClasses, addresses, phones, alternateEmails, enrolments, studentCourses, tutorCourses, tutorAllocation, absences, workshopAbsences, workshopAbsencesReplacements, modifiedClasses, notes, documents, discounts) {
        if (firstName === void 0) { firstName = ""; }
        if (lastName === void 0) { lastName = ""; }
        if (fullName === void 0) { fullName = ""; }
        if (email === void 0) { email = ""; }
        if (gender === void 0) { gender = 0; }
        if (contactType === void 0) { contactType = 0; }
        if (school === void 0) { school = ""; }
        if (grade === void 0) { grade = null; }
        if (joiningGrade === void 0) { joiningGrade = 0; }
        if (salutation === void 0) { salutation = ""; }
        if (dob === void 0) { dob = null; }
        if (medicalCondition === void 0) { medicalCondition = ""; }
        if (promoCode === void 0) { promoCode = ""; }
        if (marketingSource === void 0) { marketingSource = ""; }
        if (newsletterSubscription === void 0) { newsletterSubscription = false; }
        if (instalments === void 0) { instalments = 0; }
        if (employmentStart === void 0) { employmentStart = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (avatar === void 0) { avatar = ""; }
        if (avatarFileName === void 0) { avatarFileName = ""; }
        if (avatarUrl === void 0) { avatarUrl = ""; }
        if (guardian === void 0) { guardian = null; }
        if (students === void 0) { students = []; }
        if (creditCard === void 0) { creditCard = null; }
        if (matrixClasses === void 0) { matrixClasses = []; }
        if (addresses === void 0) { addresses = []; }
        if (phones === void 0) { phones = []; }
        if (alternateEmails === void 0) { alternateEmails = []; }
        if (enrolments === void 0) { enrolments = []; }
        if (studentCourses === void 0) { studentCourses = []; }
        if (tutorCourses === void 0) { tutorCourses = []; }
        if (tutorAllocation === void 0) { tutorAllocation = null; }
        if (absences === void 0) { absences = []; }
        if (workshopAbsences === void 0) { workshopAbsences = []; }
        if (workshopAbsencesReplacements === void 0) { workshopAbsencesReplacements = []; }
        if (modifiedClasses === void 0) { modifiedClasses = []; }
        if (notes === void 0) { notes = []; }
        if (documents === void 0) { documents = []; }
        if (discounts === void 0) { discounts = []; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.tutorAllocationId = tutorAllocationId;
        _this.guardianId = guardianId;
        _this.firstName = firstName;
        _this.lastName = lastName;
        _this.fullName = fullName;
        _this.email = email;
        _this.gender = gender;
        _this.contactType = contactType;
        _this.school = school;
        _this.grade = grade;
        _this.joiningGrade = joiningGrade;
        _this.salutation = salutation;
        _this.dob = dob;
        _this.medicalCondition = medicalCondition;
        _this.promoCode = promoCode;
        _this.marketingSource = marketingSource;
        _this.newsletterSubscription = newsletterSubscription;
        _this.instalments = instalments;
        _this.employmentStart = employmentStart;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        _this.avatar = avatar;
        _this.avatarFileName = avatarFileName;
        _this.avatarUrl = avatarUrl;
        _this.guardian = guardian;
        _this.students = students;
        _this.creditCard = creditCard;
        _this.matrixClasses = matrixClasses;
        _this.addresses = addresses;
        _this.phones = phones;
        _this.alternateEmails = alternateEmails;
        _this.enrolments = enrolments;
        _this.studentCourses = studentCourses;
        _this.tutorCourses = tutorCourses;
        _this.tutorAllocation = tutorAllocation;
        _this.absences = absences;
        _this.workshopAbsences = workshopAbsences;
        _this.workshopAbsencesReplacements = workshopAbsencesReplacements;
        _this.modifiedClasses = modifiedClasses;
        _this.notes = notes;
        _this.documents = documents;
        _this.discounts = discounts;
        return _this;
    }
    Contact.clone = function (obj) {
        var contact = new this();
        if (obj.id) {
            contact.id = obj.id;
        }
        if (obj.guardianId) {
            contact.guardianId = obj.guardianId;
        }
        if (obj.tutorAllocationId) {
            contact.tutorAllocationId = obj.tutorAllocationId;
        }
        if (obj.firstName) {
            contact.firstName = obj.firstName;
        }
        if (obj.lastName) {
            contact.lastName = obj.lastName;
        }
        if (obj.fullName) {
            contact.fullName = obj.fullName;
        }
        if (obj.email) {
            contact.email = obj.email;
        }
        if (obj.gender) {
            contact.gender = obj.gender;
        }
        if (obj.contactType) {
            contact.contactType = obj.contactType;
        }
        if (obj.school) {
            contact.school = obj.school;
        }
        if (obj.grade) {
            contact.grade = obj.grade;
        }
        if (obj.joiningGrade) {
            contact.joiningGrade = obj.joiningGrade;
        }
        if (obj.salutation) {
            contact.salutation = obj.salutation;
        }
        if (obj.dob) {
            contact.dob = Utilities.makeDate(obj.dob);
        }
        if (obj.medicalCondition) {
            contact.medicalCondition = obj.medicalCondition;
        }
        if (obj.promoCode) {
            contact.promoCode = obj.promoCode;
        }
        if (obj.marketingSource) {
            contact.marketingSource = obj.marketingSource;
        }
        if (obj.newsletterSubscription) {
            contact.newsletterSubscription = obj.newsletterSubscription;
        }
        if (obj.instalments) {
            contact.instalments = obj.instalments;
        }
        if (obj.employmentStart) {
            contact.employmentStart = Utilities.makeDate(obj.employmentStart);
        }
        if (obj.tutorAllocation) {
            contact.tutorAllocation = tutor_allocation_TutorAllocation.clone(obj.tutorAllocation);
        }
        if (obj.updatedAt) {
            contact.updatedAt = obj.updatedAt;
        }
        if (obj.createdAt) {
            contact.createdAt = obj.createdAt;
        }
        if (obj.avatar) {
            contact.avatar = obj.avatar;
        }
        if (obj.avatarFileName) {
            contact.avatarFileName = obj.avatarFileName;
        }
        if (obj.avatarUrl) {
            contact.avatarUrl = obj.avatarUrl;
        }
        if (obj.guardian) {
            contact.guardian = Contact.clone(obj.guardian);
        }
        if (obj.creditCard) {
            contact.creditCard = CreditCard.clone(obj.creditCard);
        }
        if (obj.students && obj.students.length > 0) {
            obj.students.forEach(function (s) {
                contact.students.push(Contact.clone(s));
            });
        }
        if (obj.addresses && obj.addresses.length > 0) {
            obj.addresses.forEach(function (a) {
                contact.addresses.push(address_Address.clone(a));
            });
        }
        if (obj.phones && obj.phones.length > 0) {
            obj.phones.forEach(function (p) {
                contact.phones.push(Phone.clone(p));
            });
        }
        if (obj.alternateEmails && obj.alternateEmails.length > 0) {
            obj.alternateEmails.forEach(function (e) {
                contact.alternateEmails.push(AlternateEmail.clone(e));
            });
        }
        if (obj.enrolments && obj.enrolments.length > 0) {
            obj.enrolments.forEach(function (e) {
                contact.enrolments.push(enrolment_Enrolment.clone(e));
            });
        }
        if (obj.studentCourses && obj.studentCourses.length > 0) {
            obj.studentCourses.forEach(function (c) {
                contact.studentCourses.push(course_Course.clone(c));
            });
        }
        if (obj.tutorCourses && obj.tutorCourses.length > 0) {
            obj.tutorCourses.forEach(function (c) {
                contact.tutorCourses.push(course_Course.clone(c));
            });
        }
        if (obj.matrixClasses && obj.matrixClasses.length > 0) {
            obj.matrixClasses.forEach(function (c) {
                contact.matrixClasses.push(matrix_class_MatrixClass.clone(c));
            });
        }
        if (obj.absences && obj.absences.length > 0) {
            obj.absences.forEach(function (a) {
                contact.absences.push(absence_Absence.clone(a));
            });
        }
        if (obj.workshopAbsences && obj.workshopAbsences.length > 0) {
            obj.workshopAbsences.forEach(function (wa) {
                contact.workshopAbsences.push(workshop_absence_WorkshopAbsence.clone(wa));
            });
        }
        if (obj.workshopAbsencesReplacements && obj.workshopAbsencesReplacements.length > 0) {
            obj.workshopAbsencesReplacements.forEach(function (wa) {
                contact.workshopAbsencesReplacements.push(workshop_absence_WorkshopAbsence.clone(wa));
            });
        }
        if (obj.modifiedClasses && obj.modifiedClasses.length > 0) {
            obj.modifiedClasses.forEach(function (modC) {
                contact.modifiedClasses.push(modified_class_ModifiedClass.clone(modC));
            });
        }
        if (obj.notes && obj.notes.length > 0) {
            obj.notes.forEach(function (n) {
                contact.notes.push(Note.clone(n));
            });
        }
        if (obj.documents && obj.documents.length > 0) {
            obj.documents.forEach(function (d) {
                contact.documents.push(Document.clone(d));
            });
        }
        if (obj.discounts && obj.discounts.length > 0) {
            obj.discounts.forEach(function (d) {
                contact.discounts.push(discount_Discount.clone(d));
            });
        }
        if (obj.errors && Object.keys(obj.errors).length > 0) {
            contact.errors = Model.getJsonApiErrors(obj.errors);
        }
        return contact;
    };
    Contact.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        if (response.addresses && response.addresses.length > 0) {
            response.addressesAttributes = response.addresses;
        }
        if (response.phones && response.phones.length > 0) {
            response.phonesAttributes = response.phones;
        }
        if (response.alternateEmails && response.alternateEmails.length > 0) {
            response.alternateEmailsAttributes = response.alternateEmails;
        }
        return response;
    };
    return Contact;
}(Model));

//# sourceMappingURL=contact.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/ticket.ts
var ticket___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ticket_Ticket = (function (_super) {
    ticket___extends(Ticket, _super);
    function Ticket(id, contactId, ticketAllocationId, purchaseDate, contact, 
        // TODO: Consider moving all of uiState to an interface
        uiState, createdAt, updatedAt) {
        if (purchaseDate === void 0) { purchaseDate = null; }
        if (contact === void 0) { contact = null; }
        if (uiState === void 0) { uiState = {}; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.ticketAllocationId = ticketAllocationId;
        _this.purchaseDate = purchaseDate;
        _this.contact = contact;
        _this.uiState = uiState;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Ticket.clone = function (obj) {
        var e = new this();
        if (obj.id) {
            e.id = obj.id;
        }
        if (obj.contactId) {
            e.contactId = obj.contactId;
        }
        if (obj.ticketAllocationId) {
            e.ticketAllocationId = obj.ticketAllocationId;
        }
        if (obj.purchaseDate) {
            e.purchaseDate = new Date(obj.purchaseDate);
        }
        if (obj.contact) {
            e.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.createdAt) {
            e.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            e.updatedAt = new Date(obj.updatedAt);
        }
        return e;
    };
    return Ticket;
}(Model));

//# sourceMappingURL=ticket.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/ticket-allocation.ts
var ticket_allocation___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ticket_allocation_TicketAllocation = (function (_super) {
    ticket_allocation___extends(TicketAllocation, _super);
    function TicketAllocation(id, termId, courseId, eventId, contactId, title, price, whenDisplay, location, locationUrl, saleStartDateTime, saleEndDateTime, startDateTime, endDateTime, quantity, recurringDays, soldCount, remainingCount, course, term, event, contact, tickets, uiState, createdAt, updatedAt) {
        if (title === void 0) { title = null; }
        if (price === void 0) { price = null; }
        if (whenDisplay === void 0) { whenDisplay = null; }
        if (location === void 0) { location = null; }
        if (locationUrl === void 0) { locationUrl = null; }
        if (saleStartDateTime === void 0) { saleStartDateTime = null; }
        if (saleEndDateTime === void 0) { saleEndDateTime = null; }
        if (startDateTime === void 0) { startDateTime = null; }
        if (endDateTime === void 0) { endDateTime = null; }
        if (quantity === void 0) { quantity = null; }
        if (recurringDays === void 0) { recurringDays = null; }
        if (soldCount === void 0) { soldCount = 0; }
        if (remainingCount === void 0) { remainingCount = 0; }
        if (course === void 0) { course = null; }
        if (term === void 0) { term = null; }
        if (event === void 0) { event = null; }
        if (contact === void 0) { contact = null; }
        if (tickets === void 0) { tickets = []; }
        if (uiState === void 0) { uiState = {}; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.termId = termId;
        _this.courseId = courseId;
        _this.eventId = eventId;
        _this.contactId = contactId;
        _this.title = title;
        _this.price = price;
        _this.whenDisplay = whenDisplay;
        _this.location = location;
        _this.locationUrl = locationUrl;
        _this.saleStartDateTime = saleStartDateTime;
        _this.saleEndDateTime = saleEndDateTime;
        _this.startDateTime = startDateTime;
        _this.endDateTime = endDateTime;
        _this.quantity = quantity;
        _this.recurringDays = recurringDays;
        _this.soldCount = soldCount;
        _this.remainingCount = remainingCount;
        _this.course = course;
        _this.term = term;
        _this.event = event;
        _this.contact = contact;
        _this.tickets = tickets;
        _this.uiState = uiState;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    TicketAllocation.clone = function (obj) {
        var e = new this();
        if (obj.id) {
            e.id = obj.id;
        }
        if (obj.termId) {
            e.termId = obj.termId;
        }
        if (obj.courseId) {
            e.courseId = obj.courseId;
        }
        if (obj.eventId) {
            e.eventId = obj.eventId;
        }
        if (obj.contactId) {
            e.contactId = obj.contactId;
        }
        if (obj.title) {
            e.title = obj.title;
        }
        if (obj.price) {
            e.price = parseFloat(obj.price);
        }
        if (obj.whenDisplay) {
            e.whenDisplay = obj.whenDisplay;
        }
        if (obj.location) {
            e.location = obj.location;
        }
        if (obj.locationUrl) {
            e.locationUrl = obj.locationUrl;
        }
        if (obj.startDateTime) {
            e.startDateTime = new Date(obj.startDateTime);
        }
        if (obj.endDateTime) {
            e.endDateTime = new Date(obj.endDateTime);
        }
        if (obj.saleStartDateTime) {
            e.saleStartDateTime = new Date(obj.saleStartDateTime);
        }
        if (obj.saleEndDateTime) {
            e.saleEndDateTime = new Date(obj.saleEndDateTime);
        }
        if (obj.quantity) {
            e.quantity = obj.quantity;
        }
        if (obj.recurringDays) {
            e.recurringDays = obj.recurringDays;
        }
        if (obj.remainingCount) {
            e.remainingCount = obj.remainingCount;
        }
        if (obj.soldCount) {
            e.soldCount = parseInt(obj.soldCount);
        }
        if (obj.uiState) {
            e.uiState = obj.uiState;
        }
        if (obj.course) {
            e.course = course_Course.clone(obj.course);
        }
        if (obj.term) {
            e.term = term_Term.clone(obj.term);
        }
        if (obj.event) {
            e.event = event_Event.clone(obj.event);
        }
        if (obj.contact) {
            e.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.tickets && obj.tickets.length > 0) {
            e.tickets = obj.tickets.map(function (t) { return ticket_Ticket.clone(t); });
        }
        if (obj.createdAt) {
            e.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            e.updatedAt = new Date(obj.updatedAt);
        }
        return e;
    };
    TicketAllocation.prototype.available = function () {
        return !this.soldOut() && !this.unavailable();
    };
    TicketAllocation.prototype.expired = function () {
        return moment().isAfter(this.saleEndDateTime);
    };
    TicketAllocation.prototype.unavailable = function () {
        return moment().isBefore(this.saleStartDateTime) || this.expired();
    };
    TicketAllocation.prototype.soldOut = function () {
        return this.remainingCount <= 0;
    };
    return TicketAllocation;
}(Model));

//# sourceMappingURL=ticket-allocation.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/event.ts
var event___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var event_Event = (function (_super) {
    event___extends(Event, _super);
    function Event(id, title, description, startDateTime, endDateTime, ticketAllocations, createdAt, updatedAt) {
        if (title === void 0) { title = null; }
        if (description === void 0) { description = null; }
        if (startDateTime === void 0) { startDateTime = null; }
        if (endDateTime === void 0) { endDateTime = null; }
        if (ticketAllocations === void 0) { ticketAllocations = []; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.title = title;
        _this.description = description;
        _this.startDateTime = startDateTime;
        _this.endDateTime = endDateTime;
        _this.ticketAllocations = ticketAllocations;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Event.clone = function (obj) {
        var e = new this();
        if (obj.id) {
            e.id = obj.id;
        }
        if (obj.title) {
            e.title = obj.title;
        }
        if (obj.description) {
            e.description = obj.description;
        }
        if (obj.startDateTime) {
            e.startDateTime = new Date(obj.startDateTime);
        }
        if (obj.endDateTime) {
            e.endDateTime = new Date(obj.endDateTime);
        }
        if (obj.ticketAllocations && obj.ticketAllocations.length > 0) {
            obj.ticketAllocations.forEach(function (ta) {
                e.ticketAllocations.push(ticket_allocation_TicketAllocation.clone(ta));
            });
        }
        if (obj.createdAt) {
            e.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            e.updatedAt = new Date(obj.updatedAt);
        }
        return e;
    };
    Event.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        response.ticketAllocationsAttributes = response.ticketAllocations;
        return response;
    };
    Event.createPurchaseTicketAsGuestPayload = function (student, parent, taIds, creditCard) {
        var result = {};
        result.student_attributes = student.serializeForRails();
        result.guardian_attributes = parent.serializeForRails();
        result.card_attributes = creditCard.serializeForRails();
        result.tickets_attributes = taIds.map(function (ticketAllocationId) {
            return {
                ticket_allocation_id: ticketAllocationId,
            };
        });
        return result;
    };
    Event.createPurchaseTicketAsExistingPayload = function (student, taIds) {
        var result = {};
        result.studentId = student.id;
        result.ticketAllocationIds = taIds;
        return result;
    };
    return Event;
}(Model));

//# sourceMappingURL=event.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/validators/matching.ts
var MatchingValidation = (function () {
    function MatchingValidation() {
    }
    MatchingValidation.studentAndParentEmailsDifferent = function (c) {
        var sEmail = c.get('studentEmail').value;
        var pEmail = c.get('parentEmail').value;
        if (sEmail === pEmail) {
            c.get('parentEmail').setErrors({ cantBeSameAsStudentEmail: true });
        }
        else {
            c.get('parentEmail').setErrors(null);
        }
    };
    return MatchingValidation;
}());

//# sourceMappingURL=matching.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/rxjs/Rx.js
var Rx = __webpack_require__("Dqrr");
var Rx_default = /*#__PURE__*/__webpack_require__.n(Rx);

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("CPp0");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/class-between.ts
var ClassBetween = (function () {
    function ClassBetween(matrixClassId, code, period, startDateTime, endDateTime, date) {
        if (matrixClassId === void 0) { matrixClassId = null; }
        if (code === void 0) { code = ""; }
        if (period === void 0) { period = 1; }
        if (startDateTime === void 0) { startDateTime = null; }
        if (endDateTime === void 0) { endDateTime = null; }
        if (date === void 0) { date = null; }
        this.matrixClassId = matrixClassId;
        this.code = code;
        this.period = period;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.date = date;
    }
    ClassBetween.clone = function (obj) {
        var cb = new this();
        if (obj.matrixClassId) {
            cb.matrixClassId = obj.matrixClassId;
        }
        if (obj.code) {
            cb.code = obj.code;
        }
        if (obj.period) {
            cb.period = obj.period;
        }
        if (obj.startDateTime) {
            cb.startDateTime = new Date(obj.startDateTime);
        }
        if (obj.endDateTime) {
            cb.endDateTime = new Date(obj.endDateTime);
        }
        if (obj.date) {
            cb.date = new Date(obj.date);
        }
        return cb;
    };
    return ClassBetween;
}());

//# sourceMappingURL=class-between.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/action-cable.ts
var ActionCable = __webpack_require__("3/rO");
var ActionCableService = (function () {
    function ActionCableService() {
        this.init();
    }
    ActionCableService.prototype.init = function () {
        if (!this.isInitted) {
            this.cable = ActionCable.createConsumer();
            this.isInitted = true;
        }
    };
    ActionCableService.ctorParameters = function () { return []; };
    return ActionCableService;
}());

//# sourceMappingURL=action-cable.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/contacts.ts


var contacts_ContactsStore = (function () {
    function ContactsStore(contacts, activeContact, editableContact, editableAbsence, students) {
        if (contacts === void 0) { contacts = []; }
        if (activeContact === void 0) { activeContact = new contact_Contact(); }
        if (editableContact === void 0) { editableContact = new contact_Contact(); }
        if (editableAbsence === void 0) { editableAbsence = new absence_Absence(); }
        if (students === void 0) { students = []; }
        this.contacts = contacts;
        this.activeContact = activeContact;
        this.editableContact = editableContact;
        this.editableAbsence = editableAbsence;
        this.students = students;
    }
    return ContactsStore;
}());

//# sourceMappingURL=contacts.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/contacts.ts



var contactsReducer = function (state, action) {
    if (state === void 0) { state = new contacts_ContactsStore(); }
    switch (action.type) {
        case POPULATE_CONTACTS:
            return new contacts_ContactsStore(action.payload.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case ADD_CONTACT:
            return new contacts_ContactsStore(state.contacts.concat([action.payload]), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case REPLACE_CONTACT:
            var p_1 = action.payload;
            var contacts = state.contacts.map(function (c) {
                if (c.id === p_1.id) {
                    return p_1;
                }
                ;
                return c;
            });
            var active = state.activeContact.id === p_1.id ? p_1 : contact_Contact.clone(state.activeContact);
            var editable = state.editableContact.id === p_1.id ? p_1 : contact_Contact.clone(state.editableContact);
            return new contacts_ContactsStore(contacts, active, editable, state.editableAbsence, state.students.slice());
        case POPULATE_EDITABLE_CONTACT:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, action.payload, state.editableAbsence, state.students.slice());
        case POPULATE_ACTIVE_CONTACT:
            return new contacts_ContactsStore(state.contacts.slice(), action.payload, state.editableContact, state.editableAbsence, state.students.slice());
        case POPULATE_ACTIVE_CONTACT_ENROLMENTS:
            state.activeContact.enrolments = action.payload;
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case RESET_CONTACT_ERRORS:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, contact_Contact.clone(Object.assign({}, action.payload, { errors: {} })), state.editableAbsence, state.students.slice());
        case RESET_EDITABLE_CONTACT:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, null, state.editableAbsence, state.students.slice());
        case REMOVE_CONTACT:
            return new contacts_ContactsStore(state.contacts.filter(function (contact) { return contact.id !== action.payload.id; }), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case CREATE_CONTACT_FAILURE:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, contact_Contact.clone(Object.assign({}, state.editableContact, action.payload)), state.editableAbsence, state.students.slice());
        case UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, absence_Absence.clone(Object.assign({}, state.editableAbsence, { classesBetween: action.payload })), state.students.slice());
        case POPULATE_STUDENTS:
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, action.payload.slice());
        case CREATED_DOCUMENT:
            state.activeContact.documents.push(action.payload);
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case DELETED_DOCUMENT:
            state.activeContact.documents =
                state.activeContact.documents.filter(function (d) { return d.id != action.payload; });
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case CREATED_NOTE:
            state.activeContact.notes.push(action.payload);
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case DELETED_NOTE:
            state.activeContact.notes =
                state.activeContact.notes.filter(function (n) { return n.id != action.payload; });
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case DELETED_ADDRESS:
            state.activeContact.addresses =
                state.activeContact.addresses.filter(function (a) { return a.id != action.payload; });
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        case DELETED_PHONE:
            state.activeContact.phones =
                state.activeContact.phones.filter(function (p) { return p.id != action.payload; });
            return new contacts_ContactsStore(state.contacts.slice(), state.activeContact, state.editableContact, state.editableAbsence, state.students.slice());
        default:
            return state;
    }
};
var FETCH_CONTACTS = 'FETCH_CONTACTS';
var FETCH_CONTACTS_FAILURE = 'FETCH_CONTACTS_FAILURE';
var FETCH_CONTACT = 'FETCH_CONTACT';
var FETCH_CONTACT_FAILURE = 'FETCH_CONTACT_FAILURE';
var POPULATE_CONTACTS = 'POPULATE_CONTACTS';
var POPULATE_EDITABLE_CONTACT = 'POPULATE_EDITABLE_CONTACT';
var POPULATE_ACTIVE_CONTACT = 'POPULATE_ACTIVE_CONTACT';
var FETCH_ACTIVE_CONTACT_ENROLMENTS = 'FETCH_ACTIVE_CONTACT_ENROLMENTS';
var FETCH_ACTIVE_CONTACT_ENROLMENTS_FAILURE = 'FETCH_ACTIVE_CONTACT_ENROLMENTS_FAILURE';
var POPULATE_ACTIVE_CONTACT_ENROLMENTS = 'POPULATE_ACTIVE_CONTACT_ENROLMENTS';
var ADD_CONTACT = 'ADD_CONTACT';
var REPLACE_CONTACT = 'REPLACE_CONTACT';
var RESET_CONTACT_ERRORS = "RESET_CONTACT_ERRORS";
var RESET_EDITABLE_CONTACT = "RESET_EDITABLE_CONTACT";
var REMOVE_CONTACT = 'REMOVE_CONTACT';
var CREATE_CONTACT = 'CREATE_CONTACT';
var CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE';
var UPDATE_CONTACT = 'UPDATE_CONTACT';
var UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE';
var FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT = 'FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT';
var UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT = 'UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT';
var CREATE_ABSENCE = 'CREATE_ABSENCE';
var CREATE_ABSENCE_FAILURE = 'CREATE_ABSENCE_FAILURE';
var DELETE_ABSENCE = 'DELETE_ABSENCE';
var DELETE_ABSENCE_FAILURE = 'DELETE_ABSENCE_FAILURE';
var FETCH_STUDENTS = 'FETCH_STUDENTS';
var FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";
var POPULATE_STUDENTS = 'POPULATE_STUDENTS';
var CREATE_DOCUMENT = 'CREATE_DOCUMENT';
var CREATED_DOCUMENT = 'CREATED_DOCUMENT';
var CREATE_DOCUMENT_FAILURE = 'CREATE_DOCUMENT_FAILURE';
var DELETE_DOCUMENT = 'DELETE_DOCUMENT';
var DELETED_DOCUMENT = 'DELETED_DOCUMENT';
var DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE';
var CREATE_NOTE = 'CREATE_NOTE';
var CREATED_NOTE = 'CREATED_NOTE';
var CREATE_NOTE_FAILURE = 'CREATE_NOTE_FAILURE';
var DELETE_NOTE = 'DELETE_NOTE';
var DELETED_NOTE = 'DELETED_NOTE';
var DELETE_NOTE_FAILURE = 'DELETE_NOTE_FAILURE';
var DELETE_ADDRESS = 'DELETE_ADDRESS';
var DELETED_ADDRESS = 'DELETED_ADDRESS';
var DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE';
var DELETE_PHONE = 'DELETE_PHONE';
var DELETED_PHONE = 'DELETED_PHONE';
var DELETE_PHONE_FAILURE = 'DELETE_PHONE_FAILURE';
var PERFORM_ACADEMIC_ROLLOVER = 'PERFORM_ACADEMIC_ROLLOVER';
var PERFORMED_ACADEMIC_ROLLOVER = 'PERFORMED_ACADEMIC_ROLLOVER';
var ACADEMIC_ROLLOVER_FAILURE = 'ACADEMIC_ROLLOVER_FAILURE';
var APPLY_DISCOUNT = 'APPLY_DISCOUNT';
var APPLIED_DISCOUNT = 'APPLIED_DISCOUNT';
var APPLY_DISCOUNT_FAILURE = 'APPLY_DISCOUNT_FAILURE';
var REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';
var REMOVE_DISCOUNT_SUCCESS = 'REMOVE_DISCOUNT_SUCCESS';
var REMOVE_DISCOUNT_FAILURE = 'REMOVE_DISCOUNT_FAILURE';
//# sourceMappingURL=contacts.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/rxjs/add/operator/map.js
var map = __webpack_require__("5v8a");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/rxjs/add/operator/catch.js
var operator_catch = __webpack_require__("xpf9");
var catch_default = /*#__PURE__*/__webpack_require__.n(operator_catch);

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/contact.ts













var contact_ContactService = (function () {
    function ContactService(http, actionCableService, store) {
        this.http = http;
        this.actionCableService = actionCableService;
        this.store = store;
        this.contactsUrl = 'contacts';
        this.documentsUrl = 'documents';
        this.notesUrl = 'notes';
        this.addressesUrl = 'addresses';
        this.phonesUrl = 'phones';
        this.absenceUrl = 'absences';
    }
    ContactService.prototype.index = function (params) {
        if (params === void 0) { params = {}; }
        var search = new http_es5["k" /* URLSearchParams */]();
        for (var key in params) {
            search.set(key, params[key]);
        }
        return this.http.get(this.contactsUrl, { search: search })
            .map(function (res) {
            return res.json().map(function (c) { return contact_Contact.clone(c); });
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.fetch = function (id) {
        return this.http.get(this.contactsUrl + "/" + id)
            .map(function (res) { return contact_Contact.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.create = function (params) {
        return this.http.post(this.contactsUrl, params)
            .map(function (res) { return contact_Contact.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.update = function (params) {
        return this.http.patch(this.contactsUrl + "/" + params.id, params)
            .map(function (res) { return contact_Contact.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.classesBetween = function (p) {
        return this.http.post(this.contactsUrl + "/" + p.contactId + "/classes_between", p)
            .map(function (res) {
            return res.json().map(function (r) { return ClassBetween.clone(r); });
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.createAbsence = function (a) {
        return this.http.post("" + this.absenceUrl, a.serializeForRails())
            .map(function (res) { return absence_Absence.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.deleteAbsence = function (a) {
        return this.http.delete(this.absenceUrl + "/" + a.id)
            .map(function () { return a.contactId; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.students = function () {
        return this.http.get(this.contactsUrl + "/students")
            .map(function (res) {
            return res.json().map(function (c) { return contact_Contact.clone(c); });
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.checkUniqueEmail = function (email) {
        return this.http.put(this.contactsUrl + "/check_unique_email", { email: email })
            .map(function (res) {
            var response = res.json();
            var result = { result: response.result };
            if (response.contact) {
                result.contact = contact_Contact.clone(response.contact);
            }
            return result;
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.createDocument = function (document) {
        return this.http.post(this.documentsUrl, document)
            .map(function (res) { return Document.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.deleteDocument = function (id) {
        return this.http.delete(this.documentsUrl + "/" + id)
            .map(function () { return id; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.createNote = function (note) {
        return this.http.post(this.notesUrl, note)
            .map(function (res) { return Note.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.deleteNote = function (id) {
        return this.http.delete(this.notesUrl + "/" + id)
            .map(function () { return id; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.deleteAddress = function (id) {
        return this.http.delete(this.addressesUrl + "/" + id)
            .map(function () { return id; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.deletePhone = function (id) {
        return this.http.delete(this.phonesUrl + "/" + id)
            .map(function () { return id; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.academicRollover = function () {
        return this.http.patch(this.contactsUrl + "/academic_rollover", {})
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.applyDiscount = function (params) {
        return this.http.patch(this.contactsUrl + "/" + params.studentId + "/apply_discount", params)
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.removeDiscount = function (params) {
        return this.http.patch(this.contactsUrl + "/remove_discount", params)
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ContactService.prototype.subscribe = function () {
        var _this = this;
        this.actionCableService.cable.subscriptions.create({ channel: 'ContactsChannel' }, {
            received: function (data) {
                if (data.action === "create") {
                    var c = data.content;
                    _this.store.dispatch({ type: ADD_CONTACT, payload: contact_Contact.clone(c) });
                }
            },
        });
    };
    ContactService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: ActionCableService }, { type: _ngrx_store["f" /* Store */] }]; };
    return ContactService;
}());

//# sourceMappingURL=contact.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/validators/unique-email-async.ts


var unique_email_async_UniqueEmailAsyncValidation = (function () {
    function UniqueEmailAsyncValidation(contactService) {
        this.contactService = contactService;
    }
    UniqueEmailAsyncValidation.prototype.validate = function (c) {
        return this.checkUnique(c.value).first();
    };
    UniqueEmailAsyncValidation.prototype.checkUnique = function (email) {
        var _this = this;
        return Rx["Observable"].timer(500).switchMap(function () {
            return _this.contactService
                .checkUniqueEmail(email)
                .switchMap(function (check) {
                if (!check.result) {
                    return Rx["Observable"].of({ emailTaken: true });
                }
                else {
                    return Rx["Observable"].of(null);
                }
            });
        });
    };
    UniqueEmailAsyncValidation.ctorParameters = function () { return [{ type: contact_ContactService }]; };
    return UniqueEmailAsyncValidation;
}());

//# sourceMappingURL=unique-email-async.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/events.ts
var EventsStore = (function () {
    function EventsStore(events, activeEvent, editableCreditCard, errors, loading) {
        if (events === void 0) { events = []; }
        if (activeEvent === void 0) { activeEvent = null; }
        if (editableCreditCard === void 0) { editableCreditCard = null; }
        if (errors === void 0) { errors = null; }
        if (loading === void 0) { loading = false; }
        this.events = events;
        this.activeEvent = activeEvent;
        this.editableCreditCard = editableCreditCard;
        this.errors = errors;
        this.loading = loading;
    }
    EventsStore.clone = function (store) {
        var result = new this();
        result.events = store.events.slice();
        result.activeEvent = store.activeEvent;
        result.editableCreditCard = store.editableCreditCard;
        result.errors = store.errors;
        return result;
    };
    return EventsStore;
}());

//# sourceMappingURL=events.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/events.ts
var events___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var eventsReducer = function (state, action) {
    if (state === void 0) { state = new EventsStore(); }
    var s = EventsStore.clone(state);
    var activeEvent;
    var allocation;
    var allocationIndex;
    var ticket;
    var ticketIndex;
    var newAllocations;
    var newTickets;
    var newActiveEvent;
    switch (action.type) {
        case POPULATE_EVENTS:
            return events___assign({}, s, { events: action.payload });
        case ADD_EVENT:
            return events___assign({}, s, { events: state.events.concat([
                    action.payload,
                ]) });
        case POPULATE_ACTIVE_EVENT:
            return events___assign({}, s, { activeEvent: action.payload });
        case POPULATE_EDITABLE_CREDIT_CARD:
            return events___assign({}, s, { editableCreditCard: action.payload });
        case PURCHASE_TICKETS_AS_GUEST:
            return events___assign({}, s, { loading: true });
        case PURCHASED_TICKETS_AS_GUEST:
            return events___assign({}, s, { loading: false });
        case PURCHASE_TICKETS_AS_GUEST_FAILURE:
            return events___assign({}, s, { errors: action.payload, loading: false });
        case PURCHASE_TICKETS_AS_EXISTING:
            return events___assign({}, s, { loading: true });
        case PURCHASED_TICKETS_AS_EXISTING:
            return events___assign({}, s, { loading: false });
        case PURCHASE_TICKETS_AS_EXISTING_FAILURE:
            return events___assign({}, s, { errors: action.payload, loading: false });
        case PURCHASE_TICKET_AS_STAFF:
            return events___assign({}, s, { loading: true });
        case PURCHASED_TICKET_AS_STAFF:
            return events___assign({}, s, { loading: false });
        case PURCHASE_TICKET_AS_STAFF_FAILURE:
            return events___assign({}, s, { errors: action.payload, loading: false });
        // TODO: Test coverage on these items
        // TODO: Introduce immutable.js
        case DELETE_TICKET_FROM_EVENT:
            activeEvent = events___assign({}, s.activeEvent);
            allocationIndex = activeEvent.ticketAllocations.findIndex(function (ta) {
                return action.payload.allocation.id === ta.id;
            });
            allocation = ticket_allocation_TicketAllocation.clone(action.payload.allocation);
            ticket = events___assign({}, action.payload.ticket);
            newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.map(function (t) {
                if (t.id === ticket.id) {
                    return events___assign({}, t, { uiState: {
                            failure: false,
                            loading: true,
                        } });
                }
                return events___assign({}, t);
            });
            newAllocations = activeEvent.ticketAllocations.map(function (ta) {
                if (ta.id === allocation.id) {
                    return events___assign({}, ta, { tickets: newTickets });
                }
                return events___assign({}, ta);
            });
            return events___assign({}, s, { activeEvent: events___assign({}, activeEvent, { ticketAllocations: newAllocations }) });
        case DELETED_TICKET_FROM_EVENT:
            activeEvent = events___assign({}, s.activeEvent);
            allocationIndex = activeEvent.ticketAllocations.findIndex(function (ta) {
                return action.payload.allocation.id === ta.id;
            });
            allocation = ticket_allocation_TicketAllocation.clone(action.payload.allocation);
            ticket = events___assign({}, action.payload.ticket);
            newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.filter(function (t) {
                return t.id != ticket.id;
            });
            newAllocations = activeEvent.ticketAllocations.map(function (ta) {
                if (ta.id === allocation.id) {
                    return events___assign({}, ta, { tickets: newTickets });
                }
                return events___assign({}, ta);
            });
            return events___assign({}, s, { activeEvent: events___assign({}, activeEvent, { ticketAllocations: newAllocations }) });
        case DELETE_TICKET_FROM_EVENT_FAILURE:
            activeEvent = events___assign({}, s.activeEvent);
            allocationIndex = activeEvent.ticketAllocations.findIndex(function (ta) {
                return action.payload.allocation.id === ta.id;
            });
            allocation = ticket_allocation_TicketAllocation.clone(action.payload.allocation);
            ticket = events___assign({}, action.payload.ticket);
            newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.map(function (t) {
                if (t.id === ticket.id) {
                    return events___assign({}, t, { uiState: {
                            failure: true,
                            loading: false,
                        } });
                }
                return events___assign({}, t);
            });
            newAllocations = activeEvent.ticketAllocations.map(function (ta) {
                if (ta.id === allocation.id) {
                    return events___assign({}, ta, { tickets: newTickets });
                }
                return events___assign({}, ta);
            });
            return events___assign({}, s, { activeEvent: events___assign({}, activeEvent, { ticketAllocations: newAllocations }) });
        case CLEAR_EVENT_ERRORS:
            return events___assign({}, s, { loading: false, errors: null });
        default:
            return state;
    }
};
var FETCH_EVENTS = "FETCH_EVENTS";
var FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";
var POPULATE_EVENTS = "POPULATE_EVENTS";
var FETCH_EVENT = "FETCH_EVENT";
var FETCH_EVENT_FAILURE = "FETCH_EVENT_FAILURE";
var POPULATE_ACTIVE_EVENT = "POPULATE_ACTIVE_EVENT";
var ADD_EVENT = "ADD_EVENT";
var CREATE_EVENT = "CREATE_EVENT";
var CREATED_EVENT = "CREATED_EVENT";
var CREATE_EVENT_FAILURE = "CREATE_EVENT_FAILURE";
var UPDATE_EVENT = "UPDATE_EVENT";
var UPDATED_EVENT = "UPDATED_EVENT";
var UPDATE_EVENT_FAILURE = "UPDATE_EVENT_FAILURE";
var DELETE_TICKET_FROM_EVENT = "DELETE_TICKET_FROM_EVENT";
var DELETED_TICKET_FROM_EVENT = "DELETED_TICKET_FROM_EVENT";
var DELETE_TICKET_FROM_EVENT_FAILURE = "DELETE_TICKET_FROM_EVENT_FAILURE";
var POPULATE_EDITABLE_CREDIT_CARD = "POPULATE_EDITABLE_CREDIT_CARD";
var PURCHASE_TICKETS_AS_GUEST = "PURCHASE_TICKETS_AS_GUEST";
var PURCHASED_TICKETS_AS_GUEST = "PURCHASED_TICKETS_AS_GUEST";
var PURCHASE_TICKETS_AS_GUEST_FAILURE = "PURCHASE_TICKETS_AS_GUEST_FAILURE";
var PURCHASE_TICKETS_AS_EXISTING = "PURCHASE_TICKETS_AS_EXISTING";
var PURCHASED_TICKETS_AS_EXISTING = "PURCHASED_TICKETS_AS_EXISTING";
var PURCHASE_TICKETS_AS_EXISTING_FAILURE = "PURCHASE_TICKETS_AS_EXISTING_FAILURE";
var PURCHASE_TICKET_AS_STAFF = "PURCHASE_TICKET_AS_STAFF";
var PURCHASED_TICKET_AS_STAFF = "PURCHASED_TICKET_AS_STAFF";
var PURCHASE_TICKET_AS_STAFF_FAILURE = "PURCHASE_TICKET_AS_STAFF_FAILURE";
var CLEAR_EVENT_ERRORS = "CLEAR_EVENT_ERRORS";
//# sourceMappingURL=events.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket-guest-form.ts















var purchase_ticket_guest_form_PurchaseTicketGuestFormComponent = (function () {
    function PurchaseTicketGuestFormComponent(store, fb, completerService, uniqueEmailsAsyncValidation) {
        this.store = store;
        this.fb = fb;
        this.completerService = completerService;
        this.uniqueEmailsAsyncValidation = uniqueEmailsAsyncValidation;
        this.student = new contact_Contact();
        this.parent = new contact_Contact();
        this.creditCard = new CreditCard();
        this.hasFormBeenSubmitted = false;
        this.genders = GENDERS;
        this.schools = SCHOOLS;
        this.states = STATES;
        this.grades = GRADES;
        this.loading = false;
        this.terms = false;
    }
    PurchaseTicketGuestFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.schoolCompleter =
            this.completerService.local(this.schools, "title", "title");
        this.stateCompleter =
            this.completerService.local(this.states, "value", "title");
        this.gradeCompleter =
            this.completerService.local(this.grades, "value", "title");
        this.genderCompleter =
            this.completerService.local(this.genders, "value", "title");
        this.setupMainForm();
        this.store.dispatch({ type: CLEAR_EVENT_ERRORS });
        this.store.dispatch({ type: POPULATE_EDITABLE_CREDIT_CARD, payload: new CreditCard() });
        this.eventsSubscription = this.store.select("eventsReducer").subscribe(function (s) {
            _this.event = s.activeEvent;
            _this.errors = s.errors;
            _this.loading = s.loading;
        });
    };
    PurchaseTicketGuestFormComponent.prototype.setupMainForm = function () {
        this.student.phones.push(new Phone());
        this.parent.phones.push(new Phone());
        this.parent.addresses.push(new address_Address());
        this.mainForm = this.fb.group({
            studentFirstName: [this.student.firstName, [forms_es5["Validators"].required]],
            studentLastName: [this.student.lastName, [forms_es5["Validators"].required]],
            studentDob: [this.student.dob, [forms_es5["Validators"].required]],
            studentPhone: [this.student.phones[0].value, [forms_es5["Validators"].required]],
            studentEmail: [this.student.email, [forms_es5["Validators"].required], [this.uniqueEmailsAsyncValidation]],
            studentGender: [this.student.gender, [forms_es5["Validators"].required]],
            studentNewsletterSubscription: [true],
            grade: [this.student.grade, [forms_es5["Validators"].required]],
            parentFirstName: [this.parent.firstName, [forms_es5["Validators"].required]],
            parentLastName: [this.parent.lastName, [forms_es5["Validators"].required]],
            parentPhone: [this.parent.phones[0].value, [forms_es5["Validators"].required]],
            parentEmail: [this.parent.email, [forms_es5["Validators"].required], [this.uniqueEmailsAsyncValidation]],
            parentAddressLineOne: [this.parent.addresses[0].lineOne, [forms_es5["Validators"].required]],
            parentAddressLineTwo: [this.parent.addresses[0].lineTwo],
            parentAddressSuburb: [this.parent.addresses[0].suburb, [forms_es5["Validators"].required]],
            parentAddressState: [this.parent.addresses[0].state, [forms_es5["Validators"].required]],
            parentAddressPostcode: [this.parent.addresses[0].postcode, [forms_es5["Validators"].required]],
            creditCardHolder: [this.creditCard.holder, [forms_es5["Validators"].required]],
            creditCardCardNumber: [this.creditCard.cardNumber, [forms_es5["Validators"].required, forms_es5["Validators"].minLength(16), forms_es5["Validators"].maxLength(19)]],
            creditCardExpiryMonth: [this.creditCard.expiryMonth, [forms_es5["Validators"].required, forms_es5["Validators"].minLength(2), forms_es5["Validators"].maxLength(2)]],
            creditCardExpiryYear: [this.creditCard.expiryYear, [forms_es5["Validators"].required, forms_es5["Validators"].minLength(4), forms_es5["Validators"].maxLength(4)]],
            creditCardCvv: [this.creditCard.cvv, [forms_es5["Validators"].required, forms_es5["Validators"].minLength(3), forms_es5["Validators"].maxLength(4)]],
            terms: [this.terms, [forms_es5["Validators"].requiredTrue]],
        }, {
            validator: forms_es5["Validators"].compose([
                MatchingValidation.studentAndParentEmailsDifferent,
            ])
        });
    };
    PurchaseTicketGuestFormComponent.prototype.selectedSchool = function (e) {
        if (e && e.originalObject) {
            this.student.school = e.originalObject.value;
        }
    };
    PurchaseTicketGuestFormComponent.prototype.selectedGrade = function (e) {
        if (e && e.originalObject) {
            var value = e.originalObject.value;
            this.mainForm.controls['grade'].setValue(value);
        }
    };
    PurchaseTicketGuestFormComponent.prototype.selectedState = function (e) {
        if (e && e.originalObject) {
            var value = e.originalObject.value;
            this.mainForm.controls['parentAddressState'].setValue(value);
        }
    };
    PurchaseTicketGuestFormComponent.prototype.selectedGender = function (e) {
        if (e && e.originalObject) {
            var value = e.originalObject.value;
            this.mainForm.controls['studentGender'].setValue(value);
        }
    };
    PurchaseTicketGuestFormComponent.prototype.onSubmit = function (_a) {
        var value = _a.value, valid = _a.valid;
        this.hasFormBeenSubmitted = true;
        if (valid) {
            this.populateModelsFromForm(value);
        }
    };
    PurchaseTicketGuestFormComponent.prototype.populateModelsFromForm = function (value) {
        this.student.firstName = value.studentFirstName;
        this.student.lastName = value.studentLastName;
        this.student.dob = value.studentDob;
        this.student.gender = value.studentGender;
        this.student.phones[0].value = value.studentPhone;
        this.student.phones[0].label = 'Mobile';
        this.student.email = value.studentEmail;
        this.student.newsletterSubscription = value.studentNewsletterSubscription;
        this.student.grade = value.grade;
        this.parent.firstName = value.parentFirstName;
        this.parent.lastName = value.parentLastName;
        this.parent.dob = value.parentDob;
        this.parent.phones[0].value = value.parentPhone;
        this.parent.phones[0].label = 'Mobile';
        this.parent.email = value.parentEmail;
        this.parent.newsletterSubscription = value.studentNewsletterSubscription;
        this.parent.addresses[0].label = 'home';
        this.parent.addresses[0].lineOne = value.parentAddressLineOne;
        this.parent.addresses[0].lineTwo = value.parentAddressLineTwo;
        this.parent.addresses[0].suburb = value.parentAddressSuburb;
        this.parent.addresses[0].state = value.parentAddressState;
        this.parent.addresses[0].postcode = value.parentAddressPostcode;
        var taIds = this.event.ticketAllocations
            .filter(function (ta) { return ta.uiState.isPurchasing; })
            .map(function (ta) { return ta.id; });
        var payload = event_Event.createPurchaseTicketAsGuestPayload(this.student, this.parent, taIds, this.creditCard);
        this.store.dispatch({ type: CLEAR_EVENT_ERRORS });
        this.store.dispatch({ type: PURCHASE_TICKETS_AS_GUEST, payload: payload });
    };
    PurchaseTicketGuestFormComponent.prototype.getKeys = function (errors) { return Object.keys(errors); };
    PurchaseTicketGuestFormComponent.prototype.ngOnDestroy = function () {
        this.eventsSubscription.unsubscribe();
    };
    PurchaseTicketGuestFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: forms_es5["FormBuilder"] }, { type: ng2_completer["a" /* CompleterService */] }, { type: unique_email_async_UniqueEmailAsyncValidation }]; };
    return PurchaseTicketGuestFormComponent;
}());

//# sourceMappingURL=purchase-ticket-guest-form.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/src/$$_gendir/node_modules/ng2-completer/components/completer-cmp.ngfactory.ts + 1 modules
var completer_cmp_ngfactory = __webpack_require__("TgBZ");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/components/completer-cmp.js
var completer_cmp = __webpack_require__("AHvm");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/services/completer-service.js
var completer_service = __webpack_require__("2jA6");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/public/credit-card-form.ts
var CreditCardFormComponent = (function () {
    function CreditCardFormComponent() {
    }
    return CreditCardFormComponent;
}());

//# sourceMappingURL=credit-card-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/public/credit-card-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_CreditCardFormComponent = [];
var RenderType_CreditCardFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CreditCardFormComponent, data: {} });
function View_CreditCardFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a name']))], null, null);
}
function View_CreditCardFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a valid credit card number']))], null, null);
}
function View_CreditCardFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a valid month']))], null, null);
}
function View_CreditCardFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a valid year']))], null, null);
}
function View_CreditCardFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a valid CVV']))], null, null);
}
function View_CreditCardFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 86, 'div', [['class',
                'credit-card-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 85, 'div', [['class',
                'ccf__content-wrapper']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](2, 540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]), core_es5["ɵdid"](4, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](5, 0, null, null, 32, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 15, 'div', [['class', 'input-group cc-holder half']], null, null, null, null, null)),
        core_es5["ɵdid"](7, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](8, { 'error': 0 }), (_l()(), core_es5["ɵeld"](9, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 3, 'label', [['for', 'cc-holder']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Card holder'])),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 5, 'input', [['formControlName', 'creditCardHolder'], ['id', 'cc-holder'],
            ['name', 'cc-holder'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 15)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 15).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 15)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 15)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.creditCard.holder = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](15, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](17, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](19, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreditCardFormComponent_1)),
        core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](22, 0, null, null, 15, 'div', [['class', 'input-group cc-number half']], null, null, null, null, null)), core_es5["ɵdid"](23, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](24, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 3, 'label', [['for', 'cc-number']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Card number (no spaces or dashes, numbers only)'])),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵeld"](30, 0, null, null, 5, 'input', [['formControlName', 'creditCardCardNumber'], ['id',
                'cc-number'], ['name', 'cc-number'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.creditCard.cardNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](31, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](33, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](35, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreditCardFormComponent_2)),
        core_es5["ɵdid"](37, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](38, 0, null, null, 48, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 15, 'div', [['class', 'input-group cc-expiry-month']], null, null, null, null, null)), core_es5["ɵdid"](40, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](41, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](42, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](43, 0, null, null, 3, 'label', [['for', 'cc-expiry-month']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Expiry month (mm)'])), (_l()(), core_es5["ɵeld"](45, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵeld"](47, 0, null, null, 5, 'input', [['formControlName', 'creditCardExpiryMonth'], ['id', 'cc-expiry-month'],
            ['name', 'cc-expiry-month'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 48)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 48).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 48)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 48)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.creditCard.expiryMonth = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](48, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](50, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](52, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreditCardFormComponent_3)),
        core_es5["ɵdid"](54, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](55, 0, null, null, 15, 'div', [['class', 'input-group cc-expiry-year']], null, null, null, null, null)), core_es5["ɵdid"](56, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](57, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](58, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](59, 0, null, null, 3, 'label', [['for', 'cc-expiry-year']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Expiry year (yyyy)'])), (_l()(), core_es5["ɵeld"](61, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵeld"](63, 0, null, null, 5, 'input', [['formControlName', 'creditCardExpiryYear'], ['id', 'cc-expiry-year'],
            ['name', 'cc-expiry-year'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 64)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 64).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 64)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 64)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.creditCard.expiryYear = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](64, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](66, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](68, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreditCardFormComponent_4)),
        core_es5["ɵdid"](70, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](71, 0, null, null, 15, 'div', [['class', 'input-group cc-cvv']], null, null, null, null, null)), core_es5["ɵdid"](72, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](73, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](74, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](75, 0, null, null, 3, 'label', [['for', 'cc-cvv']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['CVV'])), (_l()(), core_es5["ɵeld"](77, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵeld"](79, 0, null, null, 5, 'input', [['formControlName',
                'creditCardCvv'], ['id', 'cc-cvv'], ['name', 'cc-cvv'], ['type', 'text']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 80)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 80).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 80)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 80)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.creditCard.cvv = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](80, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](82, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](84, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreditCardFormComponent_5)),
        core_es5["ɵdid"](86, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.mainForm;
        _ck(_v, 2, 0, currVal_7);
        var currVal_8 = 'input-group cc-holder half';
        var currVal_9 = _ck(_v, 8, 0, (_co.mainForm.get('creditCardHolder').invalid && _co.hasFormBeenSubmitted));
        _ck(_v, 7, 0, currVal_8, currVal_9);
        var currVal_17 = 'creditCardHolder';
        var currVal_18 = _co.creditCard.holder;
        _ck(_v, 17, 0, currVal_17, currVal_18);
        var currVal_19 = (_co.mainForm.get('creditCardHolder').invalid && _co.hasFormBeenSubmitted);
        _ck(_v, 21, 0, currVal_19);
        var currVal_20 = 'input-group cc-number half';
        var currVal_21 = _ck(_v, 24, 0, (_co.mainForm.get('creditCardCardNumber').invalid && _co.hasFormBeenSubmitted));
        _ck(_v, 23, 0, currVal_20, currVal_21);
        var currVal_29 = 'creditCardCardNumber';
        var currVal_30 = _co.creditCard.cardNumber;
        _ck(_v, 33, 0, currVal_29, currVal_30);
        var currVal_31 = (_co.mainForm.get('creditCardCardNumber').invalid && _co.hasFormBeenSubmitted);
        _ck(_v, 37, 0, currVal_31);
        var currVal_32 = 'input-group cc-expiry-month';
        var currVal_33 = _ck(_v, 41, 0, (_co.mainForm.get('creditCardExpiryMonth').invalid && _co.hasFormBeenSubmitted));
        _ck(_v, 40, 0, currVal_32, currVal_33);
        var currVal_41 = 'creditCardExpiryMonth';
        var currVal_42 = _co.creditCard.expiryMonth;
        _ck(_v, 50, 0, currVal_41, currVal_42);
        var currVal_43 = (_co.mainForm.get('creditCardExpiryMonth').invalid && _co.hasFormBeenSubmitted);
        _ck(_v, 54, 0, currVal_43);
        var currVal_44 = 'input-group cc-expiry-year';
        var currVal_45 = _ck(_v, 57, 0, (_co.mainForm.get('creditCardExpiryYear').invalid && _co.hasFormBeenSubmitted));
        _ck(_v, 56, 0, currVal_44, currVal_45);
        var currVal_53 = 'creditCardExpiryYear';
        var currVal_54 = _co.creditCard.expiryYear;
        _ck(_v, 66, 0, currVal_53, currVal_54);
        var currVal_55 = (_co.mainForm.get('creditCardExpiryYear').invalid && _co.hasFormBeenSubmitted);
        _ck(_v, 70, 0, currVal_55);
        var currVal_56 = 'input-group cc-cvv';
        var currVal_57 = _ck(_v, 73, 0, (_co.mainForm.get('creditCardCvv').invalid && _co.hasFormBeenSubmitted));
        _ck(_v, 72, 0, currVal_56, currVal_57);
        var currVal_65 = 'creditCardCvv';
        var currVal_66 = _co.creditCard.cvv;
        _ck(_v, 82, 0, currVal_65, currVal_66);
        var currVal_67 = (_co.mainForm.get('creditCardCvv').invalid && _co.hasFormBeenSubmitted);
        _ck(_v, 86, 0, currVal_67);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 4).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 4).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 4).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 4).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 4).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 4).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 4).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_10 = core_es5["ɵnov"](_v, 19).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 19).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 19).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 19).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 19).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 19).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 19).ngClassPending;
        _ck(_v, 14, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_22 = core_es5["ɵnov"](_v, 35).ngClassUntouched;
        var currVal_23 = core_es5["ɵnov"](_v, 35).ngClassTouched;
        var currVal_24 = core_es5["ɵnov"](_v, 35).ngClassPristine;
        var currVal_25 = core_es5["ɵnov"](_v, 35).ngClassDirty;
        var currVal_26 = core_es5["ɵnov"](_v, 35).ngClassValid;
        var currVal_27 = core_es5["ɵnov"](_v, 35).ngClassInvalid;
        var currVal_28 = core_es5["ɵnov"](_v, 35).ngClassPending;
        _ck(_v, 30, 0, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28);
        var currVal_34 = core_es5["ɵnov"](_v, 52).ngClassUntouched;
        var currVal_35 = core_es5["ɵnov"](_v, 52).ngClassTouched;
        var currVal_36 = core_es5["ɵnov"](_v, 52).ngClassPristine;
        var currVal_37 = core_es5["ɵnov"](_v, 52).ngClassDirty;
        var currVal_38 = core_es5["ɵnov"](_v, 52).ngClassValid;
        var currVal_39 = core_es5["ɵnov"](_v, 52).ngClassInvalid;
        var currVal_40 = core_es5["ɵnov"](_v, 52).ngClassPending;
        _ck(_v, 47, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
        var currVal_46 = core_es5["ɵnov"](_v, 68).ngClassUntouched;
        var currVal_47 = core_es5["ɵnov"](_v, 68).ngClassTouched;
        var currVal_48 = core_es5["ɵnov"](_v, 68).ngClassPristine;
        var currVal_49 = core_es5["ɵnov"](_v, 68).ngClassDirty;
        var currVal_50 = core_es5["ɵnov"](_v, 68).ngClassValid;
        var currVal_51 = core_es5["ɵnov"](_v, 68).ngClassInvalid;
        var currVal_52 = core_es5["ɵnov"](_v, 68).ngClassPending;
        _ck(_v, 63, 0, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52);
        var currVal_58 = core_es5["ɵnov"](_v, 84).ngClassUntouched;
        var currVal_59 = core_es5["ɵnov"](_v, 84).ngClassTouched;
        var currVal_60 = core_es5["ɵnov"](_v, 84).ngClassPristine;
        var currVal_61 = core_es5["ɵnov"](_v, 84).ngClassDirty;
        var currVal_62 = core_es5["ɵnov"](_v, 84).ngClassValid;
        var currVal_63 = core_es5["ɵnov"](_v, 84).ngClassInvalid;
        var currVal_64 = core_es5["ɵnov"](_v, 84).ngClassPending;
        _ck(_v, 79, 0, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64);
    });
}
function View_CreditCardFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'credit-card-form', [], null, null, null, View_CreditCardFormComponent_0, RenderType_CreditCardFormComponent)), core_es5["ɵdid"](1, 49152, null, 0, CreditCardFormComponent, [], null, null)], null, null);
}
var CreditCardFormComponentNgFactory = core_es5["ɵccf"]('credit-card-form', CreditCardFormComponent, View_CreditCardFormComponent_Host_0, { creditCard: 'creditCard',
    hasFormBeenSubmitted: 'hasFormBeenSubmitted', mainForm: 'mainForm' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9wdWJsaWMvY3JlZGl0LWNhcmQtZm9ybS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvcHVibGljL2NyZWRpdC1jYXJkLWZvcm0udHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvcHVibGljL2NyZWRpdC1jYXJkLWZvcm0ucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL3B1YmxpYy9jcmVkaXQtY2FyZC1mb3JtLnRzLkNyZWRpdENhcmRGb3JtQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNyZWRpdC1jYXJkLWZvcm1cIj48ZGl2IGNsYXNzPVwiY2NmX19jb250ZW50LXdyYXBwZXJcIiBbZm9ybUdyb3VwXT1cIm1haW5Gb3JtXCI+PGRpdiBjbGFzcz1cImlucHV0LXJvd1wiPjxkaXYgY2xhc3M9XCJpbnB1dC1ncm91cCBjYy1ob2xkZXIgaGFsZlwiIFtuZ0NsYXNzXT1cInsgJ2Vycm9yJzogbWFpbkZvcm0uZ2V0KCdjcmVkaXRDYXJkSG9sZGVyJykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkIH1cIj48ZGl2IGNsYXNzPVwiaWdfX2NvbnRlbnQtd3JhcHBlclwiPjxsYWJlbCBmb3I9XCJjYy1ob2xkZXJcIj5DYXJkIGhvbGRlcjxzcGFuIGNsYXNzPVwicmVxdWlyZWRcIj4qPC9zcGFuPjwvbGFiZWw+PGlucHV0IGlkPVwiY2MtaG9sZGVyXCIgdHlwZT1cInRleHRcIiBbKG5nTW9kZWwpXT1cImNyZWRpdENhcmQuaG9sZGVyXCIgbmFtZT1cImNjLWhvbGRlclwiIGZvcm1Db250cm9sTmFtZT1cImNyZWRpdENhcmRIb2xkZXJcIj48c3BhbiBjbGFzcz1cImlnX19lcnJvclwiICpuZ0lmPVwibWFpbkZvcm0uZ2V0KCdjcmVkaXRDYXJkSG9sZGVyJykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkXCI+UGxlYXNlIGVudGVyIGEgbmFtZTwvc3Bhbj48L2Rpdj48L2Rpdj48ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXAgY2MtbnVtYmVyIGhhbGZcIiBbbmdDbGFzc109XCJ7ICdlcnJvcic6IG1haW5Gb3JtLmdldCgnY3JlZGl0Q2FyZENhcmROdW1iZXInKS5pbnZhbGlkICZhbXA7JmFtcDsgaGFzRm9ybUJlZW5TdWJtaXR0ZWQgfVwiPjxkaXYgY2xhc3M9XCJpZ19fY29udGVudC13cmFwcGVyXCI+PGxhYmVsIGZvcj1cImNjLW51bWJlclwiPkNhcmQgbnVtYmVyIChubyBzcGFjZXMgb3IgZGFzaGVzLCBudW1iZXJzIG9ubHkpPHNwYW4gY2xhc3M9XCJyZXF1aXJlZFwiPio8L3NwYW4+PC9sYWJlbD48aW5wdXQgaWQ9XCJjYy1udW1iZXJcIiB0eXBlPVwidGV4dFwiIFsobmdNb2RlbCldPVwiY3JlZGl0Q2FyZC5jYXJkTnVtYmVyXCIgbmFtZT1cImNjLW51bWJlclwiIGZvcm1Db250cm9sTmFtZT1cImNyZWRpdENhcmRDYXJkTnVtYmVyXCI+PHNwYW4gY2xhc3M9XCJpZ19fZXJyb3JcIiAqbmdJZj1cIm1haW5Gb3JtLmdldCgnY3JlZGl0Q2FyZENhcmROdW1iZXInKS5pbnZhbGlkICZhbXA7JmFtcDsgaGFzRm9ybUJlZW5TdWJtaXR0ZWRcIj5QbGVhc2UgZW50ZXIgYSB2YWxpZCBjcmVkaXQgY2FyZCBudW1iZXI8L3NwYW4+PC9kaXY+PC9kaXY+PC9kaXY+PGRpdiBjbGFzcz1cImlucHV0LXJvd1wiPjxkaXYgY2xhc3M9XCJpbnB1dC1ncm91cCBjYy1leHBpcnktbW9udGhcIiBbbmdDbGFzc109XCJ7ICdlcnJvcic6IG1haW5Gb3JtLmdldCgnY3JlZGl0Q2FyZEV4cGlyeU1vbnRoJykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkIH1cIj48ZGl2IGNsYXNzPVwiaWdfX2NvbnRlbnQtd3JhcHBlclwiPjxsYWJlbCBmb3I9XCJjYy1leHBpcnktbW9udGhcIj5FeHBpcnkgbW9udGggKG1tKTxzcGFuIGNsYXNzPVwicmVxdWlyZWRcIj4qPC9zcGFuPjwvbGFiZWw+PGlucHV0IGlkPVwiY2MtZXhwaXJ5LW1vbnRoXCIgdHlwZT1cInRleHRcIiBbKG5nTW9kZWwpXT1cImNyZWRpdENhcmQuZXhwaXJ5TW9udGhcIiBuYW1lPVwiY2MtZXhwaXJ5LW1vbnRoXCIgZm9ybUNvbnRyb2xOYW1lPVwiY3JlZGl0Q2FyZEV4cGlyeU1vbnRoXCI+PHNwYW4gY2xhc3M9XCJpZ19fZXJyb3JcIiAqbmdJZj1cIm1haW5Gb3JtLmdldCgnY3JlZGl0Q2FyZEV4cGlyeU1vbnRoJykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkXCI+UGxlYXNlIGVudGVyIGEgdmFsaWQgbW9udGg8L3NwYW4+PC9kaXY+PC9kaXY+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwIGNjLWV4cGlyeS15ZWFyXCIgW25nQ2xhc3NdPVwieyAnZXJyb3InOiBtYWluRm9ybS5nZXQoJ2NyZWRpdENhcmRFeHBpcnlZZWFyJykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkIH1cIj48ZGl2IGNsYXNzPVwiaWdfX2NvbnRlbnQtd3JhcHBlclwiPjxsYWJlbCBmb3I9XCJjYy1leHBpcnkteWVhclwiPkV4cGlyeSB5ZWFyICh5eXl5KTxzcGFuIGNsYXNzPVwicmVxdWlyZWRcIj4qPC9zcGFuPjwvbGFiZWw+PGlucHV0IGlkPVwiY2MtZXhwaXJ5LXllYXJcIiB0eXBlPVwidGV4dFwiIFsobmdNb2RlbCldPVwiY3JlZGl0Q2FyZC5leHBpcnlZZWFyXCIgbmFtZT1cImNjLWV4cGlyeS15ZWFyXCIgZm9ybUNvbnRyb2xOYW1lPVwiY3JlZGl0Q2FyZEV4cGlyeVllYXJcIj48c3BhbiBjbGFzcz1cImlnX19lcnJvclwiICpuZ0lmPVwibWFpbkZvcm0uZ2V0KCdjcmVkaXRDYXJkRXhwaXJ5WWVhcicpLmludmFsaWQgJmFtcDsmYW1wOyBoYXNGb3JtQmVlblN1Ym1pdHRlZFwiPlBsZWFzZSBlbnRlciBhIHZhbGlkIHllYXI8L3NwYW4+PC9kaXY+PC9kaXY+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwIGNjLWN2dlwiIFtuZ0NsYXNzXT1cInsgJ2Vycm9yJzogbWFpbkZvcm0uZ2V0KCdjcmVkaXRDYXJkQ3Z2JykuaW52YWxpZCAmYW1wOyZhbXA7IGhhc0Zvcm1CZWVuU3VibWl0dGVkIH1cIj48ZGl2IGNsYXNzPVwiaWdfX2NvbnRlbnQtd3JhcHBlclwiPjxsYWJlbCBmb3I9XCJjYy1jdnZcIj5DVlY8c3BhbiBjbGFzcz1cInJlcXVpcmVkXCI+Kjwvc3Bhbj48L2xhYmVsPjxpbnB1dCBpZD1cImNjLWN2dlwiIHR5cGU9XCJ0ZXh0XCIgWyhuZ01vZGVsKV09XCJjcmVkaXRDYXJkLmN2dlwiIG5hbWU9XCJjYy1jdnZcIiBmb3JtQ29udHJvbE5hbWU9XCJjcmVkaXRDYXJkQ3Z2XCI+PHNwYW4gY2xhc3M9XCJpZ19fZXJyb3JcIiAqbmdJZj1cIm1haW5Gb3JtLmdldCgnY3JlZGl0Q2FyZEN2dicpLmludmFsaWQgJmFtcDsmYW1wOyBoYXNGb3JtQmVlblN1Ym1pdHRlZFwiPlBsZWFzZSBlbnRlciBhIHZhbGlkIENWVjwvc3Bhbj48L2Rpdj48L2Rpdj48L2Rpdj48L2Rpdj48L2Rpdj4iLCI8Y3JlZGl0LWNhcmQtZm9ybT48L2NyZWRpdC1jYXJkLWZvcm0+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNBd2Q7TUFBQTtNQUF5Rzs7O29CQUFnYztNQUFBO01BQTZHOzs7O29CQUF5ZTtNQUFBO01BQThHOzs7O29CQUF5YjtNQUFBO01BQTZHOzs7O29CQUFvWDtNQUFBO01BQXNHOzs7O29CQUFyc0Y7TUFBQTtNQUFBLGdCQUE4QjtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7RUFBQSx1Q0FBQTtNQUFBLDhFQUFBO01BQUEsZ0ZBQUE7TUFBQTtNQUFBLGVBQXlEO01BQUE7TUFBdUI7VUFBQTthQUFBO21DQUFBO2FBQXdDLGdCQUFrRztVQUFBO1VBQUEsOEJBQWlDO1VBQUE7VUFBQSw4QkFBdUI7TUFBVztVQUFBO01BQXVCLHlDQUFnQjtVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFrQztjQUFBO2NBQUE7WUFBQTtZQUFsQztVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtRQUFBO01BQUEsb0NBQUE7VUFBQTtVQUFBLHFFQUFBO1VBQUEsc0VBQUE7VUFBQTtNQUFzSDthQUFBO1VBQUEsaUNBQStJO1VBQUE7VUFBQSxtREFBQTtVQUFBO1VBQUEsZ0VBQXdDO01BQXNHO1VBQUE7TUFBaUM7VUFBQTtNQUF1QjtNQUErQztVQUFBO01BQXVCLHlDQUFnQjtVQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFrQztjQUFBO2NBQUE7WUFBQTtZQUFsQztVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtRQUFBO01BQUEsb0NBQUE7VUFBQTtVQUFBLHFFQUFBO1VBQUEsc0VBQUE7VUFBQTtNQUE4SDthQUFBO1VBQUEsaUNBQTZLO1VBQUE7VUFBQSw4QkFBdUI7VUFBQTtVQUFBLG1EQUFBO1VBQUE7VUFBQSxnRUFBeUM7TUFBdUc7VUFBQTtNQUFpQztVQUFBO01BQTZCLHlEQUFpQjtVQUFBO1VBQUEsMERBQXVCO1VBQUEsc0JBQWdCO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXdDO2NBQUE7Y0FBQTtZQUFBO1lBQXhDO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEscUVBQUE7VUFBQSxzRUFBQTtVQUFBO01BQTRJO2FBQUE7VUFBQSxpQ0FBMko7VUFBQTtVQUFBLG1EQUFBO1VBQUE7VUFBQSxnRUFBd0M7TUFBc0c7VUFBQTtNQUFpQztVQUFBO01BQTRCLDBEQUFrQjtVQUFBO1VBQUEsMERBQXVCO1VBQUEsc0JBQWdCO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXVDO2NBQUE7Y0FBQTtZQUFBO1lBQXZDO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEscUVBQUE7VUFBQSxzRUFBQTtVQUFBO01BQXdJO2FBQUE7VUFBQSxpQ0FBeUo7VUFBQTtVQUFBLHFDQUFBO1VBQUE7Y0FBQSxzREFBZ0M7TUFBK0Y7VUFBQTtNQUFpQztVQUFBO01BQW9CLDJDQUFHO1VBQUE7VUFBQSw0Q0FBdUI7VUFBQSxRQUFnQjtVQUFBO1VBQUE7VUFBQTtVQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUErQjtVQUFBO1VBQUE7UUFBQTtRQUEvQjtNQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtRQUFBO01BQUEsb0NBQUE7VUFBQTtVQUFBLHFFQUFBO1VBQUEsc0VBQUE7VUFBQTtNQUEwRzthQUFBO1VBQUE7O0lBQS9oRjtJQUFsQyxXQUFrQyxTQUFsQztJQUFxRjtJQUFtQztJQUF4QyxXQUFLLFVBQW1DLFNBQXhDO0lBQXVVO0lBQWpEO0lBQWxDLFlBQW1GLFdBQWpELFVBQWxDO0lBQThJO0lBQXhCLFlBQXdCLFVBQXhCO0lBQW9KO0lBQW1DO0lBQXhDLFlBQUssV0FBbUMsVUFBeEM7SUFBbVg7SUFBckQ7SUFBbEMsWUFBdUYsV0FBckQsVUFBbEM7SUFBc0o7SUFBeEIsWUFBd0IsVUFBeEI7SUFBeU07SUFBb0M7SUFBekMsWUFBSyxXQUFvQyxVQUF6QztJQUEwVztJQUE1RDtJQUF4QyxZQUFvRyxXQUE1RCxVQUF4QztJQUFvSztJQUF4QixZQUF3QixVQUF4QjtJQUFnSztJQUFtQztJQUF4QyxZQUFLLFdBQW1DLFVBQXhDO0lBQXFXO0lBQTFEO0lBQXZDLFlBQWlHLFdBQTFELFVBQXZDO0lBQWdLO0lBQXhCLFlBQXdCLFVBQXhCO0lBQThKO0lBQTJCO0lBQWhDLFlBQUssV0FBMkIsVUFBaEM7SUFBd1M7SUFBM0M7SUFBL0IsWUFBMEUsV0FBM0MsVUFBL0I7SUFBa0k7SUFBeEIsWUFBd0IsVUFBeEI7O0lBQWprRjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEscUVBQUE7SUFBb1U7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsVUFBQTtJQUFpaUI7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsVUFBQTtJQUF3a0I7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsVUFBQTtJQUEyaUI7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsVUFBQTtJQUErZjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUE7UUFBQSxVQUFBOzs7O29CQ0FyL0U7TUFBQTt3Q0FBQSxVQUFBO01BQUE7Ozs7In0=
//# sourceMappingURL=credit-card-form.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/src/store.js + 5 modules
var src_store = __webpack_require__("QI4+");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/public/purchase-ticket-guest-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_PurchaseTicketGuestFormComponent = [];
var RenderType_PurchaseTicketGuestFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PurchaseTicketGuestFormComponent, data: {} });
function View_PurchaseTicketGuestFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptgf__form-error student-email-taken']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This student\'s email is already taken. Please try signing in with that email.']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptgf__form-error parent-email-taken']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This parent\'s email is already taken']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.parent.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.errors[_v.parent.context.$implicit][_v.context.$implicit];
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_PurchaseTicketGuestFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'dl', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_5)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors[_v.context.$implicit]);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_PurchaseTicketGuestFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'ptgf__server-errors']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'inverted']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Errors occured while submitting your application form'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_4)),
        core_es5["ɵdid"](4, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](5, 0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Please try again and if the problem persists please get in contact with our friendly Customer Service team at'])),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'a', [['href', 'mailto:info@matrix.edu.au']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['info@matrix.edu.au '])), (_l()(), core_es5["ɵted"](-1, null, ['or call us on 1300 008 008.']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors);
        _ck(_v, 4, 0, currVal_0);
    }, null);
}
function View_PurchaseTicketGuestFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a first name']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a last name']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a date of birth']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a mobile phone number']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter an email']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter student gender']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a school grade']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a first name']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a last name']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a mobile phone number']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter an email']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Email can\'t be same as student']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter an address']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a suburb']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a state']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a postcode']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please agree to the terms and conditions']))], null, null);
}
function View_PurchaseTicketGuestFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 330, 'div', [['class',
                'purchase-ticket-guest-form']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'purchase-ticket-guest-form--loading': 0 }),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 327, 'div', [['class', 'ptgf__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 326, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.onSubmit(_co.mainForm) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](6, 540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]),
        core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_1)), core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_2)), core_es5["ɵdid"](12, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_3)),
        core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](15, 0, null, null, 127, 'div', [['class', 'ptgf__form student']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'h3', [['class', 'borderless']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student details'])),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 32, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 15, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)),
        core_es5["ɵdid"](20, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](21, { 'error': 0 }), (_l()(), core_es5["ɵeld"](22, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](23, 0, null, null, 5, 'input', [['formControlName', 'studentFirstName'], ['id', 'student-first-name'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](24, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](26, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](28, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](29, 0, null, null, 3, 'label', [['for', 'student-first-name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](31, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_6)),
        core_es5["ɵdid"](34, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](35, 0, null, null, 15, 'div', [['class', 'input-group last-name half']], null, null, null, null, null)), core_es5["ɵdid"](36, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](37, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](38, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 5, 'input', [['formControlName',
                'studentLastName'], ['id', 'student-last-name'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 40)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 40)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 40)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](40, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](42, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](44, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](45, 0, null, null, 3, 'label', [['for', 'student-last-name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](47, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_7)),
        core_es5["ɵdid"](50, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](51, 0, null, null, 32, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](52, 0, null, null, 15, 'div', [['class', 'input-group dob half']], null, null, null, null, null)), core_es5["ɵdid"](53, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](54, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](55, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](56, 0, null, null, 5, 'input', [['formControlName',
                'studentDob'], ['id', 'student-dob'], ['type', 'date']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 57)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 57).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 57)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 57)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](57, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](59, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](61, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](62, 0, null, null, 3, 'label', [['for', 'student-dob']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Date of birth'])), (_l()(), core_es5["ɵeld"](64, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_8)),
        core_es5["ɵdid"](67, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](68, 0, null, null, 15, 'div', [['class', 'input-group phone half']], null, null, null, null, null)), core_es5["ɵdid"](69, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](70, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](71, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](72, 0, null, null, 5, 'input', [['formControlName',
                'studentPhone'], ['id', 'student-phone'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 73)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 73).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 73)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 73)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](73, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](75, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](77, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](78, 0, null, null, 3, 'label', [['for', 'student-phone']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Mobile Phone'])), (_l()(), core_es5["ɵeld"](80, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_9)),
        core_es5["ɵdid"](83, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](84, 0, null, null, 31, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](85, 0, null, null, 15, 'div', [['class', 'input-group email half']], null, null, null, null, null)), core_es5["ɵdid"](86, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](87, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](88, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](89, 0, null, null, 5, 'input', [['formControlName',
                'studentEmail'], ['id', 'student-email'], ['type', 'email']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 90)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 90).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 90)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 90)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](90, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](92, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](94, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](95, 0, null, null, 3, 'label', [['for', 'student-email']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student email'])), (_l()(), core_es5["ɵeld"](97, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_10)),
        core_es5["ɵdid"](100, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](101, 0, null, null, 14, 'div', [['class', 'input-group gender half']], null, null, null, null, null)), core_es5["ɵdid"](102, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](103, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](104, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](105, 0, null, null, 6, 'ng2-completer', [['id', 'studentGender']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.genderSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGender($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](106, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](108, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0,
                'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](109, { standalone: 0 }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](111, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](112, 0, null, null, 1, 'label', [['for', 'studentGender']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Student gender'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_11)),
        core_es5["ɵdid"](115, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](116, 0, null, null, 26, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](117, 0, null, null, 10, 'div', [['class', 'input-group school half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](118, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](119, 0, null, null, 1, 'label', [['for', 'school']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Current school'])),
        (_l()(), core_es5["ɵeld"](121, 0, null, null, 6, 'ng2-completer', [['id', 'school']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.schoolSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedSchool($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](122, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](124, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0,
                'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](125, { standalone: 0 }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](127, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](128, 0, null, null, 14, 'div', [['class', 'input-group grade half']], null, null, null, null, null)),
        core_es5["ɵdid"](129, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](130, { 'error': 0 }), (_l()(), core_es5["ɵeld"](131, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](132, 0, null, null, 6, 'ng2-completer', [['id', 'grade']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.gradeSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGrade($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](133, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](135, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0,
                'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](136, { standalone: 0 }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](138, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](139, 0, null, null, 1, 'label', [['for', 'grade']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Current grade'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_12)),
        core_es5["ɵdid"](142, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](143, 0, null, null, 141, 'div', [['class', 'ptgf__form parent']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](144, 0, null, null, 1, 'h3', [['class', 'borderless']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Parent details'])),
        (_l()(), core_es5["ɵeld"](146, 0, null, null, 32, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](147, 0, null, null, 15, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)),
        core_es5["ɵdid"](148, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](149, { 'error': 0 }), (_l()(), core_es5["ɵeld"](150, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](151, 0, null, null, 5, 'input', [['formControlName', 'parentFirstName'], ['id', 'parent-first-name'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 152)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 152).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 152)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 152)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](152, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](154, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](156, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](157, 0, null, null, 3, 'label', [['for', 'parent-first-name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](159, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_13)),
        core_es5["ɵdid"](162, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](163, 0, null, null, 15, 'div', [['class', 'input-group last-name half']], null, null, null, null, null)), core_es5["ɵdid"](164, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](165, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](166, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](167, 0, null, null, 5, 'input', [['formControlName',
                'parentLastName'], ['id', 'parent-last-name'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 168)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 168).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 168)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 168)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](168, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](170, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](172, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](173, 0, null, null, 3, 'label', [['for', 'parent-last-name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](175, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_14)),
        core_es5["ɵdid"](178, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](179, 0, null, null, 34, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](180, 0, null, null, 15, 'div', [['class', 'input-group phone half']], null, null, null, null, null)), core_es5["ɵdid"](181, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](182, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](183, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](184, 0, null, null, 5, 'input', [['formControlName',
                'parentPhone'], ['id', 'parent-phone'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 185)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 185).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 185)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 185)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](185, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](187, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](189, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](190, 0, null, null, 3, 'label', [['for', 'parent-phone']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Mobile Phone'])), (_l()(), core_es5["ɵeld"](192, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_15)),
        core_es5["ɵdid"](195, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](196, 0, null, null, 17, 'div', [['class', 'input-group email half']], null, null, null, null, null)), core_es5["ɵdid"](197, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](198, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](199, 0, null, null, 14, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](200, 0, null, null, 5, 'input', [['formControlName',
                'parentEmail'], ['id', 'parent-email'], ['type', 'email']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 201)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 201).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 201)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 201)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](201, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](203, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](205, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](206, 0, null, null, 3, 'label', [['for', 'parent-email']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Parent email'])), (_l()(), core_es5["ɵeld"](208, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_16)),
        core_es5["ɵdid"](211, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_17)),
        core_es5["ɵdid"](213, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](214, 0, null, null, 24, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](215, 0, null, null, 13, 'div', [['class', 'input-group line-one half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](216, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](217, 0, null, null, 5, 'input', [['formControlName', 'parentAddressLineOne'], ['id',
                'line-one'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 218)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 218).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 218)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 218)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](218, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](220, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](222, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](223, 0, null, null, 3, 'label', [['for', 'line-one']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Address one'])), (_l()(), core_es5["ɵeld"](225, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_18)),
        core_es5["ɵdid"](228, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](229, 0, null, null, 9, 'div', [['class', 'input-group line-two half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](230, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](231, 0, null, null, 5, 'input', [['formControlName', 'parentAddressLineTwo'], ['id',
                'line-two'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 232)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 232).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 232)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 232)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](232, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](234, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](236, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](237, 0, null, null, 1, 'label', [['for', 'line-two']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Address two'])), (_l()(), core_es5["ɵeld"](239, 0, null, null, 45, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](240, 0, null, null, 13, 'div', [['class', 'input-group line-one one-third']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](241, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](242, 0, null, null, 5, 'input', [['formControlName', 'parentAddressSuburb'], ['id',
                'suburb'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 243)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 243).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 243)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 243)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](243, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](245, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](247, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](248, 0, null, null, 3, 'label', [['for', 'suburb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Suburb'])),
        (_l()(), core_es5["ɵeld"](250, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_19)),
        core_es5["ɵdid"](253, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](254, 0, null, null, 16, 'div', [['class', 'input-group line-one one-third']], null, null, null, null, null)), core_es5["ɵdid"](255, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](256, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](257, 0, null, null, 13, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](258, 0, null, null, 6, 'ng2-completer', [['id', 'state']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.stateSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedState($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](259, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](261, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0,
                'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](262, { standalone: 0 }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](264, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](265, 0, null, null, 3, 'label', [['for', 'state']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['State'])), (_l()(), core_es5["ɵeld"](267, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_20)), core_es5["ɵdid"](270, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](271, 0, null, null, 13, 'div', [['class', 'input-group line-one one-third']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](272, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](273, 0, null, null, 5, 'input', [['formControlName',
                'parentAddressPostcode'], ['id', 'postcode'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 274)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 274).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 274)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 274)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](274, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](276, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](278, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](279, 0, null, null, 3, 'label', [['for', 'postcode']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Postcode'])), (_l()(), core_es5["ɵeld"](281, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_21)),
        core_es5["ɵdid"](284, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](285, 0, null, null, 4, 'div', [['class', 'ptgf__form payment-method']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](286, 0, null, null, 1, 'h3', [['class', 'borderless']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Payment Details'])), (_l()(), core_es5["ɵeld"](288, 0, null, null, 1, 'credit-card-form', [], null, null, null, View_CreditCardFormComponent_0, RenderType_CreditCardFormComponent)),
        core_es5["ɵdid"](289, 49152, null, 0, CreditCardFormComponent, [], { creditCard: [0,
                'creditCard'], hasFormBeenSubmitted: [1, 'hasFormBeenSubmitted'], mainForm: [2,
                'mainForm'] }, null), (_l()(), core_es5["ɵeld"](290, 0, null, null, 19, 'div', [['class', 'input-group checkbox-square standalone'], ['style', 'max-width:100%;margin-bottom:1rem']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](291, 0, null, null, 18, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](292, 0, null, null, 5, 'input', [['formControlName',
                'terms'], ['id', 'terms'], ['type', 'checkbox']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'change'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 293).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 293).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](293, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](295, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](297, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](298, 0, null, null, 0, 'label', [['for', 'terms'],
            ['style', 'right:inherit']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](299, 0, null, null, 8, 'div', [['style', 'padding-left:2.5rem;padding-top:0.3rem']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['I agree to Matrix\'s '])), (_l()(), core_es5["ɵeld"](301, 0, null, null, 1, 'a', [['href', 'https://www.matrix.edu.au/legal/online-course-service-terms-and-conditions/'],
            ['rel', 'noopener'], ['target', '_blank']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Terms and Conditions'])), (_l()(), core_es5["ɵted"](-1, null, [' and '])),
        (_l()(), core_es5["ɵeld"](304, 0, null, null, 1, 'a', [['href', 'https://www.matrix.edu.au/legal/privacy-policy/'],
            ['rel', 'noopener'], ['target', '_blank']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Privacy Policy.'])),
        (_l()(), core_es5["ɵeld"](306, 0, null, null, 1, 'span', [['class', 'required']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['*'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketGuestFormComponent_22)),
        core_es5["ɵdid"](309, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](310, 0, null, null, 10, 'div', [['class', 'input-group checkbox-square standalone'], ['style', 'max-width:100%;margin-bottom:1rem']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](311, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](312, 0, null, null, 5, 'input', [['formControlName',
                'studentNewsletterSubscription'], ['id', 'student-newsletter-subscription'],
            ['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 313).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 313).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](313, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](315, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](317, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](318, 0, null, null, 0, 'label', [['for', 'student-newsletter-subscription'],
            ['style', 'right:inherit']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](319, 0, null, null, 1, 'div', [['style', 'padding-left:2.5rem;padding-top:0.3rem']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Send me emails with special offers, study advice and free event invites.'])),
        (_l()(), core_es5["ɵeld"](321, 0, null, null, 9, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](322, 0, null, null, 8, 'div', [['class', 'input-row justify-content-between align-items-center']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](323, 0, null, null, 2, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](324, 0, null, null, 1, 'small', [['class', 'required small']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['* Required field'])), (_l()(), core_es5["ɵeld"](326, 0, null, null, 4, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](327, 0, null, null, 3, 'button', [['class', 'ptgf__btn-submit']], [[8, 'disabled', 0]], null, null, null, null)),
        core_es5["ɵdid"](328, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](329, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](330, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'purchase-ticket-guest-form';
        var currVal_1 = _ck(_v, 2, 0, _co.loading);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_9 = _co.mainForm;
        _ck(_v, 6, 0, currVal_9);
        var currVal_10 = _co.mainForm.get('studentEmail').hasError('emailTaken');
        _ck(_v, 10, 0, currVal_10);
        var currVal_11 = _co.mainForm.get('parentEmail').hasError('emailTaken');
        _ck(_v, 12, 0, currVal_11);
        var currVal_12 = _co.errors;
        _ck(_v, 14, 0, currVal_12);
        var currVal_13 = 'input-group first-name half';
        var currVal_14 = _ck(_v, 21, 0, (_co.mainForm.get('studentFirstName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 20, 0, currVal_13, currVal_14);
        var currVal_22 = 'studentFirstName';
        _ck(_v, 26, 0, currVal_22);
        var currVal_23 = (_co.mainForm.get('studentFirstName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 34, 0, currVal_23);
        var currVal_24 = 'input-group last-name half';
        var currVal_25 = _ck(_v, 37, 0, (_co.mainForm.get('studentLastName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 36, 0, currVal_24, currVal_25);
        var currVal_33 = 'studentLastName';
        _ck(_v, 42, 0, currVal_33);
        var currVal_34 = (_co.mainForm.get('studentLastName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 50, 0, currVal_34);
        var currVal_35 = 'input-group dob half';
        var currVal_36 = _ck(_v, 54, 0, (_co.mainForm.get('studentDob').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 53, 0, currVal_35, currVal_36);
        var currVal_44 = 'studentDob';
        _ck(_v, 59, 0, currVal_44);
        var currVal_45 = (_co.mainForm.get('studentDob').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 67, 0, currVal_45);
        var currVal_46 = 'input-group phone half';
        var currVal_47 = _ck(_v, 70, 0, (_co.mainForm.get('studentPhone').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 69, 0, currVal_46, currVal_47);
        var currVal_55 = 'studentPhone';
        _ck(_v, 75, 0, currVal_55);
        var currVal_56 = (_co.mainForm.get('studentPhone').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 83, 0, currVal_56);
        var currVal_57 = 'input-group email half';
        var currVal_58 = _ck(_v, 87, 0, (_co.mainForm.get('studentEmail').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 86, 0, currVal_57, currVal_58);
        var currVal_66 = 'studentEmail';
        _ck(_v, 92, 0, currVal_66);
        var currVal_67 = (_co.mainForm.get('studentEmail').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 100, 0, currVal_67);
        var currVal_68 = 'input-group gender half';
        var currVal_69 = _ck(_v, 103, 0, (_co.mainForm.get('studentGender').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 102, 0, currVal_68, currVal_69);
        var currVal_77 = 0;
        var currVal_78 = true;
        var currVal_79 = _co.genderCompleter;
        _ck(_v, 106, 0, currVal_77, currVal_78, currVal_79);
        var currVal_80 = _co.genderSearchStr;
        var currVal_81 = _ck(_v, 109, 0, true);
        _ck(_v, 108, 0, currVal_80, currVal_81);
        var currVal_82 = (_co.mainForm.get('studentGender').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 115, 0, currVal_82);
        var currVal_90 = 0;
        var currVal_91 = true;
        var currVal_92 = _co.schoolCompleter;
        _ck(_v, 122, 0, currVal_90, currVal_91, currVal_92);
        var currVal_93 = _co.schoolSearchStr;
        var currVal_94 = _ck(_v, 125, 0, true);
        _ck(_v, 124, 0, currVal_93, currVal_94);
        var currVal_95 = 'input-group grade half';
        var currVal_96 = _ck(_v, 130, 0, (_co.mainForm.get('grade').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 129, 0, currVal_95, currVal_96);
        var currVal_104 = 0;
        var currVal_105 = true;
        var currVal_106 = _co.gradeCompleter;
        _ck(_v, 133, 0, currVal_104, currVal_105, currVal_106);
        var currVal_107 = _co.gradeSearchStr;
        var currVal_108 = _ck(_v, 136, 0, true);
        _ck(_v, 135, 0, currVal_107, currVal_108);
        var currVal_109 = (_co.mainForm.get('grade').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 142, 0, currVal_109);
        var currVal_110 = 'input-group first-name half';
        var currVal_111 = _ck(_v, 149, 0, (_co.mainForm.get('parentFirstName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 148, 0, currVal_110, currVal_111);
        var currVal_119 = 'parentFirstName';
        _ck(_v, 154, 0, currVal_119);
        var currVal_120 = (_co.mainForm.get('parentFirstName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 162, 0, currVal_120);
        var currVal_121 = 'input-group last-name half';
        var currVal_122 = _ck(_v, 165, 0, (_co.mainForm.get('parentLastName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 164, 0, currVal_121, currVal_122);
        var currVal_130 = 'parentLastName';
        _ck(_v, 170, 0, currVal_130);
        var currVal_131 = (_co.mainForm.get('parentLastName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 178, 0, currVal_131);
        var currVal_132 = 'input-group phone half';
        var currVal_133 = _ck(_v, 182, 0, (_co.mainForm.get('parentPhone').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 181, 0, currVal_132, currVal_133);
        var currVal_141 = 'parentPhone';
        _ck(_v, 187, 0, currVal_141);
        var currVal_142 = (_co.mainForm.get('parentPhone').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 195, 0, currVal_142);
        var currVal_143 = 'input-group email half';
        var currVal_144 = _ck(_v, 198, 0, (_co.mainForm.get('parentEmail').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 197, 0, currVal_143, currVal_144);
        var currVal_152 = 'parentEmail';
        _ck(_v, 203, 0, currVal_152);
        var currVal_153 = (_co.mainForm.get('parentEmail').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 211, 0, currVal_153);
        var currVal_154 = (_co.mainForm.get('parentEmail').hasError('cantBeSameAsStudentEmail') && _co.hasFormBeenSubmitted);
        _ck(_v, 213, 0, currVal_154);
        var currVal_162 = 'parentAddressLineOne';
        _ck(_v, 220, 0, currVal_162);
        var currVal_163 = (_co.mainForm.get('parentAddressLineOne').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 228, 0, currVal_163);
        var currVal_171 = 'parentAddressLineTwo';
        _ck(_v, 234, 0, currVal_171);
        var currVal_179 = 'parentAddressSuburb';
        _ck(_v, 245, 0, currVal_179);
        var currVal_180 = (_co.mainForm.get('parentAddressSuburb').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 253, 0, currVal_180);
        var currVal_181 = 'input-group line-one one-third';
        var currVal_182 = _ck(_v, 256, 0, (_co.mainForm.get('parentAddressState').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 255, 0, currVal_181, currVal_182);
        var currVal_190 = 0;
        var currVal_191 = true;
        var currVal_192 = _co.states[1];
        var currVal_193 = _co.stateCompleter;
        _ck(_v, 259, 0, currVal_190, currVal_191, currVal_192, currVal_193);
        var currVal_194 = _co.stateSearchStr;
        var currVal_195 = _ck(_v, 262, 0, true);
        _ck(_v, 261, 0, currVal_194, currVal_195);
        var currVal_196 = (_co.mainForm.get('parentAddressState').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 270, 0, currVal_196);
        var currVal_204 = 'parentAddressPostcode';
        _ck(_v, 276, 0, currVal_204);
        var currVal_205 = (_co.mainForm.get('parentAddressPostcode').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 284, 0, currVal_205);
        var currVal_206 = _co.creditCard;
        var currVal_207 = _co.hasFormBeenSubmitted;
        var currVal_208 = _co.mainForm;
        _ck(_v, 289, 0, currVal_206, currVal_207, currVal_208);
        var currVal_216 = 'terms';
        _ck(_v, 295, 0, currVal_216);
        var currVal_217 = (_co.mainForm.get('terms').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 309, 0, currVal_217);
        var currVal_225 = 'studentNewsletterSubscription';
        _ck(_v, 315, 0, currVal_225);
        var currVal_227 = 'ptgf__btn-submit';
        var currVal_228 = _ck(_v, 329, 0, _co.loading);
        _ck(_v, 328, 0, currVal_227, currVal_228);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_16 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_17 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_18 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_19 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_20 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_21 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 23, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_26 = core_es5["ɵnov"](_v, 44).ngClassUntouched;
        var currVal_27 = core_es5["ɵnov"](_v, 44).ngClassTouched;
        var currVal_28 = core_es5["ɵnov"](_v, 44).ngClassPristine;
        var currVal_29 = core_es5["ɵnov"](_v, 44).ngClassDirty;
        var currVal_30 = core_es5["ɵnov"](_v, 44).ngClassValid;
        var currVal_31 = core_es5["ɵnov"](_v, 44).ngClassInvalid;
        var currVal_32 = core_es5["ɵnov"](_v, 44).ngClassPending;
        _ck(_v, 39, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32);
        var currVal_37 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_38 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_39 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_40 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_41 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_42 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_43 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 56, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43);
        var currVal_48 = core_es5["ɵnov"](_v, 77).ngClassUntouched;
        var currVal_49 = core_es5["ɵnov"](_v, 77).ngClassTouched;
        var currVal_50 = core_es5["ɵnov"](_v, 77).ngClassPristine;
        var currVal_51 = core_es5["ɵnov"](_v, 77).ngClassDirty;
        var currVal_52 = core_es5["ɵnov"](_v, 77).ngClassValid;
        var currVal_53 = core_es5["ɵnov"](_v, 77).ngClassInvalid;
        var currVal_54 = core_es5["ɵnov"](_v, 77).ngClassPending;
        _ck(_v, 72, 0, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54);
        var currVal_59 = core_es5["ɵnov"](_v, 94).ngClassUntouched;
        var currVal_60 = core_es5["ɵnov"](_v, 94).ngClassTouched;
        var currVal_61 = core_es5["ɵnov"](_v, 94).ngClassPristine;
        var currVal_62 = core_es5["ɵnov"](_v, 94).ngClassDirty;
        var currVal_63 = core_es5["ɵnov"](_v, 94).ngClassValid;
        var currVal_64 = core_es5["ɵnov"](_v, 94).ngClassInvalid;
        var currVal_65 = core_es5["ɵnov"](_v, 94).ngClassPending;
        _ck(_v, 89, 0, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65);
        var currVal_70 = core_es5["ɵnov"](_v, 111).ngClassUntouched;
        var currVal_71 = core_es5["ɵnov"](_v, 111).ngClassTouched;
        var currVal_72 = core_es5["ɵnov"](_v, 111).ngClassPristine;
        var currVal_73 = core_es5["ɵnov"](_v, 111).ngClassDirty;
        var currVal_74 = core_es5["ɵnov"](_v, 111).ngClassValid;
        var currVal_75 = core_es5["ɵnov"](_v, 111).ngClassInvalid;
        var currVal_76 = core_es5["ɵnov"](_v, 111).ngClassPending;
        _ck(_v, 105, 0, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76);
        var currVal_83 = core_es5["ɵnov"](_v, 127).ngClassUntouched;
        var currVal_84 = core_es5["ɵnov"](_v, 127).ngClassTouched;
        var currVal_85 = core_es5["ɵnov"](_v, 127).ngClassPristine;
        var currVal_86 = core_es5["ɵnov"](_v, 127).ngClassDirty;
        var currVal_87 = core_es5["ɵnov"](_v, 127).ngClassValid;
        var currVal_88 = core_es5["ɵnov"](_v, 127).ngClassInvalid;
        var currVal_89 = core_es5["ɵnov"](_v, 127).ngClassPending;
        _ck(_v, 121, 0, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89);
        var currVal_97 = core_es5["ɵnov"](_v, 138).ngClassUntouched;
        var currVal_98 = core_es5["ɵnov"](_v, 138).ngClassTouched;
        var currVal_99 = core_es5["ɵnov"](_v, 138).ngClassPristine;
        var currVal_100 = core_es5["ɵnov"](_v, 138).ngClassDirty;
        var currVal_101 = core_es5["ɵnov"](_v, 138).ngClassValid;
        var currVal_102 = core_es5["ɵnov"](_v, 138).ngClassInvalid;
        var currVal_103 = core_es5["ɵnov"](_v, 138).ngClassPending;
        _ck(_v, 132, 0, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103);
        var currVal_112 = core_es5["ɵnov"](_v, 156).ngClassUntouched;
        var currVal_113 = core_es5["ɵnov"](_v, 156).ngClassTouched;
        var currVal_114 = core_es5["ɵnov"](_v, 156).ngClassPristine;
        var currVal_115 = core_es5["ɵnov"](_v, 156).ngClassDirty;
        var currVal_116 = core_es5["ɵnov"](_v, 156).ngClassValid;
        var currVal_117 = core_es5["ɵnov"](_v, 156).ngClassInvalid;
        var currVal_118 = core_es5["ɵnov"](_v, 156).ngClassPending;
        _ck(_v, 151, 0, currVal_112, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118);
        var currVal_123 = core_es5["ɵnov"](_v, 172).ngClassUntouched;
        var currVal_124 = core_es5["ɵnov"](_v, 172).ngClassTouched;
        var currVal_125 = core_es5["ɵnov"](_v, 172).ngClassPristine;
        var currVal_126 = core_es5["ɵnov"](_v, 172).ngClassDirty;
        var currVal_127 = core_es5["ɵnov"](_v, 172).ngClassValid;
        var currVal_128 = core_es5["ɵnov"](_v, 172).ngClassInvalid;
        var currVal_129 = core_es5["ɵnov"](_v, 172).ngClassPending;
        _ck(_v, 167, 0, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129);
        var currVal_134 = core_es5["ɵnov"](_v, 189).ngClassUntouched;
        var currVal_135 = core_es5["ɵnov"](_v, 189).ngClassTouched;
        var currVal_136 = core_es5["ɵnov"](_v, 189).ngClassPristine;
        var currVal_137 = core_es5["ɵnov"](_v, 189).ngClassDirty;
        var currVal_138 = core_es5["ɵnov"](_v, 189).ngClassValid;
        var currVal_139 = core_es5["ɵnov"](_v, 189).ngClassInvalid;
        var currVal_140 = core_es5["ɵnov"](_v, 189).ngClassPending;
        _ck(_v, 184, 0, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140);
        var currVal_145 = core_es5["ɵnov"](_v, 205).ngClassUntouched;
        var currVal_146 = core_es5["ɵnov"](_v, 205).ngClassTouched;
        var currVal_147 = core_es5["ɵnov"](_v, 205).ngClassPristine;
        var currVal_148 = core_es5["ɵnov"](_v, 205).ngClassDirty;
        var currVal_149 = core_es5["ɵnov"](_v, 205).ngClassValid;
        var currVal_150 = core_es5["ɵnov"](_v, 205).ngClassInvalid;
        var currVal_151 = core_es5["ɵnov"](_v, 205).ngClassPending;
        _ck(_v, 200, 0, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151);
        var currVal_155 = core_es5["ɵnov"](_v, 222).ngClassUntouched;
        var currVal_156 = core_es5["ɵnov"](_v, 222).ngClassTouched;
        var currVal_157 = core_es5["ɵnov"](_v, 222).ngClassPristine;
        var currVal_158 = core_es5["ɵnov"](_v, 222).ngClassDirty;
        var currVal_159 = core_es5["ɵnov"](_v, 222).ngClassValid;
        var currVal_160 = core_es5["ɵnov"](_v, 222).ngClassInvalid;
        var currVal_161 = core_es5["ɵnov"](_v, 222).ngClassPending;
        _ck(_v, 217, 0, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161);
        var currVal_164 = core_es5["ɵnov"](_v, 236).ngClassUntouched;
        var currVal_165 = core_es5["ɵnov"](_v, 236).ngClassTouched;
        var currVal_166 = core_es5["ɵnov"](_v, 236).ngClassPristine;
        var currVal_167 = core_es5["ɵnov"](_v, 236).ngClassDirty;
        var currVal_168 = core_es5["ɵnov"](_v, 236).ngClassValid;
        var currVal_169 = core_es5["ɵnov"](_v, 236).ngClassInvalid;
        var currVal_170 = core_es5["ɵnov"](_v, 236).ngClassPending;
        _ck(_v, 231, 0, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170);
        var currVal_172 = core_es5["ɵnov"](_v, 247).ngClassUntouched;
        var currVal_173 = core_es5["ɵnov"](_v, 247).ngClassTouched;
        var currVal_174 = core_es5["ɵnov"](_v, 247).ngClassPristine;
        var currVal_175 = core_es5["ɵnov"](_v, 247).ngClassDirty;
        var currVal_176 = core_es5["ɵnov"](_v, 247).ngClassValid;
        var currVal_177 = core_es5["ɵnov"](_v, 247).ngClassInvalid;
        var currVal_178 = core_es5["ɵnov"](_v, 247).ngClassPending;
        _ck(_v, 242, 0, currVal_172, currVal_173, currVal_174, currVal_175, currVal_176, currVal_177, currVal_178);
        var currVal_183 = core_es5["ɵnov"](_v, 264).ngClassUntouched;
        var currVal_184 = core_es5["ɵnov"](_v, 264).ngClassTouched;
        var currVal_185 = core_es5["ɵnov"](_v, 264).ngClassPristine;
        var currVal_186 = core_es5["ɵnov"](_v, 264).ngClassDirty;
        var currVal_187 = core_es5["ɵnov"](_v, 264).ngClassValid;
        var currVal_188 = core_es5["ɵnov"](_v, 264).ngClassInvalid;
        var currVal_189 = core_es5["ɵnov"](_v, 264).ngClassPending;
        _ck(_v, 258, 0, currVal_183, currVal_184, currVal_185, currVal_186, currVal_187, currVal_188, currVal_189);
        var currVal_197 = core_es5["ɵnov"](_v, 278).ngClassUntouched;
        var currVal_198 = core_es5["ɵnov"](_v, 278).ngClassTouched;
        var currVal_199 = core_es5["ɵnov"](_v, 278).ngClassPristine;
        var currVal_200 = core_es5["ɵnov"](_v, 278).ngClassDirty;
        var currVal_201 = core_es5["ɵnov"](_v, 278).ngClassValid;
        var currVal_202 = core_es5["ɵnov"](_v, 278).ngClassInvalid;
        var currVal_203 = core_es5["ɵnov"](_v, 278).ngClassPending;
        _ck(_v, 273, 0, currVal_197, currVal_198, currVal_199, currVal_200, currVal_201, currVal_202, currVal_203);
        var currVal_209 = core_es5["ɵnov"](_v, 297).ngClassUntouched;
        var currVal_210 = core_es5["ɵnov"](_v, 297).ngClassTouched;
        var currVal_211 = core_es5["ɵnov"](_v, 297).ngClassPristine;
        var currVal_212 = core_es5["ɵnov"](_v, 297).ngClassDirty;
        var currVal_213 = core_es5["ɵnov"](_v, 297).ngClassValid;
        var currVal_214 = core_es5["ɵnov"](_v, 297).ngClassInvalid;
        var currVal_215 = core_es5["ɵnov"](_v, 297).ngClassPending;
        _ck(_v, 292, 0, currVal_209, currVal_210, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215);
        var currVal_218 = core_es5["ɵnov"](_v, 317).ngClassUntouched;
        var currVal_219 = core_es5["ɵnov"](_v, 317).ngClassTouched;
        var currVal_220 = core_es5["ɵnov"](_v, 317).ngClassPristine;
        var currVal_221 = core_es5["ɵnov"](_v, 317).ngClassDirty;
        var currVal_222 = core_es5["ɵnov"](_v, 317).ngClassValid;
        var currVal_223 = core_es5["ɵnov"](_v, 317).ngClassInvalid;
        var currVal_224 = core_es5["ɵnov"](_v, 317).ngClassPending;
        _ck(_v, 312, 0, currVal_218, currVal_219, currVal_220, currVal_221, currVal_222, currVal_223, currVal_224);
        var currVal_226 = _co.loading;
        _ck(_v, 327, 0, currVal_226);
        var currVal_229 = (_co.loading ? 'Confirming...' : 'Confirm & Pay');
        _ck(_v, 330, 0, currVal_229);
    });
}
function View_PurchaseTicketGuestFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'purchase-ticket-guest-form', [], null, null, null, View_PurchaseTicketGuestFormComponent_0, RenderType_PurchaseTicketGuestFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, purchase_ticket_guest_form_PurchaseTicketGuestFormComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"], completer_service["a" /* CompleterService */],
            unique_email_async_UniqueEmailAsyncValidation], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PurchaseTicketGuestFormComponentNgFactory = core_es5["ɵccf"]('purchase-ticket-guest-form', purchase_ticket_guest_form_PurchaseTicketGuestFormComponent, View_PurchaseTicketGuestFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=purchase-ticket-guest-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket-existing-form.ts





var purchase_ticket_existing_form_PurchaseTicketExistingFormComponent = (function () {
    function PurchaseTicketExistingFormComponent(store, tokenService) {
        this.store = store;
        this.tokenService = tokenService;
        this.loading = false;
    }
    PurchaseTicketExistingFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.dispatch({ type: CLEAR_EVENT_ERRORS });
        this.store.dispatch({ type: POPULATE_EDITABLE_CREDIT_CARD, payload: new CreditCard() });
        this.eventsSubscription = this.store.select("eventsReducer").subscribe(function (s) {
            _this.event = s.activeEvent;
            _this.errors = s.errors;
            _this.loading = s.loading;
        });
        this.userSubscription =
            this.store.select("userReducer").subscribe(function (s) {
                _this.currentUserContact = s.currentUserContact;
                _this.currentUserGuardian = s.currentUserContact.guardian;
            });
    };
    PurchaseTicketExistingFormComponent.prototype.clickedPay = function () {
        var taIds = this.event.ticketAllocations
            .filter(function (ta) { return ta.uiState.isPurchasing; })
            .map(function (ta) { return ta.id; });
        var payload = event_Event.createPurchaseTicketAsExistingPayload(this.currentUserContact, taIds);
        this.store.dispatch({ type: CLEAR_EVENT_ERRORS });
        this.store.dispatch({ type: PURCHASE_TICKETS_AS_EXISTING, payload: payload });
    };
    PurchaseTicketExistingFormComponent.prototype.getKeys = function (errors) { return Object.keys(errors); };
    PurchaseTicketExistingFormComponent.prototype.ngOnDestroy = function () {
        this.eventsSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
    };
    PurchaseTicketExistingFormComponent.ctorParameters = function () { return [{ type: src_store["a" /* Store */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return PurchaseTicketExistingFormComponent;
}());

//# sourceMappingURL=purchase-ticket-existing-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/public/purchase-ticket-existing-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_PurchaseTicketExistingFormComponent = [];
var RenderType_PurchaseTicketExistingFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PurchaseTicketExistingFormComponent, data: {} });
function View_PurchaseTicketExistingFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptef__attr phone']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentUserContact.phones[0].value;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_PurchaseTicketExistingFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptef__attr phone']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentUserGuardian.phones[0].value;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_PurchaseTicketExistingFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Payment Details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['We will automatically bill your saved'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'span', [['class', 'ptef__credit-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](6, null, [' ', ''])), (_l()(), core_es5["ɵted"](-1, null, [' with the number'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'span', [['class', 'ptef__credit-info']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](9, null, [' ', '.'])),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['If you\'d like to pay with another credit card, please contact our friendly Customer Service team at '])),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'a', [['href', 'mailto:info@matrix.edu.au']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['info@matrix.edu.au '])), (_l()(), core_es5["ɵted"](-1, null, ['or 1300 008 008.']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.currentUserGuardian.creditCard.cardType;
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _co.currentUserGuardian.creditCard.cardNumber;
        _ck(_v, 9, 0, currVal_1);
    });
}
function View_PurchaseTicketExistingFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No Billing Details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['We were unable to find billing information for your account, please contact our friendly Customer Service team at '])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'a', [['href', 'mailto:info@matrix.edu.au']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['info@matrix.edu.au '])), (_l()(), core_es5["ɵted"](-1, null, ['or 1300 008 008.']))], null, null);
}
function View_PurchaseTicketExistingFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.parent.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.errors[_v.parent.context.$implicit][_v.context.$implicit];
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_PurchaseTicketExistingFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'dl', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_7)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors[_v.context.$implicit]);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_PurchaseTicketExistingFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'ptef__server-errors']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'inverted']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Errors occured while submitting your application'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_6)),
        core_es5["ɵdid"](4, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](5, 0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Please try again and if the problem persists please get in contact with our friendly Customer Service team at '])),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'a', [['href', 'mailto:info@matrix.edu.au']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['info@matrix.edu.au '])), (_l()(), core_es5["ɵted"](-1, null, ['or 1300 008 008.']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors);
        _ck(_v, 4, 0, currVal_0);
    }, null);
}
function View_PurchaseTicketExistingFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'button', [['class', 'ptef__btn-submit']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPay() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.loading ? 'Confirming...' : 'Confirm & Pay');
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_PurchaseTicketExistingFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 34, 'div', [['class',
                'purchase-ticket-existing-form']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'purchase-ticket-existing-form--loading': 0 }),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 31, 'div', [['class', 'ptef__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Double check your details'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'p', [['class', 'ptef__blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Please ensure the following student and parent contact details are correct as further information regarding the event will be sent to the provided email addresses. If any details are wrong, please contact our Customer Service team.'])),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 18, 'div', [['class', 'ptef__details-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 8, 'div', [['class', 'ptef__details student']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student details'])), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'div', [['class', 'ptef__attr name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](13, null, ['', ''])),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 1, 'div', [['class', 'ptef__attr email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](15, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_1)),
        core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](18, 0, null, null, 8, 'div', [['class', 'ptef__details parent']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Parent details'])), (_l()(),
            core_es5["ɵeld"](21, 0, null, null, 1, 'div', [['class', 'ptef__attr name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](22, null, ['', ''])), (_l()(), core_es5["ɵeld"](23, 0, null, null, 1, 'div', [['class', 'ptef__attr email']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](24, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_2)), core_es5["ɵdid"](26, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_3)),
        core_es5["ɵdid"](28, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_4)),
        core_es5["ɵdid"](30, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_5)),
        core_es5["ɵdid"](32, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketExistingFormComponent_8)),
        core_es5["ɵdid"](34, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'purchase-ticket-existing-form';
        var currVal_1 = _ck(_v, 2, 0, _co.loading);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_4 = _co.currentUserContact.phones[0];
        _ck(_v, 17, 0, currVal_4);
        var currVal_7 = _co.currentUserGuardian.phones[0];
        _ck(_v, 26, 0, currVal_7);
        var currVal_8 = (_co.currentUserGuardian.creditCard && !_co.errors);
        _ck(_v, 28, 0, currVal_8);
        var currVal_9 = (!_co.currentUserGuardian.creditCard && !_co.errors);
        _ck(_v, 30, 0, currVal_9);
        var currVal_10 = _co.errors;
        _ck(_v, 32, 0, currVal_10);
        var currVal_11 = _co.currentUserGuardian.creditCard;
        _ck(_v, 34, 0, currVal_11);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.currentUserContact.fullName;
        _ck(_v, 13, 0, currVal_2);
        var currVal_3 = _co.currentUserContact.email;
        _ck(_v, 15, 0, currVal_3);
        var currVal_5 = _co.currentUserGuardian.fullName;
        _ck(_v, 22, 0, currVal_5);
        var currVal_6 = _co.currentUserGuardian.email;
        _ck(_v, 24, 0, currVal_6);
    });
}
function View_PurchaseTicketExistingFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'purchase-ticket-existing-form', [], null, null, null, View_PurchaseTicketExistingFormComponent_0, RenderType_PurchaseTicketExistingFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, purchase_ticket_existing_form_PurchaseTicketExistingFormComponent, [src_store["a" /* Store */], angular2_token_es5["a" /* Angular2TokenService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PurchaseTicketExistingFormComponentNgFactory = core_es5["ɵccf"]('purchase-ticket-existing-form', purchase_ticket_existing_form_PurchaseTicketExistingFormComponent, View_PurchaseTicketExistingFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=purchase-ticket-existing-form.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/rxjs/Observable.js
var Observable = __webpack_require__("bKpL");
var Observable_default = /*#__PURE__*/__webpack_require__.n(Observable);

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/effects/index.js + 1 modules
var effects = __webpack_require__("/vpO");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/role.ts
var role___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Role = (function (_super) {
    role___extends(Role, _super);
    function Role(name, code) {
        if (name === void 0) { name = null; }
        if (code === void 0) { code = null; }
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.code = code;
        return _this;
    }
    Role.clone = function (obj) {
        var role = new this();
        if (obj.code) {
            role.code = obj.code;
        }
        if (obj.name) {
            role.name = obj.name;
        }
        return role;
    };
    Role.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        return response;
    };
    return Role;
}(Model));

//# sourceMappingURL=role.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/user.ts

var user_User = (function () {
    function User(id, contactId, contact, email, uid, roles) {
        if (contactId === void 0) { contactId = null; }
        if (contact === void 0) { contact = null; }
        if (email === void 0) { email = null; }
        if (uid === void 0) { uid = null; }
        if (roles === void 0) { roles = []; }
        this.id = id;
        this.contactId = contactId;
        this.contact = contact;
        this.email = email;
        this.uid = uid;
        this.roles = roles;
    }
    User.initFromCurrentUserData = function (data) {
        var user = new this();
        if (data.id) {
            user.id = data.id;
        }
        if (data.contactId) {
            user.contactId = data.contactId;
        }
        if (data.email) {
            user.email = data.email;
        }
        if (data.uid) {
            user.uid = data.uid;
        }
        if (data.roles) {
            user.roles = data.roles;
        }
        return user;
    };
    User.clone = function (obj) {
        var user = new this();
        if (obj.id) {
            user.id = obj.id;
        }
        if (obj.contactId) {
            user.id = obj.id;
        }
        if (obj.contact) {
            user.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.email) {
            user.email = obj.email;
        }
        if (obj.uid) {
            user.uid = obj.uid;
        }
        if (obj.roles) {
            user.roles = obj.roles;
        }
        return user;
    };
    User.prototype.serializeForRails = function () {
        return {
            id: this.id,
            roles: this.roles,
        };
    };
    return User;
}());

//# sourceMappingURL=user.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/role.ts





var role_RoleService = (function () {
    function RoleService(http, store) {
        this.http = http;
        this.store = store;
        this.rolesUrl = 'roles';
        this.usersUrl = 'users';
    }
    RoleService.prototype.index = function (params) {
        return this.http.get(this.rolesUrl)
            .map(function (res) { return res.json().map(function (r) { return Role.clone(r); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    RoleService.prototype.updateUser = function (user) {
        return this.http.patch(this.usersUrl + "/" + user.id, user)
            .map(function (res) { return user_User.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    RoleService.prototype.roleUsers = function (roleId) {
        return this.http.get(this.rolesUrl + "/" + roleId + "/users")
            .map(function (res) { return res.json().map(function (u) { return user_User.clone(u); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    RoleService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return RoleService;
}());

//# sourceMappingURL=role.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/user.ts
var UserStore = (function () {
    function UserStore(currentUserContact) {
        if (currentUserContact === void 0) { currentUserContact = null; }
        this.currentUserContact = currentUserContact;
    }
    return UserStore;
}());

//# sourceMappingURL=user.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/user.ts

var userReducer = function (state, action) {
    if (state === void 0) { state = new UserStore(); }
    switch (action.type) {
        case POPULATE_CURRENT_USER_CONTACT:
            return new UserStore(action.payload);
        default:
            return state;
    }
};
var LOGIN = "LOGIN";
var LOGIN_FAILURE = "LOGIN_FAILURE";
var LOGIN_SUCCESS = "LOGIN_SUCCESS";
var FETCH_CURRENT_USER_CONTACT = "FETCH_CURRENT_USER_CONTACT";
var FETCH_CURRENT_USER_CONTACT_FAILURE = "FETCH_CURRENT_USER_CONTACT_FAILURE";
var POPULATE_CURRENT_USER_CONTACT = "POPULATE_CURRENT_USER_CONTACT";
var UPDATE_USER = "UPDATE_USER";
var UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
var REPLACE_USER = "REPLACE_USER";
//# sourceMappingURL=user.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/user.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var user_UserEffects = (function () {
    function UserEffects(actions, contactService, roleService, tokenService) {
        var _this = this;
        this.actions = actions;
        this.contactService = contactService;
        this.roleService = roleService;
        this.tokenService = tokenService;
        this.login = this.actions
            .ofType(LOGIN)
            .map(function (action) { return action.payload; })
            .switchMap(function (credentials) {
            return _this.tokenService.signIn(credentials)
                .map(function (res) { return ({ type: LOGIN_SUCCESS, payload: res }); })
                .catch(function (err) { return Observable["Observable"].of({ type: LOGIN_FAILURE, payload: err }); });
        });
        this.update = this.actions
            .ofType(UPDATE_USER)
            .map(function (action) { return action.payload; })
            .switchMap(function (user) { return _this.roleService.updateUser(user.serializeForRails())
            .map(function (user) { return ({ type: REPLACE_USER, payload: user }); })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_USER_FAILURE, payload: response }); }); });
    }
    UserEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: contact_ContactService }, { type: role_RoleService }, { type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return UserEffects;
}());

__decorate([
    Object(effects["b" /* Effect */])(),
    __metadata("design:type", Object)
], user_UserEffects.prototype, "login", void 0);
__decorate([
    Object(effects["b" /* Effect */])(),
    __metadata("design:type", Object)
], user_UserEffects.prototype, "update", void 0);
//# sourceMappingURL=user.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket-form.ts





var purchase_ticket_form_PurchaseTicketFormComponent = (function () {
    function PurchaseTicketFormComponent(store, tokenService, userEffects) {
        this.store = store;
        this.tokenService = tokenService;
        this.userEffects = userEffects;
        this.uiState = { continueAsGuest: false };
        this.signInData = {};
    }
    PurchaseTicketFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventsSubscription =
            this.store.select("eventsReducer").subscribe(function (s) {
                _this.event = s.activeEvent;
            });
        this.userSubscription =
            this.store.select("userReducer").subscribe(function (s) {
                _this.currentUserContact = s.currentUserContact;
            });
    };
    PurchaseTicketFormComponent.prototype.submitLogin = function () {
        var _this = this;
        this.signInError = false;
        this.signInLoading = true;
        this.tokenService.signIn(this.signInData)
            .take(1)
            .subscribe(function (res) {
            _this.store.dispatch({
                type: POPULATE_CURRENT_USER_CONTACT,
                payload: JSON.parse(res._body).data.contact,
            });
            _this.signInLoading = false;
            _this.tokenService.validateToken();
        }, function (err) {
            _this.signInLoading = false;
            _this.signInError = true;
            return Observable["Observable"].of(err);
        });
    };
    PurchaseTicketFormComponent.prototype.clickedContinueAsGuest = function () {
        this.uiState.continueAsGuest = true;
    };
    PurchaseTicketFormComponent.prototype.clickedLogout = function () {
        this.tokenService.signOut();
    };
    PurchaseTicketFormComponent.prototype.ticketAllocationsToPurchase = function () {
        return this.event.ticketAllocations.filter(function (ta) {
            return ta.uiState.isPurchasing;
        });
    };
    PurchaseTicketFormComponent.prototype.ticketAllocationsToPurchaseTotal = function () {
        return this.event.ticketAllocations.filter(function (ta) {
            return ta.uiState.isPurchasing;
        }).map(function (ta) {
            return ta.price;
        }).reduce(function (total, price) {
            return total + price;
        });
    };
    PurchaseTicketFormComponent.prototype.shouldShowLoginForm = function () {
        return !this.tokenService.userSignedIn() && !this.uiState.continueAsGuest;
    };
    PurchaseTicketFormComponent.prototype.canUserPurchase = function () {
        return this.currentUserContact && this.currentUserContact.contactType == 0;
    };
    PurchaseTicketFormComponent.prototype.ngOnDestroy = function () {
        this.eventsSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
    };
    PurchaseTicketFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: user_UserEffects }]; };
    return PurchaseTicketFormComponent;
}());

//# sourceMappingURL=purchase-ticket-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/public/purchase-ticket-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_PurchaseTicketFormComponent = [];
var RenderType_PurchaseTicketFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PurchaseTicketFormComponent, data: {} });
function View_PurchaseTicketFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'li', [['class',
                'ptf__ticket']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class', 'ptf__t-title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'div', [['class', 'ptf__t-location']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'div', [['class',
                'ptf__t-when']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ''])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'div', [['class', 'ptf__t-price']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](8, null, ['', ''])), core_es5["ɵppd"](9, 4)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_v.context.$implicit.title || _co.event.title);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.location;
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.whenDisplay;
        _ck(_v, 6, 0, currVal_2);
        var currVal_3 = core_es5["ɵunv"](_v, 8, 0, _ck(_v, 9, 0, core_es5["ɵnov"](_v.parent, 0), _v.context.$implicit.price, 'USD', true, '1.2-2'));
        _ck(_v, 8, 0, currVal_3);
    });
}
function View_PurchaseTicketFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'ptf__login-warning']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 6, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Please note we currently require'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'strong', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['  student login details'])), (_l()(), core_es5["ɵted"](-1, null, ['  for enrolment.'])),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Should you encounter any problems, please contact our Customer Service Team on 1300 008 008.']))], null, null);
}
function View_PurchaseTicketFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptf__login-error']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Login failed. Please try again...']))], null, null);
}
function View_PurchaseTicketFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ptf__login-help-advice']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['If you\'re having difficulty accessing your account please don\'t hesitate to get in contact with our friendly Customer Service team at info@matrix.edu.au or 1300 008 008.']))], null, null);
}
function View_PurchaseTicketFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 50, 'div', [['class',
                'ptf__panel login-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 44, 'div', [['class',
                'ptf__login']], null, null, null, null, null)),
        core_es5["ɵdid"](2, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](3, { 'ptf__login--loading': 0 }), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'h3', [['class', 'borderless']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Have a student account? Login to purchase...'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_3)),
        core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_4)), core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_5)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 33, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 14).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 14).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.submitLogin() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](13, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](14, 16384, null, 0, forms_es5["NgForm"], [[8, null], [8, null]], null, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](16, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](17, 0, null, null, 22, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](18, 0, null, null, 10, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 1, 'label', [['for', 'email']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](22, 0, null, null, 6, 'input', [['id', 'email'], ['type', 'email']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 23)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 23)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.signInData.email = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](25, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](26, { standalone: 0 }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]),
        core_es5["ɵdid"](28, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](29, 0, null, null, 10, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](30, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 1, 'label', [['for', 'password']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Password'])),
        (_l()(), core_es5["ɵeld"](33, 0, null, null, 6, 'input', [['id', 'password'],
            ['type', 'password']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 34)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 34).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 34)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 34)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.signInData.password = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](34, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](36, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'], options: [1, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](37, { standalone: 0 }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]),
        core_es5["ɵdid"](39, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](40, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](41, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](43, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](44, 0, null, null, 1, 'button', [['class', 'ptf__btn-continue-guest'], ['type', 'submit']], [[8, 'disabled',
                0]], null, null, null, null)), (_l()(),
            core_es5["ɵted"](45, null, ['', ''])), (_l()(), core_es5["ɵeld"](46, 0, null, null, 4, 'div', [['class', 'ptf__continue_guest-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](47, 0, null, null, 1, 'span', [['class', 'ptf__continue_guest-caption']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['or'])), (_l()(), core_es5["ɵeld"](49, 0, null, null, 1, 'a', [['class', 'ptf__continue_guest-link']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedContinueAsGuest() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Continue as guest']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'ptf__login';
        var currVal_1 = _ck(_v, 3, 0, _co.signInLoading);
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = !_co.signInError;
        _ck(_v, 7, 0, currVal_2);
        var currVal_3 = _co.signInError;
        _ck(_v, 9, 0, currVal_3);
        var currVal_4 = _co.signInError;
        _ck(_v, 11, 0, currVal_4);
        var currVal_19 = _co.signInData.email;
        var currVal_20 = _ck(_v, 26, 0, true);
        _ck(_v, 25, 0, currVal_19, currVal_20);
        var currVal_28 = _co.signInData.password;
        var currVal_29 = _ck(_v, 37, 0, true);
        _ck(_v, 36, 0, currVal_28, currVal_29);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 12, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 22, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_21 = core_es5["ɵnov"](_v, 39).ngClassUntouched;
        var currVal_22 = core_es5["ɵnov"](_v, 39).ngClassTouched;
        var currVal_23 = core_es5["ɵnov"](_v, 39).ngClassPristine;
        var currVal_24 = core_es5["ɵnov"](_v, 39).ngClassDirty;
        var currVal_25 = core_es5["ɵnov"](_v, 39).ngClassValid;
        var currVal_26 = core_es5["ɵnov"](_v, 39).ngClassInvalid;
        var currVal_27 = core_es5["ɵnov"](_v, 39).ngClassPending;
        _ck(_v, 33, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_30 = _co.signInLoading;
        _ck(_v, 44, 0, currVal_30);
        var currVal_31 = (_co.signInLoading ? 'Logging in...' : 'Login');
        _ck(_v, 45, 0, currVal_31);
    });
}
function View_PurchaseTicketFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'ptf__guest-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'purchase-ticket-guest-form', [], null, null, null, View_PurchaseTicketGuestFormComponent_0, RenderType_PurchaseTicketGuestFormComponent)), core_es5["ɵdid"](2, 245760, null, 0, purchase_ticket_guest_form_PurchaseTicketGuestFormComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"], completer_service["a" /* CompleterService */],
            unique_email_async_UniqueEmailAsyncValidation], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_PurchaseTicketFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](1, 0, null, null, 1, 'purchase-ticket-existing-form', [], null, null, null, View_PurchaseTicketExistingFormComponent_0, RenderType_PurchaseTicketExistingFormComponent)), core_es5["ɵdid"](2, 245760, null, 0, purchase_ticket_existing_form_PurchaseTicketExistingFormComponent, [src_store["a" /* Store */], angular2_token_es5["a" /* Angular2TokenService */]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_PurchaseTicketFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class', 'ptf__stop']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['We weren\'t able to retrieve your information, please try logging in with student account details.'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'p', [['class', 'ptf__stop--link']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedLogout() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Sign in with your student\'s login']))], null, null);
}
function View_PurchaseTicketFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'ptf__user-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'ptf__btn-logout-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [['class', 'tiny ptf__btn-logout']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedLogout() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Sign out'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_9)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_10)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.canUserPurchase();
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = !_co.canUserPurchase();
        _ck(_v, 7, 0, currVal_1);
    }, null);
}
function View_PurchaseTicketFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'ptf__panel purchase-form']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_7)), core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_8)),
        core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.uiState.continueAsGuest;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = !_co.uiState.continueAsGuest;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_PurchaseTicketFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 15, 'div', [['class', 'purchase-ticket-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 14, 'div', [['class', 'ptf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 9, 'div', [['class', 'ptf__tickets-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Looking to purchase:'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 6, 'ul', [['class', 'ptf__tickets']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_1)), core_es5["ɵdid"](8, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 3, 'li', [['class',
                'ptf__ticket_total']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'div', [['class',
                'ptf__t_total-price']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](11, null, ['Total ', ''])), core_es5["ɵppd"](12, 4), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_2)),
        core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketFormComponent_6)), core_es5["ɵdid"](16, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ticketAllocationsToPurchase();
        _ck(_v, 8, 0, currVal_0);
        var currVal_2 = _co.shouldShowLoginForm();
        _ck(_v, 14, 0, currVal_2);
        var currVal_3 = !_co.shouldShowLoginForm();
        _ck(_v, 16, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵunv"](_v, 11, 0, _ck(_v, 12, 0, core_es5["ɵnov"](_v, 0), _co.ticketAllocationsToPurchaseTotal(), 'USD', true, '1.2-2'));
        _ck(_v, 11, 0, currVal_1);
    });
}
function View_PurchaseTicketFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'purchase-ticket-form', [], null, null, null, View_PurchaseTicketFormComponent_0, RenderType_PurchaseTicketFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, purchase_ticket_form_PurchaseTicketFormComponent, [src_store["a" /* Store */], angular2_token_es5["a" /* Angular2TokenService */], user_UserEffects], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PurchaseTicketFormComponentNgFactory = core_es5["ɵccf"]('purchase-ticket-form', purchase_ticket_form_PurchaseTicketFormComponent, View_PurchaseTicketFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=purchase-ticket-form.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket.ts




var purchase_ticket_PurchaseTicketComponent = (function () {
    function PurchaseTicketComponent(store, actions, router) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.uiState = { step: 1 };
    }
    PurchaseTicketComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventsSubscription =
            this.store.select("eventsReducer").subscribe(function (s) {
                _this.event = s.activeEvent;
                _this.events = s.events;
                // if (s.events.length > 0) {
                //   this.eventsSearch = this.event.title
                //   this.eventsCompleter = this.completerService.local(s.events, null, 'title')
                // }
            });
        if (window['ga']) {
            ga('send', 'event', 'Events Enrolment', this.event.title, 'Select Ticket', {
                nonInteraction: true
            });
        }
        this.actionsSubcription =
            this.actions
                .filter(function (a) {
                return [
                    PURCHASED_TICKETS_AS_GUEST,
                    PURCHASED_TICKETS_AS_EXISTING,
                ].includes(a.type);
            })
                .subscribe(function (a) {
                if (window['ga']) {
                    ga('send', 'event', 'Events Enrolment', _this.event.title, 'Confirmation', {
                        nonInteraction: true
                    });
                    _this.selectedTicketTitles().forEach(function (title) {
                        ga('send', 'event', 'Events Enrolled', _this.event.title, title, {
                            nonInteraction: true
                        });
                    });
                }
                _this.uiState.step = 3;
                _this.uiState.tickets = a.payload;
            });
    };
    PurchaseTicketComponent.prototype.clickedTicketAllocation = function (ta) {
        if (ta.available()) {
            ta.uiState.isPurchasing = !ta.uiState.isPurchasing;
        }
    };
    PurchaseTicketComponent.prototype.clickedCheckboxDirectly = function (e) {
        e.preventDefault();
    };
    PurchaseTicketComponent.prototype.clickedNext = function () {
        if (this.purchasingCount() == 0) {
            return;
        }
        if (window['ga']) {
            ga('send', 'event', 'Events Enrolment', this.event.title, 'Details and Pay', {
                nonInteraction: true
            });
        }
        this.uiState.step = 2;
    };
    PurchaseTicketComponent.prototype.clickedBack = function () {
        this.uiState.step = 1;
    };
    // changeEvent(item: CompleterItem) {
    PurchaseTicketComponent.prototype.clickEventButton = function (event) {
        console.log(event);
        this.router.navigate(['public', 'events', event.id]);
    };
    PurchaseTicketComponent.prototype.selectedTickets = function () {
        return this.event.ticketAllocations.filter(function (ta) {
            return ta.uiState.isPurchasing;
        });
    };
    PurchaseTicketComponent.prototype.selectedTicketTitles = function () {
        return this.selectedTickets().map(function (ta) {
            return ta.title;
        });
    };
    PurchaseTicketComponent.prototype.purchasingCount = function () {
        return this.selectedTickets().length;
    };
    PurchaseTicketComponent.prototype.ngOnDestroy = function () {
        this.eventsSubscription.unsubscribe();
        this.actionsSubcription.unsubscribe();
    };
    PurchaseTicketComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: router_es5["k" /* Router */] }]; };
    return PurchaseTicketComponent;
}());

//# sourceMappingURL=purchase-ticket.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/effects/src/actions.js
var src_actions = __webpack_require__("uwGy");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/public/purchase-ticket.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_PurchaseTicketComponent = [];
var RenderType_PurchaseTicketComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_PurchaseTicketComponent, data: {} });
function View_PurchaseTicketComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickEventButton(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'active': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, (_v.context.$implicit.id == _co.event.id));
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.title;
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_PurchaseTicketComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'pt__ta--sold-out']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Unavailable']))], null, null);
}
function View_PurchaseTicketComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'pt__ta--sold-out']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Sold out']))], null, null);
}
function View_PurchaseTicketComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'input', [['name',
                'newsletterSubscription'], ['type', 'checkbox']], [[8, 'id', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_v.parent.context.$implicit.uiState.isPurchasing = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](2, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](4, 671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 0, 'label', [], [[8, 'htmlFor', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCheckboxDirectly($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], function (_ck, _v) {
        var currVal_8 = 'newsletterSubscription';
        var currVal_9 = _v.parent.context.$implicit.uiState.isPurchasing;
        _ck(_v, 4, 0, currVal_8, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = (_v.parent.context.$implicit.id + '_is-purchasing');
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_10 = (_v.parent.context.$implicit.id + '_is-purchasing');
        _ck(_v, 7, 0, currVal_10);
    });
}
function View_PurchaseTicketComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'pt__ta-meta location']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', ' ('])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'a', [['target', '_blank']], [[8, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['View map'])), (_l()(), core_es5["ɵted"](-1, null, [')']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.location;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '', _v.parent.context.$implicit.locationUrl, '');
        _ck(_v, 2, 0, currVal_1);
    });
}
function View_PurchaseTicketComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 17, 'li', [['class',
                'pt__ta-wrapper']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTicketAllocation(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0, 'pt__ta-wrapper--is-available': 1,
            'pt__ta-wrapper--sold-out': 2, 'pt__ta-wrapper--unavailable': 3, 'pt__ta-wrapper--expired': 4 }),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'div', [['class', 'input-group checkbox-square standalone is-purchasing']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_4)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_5)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_6)), core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 7, 'div', [['class', 'pt__ta']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 6, 'ul', [['class', 'pt__ta-metas']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'li', [['class', 'pt__ta-meta title']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](13, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_7)), core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'li', [['class', 'pt__ta-meta time']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](17, null, ['', '']))], function (_ck, _v) {
        var currVal_0 = 'pt__ta-wrapper';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.uiState.isPurchasing, _v.context.$implicit.available(), _v.context.$implicit.soldOut(), _v.context.$implicit.unavailable(), _v.context.$implicit.expired());
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _v.context.$implicit.unavailable();
        _ck(_v, 5, 0, currVal_2);
        var currVal_3 = (_v.context.$implicit.soldOut() && !_v.context.$implicit.unavailable());
        _ck(_v, 7, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.available();
        _ck(_v, 9, 0, currVal_4);
        var currVal_6 = _v.context.$implicit.location;
        _ck(_v, 15, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_5 = _v.context.$implicit.title;
        _ck(_v, 13, 0, currVal_5);
        var currVal_7 = _v.context.$implicit.whenDisplay;
        _ck(_v, 17, 0, currVal_7);
    });
}
function View_PurchaseTicketComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 17, 'div', [['class',
                'pt__step-content select']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'div', [['class',
                'pt__event-select']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Select an Event'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'div', [['class', 'btn-group']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_2)), core_es5["ɵdid"](6, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'h2', [['class', 'pt__step-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Which tickets would you like?'])),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 8, 'div', [['class', 'pt__ticket-allocations-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'ul', [['class', 'pt__tas']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_3)),
        core_es5["ɵdid"](12, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](13, 0, null, null, 4, 'div', [['class', 'pt__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](14, 0, null, null, 3, 'button', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedNext() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](15, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](16, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](17, null, ['Next (with ', ' ', ')']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.events;
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _co.event.ticketAllocations;
        _ck(_v, 12, 0, currVal_1);
        var currVal_2 = _ck(_v, 16, 0, (_co.purchasingCount() == 0));
        _ck(_v, 15, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = _co.purchasingCount();
        var currVal_4 = ((_co.purchasingCount() > 1) ? 'tickets' : 'ticket');
        _ck(_v, 17, 0, currVal_3, currVal_4);
    });
}
function View_PurchaseTicketComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'pt__step-content purchase']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'button', [['class',
                'tiny pt__btn-edit-tickets']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Edit'])), (_l()(),
            core_es5["ɵeld"](3, 0, null, null, 1, 'purchase-ticket-form', [], null, null, null, View_PurchaseTicketFormComponent_0, RenderType_PurchaseTicketFormComponent)), core_es5["ɵdid"](4, 245760, null, 0, purchase_ticket_form_PurchaseTicketFormComponent, [src_store["a" /* Store */], angular2_token_es5["a" /* Angular2TokenService */], user_UserEffects], null, null)], function (_ck, _v) {
        _ck(_v, 4, 0);
    }, null);
}
function View_PurchaseTicketComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'div', [['class',
                'pt__step-content complete']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h2', [['class',
                'pt__step-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Your enrolment is now complete!'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Thank you for registering and we look forward to seeing you on the first day of the course.'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['You will soon receive a email confirming your enrolment. Should you have any queries, please don\'t hesitate to get in contact with our friendly service team at info@matrix.edu.au or 1300 008 008.']))], null, null);
}
function View_PurchaseTicketComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 30, 'div', [['class',
                'purchase-ticket']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class',
                'pt__header-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'div', [['class',
                'pt__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'div', [['class', 'pt__header-inner-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 0, 'img', [['class', 'pt__logo'],
            ['src', 'images/logo-icon-red.png']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 3, 'h1', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'span', [['class', 'pt__event-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Purchasing ticket(s) for'])),
        (_l()(), core_es5["ɵted"](8, null, ['', ''])), (_l()(), core_es5["ɵeld"](9, 0, null, null, 21, 'div', [['class', 'pt__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 20, 'div', [['class', 'pt__content-inner-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 11, 'div', [['class', 'pt__timeline']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 10, 'ul', [['class', 'pt__tl-items']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](13, 0, null, null, 4, 'li', [['class', 'pt__tl-item one']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](14, 0, null, null, 3, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Step 1'])), (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Select ticket'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 4, 'li', [['class', 'pt__tl-item two']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 3, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Step 2'])),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Details & Pay'])), (_l()(), core_es5["ɵeld"](23, 0, null, null, 1, 'div', [['class', 'pt__event-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](24, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_1)), core_es5["ɵdid"](26, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_8)),
        core_es5["ɵdid"](28, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_PurchaseTicketComponent_9)), core_es5["ɵdid"](30, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.uiState.step == 1);
        _ck(_v, 26, 0, currVal_2);
        var currVal_3 = (_co.uiState.step == 2);
        _ck(_v, 28, 0, currVal_3);
        var currVal_4 = (_co.uiState.step == 3);
        _ck(_v, 30, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.event.title;
        _ck(_v, 8, 0, currVal_0);
        var currVal_1 = _co.event.description;
        _ck(_v, 24, 0, currVal_1);
    });
}
function View_PurchaseTicketComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'purchase-ticket', [], null, null, null, View_PurchaseTicketComponent_0, RenderType_PurchaseTicketComponent)), core_es5["ɵdid"](1, 245760, null, 0, purchase_ticket_PurchaseTicketComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], router_es5["k" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var PurchaseTicketComponentNgFactory = core_es5["ɵccf"]('purchase-ticket', purchase_ticket_PurchaseTicketComponent, View_PurchaseTicketComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=purchase-ticket.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/enquiry.ts
// NOTE: ENquiries are a unique model as if we try to clone null it just
// returns a fresh Enquiry object.
var enquiry___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var enquiry_Enquiry = (function (_super) {
    enquiry___extends(Enquiry, _super);
    function Enquiry(id, guid, courseIds, campusIds, matrixClassIds, isInternal, step, quickFullName, quickEmail, quickMobile, quickContactType, studentFirstName, studentLastName, studentGender, studentPhone, studentDob, studentEmail, parentFirstName, parentLastName, parentGender, parentPhone, parentDob, parentEmail, grade, currentGrade, school, isOnWaitingList, enquiryStatus, preferredContact, updatedAt, createdAt) {
        if (guid === void 0) { guid = null; }
        if (courseIds === void 0) { courseIds = []; }
        if (campusIds === void 0) { campusIds = []; }
        if (matrixClassIds === void 0) { matrixClassIds = []; }
        if (isInternal === void 0) { isInternal = false; }
        if (step === void 0) { step = 1; }
        if (quickFullName === void 0) { quickFullName = null; }
        if (quickEmail === void 0) { quickEmail = null; }
        if (quickMobile === void 0) { quickMobile = null; }
        if (quickContactType === void 0) { quickContactType = "parent"; }
        if (studentFirstName === void 0) { studentFirstName = null; }
        if (studentLastName === void 0) { studentLastName = null; }
        if (studentGender === void 0) { studentGender = null; }
        if (studentPhone === void 0) { studentPhone = null; }
        if (studentDob === void 0) { studentDob = new Date(); }
        if (studentEmail === void 0) { studentEmail = null; }
        if (parentFirstName === void 0) { parentFirstName = null; }
        if (parentLastName === void 0) { parentLastName = null; }
        if (parentGender === void 0) { parentGender = 0; }
        if (parentPhone === void 0) { parentPhone = null; }
        if (parentDob === void 0) { parentDob = new Date(); }
        if (parentEmail === void 0) { parentEmail = null; }
        if (grade === void 0) { grade = 7; }
        if (currentGrade === void 0) { currentGrade = null; }
        if (school === void 0) { school = null; }
        if (isOnWaitingList === void 0) { isOnWaitingList = false; }
        if (enquiryStatus === void 0) { enquiryStatus = 0; }
        if (preferredContact === void 0) { preferredContact = 1; }
        if (updatedAt === void 0) { updatedAt = null; }
        if (createdAt === void 0) { createdAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.guid = guid;
        _this.courseIds = courseIds;
        _this.campusIds = campusIds;
        _this.matrixClassIds = matrixClassIds;
        _this.isInternal = isInternal;
        _this.step = step;
        _this.quickFullName = quickFullName;
        _this.quickEmail = quickEmail;
        _this.quickMobile = quickMobile;
        _this.quickContactType = quickContactType;
        _this.studentFirstName = studentFirstName;
        _this.studentLastName = studentLastName;
        _this.studentGender = studentGender;
        _this.studentPhone = studentPhone;
        _this.studentDob = studentDob;
        _this.studentEmail = studentEmail;
        _this.parentFirstName = parentFirstName;
        _this.parentLastName = parentLastName;
        _this.parentGender = parentGender;
        _this.parentPhone = parentPhone;
        _this.parentDob = parentDob;
        _this.parentEmail = parentEmail;
        _this.grade = grade;
        _this.currentGrade = currentGrade;
        _this.school = school;
        _this.isOnWaitingList = isOnWaitingList;
        _this.enquiryStatus = enquiryStatus;
        _this.preferredContact = preferredContact;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        return _this;
    }
    Enquiry.clone = function (obj) {
        var enquiry = new this();
        if (!obj) {
            return enquiry;
        }
        if (obj.id) {
            enquiry.id = obj.id;
        }
        if (obj.guid) {
            enquiry.guid = obj.guid;
        }
        if (obj.courseIds) {
            enquiry.courseIds = obj.courseIds;
        }
        if (obj.campusIds) {
            enquiry.campusIds = obj.campusIds;
        }
        if (obj.matrixClassIds) {
            enquiry.matrixClassIds = obj.matrixClassIds;
        }
        if (obj.isInternal) {
            enquiry.isInternal = obj.isInternal;
        }
        if (obj.step) {
            enquiry.step = obj.step;
        }
        if (obj.quickFullName) {
            enquiry.quickFullName = obj.quickFullName;
        }
        if (obj.quickEmail) {
            enquiry.quickEmail = obj.quickEmail;
        }
        if (obj.quickMobile) {
            enquiry.quickMobile = obj.quickMobile;
        }
        if (obj.quickContactType) {
            enquiry.quickContactType = obj.quickContactType;
        }
        if (obj.studentFirstName) {
            enquiry.studentFirstName = obj.studentFirstName;
        }
        if (obj.studentLastName) {
            enquiry.studentLastName = obj.studentLastName;
        }
        if (obj.studentGender != null) {
            enquiry.studentGender = obj.studentGender;
        }
        if (obj.studentPhone) {
            enquiry.studentPhone = obj.studentPhone;
        }
        if (obj.studentDob) {
            enquiry.studentDob = Utilities.makeDate(obj.studentDob);
        }
        if (obj.studentEmail) {
            enquiry.studentEmail = obj.studentEmail;
        }
        if (obj.parentFirstName) {
            enquiry.parentFirstName = obj.parentFirstName;
        }
        if (obj.parentLastName) {
            enquiry.parentLastName = obj.parentLastName;
        }
        if (obj.parentGender != null) {
            enquiry.parentGender = obj.parentGender;
        }
        if (obj.parentPhone) {
            enquiry.parentPhone = obj.parentPhone;
        }
        if (obj.parentEmail) {
            enquiry.parentEmail = obj.parentEmail;
        }
        if (obj.grade) {
            enquiry.grade = obj.grade;
        }
        if (obj.currentGrade) {
            enquiry.currentGrade = obj.currentGrade;
        }
        if (obj.school) {
            enquiry.school = obj.school;
        }
        if (obj.isOnWaitingList) {
            enquiry.isOnWaitingList = obj.isOnWaitingList;
        }
        if (obj.enquiryStatus) {
            enquiry.enquiryStatus = obj.enquiryStatus;
        }
        if (obj.preferredContact) {
            enquiry.preferredContact = obj.preferredContact;
        }
        if (obj.updatedAt) {
            enquiry.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.createdAt) {
            enquiry.createdAt = new Date(obj.createdAt);
        }
        if (obj.errors && Object.keys(obj.errors).length > 0) {
            enquiry.errors = Model.getJsonApiErrors(obj.errors);
        }
        return enquiry;
    };
    Enquiry.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Enquiry;
}(Model));

//# sourceMappingURL=enquiry.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/enquiries.ts

var enquiries_EnquiriesStore = (function () {
    function EnquiriesStore(enquiries, activeEnquiry, editableEnquiry, classes) {
        if (enquiries === void 0) { enquiries = []; }
        if (activeEnquiry === void 0) { activeEnquiry = new enquiry_Enquiry(); }
        if (editableEnquiry === void 0) { editableEnquiry = new enquiry_Enquiry(); }
        if (classes === void 0) { classes = []; }
        this.enquiries = enquiries;
        this.activeEnquiry = activeEnquiry;
        this.editableEnquiry = editableEnquiry;
        this.classes = classes;
    }
    EnquiriesStore.clone = function (store) {
        var result = new this();
        result.enquiries = store.enquiries.slice();
        result.activeEnquiry = store.activeEnquiry;
        result.editableEnquiry = store.editableEnquiry;
        result.classes = store.classes.slice();
        return result;
    };
    return EnquiriesStore;
}());

//# sourceMappingURL=enquiries.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/enquiries.ts


var enquiriesReducer = function (state, action) {
    if (state === void 0) { state = new enquiries_EnquiriesStore(); }
    var activeEnquiry, targetStep;
    var s = enquiries_EnquiriesStore.clone(state);
    switch (action.type) {
        case POPULATE_ENQUIRIES:
            s.enquiries = action.payload.slice();
            return s;
        case ADD_ENQUIRY:
            s.enquiries = action.payload.concat([s.enquiries]);
            s.activeEnquiry = action.payload;
            return s;
        case REPLACE_ENQUIRY:
            var p_1 = action.payload;
            var enquiries = state.enquiries.map(function (e) {
                if (e.id === p_1.id) {
                    return p_1;
                }
                return e;
            });
            var active = state.activeEnquiry.id === p_1.id ? p_1 : enquiry_Enquiry.clone(state.activeEnquiry);
            var editable = state.editableEnquiry.id === p_1.id ? p_1 : enquiry_Enquiry.clone(state.editableEnquiry);
            return new enquiries_EnquiriesStore(enquiries, active, editable, state.classes);
        case POPULATE_ACTIVE_ENQUIRY:
            s.activeEnquiry = action.payload;
            return s;
        case POPULATE_EDITABLE_ENQUIRY:
            s.editableEnquiry = action.payload;
            return s;
        case CREATE_ENQUIRY_FAILURE:
            s.editableEnquiry =
                enquiry_Enquiry.clone(Object.assign({}, state.editableEnquiry, action.payload));
            return s;
        case RESET_ENQUIRY_ERRORS:
            s.editableEnquiry =
                enquiry_Enquiry.clone(Object.assign({}, action.payload, { errors: {} }));
            return s;
        case POPULATE_ENQUIRY_CLASSES:
            s.classes = action.payload;
            return s;
        case ENQUIRY_ACTIVE_INCREMENT_STEP:
            targetStep = state.activeEnquiry.step + 1;
            s.activeEnquiry =
                enquiry_Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: targetStep }));
            return s;
        case ENQUIRY_ACTIVE_DECREMENT_STEP:
            targetStep = state.activeEnquiry.step - 1;
            s.activeEnquiry =
                enquiry_Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: targetStep }));
            return s;
        case ENQUIRY_ACTIVE_GO_TO_STEP:
            s.activeEnquiry =
                enquiry_Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: action.payload }));
            return s;
        default:
            return s;
    }
};
var FETCH_ENQUIRIES = "FETCH_ENQUIRIES";
var FETCH_ENQUIRIES_FAILURE = "FETCH_ENQUIRIES";
var POPULATE_ENQUIRIES = "POPULATE_ENQUIRIES";
var ADD_ENQUIRY = "ADD_ENQUIRY";
var FETCH_ENQUIRY = "FETCH_ENQUIRY";
var FETCH_ENQUIRY_BY_GUID = "FETCH_ENQUIRY_BY_GUID";
var FETCH_ENQUIRY_FAILURE = "FETCH_ENQUIRY_FAILURE";
var POPULATE_ACTIVE_ENQUIRY = "POPULATE_ACTIVE_ENQUIRY";
var POPULATE_EDITABLE_ENQUIRY = "POPULATE_EDITABLE_ENQUIRY";
var REPLACE_ENQUIRY = "REPLACE_ENQUIRY";
var UPDATE_ENQUIRY = "UPDATE_ENQUIRY";
var UPDATE_ENQUIRY_FAILURE = "UPDATE_ENQUIRY_FAILURE";
var CREATE_ENQUIRY = "CREATE_ENQUIRY";
var CREATE_ENQUIRY_FAILURE = "CREATE_ENQUIRY_FAILURE";
var RESET_ENQUIRY_ERRORS = "RESET_ENQUIRY_ERRORS";
var FETCH_ENQUIRY_CLASSES = "FETCH_ENQUIRY_CLASSES";
var POPULATE_ENQUIRY_CLASSES = "POPULATE_ENQUIRY_CLASSES";
var FETCH_ENQUIRY_CLASSES_FAILURE = "FETCH_ENQUIRY_CLASSES_FAILURE";
var ENQUIRY_ACTIVE_INCREMENT_STEP = "ENQUIRY_ACTIVE_INCREMENT_STEP";
var ENQUIRY_ACTIVE_DECREMENT_STEP = "ENQUIRY_ACTIVE_DECREMENT_STEP";
var ENQUIRY_ACTIVE_GO_TO_STEP = "ENQUIRY_ACTIVE_GO_TO_STEP";
var CONVERT_ENQUIRY_TO_CONTACT = "CONVERT_ENQUIRY_TO_CONTACT";
var CONVERTED_ENQUIRY_TO_CONTACT = "CONVERTED_ENQUIRY_TO_CONTACT";
var CONVERT_ENQUIRY_TO_CONTACT_FAILURE = "CONVERT_ENQUIRY_TO_CONTACT_FAILURE";
//# sourceMappingURL=enquiries.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-one.ts



var online_enrolment_step_one_OnlineEnrolmentStepOneComponent = (function () {
    function OnlineEnrolmentStepOneComponent(store, fb) {
        this.store = store;
        this.fb = fb;
        this.coursesForGrade = [];
    }
    OnlineEnrolmentStepOneComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquirySubscription =
            this.store.select("enquiriesReducer").subscribe(function (s) {
                _this.enquiry = s.activeEnquiry;
            });
        this.constantsSubscription =
            this.store.select("constantsReducer").subscribe(function (s) {
                _this.courses = s.constants.courses;
                _this.terms = s.constants.terms;
                _this.setUpcomingTerm();
            });
        this.setupMainForm();
    };
    OnlineEnrolmentStepOneComponent.prototype.setupMainForm = function () {
        var _this = this;
        this.mf = this.fb.group({
            quickFullName: [this.enquiry.quickFullName, [forms_es5["Validators"].required]],
            quickEmail: [this.enquiry.quickEmail, [forms_es5["Validators"].required]],
            quickContactType: [this.enquiry.quickContactType, [forms_es5["Validators"].required]],
            quickMobile: [this.enquiry.quickMobile, [forms_es5["Validators"].required]],
            grade: [this.enquiry.grade, [forms_es5["Validators"].required]],
            courseIds: this.fb.array(this.enquiry.courseIds, forms_es5["Validators"].minLength(1)),
        });
        this.refreshAvailableCourses();
        this.mfSubscription =
            this.mf.valueChanges.subscribe(function (data) {
                _this.updateModel(data);
            });
    };
    OnlineEnrolmentStepOneComponent.prototype.setUpcomingTerm = function () {
        this.upcomingTerm = this.terms.find(function (t) { return t.isOnlineEnrolmentEnabled; });
    };
    OnlineEnrolmentStepOneComponent.prototype.isTypeSelected = function (option) {
        return this.mf.get('quickContactType').value == option;
    };
    OnlineEnrolmentStepOneComponent.prototype.isGradeSelected = function (option) {
        return this.mf.get('grade').value == option;
    };
    OnlineEnrolmentStepOneComponent.prototype.isCourseSelected = function (course) {
        return this.enquiry.courseIds.includes(course.id);
    };
    OnlineEnrolmentStepOneComponent.prototype.clickedTypeOption = function (option) {
        this.mf.patchValue({ quickContactType: option });
    };
    OnlineEnrolmentStepOneComponent.prototype.clickedGradeOption = function (option) {
        this.mf.patchValue({ grade: option });
        this.refreshAvailableCourses();
    };
    OnlineEnrolmentStepOneComponent.prototype.clickedCourse = function (targetCourse) {
        var selectedCourseIds = this.mf.get("courseIds").value;
        var targetCourseIds;
        if (selectedCourseIds.includes(targetCourse.id)) {
            targetCourseIds = selectedCourseIds.filter(function (cId) { return cId != targetCourse.id; });
        }
        else {
            targetCourseIds = selectedCourseIds.slice(0);
            targetCourseIds.push(targetCourse.id);
        }
        this.mf.patchValue({ courseIds: targetCourseIds });
    };
    OnlineEnrolmentStepOneComponent.prototype.refreshAvailableCourses = function () {
        if (this.mf.get("grade").value) {
            var targetGrade_1 = this.mf.get("grade").value;
            this.mf.patchValue({ courseIds: [] });
            this.coursesForGrade =
                this.courses.filter(function (c) { return c.grade == targetGrade_1; });
        }
    };
    OnlineEnrolmentStepOneComponent.prototype.updateModel = function (data) {
        this.enquiry.quickFullName = data.quickFullName;
        this.enquiry.quickEmail = data.quickEmail;
        this.enquiry.quickContactType = data.quickContactType;
        this.enquiry.quickMobile = data.quickMobile;
        this.enquiry.grade = data.grade;
        this.enquiry.courseIds = data.courseIds;
    };
    OnlineEnrolmentStepOneComponent.prototype.submittedForm = function (_a) {
        var value = _a.value, valid = _a.valid;
        this.hasFormBeenSubmitted = true;
        if (this.enquiry.courseIds.length == 0) {
            return;
        }
        if (valid) {
            this.store.dispatch({ type: ENQUIRY_ACTIVE_INCREMENT_STEP });
        }
    };
    OnlineEnrolmentStepOneComponent.prototype.ngOnDestroy = function () {
        this.enquirySubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
        this.mfSubscription.unsubscribe();
    };
    OnlineEnrolmentStepOneComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: forms_es5["FormBuilder"] }]; };
    return OnlineEnrolmentStepOneComponent;
}());

//# sourceMappingURL=online-enrolment-step-one.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-step-one.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_OnlineEnrolmentStepOneComponent = [];
var RenderType_OnlineEnrolmentStepOneComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentStepOneComponent, data: {} });
function View_OnlineEnrolmentStepOneComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter your full name']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a contact email']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter a contact number']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select the grade you\'re interested in']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'li', [['class',
                'oeso__course']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCourse(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 8, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'dt', [['class', 'name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', ''])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'span', [['class', 'price']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](8, null, ['', ''])), core_es5["ɵppd"](9, 4), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['per course, per term']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'oeso__course';
        var currVal_1 = _ck(_v, 2, 0, _co.isCourseSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.name;
        _ck(_v, 5, 0, currVal_2);
        var currVal_3 = core_es5["ɵunv"](_v, 8, 0, _ck(_v, 9, 0, core_es5["ɵnov"](_v.parent.parent, 1), _v.context.$implicit.cost, 'USD', true, '1.2-2'));
        _ck(_v, 8, 0, currVal_3);
    });
}
function View_OnlineEnrolmentStepOneComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'form-error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select at least one course']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'oeso__course-selector-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class', 'oeso__courses-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select the courses you\'re interested in'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'oeso__courses']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_6)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_7)),
        core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.coursesForGrade;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = ((((_co.enquiry.courseIds == null) ? null : _co.enquiry.courseIds.length) == 0) && _co.hasFormBeenSubmitted);
        _ck(_v, 7, 0, currVal_1);
    }, null);
}
function View_OnlineEnrolmentStepOneComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'oeso__terms']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['By clicking Next, you agree to the terms of our '])), (_l()(),
            core_es5["ɵeld"](3, 0, null, null, 1, 'a', [['href', 'https://www.matrix.edu.au/privacy-policy/'],
                ['target', '_blank']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Privacy Policy'])),
        (_l()(), core_es5["ɵted"](-1, null, ['.']))], null, null);
}
function View_OnlineEnrolmentStepOneComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](2, 0, null, null, 118, 'div', [['class',
                'online-enrolment-step-one']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 117, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.submittedForm(_co.mf) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](5, 540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]),
        core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 109, 'div', [['class', 'oeso__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 7, 'p', [['class', 'oeso__blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['For enrolment in '])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](12, null, ['', ''])), (_l()(), core_es5["ɵted"](-1, null, [', commencing '])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](15, null, ['', ''])), core_es5["ɵppd"](16, 2),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 100, 'div', [['class', 'oeso__inner-content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 62, 'div', [['class', 'oeso__quick-contact-form-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 61, 'div', [['class', 'oeso__quick-contact-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        core_es5["ɵdid"](22, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](23, { 'error': 0 }), (_l()(), core_es5["ɵeld"](24, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](25, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Your name'])), (_l()(),
            core_es5["ɵeld"](27, 0, null, null, 5, 'input', [['formControlName', 'quickFullName'],
                ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
                [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                if (('input' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 28)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 28).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (core_es5["ɵnov"](_v, 28)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (core_es5["ɵnov"](_v, 28)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](28, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](30, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](32, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_1)), core_es5["ɵdid"](34, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](35, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](36, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](37, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](38, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](40, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Your email'])), (_l()(), core_es5["ɵeld"](42, 0, null, null, 5, 'input', [['formControlName', 'quickEmail'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 43)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 43).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 43)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 43)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](43, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](45, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](47, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_2)), core_es5["ɵdid"](49, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](50, 0, null, null, 16, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](51, 0, null, null, 15, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](52, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](53, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](54, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](55, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Your mobile'])), (_l()(), core_es5["ɵeld"](57, 0, null, null, 7, 'input', [['formControlName', 'quickMobile'], ['pattern', '[0-9]*'], ['type',
                'text']], [[1, 'pattern', 0], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](58, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](59, 540672, null, 0, forms_es5["PatternValidator"], [], { pattern: [0, 'pattern'] }, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALIDATORS"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["PatternValidator"]]), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](62, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [2, forms_es5["NG_VALIDATORS"]], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](64, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_3)), core_es5["ɵdid"](66, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](67, 0, null, null, 13, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](68, 0, null, null, 12, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](69, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](70, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['You are the...'])), (_l()(),
            core_es5["ɵeld"](72, 0, null, null, 8, 'div', [['class', 'oeso__type-picker-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](73, 0, null, null, 3, 'div', [['class', 'oeso__type-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTypeOption('parent') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](74, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](75, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['...parent'])), (_l()(), core_es5["ɵeld"](77, 0, null, null, 3, 'div', [['class', 'oeso__type-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTypeOption('student') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](78, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](79, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['...student'])), (_l()(), core_es5["ɵeld"](81, 0, null, null, 36, 'div', [['class', 'oeso__grade-and-course-picker-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](82, 0, null, null, 31, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](83, 0, null, null, 30, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](84, 0, null, null, 29, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](85, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select your 2018 grade'])), (_l()(), core_es5["ɵeld"](87, 0, null, null, 24, 'div', [['class', 'oeso__grade-picker']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](88, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(7) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](89, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](90, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 7'])), (_l()(), core_es5["ɵeld"](92, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(8) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](93, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](94, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 8'])), (_l()(), core_es5["ɵeld"](96, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(9) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](97, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](98, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 9'])), (_l()(), core_es5["ɵeld"](100, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(10) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](101, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](102, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 10'])), (_l()(), core_es5["ɵeld"](104, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(11) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](105, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](106, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 11'])), (_l()(), core_es5["ɵeld"](108, 0, null, null, 3, 'div', [['class', 'oeso__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(12) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](109, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](110, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 12'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_4)), core_es5["ɵdid"](113, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_5)), core_es5["ɵdid"](115, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepOneComponent_8)), core_es5["ɵdid"](117, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](118, 0, null, null, 2, 'div', [['class', 'oeso__actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](119, 0, null, null, 1, 'button', [['class', 'oeso__btn-next'],
            ['type', 'submit']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Next']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.mf;
        _ck(_v, 5, 0, currVal_7);
        var currVal_10 = 'input-group full';
        var currVal_11 = _ck(_v, 23, 0, (_co.mf.get('quickFullName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 22, 0, currVal_10, currVal_11);
        var currVal_19 = 'quickFullName';
        _ck(_v, 30, 0, currVal_19);
        var currVal_20 = (_co.mf.get('quickFullName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 34, 0, currVal_20);
        var currVal_21 = 'input-group full';
        var currVal_22 = _ck(_v, 38, 0, (_co.mf.get('quickEmail').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 37, 0, currVal_21, currVal_22);
        var currVal_30 = 'quickEmail';
        _ck(_v, 45, 0, currVal_30);
        var currVal_31 = (_co.mf.get('quickEmail').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 49, 0, currVal_31);
        var currVal_32 = 'input-group full';
        var currVal_33 = _ck(_v, 53, 0, (_co.mf.get('quickMobile').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 52, 0, currVal_32, currVal_33);
        var currVal_42 = '[0-9]*';
        _ck(_v, 59, 0, currVal_42);
        var currVal_43 = 'quickMobile';
        _ck(_v, 62, 0, currVal_43);
        var currVal_44 = (_co.mf.get('quickMobile').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 66, 0, currVal_44);
        var currVal_45 = 'oeso__type-picker-option';
        var currVal_46 = _ck(_v, 75, 0, _co.isTypeSelected('parent'));
        _ck(_v, 74, 0, currVal_45, currVal_46);
        var currVal_47 = 'oeso__type-picker-option';
        var currVal_48 = _ck(_v, 79, 0, _co.isTypeSelected('student'));
        _ck(_v, 78, 0, currVal_47, currVal_48);
        var currVal_49 = 'oeso__grade-picker-option';
        var currVal_50 = _ck(_v, 90, 0, _co.isGradeSelected(7));
        _ck(_v, 89, 0, currVal_49, currVal_50);
        var currVal_51 = 'oeso__grade-picker-option';
        var currVal_52 = _ck(_v, 94, 0, _co.isGradeSelected(8));
        _ck(_v, 93, 0, currVal_51, currVal_52);
        var currVal_53 = 'oeso__grade-picker-option';
        var currVal_54 = _ck(_v, 98, 0, _co.isGradeSelected(9));
        _ck(_v, 97, 0, currVal_53, currVal_54);
        var currVal_55 = 'oeso__grade-picker-option';
        var currVal_56 = _ck(_v, 102, 0, _co.isGradeSelected(10));
        _ck(_v, 101, 0, currVal_55, currVal_56);
        var currVal_57 = 'oeso__grade-picker-option';
        var currVal_58 = _ck(_v, 106, 0, _co.isGradeSelected(11));
        _ck(_v, 105, 0, currVal_57, currVal_58);
        var currVal_59 = 'oeso__grade-picker-option';
        var currVal_60 = _ck(_v, 110, 0, _co.isGradeSelected(12));
        _ck(_v, 109, 0, currVal_59, currVal_60);
        var currVal_61 = (_co.mf.get('grade').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 113, 0, currVal_61);
        var currVal_62 = (_co.coursesForGrade.length > 0);
        _ck(_v, 115, 0, currVal_62);
        var currVal_63 = (((_co.enquiry.courseIds == null) ? null : _co.enquiry.courseIds.length) > 0);
        _ck(_v, 117, 0, currVal_63);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = _co.upcomingTerm.name;
        _ck(_v, 12, 0, currVal_8);
        var currVal_9 = core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v, 0), _co.upcomingTerm.startDate, 'shortDate'));
        _ck(_v, 15, 0, currVal_9);
        var currVal_12 = core_es5["ɵnov"](_v, 32).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 32).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 32).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 32).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 32).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 32).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 32).ngClassPending;
        _ck(_v, 27, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_23 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_24 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_25 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_26 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_27 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_28 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_29 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 42, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_34 = (core_es5["ɵnov"](_v, 59).pattern ? core_es5["ɵnov"](_v, 59).pattern : null);
        var currVal_35 = core_es5["ɵnov"](_v, 64).ngClassUntouched;
        var currVal_36 = core_es5["ɵnov"](_v, 64).ngClassTouched;
        var currVal_37 = core_es5["ɵnov"](_v, 64).ngClassPristine;
        var currVal_38 = core_es5["ɵnov"](_v, 64).ngClassDirty;
        var currVal_39 = core_es5["ɵnov"](_v, 64).ngClassValid;
        var currVal_40 = core_es5["ɵnov"](_v, 64).ngClassInvalid;
        var currVal_41 = core_es5["ɵnov"](_v, 64).ngClassPending;
        _ck(_v, 57, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
    });
}
function View_OnlineEnrolmentStepOneComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-step-one', [], null, null, null, View_OnlineEnrolmentStepOneComponent_0, RenderType_OnlineEnrolmentStepOneComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_step_one_OnlineEnrolmentStepOneComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentStepOneComponentNgFactory = core_es5["ɵccf"]('online-enrolment-step-one', online_enrolment_step_one_OnlineEnrolmentStepOneComponent, View_OnlineEnrolmentStepOneComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=online-enrolment-step-one.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-two.ts



var online_enrolment_step_two_OnlineEnrolmentStepTwoComponent = (function () {
    function OnlineEnrolmentStepTwoComponent(store, fb) {
        this.store = store;
        this.fb = fb;
        this.upcomingNormalTerm = null;
        this.upcomingHolidayTerm = null;
        this.classes = [];
    }
    OnlineEnrolmentStepTwoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquirySubscription =
            this.store.select("enquiriesReducer").subscribe(function (s) {
                _this.enquiry = s.activeEnquiry;
                _this.classes = s.classes;
            });
        this.constantsSubscription =
            this.store.select("constantsReducer").subscribe(function (s) {
                _this.campuses = s.constants.campuses;
                _this.terms = s.constants.terms;
                _this.setUpcomingTerm();
            });
        this.setupMainForm();
        this.refreshPotentialClasses();
    };
    OnlineEnrolmentStepTwoComponent.prototype.setupMainForm = function () {
        var _this = this;
        this.mf = this.fb.group({
            campusIds: this.fb.array(this.enquiry.campusIds),
            matrixClassIds: this.fb.array(this.enquiry.matrixClassIds),
        });
        this.mfSubscription =
            this.mf.valueChanges.subscribe(function (data) {
                _this.updateModel(data);
            });
    };
    OnlineEnrolmentStepTwoComponent.prototype.setUpcomingTerm = function () {
        this.upcomingNormalTerm = this.terms.find(function (t) {
            return t.isOnlineEnrolmentEnabled && !t.isHoliday;
        });
        this.upcomingHolidayTerm = this.terms.find(function (t) {
            return t.isOnlineEnrolmentEnabled && t.isHoliday;
        });
    };
    OnlineEnrolmentStepTwoComponent.prototype.isCampusSelected = function (campus) {
        return this.mf.get('campusIds').value.includes(campus.id);
    };
    OnlineEnrolmentStepTwoComponent.prototype.clickedCampusOption = function (targetCampus) {
        var selectedCampusIds = this.mf.get("campusIds").value;
        var targetCampusIds;
        if (selectedCampusIds.includes(targetCampus.id)) {
            targetCampusIds = selectedCampusIds.filter(function (cId) { return cId != targetCampus.id; });
        }
        else {
            targetCampusIds = selectedCampusIds.slice(0);
            targetCampusIds.push(targetCampus.id);
        }
        this.mf.setControl("campusIds", this.fb.array(targetCampusIds));
        this.refreshPotentialClasses();
    };
    OnlineEnrolmentStepTwoComponent.prototype.clickedClassOption = function (mc) {
        var selectedMatrixClassIds = this.mf.get("matrixClassIds").value;
        var targetMatrixClassIds;
        if (selectedMatrixClassIds.includes(mc.id)) {
            targetMatrixClassIds = selectedMatrixClassIds.filter(function (mcId) { return mcId != mc.id; });
        }
        else {
            targetMatrixClassIds = selectedMatrixClassIds.slice(0);
            targetMatrixClassIds.push(mc.id);
        }
        this.mf.setControl("matrixClassIds", this.fb.array(targetMatrixClassIds));
    };
    OnlineEnrolmentStepTwoComponent.prototype.clickedPrevious = function () {
        this.store.dispatch({ type: ENQUIRY_ACTIVE_DECREMENT_STEP });
    };
    OnlineEnrolmentStepTwoComponent.prototype.getUniqueCampusIdsFromClasses = function () {
        var campusIds = [];
        this.classes.forEach(function (mc) {
            if (!campusIds.includes(mc.campus.id)) {
                campusIds.push(mc.campus.id);
            }
        });
        return campusIds;
    };
    OnlineEnrolmentStepTwoComponent.prototype.getCampus = function (id) {
        return this.campuses.find(function (c) { return c.id == id; });
    };
    OnlineEnrolmentStepTwoComponent.prototype.getNormalClassesByCampus = function (campusId) {
        return this.classes.filter(function (mc) { return mc.campus.id == campusId && !mc.term.isHoliday; });
    };
    OnlineEnrolmentStepTwoComponent.prototype.getHolidayClassesByCampus = function (campusId) {
        return this.classes.filter(function (mc) { return mc.campus.id == campusId && mc.term.isHoliday; });
    };
    OnlineEnrolmentStepTwoComponent.prototype.areNormalTermClassesAvailable = function () {
        return this.classes.filter(function (mc) { return !mc.term.isHoliday; }).length > 0;
    };
    OnlineEnrolmentStepTwoComponent.prototype.areHolidayTermClassesAvailable = function () {
        return this.classes.filter(function (mc) { return mc.term.isHoliday; }).length > 0;
    };
    OnlineEnrolmentStepTwoComponent.prototype.updateModel = function (data) {
        this.enquiry.campusIds = data.campusIds;
        this.enquiry.matrixClassIds = data.matrixClassIds;
    };
    OnlineEnrolmentStepTwoComponent.prototype.isClassSelected = function (mc) {
        var selectedIds = this.mf.get("matrixClassIds").value;
        return selectedIds.includes(mc.id);
    };
    OnlineEnrolmentStepTwoComponent.prototype.refreshPotentialClasses = function () {
        if (this.enquiry.campusIds.length > 0 && this.enquiry.courseIds.length > 0) {
            var termIds = [];
            if (this.upcomingHolidayTerm) {
                termIds.push(this.upcomingHolidayTerm.id);
            }
            if (this.upcomingNormalTerm) {
                termIds.push(this.upcomingNormalTerm.id);
            }
            var params = {
                termIds: termIds,
                campusIds: this.enquiry.campusIds,
                courseIds: this.enquiry.courseIds,
            };
            this.store.dispatch({ type: FETCH_ENQUIRY_CLASSES, payload: params });
        }
    };
    OnlineEnrolmentStepTwoComponent.prototype.submittedForm = function (_a) {
        var value = _a.value, valid = _a.valid;
        this.hasFormBeenSubmitted = true;
        if (this.enquiry.campusIds.length == 0 ||
            this.enquiry.matrixClassIds.length == 0) {
            return;
        }
        if (valid) {
            this.store.dispatch({ type: ENQUIRY_ACTIVE_INCREMENT_STEP });
        }
    };
    OnlineEnrolmentStepTwoComponent.prototype.ngOnDestroy = function () {
        this.enquirySubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
        this.mfSubscription.unsubscribe();
    };
    OnlineEnrolmentStepTwoComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: forms_es5["FormBuilder"] }]; };
    return OnlineEnrolmentStepTwoComponent;
}());

//# sourceMappingURL=online-enrolment-step-two.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-quick-details.ts


var online_enrolment_quick_details_OnlineEnrolmentQuickDetailsComponent = (function () {
    function OnlineEnrolmentQuickDetailsComponent(store) {
        this.store = store;
        this.classes = [];
        this.upcomingNormalTerm = null;
        this.upcomingHolidayTerm = null;
    }
    OnlineEnrolmentQuickDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquirySubscription =
            this.store.select("enquiriesReducer").subscribe(function (s) {
                _this.enquiry = s.activeEnquiry;
                _this.classes = s.classes;
            });
        this.constantsSubscription =
            this.store.select("constantsReducer").subscribe(function (s) {
                _this.courses = s.constants.courses;
                _this.terms = s.constants.terms;
                _this.setUpcomingTerm();
            });
        this.refreshPotentialClasses();
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.setUpcomingTerm = function () {
        this.upcomingNormalTerm = this.terms.find(function (t) {
            return t.isOnlineEnrolmentEnabled && !t.isHoliday;
        });
        this.upcomingHolidayTerm = this.terms.find(function (t) {
            return t.isOnlineEnrolmentEnabled && t.isHoliday;
        });
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.clickedBack = function () {
        this.store.dispatch({ type: ENQUIRY_ACTIVE_DECREMENT_STEP });
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.getCourses = function () {
        var _this = this;
        return this.courses.filter(function (c) { return _this.enquiry.courseIds.includes(c.id); });
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.getMatrixClasses = function () {
        var _this = this;
        return this.classes.filter(function (c) { return _this.enquiry.matrixClassIds.includes(c.id); });
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.refreshPotentialClasses = function () {
        if (this.enquiry.campusIds.length > 0 && this.enquiry.courseIds.length > 0) {
            var termIds = [];
            if (this.upcomingHolidayTerm) {
                termIds.push(this.upcomingHolidayTerm.id);
            }
            if (this.upcomingNormalTerm) {
                termIds.push(this.upcomingNormalTerm.id);
            }
            var params = {
                termId: termIds,
                campusIds: this.enquiry.campusIds,
                courseIds: this.enquiry.courseIds,
            };
            this.store.dispatch({ type: FETCH_ENQUIRY_CLASSES, payload: params });
        }
    };
    OnlineEnrolmentQuickDetailsComponent.prototype.ngOnDestroy = function () {
        this.enquirySubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
    };
    OnlineEnrolmentQuickDetailsComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }]; };
    return OnlineEnrolmentQuickDetailsComponent;
}());

//# sourceMappingURL=online-enrolment-quick-details.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-quick-details.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_OnlineEnrolmentQuickDetailsComponent = [];
var RenderType_OnlineEnrolmentQuickDetailsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentQuickDetailsComponent, data: {} });
function View_OnlineEnrolmentQuickDetailsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['', ' Grade ', '', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.name;
        var currVal_1 = _v.context.$implicit.grade;
        var currVal_2 = (_v.context.last ? '' : ', ');
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_OnlineEnrolmentQuickDetailsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', ''])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', ' (', ')']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.course.name;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.campus.name;
        var currVal_2 = _v.context.$implicit.getClassTimeDisplay();
        _ck(_v, 3, 0, currVal_1, currVal_2);
    });
}
function View_OnlineEnrolmentQuickDetailsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'li', [['class',
                'oeqd__overview-item classes']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'dl', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](2, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Classes'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'dd', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentQuickDetailsComponent_3)),
        core_es5["ɵdid"](6, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getMatrixClasses();
        _ck(_v, 6, 0, currVal_0);
    }, null);
}
function View_OnlineEnrolmentQuickDetailsComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 35, 'div', [['class',
                'online-enrolment-quick-details']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 34, 'div', [['class', 'oeqd__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Quick contact details'])),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'button', [['class', 'oeqd__btn-back tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Back'])),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 29, 'ul', [['class', 'oeqd__overview-items']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 7, 'li', [['class', 'oeqd__overview-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 6, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Your name '])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 3, 'dd', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](12, null, ['', ''])), (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'span', [['class', 'badge']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](14, null, ['', ''])),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 5, 'li', [['class', 'oeqd__overview-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 4, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](17, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 1, 'dd', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](20, null, ['', ''])), (_l()(), core_es5["ɵeld"](21, 0, null, null, 5, 'li', [['class', 'oeqd__overview-item mobile']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](22, 0, null, null, 4, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](23, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Mobile'])),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 1, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](26, null, ['', ''])), (_l()(), core_es5["ɵeld"](27, 0, null, null, 6, 'li', [['class', 'oeqd__overview-item courses']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](28, 0, null, null, 5, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Interested in...'])),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 2, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentQuickDetailsComponent_1)),
        core_es5["ɵdid"](33, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentQuickDetailsComponent_2)),
        core_es5["ɵdid"](35, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = _co.getCourses();
        _ck(_v, 33, 0, currVal_4);
        var currVal_5 = (_co.enquiry.matrixClassIds.length > 0);
        _ck(_v, 35, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enquiry.quickFullName;
        _ck(_v, 12, 0, currVal_0);
        var currVal_1 = _co.enquiry.quickContactType;
        _ck(_v, 14, 0, currVal_1);
        var currVal_2 = _co.enquiry.quickEmail;
        _ck(_v, 20, 0, currVal_2);
        var currVal_3 = _co.enquiry.quickMobile;
        _ck(_v, 26, 0, currVal_3);
    });
}
function View_OnlineEnrolmentQuickDetailsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-quick-details', [], null, null, null, View_OnlineEnrolmentQuickDetailsComponent_0, RenderType_OnlineEnrolmentQuickDetailsComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_quick_details_OnlineEnrolmentQuickDetailsComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentQuickDetailsComponentNgFactory = core_es5["ɵccf"]('online-enrolment-quick-details', online_enrolment_quick_details_OnlineEnrolmentQuickDetailsComponent, View_OnlineEnrolmentQuickDetailsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=online-enrolment-quick-details.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-step-two.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_OnlineEnrolmentStepTwoComponent = [];
var RenderType_OnlineEnrolmentStepTwoComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentStepTwoComponent, data: {} });
function View_OnlineEnrolmentStepTwoComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'oest__campus']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCampusOption(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'oest__campus';
        var currVal_1 = _ck(_v, 2, 0, _co.isCampusSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.name;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_OnlineEnrolmentStepTwoComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'form-error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select at least one course']))], null, null);
}
function View_OnlineEnrolmentStepTwoComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'label', [['class',
                'oest__term-type-label']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Standard'])), (_l()(), core_es5["ɵted"](-1, null, [' term availability']))], null, null);
}
function View_OnlineEnrolmentStepTwoComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'oest__class-topic']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', ' ']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.topic.name;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OnlineEnrolmentStepTwoComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'li', [['class',
                'oest__class']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClassOption(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'div', [['class', 'oest__class-time']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'div', [['class',
                'oest__class-course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_7)),
        core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'oest__class';
        var currVal_1 = _ck(_v, 2, 0, _co.isClassSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_4 = _v.context.$implicit.topic;
        _ck(_v, 8, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.getClassTimeDisplay();
        _ck(_v, 4, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.course.name;
        _ck(_v, 6, 0, currVal_3);
    });
}
function View_OnlineEnrolmentStepTwoComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'oest__campus-container']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'oest__campus-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'oest__classes']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_6)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getNormalClassesByCampus(_v.context.$implicit);
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getCampus(_v.context.$implicit).name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_OnlineEnrolmentStepTwoComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'li', [['class',
                'oest__class']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClassOption(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'div', [['class', 'oest__class-time']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'div', [['class',
                'oest__class-course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ''])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'div', [['class', 'oest__class-code']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](9, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'oest__class';
        var currVal_1 = _ck(_v, 2, 0, _co.isClassSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.getClassTimeDisplay();
        _ck(_v, 4, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.course.name;
        _ck(_v, 6, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.code;
        _ck(_v, 9, 0, currVal_4);
    });
}
function View_OnlineEnrolmentStepTwoComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'oest__campus-container']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'oest__campus-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'oest__classes']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_10)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getHolidayClassesByCampus(_v.context.$implicit);
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getCampus(_v.context.$implicit).name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_OnlineEnrolmentStepTwoComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['class',
                'oest__term-type holiday']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'label', [['class',
                'oest__term-type-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['For '])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Holiday'])), (_l()(), core_es5["ɵted"](-1, null, [' term, starting '])), (_l()(),
            core_es5["ɵeld"](6, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](7, null, ['', ''])), core_es5["ɵppd"](8, 2), (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'ul', [['class', 'oest__classes-by-campus']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_9)), core_es5["ɵdid"](11, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getUniqueCampusIdsFromClasses();
        _ck(_v, 11, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 7, 0, _ck(_v, 8, 0, core_es5["ɵnov"](_v.parent.parent, 0), _co.upcomingHolidayTerm.startDate, 'shortDate'));
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_OnlineEnrolmentStepTwoComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'form-error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select at least one course']))], null, null);
}
function View_OnlineEnrolmentStepTwoComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 15, 'div', [['class',
                'oest__classes-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h2', [['class',
                'oest__campus-picker-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Are you interested in any of these classes?'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 10, 'div', [['class', 'oest__term-type-wrapper']], null, null, null, null, null)),
        core_es5["ɵdid"](4, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](5, { 'no-normal': 0, 'no-holiday': 1 }), (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'div', [['class', 'oest__term-type normal']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_4)),
        core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'ul', [['class', 'oest__classes-by-campus']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_5)), core_es5["ɵdid"](11, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_8)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_11)), core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'oest__term-type-wrapper';
        var currVal_1 = _ck(_v, 5, 0, !_co.areNormalTermClassesAvailable(), !_co.areHolidayTermClassesAvailable());
        _ck(_v, 4, 0, currVal_0, currVal_1);
        var currVal_2 = _co.areHolidayTermClassesAvailable();
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _co.getUniqueCampusIdsFromClasses();
        _ck(_v, 11, 0, currVal_3);
        var currVal_4 = (_co.upcomingHolidayTerm && _co.areHolidayTermClassesAvailable());
        _ck(_v, 13, 0, currVal_4);
        var currVal_5 = ((((_co.enquiry.matrixClassIds == null) ? null : _co.enquiry.matrixClassIds.length) == 0) && _co.hasFormBeenSubmitted);
        _ck(_v, 15, 0, currVal_5);
    }, null);
}
function View_OnlineEnrolmentStepTwoComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 27, 'div', [['class', 'online-enrolment-step-two']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 26, 'form', [['novalidate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngSubmit'],
            [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.submittedForm(_co.mf) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](4, 540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]),
        core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 16, 'div', [['class', 'oest__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 15, 'div', [['class', 'oest__side-and-main']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'div', [['class', 'oest__side-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'online-enrolment-quick-details', [], null, null, null, View_OnlineEnrolmentQuickDetailsComponent_0, RenderType_OnlineEnrolmentQuickDetailsComponent)), core_es5["ɵdid"](11, 245760, null, 0, online_enrolment_quick_details_OnlineEnrolmentQuickDetailsComponent, [src_store["a" /* Store */]], null, null),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 11, 'div', [['class', 'oest__main-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 6, 'div', [['class', 'oest__campus-picker-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 5, 'div', [['class', 'oest__campus-picker']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'h2', [['class', 'oest__campus-picker-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Which campuses are you interested in?'])),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 2, 'div', [['class', 'oest__campuses']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_1)),
        core_es5["ɵdid"](19, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_2)),
        core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepTwoComponent_3)), core_es5["ɵdid"](23, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](24, 0, null, null, 4, 'div', [['class', 'oest__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](25, 0, null, null, 1, 'button', [['class', 'oest__btn-previous'], ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPrevious() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Previous'])),
        (_l()(), core_es5["ɵeld"](27, 0, null, null, 1, 'button', [['class', 'oest__btn-next'],
            ['type', 'submit']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Next']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.mf;
        _ck(_v, 4, 0, currVal_7);
        _ck(_v, 11, 0);
        var currVal_8 = _co.campuses;
        _ck(_v, 19, 0, currVal_8);
        var currVal_9 = ((((_co.enquiry.campusIds == null) ? null : _co.enquiry.campusIds.length) == 0) && _co.hasFormBeenSubmitted);
        _ck(_v, 21, 0, currVal_9);
        var currVal_10 = (_co.classes.length > 0);
        _ck(_v, 23, 0, currVal_10);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_OnlineEnrolmentStepTwoComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-step-two', [], null, null, null, View_OnlineEnrolmentStepTwoComponent_0, RenderType_OnlineEnrolmentStepTwoComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_step_two_OnlineEnrolmentStepTwoComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentStepTwoComponentNgFactory = core_es5["ɵccf"]('online-enrolment-step-two', online_enrolment_step_two_OnlineEnrolmentStepTwoComponent, View_OnlineEnrolmentStepTwoComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=online-enrolment-step-two.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/helpers.ts

;
var helpers_ConstantsHelpers = (function () {
    function ConstantsHelpers() {
    }
    ConstantsHelpers.prototype.getObject = function (targetValue, constants) {
        return constants.find(function (c) {
            var result;
            if (typeof targetValue === 'object') {
                result = JSON.stringify(targetValue) === JSON.stringify(c.value);
            }
            else {
                result = c.value === targetValue;
            }
            return result;
        });
    };
    ConstantsHelpers.prototype.getPeriodTimesForClass = function (matrixClass) {
        return PERIODS_BY_CAMPUS[matrixClass.day.code][matrixClass.period - 1];
    };
    ConstantsHelpers.prototype.getValue = function (data, title) {
        return data.find(function (d) { return d.title == title; }).value;
    };
    ConstantsHelpers.ctorParameters = function () { return []; };
    return ConstantsHelpers;
}());

//# sourceMappingURL=helpers.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-three.ts






var online_enrolment_step_three_OnlineEnrolmentStepThreeComponent = (function () {
    function OnlineEnrolmentStepThreeComponent(store, fb, completerService, constantsHelpers) {
        this.store = store;
        this.fb = fb;
        this.completerService = completerService;
        this.constantsHelpers = constantsHelpers;
        this.schools = SCHOOLS;
    }
    OnlineEnrolmentStepThreeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquirySubscription =
            this.store.select("enquiriesReducer").subscribe(function (s) {
                _this.enquiry = s.activeEnquiry;
            });
        this.schoolCompleter =
            this.completerService.local(this.schools, "title", "title");
        this.setupMainForm();
    };
    OnlineEnrolmentStepThreeComponent.prototype.setupMainForm = function () {
        var _this = this;
        this.mf = this.fb.group({
            studentFirstName: [this.enquiry.studentFirstName, [forms_es5["Validators"].required]],
            studentLastName: [this.enquiry.studentLastName, [forms_es5["Validators"].required]],
            studentGender: [this.enquiry.studentGender, [forms_es5["Validators"].required]],
            studentPhone: [this.enquiry.studentPhone, [forms_es5["Validators"].required]],
            studentDob: [this.enquiry.studentDob, [forms_es5["Validators"].required]],
            parentFirstName: [this.enquiry.parentFirstName, [forms_es5["Validators"].required]],
            parentLastName: [this.enquiry.parentLastName, [forms_es5["Validators"].required]],
            parentPhone: [this.enquiry.parentPhone, [forms_es5["Validators"].required]],
            parentEmail: [this.enquiry.parentEmail, [forms_es5["Validators"].required]],
            currentGrade: [this.enquiry.currentGrade, [forms_es5["Validators"].required]],
            preferredContact: [this.enquiry.preferredContact, [forms_es5["Validators"].required]],
            school: [this.enquiry.school, [forms_es5["Validators"].required]],
        });
        this.mfSubscription =
            this.mf.valueChanges.subscribe(function (data) {
                _this.updateModel(data);
            });
    };
    OnlineEnrolmentStepThreeComponent.prototype.clickedGenderOption = function (value) {
        this.mf.patchValue({ 'studentGender': value });
    };
    OnlineEnrolmentStepThreeComponent.prototype.clickedGradeOption = function (value) {
        this.mf.patchValue({ 'currentGrade': value });
    };
    OnlineEnrolmentStepThreeComponent.prototype.clickedPreferredContactOption = function (value) {
        this.mf.patchValue({ 'preferredContact': value });
    };
    OnlineEnrolmentStepThreeComponent.prototype.submittedForm = function (_a) {
        var value = _a.value, valid = _a.valid;
        this.hasFormBeenSubmitted = true;
        if (valid) {
            this.store.dispatch({ type: ENQUIRY_ACTIVE_INCREMENT_STEP });
        }
    };
    OnlineEnrolmentStepThreeComponent.prototype.clickedPrevious = function () {
        this.store.dispatch({ type: ENQUIRY_ACTIVE_DECREMENT_STEP });
    };
    OnlineEnrolmentStepThreeComponent.prototype.isGenderSelected = function (value) {
        return this.mf.get("studentGender").value === value;
    };
    OnlineEnrolmentStepThreeComponent.prototype.isGradeSelected = function (value) {
        return this.mf.get('currentGrade').value === value;
    };
    OnlineEnrolmentStepThreeComponent.prototype.isPreferredContactSelected = function (value) {
        return this.mf.get('preferredContact').value === value;
    };
    OnlineEnrolmentStepThreeComponent.prototype.selectedSchool = function (e) {
        if (e && e.originalObject) {
            this.mf.patchValue({ school: e.originalObject.value });
        }
    };
    // TODO: This should all be driven by the reactive form...
    // not by manually updating the model and saving in the parent view...
    OnlineEnrolmentStepThreeComponent.prototype.updateModel = function (data) {
        this.enquiry.studentFirstName = data.studentFirstName;
        this.enquiry.studentLastName = data.studentLastName;
        this.enquiry.studentGender = data.studentGender;
        this.enquiry.studentPhone = data.studentPhone;
        this.enquiry.studentDob = data.studentDob;
        this.enquiry.parentFirstName = data.parentFirstName;
        this.enquiry.parentLastName = data.parentLastName;
        this.enquiry.parentPhone = data.parentPhone;
        this.enquiry.parentEmail = data.parentEmail;
        this.enquiry.currentGrade = data.currentGrade;
        this.enquiry.preferredContact = data.preferredContact;
        this.enquiry.school = data.school;
    };
    OnlineEnrolmentStepThreeComponent.prototype.ngOnDestroy = function () {
        this.enquirySubscription.unsubscribe();
        this.mfSubscription.unsubscribe();
    };
    OnlineEnrolmentStepThreeComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: forms_es5["FormBuilder"] }, { type: ng2_completer["a" /* CompleterService */] }, { type: helpers_ConstantsHelpers }]; };
    return OnlineEnrolmentStepThreeComponent;
}());

//# sourceMappingURL=online-enrolment-step-three.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-date-value-accessor/date-value-accessor.js
var date_value_accessor = __webpack_require__("eH1a");
var date_value_accessor_default = /*#__PURE__*/__webpack_require__.n(date_value_accessor);

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-step-three.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_OnlineEnrolmentStepThreeComponent = [];
var RenderType_OnlineEnrolmentStepThreeComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentStepThreeComponent, data: {} });
function View_OnlineEnrolmentStepThreeComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the parent\'s first name']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the parent\'s last name']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the parent\'s phone']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the parent\'s email']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s first name']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s last name']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s gender']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s phone']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s date of birth']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s current grade']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please enter the student\'s current grade']))], null, null);
}
function View_OnlineEnrolmentStepThreeComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 225, 'div', [['class',
                'online-enrolment-step-three']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 224, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null], [2,
                'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngSubmit'], [null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngSubmit' === en)) {
                var pd_2 = (_co.submittedForm(_co.mf) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](2, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](3, 540672, null, 0, forms_es5["FormGroupDirective"], [[8, null], [8, null]], { form: [0, 'form'] }, { ngSubmit: 'ngSubmit' }),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["FormGroupDirective"]]),
        core_es5["ɵdid"](5, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](6, 0, null, null, 214, 'div', [['class', 'oest__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 213, 'div', [['class', 'oest__side-and-main']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 2, 'div', [['class', 'oest__side-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'online-enrolment-quick-details', [], null, null, null, View_OnlineEnrolmentQuickDetailsComponent_0, RenderType_OnlineEnrolmentQuickDetailsComponent)), core_es5["ɵdid"](10, 245760, null, 0, online_enrolment_quick_details_OnlineEnrolmentQuickDetailsComponent, [src_store["a" /* Store */]], null, null),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 209, 'div', [['class', 'oest__main-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 208, 'div', [['class', 'oest__parent-student-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 76, 'div', [['class', 'oest__parent-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Parent/guardian details'])), (_l()(), core_es5["ɵeld"](16, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](17, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](18, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](19, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](23, 0, null, null, 5, 'input', [['formControlName', 'parentFirstName'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](24, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](26, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](28, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_1)),
        core_es5["ɵdid"](30, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](31, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](33, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](34, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](35, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 5, 'input', [['formControlName', 'parentLastName'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 39)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 39).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 39)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 39)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](39, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](41, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](43, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_2)),
        core_es5["ɵdid"](45, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](46, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](47, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](48, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](49, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](50, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](51, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Phone'])), (_l()(), core_es5["ɵeld"](53, 0, null, null, 5, 'input', [['formControlName', 'parentPhone'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 54)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 54).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 54)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 54)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](54, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](56, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](58, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_3)),
        core_es5["ɵdid"](60, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](61, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](62, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](63, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](64, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](65, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](66, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](68, 0, null, null, 5, 'input', [['formControlName', 'parentEmail'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 69)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 69).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 69)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 69)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](69, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](71, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](73, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_4)),
        core_es5["ɵdid"](75, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](76, 0, null, null, 13, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](77, 0, null, null, 12, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](78, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](79, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Preferred contact'])),
        (_l()(), core_es5["ɵeld"](81, 0, null, null, 8, 'div', [['class', 'oest__preferred-contact-picker-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](82, 0, null, null, 3, 'div', [['class', 'oest__preferred-contact-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPreferredContactOption(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](83, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](84, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Parent'])), (_l()(), core_es5["ɵeld"](86, 0, null, null, 3, 'div', [['class', 'oest__preferred-contact-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPreferredContactOption(0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](87, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](88, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Student'])), (_l()(), core_es5["ɵeld"](90, 0, null, null, 130, 'div', [['class', 'oest__student-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](91, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student details'])), (_l()(), core_es5["ɵeld"](93, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](94, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](95, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](96, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](97, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](98, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](100, 0, null, null, 5, 'input', [['formControlName', 'studentFirstName'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 101)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 101).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 101)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 101)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](101, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](103, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](105, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_5)),
        core_es5["ɵdid"](107, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](108, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](109, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](110, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](111, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](112, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](113, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](115, 0, null, null, 5, 'input', [['formControlName', 'studentLastName'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 116)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 116).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 116)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 116)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](116, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](118, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](120, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_6)),
        core_es5["ɵdid"](122, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](123, 0, null, null, 17, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](124, 0, null, null, 16, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](125, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](126, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](127, 0, null, null, 13, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](128, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Gender'])), (_l()(), core_es5["ɵeld"](130, 0, null, null, 8, 'div', [['class', 'oest__gender-picker-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](131, 0, null, null, 3, 'div', [['class', 'oest__gender-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGenderOption(0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](132, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](133, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Male'])), (_l()(), core_es5["ɵeld"](135, 0, null, null, 3, 'div', [['class', 'oest__gender-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGenderOption(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](136, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](137, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Female'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_7)),
        core_es5["ɵdid"](140, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](141, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](142, 0, null, null, 13, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](143, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](144, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](145, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](146, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Phone'])), (_l()(), core_es5["ɵeld"](148, 0, null, null, 5, 'input', [['formControlName', 'studentPhone'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 149)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 149).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 149)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 149)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](149, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](151, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](153, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_8)),
        core_es5["ɵdid"](155, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](156, 0, null, null, 15, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](157, 0, null, null, 14, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](158, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](159, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](160, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](161, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Date of birth'])), (_l()(), core_es5["ɵeld"](163, 0, null, null, 6, 'input', [['formControlName', 'studentDob'], ['type', 'date'], ['useValueAsDate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 164)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 164).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 164)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 164)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 165).onChange($event.target.valueAsDate) !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 165).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](164, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](165, 16384, null, 0, date_value_accessor["DateValueAccessor"], [core_es5["Renderer"],
            core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], date_value_accessor["DateValueAccessor"]]), core_es5["ɵdid"](167, 671744, null, 0, forms_es5["FormControlName"], [[3, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'] }, null), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["FormControlName"]]), core_es5["ɵdid"](169, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_9)),
        core_es5["ɵdid"](171, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](172, 0, null, null, 34, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](173, 0, null, null, 33, 'div', [['class', 'input-group full']], null, null, null, null, null)), core_es5["ɵdid"](174, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](175, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](176, 0, null, null, 30, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](177, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Current grade at school'])), (_l()(), core_es5["ɵeld"](179, 0, null, null, 25, 'div', [['class', 'oest__grade-picker-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](180, 0, null, null, 24, 'div', [['class', 'oest__grade-picker']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](181, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(7) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](182, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](183, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 7'])), (_l()(), core_es5["ɵeld"](185, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(8) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](186, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](187, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 8'])), (_l()(), core_es5["ɵeld"](189, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(9) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](190, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](191, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 9'])), (_l()(), core_es5["ɵeld"](193, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(10) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](194, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](195, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 10'])), (_l()(), core_es5["ɵeld"](197, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(11) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](198, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](199, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 11'])), (_l()(), core_es5["ɵeld"](201, 0, null, null, 3, 'div', [['class', 'oest__grade-picker-option']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedGradeOption(12) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](202, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](203, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Grade 12'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_10)),
        core_es5["ɵdid"](206, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](207, 0, null, null, 13, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](208, 0, null, null, 12, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](209, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](210, 0, null, null, 1, 'label', [['for', 'school']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Current school'])), (_l()(),
            core_es5["ɵeld"](212, 0, null, null, 6, 'ng2-completer', [['id', 'school'],
                ['name', 'school']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                    null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
                [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                    null]], [[null, 'ngModelChange'], [null,
                    'selected']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('ngModelChange' === en)) {
                    var pd_0 = ((_co.schoolSearchStr = $event) !== false);
                    ad = (pd_0 && ad);
                }
                if (('selected' === en)) {
                    var pd_1 = (_co.selectedSchool($event) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](213, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](215, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'], options: [2, 'options'] }, { update: 'ngModelChange' }), core_es5["ɵpod"](216, { standalone: 0 }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]),
        core_es5["ɵdid"](218, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentStepThreeComponent_11)), core_es5["ɵdid"](220, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](221, 0, null, null, 4, 'div', [['class', 'oest__actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](222, 0, null, null, 1, 'button', [['class', 'oest__btn-next'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPrevious() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Previous'])),
        (_l()(), core_es5["ɵeld"](224, 0, null, null, 1, 'button', [['class', 'oest__btn-submit positive'],
            ['type', 'submit']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Submit']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.mf;
        _ck(_v, 3, 0, currVal_7);
        _ck(_v, 10, 0);
        var currVal_8 = 'input-group full';
        var currVal_9 = _ck(_v, 19, 0, (_co.mf.get('parentFirstName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 18, 0, currVal_8, currVal_9);
        var currVal_17 = 'parentFirstName';
        _ck(_v, 26, 0, currVal_17);
        var currVal_18 = (_co.mf.get('parentFirstName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 30, 0, currVal_18);
        var currVal_19 = 'input-group full';
        var currVal_20 = _ck(_v, 34, 0, (_co.mf.get('parentLastName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 33, 0, currVal_19, currVal_20);
        var currVal_28 = 'parentLastName';
        _ck(_v, 41, 0, currVal_28);
        var currVal_29 = (_co.mf.get('parentLastName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 45, 0, currVal_29);
        var currVal_30 = 'input-group full';
        var currVal_31 = _ck(_v, 49, 0, (_co.mf.get('parentPhone').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 48, 0, currVal_30, currVal_31);
        var currVal_39 = 'parentPhone';
        _ck(_v, 56, 0, currVal_39);
        var currVal_40 = (_co.mf.get('parentPhone').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 60, 0, currVal_40);
        var currVal_41 = 'input-group full';
        var currVal_42 = _ck(_v, 64, 0, (_co.mf.get('parentEmail').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 63, 0, currVal_41, currVal_42);
        var currVal_50 = 'parentEmail';
        _ck(_v, 71, 0, currVal_50);
        var currVal_51 = (_co.mf.get('parentPhone').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 75, 0, currVal_51);
        var currVal_52 = 'oest__preferred-contact-picker-option';
        var currVal_53 = _ck(_v, 84, 0, _co.isPreferredContactSelected(1));
        _ck(_v, 83, 0, currVal_52, currVal_53);
        var currVal_54 = 'oest__preferred-contact-picker-option';
        var currVal_55 = _ck(_v, 88, 0, _co.isPreferredContactSelected(0));
        _ck(_v, 87, 0, currVal_54, currVal_55);
        var currVal_56 = 'input-group full';
        var currVal_57 = _ck(_v, 96, 0, (_co.mf.get('studentFirstName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 95, 0, currVal_56, currVal_57);
        var currVal_65 = 'studentFirstName';
        _ck(_v, 103, 0, currVal_65);
        var currVal_66 = (_co.mf.get('studentFirstName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 107, 0, currVal_66);
        var currVal_67 = 'input-group full';
        var currVal_68 = _ck(_v, 111, 0, (_co.mf.get('studentLastName').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 110, 0, currVal_67, currVal_68);
        var currVal_76 = 'studentLastName';
        _ck(_v, 118, 0, currVal_76);
        var currVal_77 = (_co.mf.get('studentLastName').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 122, 0, currVal_77);
        var currVal_78 = 'input-group full';
        var currVal_79 = _ck(_v, 126, 0, (_co.mf.get('studentGender').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 125, 0, currVal_78, currVal_79);
        var currVal_80 = 'oest__gender-picker-option';
        var currVal_81 = _ck(_v, 133, 0, _co.isGenderSelected(0));
        _ck(_v, 132, 0, currVal_80, currVal_81);
        var currVal_82 = 'oest__gender-picker-option';
        var currVal_83 = _ck(_v, 137, 0, _co.isGenderSelected(1));
        _ck(_v, 136, 0, currVal_82, currVal_83);
        var currVal_84 = (_co.mf.get('studentGender').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 140, 0, currVal_84);
        var currVal_85 = 'input-group full';
        var currVal_86 = _ck(_v, 144, 0, (_co.mf.get('studentPhone').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 143, 0, currVal_85, currVal_86);
        var currVal_94 = 'studentPhone';
        _ck(_v, 151, 0, currVal_94);
        var currVal_95 = (_co.mf.get('studentPhone').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 155, 0, currVal_95);
        var currVal_96 = 'input-group full';
        var currVal_97 = _ck(_v, 159, 0, (_co.mf.get('studentDob').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 158, 0, currVal_96, currVal_97);
        var currVal_105 = 'studentDob';
        _ck(_v, 167, 0, currVal_105);
        var currVal_106 = (_co.mf.get('studentDob').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 171, 0, currVal_106);
        var currVal_107 = 'input-group full';
        var currVal_108 = _ck(_v, 175, 0, (_co.mf.get('currentGrade').hasError('required') && _co.hasFormBeenSubmitted));
        _ck(_v, 174, 0, currVal_107, currVal_108);
        var currVal_109 = 'oest__grade-picker-option';
        var currVal_110 = _ck(_v, 183, 0, _co.isGradeSelected(7));
        _ck(_v, 182, 0, currVal_109, currVal_110);
        var currVal_111 = 'oest__grade-picker-option';
        var currVal_112 = _ck(_v, 187, 0, _co.isGradeSelected(8));
        _ck(_v, 186, 0, currVal_111, currVal_112);
        var currVal_113 = 'oest__grade-picker-option';
        var currVal_114 = _ck(_v, 191, 0, _co.isGradeSelected(9));
        _ck(_v, 190, 0, currVal_113, currVal_114);
        var currVal_115 = 'oest__grade-picker-option';
        var currVal_116 = _ck(_v, 195, 0, _co.isGradeSelected(10));
        _ck(_v, 194, 0, currVal_115, currVal_116);
        var currVal_117 = 'oest__grade-picker-option';
        var currVal_118 = _ck(_v, 199, 0, _co.isGradeSelected(11));
        _ck(_v, 198, 0, currVal_117, currVal_118);
        var currVal_119 = 'oest__grade-picker-option';
        var currVal_120 = _ck(_v, 203, 0, _co.isGradeSelected(12));
        _ck(_v, 202, 0, currVal_119, currVal_120);
        var currVal_121 = (_co.mf.get('currentGrade').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 206, 0, currVal_121);
        var currVal_129 = 0;
        var currVal_130 = true;
        var currVal_131 = (_co.enquiry.school || '');
        var currVal_132 = _co.schoolCompleter;
        _ck(_v, 213, 0, currVal_129, currVal_130, currVal_131, currVal_132);
        var currVal_133 = 'school';
        var currVal_134 = _co.schoolSearchStr;
        var currVal_135 = _ck(_v, 216, 0, true);
        _ck(_v, 215, 0, currVal_133, currVal_134, currVal_135);
        var currVal_136 = (_co.mf.get('currentGrade').hasError('required') && _co.hasFormBeenSubmitted);
        _ck(_v, 220, 0, currVal_136);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_10 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 23, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_21 = core_es5["ɵnov"](_v, 43).ngClassUntouched;
        var currVal_22 = core_es5["ɵnov"](_v, 43).ngClassTouched;
        var currVal_23 = core_es5["ɵnov"](_v, 43).ngClassPristine;
        var currVal_24 = core_es5["ɵnov"](_v, 43).ngClassDirty;
        var currVal_25 = core_es5["ɵnov"](_v, 43).ngClassValid;
        var currVal_26 = core_es5["ɵnov"](_v, 43).ngClassInvalid;
        var currVal_27 = core_es5["ɵnov"](_v, 43).ngClassPending;
        _ck(_v, 38, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_32 = core_es5["ɵnov"](_v, 58).ngClassUntouched;
        var currVal_33 = core_es5["ɵnov"](_v, 58).ngClassTouched;
        var currVal_34 = core_es5["ɵnov"](_v, 58).ngClassPristine;
        var currVal_35 = core_es5["ɵnov"](_v, 58).ngClassDirty;
        var currVal_36 = core_es5["ɵnov"](_v, 58).ngClassValid;
        var currVal_37 = core_es5["ɵnov"](_v, 58).ngClassInvalid;
        var currVal_38 = core_es5["ɵnov"](_v, 58).ngClassPending;
        _ck(_v, 53, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_43 = core_es5["ɵnov"](_v, 73).ngClassUntouched;
        var currVal_44 = core_es5["ɵnov"](_v, 73).ngClassTouched;
        var currVal_45 = core_es5["ɵnov"](_v, 73).ngClassPristine;
        var currVal_46 = core_es5["ɵnov"](_v, 73).ngClassDirty;
        var currVal_47 = core_es5["ɵnov"](_v, 73).ngClassValid;
        var currVal_48 = core_es5["ɵnov"](_v, 73).ngClassInvalid;
        var currVal_49 = core_es5["ɵnov"](_v, 73).ngClassPending;
        _ck(_v, 68, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49);
        var currVal_58 = core_es5["ɵnov"](_v, 105).ngClassUntouched;
        var currVal_59 = core_es5["ɵnov"](_v, 105).ngClassTouched;
        var currVal_60 = core_es5["ɵnov"](_v, 105).ngClassPristine;
        var currVal_61 = core_es5["ɵnov"](_v, 105).ngClassDirty;
        var currVal_62 = core_es5["ɵnov"](_v, 105).ngClassValid;
        var currVal_63 = core_es5["ɵnov"](_v, 105).ngClassInvalid;
        var currVal_64 = core_es5["ɵnov"](_v, 105).ngClassPending;
        _ck(_v, 100, 0, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64);
        var currVal_69 = core_es5["ɵnov"](_v, 120).ngClassUntouched;
        var currVal_70 = core_es5["ɵnov"](_v, 120).ngClassTouched;
        var currVal_71 = core_es5["ɵnov"](_v, 120).ngClassPristine;
        var currVal_72 = core_es5["ɵnov"](_v, 120).ngClassDirty;
        var currVal_73 = core_es5["ɵnov"](_v, 120).ngClassValid;
        var currVal_74 = core_es5["ɵnov"](_v, 120).ngClassInvalid;
        var currVal_75 = core_es5["ɵnov"](_v, 120).ngClassPending;
        _ck(_v, 115, 0, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75);
        var currVal_87 = core_es5["ɵnov"](_v, 153).ngClassUntouched;
        var currVal_88 = core_es5["ɵnov"](_v, 153).ngClassTouched;
        var currVal_89 = core_es5["ɵnov"](_v, 153).ngClassPristine;
        var currVal_90 = core_es5["ɵnov"](_v, 153).ngClassDirty;
        var currVal_91 = core_es5["ɵnov"](_v, 153).ngClassValid;
        var currVal_92 = core_es5["ɵnov"](_v, 153).ngClassInvalid;
        var currVal_93 = core_es5["ɵnov"](_v, 153).ngClassPending;
        _ck(_v, 148, 0, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93);
        var currVal_98 = core_es5["ɵnov"](_v, 169).ngClassUntouched;
        var currVal_99 = core_es5["ɵnov"](_v, 169).ngClassTouched;
        var currVal_100 = core_es5["ɵnov"](_v, 169).ngClassPristine;
        var currVal_101 = core_es5["ɵnov"](_v, 169).ngClassDirty;
        var currVal_102 = core_es5["ɵnov"](_v, 169).ngClassValid;
        var currVal_103 = core_es5["ɵnov"](_v, 169).ngClassInvalid;
        var currVal_104 = core_es5["ɵnov"](_v, 169).ngClassPending;
        _ck(_v, 163, 0, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104);
        var currVal_122 = core_es5["ɵnov"](_v, 218).ngClassUntouched;
        var currVal_123 = core_es5["ɵnov"](_v, 218).ngClassTouched;
        var currVal_124 = core_es5["ɵnov"](_v, 218).ngClassPristine;
        var currVal_125 = core_es5["ɵnov"](_v, 218).ngClassDirty;
        var currVal_126 = core_es5["ɵnov"](_v, 218).ngClassValid;
        var currVal_127 = core_es5["ɵnov"](_v, 218).ngClassInvalid;
        var currVal_128 = core_es5["ɵnov"](_v, 218).ngClassPending;
        _ck(_v, 212, 0, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128);
    });
}
function View_OnlineEnrolmentStepThreeComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-step-three', [], null, null, null, View_OnlineEnrolmentStepThreeComponent_0, RenderType_OnlineEnrolmentStepThreeComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_step_three_OnlineEnrolmentStepThreeComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"], completer_service["a" /* CompleterService */],
            helpers_ConstantsHelpers], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentStepThreeComponentNgFactory = core_es5["ɵccf"]('online-enrolment-step-three', online_enrolment_step_three_OnlineEnrolmentStepThreeComponent, View_OnlineEnrolmentStepThreeComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=online-enrolment-step-three.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-four.ts

var online_enrolment_step_four_OnlineEnrolmentStepFourComponent = (function () {
    function OnlineEnrolmentStepFourComponent(store) {
        this.store = store;
    }
    OnlineEnrolmentStepFourComponent.prototype.ngOnInit = function () {
    };
    OnlineEnrolmentStepFourComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }]; };
    return OnlineEnrolmentStepFourComponent;
}());

//# sourceMappingURL=online-enrolment-step-four.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-step-four.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_OnlineEnrolmentStepFourComponent = [];
var RenderType_OnlineEnrolmentStepFourComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentStepFourComponent, data: {} });
function View_OnlineEnrolmentStepFourComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['class',
                'online-enroment-step-four']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class',
                'oesf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'oesf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Thank you for your submission!'])), (_l()(),
            core_es5["ɵeld"](4, 0, null, null, 7, 'div', [['class', 'oesf__blurb']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 4, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['A confirmation of your enrolment request has been sent to '])),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['emmet.w.rogan@gmail.com'])), (_l()(), core_es5["ɵted"](-1, null, ['.'])), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['A Customer Service Representative will be in contact with you within the next 48 hours. Please check your email for the next steps.']))], null, null);
}
function View_OnlineEnrolmentStepFourComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-step-four', [], null, null, null, View_OnlineEnrolmentStepFourComponent_0, RenderType_OnlineEnrolmentStepFourComponent)), core_es5["ɵdid"](1, 114688, null, 0, online_enrolment_step_four_OnlineEnrolmentStepFourComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentStepFourComponentNgFactory = core_es5["ɵccf"]('online-enrolment-step-four', online_enrolment_step_four_OnlineEnrolmentStepFourComponent, View_OnlineEnrolmentStepFourComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9vbmxpbmUtZW5yb2xtZW50LXN0ZXAtZm91ci5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvb25saW5lLWVucm9sbWVudC1zdGVwLWZvdXIudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvb25saW5lLWVucm9sbWVudC1zdGVwLWZvdXIucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL29ubGluZS1lbnJvbG1lbnQtc3RlcC1mb3VyLnRzLk9ubGluZUVucm9sbWVudFN0ZXBGb3VyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIm9ubGluZS1lbnJvbWVudC1zdGVwLWZvdXJcIj48ZGl2IGNsYXNzPVwib2VzZl9fY29udGVudC13cmFwcGVyXCI+PGgxIGNsYXNzPVwib2VzZl9faGVhZGVyXCI+VGhhbmsgeW91IGZvciB5b3VyIHN1Ym1pc3Npb24hPC9oMT48ZGl2IGNsYXNzPVwib2VzZl9fYmx1cmJcIj48cD5BIGNvbmZpcm1hdGlvbiBvZiB5b3VyIGVucm9sbWVudCByZXF1ZXN0IGhhcyBiZWVuIHNlbnQgdG8gPHNwYW4+ZW1tZXQudy5yb2dhbkBnbWFpbC5jb208L3NwYW4+LjwvcD48cD5BIEN1c3RvbWVyIFNlcnZpY2UgUmVwcmVzZW50YXRpdmUgd2lsbCBiZSBpbiBjb250YWN0IHdpdGggeW91IHdpdGhpbiB0aGUgbmV4dCA0OCBob3Vycy4gUGxlYXNlIGNoZWNrIHlvdXIgZW1haWwgZm9yIHRoZSBuZXh0IHN0ZXBzLjwvcD48L2Rpdj48L2Rpdj48L2Rpdj4iLCI8b25saW5lLWVucm9sbWVudC1zdGVwLWZvdXI+PC9vbmxpbmUtZW5yb2xtZW50LXN0ZXAtZm91cj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUF1QztNQUFBO01BQUEsZ0JBQW1DO01BQUE7TUFBeUIsc0VBQW1DO2lCQUFBO2NBQUE7TUFBeUI7VUFBQSwwREFBRztVQUFBO01BQTBEO1VBQUEsMERBQU07VUFBQSw0Q0FBOEI7VUFBQSxRQUFLO1VBQUE7TUFBRzs7OztvQkNBeFE7TUFBQTtpREFBQSxVQUFBO01BQUE7O1FBQUE7Ozs7OyJ9
//# sourceMappingURL=online-enrolment-step-four.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-timeline.ts

var online_enrolment_timeline_OnlineEnrolmentTimelineComponent = (function () {
    function OnlineEnrolmentTimelineComponent(store) {
        this.store = store;
    }
    OnlineEnrolmentTimelineComponent.prototype.ngOnInit = function () {
    };
    OnlineEnrolmentTimelineComponent.prototype.getBarCompleteStyle = function () {
        var result = {};
        switch (this.enquiry.step) {
            case 1: {
                result = { 'width': '10px' };
                break;
            }
            case 2: {
                result = { 'width': '50%' };
                break;
            }
            case 3: {
                result = { 'width': '100%' };
                break;
            }
        }
        return result;
    };
    OnlineEnrolmentTimelineComponent.prototype.ngOnDestroy = function () {
    };
    OnlineEnrolmentTimelineComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }]; };
    return OnlineEnrolmentTimelineComponent;
}());

//# sourceMappingURL=online-enrolment-timeline.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-timeline.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_OnlineEnrolmentTimelineComponent = [];
var RenderType_OnlineEnrolmentTimelineComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentTimelineComponent, data: {} });
function View_OnlineEnrolmentTimelineComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 12, 'div', [['class',
                'online-enrolment-timeline']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 11, 'div', [['class',
                'oet__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'ul', [['class',
                'oet__line-items']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'li', [['class',
                'oet__line-item one']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Step 1'])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'li', [['class', 'oet__line-item two']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Step 2'])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'li', [['class', 'oet__line-item three']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Step 3'])),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 3, 'div', [['class', 'oet__bar-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'div', [['class', 'oet__bar-total']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'div', [['class', 'oet__bar-complete']], null, null, null, null, null)),
        core_es5["ɵdid"](12, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getBarCompleteStyle();
        _ck(_v, 12, 0, currVal_0);
    }, null);
}
function View_OnlineEnrolmentTimelineComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-timeline', [], null, null, null, View_OnlineEnrolmentTimelineComponent_0, RenderType_OnlineEnrolmentTimelineComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_timeline_OnlineEnrolmentTimelineComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentTimelineComponentNgFactory = core_es5["ɵccf"]('online-enrolment-timeline', online_enrolment_timeline_OnlineEnrolmentTimelineComponent, View_OnlineEnrolmentTimelineComponent_Host_0, { enquiry: 'enquiry' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9vbmxpbmUtZW5yb2xtZW50LXRpbWVsaW5lLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9vbmxpbmUtZW5yb2xtZW50LXRpbWVsaW5lLnRzIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL29ubGluZS1lbnJvbG1lbnQtdGltZWxpbmUucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL29ubGluZS1lbnJvbG1lbnQtdGltZWxpbmUudHMuT25saW5lRW5yb2xtZW50VGltZWxpbmVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwib25saW5lLWVucm9sbWVudC10aW1lbGluZVwiPjxkaXYgY2xhc3M9XCJvZXRfX2NvbnRlbnQtd3JhcHBlclwiPjx1bCBjbGFzcz1cIm9ldF9fbGluZS1pdGVtc1wiPjxsaSBjbGFzcz1cIm9ldF9fbGluZS1pdGVtIG9uZVwiPlN0ZXAgMTwvbGk+PGxpIGNsYXNzPVwib2V0X19saW5lLWl0ZW0gdHdvXCI+U3RlcCAyPC9saT48bGkgY2xhc3M9XCJvZXRfX2xpbmUtaXRlbSB0aHJlZVwiPlN0ZXAgMzwvbGk+PC91bD48ZGl2IGNsYXNzPVwib2V0X19iYXItd3JhcHBlclwiPjxkaXYgY2xhc3M9XCJvZXRfX2Jhci10b3RhbFwiPjxkaXYgY2xhc3M9XCJvZXRfX2Jhci1jb21wbGV0ZVwiIFtuZ1N0eWxlXT1cImdldEJhckNvbXBsZXRlU3R5bGUoKVwiPjwvZGl2PjwvZGl2PjwvZGl2PjwvZGl2PjwvZGl2PiIsIjxvbmxpbmUtZW5yb2xtZW50LXRpbWVsaW5lPjwvb25saW5lLWVucm9sbWVudC10aW1lbGluZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBdUM7TUFBQTtNQUFBLGdCQUFrQztNQUFBO01BQUEsZ0JBQTRCO01BQUE7TUFBQSxnQkFBK0IsOENBQVc7TUFBQTtNQUFBLDBEQUErQjtNQUFBLDJCQUFXO01BQUE7TUFBQSw4QkFBaUM7TUFBZ0I7VUFBQTtNQUE4QjtVQUFBO01BQTRCO1VBQUE7YUFBQTtxQkFBQTs7SUFBK0I7SUFBL0IsWUFBK0IsU0FBL0I7Ozs7b0JDQXBTO01BQUE7aURBQUEsVUFBQTtNQUFBOztRQUFBOzs7OzsifQ==
//# sourceMappingURL=online-enrolment-timeline.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/online-enrolment-view.ts




var online_enrolment_view_OnlineEnrolmentViewComponent = (function () {
    function OnlineEnrolmentViewComponent(store, router, actions) {
        this.store = store;
        this.router = router;
        this.actions = actions;
    }
    OnlineEnrolmentViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userSubscription =
            this.store.select("userReducer").subscribe(function (s) {
                _this.currentUserContact = s.currentUserContact;
            });
        this.enquiriesSubscription =
            this.store.select("enquiriesReducer").subscribe(function (s) {
                _this.enquiry = s.activeEnquiry;
                _this.setupInitialState();
            });
        this.actionsSubscription =
            this.actions
                .ofType(ENQUIRY_ACTIVE_INCREMENT_STEP, ENQUIRY_ACTIVE_DECREMENT_STEP)
                .subscribe(function (a) {
                _this.saveEnquiry();
            });
    };
    OnlineEnrolmentViewComponent.prototype.setupInitialState = function () {
        if (this.enquiry.guid) {
            this.router.navigate(['/online-enrolment'], { queryParams: { guid: this.enquiry.guid } });
        }
    };
    OnlineEnrolmentViewComponent.prototype.saveEnquiry = function () {
        if (!this.enquiry.guid) {
            this.enquiry.guid = this.generateGuid();
            this.router.navigate(['/online-enrolment'], { queryParams: { guid: this.enquiry.guid } });
            this.store.dispatch({ type: CREATE_ENQUIRY, payload: this.enquiry });
        }
        else {
            this.store.dispatch({ type: UPDATE_ENQUIRY, payload: this.enquiry });
        }
    };
    OnlineEnrolmentViewComponent.prototype.ngOnDestroy = function () {
        this.userSubscription.unsubscribe();
        this.enquiriesSubscription.unsubscribe();
        this.actionsSubscription.unsubscribe();
    };
    OnlineEnrolmentViewComponent.prototype.s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    OnlineEnrolmentViewComponent.prototype.generateGuid = function () {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
            this.s4() + '-' + this.s4() + this.s4() + this.s4();
    };
    OnlineEnrolmentViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }, { type: effects["a" /* Actions */] }]; };
    return OnlineEnrolmentViewComponent;
}());

//# sourceMappingURL=online-enrolment-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/online-enrolment-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



















var styles_OnlineEnrolmentViewComponent = [];
var RenderType_OnlineEnrolmentViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_OnlineEnrolmentViewComponent, data: {} });
function View_OnlineEnrolmentViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'oev__page one']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'online-enrolment-step-one', [], null, null, null, View_OnlineEnrolmentStepOneComponent_0, RenderType_OnlineEnrolmentStepOneComponent)), core_es5["ɵdid"](2, 245760, null, 0, online_enrolment_step_one_OnlineEnrolmentStepOneComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_OnlineEnrolmentViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'oev__page two']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'online-enrolment-step-two', [], null, null, null, View_OnlineEnrolmentStepTwoComponent_0, RenderType_OnlineEnrolmentStepTwoComponent)), core_es5["ɵdid"](2, 245760, null, 0, online_enrolment_step_two_OnlineEnrolmentStepTwoComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_OnlineEnrolmentViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'oev__page three']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'online-enrolment-step-three', [], null, null, null, View_OnlineEnrolmentStepThreeComponent_0, RenderType_OnlineEnrolmentStepThreeComponent)), core_es5["ɵdid"](2, 245760, null, 0, online_enrolment_step_three_OnlineEnrolmentStepThreeComponent, [src_store["a" /* Store */], forms_es5["FormBuilder"], completer_service["a" /* CompleterService */],
            helpers_ConstantsHelpers], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_OnlineEnrolmentViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'oev__page three']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'online-enrolment-step-four', [], null, null, null, View_OnlineEnrolmentStepFourComponent_0, RenderType_OnlineEnrolmentStepFourComponent)), core_es5["ɵdid"](2, 114688, null, 0, online_enrolment_step_four_OnlineEnrolmentStepFourComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_OnlineEnrolmentViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 15, 'div', [['class',
                'online-enrolment-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 14, 'div', [['class',
                'oev__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 13, 'div', [['class',
                'oev__inner-content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'div', [['class',
                'oev__timeline-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'online-enrolment-timeline', [], null, null, null, View_OnlineEnrolmentTimelineComponent_0, RenderType_OnlineEnrolmentTimelineComponent)), core_es5["ɵdid"](5, 245760, null, 0, online_enrolment_timeline_OnlineEnrolmentTimelineComponent, [src_store["a" /* Store */]], { enquiry: [0, 'enquiry'] }, null),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 9, 'div', [['class', 'oev__pages-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 8, 'div', [['class', 'oev__pages']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentViewComponent_1)),
        core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentViewComponent_2)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentViewComponent_3)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OnlineEnrolmentViewComponent_4)),
        core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enquiry;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = (_co.enquiry.step == 1);
        _ck(_v, 9, 0, currVal_1);
        var currVal_2 = (_co.enquiry.step == 2);
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = (_co.enquiry.step == 3);
        _ck(_v, 13, 0, currVal_3);
        var currVal_4 = (_co.enquiry.step == 4);
        _ck(_v, 15, 0, currVal_4);
    }, null);
}
function View_OnlineEnrolmentViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'online-enrolment-view', [], null, null, null, View_OnlineEnrolmentViewComponent_0, RenderType_OnlineEnrolmentViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, online_enrolment_view_OnlineEnrolmentViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OnlineEnrolmentViewComponentNgFactory = core_es5["ɵccf"]('online-enrolment-view', online_enrolment_view_OnlineEnrolmentViewComponent, View_OnlineEnrolmentViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=online-enrolment-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/policy-check.directive.ts


var policy_check_directive_PolicyCheckDirective = (function () {
    function PolicyCheckDirective(el, _tokenService) {
        this.el = el;
        this._tokenService = _tokenService;
        this.policies = {};
    }
    PolicyCheckDirective.prototype.ngOnInit = function () {
        if (this._tokenService.currentUserData) {
            this.policies = this._tokenService.currentUserData['policies'];
            if (this.policies[this.policyCheck.name]
                && this.policies[this.policyCheck.name].includes(this.policyCheck.action)) {
                this.el.nativeElement.style.display = 'block';
            }
            else {
                this.el.nativeElement.style.display = 'none';
            }
        }
        else {
            this.el.nativeElement.style.display = 'none';
        }
    };
    PolicyCheckDirective.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return PolicyCheckDirective;
}());

//# sourceMappingURL=policy-check.directive.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/main-navigation.ts


var main_navigation_MainNavigationComponent = (function () {
    function MainNavigationComponent(tokenService, router) {
        this.tokenService = tokenService;
        this.router = router;
    }
    MainNavigationComponent.prototype.clickedSignOut = function () {
        this.tokenService.signOut()
            .subscribe(function () {
            window.location.href = '/';
        });
    };
    MainNavigationComponent.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: router_es5["k" /* Router */] }]; };
    return MainNavigationComponent;
}());

//# sourceMappingURL=main-navigation.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/main-navigation.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_MainNavigationComponent = [];
var RenderType_MainNavigationComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_MainNavigationComponent, data: {} });
function View_MainNavigationComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 67, 'div', [['class',
                'main-navigation']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 66, 'div', [['class',
                'mn__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'div', [['class',
                'mn__logo-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 0, 'img', [['class',
                'mn__logo'], ['src', 'images/logo-red.svg']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 61, 'ul', [['class', 'mn__links']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 6, 'li', [['class',
                'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'a', [['class',
                'mn__link'], ['routerLink', '/'], ['routerLinkActive', 'active']], [[1, 'target', 0],
            [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](7, 671744, [[2, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](8, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 1, { links: 1 }), core_es5["ɵqud"](603979776, 2, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Dashboard'])), (_l()(), core_es5["ɵeld"](12, 0, null, null, 2, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'a', [['class', 'mn__link'], ['href', '/contacts']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Contact'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 2, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'a', [['class', 'mn__link'], ['href', '/enquiries']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enquiries'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 2, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 1, 'a', [['class', 'mn__link'], ['href', '/classes']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Classes'])), (_l()(), core_es5["ɵeld"](21, 0, null, null, 6, 'li', [['class',
                'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](22, 0, null, null, 5, 'a', [['class',
                'mn__link'], ['routerLink', '/workshops'], ['routerLinkActive', 'active']], [[1,
                'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](23, 671744, [[4, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](24, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 3, { links: 1 }), core_es5["ɵqud"](603979776, 4, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Workshops'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 2, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 1, 'a', [['class', 'mn__link'], ['href', '/events']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Events'])), (_l()(), core_es5["ɵeld"](31, 0, null, null, 6, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 5, 'a', [['class', 'mn__link'], ['routerLink', '/calendar'], ['routerLinkActive',
                'active']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 33).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](33, 671744, [[6, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](34, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 5, { links: 1 }), core_es5["ɵqud"](603979776, 6, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Calendar'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 6, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 5, 'a', [['class', 'mn__link'], ['routerLink', '/communications'],
            ['routerLinkActive', 'active']], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 40).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](40, 671744, [[8, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](41, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 7, { links: 1 }), core_es5["ɵqud"](603979776, 8, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Communications'])), (_l()(), core_es5["ɵeld"](45, 0, null, null, 2, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](46, 0, null, null, 1, 'a', [['class', 'mn__link'], ['href', '/transactions']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Transactions'])), (_l()(), core_es5["ɵeld"](48, 0, null, null, 8, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), core_es5["ɵdid"](49, 81920, null, 0, policy_check_directive_PolicyCheckDirective, [core_es5["ElementRef"], angular2_token_es5["a" /* Angular2TokenService */]], { policyCheck: [0, 'policyCheck'] }, null), core_es5["ɵpod"](50, { name: 0, action: 1 }), (_l()(), core_es5["ɵeld"](51, 0, null, null, 5, 'a', [['class', 'mn__link'], ['routerLink', '/roles'], ['routerLinkActive',
                'active']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 52).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](52, 671744, [[10, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](53, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 9, { links: 1 }), core_es5["ɵqud"](603979776, 10, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Roles'])), (_l()(), core_es5["ɵeld"](57, 0, null, null, 8, 'li', [['class', 'mn__link--wrapper']], null, null, null, null, null)), core_es5["ɵdid"](58, 81920, null, 0, policy_check_directive_PolicyCheckDirective, [core_es5["ElementRef"], angular2_token_es5["a" /* Angular2TokenService */]], { policyCheck: [0,
                'policyCheck'] }, null), core_es5["ɵpod"](59, { name: 0, action: 1 }), (_l()(),
            core_es5["ɵeld"](60, 0, null, null, 5, 'a', [['class', 'mn__link'], ['routerLink',
                    '/admin-area'], ['routerLinkActive', 'active']], [[1, 'target', 0], [8, 'href',
                    4]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 61).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](61, 671744, [[12, 4]], 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵdid"](62, 1720320, null, 2, router_es5["m" /* RouterLinkActive */], [router_es5["k" /* Router */],
            core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"]], { routerLinkActive: [0, 'routerLinkActive'] }, null), core_es5["ɵqud"](603979776, 11, { links: 1 }), core_es5["ɵqud"](603979776, 12, { linksWithHrefs: 1 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Admin area'])), (_l()(), core_es5["ɵeld"](66, 0, null, null, 1, 'a', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSignOut() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Sign out']))], function (_ck, _v) {
        var currVal_2 = '/';
        _ck(_v, 7, 0, currVal_2);
        var currVal_3 = 'active';
        _ck(_v, 8, 0, currVal_3);
        var currVal_6 = '/workshops';
        _ck(_v, 23, 0, currVal_6);
        var currVal_7 = 'active';
        _ck(_v, 24, 0, currVal_7);
        var currVal_10 = '/calendar';
        _ck(_v, 33, 0, currVal_10);
        var currVal_11 = 'active';
        _ck(_v, 34, 0, currVal_11);
        var currVal_14 = '/communications';
        _ck(_v, 40, 0, currVal_14);
        var currVal_15 = 'active';
        _ck(_v, 41, 0, currVal_15);
        var currVal_16 = _ck(_v, 50, 0, 'Settings', 'read');
        _ck(_v, 49, 0, currVal_16);
        var currVal_19 = '/roles';
        _ck(_v, 52, 0, currVal_19);
        var currVal_20 = 'active';
        _ck(_v, 53, 0, currVal_20);
        var currVal_21 = _ck(_v, 59, 0, 'Settings', 'read');
        _ck(_v, 58, 0, currVal_21);
        var currVal_24 = '/admin-area';
        _ck(_v, 61, 0, currVal_24);
        var currVal_25 = 'active';
        _ck(_v, 62, 0, currVal_25);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).target;
        var currVal_1 = core_es5["ɵnov"](_v, 7).href;
        _ck(_v, 6, 0, currVal_0, currVal_1);
        var currVal_4 = core_es5["ɵnov"](_v, 23).target;
        var currVal_5 = core_es5["ɵnov"](_v, 23).href;
        _ck(_v, 22, 0, currVal_4, currVal_5);
        var currVal_8 = core_es5["ɵnov"](_v, 33).target;
        var currVal_9 = core_es5["ɵnov"](_v, 33).href;
        _ck(_v, 32, 0, currVal_8, currVal_9);
        var currVal_12 = core_es5["ɵnov"](_v, 40).target;
        var currVal_13 = core_es5["ɵnov"](_v, 40).href;
        _ck(_v, 39, 0, currVal_12, currVal_13);
        var currVal_17 = core_es5["ɵnov"](_v, 52).target;
        var currVal_18 = core_es5["ɵnov"](_v, 52).href;
        _ck(_v, 51, 0, currVal_17, currVal_18);
        var currVal_22 = core_es5["ɵnov"](_v, 61).target;
        var currVal_23 = core_es5["ɵnov"](_v, 61).href;
        _ck(_v, 60, 0, currVal_22, currVal_23);
    });
}
function View_MainNavigationComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'main-navigation', [], null, null, null, View_MainNavigationComponent_0, RenderType_MainNavigationComponent)), core_es5["ɵdid"](1, 49152, null, 0, main_navigation_MainNavigationComponent, [angular2_token_es5["a" /* Angular2TokenService */], router_es5["k" /* Router */]], null, null)], null, null);
}
var MainNavigationComponentNgFactory = core_es5["ɵccf"]('main-navigation', main_navigation_MainNavigationComponent, View_MainNavigationComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=main-navigation.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/main.ts


var main_MainComponent = (function () {
    function MainComponent(tokenService, router) {
        this.tokenService = tokenService;
        this.router = router;
        this.isSignedIn = this.tokenService.userSignedIn();
    }
    MainComponent.prototype.ngOnInit = function () {
    };
    MainComponent.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: router_es5["k" /* Router */] }]; };
    return MainComponent;
}());

//# sourceMappingURL=main.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/main.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_MainComponent = [];
var RenderType_MainComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_MainComponent, data: {} });
function View_MainComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'main']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 6, 'div', [['class', 'm__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 2, 'div', [['class', 'm__menu']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'main-navigation', [], null, null, null, View_MainNavigationComponent_0, RenderType_MainNavigationComponent)), core_es5["ɵdid"](4, 49152, null, 0, main_navigation_MainNavigationComponent, [angular2_token_es5["a" /* Angular2TokenService */], router_es5["k" /* Router */]], null, null), (_l()(), core_es5["ɵeld"](5, 0, null, null, 2, 'div', [['class',
                'm__content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        core_es5["ɵdid"](7, 212992, null, 0, router_es5["p" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */],
            core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"], [8, null], core_es5["ChangeDetectorRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 7, 0);
    }, null);
}
function View_MainComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'main', [], null, null, null, View_MainComponent_0, RenderType_MainComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, main_MainComponent, [angular2_token_es5["a" /* Angular2TokenService */], router_es5["k" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var MainComponentNgFactory = core_es5["ɵccf"]('main', main_MainComponent, View_MainComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tYWluLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tYWluLnRzIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL21haW4ucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL21haW4udHMuTWFpbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJtYWluXCI+PGRpdiBjbGFzcz1cIm1fX2NvbnRlbnQtd3JhcHBlclwiPjxkaXYgY2xhc3M9XCJtX19tZW51XCI+PG1haW4tbmF2aWdhdGlvbj48L21haW4tbmF2aWdhdGlvbj48L2Rpdj48ZGl2IGNsYXNzPVwibV9fY29udGVudFwiPjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD48L2Rpdj48L2Rpdj48L2Rpdj4iLCI8bWFpbj48L21haW4+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBa0I7VUFBQTtNQUFnQztVQUFBO01BQXFCO1VBQUE7K0NBQUEsVUFBQTtxQ0FBQTtVQUFBLGVBQXlDO1VBQUE7TUFBd0I7VUFBQTthQUFBOzBEQUFBO1VBQUE7SUFBQTs7OztvQkNBeEk7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=main.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/rxjs/Subject.js
var Subject = __webpack_require__("rlar");
var Subject_default = /*#__PURE__*/__webpack_require__.n(Subject);

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/modal.ts

var ModalConfig = (function () {
    function ModalConfig(component, componentInputs) {
        if (componentInputs === void 0) { componentInputs = {}; }
        this.component = component;
        this.componentInputs = componentInputs;
    }
    return ModalConfig;
}());

var modal_ModalService = (function () {
    function ModalService() {
        this.component$ = new Subject["Subject"]();
    }
    ModalService.prototype.showModal = function (input) {
        this.component$.next(input);
    };
    ModalService.prototype.closeModal = function () {
        this.component$.next(null);
    };
    ModalService.ctorParameters = function () { return []; };
    return ModalService;
}());

//# sourceMappingURL=modal.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/enrolment.ts








var enrolment_EnrolmentService = (function () {
    function EnrolmentService(http, actionCableService, store) {
        this.http = http;
        this.actionCableService = actionCableService;
        this.store = store;
        this.enrolmentsUrl = 'enrolments';
    }
    EnrolmentService.prototype.fetchEnrolments = function (params) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        for (var key in params) {
            searchParams.set(key, params[key]);
        }
        return this.http.get(this.enrolmentsUrl, options)
            .map(function (res) {
            return res.json().map(function (e) { return enrolment_Enrolment.clone(e); });
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.prototype.createEnrolment = function (params) {
        return this.http.post(this.enrolmentsUrl, params)
            .map(function (res) { return enrolment_Enrolment.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.prototype.setRollover = function (params) {
        return this.http.patch(this.enrolmentsUrl + "/" + params.enrolment_id + "/set_rollover", { target_action: params.target_action })
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.prototype.rolloverEnrolments = function () {
        return this.http.patch(this.enrolmentsUrl + "/rollover", {})
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.prototype.changeClass = function (params) {
        return this.http.patch(this.enrolmentsUrl + "/" + params.enrolment_id + "/change_class", { matrix_class_id: params.matrix_class_id })
            .map(function (res) { return enrolment_Enrolment.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.prototype.disenrol = function (params) {
        return this.http.patch(this.enrolmentsUrl + "/" + params.enrolment_id + "/disenrol", { refund_amount: params.refund_amount })
            .map(function (res) { return enrolment_Enrolment.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    EnrolmentService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: ActionCableService }, { type: _ngrx_store["f" /* Store */] }]; };
    return EnrolmentService;
}());

//# sourceMappingURL=enrolment.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/matrix-class.ts






var matrix_class_MatrixClassService = (function () {
    function MatrixClassService(http, store) {
        this.http = http;
        this.store = store;
        this.classUrl = 'classes';
        this.teachersUrl = 'teachers';
    }
    MatrixClassService.prototype.index = function (params) {
        if (params === void 0) { params = {}; }
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        for (var key in params) {
            searchParams.set(key, params[key]);
        }
        return this.http.get(this.classUrl, options)
            .map(function (res) {
            return res.json().map(function (c) { return matrix_class_MatrixClass.clone(c); });
        })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.prototype.fetch = function (id) {
        return this.http.get(this.classUrl + "/" + id)
            .map(function (res) { return matrix_class_MatrixClass.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.prototype.teachers = function () {
        return this.http.get(this.teachersUrl)
            .map(function (res) {
            return res.json().map(function (c) { return contact_Contact.clone(c); });
        })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.prototype.create = function (params) {
        return this.http.post(this.classUrl, params)
            .map(function (res) { return matrix_class_MatrixClass.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.prototype.update = function (params) {
        return this.http.put(this.classUrl + "/" + params.id, params)
            .map(function (res) { return matrix_class_MatrixClass.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.prototype.rollover = function (params) {
        var url = this.classUrl + "/rollover/" + params.from_term_id + "/" + params.to_term_id;
        return this.http.get(url)
            .map(function (res) { return res.json().map(function (c) { return matrix_class_MatrixClass.clone(c); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    MatrixClassService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return MatrixClassService;
}());

//# sourceMappingURL=matrix-class.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/enrolment.ts



var enrolment_EnrolmentsStore = (function () {
    function EnrolmentsStore(enrolments, potentialClasses, selectedClass, selectedContact, editableEnrolment, enrolmentsToRollover) {
        if (enrolments === void 0) { enrolments = []; }
        if (potentialClasses === void 0) { potentialClasses = []; }
        if (selectedClass === void 0) { selectedClass = new matrix_class_MatrixClass(); }
        if (selectedContact === void 0) { selectedContact = new contact_Contact(); }
        if (editableEnrolment === void 0) { editableEnrolment = new enrolment_Enrolment(); }
        if (enrolmentsToRollover === void 0) { enrolmentsToRollover = []; }
        this.enrolments = enrolments;
        this.potentialClasses = potentialClasses;
        this.selectedClass = selectedClass;
        this.selectedContact = selectedContact;
        this.editableEnrolment = editableEnrolment;
        this.enrolmentsToRollover = enrolmentsToRollover;
    }
    return EnrolmentsStore;
}());

//# sourceMappingURL=enrolment.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/enrolments.ts

var enrolmentsReducer = function (state, action) {
    if (state === void 0) { state = new enrolment_EnrolmentsStore(); }
    switch (action.type) {
        case POPULATE_ENROLMENTS:
            return new enrolment_EnrolmentsStore(action.payload, state.potentialClasses.slice(), state.selectedClass, state.selectedContact, state.editableEnrolment, state.enrolmentsToRollover.slice());
        case POPULATE_EDITABLE_ENROLMENT:
            return new enrolment_EnrolmentsStore(state.enrolments.slice(), state.potentialClasses.slice(), state.selectedClass, state.selectedContact, action.payload, state.enrolmentsToRollover.slice());
        case POPULATE_POTENTIAL_CLASSES:
            return new enrolment_EnrolmentsStore(state.enrolments.slice(), action.payload, state.selectedClass, state.selectedContact, state.editableEnrolment, state.enrolmentsToRollover.slice());
        case POPULATE_SELECTED_CLASS:
            return new enrolment_EnrolmentsStore(state.enrolments.slice(), state.potentialClasses.slice(), action.payload, state.selectedContact, state.editableEnrolment, state.enrolmentsToRollover.slice());
        case POPULATE_ENROLMENT_SELECTED_CONTACT:
            return new enrolment_EnrolmentsStore(state.enrolments.slice(), state.potentialClasses.slice(), state.selectedClass, action.payload, state.editableEnrolment, state.enrolmentsToRollover.slice());
        case POPULATE_ENROLMENTS_TO_ROLLOVER:
            return new enrolment_EnrolmentsStore(state.enrolments.slice(), state.potentialClasses.slice(), state.selectedClass, state.selectedContact, state.editableEnrolment, action.payload);
        default:
            return state;
    }
};
var FETCH_ENROLMENTS = 'FETCH_ENROLMENTS';
var POPULATE_ENROLMENTS = 'POPULATE_ENROLMENTS';
var FETCH_ENROLMENTS_FAILURE = 'FETCH_ENROLMENTS_FAILURE';
var ADD_ENROLMENT = "ADD_ENROLMENT";
var POPULATE_EDITABLE_ENROLMENT = 'POPULATE_EDITABLE_ENROLMENT';
var FETCH_POTENTIAL_CLASSES = 'FETCH_POTENTIAL_CLASSES';
var POPULATE_POTENTIAL_CLASSES = 'POPULATE_POTENTIAL_CLASSES';
var FETCH_POTENTIAL_CLASSES_FAILURE = 'FETCH_POTENTIAL_CLASSES_FAILURE';
var FETCH_ENROLMENT_SELECTED_CLASS = 'FETCH_ENROLMENT_SELECTED_CLASS';
var POPULATE_SELECTED_CLASS = 'POPULATE_SELECTED_CLASS';
var FETCH_ENROLMENT_SELECTED_CLASS_FAILURE = 'FETCH_ENROLMENT_SELECTED_CLASS_FAILURE';
var FETCH_ENROLMENT_SELECTED_CONTACT = 'FETCH_ENROLMENT_SELECTED_CONTACT';
var POPULATE_ENROLMENT_SELECTED_CONTACT = 'POPULATE_ENROLMENT_SELECTED_CONTACT';
var FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE = 'FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE';
var CREATE_ENROLMENT = "CREATE_ENROLMENT";
var CREATE_ENROLMENT_FAILURE = "CREATE_ENROLMENT_FAILURE";
var FETCH_ENROLMENTS_TO_ROLLOVER = "FETCH_ENROLMENTS_TO_ROLLOVER";
var FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE = "FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE";
var POPULATE_ENROLMENTS_TO_ROLLOVER = "POPULATE_ENROLMENTS_TO_ROLLOVER";
var SET_ROLLOVER = "SET_ROLLOVER";
var SET_ROLLOVER_SUCCESS = "SET_ROLLOVER_SUCCESS";
var SET_ROLLOVER_FAILURE = "SET_ROLLOVER_FAILURE";
var ROLLOVER_ENROLMENTS = "ROLLOVER_ENROLMENTS";
var ROLLOVER_ENROLMENTS_SUCCESS = "ROLLOVER_ENROLMENTS_SUCCESS";
var ROLLOVER_ENROLMENTS_FAILURE = "ROLLOVER_ENROLMENTS_FAILURE";
var CHANGE_CLASS_ON_ENROLMENT = "CHANGE_CLASS_ON_ENROLMENT";
var CHANGE_CLASS_ON_ENROLMENT_SUCCESS = "CHANGE_CLASS_ON_ENROLMENT_SUCCESS";
var CHANGE_CLASS_ON_ENROLMENT_FAILURE = "CHANGE_CLASS_ON_ENROLMENT_FAILURE";
var PERFORM_DISENROLMENT = "PERFORM_DISENROLMENT";
var PERFORM_DISENROLMENT_SUCCESS = "PERFORM_DISENROLMENT_SUCCESS";
var PERFORM_DISENROLMENT_FAILURE = "PERFORM_DISENROLMENT_FAILURE";
//# sourceMappingURL=enrolments.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/enrolment.ts
var enrolment___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var enrolment___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var enrolment_EnrolmentEffects = (function () {
    function EnrolmentEffects(actions, enrolmentService, matrixClassService, contactService) {
        var _this = this;
        this.actions = actions;
        this.enrolmentService = enrolmentService;
        this.matrixClassService = matrixClassService;
        this.contactService = contactService;
        this.fetchEnrolments = this.actions
            .ofType(FETCH_ENROLMENTS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.enrolmentService.fetchEnrolments(params)
            .map(function (enrolments) { return ({ type: POPULATE_ENROLMENTS, payload: enrolments }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_ENROLMENTS_FAILURE, payload: response }); }); })
            .share();
        this.createEnrolment = this.actions
            .ofType(CREATE_ENROLMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (enrolment) { return _this.enrolmentService.createEnrolment(enrolment.serializeForRails())
            .map(function (enrolment) { return ({ type: ADD_ENROLMENT, payload: enrolment }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_ENROLMENT_FAILURE, payload: response }); }); })
            .share();
        this.fetchPotentialClasses = this.actions
            .ofType(FETCH_POTENTIAL_CLASSES)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.matrixClassService.index(params)
            .map(function (matrixClasses) { return ({ type: POPULATE_POTENTIAL_CLASSES, payload: matrixClasses }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_POTENTIAL_CLASSES_FAILURE }); }); })
            .share();
        this.fetchSelctedClass = this.actions
            .ofType(FETCH_ENROLMENT_SELECTED_CLASS)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.matrixClassService.fetch(id)
            .map(function (matrixClass) { return ({ type: POPULATE_SELECTED_CLASS, payload: matrixClass }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ENROLMENT_SELECTED_CLASS_FAILURE }); }); })
            .share();
        this.fetchSelectedContact = this.actions
            .ofType(FETCH_ENROLMENT_SELECTED_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.fetch(id)
            .map(function (contact) { return ({ type: POPULATE_ENROLMENT_SELECTED_CONTACT, payload: contact }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ENROLMENT_SELECTED_CONTACT_FAILURE }); }); })
            .share();
        this.fetchEnrolmentsToRollover = this.actions
            .ofType(FETCH_ENROLMENTS_TO_ROLLOVER)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.enrolmentService.fetchEnrolments(params)
            .map(function (enrolments) { return ({ type: POPULATE_ENROLMENTS_TO_ROLLOVER, payload: enrolments }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ENROLMENTS_TO_ROLLOVER_FAILURE }); }); })
            .share();
        this.setRollover = this.actions
            .ofType(SET_ROLLOVER)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enrolmentService.setRollover(payload)
            .map(function () { return ({ type: SET_ROLLOVER_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: SET_ROLLOVER_FAILURE }); }); })
            .share();
        this.rolloverEnrolments = this.actions
            .ofType(ROLLOVER_ENROLMENTS)
            .switchMap(function () { return _this.enrolmentService.rolloverEnrolments()
            .map(function () { return ({ type: ROLLOVER_ENROLMENTS_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: ROLLOVER_ENROLMENTS_FAILURE }); }); })
            .share();
        this.changeClass = this.actions
            .ofType(CHANGE_CLASS_ON_ENROLMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enrolmentService.changeClass(payload)
            .map(function () { return ({ type: CHANGE_CLASS_ON_ENROLMENT_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: CHANGE_CLASS_ON_ENROLMENT_FAILURE }); }); })
            .share();
        this.disenrol = this.actions
            .ofType(PERFORM_DISENROLMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enrolmentService.disenrol(payload)
            .map(function () { return ({ type: PERFORM_DISENROLMENT_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: PERFORM_DISENROLMENT_FAILURE }); }); })
            .share();
    }
    EnrolmentEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: enrolment_EnrolmentService }, { type: matrix_class_MatrixClassService }, { type: contact_ContactService }]; };
    return EnrolmentEffects;
}());

enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "fetchEnrolments", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "createEnrolment", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "fetchPotentialClasses", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "fetchSelctedClass", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "fetchSelectedContact", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "fetchEnrolmentsToRollover", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "setRollover", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "rolloverEnrolments", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "changeClass", void 0);
enrolment___decorate([
    Object(effects["b" /* Effect */])(),
    enrolment___metadata("design:type", Object)
], enrolment_EnrolmentEffects.prototype, "disenrol", void 0);
//# sourceMappingURL=enrolment.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/enrolment-form.ts







var enrolment_form_EnrolmentFormComponent = (function () {
    function EnrolmentFormComponent(router, store, modalService, enrolmentEffects) {
        this.router = router;
        this.store = store;
        this.modalService = modalService;
        this.enrolmentEffects = enrolmentEffects;
        this.numOfClassesArray = [];
        this.maxPerCampus = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS;
        var i = 0;
        while (i < NUMBER_OF_CLASSES_PER_TERM) {
            var target = i + 1;
            this.numOfClassesArray.push(target);
            i += 1;
        }
    }
    EnrolmentFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enrolmentsSubscription =
            this.store.select("enrolmentsReducer").subscribe(function (s) {
                _this.enrolment = s.editableEnrolment;
                _this.selectedClass = s.selectedClass;
                _this.selectedContact = s.selectedContact;
            });
        this.setSelectedItems();
    };
    EnrolmentFormComponent.prototype.setSelectedItems = function () {
        this.enrolment.numberOfClasses = this.numOfClassesArray.length; // TODO: Get from backend
        this.startDateInputString = Utilities.getDateInInputStringFormat(new Date());
        this.transactionDateInputString = Utilities.getDateInInputStringFormat(new Date());
    };
    EnrolmentFormComponent.prototype.getMaxEnrolmentsForClass = function (matrixClass) {
        return this.maxPerCampus[matrixClass.campus.code];
    };
    EnrolmentFormComponent.prototype.getStyleForSliderPoint = function (i) {
        return { 'left': 100 / (this.numOfClassesArray.length - 1) * i + "%" };
    };
    EnrolmentFormComponent.prototype.getStyleForSliderBarHighlight = function () {
        return { 'width': 100 / (this.numOfClassesArray.length - 1) * (this.enrolment.numberOfClasses - 1) + "%" };
    };
    EnrolmentFormComponent.prototype.clickedSliderPoint = function (i) {
        this.enrolment.numberOfClasses = this.numOfClassesArray.length - i;
    };
    EnrolmentFormComponent.prototype.clickedSubmitForm = function (e) {
        var _this = this;
        this.enrolment.startDate = new Date(this.startDateInputString);
        this.enrolment.transactionDate = new Date(this.transactionDateInputString);
        this.store.dispatch({ type: CREATE_ENROLMENT, payload: this.enrolment });
        this.enrolmentEffects.createEnrolment.take(1).subscribe(function (a) {
            if (a.type === ADD_ENROLMENT) {
                _this.router.navigate(['contacts', _this.selectedContact.id]);
                _this.modalService.closeModal();
            }
        });
    };
    EnrolmentFormComponent.prototype.ngOnDestroy = function () {
        this.enrolmentsSubscription.unsubscribe();
    };
    EnrolmentFormComponent.ctorParameters = function () { return [{ type: router_es5["k" /* Router */] }, { type: _ngrx_store["f" /* Store */] }, { type: modal_ModalService }, { type: enrolment_EnrolmentEffects }]; };
    return EnrolmentFormComponent;
}());

//# sourceMappingURL=enrolment-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/enrolment-timetable-view.ts










var enrolment_timetable_view_EnrolmentTimetableViewComponent = (function () {
    function EnrolmentTimetableViewComponent(store, completerService, enrolmentEffects, modalService, actions) {
        this.store = store;
        this.completerService = completerService;
        this.enrolmentEffects = enrolmentEffects;
        this.modalService = modalService;
        this.actions = actions;
        this.selectedClasses = [];
        this.periodsByCampus = PERIODS_BY_CAMPUS;
        this.maxPerCampus = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS;
        this.loadingPotentialClasses = false;
    }
    EnrolmentTimetableViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.select("contactsReducer").subscribe(function (s) {
            _this.contact = s.activeContact;
        });
        this.store.select("enrolmentsReducer").subscribe(function (s) {
            _this.enrolment = s.editableEnrolment;
            _this.potentialClasses = s.potentialClasses;
        });
        this.store.select("constantsReducer").subscribe(function (s) {
            _this.campuses = s.constants.campuses;
            _this.terms = s.constants.terms;
            _this.days = s.constants.days;
            _this.courses = s.constants.courses;
            _this.setupDays();
            _this.setupCompleters();
        });
        this.setInitialFormValues();
        this.setPotentialClasses();
    };
    EnrolmentTimetableViewComponent.prototype.getPeriodsForDayWithMostPeriods = function () {
        var result = [];
        var campusPeriods = this.periodsByCampus[this.campus.code];
        Object.keys(campusPeriods).map(function (key) {
            var periods = campusPeriods[key];
            if (periods.length > result.length) {
                result = periods;
            }
        });
        return result;
    };
    EnrolmentTimetableViewComponent.prototype.getClassesForDayAndPeriod = function (day, period) {
        var result = [];
        this.potentialClasses.forEach(function (c) {
            if (c.period === period && c.dayId === day.id) {
                result.push(c);
            }
        });
        return result;
    };
    EnrolmentTimetableViewComponent.prototype.getCssClassesForTimetableCell = function (day, period) {
        return {
            'class-cell': true,
            'no-classes': this.getClassesForDayAndPeriod(day, period).length === 0,
            'has-available-enrolments': this.getClassesForDayAndPeriod(day, period).length > 0,
        };
    };
    EnrolmentTimetableViewComponent.prototype.getTimetableDisplayForDayAndPeriod = function (day, period) {
        var result = "";
        var matrixClasses = this.getClassesForDayAndPeriod(day, period);
        if (matrixClasses.length === 0) {
            result = "";
        }
        else if (matrixClasses.length === 1) {
            result = matrixClasses.length + " Class";
        }
        else {
            result = matrixClasses.length + " Classes";
        }
        return result;
    };
    EnrolmentTimetableViewComponent.prototype.getDisplayNameForDayCode = function (code) {
        var hay = [
            { code: "M", display: "Mon" },
            { code: "T", display: "Tue" },
            { code: "W", display: "Wed" },
            { code: "R", display: "Thu" },
            { code: "F", display: "Fri" },
            { code: "S", display: "Sat" },
            { code: "U", display: "Sun" },
            { code: "A", display: "Accel" }
        ];
        return hay.find(function (h) { return h.code == code; }).display;
    };
    EnrolmentTimetableViewComponent.prototype.getRelevantDays = function () {
        var result = [];
        if (this.term.isHoliday) {
            result = this.holidayTermDays;
        }
        else {
            result = this.normalTermDays;
        }
        return result;
    };
    EnrolmentTimetableViewComponent.prototype.setupDays = function () {
        this.holidayTermDays = this.days.filter(function (d) { return d.code == "A"; });
        this.normalTermDays = this.days.filter(function (d) { return d.code != "A"; });
    };
    EnrolmentTimetableViewComponent.prototype.setupCompleters = function () {
        this.campusesCompleter =
            this.completerService.local(this.campuses, "name", "name");
        this.termsCompleter =
            this.completerService.local(this.terms, "name", "name");
        this.coursesCompleter =
            this.completerService.local(this.courses, "name code humanised", "name");
    };
    EnrolmentTimetableViewComponent.prototype.selectedCampus = function (e) {
        if (e) {
            this.campus = e.originalObject;
            this.setPotentialClasses();
        }
    };
    EnrolmentTimetableViewComponent.prototype.selectedTerm = function (e) {
        if (e) {
            this.term = e.originalObject;
            this.setPotentialClasses();
        }
    };
    EnrolmentTimetableViewComponent.prototype.selectedCourse = function (e) {
        if (e) {
            this.course = e.originalObject;
            this.setPotentialClasses();
        }
    };
    EnrolmentTimetableViewComponent.prototype.setPotentialClasses = function () {
        var _this = this;
        var params = {};
        if (this.term) {
            params.termId = this.term.id;
        }
        if (this.campus) {
            params.campusId = this.campus.id;
        }
        if (this.course) {
            params.courseId = this.course.id;
        }
        this.selectedClasses = [];
        this.loadingPotentialClasses = true;
        this.store.dispatch({ type: FETCH_POTENTIAL_CLASSES, payload: params });
        this.enrolmentEffects.fetchPotentialClasses.take(1).subscribe(function (a) {
            if (a.type === POPULATE_POTENTIAL_CLASSES) {
                _this.loadingPotentialClasses = false;
            }
        });
    };
    EnrolmentTimetableViewComponent.prototype.getMaxEnrolmentsForClass = function (matrixClass) {
        return this.maxPerCampus[matrixClass.campus.code];
    };
    EnrolmentTimetableViewComponent.prototype.getStyleForEnrolmentBar = function (matrixClass) {
        var width = matrixClass.enrolments.length / this.getMaxEnrolmentsForClass(matrixClass) * 100;
        if (width > 100) {
            width = 100;
        }
        return { width: width + "%" };
    };
    EnrolmentTimetableViewComponent.prototype.setInitialFormValues = function () {
        this.campus = this.campuses[0];
        this.term = this.terms[0];
    };
    EnrolmentTimetableViewComponent.prototype.clickedClassCell = function (day, period) {
        this.selectedClasses = this.getClassesForDayAndPeriod(day, period);
    };
    EnrolmentTimetableViewComponent.prototype.clickedSelectedClass = function (matrixClass) {
        var _this = this;
        this.enrolment.matrixClassId = matrixClass.id;
        this.enrolment.cost = matrixClass.course.cost;
        this.store.dispatch({ type: POPULATE_EDITABLE_ENROLMENT, payload: this.enrolment });
        this.store.dispatch({ type: FETCH_ENROLMENT_SELECTED_CLASS, payload: this.enrolment.matrixClassId });
        this.store.dispatch({ type: FETCH_ENROLMENT_SELECTED_CONTACT, payload: this.enrolment.contactId });
        var one$ = this.actions.ofType(POPULATE_SELECTED_CLASS);
        var two$ = this.actions.ofType(POPULATE_SELECTED_CLASS);
        Observable["Observable"].zip(one$, two$)
            .take(1)
            .subscribe(function () { return _this.modalService.showModal(new ModalConfig(enrolment_form_EnrolmentFormComponent)); });
    };
    EnrolmentTimetableViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: enrolment_EnrolmentEffects }, { type: modal_ModalService }, { type: effects["a" /* Actions */] }]; };
    return EnrolmentTimetableViewComponent;
}());

//# sourceMappingURL=enrolment-timetable-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/enrolment-timetable-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_EnrolmentTimetableViewComponent = [];
var RenderType_EnrolmentTimetableViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_EnrolmentTimetableViewComponent, data: {} });
function View_EnrolmentTimetableViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getDisplayNameForDayCode(_v.context.$implicit.code);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_EnrolmentTimetableViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'td', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClassCell(_v.context.$implicit, _v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), (_l()(), core_es5["ɵted"](2, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getCssClassesForTimetableCell(_v.context.$implicit, _v.parent.context.index);
        _ck(_v, 1, 0, currVal_0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getTimetableDisplayForDayAndPeriod(_v.context.$implicit, _v.parent.context.index);
        _ck(_v, 2, 0, currVal_1);
    });
}
function View_EnrolmentTimetableViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](1, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, [' ', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_3)), core_es5["ɵdid"](4, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.getRelevantDays();
        _ck(_v, 4, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_EnrolmentTimetableViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'etv__no-selected-classes']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Please select from available classes above']))], null, null);
}
function View_EnrolmentTimetableViewComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'etv__selected-class content']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSelectedClass(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'li', [['class',
                'name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ' (Room ', ', Campus: ', ')'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'li', [['class', 'enrolments']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'div', [['class', 'etv__enrolment-bar-label']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](6, null, ['Enrolments: ', ' / ', ''])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'div', [['class', 'etv__enrolment-bar']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'div', [['class', 'etv__enrolment-bar-covered']], null, null, null, null, null)),
        core_es5["ɵdid"](9, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_5 = _co.getStyleForEnrolmentBar(_v.context.$implicit);
        _ck(_v, 9, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit.course.humanised;
        var currVal_1 = _v.context.$implicit.room;
        var currVal_2 = _v.context.$implicit.campus.name;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = _v.context.$implicit.enrolments.length;
        var currVal_4 = _co.getMaxEnrolmentsForClass(_v.context.$implicit);
        _ck(_v, 6, 0, currVal_3, currVal_4);
    });
}
function View_EnrolmentTimetableViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'etv__selected-classes-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h2', [['class', 'etv__selected-classes-blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select a class to enrol in'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'div', [['class', 'etv__selected-class header']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 4, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'li', [['class', 'name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Class details'])), (_l()(),
            core_es5["ɵeld"](7, 0, null, null, 1, 'li', [['class', 'enrolments']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enrolments'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_6)), core_es5["ɵdid"](10, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedClasses;
        _ck(_v, 10, 0, currVal_0);
    }, null);
}
function View_EnrolmentTimetableViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 54, 'div', [['class',
                'enrolment-timetable-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class',
                'etv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['Add enrolment for: ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 51, 'div', [['class', 'etv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 35, 'form', [['novalidate', '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 30, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 9, 'div', [['class', 'input-group campus']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 5, 'ng2-completer', [['id', 'campus'], ['name', 'campus']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.campusesSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCampus($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](13, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](15, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](17, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](18, 0, null, null, 1, 'label', [['for', 'campus']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select campus'])), (_l()(), core_es5["ɵeld"](20, 0, null, null, 9, 'div', [['class', 'input-group term']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](21, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](22, 0, null, null, 5, 'ng2-completer', [['id', 'term'], ['name', 'term']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTerm($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](23, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](25, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](27, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](28, 0, null, null, 1, 'label', [['for', 'term']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select term'])), (_l()(), core_es5["ɵeld"](30, 0, null, null, 9, 'div', [['class', 'input-group course']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 5, 'ng2-completer', [['id', 'course'], ['name', 'course']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.coursesStrSearch = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCourse($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](33, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](35, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](37, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](38, 0, null, null, 1, 'label', [['for', 'course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select course'])), (_l()(), core_es5["ɵeld"](40, 0, null, null, 10, 'div', [['class', 'etv__timetable-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](41, 0, null, null, 9, 'table', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 5, 'thead', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](43, 0, null, null, 4, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](44, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Period'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_1)), core_es5["ɵdid"](47, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](48, 0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_2)), core_es5["ɵdid"](50, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_4)), core_es5["ɵdid"](52, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentTimetableViewComponent_5)), core_es5["ɵdid"](54, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_15 = 0;
        var currVal_16 = true;
        var currVal_17 = _co.campus;
        var currVal_18 = _co.campusesCompleter;
        _ck(_v, 13, 0, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_19 = 'campus';
        var currVal_20 = _co.campusesSearchStr;
        _ck(_v, 15, 0, currVal_19, currVal_20);
        var currVal_28 = 0;
        var currVal_29 = true;
        var currVal_30 = _co.term;
        var currVal_31 = _co.termsCompleter;
        _ck(_v, 23, 0, currVal_28, currVal_29, currVal_30, currVal_31);
        var currVal_32 = 'term';
        var currVal_33 = _co.termSearchStr;
        _ck(_v, 25, 0, currVal_32, currVal_33);
        var currVal_41 = 0;
        var currVal_42 = true;
        var currVal_43 = _co.coursesCompleter;
        _ck(_v, 33, 0, currVal_41, currVal_42, currVal_43);
        var currVal_44 = 'course';
        var currVal_45 = _co.coursesStrSearch;
        _ck(_v, 35, 0, currVal_44, currVal_45);
        var currVal_46 = _co.getRelevantDays();
        _ck(_v, 47, 0, currVal_46);
        var currVal_47 = _co.getPeriodsForDayWithMostPeriods();
        _ck(_v, 50, 0, currVal_47);
        var currVal_48 = (_co.selectedClasses.length == 0);
        _ck(_v, 52, 0, currVal_48);
        var currVal_49 = (_co.selectedClasses.length > 0);
        _ck(_v, 54, 0, currVal_49);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_8 = core_es5["ɵnov"](_v, 17).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 17).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 17).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 17).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 17).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 17).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 17).ngClassPending;
        _ck(_v, 12, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
        var currVal_21 = core_es5["ɵnov"](_v, 27).ngClassUntouched;
        var currVal_22 = core_es5["ɵnov"](_v, 27).ngClassTouched;
        var currVal_23 = core_es5["ɵnov"](_v, 27).ngClassPristine;
        var currVal_24 = core_es5["ɵnov"](_v, 27).ngClassDirty;
        var currVal_25 = core_es5["ɵnov"](_v, 27).ngClassValid;
        var currVal_26 = core_es5["ɵnov"](_v, 27).ngClassInvalid;
        var currVal_27 = core_es5["ɵnov"](_v, 27).ngClassPending;
        _ck(_v, 22, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_34 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_35 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_36 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_37 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_38 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_39 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_40 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 32, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40);
    });
}
function View_EnrolmentTimetableViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'enrolment-timetable-view', [], null, null, null, View_EnrolmentTimetableViewComponent_0, RenderType_EnrolmentTimetableViewComponent)), core_es5["ɵdid"](1, 114688, null, 0, enrolment_timetable_view_EnrolmentTimetableViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], enrolment_EnrolmentEffects,
            modal_ModalService, src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var EnrolmentTimetableViewComponentNgFactory = core_es5["ɵccf"]('enrolment-timetable-view', enrolment_timetable_view_EnrolmentTimetableViewComponent, View_EnrolmentTimetableViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=enrolment-timetable-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/booking.ts
var booking___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var booking_Booking = (function (_super) {
    booking___extends(Booking, _super);
    function Booking(id, contactId, windowId, courseId, tutorAllocationId, previousTutorAllocationId, period, date, contact, window, course, tutorAllocation, note, createdAt, updatedAt) {
        if (period === void 0) { period = null; }
        if (date === void 0) { date = null; }
        if (contact === void 0) { contact = null; }
        if (window === void 0) { window = null; }
        if (course === void 0) { course = null; }
        if (tutorAllocation === void 0) { tutorAllocation = null; }
        if (note === void 0) { note = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.contactId = contactId;
        _this.windowId = windowId;
        _this.courseId = courseId;
        _this.tutorAllocationId = tutorAllocationId;
        _this.previousTutorAllocationId = previousTutorAllocationId;
        _this.period = period;
        _this.date = date;
        _this.contact = contact;
        _this.window = window;
        _this.course = course;
        _this.tutorAllocation = tutorAllocation;
        _this.note = note;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Booking.clone = function (obj) {
        var b = new this();
        if (obj.id) {
            b.id = obj.id;
        }
        if (obj.contactId) {
            b.contactId = obj.contactId;
        }
        if (obj.windowId) {
            b.windowId = obj.windowId;
        }
        if (obj.courseId) {
            b.courseId = obj.courseId;
        }
        if (obj.tutorAllocationId) {
            b.tutorAllocationId = obj.tutorAllocationId;
        }
        if (obj.period) {
            b.period = obj.period;
        }
        if (obj.date) {
            b.date = new Date(obj.date);
        }
        if (obj.contact) {
            b.contact = contact_Contact.clone(obj.contact);
        }
        if (obj.window) {
            b.window = window_Window.clone(obj.window);
        }
        if (obj.course) {
            b.course = course_Course.clone(obj.course);
        }
        if (obj.note) {
            b.note = obj.note;
        }
        if (obj.tutorAllocation) {
            b.tutorAllocation = tutor_allocation_TutorAllocation.clone(obj.tutorAllocation);
        }
        if (obj.createdAt) {
            b.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            b.updatedAt = new Date(obj.updatedAt);
        }
        return b;
    };
    Booking.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Booking;
}(Model));

//# sourceMappingURL=booking.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/bookings.ts
var BookingsStore = (function () {
    function BookingsStore(timeslots, editableBooking, editableWorkshopAbsence, affectedBookings, potentialStudents, replacementTutors) {
        if (timeslots === void 0) { timeslots = []; }
        if (editableBooking === void 0) { editableBooking = null; }
        if (editableWorkshopAbsence === void 0) { editableWorkshopAbsence = null; }
        if (affectedBookings === void 0) { affectedBookings = []; }
        if (potentialStudents === void 0) { potentialStudents = []; }
        if (replacementTutors === void 0) { replacementTutors = []; }
        this.timeslots = timeslots;
        this.editableBooking = editableBooking;
        this.editableWorkshopAbsence = editableWorkshopAbsence;
        this.affectedBookings = affectedBookings;
        this.potentialStudents = potentialStudents;
        this.replacementTutors = replacementTutors;
    }
    BookingsStore.clone = function (store) {
        var result = new this();
        result.timeslots = store.timeslots.slice();
        result.editableBooking = store.editableBooking;
        result.editableWorkshopAbsence = store.editableWorkshopAbsence;
        result.affectedBookings = store.affectedBookings.slice();
        result.potentialStudents = store.potentialStudents.slice();
        result.replacementTutors = store.replacementTutors.slice();
        return result;
    };
    return BookingsStore;
}());

//# sourceMappingURL=bookings.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/bookings.ts

var bookingsReducer = function (state, action) {
    if (state === void 0) { state = new BookingsStore(); }
    var s = BookingsStore.clone(state);
    switch (action.type) {
        case POPULATE_TIMESLOTS:
            s.timeslots = action.payload.slice();
            return s;
        case POPULATE_EDITABLE_BOOKING:
            s.editableBooking = action.payload;
            return s;
        case POPULATE_EDITABLE_WORKSHOP_ABSENCE:
            s.editableWorkshopAbsence = action.payload;
            return s;
        case POPULATE_AFFECTED_BOOKINGS:
            s.affectedBookings = action.payload.slice();
            return s;
        case POPULATE_POTENTIAL_BOOKING_STUDENTS:
            s.potentialStudents = action.payload.slice();
            return s;
        case POPULATE_REPLACEMENT_TUTORS:
            s.replacementTutors = action.payload.slice();
            return s;
        default:
            return state;
    }
};
var FETCH_TIMESLOTS = "FETCH_TIMESLOTS";
var FETCH_TIMESLOTS_FAILURE = "FETCH_TIMESLOTS_FAILURE";
var POPULATE_TIMESLOTS = "POPULATE_TIMESLOTS";
var CREATE_BOOKING = "CREATE_BOOKING";
var CREATE_BOOKING_FAILURE = "CREATE_BOOKING_FAILURE";
var ADD_BOOKING = "ADD_BOOKING";
var POPULATE_EDITABLE_BOOKING = "POPULATE_EDITABLE_BOOKING";
var UPDATE_BOOKING = "UPDATE_BOOKING";
var UPDATE_BOOKING_FAILURE = "UPDATE_BOOKING_FAILURE";
var REPLACE_BOOKING = "REPLACE_BOOKING";
var POPULATE_EDITABLE_WORKSHOP_ABSENCE = "POPULATE_EDITABLE_WORKSHOP_ABSENCE";
var FETCH_AFFECTED_BOOKINGS = "FETCH_AFFECTED_BOOKINGS";
var FETCH_AFFECTED_BOOKINGS_FAILURE = "FETCH_AFFECTED_BOOKINGS_FAILURE";
var POPULATE_AFFECTED_BOOKINGS = "POPULATE_AFFECTED_BOOKINGS";
var DELETE_BOOKING = "DELETE_BOOKING";
var DELETE_BOOKING_FAILURE = "DELETE_BOOKING_FAILURE";
var REMOVE_BOOKING = "REMOVE_BOOKING";
var SAME_DAY_CANCEL_BOOKING = "SAME_DAY_CANCEL_BOOKING";
var SAME_DAY_CANCEL_BOOKING_FAILURE = "SAME_DAY_CANCEL_BOOKING_FAILURE";
var FETCH_POTENTIAL_BOOKING_STUDENTS = "FETCH_POTENTIAL_BOOKING_STUDENTS";
var POPULATE_POTENTIAL_BOOKING_STUDENTS = "POPULATE_POTENTIAL_BOOKING_STUDENTS";
var FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE = "FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE";
var FETCH_REPLACEMENT_TUTORS = "FETCH_REPLACEMENT_TUTORS";
var POPULATE_REPLACEMENT_TUTORS = "POPULATE_REPLACEMENT_TUTORS";
var FETCH_REPLACEMENT_TUTORS_FAILURE = "FETCH_REPLACEMENT_TUTORS_FAILURE";
//# sourceMappingURL=bookings.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/booking-form.ts





var booking_form_BookingFormComponent = (function () {
    function BookingFormComponent(store, completerService, actions, modalService) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.modalService = modalService;
        this.mode = "new";
        this.students = [];
        this.courses = [];
    }
    BookingFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.workshopsSubscription =
            this.store.select('workshopsReducer').subscribe(function (s) {
                _this.workshop = s.workshops.find(function (w) { return _this.timeslot.window.workshopId == w.id; });
                _this.courses = _this.workshop.courses;
            });
        this.bookingsSubscription =
            this.store.select('bookingsReducer').subscribe(function (s) {
                _this.booking = s.editableBooking;
                _this.students = s.potentialStudents;
                _this.populateStudentCompleter();
                _this.setupCompletersFromState();
            });
        this.populateStudents();
    };
    BookingFormComponent.prototype.populateCoursesCompleter = function () {
        this.courseCompleter =
            this.completerService.local(this.courses, "subjectCode, name", "name");
    };
    BookingFormComponent.prototype.populateStudentCompleter = function () {
        this.studentCompleter =
            this.completerService.local(this.students, "fullName", "fullName");
    };
    BookingFormComponent.prototype.populateStudents = function () {
        var payload = {
            date: this.timeslot.date,
            period: this.period,
            windowId: this.timeslot.windowId
        };
        this.store.dispatch({ type: FETCH_POTENTIAL_BOOKING_STUDENTS, payload: payload });
    };
    BookingFormComponent.prototype.clickedSave = function () {
        var _this = this;
        this.actions
            .ofType(ADD_BOOKING, REPLACE_BOOKING)
            .take(1)
            .subscribe(function () { _this.modalService.closeModal(); });
        switch (this.mode) {
            case "new": {
                this.store.dispatch({ type: CREATE_BOOKING, payload: this.booking });
                break;
            }
            case "edit": {
                this.store.dispatch({ type: UPDATE_BOOKING, payload: this.booking });
                break;
            }
        }
    };
    BookingFormComponent.prototype.selectedStudent = function (e) {
        if (e && e.originalObject) {
            var contact = e.originalObject;
            this.booking.contact = contact;
            this.booking.contactId = contact.id;
        }
    };
    BookingFormComponent.prototype.selectedCourse = function (e) {
        if (e && e.originalObject) {
            var course = e.originalObject;
            this.booking.course = course;
            this.booking.courseId = course.id;
        }
        else {
            this.booking.course = null;
            this.booking.courseId = null;
        }
    };
    BookingFormComponent.prototype.setupCompletersFromState = function () {
        this.populateCoursesCompleter();
        if (this.booking.contact) {
            this.studentSearchStr = this.booking.contact.fullName;
        }
        if (this.booking.course) {
            this.courseSearchStr = this.booking.course.name;
        }
    };
    BookingFormComponent.prototype.ngOnDestroy = function () {
        this.bookingsSubscription.unsubscribe();
        this.workshopsSubscription.unsubscribe();
    };
    BookingFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }, { type: modal_ModalService }]; };
    return BookingFormComponent;
}());

//# sourceMappingURL=booking-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/timeslot.ts
var timeslot___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var timeslot_Timeslot = (function (_super) {
    timeslot___extends(Timeslot, _super);
    function Timeslot(bookingId, windowId, dayId, status, period, startTime, endTime, date, booking, window, day, tutorAllocation, replacementTutorAllocation) {
        if (status === void 0) { status = ""; }
        if (period === void 0) { period = null; }
        if (startTime === void 0) { startTime = null; }
        if (endTime === void 0) { endTime = null; }
        if (date === void 0) { date = null; }
        if (booking === void 0) { booking = null; }
        if (window === void 0) { window = null; }
        if (day === void 0) { day = null; }
        if (tutorAllocation === void 0) { tutorAllocation = null; }
        if (replacementTutorAllocation === void 0) { replacementTutorAllocation = null; }
        var _this = _super.call(this) || this;
        _this.bookingId = bookingId;
        _this.windowId = windowId;
        _this.dayId = dayId;
        _this.status = status;
        _this.period = period;
        _this.startTime = startTime;
        _this.endTime = endTime;
        _this.date = date;
        _this.booking = booking;
        _this.window = window;
        _this.day = day;
        _this.tutorAllocation = tutorAllocation;
        _this.replacementTutorAllocation = replacementTutorAllocation;
        return _this;
    }
    Timeslot.clone = function (obj) {
        var ts = new this();
        if (obj.bookingId) {
            ts.bookingId = obj.bookingId;
        }
        if (obj.windowId) {
            ts.windowId = obj.windowId;
        }
        if (obj.dayId) {
            ts.dayId = obj.dayId;
        }
        if (obj.status) {
            ts.status = obj.status;
        }
        if (obj.preiod) {
            ts.period = parseInt(obj.period);
        }
        if (obj.startTime) {
            ts.startTime = new Date(obj.startTime);
        }
        if (obj.endTime) {
            ts.endTime = new Date(obj.endTime);
        }
        if (obj.date) {
            ts.date = new Date(obj.date);
        }
        if (obj.booking) {
            ts.booking = booking_Booking.clone(obj.booking);
        }
        if (obj.window) {
            ts.window = window_Window.clone(obj.window);
        }
        if (obj.day) {
            ts.day = Day.clone(obj.day);
        }
        if (obj.tutorAllocation) {
            ts.tutorAllocation =
                tutor_allocation_TutorAllocation.clone(obj.tutorAllocation);
        }
        if (obj.replacementTutorAllocation) {
            ts.replacementTutorAllocation =
                tutor_allocation_TutorAllocation.clone(obj.replacementTutorAllocation);
        }
        return ts;
    };
    return Timeslot;
}(Model));

//# sourceMappingURL=timeslot.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/tutor-timeslots.ts
var tutor_timeslots___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var tutor_timeslots_TutorTimeslots = (function (_super) {
    tutor_timeslots___extends(TutorTimeslots, _super);
    function TutorTimeslots(date, byTutor) {
        if (date === void 0) { date = null; }
        if (byTutor === void 0) { byTutor = null; }
        var _this = _super.call(this) || this;
        _this.date = date;
        _this.byTutor = byTutor;
        return _this;
    }
    TutorTimeslots.clone = function (obj) {
        var t = new this();
        if (obj.date) {
            t.date = new Date(obj.date);
        }
        if (obj.byTutor && obj.byTutor.length > 0) {
            t.byTutor = obj.byTutor.map(function (bt) {
                var timeslotsByTutor = {};
                if (bt.contact) {
                    timeslotsByTutor.contact = contact_Contact.clone(bt.contact);
                }
                if (bt.timeslots && bt.timeslots.length > 0) {
                    timeslotsByTutor.timeslots =
                        bt.timeslots.map(function (t) { return timeslot_Timeslot.clone(t); });
                }
                return timeslotsByTutor;
            });
        }
        return t;
    };
    return TutorTimeslots;
}(Model));

//# sourceMappingURL=tutor-timeslots.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/booking.ts






var booking_BookingService = (function () {
    function BookingService(http) {
        this.http = http;
        this.bookingsUrl = 'bookings';
    }
    BookingService.prototype.create = function (b) {
        return this.http.post(this.bookingsUrl, b.serializeForRails())
            .map(function (res) { return booking_Booking.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.update = function (b) {
        return this.http.put(this.bookingsUrl + "/" + b.id, b.serializeForRails())
            .map(function (res) { return booking_Booking.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.timeslots = function (params) {
        var url = this.bookingsUrl + "/timeslots/" + params.twoWeekBlockIndex + "/" + params.windowId;
        return this.http.get(url)
            .map(function (res) { return res.json().map(function (t) { return tutor_timeslots_TutorTimeslots.clone(t); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.potentialStudents = function (params) {
        var search = new http_es5["k" /* URLSearchParams */]();
        for (var key in params) {
            search.set(key, params[key]);
        }
        return this.http.get(this.bookingsUrl + "/potential_students", { search: search })
            .map(function (res) { return res.json().map(function (c) { return contact_Contact.clone(c); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.affectedBookings = function (params) {
        return this.http.put(this.bookingsUrl + "/affected_bookings", params)
            .map(function (res) { return res.json().map(function (b) { return booking_Booking.clone(b); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.remove = function (params) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        searchParams.set("ban", params.ban.toString());
        return this.http.delete(this.bookingsUrl + "/" + params.booking.id, options)
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.prototype.sameDayCancel = function (bookingId) {
        return this.http.put(this.bookingsUrl + "/" + bookingId + "/same_day_cancel", {})
            .map(function (res) { return booking_Booking.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    BookingService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return BookingService;
}());

//# sourceMappingURL=booking.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/booking.ts
var booking___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var booking___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var booking_BookingEffects = (function () {
    function BookingEffects(actions, bookingService, contactService) {
        var _this = this;
        this.actions = actions;
        this.bookingService = bookingService;
        this.contactService = contactService;
        this.create = this.actions
            .ofType(CREATE_BOOKING)
            .map(function (action) { return action.payload; })
            .switchMap(function (b) { return _this.bookingService.create(b)
            .map(function (b) { return ({ type: ADD_BOOKING, payload: b }); })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_BOOKING_FAILURE }); }); })
            .share();
        this.update = this.actions
            .ofType(UPDATE_BOOKING)
            .map(function (action) { return action.payload; })
            .switchMap(function (b) { return _this.bookingService.update(b)
            .map(function (b) { return ({ type: REPLACE_BOOKING, payload: b }); })
            .catch(function () { return Observable["Observable"].of({ type: UPDATE_BOOKING_FAILURE }); }); })
            .share();
        this.timeslots = this.actions
            .ofType(FETCH_TIMESLOTS)
            .debounceTime(500)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.bookingService.timeslots(params)
            .map(function (ts) { return ({ type: POPULATE_TIMESLOTS, payload: ts }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_TIMESLOTS_FAILURE }); }); })
            .share();
        this.potentialStudents = this.actions
            .ofType(FETCH_POTENTIAL_BOOKING_STUDENTS)
            .debounceTime(300)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.bookingService.potentialStudents(params)
            .map(function (payload) { return ({ type: POPULATE_POTENTIAL_BOOKING_STUDENTS, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE }); }); })
            .share();
        this.replacementTutors = this.actions
            .ofType(FETCH_REPLACEMENT_TUTORS)
            .debounceTime(300)
            .map(function (action) { return action.payload; })
            .switchMap(function () { return _this.contactService.index({ has_tutor_allocation: true })
            .map(function (payload) { return ({ type: POPULATE_REPLACEMENT_TUTORS, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_REPLACEMENT_TUTORS_FAILURE }); }); })
            .share();
        this.affectedBookings = this.actions
            .ofType(FETCH_AFFECTED_BOOKINGS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.bookingService.affectedBookings(params)
            .map(function (bookings) { return ({ type: POPULATE_AFFECTED_BOOKINGS, payload: bookings }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_AFFECTED_BOOKINGS_FAILURE }); }); })
            .share();
        this.remove = this.actions
            .ofType(DELETE_BOOKING)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.bookingService.remove(params)
            .map(function () { return ({ type: REMOVE_BOOKING }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_BOOKING_FAILURE }); }); })
            .share();
        this.sameDayCancel = this.actions
            .ofType(SAME_DAY_CANCEL_BOOKING)
            .map(function (action) { return action.payload; })
            .switchMap(function (bookingId) { return _this.bookingService.sameDayCancel(bookingId)
            .map(function (booking) { return ({ type: REPLACE_BOOKING, payload: booking }); })
            .catch(function () { return Observable["Observable"].of({ type: SAME_DAY_CANCEL_BOOKING_FAILURE }); }); })
            .share();
    }
    BookingEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: booking_BookingService }, { type: contact_ContactService }]; };
    return BookingEffects;
}());

booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "create", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "update", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "timeslots", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "potentialStudents", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "replacementTutors", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "affectedBookings", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "remove", void 0);
booking___decorate([
    Object(effects["b" /* Effect */])(),
    booking___metadata("design:type", Object)
], booking_BookingEffects.prototype, "sameDayCancel", void 0);
//# sourceMappingURL=booking.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/booking-removal-form.ts





var booking_removal_form_BookingRemovalFormComponent = (function () {
    function BookingRemovalFormComponent(store, bookingEffects, modalService) {
        this.store = store;
        this.bookingEffects = bookingEffects;
        this.modalService = modalService;
        this.CLOSE_ACTIONS = [
            REMOVE_BOOKING,
            REPLACE_BOOKING
        ];
    }
    BookingRemovalFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bookingsSubscription = this.store.select("bookingsReducer").subscribe(function (s) {
            _this.booking = s.editableBooking;
        });
        this.setupEffectEvents();
    };
    BookingRemovalFormComponent.prototype.clickedDeleteWithoutBan = function () {
        var params = {
            ban: false,
            booking: this.booking
        };
        this.store.dispatch({ type: DELETE_BOOKING, payload: params });
    };
    BookingRemovalFormComponent.prototype.clickedDeleteWithBan = function () {
        var params = {
            ban: true,
            booking: this.booking
        };
        this.store.dispatch({ type: DELETE_BOOKING, payload: params });
    };
    BookingRemovalFormComponent.prototype.clickedSameDayCancellation = function () {
        this.store.dispatch({ type: SAME_DAY_CANCEL_BOOKING, payload: this.booking.id });
    };
    BookingRemovalFormComponent.prototype.setupEffectEvents = function () {
        var _this = this;
        this.bookingEffectsSubscription =
            Observable["Observable"]
                .merge(this.bookingEffects.remove)
                .filter(function (a) { return _this.CLOSE_ACTIONS.includes(a.type); })
                .subscribe(function () { return _this.modalService.closeModal(); });
    };
    BookingRemovalFormComponent.prototype.ngOnDestroy = function () {
        this.bookingsSubscription.unsubscribe();
        this.bookingEffectsSubscription.unsubscribe();
    };
    BookingRemovalFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: booking_BookingEffects }, { type: modal_ModalService }]; };
    return BookingRemovalFormComponent;
}());

//# sourceMappingURL=booking-removal-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/timeslots-table.ts







var timeslots_table_TimeslotsTableComponent = (function () {
    function TimeslotsTableComponent(store, modalService) {
        this.store = store;
        this.modalService = modalService;
        this.S_AVAILABLE = "S_AVAILABLE";
        this.S_AVAILABLE_WITH_REPLACEMENT = "S_AVAILABLE_WITH_REPLACEMENT";
        this.S_BOOKED = "S_BOOKED";
        this.S_BOOKED_BUT_CANCELLED_SAME_DAY = "S_BOOKED_BUT_CANCELLED_SAME_DAY";
        this.S_TUTOR_ABSENT = "S_TUTOR_ABSENT";
        this.S_TUTOR_ABSENT_W_BOOKING_NO_REPLACEMENT = "S_TUTOR_ABSENT_W_BOOKING_NO_REPLACEMENT";
        this.S_TUTOR_ABSENT_W_BOOKING_HAS_REPLACEMENT = "S_TUTOR_ABSENT_W_BOOKING_HAS_REPLACEMENT";
    }
    TimeslotsTableComponent.prototype.gTutorCount = function () {
        var result = 0;
        if (this.tutorTimeslots.length > 0) {
            result = this.tutorTimeslots[0].byTutor.length;
        }
        return result;
    };
    TimeslotsTableComponent.prototype.gTsHeaders = function () {
        if (!this.tutorTimeslots[0].byTutor) {
            return [];
        }
        return this.tutorTimeslots[0].byTutor[0].timeslots.map(function (t) {
            return "\n      " + moment(t.startTime).format("HH:mma") + " \n      - \n      " + moment(t.endTime).format("HH:mma") + "\n    ";
        });
    };
    TimeslotsTableComponent.prototype.getTwoWeekBlockTitleHtml = function (i) {
        var date = i == 0 ?
            this.twoWeekBlock.startDate : this.twoWeekBlock.secondWeekStart;
        return "\n      <label>Week " + (this.twoWeekBlock.index + 2 + i) + "</label>\n      Starts: " + moment(date).format("ddd Do MMM") + "\n      <span>" + moment(date).format("(D/M/YY)") + "</span>";
    };
    TimeslotsTableComponent.prototype.getStatusClass = function (unformattedStatus) {
        return unformattedStatus
            .replace(/S_/, "")
            .replace(/_/g, "-")
            .toLowerCase();
    };
    TimeslotsTableComponent.prototype.getTimeslotColumnWidth = function () {
        return { 'width': Math.floor(100 / this.gTutorCount()) + "%" };
    };
    TimeslotsTableComponent.prototype.clickedBookTimeslot = function (timeslot, tutor, period) {
        var booking = new booking_Booking();
        booking.period = period;
        booking.date = timeslot.date;
        booking.windowId = timeslot.windowId;
        if (timeslot.replacementTutorAllocation) {
            booking.previousTutorAllocationId = tutor.tutorAllocationId;
            booking.tutorAllocationId = timeslot.replacementTutorAllocation.id;
        }
        else {
            booking.tutorAllocationId = timeslot.tutorAllocation.id;
        }
        this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: booking });
        this.modalService.showModal(new ModalConfig(booking_form_BookingFormComponent, { timeslot: timeslot, tutor: tutor, period: period, mode: "new" }));
    };
    TimeslotsTableComponent.prototype.clickedEditTimeslot = function (timeslot, tutor, period) {
        this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: timeslot.booking });
        this.modalService.showModal(new ModalConfig(booking_form_BookingFormComponent, { timeslot: timeslot, tutor: tutor, period: period, mode: "edit" }));
    };
    TimeslotsTableComponent.prototype.clickedClearTimeslot = function (timeslot, tutor, period) {
        this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: timeslot.booking });
        this.modalService.showModal(new ModalConfig(booking_removal_form_BookingRemovalFormComponent));
    };
    TimeslotsTableComponent.prototype.ngOnInit = function () {
    };
    TimeslotsTableComponent.ctorParameters = function () { return [{ type: src_store["a" /* Store */] }, { type: modal_ModalService }]; };
    return TimeslotsTableComponent;
}());

//# sourceMappingURL=timeslots-table.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/timeslots-table.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_TimeslotsTableComponent = [];
var RenderType_TimeslotsTableComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TimeslotsTableComponent, data: {} });
function View_TimeslotsTableComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'tt__tutor-header']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), core_es5["ɵdid"](2, 16384, null, 0, router_es5["l" /* RouterLink */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], [8, null],
            core_es5["Renderer2"], core_es5["ElementRef"]], { routerLink: [0, 'routerLink'] }, null),
        core_es5["ɵpad"](3, 2), (_l()(), core_es5["ɵted"](4, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getTimeslotColumnWidth();
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _ck(_v, 3, 0, '/contacts', _v.context.$implicit.contact.id);
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.contact.fullName;
        _ck(_v, 4, 0, currVal_2);
    });
}
function View_TimeslotsTableComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'li', [['class',
                'tt__timeslot-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TimeslotsTableComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'button', [['class', 'positive tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedBookTimeslot(_v.parent.context.$implicit, _v.parent.parent.context.$implicit.contact, (_v.parent.context.index + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Book']))], null, null);
}
function View_TimeslotsTableComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Replaced by ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'button', [['class', 'positive tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedBookTimeslot(_v.parent.context.$implicit, _v.parent.parent.context.$implicit.contact, (_v.parent.context.index + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Book']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.replacementTutorAllocation.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TimeslotsTableComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.parent.context.$implicit.booking.note;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TimeslotsTableComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Booked by ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedEditTimeslot(_v.parent.context.$implicit, _v.parent.parent.context.$implicit.contact, (_v.parent.context.index + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Edit'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClearTimeslot(_v.parent.context.$implicit, _v.parent.parent.context.$implicit.contact, (_v.parent.context.index + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Clear'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_10)),
        core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var currVal_1 = _v.parent.context.$implicit.booking.note;
        _ck(_v, 8, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.booking.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TimeslotsTableComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Same day cancellation by ', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.booking.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TimeslotsTableComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Tutor Absent']))], null, null);
}
function View_TimeslotsTableComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Tutor Absent '])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['(for '])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 3, 'a', [], [[1, 'target', 0], [8, 'href',
                4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](6, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](7, 2), (_l()(), core_es5["ɵted"](8, null, ['', ''])), (_l()(),
            core_es5["ɵted"](-1, null, [')']))], function (_ck, _v) {
        var currVal_2 = _ck(_v, 7, 0, '/contact', _v.parent.context.$implicit.booking.contact);
        _ck(_v, 6, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).target;
        var currVal_1 = core_es5["ɵnov"](_v, 6).href;
        _ck(_v, 5, 0, currVal_0, currVal_1);
        var currVal_3 = _v.parent.context.$implicit.booking.contact.fullName;
        _ck(_v, 8, 0, currVal_3);
    });
}
function View_TimeslotsTableComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Booked by ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['Tutor replaced by ', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.booking.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.booking.tutorAllocation.contact.fullName;
        _ck(_v, 4, 0, currVal_1);
    });
}
function View_TimeslotsTableComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 15, 'li', [['class',
                'tt__slot']], null, null, null, null, null)),
        core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_7)),
        core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_8)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_9)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_11)),
        core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_12)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_13)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_14)),
        core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'tt__slot';
        var currVal_1 = _co.getStatusClass(_v.context.$implicit.status);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = (_v.context.$implicit.status == _co.S_AVAILABLE);
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = (_v.context.$implicit.status == _co.S_AVAILABLE_WITH_REPLACEMENT);
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = (_v.context.$implicit.status == _co.S_BOOKED);
        _ck(_v, 7, 0, currVal_4);
        var currVal_5 = (_v.context.$implicit.status == _co.S_BOOKED_BUT_CANCELLED_SAME_DAY);
        _ck(_v, 9, 0, currVal_5);
        var currVal_6 = (_v.context.$implicit.status == _co.S_TUTOR_ABSENT);
        _ck(_v, 11, 0, currVal_6);
        var currVal_7 = (_v.context.$implicit.status == _co.S_TUTOR_ABSENT_W_BOOKING_NO_REPLACEMENT);
        _ck(_v, 13, 0, currVal_7);
        var currVal_8 = (_v.context.$implicit.status == _co.S_TUTOR_ABSENT_W_BOOKING_HAS_REPLACEMENT);
        _ck(_v, 15, 0, currVal_8);
    }, null);
}
function View_TimeslotsTableComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'tt__timeslots-by-tutor']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵeld"](2, 0, null, null, 2, 'ul', [['class', 'tt__slots']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_6)), core_es5["ɵdid"](4, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getTimeslotColumnWidth();
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.timeslots;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_TimeslotsTableComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 15, 'div', [['class',
                'tt__table-wrapper']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), (_l()(), core_es5["ɵeld"](2, 0, null, null, 4, 'div', [['class', 'tt__tutor-headers-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 0, 'div', [['class', 'tt__two-week-block-title']], [[8, 'innerHTML', 1]], null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'ul', [['class', 'tt__tutor-headers']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_3)), core_es5["ɵdid"](6, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 8, 'div', [['class', 'tt__table-content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 3, 'div', [['class', 'tt__timeslot-headers-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'ul', [['class', 'tt__timeslot-headers']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_4)),
        core_es5["ɵdid"](11, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](12, 0, null, null, 3, 'div', [['class', 'tt__timeslots-by-tutors-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 2, 'ul', [['class', 'tt__timeslots-by-tutors']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_5)),
        core_es5["ɵdid"](15, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'tt__table-wrapper';
        var currVal_1 = ((_v.context.index == 0) ? 'one' : 'two');
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_3 = _v.context.$implicit.byTutor;
        _ck(_v, 6, 0, currVal_3);
        var currVal_4 = _co.gTsHeaders();
        _ck(_v, 11, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.byTutor;
        _ck(_v, 15, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.getTwoWeekBlockTitleHtml(_v.context.index);
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_TimeslotsTableComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_2)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.tutorTimeslots;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TimeslotsTableComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'timeslots-table']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class',
                'tt__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TimeslotsTableComponent_1)), core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.tutorTimeslots.length > 0);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_TimeslotsTableComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'timeslots-table', [], null, null, null, View_TimeslotsTableComponent_0, RenderType_TimeslotsTableComponent)), core_es5["ɵdid"](1, 114688, null, 0, timeslots_table_TimeslotsTableComponent, [src_store["a" /* Store */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TimeslotsTableComponentNgFactory = core_es5["ɵccf"]('timeslots-table', timeslots_table_TimeslotsTableComponent, View_TimeslotsTableComponent_Host_0, { tutorTimeslots: 'tutorTimeslots',
    twoWeekBlock: 'twoWeekBlock', window: 'window' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=timeslots-table.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/workshops.ts


var workshops_WorkshopsStore = (function () {
    function WorkshopsStore(workshops, activeWorkshop, activeCampus) {
        if (workshops === void 0) { workshops = []; }
        if (activeWorkshop === void 0) { activeWorkshop = new workshop_Workshop(); }
        if (activeCampus === void 0) { activeCampus = new Campus(); }
        this.workshops = workshops;
        this.activeWorkshop = activeWorkshop;
        this.activeCampus = activeCampus;
    }
    return WorkshopsStore;
}());

//# sourceMappingURL=workshops.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/workshops.ts

var workshopsReducer = function (state, action) {
    if (state === void 0) { state = new workshops_WorkshopsStore(); }
    switch (action.type) {
        case POPULATE_WORKSHOPS:
            return new workshops_WorkshopsStore(action.payload.slice(), state.activeWorkshop, state.activeCampus);
        case POPULATE_ACTIVE_WORKSHOP:
            return new workshops_WorkshopsStore(state.workshops.slice(), action.payload, state.activeCampus);
        case POPULATE_ACTIVE_CAMPUS:
            return new workshops_WorkshopsStore(state.workshops.slice(), state.activeWorkshop, action.payload);
        case REPLACE_WORKSHOP:
            var p = action.payload;
            var workshops = state.workshops.map(function (w) {
                if (w.id === action.payload.id) {
                    return action.payload;
                }
                return w;
            });
            var activeWorkshop = action.payload.id == state.activeWorkshop.id ?
                action.payload : state.activeWorkshop;
            return new workshops_WorkshopsStore(workshops.slice(), activeWorkshop, state.activeCampus);
        default:
            return state;
    }
};
var FETCH_WORKSHOPS = "FETCH_WORKSHOPS";
var POPULATE_WORKSHOPS = "POPULATE_WORKSHOPS";
var FETCH_WORKSHOPS_FAILURE = "FETCH_WORKSHOPS_FAILURE";
var POPULATE_ACTIVE_WORKSHOP = "POPULATE_ACTIVE_WORKSHOP";
var POPULATE_ACTIVE_CAMPUS = "POPULATE_ACTIVE_CAMPUS";
var UPDATE_WORKSHOP = "UPDATE_WORKSHOP";
var REPLACE_WORKSHOP = "REPLACE_WORKSHOP";
var UPDATE_WORKSHOP_FAILURE = "UPDATE_WORKSHOP_FAILURE";
var CREATE_WORKSHOP_ABSENCE = "CREATE_WORKSHOP_ABSENCE";
var CREATE_WORKSHOP_ABSENCE_FAILURE = "CREATE_WORKSHOP_ABSENCE_FAILURE";
var ADD_WORKSHOP_ABSENCE = "ADD_WORKSHOP_ABSENCE";
var DELETE_WORKSHOP_ABSENCE = "DELETE_WORKSHOP_ABSENCE";
var DELETE_WORKSHOP_ABSENCE_FAILURE = "DELETE_WORKSHOP_ABSENCE_FAILURE";
var REMOVE_WORKSHOP_ABSENCE = "REMOVE_WORKSHOP_ABSENCE";
var WORKSHOPS_ROLLOVER = "WORKSHOPS_ROLLOVER";
var WORKSHOPS_ROLLOVER_SUCCESS = "WORKSHOPS_ROLLOVER_SUCCESS";
var WORKSHOPS_ROLLOVER_FAILURE = "WORKSHOPS_ROLLOVER_FAILURE";
//# sourceMappingURL=workshops.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshop-bookings.ts





var workshop_bookings_WorkshopBookingsComponent = (function () {
    function WorkshopBookingsComponent(store, completerService, actions) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.terms = [];
        this.workshops = [];
        this.campuses = [];
        this.days = [];
    }
    WorkshopBookingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var workshopsStore = this.store.select("workshopsReducer");
        var constantsStore = this.store.select("constantsReducer");
        var bookingsStore = this.store.select("bookingsReducer");
        this.constantsSubscription = constantsStore.subscribe(function (s) {
            _this.days = s.constants.days;
            _this.terms = s.constants.terms.filter(function (t) { return !t.isHoliday; });
            _this.campuses = s.constants.campuses;
        });
        this.workshopsSubscription = workshopsStore.subscribe(function (s) {
            _this.workshops = s.workshops;
            _this.setupStateBasedOnFetchedWorkshops();
        });
        this.bookingsSubscription = bookingsStore.subscribe(function (s) {
            _this.timeslots = s.timeslots;
        });
        this.actionsSubscription =
            this.actions
                .ofType(REPLACE_BOOKING, ADD_BOOKING)
                .subscribe(function () { return _this.fetchTimeslots(); });
        this.setupStateBasedOnFetchedWorkshops();
    };
    WorkshopBookingsComponent.prototype.setupStateBasedOnFetchedWorkshops = function () {
        if (this.workshops.length > 0) {
            this.activeTerm = this.terms[0];
            this.activeTwoWeekBlock = this.activeTerm.twoWeekBlocks[0];
            this.activeWorkshop = this.workshops[0];
            this.activeCampus = this.campuses[0];
            this.activeDay = this.getFirstNonDisabledDay();
            this.setupCompleters();
            this.populateActiveWindow();
        }
    };
    WorkshopBookingsComponent.prototype.setupCompleters = function () {
        this.populateTermCompleterData();
        this.populateTwoWeekBlockCompleterData();
        this.populateWorkshopCompleterData();
        this.populateCampusCompleterData();
    };
    WorkshopBookingsComponent.prototype.fetchTimeslots = function () {
        if (this.activeWindow && this.activeTwoWeekBlock) {
            var payload = {
                twoWeekBlockIndex: this.activeTwoWeekBlock.index,
                windowId: this.activeWindow.id
            };
            this.store.dispatch({ type: FETCH_TIMESLOTS, payload: payload });
        }
        else {
            this.timeslots = [];
        }
    };
    WorkshopBookingsComponent.prototype.isDayActive = function (dayLetter) {
        return this.activeDay.code === dayLetter;
    };
    WorkshopBookingsComponent.prototype.isDayDisabled = function (dayCode) {
        return !this.getActiveWindow(dayCode);
    };
    WorkshopBookingsComponent.prototype.selectedTerm = function (e) {
        if (e && e.originalObject) {
            this.activeTerm = e.originalObject;
            this.store.dispatch({ type: FETCH_WORKSHOPS, payload: this.activeTerm.id });
        }
    };
    WorkshopBookingsComponent.prototype.selectedCampus = function (e) {
        if (e && e.originalObject) {
            this.activeCampus = e.originalObject;
            this.activeDay = this.getFirstNonDisabledDay();
            this.populateActiveWindow();
        }
    };
    WorkshopBookingsComponent.prototype.selectedWorkshop = function (e) {
        if (e && e.originalObject) {
            this.activeWorkshop = e.originalObject;
            this.activeDay = this.getFirstNonDisabledDay();
            this.populateActiveWindow();
        }
    };
    WorkshopBookingsComponent.prototype.selectedTwoWeekBlock = function (e) {
        if (e && e.originalObject) {
            this.activeTwoWeekBlock = e.originalObject;
            this.populateActiveWindow();
        }
    };
    WorkshopBookingsComponent.prototype.clickedDay = function (dayLetter) {
        if (this.isDayDisabled(dayLetter)) {
            return;
        }
        this.activeDay = this.days.find(function (d) { return d.code === dayLetter; });
        this.populateActiveWindow();
    };
    WorkshopBookingsComponent.prototype.populateTermCompleterData = function () {
        this.termCompleter =
            this.completerService.local(this.terms, "name", "name");
    };
    WorkshopBookingsComponent.prototype.populateTwoWeekBlockCompleterData = function () {
        this.twoWeekBlockCompleter =
            this.completerService.local(this.activeTerm.twoWeekBlocks, "name", "name");
    };
    WorkshopBookingsComponent.prototype.populateWorkshopCompleterData = function () {
        this.workshopCompleter =
            this.completerService.local(this.workshops, "displayName", "displayName");
    };
    WorkshopBookingsComponent.prototype.populateCampusCompleterData = function () {
        this.campusCompleter =
            this.completerService.local(this.campuses, "name", "name");
    };
    WorkshopBookingsComponent.prototype.populateActiveWindow = function () {
        this.activeWindow = this.getActiveWindow();
        this.fetchTimeslots();
    };
    WorkshopBookingsComponent.prototype.getActiveWindow = function (dayCode) {
        var _this = this;
        if (dayCode === void 0) { dayCode = null; }
        return this.activeWorkshop.windows.find(function (w) {
            var targetDay = _this.days.find(function (d) { return d.code == dayCode; });
            var targetDayId = null;
            if (!targetDay) {
                targetDayId = _this.activeDay.id;
            }
            else {
                targetDayId = targetDay.id;
            }
            return w.campusId == _this.activeCampus.id &&
                w.dayId == targetDayId;
        });
    };
    WorkshopBookingsComponent.prototype.getFirstNonDisabledDay = function () {
        var _this = this;
        return this.days.find(function (d) { return !_this.isDayDisabled(d.code); });
    };
    WorkshopBookingsComponent.prototype.ngOnDestroy = function () {
        this.workshopsSubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
        this.actionsSubscription.unsubscribe();
    };
    WorkshopBookingsComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }]; };
    return WorkshopBookingsComponent;
}());

//# sourceMappingURL=workshop-bookings.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshop-bookings.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_WorkshopBookingsComponent = [];
var RenderType_WorkshopBookingsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopBookingsComponent, data: {} });
function View_WorkshopBookingsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group campus']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'ng2-completer', [['id', 'campus'], ['name', 'campus']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.campusSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCampus($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](3, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [['for', 'campus']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Campus']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.campuses[0];
        var currVal_10 = _co.campusCompleter;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'campus';
        var currVal_12 = _co.campusSearchStr;
        _ck(_v, 5, 0, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopBookingsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group workshop']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'ng2-completer', [['id', 'workshop'], ['name', 'workshop']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.workshopSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedWorkshop($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](3, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [['for', 'workshop']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Workshop']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.workshops[0];
        var currVal_10 = _co.workshopCompleter;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'workshop';
        var currVal_12 = _co.workshopSearchStr;
        _ck(_v, 5, 0, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopBookingsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group two-week-block']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'ng2-completer', [['id', 'two-week-block'], ['name', 'twoWeekBlock']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.twoWeekBlockSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTwoWeekBlock($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](3, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [['for', 'term']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['2 week block']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.terms[0].twoWeekBlocks[0];
        var currVal_10 = _co.twoWeekBlockCompleter;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'twoWeekBlock';
        var currVal_12 = _co.twoWeekBlockSearchStr;
        _ck(_v, 5, 0, currVal_11, currVal_12);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopBookingsComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 30, 'div', [['class',
                'input-group day-picker']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 29, 'div', [['class',
                'wb__day-picker-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 28, 'ul', [['class',
                'wb__day-picker']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 3, 'li', [['class', 'wb__day monday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('M') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](5, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Mon'])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 3, 'li', [['class', 'wb__day tuesday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('T') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](8, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](9, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Tu'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 3, 'li', [['class', 'wb__day wednesday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('W') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](12, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](13, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Wed'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 3, 'li', [['class', 'wb__day thursday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('R') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](16, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](17, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Thurs'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 3, 'li', [['class', 'wb__day friday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('F') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](20, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](21, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Fri'])), (_l()(), core_es5["ɵeld"](23, 0, null, null, 3, 'li', [['class', 'wb__day saturday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('S') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](24, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](25, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Sat'])), (_l()(), core_es5["ɵeld"](27, 0, null, null, 3, 'li', [['class', 'wb__day sunday']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDay('U') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](28, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](29, { 'active': 0,
            'disabled': 1 }), (_l()(), core_es5["ɵted"](-1, null, ['Sun']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'wb__day monday';
        var currVal_1 = _ck(_v, 5, 0, _co.isDayActive('M'), _co.isDayDisabled('M'));
        _ck(_v, 4, 0, currVal_0, currVal_1);
        var currVal_2 = 'wb__day tuesday';
        var currVal_3 = _ck(_v, 9, 0, _co.isDayActive('T'), _co.isDayDisabled('T'));
        _ck(_v, 8, 0, currVal_2, currVal_3);
        var currVal_4 = 'wb__day wednesday';
        var currVal_5 = _ck(_v, 13, 0, _co.isDayActive('W'), _co.isDayDisabled('W'));
        _ck(_v, 12, 0, currVal_4, currVal_5);
        var currVal_6 = 'wb__day thursday';
        var currVal_7 = _ck(_v, 17, 0, _co.isDayActive('R'), _co.isDayDisabled('R'));
        _ck(_v, 16, 0, currVal_6, currVal_7);
        var currVal_8 = 'wb__day friday';
        var currVal_9 = _ck(_v, 21, 0, _co.isDayActive('F'), _co.isDayDisabled('F'));
        _ck(_v, 20, 0, currVal_8, currVal_9);
        var currVal_10 = 'wb__day saturday';
        var currVal_11 = _ck(_v, 25, 0, _co.isDayActive('S'), _co.isDayDisabled('S'));
        _ck(_v, 24, 0, currVal_10, currVal_11);
        var currVal_12 = 'wb__day sunday';
        var currVal_13 = _ck(_v, 29, 0, _co.isDayActive('U'), _co.isDayDisabled('U'));
        _ck(_v, 28, 0, currVal_12, currVal_13);
    }, null);
}
function View_WorkshopBookingsComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'wb__timeslots-table-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'timeslots-table', [], null, null, null, View_TimeslotsTableComponent_0, RenderType_TimeslotsTableComponent)), core_es5["ɵdid"](2, 114688, null, 0, timeslots_table_TimeslotsTableComponent, [src_store["a" /* Store */], modal_ModalService], { tutorTimeslots: [0, 'tutorTimeslots'], twoWeekBlock: [1,
                'twoWeekBlock'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.timeslots;
        var currVal_1 = _co.activeTwoWeekBlock;
        _ck(_v, 2, 0, currVal_0, currVal_1);
    }, null);
}
function View_WorkshopBookingsComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 23, 'div', [['class',
                'workshop-bookings']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 22, 'div', [['class',
                'wb__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 19, 'div', [['class',
                'wb__filters']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 18, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 9, 'div', [['class', 'input-group term']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'ng2-completer', [['id', 'term'],
            ['name', 'term']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTerm($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](7, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](9, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](11, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](12, 0, null, null, 1, 'label', [['for', 'term']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Term'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopBookingsComponent_1)), core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopBookingsComponent_2)),
        core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopBookingsComponent_3)), core_es5["ɵdid"](19, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopBookingsComponent_4)), core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopBookingsComponent_5)),
        core_es5["ɵdid"](23, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.terms[0];
        var currVal_10 = _co.termCompleter;
        _ck(_v, 7, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'term';
        var currVal_12 = _co.termSearchStr;
        _ck(_v, 9, 0, currVal_11, currVal_12);
        var currVal_13 = (_co.workshops.length > 0);
        _ck(_v, 15, 0, currVal_13);
        var currVal_14 = (_co.workshops.length > 0);
        _ck(_v, 17, 0, currVal_14);
        var currVal_15 = (_co.workshops.length > 0);
        _ck(_v, 19, 0, currVal_15);
        var currVal_16 = (_co.workshops.length > 0);
        _ck(_v, 21, 0, currVal_16);
        var currVal_17 = (_co.workshops.length > 0);
        _ck(_v, 23, 0, currVal_17);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 11).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 11).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 11).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 11).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 11).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 11).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 11).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopBookingsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshop-bookings', [], null, null, null, View_WorkshopBookingsComponent_0, RenderType_WorkshopBookingsComponent)), core_es5["ɵdid"](1, 245760, null, 0, workshop_bookings_WorkshopBookingsComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopBookingsComponentNgFactory = core_es5["ɵccf"]('workshop-bookings', workshop_bookings_WorkshopBookingsComponent, View_WorkshopBookingsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshop-bookings.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/tutor-allocations.ts

var tutor_allocations_TutorAllocationsStore = (function () {
    function TutorAllocationsStore(tutorAllocations, activeTutorAllocation) {
        if (tutorAllocations === void 0) { tutorAllocations = []; }
        if (activeTutorAllocation === void 0) { activeTutorAllocation = new tutor_allocation_TutorAllocation(); }
        this.tutorAllocations = tutorAllocations;
        this.activeTutorAllocation = activeTutorAllocation;
    }
    return TutorAllocationsStore;
}());

//# sourceMappingURL=tutor-allocations.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/tutor-allocations.ts

var tutorAllocationsReducer = function (state, action) {
    if (state === void 0) { state = new tutor_allocations_TutorAllocationsStore(); }
    switch (action.type) {
        case POPULATE_TUTOR_ALLOCATIONS:
            return new tutor_allocations_TutorAllocationsStore(action.payload.slice(), state.activeTutorAllocation);
        case POPULATE_EDITABLE_TUTOR_ALLOCATION:
            return new tutor_allocations_TutorAllocationsStore(state.tutorAllocations.slice(), action.payload);
        case ADD_TUTOR_ALLOCATION:
            return new tutor_allocations_TutorAllocationsStore([action.payload].concat(state.tutorAllocations), state.activeTutorAllocation);
        case REPLACE_TUTOR_ALLOCATION:
            var p_1 = action.payload;
            var tas = state.tutorAllocations.map(function (ta) {
                if (ta.id == p_1.id) {
                    return p_1;
                }
                return ta;
            });
            var activeTa = p_1.id == state.activeTutorAllocation.id ?
                p_1 : state.activeTutorAllocation;
            return new tutor_allocations_TutorAllocationsStore(tas, activeTa);
        default:
            return state;
    }
};
var FETCH_TUTOR_ALLOCATIONS = "FETCH_TUTOR_ALLOCATIONS";
var FETCH_TUTOR_ALLOCATIONS_FAILURE = "FETCH_TUTOR_ALLOCATIONS_FAILURE";
var POPULATE_TUTOR_ALLOCATIONS = "POPULATE_TUTOR_ALLOCATIONS";
var POPULATE_EDITABLE_TUTOR_ALLOCATION = "POPULATE_EDITABLE_TUTOR_ALLOCATION";
var CREATE_TUTOR_ALLOCATION = "CREATE_TUTOR_ALLOCATION";
var CREATE_TUTOR_ALLOCATION_FAILURE = "CREATE_TUTOR_ALLOCATION_FAILURE";
var ADD_TUTOR_ALLOCATION = "ADD_TUTOR_ALLOCATION";
var UPDATE_TUTOR_ALLOCATION = "UPDATE_TUTOR_ALLOCATION";
var UPDATE_TUTOR_ALLOCATION_FAILURE = "UPDATE_TUTOR_ALLOCATION_FAILURE";
var REPLACE_TUTOR_ALLOCATION = "REPLACE_TUTOR_ALLOCATION";
//# sourceMappingURL=tutor-allocations.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/tutor-allocation.ts




var tutor_allocation_TutorAllocationService = (function () {
    function TutorAllocationService(http) {
        this.http = http;
        this.tutorAllocationsUrl = 'tutor_allocations';
    }
    TutorAllocationService.prototype.index = function () {
        return this.http.get(this.tutorAllocationsUrl)
            .map(function (res) { return res.json().map(function (ta) { return tutor_allocation_TutorAllocation.clone(ta); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    TutorAllocationService.prototype.create = function (ta) {
        return this.http.post(this.tutorAllocationsUrl, ta.serializeForRails())
            .map(function (res) { return tutor_allocation_TutorAllocation.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    TutorAllocationService.prototype.update = function (ta) {
        return this.http.put(this.tutorAllocationsUrl + "/" + ta.id, ta.serializeForRails())
            .map(function (res) { return tutor_allocation_TutorAllocation.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    TutorAllocationService.prototype.timeslots = function (params) {
        return this.http.get("someurl")
            .map(function (res) { return res.json().map(function (t) { return tutor_timeslots_TutorTimeslots.clone(t); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    TutorAllocationService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return TutorAllocationService;
}());

//# sourceMappingURL=tutor-allocation.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/tutor-allocation.ts
var tutor_allocation___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var tutor_allocation___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var tutor_allocation_TutorAllocationEffects = (function () {
    function TutorAllocationEffects(actions, tutorAllocationService) {
        var _this = this;
        this.actions = actions;
        this.tutorAllocationService = tutorAllocationService;
        this.index = this.actions
            .ofType(FETCH_TUTOR_ALLOCATIONS)
            .map(function (action) { return action.payload; })
            .switchMap(function () { return _this.tutorAllocationService.index()
            .map(function (tas) { return ({ type: POPULATE_TUTOR_ALLOCATIONS, payload: tas }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_TUTOR_ALLOCATIONS_FAILURE }); }); })
            .share();
        this.create = this.actions
            .ofType(CREATE_TUTOR_ALLOCATION)
            .map(function (action) { return action.payload; })
            .switchMap(function (ta) { return _this.tutorAllocationService.create(ta)
            .map(function (ta) {
            return { type: ADD_TUTOR_ALLOCATION, payload: ta };
        })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_TUTOR_ALLOCATION_FAILURE }); }); })
            .share();
        this.update = this.actions
            .ofType(UPDATE_TUTOR_ALLOCATION)
            .map(function (action) { return action.payload; })
            .switchMap(function (ta) { return _this.tutorAllocationService.update(ta)
            .map(function (ta) {
            return { type: REPLACE_TUTOR_ALLOCATION, payload: ta };
        })
            .catch(function () { return Observable["Observable"].of({ type: UPDATE_TUTOR_ALLOCATION_FAILURE }); }); })
            .share();
    }
    TutorAllocationEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: tutor_allocation_TutorAllocationService }]; };
    return TutorAllocationEffects;
}());

tutor_allocation___decorate([
    Object(effects["b" /* Effect */])(),
    tutor_allocation___metadata("design:type", Object)
], tutor_allocation_TutorAllocationEffects.prototype, "index", void 0);
tutor_allocation___decorate([
    Object(effects["b" /* Effect */])(),
    tutor_allocation___metadata("design:type", Object)
], tutor_allocation_TutorAllocationEffects.prototype, "create", void 0);
tutor_allocation___decorate([
    Object(effects["b" /* Effect */])(),
    tutor_allocation___metadata("design:type", Object)
], tutor_allocation_TutorAllocationEffects.prototype, "update", void 0);
//# sourceMappingURL=tutor-allocation.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/states/classes-manager.ts
var ClassesManagerState = (function () {
    function ClassesManagerState(activeTerm, activeCampus, activeDay, activeHolidayWeek) {
        if (activeTerm === void 0) { activeTerm = null; }
        if (activeCampus === void 0) { activeCampus = null; }
        if (activeDay === void 0) { activeDay = null; }
        if (activeHolidayWeek === void 0) { activeHolidayWeek = 1; }
        this.activeTerm = activeTerm;
        this.activeCampus = activeCampus;
        this.activeDay = activeDay;
        this.activeHolidayWeek = activeHolidayWeek;
    }
    ClassesManagerState.clone = function (obj) {
        var state = new this();
        if (obj.activeCampus) {
            state.activeCampus = obj.activeCampus;
        }
        if (obj.activeDay) {
            state.activeDay = obj.activeDay;
        }
        if (obj.activeTerm) {
            state.activeTerm = obj.activeTerm;
        }
        if (obj.activeHolidayWeek) {
            state.activeHolidayWeek = obj.activeHolidayWeek;
        }
        return state;
    };
    return ClassesManagerState;
}());

//# sourceMappingURL=classes-manager.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/matrix-classes.ts


var matrix_classes_MatrixClassesStore = (function () {
    function MatrixClassesStore(matrixClasses, editableClass, activeClass, teachers, classesManagerState, classesRolloverTermFrom, classesRolloverTermTo, classRolloverResult) {
        if (matrixClasses === void 0) { matrixClasses = []; }
        if (editableClass === void 0) { editableClass = new matrix_class_MatrixClass(); }
        if (activeClass === void 0) { activeClass = new matrix_class_MatrixClass(); }
        if (teachers === void 0) { teachers = []; }
        if (classesManagerState === void 0) { classesManagerState = new ClassesManagerState(); }
        if (classesRolloverTermFrom === void 0) { classesRolloverTermFrom = []; }
        if (classesRolloverTermTo === void 0) { classesRolloverTermTo = []; }
        if (classRolloverResult === void 0) { classRolloverResult = []; }
        this.matrixClasses = matrixClasses;
        this.editableClass = editableClass;
        this.activeClass = activeClass;
        this.teachers = teachers;
        this.classesManagerState = classesManagerState;
        this.classesRolloverTermFrom = classesRolloverTermFrom;
        this.classesRolloverTermTo = classesRolloverTermTo;
        this.classRolloverResult = classRolloverResult;
    }
    return MatrixClassesStore;
}());

//# sourceMappingURL=matrix-classes.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/matrix-class.ts



var matrixClassesReducer = function (state, action) {
    if (state === void 0) { state = new matrix_classes_MatrixClassesStore(); }
    switch (action.type) {
        case POPULATE_CLASSES:
            return new matrix_classes_MatrixClassesStore(action.payload.slice(), state.editableClass, state.activeClass, state.teachers.slice(), ClassesManagerState.clone(state.classesManagerState), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case POPULATE_TEACHERS:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), action.payload, ClassesManagerState.clone(state.classesManagerState), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case REPLACE_CLASS:
            var p_1 = action.payload;
            var matrixClasses = state.matrixClasses.map(function (c) {
                if (c.id === p_1.id) {
                    return p_1;
                }
                ;
                return c;
            });
            var active = state.activeClass.id === p_1.id ? p_1 : state.activeClass;
            var editable = state.editableClass.id === p_1.id ? p_1 : state.editableClass;
            return new matrix_classes_MatrixClassesStore(matrixClasses, active, editable, state.teachers.slice(), state.classesManagerState, state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case ADD_CLASS:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.concat([action.payload]), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(state.classesManagerState), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case POPULATE_ACTIVE_CLASS:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), action.payload, state.teachers.slice(), ClassesManagerState.clone(state.classesManagerState), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case POPULATE_EDITABLE_CLASS:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), action.payload, matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(state.classesManagerState), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case CM_STATE_SET_ACTIVE_CAMPUS:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeCampus: action.payload })), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case CM_STATE_SET_ACTIVE_DAY:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeDay: action.payload })), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case CM_STATE_SET_ACTIVE_TERM:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeTerm: action.payload })), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case CM_STATE_SET_ACTIVE_HOLIDAY_WEEK:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), matrix_class_MatrixClass.clone(state.editableClass), matrix_class_MatrixClass.clone(state.activeClass), state.teachers.slice(), ClassesManagerState.clone(Object.assign({}, state.classesManagerState, { activeHolidayWeek: action.payload })), state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case POPULATE_CLASSSES_FOR_FROM_TERM:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), state.editableClass, state.activeClass, state.teachers.slice(), state.classesManagerState, action.payload, state.classesRolloverTermTo.slice(), state.classRolloverResult.slice());
        case POPULATE_CLASSSES_FOR_TO_TERM:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), state.editableClass, state.activeClass, state.teachers.slice(), state.classesManagerState, state.classesRolloverTermFrom.slice(), action.payload, state.classRolloverResult.slice());
        case POPULATE_CLASS_ROLLOVER_RESULT:
            return new matrix_classes_MatrixClassesStore(state.matrixClasses.slice(), state.editableClass, state.activeClass, state.teachers.slice(), state.classesManagerState, state.classesRolloverTermFrom.slice(), state.classesRolloverTermTo.slice(), action.payload);
        default:
            return state;
    }
};
var FETCH_CLASSES = "FETCH_CLASSES";
var FETCH_CLASSES_FAILURE = "FETCH_CLASSES_FAILURE";
var FETCH_CLASS = "FETCH_CLASS";
var FETCH_CLASS_FAILURE = "FETCH_CLASS_FAILURE";
var FETCH_TEACHERS = "FETCH_TEACHERS";
var FETCH_TEACHERS_FAILURE = "FETCH_TEACHERS_FAILURE";
var POPULATE_CLASSES = "POPULATE_CLASSES";
var POPULATE_TEACHERS = "POPULATE_TEACHERS";
var POPULATE_ACTIVE_CLASS = "POPULATE_ACTIVE_CLASS";
var POPULATE_EDITABLE_CLASS = "POPULATE_EDITABLE_CLASS";
var CREATE_CLASS = "CREATE_CLASS";
var CREATE_CLASS_FAILURE = "CREATE_CLASS_FAILURE";
var ADD_CLASS = "ADD_CLASS";
var UPDATE_CLASS = "UPDATE_CLASS";
var UPDATE_CLASS_FAILURE = "UPDATE_CLASS_FAILURE";
var REPLACE_CLASS = "REPLACE_CLASS";
var CM_STATE_SET_ACTIVE_CAMPUS = "CM_STATE_SET_ACTIVE_CAMPUS";
var CM_STATE_SET_ACTIVE_DAY = "CM_STATE_SET_ACTIVE_DAY";
var CM_STATE_SET_ACTIVE_TERM = "CM_STATE_SET_ACTIVE_TERM";
var CM_STATE_SET_ACTIVE_HOLIDAY_WEEK = "CM_STATE_SET_ACTIVE_HOLIDAY_WEEK";
var FETCH_CLASSSES_FOR_TO_TERM = "FETCH_CLASSSES_FOR_TO_TERM";
var POPULATE_CLASSSES_FOR_TO_TERM = "POPULATE_CLASSSES_FOR_TO_TERM";
var FETCH_CLASSSES_FOR_FROM_TERM = "FETCH_CLASSSES_FOR_FROM_TERM";
var POPULATE_CLASSSES_FOR_FROM_TERM = "POPULATE_CLASSSES_FOR_FROM_TERM";
var CLASS_ROLLOVER = "CLASS_ROLLOVER";
var POPULATE_CLASS_ROLLOVER_RESULT = "POPULATE_CLASS_ROLLOVER_RESULT";
var CLASS_ROLLOVER_FAILURE = "CLASS_ROLLOVER_FAILURE";
//# sourceMappingURL=matrix-class.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/tutor-allocation-form.ts






var tutor_allocation_form_TutorAllocationFormComponent = (function () {
    function TutorAllocationFormComponent(store, completerService, tutorAllocationEffects, modalService) {
        this.store = store;
        this.completerService = completerService;
        this.tutorAllocationEffects = tutorAllocationEffects;
        this.modalService = modalService;
        this.isEditing = false;
        this.errors = {};
        this.courses = [];
        this.workshops = [];
        this.tutors = [];
        this.potentialWindows = [];
    }
    TutorAllocationFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tutorAllocationsStore = this.store.select("tutorAllocationsReducer");
        this.workshopsStore = this.store.select("workshopsReducer");
        this.constantsStore = this.store.select("constantsReducer");
        this.matrixClassesStore = this.store.select("matrixClassesReducer");
        this.constantsStore.subscribe(function (s) {
            _this.courses = s.constants.courses;
        });
        this.workshopsStore.subscribe(function (s) {
            _this.workshops = s.workshops;
        });
        this.matrixClassesStore.subscribe(function (s) {
            _this.tutors = s.teachers;
            _this.tutorCompleter =
                _this.completerService.local(_this.tutors, "fullName", "fullName");
        });
        this.tutorAllocationsStore.subscribe(function (s) {
            _this.ta = s.activeTutorAllocation;
            _this.setupTutorAllocation();
            _this.refreshPotentialWindows();
        });
        this.populateTeachers();
        this.courseCompleter =
            this.completerService.local(this.courses, "code, name", "name");
    };
    TutorAllocationFormComponent.prototype.selectedTutor = function (e) {
        if (e && e.originalObject) {
            var tutor = e.originalObject;
            this.ta.contact = tutor;
            this.ta.contactId = tutor.id;
        }
        else {
            this.ta.contact = null;
            this.ta.contactId = null;
        }
    };
    TutorAllocationFormComponent.prototype.selectedCourse = function (e) {
        if (e && e.originalObject) {
            var course_1 = e.originalObject;
            if (!this.ta.courseIds.find(function (id) { return id == course_1.id; })) {
                this.ta.courses.push(course_1);
                this.ta.courseIds.push(course_1.id);
                this.refreshPotentialWindows();
            }
        }
    };
    TutorAllocationFormComponent.prototype.setupTutorAllocation = function () {
        if (!this.ta.courseIds) {
            this.ta.courseIds = [];
        }
        if (!this.ta.windowIds) {
            this.ta.windowIds = [];
        }
    };
    TutorAllocationFormComponent.prototype.populateTeachers = function () {
        this.store.dispatch({ type: FETCH_TEACHERS });
    };
    TutorAllocationFormComponent.prototype.refreshPotentialWindows = function () {
        var _this = this;
        var isPresent = false;
        var windows = [];
        this.potentialWindows = [];
        this.workshops.forEach(function (w) {
            isPresent = !!w.courseIds.find(function (cId) {
                return _this.ta.courseIds.indexOf(cId) >= 0;
            });
            if (isPresent) {
                w.windows.forEach(function (w) {
                    _this.potentialWindows.push(w);
                });
            }
        });
    };
    TutorAllocationFormComponent.prototype.getPotentialWindowsByCampus = function () {
        var result = [];
        this.potentialWindows.forEach(function (w) {
            var isPresent = result.find(function (wbc) { return wbc.campus.id == w.campus.id; });
            if (!isPresent) {
                var wbc = { campus: w.campus, windows: [] };
                result.push(wbc);
            }
        });
        this.potentialWindows.forEach(function (w) {
            var wbc = result.find(function (wbc) { return wbc.campus.id == w.campus.id; });
            wbc.windows.push(w);
        });
        return result;
    };
    TutorAllocationFormComponent.prototype.getWorkshopForWindow = function (window) {
        return this.workshops.find(function (w) {
            return w.id == window.workshopId;
        });
    };
    TutorAllocationFormComponent.prototype.isWindowInAllocation = function (window) {
        return !!this.ta.windowIds.find(function (wId) {
            return wId == window.id;
        });
    };
    TutorAllocationFormComponent.prototype.clickedWindowCheckbox = function (e, window) {
        if (e.target.checked && !this.isWindowInAllocation(window)) {
            this.ta.windows.push(window);
            this.ta.windowIds.push(window.id);
        }
        else {
            this.ta.windows = this.ta.windows.filter(function (w) {
                return w.id !== window.id;
            });
            this.ta.windowIds = this.ta.windowIds.filter(function (wId) {
                return wId !== window.id;
            });
        }
    };
    TutorAllocationFormComponent.prototype.clickedRemoveCourse = function (course) {
        this.ta.courses = this.ta.courses.filter(function (c) { return c.id != course.id; });
        this.ta.courseIds = this.ta.courseIds.filter(function (id) { return id != course.id; });
        this.refreshPotentialWindows();
    };
    TutorAllocationFormComponent.prototype.clickedSave = function () {
        var _this = this;
        if (!this.validateTutorAllocation()) {
            return;
        }
        if (this.isEditing) {
            this.tutorAllocationEffects.update.take(1).subscribe(function (a) {
                if (a.type == REPLACE_TUTOR_ALLOCATION) {
                    _this.modalService.closeModal();
                }
            });
            this.store.dispatch({ type: UPDATE_TUTOR_ALLOCATION, payload: this.ta });
        }
        else {
            this.tutorAllocationEffects.create.take(1).subscribe(function (a) {
                if (a.type == ADD_TUTOR_ALLOCATION) {
                    _this.modalService.closeModal();
                }
            });
            this.store.dispatch({ type: CREATE_TUTOR_ALLOCATION, payload: this.ta });
        }
    };
    TutorAllocationFormComponent.prototype.validateTutorAllocation = function () {
        var result = true;
        this.errors = {};
        if (!this.ta.contactId) {
            result = false;
            this.errors.contact = { required: true };
        }
        return result;
    };
    TutorAllocationFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: tutor_allocation_TutorAllocationEffects }, { type: modal_ModalService }]; };
    return TutorAllocationFormComponent;
}());

//# sourceMappingURL=tutor-allocation-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/matrix-class.ts
var matrix_class___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matrix_class___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var matrix_class_MatrixClassEffects = (function () {
    function MatrixClassEffects(actions, matrixClassService) {
        var _this = this;
        this.actions = actions;
        this.matrixClassService = matrixClassService;
        this.fetchClasses = this.actions
            .ofType(FETCH_CLASSES)
            .debounceTime(300)
            .switchMap(function (action) { return _this.matrixClassService.index(action.payload)
            .map(function (classes) { return ({ type: POPULATE_CLASSES, payload: classes }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_CLASSES_FAILURE }); }); })
            .share();
        this.fetchClass = this.actions
            .ofType(FETCH_CLASS)
            .switchMap(function (action) { return _this.matrixClassService.fetch(action.payload)
            .map(function (matrixClass) { return ({ type: POPULATE_ACTIVE_CLASS, payload: matrixClass }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_CLASS_FAILURE }); }); })
            .share();
        this.fetchTeachers = this.actions
            .ofType(FETCH_TEACHERS)
            .switchMap(function (action) { return _this.matrixClassService.teachers()
            .map(function (teachers) { return ({ type: POPULATE_TEACHERS, payload: teachers }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_TEACHERS_FAILURE }); }); })
            .share();
        this.createClass = this.actions
            .ofType(CREATE_CLASS)
            .map(function (action) { return action.payload; })
            .switchMap(function (matrixClass) { return _this.matrixClassService.create(matrixClass.serializeForRails())
            .map(function (matrixClass) { return ({ type: ADD_CLASS, payload: matrixClass }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_CLASS_FAILURE, payload: response }); }); })
            .share();
        this.updateClass = this.actions
            .ofType(UPDATE_CLASS)
            .map(function (action) { return action.payload; })
            .switchMap(function (matrixClass) { return _this.matrixClassService.update(matrixClass.serializeForRails())
            .map(function (matrixClass) { return ({ type: REPLACE_CLASS, payload: matrixClass }); })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_CLASS_FAILURE, payload: response }); }); })
            .share();
        this.fetchClassesToTerm = this.actions
            .ofType(FETCH_CLASSSES_FOR_TO_TERM)
            .map(function (action) { return action.payload; })
            .switchMap(function (termId) {
            return _this.matrixClassService.index({ termId: termId })
                .map(function (classes) { return ({ type: POPULATE_CLASSSES_FOR_TO_TERM, payload: classes }); });
        });
        this.fetchClassesFromTerm = this.actions
            .ofType(FETCH_CLASSSES_FOR_FROM_TERM)
            .map(function (action) { return action.payload; })
            .switchMap(function (termId) {
            return _this.matrixClassService.index({ termId: termId })
                .map(function (classes) { return ({ type: POPULATE_CLASSSES_FOR_FROM_TERM, payload: classes }); });
        });
        this.classRollover = this.actions
            .ofType(CLASS_ROLLOVER)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) {
            return _this.matrixClassService.rollover(params)
                .map(function (classes) { return ({ type: POPULATE_CLASS_ROLLOVER_RESULT, payload: classes }); });
        });
    }
    MatrixClassEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: matrix_class_MatrixClassService }]; };
    return MatrixClassEffects;
}());

matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "fetchClasses", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "fetchClass", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "fetchTeachers", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "createClass", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "updateClass", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "fetchClassesToTerm", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "fetchClassesFromTerm", void 0);
matrix_class___decorate([
    Object(effects["b" /* Effect */])(),
    matrix_class___metadata("design:type", Object)
], matrix_class_MatrixClassEffects.prototype, "classRollover", void 0);
//# sourceMappingURL=matrix-class.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/tutor-allocations.ts







var tutor_allocations_TutorAllocationsComponent = (function () {
    function TutorAllocationsComponent(store, matrixClassEffects, modalService) {
        this.store = store;
        this.matrixClassEffects = matrixClassEffects;
        this.modalService = modalService;
    }
    TutorAllocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tutorAllocationsStore = this.store.select("tutorAllocationsReducer");
        this.tutorAllocationsStore.subscribe(function (s) {
            _this.tutorAllocations = s.tutorAllocations;
        });
        this.populateTutorAllocations();
    };
    TutorAllocationsComponent.prototype.populateTutorAllocations = function () {
        this.store.dispatch({ type: FETCH_TUTOR_ALLOCATIONS });
    };
    TutorAllocationsComponent.prototype.clickedNewTutorAllocation = function () {
        var ta = new tutor_allocation_TutorAllocation();
        this.store.dispatch({ type: POPULATE_EDITABLE_TUTOR_ALLOCATION, payload: ta });
        this.modalService.showModal(new ModalConfig(tutor_allocation_form_TutorAllocationFormComponent));
    };
    TutorAllocationsComponent.prototype.clickedEditTutorAllocation = function (ta) {
        this.store.dispatch({ type: POPULATE_EDITABLE_TUTOR_ALLOCATION, payload: ta });
        this.modalService.showModal(new ModalConfig(tutor_allocation_form_TutorAllocationFormComponent, { isEditing: true }));
    };
    TutorAllocationsComponent.prototype.getTutorAllocationsByFaculty = function () {
        var _this = this;
        var result = [0, 1, 2].map(function (i) {
            return { faculty: course_Course.FACULTIES[i], tutorAllocations: [] };
        });
        result.forEach(function (tbf, i) {
            _this.tutorAllocations.forEach(function (ta) {
                if (ta.courses.find(function (c) { return c.faculty == i; })) {
                    var target = result.find(function (tbf) {
                        return tbf.faculty == course_Course.FACULTIES[i];
                    });
                    target.tutorAllocations.push(ta);
                }
            });
        });
        return result;
    };
    TutorAllocationsComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: matrix_class_MatrixClassEffects }, { type: modal_ModalService }]; };
    return TutorAllocationsComponent;
}());

//# sourceMappingURL=tutor-allocations.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/tutor-allocations.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_TutorAllocationsComponent = [];
var RenderType_TutorAllocationsComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TutorAllocationsComponent, data: {} });
function View_TutorAllocationsComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ta__ta-no-windows']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No available windows']))], null, null);
}
function View_TutorAllocationsComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'ta__ta-window']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ' '])), (_l()(), core_es5["ɵted"](3, null, ['', '\n- \n', '\n- \n',
            ''])), core_es5["ɵppd"](4, 2), core_es5["ɵppd"](5, 2)], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.campus.name;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.day.name;
        var currVal_2 = core_es5["ɵunv"](_v, 3, 1, _ck(_v, 4, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.startTime, 'shortTime'));
        var currVal_3 = core_es5["ɵunv"](_v, 3, 2, _ck(_v, 5, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.endTime, 'shortTime'));
        _ck(_v, 3, 0, currVal_1, currVal_2, currVal_3);
    });
}
function View_TutorAllocationsComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'ta__ta-windows-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'ul', [['class',
                'ta__ta-windows']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationsComponent_5)),
        core_es5["ɵdid"](3, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.windows;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_TutorAllocationsComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'li', [['class',
                'ta__tutor-allocation']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'ta__ta-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationsComponent_3)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationsComponent_4)), core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'div', [['class', 'ta__ta-actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'button', [['class', 'ta__btn-side tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedEditTutorAllocation(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Edit']))], function (_ck, _v) {
        var currVal_1 = (_v.context.$implicit.windows.length == 0);
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = (_v.context.$implicit.windows.length > 0);
        _ck(_v, 6, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TutorAllocationsComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'ta__ta-by-faculty']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'ta__ta-by-faculty-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'ta__tutor-allocations']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationsComponent_2)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.tutorAllocations;
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.faculty;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TutorAllocationsComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class', 'tutor-allocations']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 9, 'div', [['class', 'ta__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'div', [['class', 'ta__action-bar']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedNewTutorAllocation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['New Tutor Allocation'])),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 3, 'div', [['class', 'ta__tutor-allocations-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'ul', [['class', 'ta__ta-by-faculty-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationsComponent_1)),
        core_es5["ɵdid"](11, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getTutorAllocationsByFaculty();
        _ck(_v, 11, 0, currVal_0);
    }, null);
}
function View_TutorAllocationsComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'tutor-allocations', [], null, null, null, View_TutorAllocationsComponent_0, RenderType_TutorAllocationsComponent)), core_es5["ɵdid"](1, 114688, null, 0, tutor_allocations_TutorAllocationsComponent, [src_store["a" /* Store */], matrix_class_MatrixClassEffects, modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TutorAllocationsComponentNgFactory = core_es5["ɵccf"]('tutor-allocations', tutor_allocations_TutorAllocationsComponent, View_TutorAllocationsComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=tutor-allocations.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshop-campus-form.ts





var workshop_campus_form_WorkshopCampusFormComponent = (function () {
    function WorkshopCampusFormComponent(store, modalService, completerService) {
        this.store = store;
        this.modalService = modalService;
        this.completerService = completerService;
        this.newWindow = new window_Window();
        this.isNewWindowFormVisible = false;
    }
    WorkshopCampusFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.workshopsStore = this.store.select("workshopsReducer");
        this.constantsStore = this.store.select("constantsReducer");
        this.workshopsStore.subscribe(function (s) {
            _this.workshop = s.activeWorkshop;
            _this.campus = s.activeCampus;
        });
        this.constantsStore.subscribe(function (s) {
            _this.courses = s.constants.courses;
        });
        this.newWindow.setStandardLunchtimes();
        this.newWindow.campusId = this.campus.id;
        this.newWindow.workshopId = this.workshop.id;
        this.courseCompleter =
            this.completerService.local(this.courses, "humanised, code, name", "humanised");
    };
    WorkshopCampusFormComponent.prototype.windowsForCampus = function () {
        var _this = this;
        return this.workshop.windows.filter(function (w) {
            return w.campus.id == _this.campus.id;
        });
    };
    WorkshopCampusFormComponent.prototype.submittedNewWindow = function (window) {
        this.workshop.windows.push(window);
        this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop });
        this.close();
    };
    WorkshopCampusFormComponent.prototype.submittedExistingWindow = function (window) {
        this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop });
        window.isEditing = false;
        this.close();
    };
    WorkshopCampusFormComponent.prototype.closedEditWindowForm = function (window) {
        window.isEditing = false;
    };
    WorkshopCampusFormComponent.prototype.selectedCourse = function (e) {
        if (e && e.originalObject) {
            this.workshop.courseIds.push(e.originalObject.id);
            this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop });
            this.courseSearchStr = "";
        }
    };
    WorkshopCampusFormComponent.prototype.clickedNewWindow = function () {
        this.isNewWindowFormVisible = true;
    };
    WorkshopCampusFormComponent.prototype.clickedCloseNewWindowForm = function () {
        this.isNewWindowFormVisible = false;
    };
    WorkshopCampusFormComponent.prototype.clickedEditWindow = function (window) {
        window.isEditing = true;
    };
    WorkshopCampusFormComponent.prototype.clickedRemoveCourse = function (course) {
        course.isConfirmingRemove = true;
    };
    WorkshopCampusFormComponent.prototype.clickedConfirmRemoveCourse = function (course) {
        course.isConfirmingRemove = false;
        this.workshop.courseIds =
            this.workshop.courseIds.filter(function (cId) { return cId != course.id; });
        this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop });
    };
    WorkshopCampusFormComponent.prototype.clickedCancelRemoveCourse = function (course) {
        course.isConfirmingRemove = false;
    };
    WorkshopCampusFormComponent.prototype.close = function () {
        this.modalService.closeModal();
    };
    WorkshopCampusFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: modal_ModalService }, { type: ng2_completer["a" /* CompleterService */] }]; };
    return WorkshopCampusFormComponent;
}());

//# sourceMappingURL=workshop-campus-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshops-timetable-view.ts





var workshops_timetable_view_WorkshopsTimetableViewComponent = (function () {
    function WorkshopsTimetableViewComponent(store, completerService, modalService) {
        this.store = store;
        this.completerService = completerService;
        this.modalService = modalService;
    }
    WorkshopsTimetableViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.constantsStore = this.store.select("constantsReducer");
        this.workshopsStore = this.store.select("workshopsReducer");
        this.constantsStore.subscribe(function (s) {
            _this.terms = s.constants.terms.filter(function (t) { return !t.isHoliday; });
            _this.termCompleter =
                _this.completerService.local(_this.terms, "name", "name");
        });
        this.workshopsStore.subscribe(function (s) {
            _this.workshops = s.workshops;
        });
        this.activeTerm = this.terms[0];
    };
    WorkshopsTimetableViewComponent.prototype.clickedEditWorkshopCampus = function (workshop, campus) {
        this.store.dispatch({ type: POPULATE_ACTIVE_WORKSHOP, payload: workshop });
        this.store.dispatch({ type: POPULATE_ACTIVE_CAMPUS, payload: campus });
        this.modalService.showModal(new ModalConfig(workshop_campus_form_WorkshopCampusFormComponent));
    };
    WorkshopsTimetableViewComponent.prototype.selectedTerm = function (e) {
        if (e) {
            this.activeTerm = e.originalObject;
        }
    };
    WorkshopsTimetableViewComponent.prototype.populateWorkshops = function (termId) {
        this.store.dispatch({ type: FETCH_WORKSHOPS, payload: termId });
    };
    WorkshopsTimetableViewComponent.prototype.windowsForCampus = function (workshop, campus) {
        return workshop.windows.filter(function (w) {
            return w.campusId === campus.id;
        });
    };
    WorkshopsTimetableViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: modal_ModalService }]; };
    return WorkshopsTimetableViewComponent;
}());

//# sourceMappingURL=workshops-timetable-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshops-timetable-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_WorkshopsTimetableViewComponent = [];
var RenderType_WorkshopsTimetableViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopsTimetableViewComponent, data: {} });
function View_WorkshopsTimetableViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['(Lunch: ', '\n-\n', ')'])), core_es5["ɵppd"](2, 2), core_es5["ɵppd"](3, 2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.parent.context.$implicit.lunchStartTime, 'shortTime'));
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.parent.context.$implicit.lunchEndTime, 'shortTime'));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_WorkshopsTimetableViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'wtv__w-window']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', '\n- \n', '\n- \n', ''])), core_es5["ɵppd"](2, 2), core_es5["ɵppd"](3, 2), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsTimetableViewComponent_4)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var currVal_3 = _v.context.$implicit.hasLunchtime;
        _ck(_v, 5, 0, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.day.name;
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.context.$implicit.startTime, 'shortTime'));
        var currVal_2 = core_es5["ɵunv"](_v, 1, 2, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.context.$implicit.endTime, 'shortTime'));
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_WorkshopsTimetableViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'wtv__w-campus']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'div', [['class', 'wtv__w-campus-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedEditWorkshopCampus(_v.parent.context.$implicit, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Edit'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 2, 'ul', [['class', 'wtv__w-windows']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsTimetableViewComponent_3)),
        core_es5["ɵdid"](7, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.windowsForCampus(_v.parent.context.$implicit, _v.context.$implicit);
        _ck(_v, 7, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_WorkshopsTimetableViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'li', [['class',
                'wtv__workshop']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'div', [['class', 'wtv__workshop-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'div', [['class', 'wtv__w-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'div', [['class', 'wtv__w-meta']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsTimetableViewComponent_2)), core_es5["ɵdid"](6, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.uniqueCampuses;
        _ck(_v, 6, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.displayName;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_WorkshopsTimetableViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 17, 'div', [['class', 'workshops-timetable-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 16, 'div', [['class', 'wtv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 11, 'div', [['class', 'wtv__term-filter']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 9, 'div', [['class', 'input-group term']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 5, 'ng2-completer', [['id', 'term'], ['name', 'term']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTerm($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](8, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](10, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](12, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'label', [['for', 'term']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Active Term'])),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 3, 'div', [['class', 'wtv__workshops-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 2, 'ul', [['class', 'wtv__workshops']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsTimetableViewComponent_1)),
        core_es5["ɵdid"](18, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.terms[0];
        var currVal_10 = _co.termCompleter;
        _ck(_v, 8, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'term';
        var currVal_12 = _co.termSearchStr;
        _ck(_v, 10, 0, currVal_11, currVal_12);
        var currVal_13 = _co.workshops;
        _ck(_v, 18, 0, currVal_13);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopsTimetableViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshops-timetable-view', [], null, null, null, View_WorkshopsTimetableViewComponent_0, RenderType_WorkshopsTimetableViewComponent)), core_es5["ɵdid"](1, 114688, null, 0, workshops_timetable_view_WorkshopsTimetableViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopsTimetableViewComponentNgFactory = core_es5["ɵccf"]('workshops-timetable-view', workshops_timetable_view_WorkshopsTimetableViewComponent, View_WorkshopsTimetableViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshops-timetable-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshops-view.ts


var workshops_view_WorkshopsViewComponent = (function () {
    function WorkshopsViewComponent(store, router, activatedRoute) {
        this.store = store;
        this.router = router;
        this.activatedRoute = activatedRoute;
    }
    WorkshopsViewComponent.prototype.ngOnInit = function () {
        this.checkParamsForTab();
    };
    WorkshopsViewComponent.prototype.clickedTab = function (target) {
        this.currentTab = target;
        this.router.navigate(['workshops'], { queryParams: { tab: this.currentTab } });
    };
    WorkshopsViewComponent.prototype.checkParamsForTab = function () {
        this.currentTab = this.activatedRoute.snapshot.queryParams.tab || "bookings";
    };
    WorkshopsViewComponent.prototype.isActiveTab = function (target) {
        return target === this.currentTab;
    };
    WorkshopsViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return WorkshopsViewComponent;
}());

//# sourceMappingURL=workshops-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshops-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_WorkshopsViewComponent = [];
var RenderType_WorkshopsViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopsViewComponent, data: {} });
function View_WorkshopsViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'wv__tab-content timetable']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'workshop-bookings', [], null, null, null, View_WorkshopBookingsComponent_0, RenderType_WorkshopBookingsComponent)), core_es5["ɵdid"](2, 245760, null, 0, workshop_bookings_WorkshopBookingsComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_WorkshopsViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'wv__tab-content list']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'tutor-allocations', [], null, null, null, View_TutorAllocationsComponent_0, RenderType_TutorAllocationsComponent)), core_es5["ɵdid"](2, 114688, null, 0, tutor_allocations_TutorAllocationsComponent, [src_store["a" /* Store */], matrix_class_MatrixClassEffects, modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_WorkshopsViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'wv__tab-content list']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'workshops-timetable-view', [], null, null, null, View_WorkshopsTimetableViewComponent_0, RenderType_WorkshopsTimetableViewComponent)), core_es5["ɵdid"](2, 114688, null, 0, workshops_timetable_view_WorkshopsTimetableViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_WorkshopsViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 22, 'div', [['class',
                'workshop-view']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 21, 'div', [['class', 'wv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 20, 'div', [['class', 'wv__tabbed-container']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 12, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTab('bookings') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](6, { 'active': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Bookings'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 3, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTab('tutor-allocations') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](9, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](10, { 'active': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Tutor allocations'])), (_l()(), core_es5["ɵeld"](12, 0, null, null, 3, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTab('timetable') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](13, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](14, { 'active': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Timetable'])), (_l()(), core_es5["ɵeld"](16, 0, null, null, 6, 'div', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsViewComponent_1)), core_es5["ɵdid"](18, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsViewComponent_2)),
        core_es5["ɵdid"](20, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsViewComponent_3)), core_es5["ɵdid"](22, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 6, 0, _co.isActiveTab('bookings'));
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _ck(_v, 10, 0, _co.isActiveTab('tutor-allocations'));
        _ck(_v, 9, 0, currVal_1);
        var currVal_2 = _ck(_v, 14, 0, _co.isActiveTab('timetable'));
        _ck(_v, 13, 0, currVal_2);
        var currVal_3 = _co.isActiveTab('bookings');
        _ck(_v, 18, 0, currVal_3);
        var currVal_4 = _co.isActiveTab('tutor-allocations');
        _ck(_v, 20, 0, currVal_4);
        var currVal_5 = _co.isActiveTab('timetable');
        _ck(_v, 22, 0, currVal_5);
    }, null);
}
function View_WorkshopsViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshops-view', [], null, null, null, View_WorkshopsViewComponent_0, RenderType_WorkshopsViewComponent)), core_es5["ɵdid"](1, 114688, null, 0, workshops_view_WorkshopsViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopsViewComponentNgFactory = core_es5["ɵccf"]('workshops-view', workshops_view_WorkshopsViewComponent, View_WorkshopsViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshops-view.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/pipes/calendarDate.pipe.js
var calendarDate_pipe = __webpack_require__("q56l");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/providers/calendarDateFormatter.provider.js + 1 modules
var calendarDateFormatter_provider = __webpack_require__("+ElH");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/term.ts







var term_TermService = (function () {
    function TermService(http, actionCableService, store) {
        this.http = http;
        this.actionCableService = actionCableService;
        this.store = store;
        this.termsUrl = 'terms';
    }
    TermService.prototype.fetchTerms = function () {
        return this.http.get(this.termsUrl)
            .map(function (res) { return res.json().map(function (t) { return term_Term.clone(t); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TermService.prototype.create = function (params) {
        return this.http.post(this.termsUrl, params)
            .map(function (res) { return term_Term.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TermService.prototype.update = function (params) {
        return this.http.patch(this.termsUrl + "/" + params.id, params)
            .map(function (res) { return term_Term.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TermService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: ActionCableService }, { type: _ngrx_store["f" /* Store */] }]; };
    return TermService;
}());

//# sourceMappingURL=term.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/public-holiday.ts







var public_holiday_PublicHolidayService = (function () {
    function PublicHolidayService(http, actionCableService, store) {
        this.http = http;
        this.actionCableService = actionCableService;
        this.store = store;
        this.publicHolidaysUrl = 'public_holidays';
    }
    PublicHolidayService.prototype.create = function (params) {
        return this.http.post(this.publicHolidaysUrl, params)
            .map(function (res) { return public_holiday_PublicHoliday.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    PublicHolidayService.prototype.update = function (params) {
        return this.http.patch(this.publicHolidaysUrl + "/" + params.id, params)
            .map(function (res) { return public_holiday_PublicHoliday.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    PublicHolidayService.prototype.destroy = function (id) {
        return this.http.delete(this.publicHolidaysUrl + "/" + id)
            .map(function () { return true; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    PublicHolidayService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: ActionCableService }, { type: _ngrx_store["f" /* Store */] }]; };
    return PublicHolidayService;
}());

//# sourceMappingURL=public-holiday.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/calendar.ts


var calendar_CalendarStore = (function () {
    function CalendarStore(terms, editableTerm, editablePublicHoliday, activeDay) {
        if (terms === void 0) { terms = []; }
        if (editableTerm === void 0) { editableTerm = new term_Term(); }
        if (editablePublicHoliday === void 0) { editablePublicHoliday = new public_holiday_PublicHoliday(); }
        if (activeDay === void 0) { activeDay = null; }
        this.terms = terms;
        this.editableTerm = editableTerm;
        this.editablePublicHoliday = editablePublicHoliday;
        this.activeDay = activeDay;
    }
    return CalendarStore;
}());

//# sourceMappingURL=calendar.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/calendar.ts



var calendarReducer = function (state, action) {
    if (state === void 0) { state = new calendar_CalendarStore(); }
    switch (action.type) {
        case POPULATE_EDITABLE_TERM:
            return new calendar_CalendarStore(state.terms.slice(), term_Term.clone(action.payload), public_holiday_PublicHoliday.clone(state.editablePublicHoliday), state.activeDay);
        case POPULATE_EDITABLE_PUBLIC_HOLIDAY:
            return new calendar_CalendarStore(state.terms.slice(), term_Term.clone(state.editableTerm), public_holiday_PublicHoliday.clone(action.payload), state.activeDay);
        case POPULATE_ACTIVE_DAY:
            return new calendar_CalendarStore(state.terms.slice(), term_Term.clone(state.editableTerm), public_holiday_PublicHoliday.clone(state.editablePublicHoliday), action.payload);
        case POPULATE_CALENDAR_TERMS:
            return new calendar_CalendarStore(action.payload, term_Term.clone(state.editableTerm), public_holiday_PublicHoliday.clone(state.editablePublicHoliday), action.payload);
        default:
            return state;
    }
};
var FETCH_CALENDAR_TERMS = "FETCH_CALENDAR_TERMS";
var FETCH_CALENDAR_TERMS_FAILURE = "FETCH_CALENDAR_TERMS_FAILURE";
var POPULATE_CALENDAR_TERMS = "POPULATE_CALENDAR_TERMS";
var POPULATE_ACTIVE_DAY = "POPULATE_ACTIVE_DAY";
var POPULATE_EDITABLE_TERM = "POPULATE_EDITABLE_TERM";
var POPULATE_EDITABLE_PUBLIC_HOLIDAY = "POPULATE_EDITABLE_PUBLIC_HOLIDAY";
var UPDATE_TERM = "UPDATE_TERM";
var UPDATE_TERM_FAILURE = "UPDATE_TERM_FAILURE";
var CREATE_TERM = "CREATE_TERM";
var CREATE_TERM_FAILURE = "CREATE_TERM_FAILURE";
var UPDATE_PUBLIC_HOLIDAY = "UPDATE_PUBLIC_HOLIDAY";
var UPDATE_PUBLIC_HOLIDAY_FAILURE = "UPDATE_PUBLIC_HOLIDAY_FAILURE";
var CREATE_PUBLIC_HOLIDAY = "CREATE_PUBLIC_HOLIDAY";
var CREATE_PUBLIC_HOLIDAY_FAILURE = "CREATE_PUBLIC_HOLIDAY_FAILURE";
var DESTROY_PUBLIC_HOLIDAY = "DESTROY_PUBLIC_HOLIDAY";
var DESTROY_PUBLIC_HOLIDAY_FAILURE = "DESTROY_PUBLIC_HOLIDAY_FAILURE";
//# sourceMappingURL=calendar.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/constants.ts
var ConstantsStore = (function () {
    function ConstantsStore(constants, upcomingTerm) {
        if (constants === void 0) { constants = null; }
        if (upcomingTerm === void 0) { upcomingTerm = null; }
        this.constants = constants;
        this.upcomingTerm = upcomingTerm;
    }
    return ConstantsStore;
}());

//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/constants.ts

var constantsReducer = function (state, action) {
    if (state === void 0) { state = new ConstantsStore(); }
    switch (action.type) {
        case POPULATE_CONSTANTS:
            return new ConstantsStore(action.payload, state.upcomingTerm);
        case POPULATE_UPCOMING_TERM:
            return new ConstantsStore(state.constants, action.payload);
        default:
            return state;
    }
};
var FETCH_CONSTANTS = "FETCH_CONSTANTS";
var POPULATE_CONSTANTS = "POPULATE_CONSTANTS";
var FETCH_CONSTANTS_FAILURE = "FETCH_CONSTANTS_FAILURE";
var FETCH_UPCOMING_TERM = "FETCH_UPCOMING_TERM";
var POPULATE_UPCOMING_TERM = "POPULATE_UPCOMING_TERM";
var FETCH_UPCOMING_TERM_FAILURE = "FETCH_UPCOMING_TERM_FAILURE";
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/calendar.ts
var calendar___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var calendar___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var calendar_CalendarEffects = (function () {
    function CalendarEffects(actions, termService, publicHolidayService) {
        var _this = this;
        this.actions = actions;
        this.termService = termService;
        this.publicHolidayService = publicHolidayService;
        this.fetchTerms = this.actions
            .ofType(FETCH_CALENDAR_TERMS)
            .switchMap(function () { return _this.termService.fetchTerms()
            .map(function (terms) { return ({ type: POPULATE_CALENDAR_TERMS, payload: terms }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_CALENDAR_TERMS_FAILURE }); }); })
            .share();
        this.createTerm = this.actions
            .ofType(CREATE_TERM)
            .map(function (action) { return action.payload; })
            .switchMap(function (term) { return _this.termService.create(term.serializeForRails())
            .mergeMap(function (term) {
            return [
                { type: POPULATE_EDITABLE_TERM, payload: term },
                { type: FETCH_CONSTANTS },
            ];
        })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_TERM_FAILURE, payload: response }); }); })
            .share();
        this.updateTerm = this.actions
            .ofType(UPDATE_TERM)
            .map(function (action) { return action.payload; })
            .switchMap(function (term) { return _this.termService.update(term.serializeForRails())
            .mergeMap(function (term) {
            return [
                { type: POPULATE_EDITABLE_TERM, payload: term },
                { type: FETCH_CONSTANTS },
            ];
        })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_TERM_FAILURE, payload: response }); }); })
            .share();
        this.createPublicHoliday = this.actions
            .ofType(CREATE_PUBLIC_HOLIDAY)
            .map(function (action) { return action.payload; })
            .switchMap(function (publicHoliday) { return _this.publicHolidayService.create(publicHoliday.serializeForRails())
            .mergeMap(function (publicHoliday) {
            return [
                { type: POPULATE_EDITABLE_PUBLIC_HOLIDAY, payload: publicHoliday },
                { type: FETCH_CONSTANTS },
            ];
        })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_TERM_FAILURE, payload: response }); }); })
            .share();
        this.updatePublicHoliday = this.actions
            .ofType(UPDATE_PUBLIC_HOLIDAY)
            .map(function (action) { return action.payload; })
            .switchMap(function (publicHoliday) { return _this.publicHolidayService.update(publicHoliday.serializeForRails())
            .mergeMap(function (publicHoliday) {
            return [
                { type: POPULATE_EDITABLE_PUBLIC_HOLIDAY, payload: publicHoliday },
                { type: FETCH_CONSTANTS },
            ];
        })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_TERM_FAILURE, payload: response }); }); })
            .share();
        this.destroyPublicHoliday = this.actions
            .ofType(DESTROY_PUBLIC_HOLIDAY)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.publicHolidayService.destroy(id)
            .map(function () { return ({ type: FETCH_CONSTANTS }); })
            .catch(function (response) { return Observable["Observable"].of({ type: DESTROY_PUBLIC_HOLIDAY_FAILURE, payload: response }); }); })
            .share();
    }
    CalendarEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: term_TermService }, { type: public_holiday_PublicHolidayService }]; };
    return CalendarEffects;
}());

calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "fetchTerms", void 0);
calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "createTerm", void 0);
calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "updateTerm", void 0);
calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "createPublicHoliday", void 0);
calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "updatePublicHoliday", void 0);
calendar___decorate([
    Object(effects["b" /* Effect */])(),
    calendar___metadata("design:type", Object)
], calendar_CalendarEffects.prototype, "destroyPublicHoliday", void 0);
//# sourceMappingURL=calendar.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/calendar-day-form.ts






var calendar_day_form_CalendarDayFormComponent = (function () {
    function CalendarDayFormComponent(store, calendarEffects, modalService) {
        this.store = store;
        this.calendarEffects = calendarEffects;
        this.modalService = modalService;
    }
    CalendarDayFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.select("calendarReducer").subscribe(function (s) {
            _this.day = s.activeDay;
            _this.term = s.editableTerm;
            _this.publicHoliday = s.editablePublicHoliday;
        });
        this.setupTerm();
        this.setupPublicHoliday();
        this.setupEventEffects();
    };
    CalendarDayFormComponent.prototype.setupTerm = function () {
        if (!this.isEditingTerm()) {
            this.term.number = 1;
            this.term.startDate = moment(this.day.date).toDate();
            this.term.endDate = moment(this.day.date).add(7, "days").toDate();
        }
    };
    CalendarDayFormComponent.prototype.setupPublicHoliday = function () {
        if (!this.isEditingPublicHoliday()) {
            this.publicHoliday.date = moment(this.day.date).toDate();
            this.publicHoliday.state = "NSW";
        }
    };
    CalendarDayFormComponent.prototype.setupEventEffects = function () {
        var _this = this;
        Observable["Observable"].merge(this.calendarEffects.createTerm, this.calendarEffects.updateTerm, this.calendarEffects.createPublicHoliday, this.calendarEffects.updatePublicHoliday, this.calendarEffects.destroyPublicHoliday).subscribe(function (a) {
            switch (a.type) {
                default:
                    _this.modalService.closeModal();
            }
        });
    };
    CalendarDayFormComponent.prototype.getCalculatedEndDate = function () {
        var result;
        if (this.term.isHoliday) {
            result = moment(this.term.startDate)
                .add(10, "days")
                .toDate();
        }
        else {
            result = moment(this.term.startDate)
                .add(9, "weeks")
                .subtract(1, "days")
                .toDate();
        }
        return result;
    };
    CalendarDayFormComponent.prototype.getDayOfStartDate = function () {
        return moment(this.term.startDate).day();
    };
    CalendarDayFormComponent.prototype.setEndDateFromStartDate = function () {
        this.term.endDate = this.getCalculatedEndDate();
    };
    CalendarDayFormComponent.prototype.getEventClassNames = function (type) {
        return type.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    CalendarDayFormComponent.prototype.isEditingTerm = function () {
        return !!this.term.id;
    };
    CalendarDayFormComponent.prototype.isEditingPublicHoliday = function () {
        return !!this.publicHoliday.id;
    };
    CalendarDayFormComponent.prototype.clickedSubmitTerm = function () {
        this.setEndDateFromStartDate();
        var targetAction = this.isEditingTerm() ? UPDATE_TERM : CREATE_TERM;
        this.store.dispatch({ type: targetAction, payload: this.term });
    };
    CalendarDayFormComponent.prototype.clickedSubmitPublicHoliday = function () {
        var targetAction = this.isEditingPublicHoliday() ? UPDATE_PUBLIC_HOLIDAY : CREATE_PUBLIC_HOLIDAY;
        this.store.dispatch({ type: targetAction, payload: this.publicHoliday });
    };
    CalendarDayFormComponent.prototype.clickedDeletePublicHoliday = function () {
        this.store.dispatch({ type: DESTROY_PUBLIC_HOLIDAY, payload: this.publicHoliday.id });
    };
    CalendarDayFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: calendar_CalendarEffects }, { type: modal_ModalService }]; };
    return CalendarDayFormComponent;
}());

//# sourceMappingURL=calendar-day-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/calendar-view.ts








var calendar_view_CalendarViewComponent = (function () {
    function CalendarViewComponent(store, modalService) {
        this.store = store;
        this.modalService = modalService;
        this.VIEW_MODE = "month";
        this.view = this.VIEW_MODE;
        this.date = new Date();
        this.terms = [];
        this.publicHolidays = [];
        this.events = [];
    }
    CalendarViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.constantsSubscription =
            this.store.select("constantsReducer")
                .subscribe(function (c) {
                _this.publicHolidays = c.constants.publicHolidays;
                _this.populateEvents();
            });
        this.calendarSubscription =
            this.store.select("calendarReducer")
                .subscribe(function (c) {
                _this.terms = c.terms;
                _this.populateEvents();
            });
    };
    CalendarViewComponent.prototype.populateEvents = function () {
        this.events = this.getTermEvents(this.terms).concat(this.getPublicHolidayEvents(this.publicHolidays));
    };
    CalendarViewComponent.prototype.clickedDay = function (e) {
        var day = e.day;
        var publicHoliday = this.getPublicHolidayFromEvents(day.events);
        var term = this.getTermFromEvents(day.events);
        this.store.dispatch({ type: POPULATE_ACTIVE_DAY, payload: day });
        this.store.dispatch({ type: POPULATE_EDITABLE_TERM, payload: term });
        this.store.dispatch({ type: POPULATE_EDITABLE_PUBLIC_HOLIDAY, payload: publicHoliday });
        this.modalService.showModal(new ModalConfig(calendar_day_form_CalendarDayFormComponent));
    };
    // ////////////////////////
    // Day and event helpers.
    // ////////////////////////
    CalendarViewComponent.prototype.getPublicHolidayFromEvents = function (events) {
        var event = events.find(function (e) {
            return e.meta.type === "publicHoliday";
        });
        return event ? this.publicHolidays.find((function (ph) { return ph.id === event.meta.id; })) : new public_holiday_PublicHoliday();
    };
    CalendarViewComponent.prototype.getTermFromEvents = function (events) {
        var event = events.find(function (e) {
            return e.meta.type === "term";
        });
        return event ? this.terms.find((function (t) { return t.id === event.meta.id; })) : new term_Term();
    };
    CalendarViewComponent.prototype.getTermEvents = function (terms) {
        var result = terms.map(function (t) {
            return {
                title: t.name,
                color: { primary: "#a40930", secondary: "#f9d1db" },
                start: t.startDate,
                end: t.endDate,
                meta: { type: "term", id: t.id, term: t },
            };
        });
        terms.forEach(function (t) {
            t.extraDays.forEach(function (ed) {
                result.push({
                    title: "For: " + ed.publicHoliday.name,
                    color: { primary: "#a40930", secondary: "#f9d1db" },
                    start: ed.date,
                    allDay: true,
                    meta: {
                        type: "extraDay",
                        id: t.id,
                        term: t,
                        publicHoliday: ed.publicHoliday
                    },
                });
            });
        });
        return result;
    };
    CalendarViewComponent.prototype.getTermEvent = function (day) {
        return day.events.filter(function (e) {
            return e.meta.type === "term";
        })[0];
    };
    CalendarViewComponent.prototype.getTermWeek = function (day) {
        var result = 0;
        var termEvent = this.getTermEvent(day);
        var targetDate = new Date(day.date);
        var startDate = new Date(termEvent.start);
        var WEEK = 1000 * 60 * 60 * 24 * 7;
        var startDateMs = startDate.getTime();
        var endDateMs = targetDate.getTime();
        var delta = Math.abs(endDateMs - startDateMs);
        return Math.floor(delta / WEEK) + 1;
    };
    CalendarViewComponent.prototype.getPublicHolidayEvents = function (publicHolidays) {
        return publicHolidays.map(function (ph) {
            return {
                title: ph.name,
                color: { primary: "#1985d4", secondary: "#b8dbf5" },
                start: ph.date,
                allDay: true,
                meta: { type: "publicHoliday", id: ph.id },
            };
        });
    };
    CalendarViewComponent.prototype.getDate = function (date) {
        return date.getDate().toString();
    };
    CalendarViewComponent.prototype.getPublicHolidayNameFromDay = function (day) {
        return day.events.find(function (e) {
            return e.meta.type === "publicHoliday";
        }).title;
    };
    CalendarViewComponent.prototype.getExtraDayNameFromDay = function (day) {
        return day.events.find(function (e) {
            return e.meta.type === "extraDay";
        }).title;
    };
    CalendarViewComponent.prototype.isDayInTerm = function (day) {
        var d = moment(day.date).day();
        var inTerm = day.events.filter(function (e) {
            return e.meta.type === "term";
        }).length > 0;
        var fallsOnHolidayTermAndWeekend = day
            .events
            .filter(function (e) {
            return (e.meta.type === "term" &&
                e.meta.term.isHoliday &&
                (d === 0 || d === 6));
        })
            .length > 0;
        var isExtraDay = day
            .events
            .filter(function (e) { return e.meta.type === "extraDay"; })
            .length > 0;
        var result = false;
        if (inTerm) {
            result = true;
        }
        if (inTerm && fallsOnHolidayTermAndWeekend) {
            result = false;
        }
        if (isExtraDay) {
            result = true;
        }
        return result;
    };
    CalendarViewComponent.prototype.isExtraDay = function (day) {
        return day.events.filter(function (e) {
            return e.meta.type == "extraDay";
        }).length > 0;
    };
    CalendarViewComponent.prototype.isDayToday = function (day) {
        return day.date.getTime() === Utilities.makeDate(new Date()).getTime();
    };
    CalendarViewComponent.prototype.isDayMonday = function (day) {
        return day.date.getDay() === 1;
    };
    CalendarViewComponent.prototype.isDayPublicHoliday = function (day) {
        return day.events.filter(function (e) {
            return e.meta.type === "publicHoliday";
        }).length > 0;
    };
    CalendarViewComponent.prototype.ngOnDestroy = function () {
        this.constantsSubscription.unsubscribe();
        this.calendarSubscription.unsubscribe();
    };
    CalendarViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: modal_ModalService }]; };
    return CalendarViewComponent;
}());

//# sourceMappingURL=calendar-view.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/directives/calendarNextView.directive.js
var calendarNextView_directive = __webpack_require__("g5nS");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/directives/calendarPreviousView.directive.js
var calendarPreviousView_directive = __webpack_require__("u6Re");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/src/$$_gendir/node_modules/angular-calendar/dist/esm/src/components/month/calendarMonthView.component.ngfactory.ts + 5 modules
var calendarMonthView_component_ngfactory = __webpack_require__("Bfmn");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/components/month/calendarMonthView.component.js
var calendarMonthView_component = __webpack_require__("4QW5");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/providers/calendarUtils.provider.js + 1 modules
var calendarUtils_provider = __webpack_require__("K7tZ");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/calendar-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_CalendarViewComponent = [];
var RenderType_CalendarViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalendarViewComponent, data: {} });
function View_CalendarViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, [' | Today']))], null, null);
}
function View_CalendarViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'cvc__badge term-details']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', ','])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['\nWeek ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getTermEvent(_v.parent.context.day).title;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.getTermWeek(_v.parent.context.day);
        _ck(_v, 3, 0, currVal_1);
    });
}
function View_CalendarViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cvc__badge public-holiday']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getPublicHolidayNameFromDay(_v.parent.context.day);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalendarViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cvc__badge extra-day']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getExtraDayNameFromDay(_v.parent.context.day);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalendarViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 13, 'div', [['class',
                'calendar-view-cell']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 12, 'div', [['class',
                'cvc__content-wrapper']], null, null, null, null, null)), core_es5["ɵdid"](2, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](3, { 'term': 0, 'today': 1 }), (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'div', [['class', 'cvc__date']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarViewComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarViewComponent_3)),
        core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarViewComponent_4)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarViewComponent_5)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'cvc__content-wrapper';
        var currVal_1 = _ck(_v, 3, 0, _co.isDayInTerm(_v.context.day), _co.isDayToday(_v.context.day));
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = _co.isDayToday(_v.context.day);
        _ck(_v, 7, 0, currVal_3);
        var currVal_4 = (_co.isDayInTerm(_v.context.day) && _co.isDayMonday(_v.context.day));
        _ck(_v, 9, 0, currVal_4);
        var currVal_5 = _co.isDayPublicHoliday(_v.context.day);
        _ck(_v, 11, 0, currVal_5);
        var currVal_6 = _co.isExtraDay(_v.context.day);
        _ck(_v, 13, 0, currVal_6);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.getDate(_v.context.day.date);
        _ck(_v, 5, 0, currVal_2);
    });
}
function View_CalendarViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, calendarDate_pipe["a" /* CalendarDatePipe */], [calendarDateFormatter_provider["a" /* CalendarDateFormatter */], core_es5["LOCALE_ID"]]),
        (_l()(), core_es5["ɵand"](0, [['customCellTemplate', 2]], null, 0, null, View_CalendarViewComponent_1)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 12, 'div', [['class', 'calendar-view']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 11, 'div', [['class', 'cv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 7, 'div', [['class', 'cv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 6, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ''])), core_es5["ɵppd"](7, 3), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'a', [['class', 'cv__link-next-month'], ['mwlCalendarNextView', '']], null, [[null, 'viewDateChange'], [null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('viewDateChange' === en)) {
                var pd_1 = ((_co.date = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](9, 16384, null, 0, calendarNextView_directive["a" /* CalendarNextViewDirective */], [], { view: [0, 'view'], viewDate: [1, 'viewDate'] }, { viewDateChange: 'viewDateChange' }),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'a', [['class', 'cv__link-previous-month'],
            ['mwlCalendarPreviousView', '']], null, [[null, 'viewDateChange'],
            [null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('viewDateChange' === en)) {
                var pd_1 = ((_co.date = $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](11, 16384, null, 0, calendarPreviousView_directive["a" /* CalendarPreviousViewDirective */], [], { view: [0, 'view'], viewDate: [1, 'viewDate'] }, { viewDateChange: 'viewDateChange' }),
        (_l()(), core_es5["ɵeld"](12, 0, null, null, 2, 'div', [['class', 'cv__calendar-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'mwl-calendar-month-view', [], null, [[null, 'dayClicked']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('dayClicked' === en)) {
                var pd_0 = (_co.clickedDay($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, calendarMonthView_component_ngfactory["b" /* View_CalendarMonthViewComponent_0 */], calendarMonthView_component_ngfactory["a" /* RenderType_CalendarMonthViewComponent */])),
        core_es5["ɵdid"](14, 770048, null, 0, calendarMonthView_component["a" /* CalendarMonthViewComponent */], [core_es5["ChangeDetectorRef"],
            calendarUtils_provider["a" /* CalendarUtils */], core_es5["LOCALE_ID"]], { viewDate: [0, 'viewDate'], events: [1, 'events'],
            weekStartsOn: [2, 'weekStartsOn'], cellTemplate: [3, 'cellTemplate'] }, { dayClicked: 'dayClicked' })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.view;
        var currVal_2 = _co.date;
        _ck(_v, 9, 0, currVal_1, currVal_2);
        var currVal_3 = _co.view;
        var currVal_4 = _co.date;
        _ck(_v, 11, 0, currVal_3, currVal_4);
        var currVal_5 = _co.date;
        var currVal_6 = _co.events;
        var currVal_7 = 1;
        var currVal_8 = core_es5["ɵnov"](_v, 1);
        _ck(_v, 14, 0, currVal_5, currVal_6, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 6, 0, _ck(_v, 7, 0, core_es5["ɵnov"](_v, 0), _co.date, (_co.view + 'ViewTitle'), 'en'));
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_CalendarViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'calendar-view', [], null, null, null, View_CalendarViewComponent_0, RenderType_CalendarViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, calendar_view_CalendarViewComponent, [src_store["a" /* Store */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CalendarViewComponentNgFactory = core_es5["ɵccf"]('calendar-view', calendar_view_CalendarViewComponent, View_CalendarViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calendar-view.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/comms.ts
var CommsStore = (function () {
    function CommsStore(templates, commSends, commReceipts, emailPreview, numberOfRecipients) {
        if (templates === void 0) { templates = []; }
        if (commSends === void 0) { commSends = []; }
        if (commReceipts === void 0) { commReceipts = []; }
        if (emailPreview === void 0) { emailPreview = null; }
        if (numberOfRecipients === void 0) { numberOfRecipients = null; }
        this.templates = templates;
        this.commSends = commSends;
        this.commReceipts = commReceipts;
        this.emailPreview = emailPreview;
        this.numberOfRecipients = numberOfRecipients;
    }
    CommsStore.clone = function (store) {
        var result = new this();
        result.templates = store.templates.slice();
        result.commSends = store.commSends.slice();
        result.commReceipts = store.commReceipts.slice();
        result.emailPreview = store.emailPreview;
        result.numberOfRecipients = store.numberOfRecipients;
        return result;
    };
    return CommsStore;
}());

//# sourceMappingURL=comms.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/comms.ts

var commsReducer = function (state, action) {
    if (state === void 0) { state = new CommsStore(); }
    var s = CommsStore.clone(state);
    switch (action.type) {
        case POPULATE_TEMPLATES:
            s.templates = action.payload;
            return s;
        case POPULATE_COMM_SENDS:
            s.commSends = action.payload;
            return s;
        case POPULATE_COMM_RECEIPTS:
            s.commReceipts = action.payload;
            return s;
        case POPULATE_EMAIL_PREVIEW:
            s.emailPreview = action.payload;
            return s;
        case POPULATE_NUMBER_OF_RECIPIENTS:
            s.numberOfRecipients = action.payload;
            return s;
        default:
            return s;
    }
};
var FETCH_TEMPLATES = "FETCH_TEMPLATES";
var FETCH_TEMPLATES_FAILURE = "FETCH_TEMPLATES_FAILURE";
var POPULATE_TEMPLATES = "POPULATE_TEMPLATES";
var RELOAD_EMAIL_TEMPLATES = "RELOAD_EMAIL_TEMPLATES";
var RELOAD_EMAIL_TEMPLATES_SUCCESS = "RELOAD_EMAIL_TEMPLATES_SUCCESS";
var RELOAD_EMAIL_TEMPLATES_FAILURE = "RELOAD_EMAIL_TEMPLATES_FAILURE";
var SEND_COMM = "SEND_COMM";
var SENT_COMM = "SENT_COMM";
var SEND_COMM_FAILURE = "SENT_COMM_FAILURE";
var FETCH_COMM_SENDS = "FETCH_EMAIL_SENDS";
var POPULATE_COMM_SENDS = "POPULATE_COMM_SENDS";
var FETCH_COMM_SENDS_FAILURE = "FETCH_COMM_SENDS_FAILURE";
var FETCH_COMM_RECEIPTS = "FETCH_COMM_RECEIPTS";
var POPULATE_COMM_RECEIPTS = "POPULATE_COMM_RECEIPTS";
var FETCH_COMM_RECEIPTS_FAILURE = "FETCH_COMM_RECEIPTS_FAILURE";
var FETCH_EMAIL_PREVIEW = "FETCH_EMAIL_PREVIEW";
var POPULATE_EMAIL_PREVIEW = "POPULATE_EMAIL_PREVIEW";
var FETCH_EMAIL_PREVIEW_FAILURE = "FETCH_EMAIL_PREVIEW_FAILURE";
var GET_NUMBER_OF_RECIPIENTS = "GET_NUMBER_OF_RECIPIENTS";
var POPULATE_NUMBER_OF_RECIPIENTS = "POPULATE_NUMBER_OF_RECIPIENTS";
var GET_NUMBER_OF_RECIPIENTS_FAILURE = "GET_NUMBER_OF_RECIPIENTS_FAILURE";
//# sourceMappingURL=comms.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/comms.ts
var COMM_OF_TYPES;
(function (COMM_OF_TYPES) {
    COMM_OF_TYPES[COMM_OF_TYPES["Email"] = 0] = "Email";
    COMM_OF_TYPES[COMM_OF_TYPES["Sms"] = 1] = "Sms";
})(COMM_OF_TYPES || (COMM_OF_TYPES = {}));
//# sourceMappingURL=comms.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/comms-sends-view.ts





var comms_sends_view_CommsSendsViewComponent = (function () {
    function CommsSendsViewComponent(store, router, activatedRoute, htmlSanitizer) {
        this.store = store;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.htmlSanitizer = htmlSanitizer;
        this.mode = "email";
        this.commSends = [];
        this.commReceipts = [];
        this.sanatizedTemplateBodyHtml = null;
    }
    CommsSendsViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.commsSubscription =
            this.store.select("commsReducer")
                .subscribe(function (s) {
                _this.commSends = s.commSends;
                _this.commReceipts = s.commReceipts;
            });
        this.initialSetup();
    };
    CommsSendsViewComponent.prototype.initialSetup = function () {
        var typeOf;
        switch (this.mode) {
            case "email": {
                typeOf = COMM_OF_TYPES.Email;
                break;
            }
            case "sms": {
                typeOf = COMM_OF_TYPES.Sms;
                break;
            }
        }
        var payload = { type_of: typeOf };
        this.store.dispatch({ type: FETCH_COMM_SENDS, payload: payload });
    };
    CommsSendsViewComponent.prototype.clickedCommSend = function (cs) {
        if (cs.isShowingEmailReceipts) {
            cs.isShowingEmailReceipts = false;
        }
        else {
            this.commSends.forEach(function (cs) { return cs.isShowingEmailReceipts = false; });
            cs.isShowingEmailReceipts = true;
            this.sanatizedTemplateBodyHtml =
                this.htmlSanitizer.bypassSecurityTrustResourceUrl("data:text/html;charset=utf-8," + cs.messageBody);
            var payload = { comm_send_id: cs.id };
            this.store.dispatch({ type: FETCH_COMM_RECEIPTS, payload: payload });
        }
    };
    CommsSendsViewComponent.prototype.isEmailPreviewShowing = function () {
        return this.mode == "email" && !!this.sanatizedTemplateBodyHtml;
    };
    CommsSendsViewComponent.prototype.ngOnDestroy = function () {
        this.commsSubscription.unsubscribe();
    };
    CommsSendsViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: platform_browser_es5["c" /* DomSanitizer */] }]; };
    return CommsSendsViewComponent;
}());

//# sourceMappingURL=comms-sends-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/comms-sends-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_CommsSendsViewComponent = [];
var RenderType_CommsSendsViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CommsSendsViewComponent, data: {} });
function View_CommsSendsViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'tr', [['class',
                'csv__email-receipt']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'td', [['class',
                'receipient-name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'td', [['class', 'recipient-address']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'td', [['class', 'status right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ' ', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.recipientName;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.recipientAddress;
        _ck(_v, 4, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.status;
        var currVal_3 = (_v.context.$implicit.rejectReason ? ('|' + _v.context.$implicit.rejectReason) : '');
        _ck(_v, 6, 0, currVal_2, currVal_3);
    });
}
function View_CommsSendsViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'iframe', [['class',
                'csv__email-receipt-preview']], [[8, 'src', 5]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sanatizedTemplateBodyHtml;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CommsSendsViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'tr', [['class',
                'no-hover']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 6, 'td', [['class', 'csv__email-receipts-wrapper'],
            ['colspan', '2']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'table', [['class', 'csv__email-receipts']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsSendsViewComponent_3)), core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsSendsViewComponent_4)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.commReceipts;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isEmailPreviewShowing();
        _ck(_v, 7, 0, currVal_1);
    }, null);
}
function View_CommsSendsViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 18, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 15, 'tr', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCommSend(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](2, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](3, { 'open': 0 }), (_l()(), core_es5["ɵeld"](4, 0, null, null, 9, 'td', [['class', 'description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ''])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 6, 'label', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Sent by '])), (_l()(), core_es5["ɵeld"](9, 0, null, null, 3, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 10).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](10, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["LocationStrategy"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](11, 2), (_l()(), core_es5["ɵted"](12, null, ['', ''])),
        (_l()(), core_es5["ɵted"](13, null, [' to ', ' recipients'])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 2, 'td', [['class', 'date right']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](15, null, ['', ''])), core_es5["ɵppd"](16, 2), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsSendsViewComponent_2)), core_es5["ɵdid"](18, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var currVal_0 = _ck(_v, 3, 0, _v.context.$implicit.isShowingEmailReceipts);
        _ck(_v, 2, 0, currVal_0);
        var currVal_4 = _ck(_v, 11, 0, '/contacts', _v.context.$implicit.user.contact.id);
        _ck(_v, 10, 0, currVal_4);
        var currVal_8 = _v.context.$implicit.isShowingEmailReceipts;
        _ck(_v, 18, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.description;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = core_es5["ɵnov"](_v, 10).target;
        var currVal_3 = core_es5["ɵnov"](_v, 10).href;
        _ck(_v, 9, 0, currVal_2, currVal_3);
        var currVal_5 = _v.context.$implicit.user.contact.fullName;
        _ck(_v, 12, 0, currVal_5);
        var currVal_6 = _v.context.$implicit.numberOfRecipients;
        _ck(_v, 13, 0, currVal_6);
        var currVal_7 = core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v.parent, 0), _v.context.$implicit.processedAt, 'yyyy-MM-dd HH:mm'));
        _ck(_v, 15, 0, currVal_7);
    });
}
function View_CommsSendsViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class', 'comms-sends-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'div', [['class', 'csv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Email Sends from the last 7 days'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 3, 'table', [['class', 'csv__email-sends']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsSendsViewComponent_1)),
        core_es5["ɵdid"](8, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.commSends;
        _ck(_v, 8, 0, currVal_0);
    }, null);
}
function View_CommsSendsViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'comms-sends-view', [], null, null, null, View_CommsSendsViewComponent_0, RenderType_CommsSendsViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, comms_sends_view_CommsSendsViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], platform_browser_es5["c" /* DomSanitizer */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CommsSendsViewComponentNgFactory = core_es5["ɵccf"]('comms-sends-view', comms_sends_view_CommsSendsViewComponent, View_CommsSendsViewComponent_Host_0, { mode: 'mode' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=comms-sends-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/template.ts
var template___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Template = (function (_super) {
    template___extends(Template, _super);
    function Template(id, description, subject, body, labels, typeOf, slug) {
        if (description === void 0) { description = null; }
        if (subject === void 0) { subject = null; }
        if (body === void 0) { body = null; }
        if (labels === void 0) { labels = []; }
        if (typeOf === void 0) { typeOf = 0; }
        if (slug === void 0) { slug = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.description = description;
        _this.subject = subject;
        _this.body = body;
        _this.labels = labels;
        _this.typeOf = typeOf;
        _this.slug = slug;
        return _this;
    }
    Template.clone = function (obj) {
        var result = new this();
        if (obj.id) {
            result.id = obj.id;
        }
        if (obj.description) {
            result.description = obj.description;
        }
        if (obj.subject) {
            result.subject = obj.subject;
        }
        if (obj.body) {
            result.body = obj.body;
        }
        if (obj.labels) {
            result.labels = JSON.parse(obj.labels);
        }
        if (obj.typeOf != undefined) {
            result.typeOf = obj.typeOf;
        }
        if (obj.slug) {
            result.slug = obj.slug;
        }
        return result;
    };
    return Template;
}(Model));

//# sourceMappingURL=template.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/comm-send.ts
var comm_send___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var comm_send_CommSend = (function (_super) {
    comm_send___extends(CommSend, _super);
    function CommSend(id, userId, templateId, user, processedAt, description, numberOfRecipients, messageBody, template, isShowingEmailReceipts, createdAt, updatedAt) {
        if (user === void 0) { user = null; }
        if (processedAt === void 0) { processedAt = null; }
        if (description === void 0) { description = null; }
        if (numberOfRecipients === void 0) { numberOfRecipients = null; }
        if (messageBody === void 0) { messageBody = null; }
        if (template === void 0) { template = null; }
        if (isShowingEmailReceipts === void 0) { isShowingEmailReceipts = false; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.userId = userId;
        _this.templateId = templateId;
        _this.user = user;
        _this.processedAt = processedAt;
        _this.description = description;
        _this.numberOfRecipients = numberOfRecipients;
        _this.messageBody = messageBody;
        _this.template = template;
        _this.isShowingEmailReceipts = isShowingEmailReceipts;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    CommSend.clone = function (obj) {
        var o = new this();
        if (obj.id) {
            o.id = obj.id;
        }
        if (obj.userId) {
            o.userId = obj.userId;
        }
        if (obj.templateId) {
            o.templateId = obj.templateId;
        }
        if (obj.user) {
            o.user = user_User.clone(obj.user);
        }
        if (obj.processedAt) {
            o.processedAt = new Date(obj.processedAt);
        }
        if (obj.description) {
            o.description = obj.description;
        }
        if (obj.numberOfRecipients) {
            o.numberOfRecipients = obj.numberOfRecipients;
        }
        if (obj.messageBody) {
            o.messageBody = obj.messageBody;
        }
        if (obj.template) {
            o.template = Template.clone(obj.template);
        }
        if (obj.updatedAt) {
            o.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.createdAt) {
            o.createdAt = new Date(obj.createdAt);
        }
        return o;
    };
    return CommSend;
}(Model));

//# sourceMappingURL=comm-send.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/comm-receipt.ts
var comm_receipt___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CommReceipt = (function (_super) {
    comm_receipt___extends(CommReceipt, _super);
    function CommReceipt(id, commSendId, status, rejectReason, mandrillId, recipientName, recipientAddress, createdAt, updatedAt) {
        if (status === void 0) { status = null; }
        if (rejectReason === void 0) { rejectReason = null; }
        if (mandrillId === void 0) { mandrillId = null; }
        if (recipientName === void 0) { recipientName = null; }
        if (recipientAddress === void 0) { recipientAddress = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.commSendId = commSendId;
        _this.status = status;
        _this.rejectReason = rejectReason;
        _this.mandrillId = mandrillId;
        _this.recipientName = recipientName;
        _this.recipientAddress = recipientAddress;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    CommReceipt.clone = function (obj) {
        var o = new this();
        if (obj.id) {
            o.id = obj.id;
        }
        if (obj.commSendId) {
            o.commSendId = obj.commSendId;
        }
        if (obj.status) {
            o.status = obj.status;
        }
        if (obj.rejectReason) {
            o.rejectReason = obj.rejectReason;
        }
        if (obj.mandrillId) {
            o.mandrillId = obj.mandrillId;
        }
        if (obj.recipientName) {
            o.recipientName = obj.recipientName;
        }
        if (obj.recipientAddress) {
            o.recipientAddress = obj.recipientAddress;
        }
        if (obj.updatedAt) {
            o.updatedAt = new Date(obj.updatedAt);
        }
        if (obj.createdAt) {
            o.createdAt = new Date(obj.createdAt);
        }
        return o;
    };
    return CommReceipt;
}(Model));

//# sourceMappingURL=comm-receipt.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/comm.ts






var commsUrl = "communications";
var templatesUrl = "templates";
var comm_CommService = (function () {
    function CommService(http) {
        this.http = http;
    }
    CommService.prototype.templatesIndex = function () {
        return this.http.get(templatesUrl + "?external=true")
            .map(function (res) { return res.json().map(function (t) { return Template.clone(t); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.commSendsIndex = function (params) {
        var search = new http_es5["k" /* URLSearchParams */]();
        for (var key in params) {
            search.set(key, params[key]);
        }
        return this.http.get(commsUrl + "/comm_sends", { search: search })
            .map(function (res) { return res.json().map(function (cs) { return comm_send_CommSend.clone(cs); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.commReceiptsIndex = function (params) {
        var search = new http_es5["k" /* URLSearchParams */]();
        for (var key in params) {
            search.set(key, params[key]);
        }
        return this.http.get(commsUrl + "/comm_receipts", { search: search })
            .map(function (res) { return res.json().map(function (cr) { return CommReceipt.clone(cr); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.emailPreview = function (params) {
        return this.http.patch(commsUrl + "/email_preview", params)
            .map(function (res) { return res.json().html; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.numberOfRecipients = function (params) {
        return this.http.patch(commsUrl + "/number_of_recipients", params)
            .map(function (res) { return res.json().count; })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.reloadEmailTemplates = function () {
        return this.http.patch(templatesUrl + "/reload_email_templates", {})
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.prototype.sendComm = function (payload) {
        return this.http.post(commsUrl + "/send_comm", payload)
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    CommService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return CommService;
}());

//# sourceMappingURL=comm.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/recipient.ts
var recipient___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Recipient = (function (_super) {
    recipient___extends(Recipient, _super);
    function Recipient(contactId, courseId, matrixClassId, grade, title, query) {
        if (contactId === void 0) { contactId = null; }
        if (courseId === void 0) { courseId = null; }
        if (matrixClassId === void 0) { matrixClassId = null; }
        if (grade === void 0) { grade = null; }
        if (title === void 0) { title = null; }
        if (query === void 0) { query = null; }
        var _this = _super.call(this) || this;
        _this.contactId = contactId;
        _this.courseId = courseId;
        _this.matrixClassId = matrixClassId;
        _this.grade = grade;
        _this.title = title;
        _this.query = query;
        return _this;
    }
    Recipient.clone = function (obj) {
        var o = new this();
        if (obj.contactId) {
            o.contactId = obj.contactId;
        }
        if (obj.courseId) {
            o.courseId = obj.courseId;
        }
        if (obj.matrixClassId) {
            o.matrixClassId = obj.matrixClassId;
        }
        if (obj.grade) {
            o.grade = obj.grade;
        }
        if (obj.title) {
            o.title = obj.title;
        }
        if (obj.query) {
            o.query = obj.query;
        }
        return o;
    };
    return Recipient;
}(Model));

//# sourceMappingURL=recipient.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/sms-templates.ts

var SMS_TEMPLATES = [
    new Template(-1, 'Class Schedule Reminder', null, 'This is a friendly reminder that your <class> for <term> starts on <date> <time> at <campus>. Matrix Education 1300 008 008', ['allUsers'], 1, 'class-schedule-reminder'),
    new Template(-1, 'Cancelled Class', null, 'Your <class> lesson has been postponed for today. A replacement lesson will be held in Week 10. Apologies and kindest regards, Matrix Education 1300 008 008', ['allUsers'], 1, 'cancelled-class'),
    new Template(-1, 'Maths Homework Reminder', null, 'All Maths homework must be submitted by your child’s last lesson of the term. Any homework submitted after this will not be marked – Maths Team 1300 008 008', ['allUsers'], 1, 'maths-homework-reminder'),
    new Template(-1, 'No Homework Submission', null, '<student> has not submitted his/her <subject> homework. Please speak to <student> about completing his/her homework next week. Matrix 1300 008 008>', ['allUsers'], 1, 'no-homework-submission'),
    new Template(-1, 'Replacement Class Schedule Reminder', null, 'Hi <name>, this is a reminder that you will be teaching <class> tomorrow <time> at <campus>. Matrix Education 1300 008 008', ['allUsers'], 1, 'replacement-class-schedule-reminder'),
    new Template(-1, 'Teacher Class Schedule Reminder', null, 'Hi <name>, this is a reminder of your teaching schedule on <date>: <class> at <campus>. Matrix Education 1300 008 008', ['allUsers'], 1, 'teacher-class-schedule-reminder'),
    new Template(-1, 'Week 10 Class Reminder', null, 'This is a friendly reminder that you have a Week 10 class for <class> tomorrow at <campus>. Matrix Education 1300 008 008', ['allUsers'], 1, 'week-10-class-reminder'),
];
//# sourceMappingURL=sms-templates.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/comms-form.ts












var SEND_TO_EMAIL_TYPES = [
    { title: "Student", value: 0 },
    { title: "Parent", value: 1 },
    { title: "Staff", value: 2 },
];
var SEND_TO_SMS_TYPES = [
    { title: "Student", value: 0 },
    { title: "Parent", value: 1 },
    { title: "Staff", value: 2 },
    { title: "Group", value: 3 },
];
var comms_form_CommsFormComponent = (function () {
    function CommsFormComponent(store, actions, router, activatedRoute, completerService, http, htmlSanitizer, el) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.completerService = completerService;
        this.http = http;
        this.htmlSanitizer = htmlSanitizer;
        this.el = el;
        this.mode = "email";
        this.subscriptions = [];
        this.terms = [];
        this.templates = [];
        this.recipients = [];
        this.activeSendTo = null;
        this.activeVariablePreviewRecipient = null;
        this.isInVariablePreviewMode = false;
        this.isUsingCustomisedTemplate = false;
        this.isSendingComm = false;
        this.isSuccessFlashVisible = false;
        this.numberOfRecipients = 0;
        this.sanatizedTemplateBodyHtml = null;
        this.sanatizedVariablePreviewHtml = null;
        this.editedTemplateBody = null;
        this.enquiryId = null;
        this.enquirySendTo = null;
        this.enquiryName = null;
        this.isSendingSpecialEnquiryEmail = false;
    }
    CommsFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptions.push(this.store.select("commsReducer")
            .subscribe(function (s) {
            _this.templates = s.templates;
            _this.sanatizedVariablePreviewHtml = _this.sanatiseHtml(s.emailPreview);
            _this.numberOfRecipients = s.numberOfRecipients;
        }));
        this.subscriptions.push(this.store.select("constantsReducer")
            .subscribe(function (s) {
            _this.terms = s.constants.terms;
            if (!_this.activeTerm) {
                _this.activeTerm = _this.terms[0];
            }
        }));
        switch (this.mode) {
            case "email": {
                this.setupEmailCompleters();
                this.handleSpecialEnquiryEmailScenario();
                this.setupVariablePreviewCompleter();
                break;
            }
            case "sms": {
                this.setupSmsCompleters();
                this.setupInitialSmsState();
                break;
            }
        }
        this.setupSharedCompleters();
    };
    CommsFormComponent.prototype.setupEmailCompleters = function () {
        this.sendToSearchCompleter =
            this.completerService.local(SEND_TO_EMAIL_TYPES, "title", "title");
        this.templateCompleter =
            this.completerService.local(this.templates, "description", "description");
    };
    CommsFormComponent.prototype.setupSharedCompleters = function () {
        this.termCompleter =
            this.completerService.local(this.terms, "name", "name");
        this.setupRecipientCompleter();
    };
    CommsFormComponent.prototype.setupSmsCompleters = function () {
        this.templateCompleter =
            this.completerService.local(SMS_TEMPLATES, "description", "description");
        this.sendToSearchCompleter =
            this.completerService.local(SEND_TO_SMS_TYPES, "title", "title");
    };
    CommsFormComponent.prototype.setupRecipientCompleter = function () {
        if (this.activeTerm) {
            var url = commsUrl + "/recipients?term_id=" + this.activeTerm.id + "&query=";
            this.recipientCompleter =
                this.completerService.remote(url, "title,query", "title");
            this.recipientCompleter.requestOptions(new http_es5["i" /* RequestOptions */]({
                headers: this.http.currentAuthHeaders,
            }));
        }
    };
    CommsFormComponent.prototype.setupVariablePreviewCompleter = function () {
        this.variablePreviewCompleter =
            this.completerService.local(this.recipients, "title", "title");
    };
    CommsFormComponent.prototype.setupInitialSmsState = function () {
        // NOTE: For SMS this is always true. The template is merely a scaffold for
        // the customer rep to customise and send.
        this.isUsingCustomisedTemplate = true;
    };
    CommsFormComponent.prototype.isSendToPickerVisible = function () {
        var result = false;
        switch (this.mode) {
            case "email": {
                result = !!this.activeTemplate &&
                    this.activeTemplate.labels.includes("allUsers");
                break;
            }
            case "sms": {
                result = true;
            }
        }
        return result;
    };
    CommsFormComponent.prototype.isToggleVariablePreviewEnabled = function () {
        return this.activeTemplate && this.activeTerm && this.recipients.length > 0;
    };
    CommsFormComponent.prototype.clickedToggleVariablePreview = function () {
        if (this.isInVariablePreviewMode) {
            this.isInVariablePreviewMode = false;
            this.sanatizedVariablePreviewHtml = null;
        }
        else {
            this.isInVariablePreviewMode = true;
        }
    };
    CommsFormComponent.prototype.clickedRemoveRecipient = function (recipient) {
        this.recipients = this.recipients.filter(function (r) { return r != recipient; });
        this.setupVariablePreviewCompleter();
        this.refreshNumberOfRecipients();
    };
    CommsFormComponent.prototype.clickedCustomiseTemplate = function () {
        this.isUsingCustomisedTemplate = !this.isUsingCustomisedTemplate;
        this.sanatizedVariablePreviewHtml = null;
    };
    CommsFormComponent.prototype.clickedSend = function () {
        var _this = this;
        var payload = {
            recipients: this.recipients,
            sendTo: this.activeSendTo,
            termId: this.activeTerm.id,
            templateId: this.activeTemplate.id,
            enquirySendTo: this.enquirySendTo,
            enquiryId: this.enquiryId,
        };
        this.checkAndSetEditableTemplateBodyForEmailMode();
        if (this.editedTemplateBody) {
            payload.edited_template_body = this.editedTemplateBody;
        }
        this.isSendingComm = true;
        this.actions
            .ofType(SENT_COMM)
            .take(1)
            .subscribe(function () {
            _this.isSendingComm = false;
            _this.flashSuccessMessage();
        });
        this.store.dispatch({ type: SEND_COMM, payload: payload });
    };
    CommsFormComponent.prototype.flashSuccessMessage = function () {
        var _this = this;
        this.isSuccessFlashVisible = true;
        this.recipients = [];
        setTimeout(function () {
            _this.isSuccessFlashVisible = false;
        }, 5000);
    };
    CommsFormComponent.prototype.selectedTerm = function (e) {
        if (e) {
            this.activeTerm = e.originalObject;
        }
        else {
            this.activeTerm = null;
        }
        this.setupRecipientCompleter();
    };
    CommsFormComponent.prototype.selectedTemplate = function (e) {
        if (e) {
            this.activeTemplate = e.originalObject;
            switch (this.mode) {
                case "email": {
                    this.sanatizedTemplateBodyHtml = this.sanatiseHtml(this.activeTemplate.body);
                    break;
                }
                case "sms": {
                    this.editedTemplateBody = this.activeTemplate.body;
                    break;
                }
            }
        }
        else {
            this.activeTemplate = null;
        }
    };
    CommsFormComponent.prototype.sanatiseHtml = function (htmlString) {
        if (htmlString) {
            return this.htmlSanitizer.bypassSecurityTrustHtml(htmlString);
        }
        else {
            return null;
        }
    };
    CommsFormComponent.prototype.selectedRecipient = function (e) {
        if (e) {
            var recipient = Recipient.clone(e.originalObject);
            this.recipients.push(recipient);
            this.setupVariablePreviewCompleter();
            this.refreshNumberOfRecipients();
        }
    };
    CommsFormComponent.prototype.selectedSendTo = function (e) {
        if (e) {
            this.activeSendTo = e.originalObject.value;
        }
        else {
            this.activeSendTo = null;
        }
    };
    CommsFormComponent.prototype.selectedVariablePreview = function (e) {
        if (e) {
            this.activeVariablePreviewRecipient = e.originalObject;
            if (this.activeTerm && this.activeTemplate && this.activeVariablePreviewRecipient) {
                var payload = {
                    term_id: this.activeTerm.id,
                    template_id: this.activeTemplate.id,
                };
                if (this.activeVariablePreviewRecipient.matrixClassId) {
                    payload.matrix_class_id = this.activeVariablePreviewRecipient.matrixClassId;
                }
                if (this.activeVariablePreviewRecipient.courseId) {
                    payload.course_id = this.activeVariablePreviewRecipient.courseId;
                }
                if (this.activeVariablePreviewRecipient.contactId) {
                    payload.contact_id = this.activeVariablePreviewRecipient.contactId;
                }
                if (this.activeVariablePreviewRecipient.grade) {
                    payload.grade = this.activeVariablePreviewRecipient.grade;
                }
                this.checkAndSetEditableTemplateBodyForEmailMode();
                if (this.editedTemplateBody) {
                    payload.edited_template_body = this.editedTemplateBody;
                }
                this.store.dispatch({ type: FETCH_EMAIL_PREVIEW, payload: payload });
            }
        }
        else {
            this.activeVariablePreviewRecipient = null;
        }
    };
    CommsFormComponent.prototype.isOriginalPreviewVisible = function () {
        return !this.isUsingCustomisedTemplate && this.mode == "email";
    };
    CommsFormComponent.prototype.isEditablePreviewVisible = function () {
        return this.isUsingCustomisedTemplate && this.mode == "email";
    };
    CommsFormComponent.prototype.isVariablePreviewVisible = function () {
        return this.isInVariablePreviewMode && !!this.sanatizedVariablePreviewHtml && this.mode == "email";
    };
    CommsFormComponent.prototype.isCustomiseButtonVisible = function () {
        return !this.isInVariablePreviewMode && this.mode == "email";
    };
    CommsFormComponent.prototype.isSmsEditorVisible = function () {
        return this.mode == "sms";
    };
    CommsFormComponent.prototype.isSendButtonVisible = function () {
        return !this.isInVariablePreviewMode;
    };
    CommsFormComponent.prototype.isPreviewAreaVisible = function () {
        return !!this.sanatizedTemplateBodyHtml || this.mode == "sms";
    };
    CommsFormComponent.prototype.isToggleVariablePreviewBtnVisible = function () {
        return this.mode == "email";
    };
    CommsFormComponent.prototype.isFormvalid = function () {
        var result = true;
        switch (this.mode) {
            case "email": {
                if (!this.activeTerm) {
                    result = false;
                }
                if (!this.activeTemplate) {
                    result = false;
                }
                if (this.recipients.length == 0) {
                    result = false;
                }
                if (this.isSendToPickerVisible() && this.activeSendTo === null) {
                    result = false;
                }
                break;
            }
            case "sms": {
                if (!this.activeTerm) {
                    result = false;
                }
                if (!this.editedTemplateBody) {
                    result = false;
                }
                if (this.recipients.length == 0) {
                    result = false;
                }
                if (this.activeSendTo == null) {
                    result = false;
                }
                break;
            }
        }
        return result;
    };
    CommsFormComponent.prototype.checkAndSetEditableTemplateBodyForEmailMode = function () {
        if (this.mode != "email") {
            return;
        }
        if (this.isUsingCustomisedTemplate) {
            this.editedTemplateBody =
                this.el.nativeElement.querySelectorAll(".cf__editable-preview")[0].innerHTML;
        }
        else {
            this.editedTemplateBody = null;
        }
    };
    CommsFormComponent.prototype.refreshNumberOfRecipients = function () {
        if (this.activeTemplate && this.recipients.length > 0) {
            var payload = {
                recipients: this.recipients,
                template_id: this.activeTemplate.id
            };
            this.store.dispatch({ type: GET_NUMBER_OF_RECIPIENTS, payload: payload });
        }
    };
    CommsFormComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    // TODO: This is a hacky thing put in becuase old SIS behaves this way.
    // Perhaps there's a better UI approach (why is this email so besopke?
    // are there other emails that need to act like this?)...
    // Note, the form elements are merely hidden with display: none via a
    // class on the root element.
    CommsFormComponent.prototype.handleSpecialEnquiryEmailScenario = function () {
        var qp = this.activatedRoute.snapshot.queryParams;
        if (!qp.enquiryId || !qp.sendTo || !qp.name) {
            return;
        }
        this.enquiryId = qp.enquiryId;
        this.enquirySendTo = qp.sendTo;
        this.enquiryName = qp.name;
        this.activeTemplate = this.templates.find(function (t) {
            return t.slug == "online-enrolment-email-template";
        });
        this.activeTerm = this.terms[0];
        this.recipients = [new Recipient()];
        this.sanatizedTemplateBodyHtml =
            this.sanatiseHtml(this.activeTemplate.body);
        this.isSendingSpecialEnquiryEmail = true;
    };
    CommsFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: router_es5["k" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: platform_browser_es5["c" /* DomSanitizer */] }, { type: core_es5["ElementRef"] }]; };
    return CommsFormComponent;
}());

//# sourceMappingURL=comms-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/comms-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_CommsFormComponent = [];
var RenderType_CommsFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CommsFormComponent, data: {} });
function View_CommsFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cf__flash']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Successfully sent communication']))], null, null);
}
function View_CommsFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'li', [['class',
                'cf__recipient']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', ''])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRemoveRecipient(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['×']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.title;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CommsFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'cf__recipients-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'cf__recipients-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Target recipients (will be sent to ',
            ')'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'cf__recipients']], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_3)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.recipients;
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.numberOfRecipients;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_CommsFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'ng2-completer', [['id', 'send-to-picker'],
            ['name', 'send-to-picker']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.sendToSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedSendTo($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](4, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](6, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [['for', 'send-to-picker']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Who to send to?']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.sendToSearchCompleter;
        _ck(_v, 4, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'send-to-picker';
        var currVal_11 = _co.sendToSearchStr;
        _ck(_v, 6, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CommsFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'cf__special-enquiry-form-notice']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Note: You are sending the "online-enrolment-email-template" to '])),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', ' (', ')']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enquiryName;
        var currVal_1 = _co.enquirySendTo;
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_CommsFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'button', [['class',
                'cf__btn-toggle-variable-preview tiny']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedToggleVariablePreview() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', ' variable preview']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'cf__btn-toggle-variable-preview tiny';
        var currVal_2 = _ck(_v, 2, 0, !_co.isToggleVariablePreviewEnabled());
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isToggleVariablePreviewEnabled();
        _ck(_v, 0, 0, currVal_0);
        var currVal_3 = (_co.isInVariablePreviewMode ? 'Disable' : 'Enable');
        _ck(_v, 3, 0, currVal_3);
    });
}
function View_CommsFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'button', [['class',
                'cf__btn-send short']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSend() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'disabled': 0, 'loading': 1 }), (_l()(), core_es5["ɵted"](3, null, ['Send ', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = 'cf__btn-send short';
        var currVal_2 = _ck(_v, 2, 0, !_co.isFormvalid(), _co.isSendingComm);
        _ck(_v, 1, 0, currVal_1, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isFormvalid();
        _ck(_v, 0, 0, currVal_0);
        var currVal_3 = _co.mode;
        _ck(_v, 3, 0, currVal_3);
    });
}
function View_CommsFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'div', [['class', 'cf__variable-preview-picker']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'ng2-completer', [['id', 'variable-preview'],
            ['name', 'variable-preview']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.variablePreviewSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedVariablePreview($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](4, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](6, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [['for', 'variable-preview']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['See merge variables for...']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.variablePreviewCompleter;
        _ck(_v, 4, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'variable-preview';
        var currVal_11 = _co.variablePreviewSearchStr;
        _ck(_v, 6, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CommsFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cf__edit-warning']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Note: You\'re working with an edited version of the original template']))], null, null);
}
function View_CommsFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'cf__btn-customise tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCustomiseTemplate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.isUsingCustomisedTemplate ? 'Use original template' : 'Use customised template');
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CommsFormComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'cf__original-preview']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sanatizedTemplateBodyHtml;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CommsFormComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'cf__editable-preview'], ['contenteditable', 'true']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sanatizedTemplateBodyHtml;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CommsFormComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'cf__variable-preview']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.sanatizedVariablePreviewHtml;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_CommsFormComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'cf__sms-editor']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 7, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'input', [['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.editedTemplateBody = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.editedTemplateBody;
        _ck(_v, 7, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CommsFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 21, 'div', [['class',
                'cf__preview-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'h3', [['class',
                'cf__preview-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Preview'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_7)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_8)), core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_9)),
        core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 12, 'div', [['class', 'cf__preview-inner-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_10)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_11)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_12)),
        core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_13)), core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_14)), core_es5["ɵdid"](19, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_15)),
        core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isToggleVariablePreviewBtnVisible();
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _co.isSendButtonVisible();
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.isInVariablePreviewMode;
        _ck(_v, 8, 0, currVal_2);
        var currVal_3 = _co.isEditablePreviewVisible();
        _ck(_v, 11, 0, currVal_3);
        var currVal_4 = _co.isCustomiseButtonVisible();
        _ck(_v, 13, 0, currVal_4);
        var currVal_5 = _co.isOriginalPreviewVisible();
        _ck(_v, 15, 0, currVal_5);
        var currVal_6 = _co.isEditablePreviewVisible();
        _ck(_v, 17, 0, currVal_6);
        var currVal_7 = _co.isVariablePreviewVisible();
        _ck(_v, 19, 0, currVal_7);
        var currVal_8 = _co.isSmsEditorVisible();
        _ck(_v, 21, 0, currVal_8);
    }, null);
}
function View_CommsFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 46, 'div', [['class',
                'comms-form']], null, null, null, null, null)),
        core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](2, { 'special-enquiry-email': 0 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_1)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](5, 0, null, null, 39, 'div', [['class', 'cf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 36, 'div', [['class', 'cf__upper-form-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 20, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 5, 'ng2-completer', [['id', 'term'], ['name', 'term']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTerm($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](11, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](13, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](15, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](16, 0, null, null, 1, 'label', [['for', 'term']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Active Term'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 9, 'div', [['class', 'input-group two-thirds']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 5, 'ng2-completer', [['id', 'template'], ['name', 'template']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.templateSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTemplate($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](21, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](23, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](25, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](26, 0, null, null, 1, 'label', [['for', 'template']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Template'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 9, 'div', [['class', 'input-group full recipient-picker']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](30, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 5, 'ng2-completer', [['id', 'recipient-picker'],
            ['name', 'recipient-picker']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.recipientSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedRecipient($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](32, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { pause: [0, 'pause'], minSearchLength: [1, 'minSearchLength'], clearSelected: [2,
                'clearSelected'], openOnFocus: [3, 'openOnFocus'], datasource: [4, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](34, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](36, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](37, 0, null, null, 1, 'label', [['for', 'recipient-picker']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Select Recipients'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_2)),
        core_es5["ɵdid"](40, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_4)), core_es5["ɵdid"](42, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_5)), core_es5["ɵdid"](44, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsFormComponent_6)),
        core_es5["ɵdid"](46, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'comms-form';
        var currVal_1 = _ck(_v, 2, 0, _co.isSendingSpecialEnquiryEmail);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = _co.isSuccessFlashVisible;
        _ck(_v, 4, 0, currVal_2);
        var currVal_10 = 0;
        var currVal_11 = true;
        var currVal_12 = _co.terms[0];
        var currVal_13 = _co.termCompleter;
        _ck(_v, 11, 0, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_14 = 'term';
        var currVal_15 = _co.termSearchStr;
        _ck(_v, 13, 0, currVal_14, currVal_15);
        var currVal_23 = 0;
        var currVal_24 = true;
        var currVal_25 = _co.templateCompleter;
        _ck(_v, 21, 0, currVal_23, currVal_24, currVal_25);
        var currVal_26 = 'template';
        var currVal_27 = _co.templateSearchStr;
        _ck(_v, 23, 0, currVal_26, currVal_27);
        var currVal_35 = 500;
        var currVal_36 = 1;
        var currVal_37 = true;
        var currVal_38 = true;
        var currVal_39 = _co.recipientCompleter;
        _ck(_v, 32, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = 'recipient-picker';
        var currVal_41 = _co.recipientSearchStr;
        _ck(_v, 34, 0, currVal_40, currVal_41);
        var currVal_42 = (_co.recipients.length > 0);
        _ck(_v, 40, 0, currVal_42);
        var currVal_43 = _co.isSendToPickerVisible();
        _ck(_v, 42, 0, currVal_43);
        var currVal_44 = _co.isSendingSpecialEnquiryEmail;
        _ck(_v, 44, 0, currVal_44);
        var currVal_45 = _co.isPreviewAreaVisible();
        _ck(_v, 46, 0, currVal_45);
    }, function (_ck, _v) {
        var currVal_3 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_7 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_8 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_9 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 10, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
        var currVal_16 = core_es5["ɵnov"](_v, 25).ngClassUntouched;
        var currVal_17 = core_es5["ɵnov"](_v, 25).ngClassTouched;
        var currVal_18 = core_es5["ɵnov"](_v, 25).ngClassPristine;
        var currVal_19 = core_es5["ɵnov"](_v, 25).ngClassDirty;
        var currVal_20 = core_es5["ɵnov"](_v, 25).ngClassValid;
        var currVal_21 = core_es5["ɵnov"](_v, 25).ngClassInvalid;
        var currVal_22 = core_es5["ɵnov"](_v, 25).ngClassPending;
        _ck(_v, 20, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_28 = core_es5["ɵnov"](_v, 36).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 36).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 36).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 36).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 36).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 36).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 36).ngClassPending;
        _ck(_v, 31, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
    });
}
function View_CommsFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'comms-form', [], null, null, null, View_CommsFormComponent_0, RenderType_CommsFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, comms_form_CommsFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], completer_service["a" /* CompleterService */], angular2_token_es5["a" /* Angular2TokenService */],
            platform_browser_es5["c" /* DomSanitizer */], core_es5["ElementRef"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CommsFormComponentNgFactory = core_es5["ɵccf"]('comms-form', comms_form_CommsFormComponent, View_CommsFormComponent_Host_0, { mode: 'mode' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=comms-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/comms-view.ts




var comms_view_CommsViewComponent = (function () {
    function CommsViewComponent(store, actions, router, activatedRoute) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.activeTab = "email";
        this.isComposing = false;
        this.isReloadingTemplates = false;
    }
    CommsViewComponent.prototype.ngOnInit = function () {
        this.commsSubscription =
            this.store.select("commsReducer")
                .subscribe(function (s) {
            });
        this.checkParams();
    };
    CommsViewComponent.prototype.checkParams = function () {
        var queryParams = this.activatedRoute.snapshot.queryParams;
        this.activeTab = queryParams.tab || "email";
        if (queryParams.mode == "composing") {
            this.isComposing = true;
        }
    };
    CommsViewComponent.prototype.isTabActive = function (tab) {
        return tab == this.activeTab;
    };
    CommsViewComponent.prototype.clickedTab = function (tab) {
        this.activeTab = tab;
        this.isComposing = false;
        this.router.navigate(['/communications'], { queryParams: {
                tab: this.activeTab
            } });
    };
    CommsViewComponent.prototype.clickedCompose = function () {
        this.isComposing = true;
        this.router.navigate(['/communications'], { queryParams: {
                tab: this.activeTab, mode: "composing"
            } });
    };
    CommsViewComponent.prototype.clickedReloadTemplates = function () {
        var _this = this;
        this.isReloadingTemplates = true;
        this.actions
            .ofType(RELOAD_EMAIL_TEMPLATES_SUCCESS)
            .take(1)
            .subscribe(function () {
            _this.isReloadingTemplates = false;
            _this.store.dispatch({ type: FETCH_TEMPLATES });
        });
        this.store.dispatch({ type: RELOAD_EMAIL_TEMPLATES });
    };
    CommsViewComponent.prototype.isReloadEmailTemplatesBtnVisible = function () {
        return this.isTabActive('email');
    };
    CommsViewComponent.prototype.ngOnDestroy = function () {
        this.commsSubscription.unsubscribe();
    };
    CommsViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: router_es5["k" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }]; };
    return CommsViewComponent;
}());

//# sourceMappingURL=comms-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/comms-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_CommsViewComponent = [];
var RenderType_CommsViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CommsViewComponent, data: {} });
function View_CommsViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'button', [['class',
                'cv__action-btn short']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedReloadTemplates() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'loading': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Reload Email Templates']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'cv__action-btn short';
        var currVal_1 = _ck(_v, 2, 0, _co.isReloadingTemplates);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, null);
}
function View_CommsViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'comms-sends-view', [], null, null, null, View_CommsSendsViewComponent_0, RenderType_CommsSendsViewComponent)), core_es5["ɵdid"](2, 245760, null, 0, comms_sends_view_CommsSendsViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], platform_browser_es5["c" /* DomSanitizer */]], { mode: [0, 'mode'] }, null)], function (_ck, _v) {
        var currVal_0 = 'email';
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CommsViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'comms-sends-view', [], null, null, null, View_CommsSendsViewComponent_0, RenderType_CommsSendsViewComponent)), core_es5["ɵdid"](2, 245760, null, 0, comms_sends_view_CommsSendsViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], platform_browser_es5["c" /* DomSanitizer */]], { mode: [0, 'mode'] }, null)], function (_ck, _v) {
        var currVal_0 = 'sms';
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CommsViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsViewComponent_3)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsViewComponent_4)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.activeTab == 'email');
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = (_co.activeTab == 'sms');
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_CommsViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'comms-form', [], null, null, null, View_CommsFormComponent_0, RenderType_CommsFormComponent)),
        core_es5["ɵdid"](2, 245760, null, 0, comms_form_CommsFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */],
            router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], completer_service["a" /* CompleterService */], angular2_token_es5["a" /* Angular2TokenService */],
            platform_browser_es5["c" /* DomSanitizer */], core_es5["ElementRef"]], { mode: [0, 'mode'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.activeTab;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CommsViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 20, 'div', [['class',
                'comms-view']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 19, 'div', [['class', 'cv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 3, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTab('email') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](5, { 'active': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 3, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTab('sms') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](8, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](9, { 'active': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['SMS'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 4, 'div', [['class', 'cv__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'button', [['class', 'cv__action-btn short']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCompose() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Compose'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsViewComponent_1)),
        core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](16, 0, null, null, 4, 'div', [['class', 'cv__inner-content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsViewComponent_2)), core_es5["ɵdid"](18, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CommsViewComponent_5)), core_es5["ɵdid"](20, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 5, 0, _co.isTabActive('email'));
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = _ck(_v, 9, 0, _co.isTabActive('sms'));
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = _co.isReloadEmailTemplatesBtnVisible();
        _ck(_v, 15, 0, currVal_2);
        var currVal_3 = !_co.isComposing;
        _ck(_v, 18, 0, currVal_3);
        var currVal_4 = _co.isComposing;
        _ck(_v, 20, 0, currVal_4);
    }, null);
}
function View_CommsViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'comms-view', [], null, null, null, View_CommsViewComponent_0, RenderType_CommsViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, comms_view_CommsViewComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CommsViewComponentNgFactory = core_es5["ɵccf"]('comms-view', comms_view_CommsViewComponent, View_CommsViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=comms-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/roles.ts
var RolesStore = (function () {
    function RolesStore(roles, roleUsers) {
        if (roles === void 0) { roles = []; }
        if (roleUsers === void 0) { roleUsers = []; }
        this.roles = roles;
        this.roleUsers = roleUsers;
    }
    return RolesStore;
}());

//# sourceMappingURL=roles.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/roles.ts

var rolesReducer = function (state, action) {
    if (state === void 0) { state = new RolesStore(); }
    switch (action.type) {
        case POPULATE_ROLES:
            return new RolesStore(action.payload, state.roleUsers);
        case POPULATE_ROLE_USERS:
            return new RolesStore(state.roles, action.payload);
        default:
            return state;
    }
};
var FETCH_ROLES = "FETCH_ROLES";
var POPULATE_ROLES = "POPULATE_ROLES";
var FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";
var FETCH_ROLE_USERS = "FETCH_ROLE_USERS";
var POPULATE_ROLE_USERS = "POPULATE_ROLE_USERS";
var FETCH_ROLE_USERS_FAILURE = "FETCH_ROLE_USERS_FAILURE";
//# sourceMappingURL=roles.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/roles-view.ts








var roles_view_RolesViewComponent = (function () {
    function RolesViewComponent(store, completerService, http, userEffects) {
        this.store = store;
        this.completerService = completerService;
        this.http = http;
        this.userEffects = userEffects;
        this.emailUrl = "/api/v1/users/email_search?query=";
    }
    RolesViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.rolesSubscription =
            this.store.select("rolesReducer").subscribe(function (s) {
                _this.roles = s.roles;
                _this.roleUsers = s.roleUsers;
            });
        this.emailCompleter =
            this.completerService.remote(this.emailUrl, "email", "email");
        this.emailCompleter.requestOptions(new http_es5["i" /* RequestOptions */]({
            headers: this.http.currentAuthHeaders,
        }));
    };
    RolesViewComponent.prototype.clickedRole = function (role) {
        this.activeRole = role;
        this.store.dispatch({ type: FETCH_ROLE_USERS, payload: role.code });
    };
    RolesViewComponent.prototype.clickedAddUser = function () {
        if (!this.selectedUser) {
            return;
        }
        if (!this.selectedUser.roles.includes(this.activeRole.code)) {
            this.selectedUser.roles.push(this.activeRole.code);
            this.store.dispatch({ type: UPDATE_USER, payload: this.selectedUser });
            this.refreshRoleUsersAfterUpdate();
        }
    };
    RolesViewComponent.prototype.clickedRemoveUserFromRole = function (user) {
        var _this = this;
        var payload = user_User.clone(user);
        payload.roles =
            payload.roles.filter(function (code) { return code != _this.activeRole.code; });
        this.store.dispatch({ type: UPDATE_USER, payload: payload });
        this.refreshRoleUsersAfterUpdate();
    };
    RolesViewComponent.prototype.selectedUserToAdd = function (e) {
        if (e && e.originalObject) {
            this.selectedUser = user_User.clone(e.originalObject);
        }
        else {
            this.selectedUser = null;
        }
    };
    RolesViewComponent.prototype.refreshRoleUsersAfterUpdate = function () {
        var _this = this;
        this.userEffects.update
            .filter(function (a) { return a.type == REPLACE_USER; })
            .take(1)
            .subscribe(function () {
            _this.store.dispatch({ type: FETCH_ROLE_USERS, payload: _this.activeRole.code });
        });
    };
    RolesViewComponent.prototype.ngOnDestroy = function () {
        this.rolesSubscription.unsubscribe();
    };
    RolesViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: user_UserEffects }]; };
    return RolesViewComponent;
}());

//# sourceMappingURL=roles-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/roles-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_RolesViewComponent = [];
var RenderType_RolesViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_RolesViewComponent, data: {} });
function View_RolesViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'rv__role']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRole(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.name;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.code;
        _ck(_v, 5, 0, currVal_1);
    });
}
function View_RolesViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'rv__no-active-role']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select a role on the left to adjust user-role assignment']))], null, null);
}
function View_RolesViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'rv__role-user']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'label', [['class', 'rv__ru-email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'button', [['class', 'rv__ru-btn-remove tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRemoveUserFromRole(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Remove']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.email;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_RolesViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 26, 'div', [['class',
                'rv__active-role']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class',
                'rv__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['Users with: ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 20, 'div', [['class', 'rv__add-user-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 19, 'div', [['class', 'rv__add-user']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 9, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 5, 'ng2-completer', [['id', 'search-by-email'],
            ['name', 'search-by-email']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.emailSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedUserToAdd($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](9, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { pause: [0, 'pause'], minSearchLength: [1, 'minSearchLength'], openOnFocus: [2,
                'openOnFocus'], datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](11, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](13, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](14, 0, null, null, 1, 'label', [['for', 'search-by-email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Add by User email'])), (_l()(), core_es5["ɵeld"](16, 0, null, null, 7, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](17, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](18, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 3, 'button', [['class', 'tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedAddUser() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](21, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](22, { 'disabled': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Add'])), (_l()(), core_es5["ɵeld"](24, 0, null, null, 2, 'ul', [['class', 'rv__role-users']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RolesViewComponent_4)), core_es5["ɵdid"](26, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = 500;
        var currVal_9 = 0;
        var currVal_10 = true;
        var currVal_11 = _co.emailCompleter;
        _ck(_v, 9, 0, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'search-by-email';
        var currVal_13 = _co.emailSearchStr;
        _ck(_v, 11, 0, currVal_12, currVal_13);
        var currVal_14 = 'tiny';
        var currVal_15 = _ck(_v, 22, 0, !_co.selectedUser);
        _ck(_v, 21, 0, currVal_14, currVal_15);
        var currVal_16 = _co.roleUsers;
        _ck(_v, 26, 0, currVal_16);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.activeRole.name;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 8, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
    });
}
function View_RolesViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 12, 'div', [['class',
                'roles-view']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class', 'rv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Roles and policies'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 9, 'div', [['class', 'rv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'div', [['class', 'rv__roles-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 2, 'ul', [['class', 'rv__roles']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RolesViewComponent_1)),
        core_es5["ɵdid"](7, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 4, 'div', [['class', 'rv__active-role-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RolesViewComponent_2)),
        core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_RolesViewComponent_3)), core_es5["ɵdid"](12, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.roles;
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = !_co.activeRole;
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = _co.activeRole;
        _ck(_v, 12, 0, currVal_2);
    }, null);
}
function View_RolesViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'roles-view', [], null, null, null, View_RolesViewComponent_0, RenderType_RolesViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, roles_view_RolesViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], angular2_token_es5["a" /* Angular2TokenService */], user_UserEffects], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var RolesViewComponentNgFactory = core_es5["ɵccf"]('roles-view', roles_view_RolesViewComponent, View_RolesViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=roles-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/admin-area-view.ts

var admin_area_view_AdminAreaViewComponent = (function () {
    function AdminAreaViewComponent(store) {
        this.store = store;
    }
    AdminAreaViewComponent.prototype.ngOnInit = function () {
    };
    AdminAreaViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }]; };
    return AdminAreaViewComponent;
}());

//# sourceMappingURL=admin-area-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/admin-area-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_AdminAreaViewComponent = [];
var RenderType_AdminAreaViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AdminAreaViewComponent, data: {} });
function View_AdminAreaViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 44, 'div', [['class',
                'admin-area-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 43, 'div', [['class',
                'aav__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'aav__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Admin area'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 40, 'ul', [['class', 'aav__items']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 10, 'li', [['class', 'aav__item-wrapper']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](6, 16384, null, 0, router_es5["l" /* RouterLink */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], [8, null], core_es5["Renderer2"], core_es5["ElementRef"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](7, 1), (_l()(), core_es5["ɵeld"](8, 0, null, null, 7, 'div', [['class', 'aav__item']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'h2', [['class', 'aav__item-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Class rollover'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 4, 'div', [['class', 'aav__item-description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Copy classes from one Term to another Term.'])),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Make sure you have already created the target Term via the Calendar.'])),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 8, 'li', [['class', 'aav__item-wrapper']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 17).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](17, 16384, null, 0, router_es5["l" /* RouterLink */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], [8, null], core_es5["Renderer2"], core_es5["ElementRef"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](18, 1), (_l()(), core_es5["ɵeld"](19, 0, null, null, 5, 'div', [['class', 'aav__item']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 1, 'h2', [['class', 'aav__item-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enrolment rollover'])), (_l()(), core_es5["ɵeld"](22, 0, null, null, 2, 'div', [['class', 'aav__item-description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](23, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Activate all rollovers which have been set for the upcoming term.'])),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 8, 'li', [['class', 'aav__item-wrapper']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 26).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](26, 16384, null, 0, router_es5["l" /* RouterLink */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], [8, null], core_es5["Renderer2"], core_es5["ElementRef"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](27, 1), (_l()(), core_es5["ɵeld"](28, 0, null, null, 5, 'div', [['class', 'aav__item']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 1, 'h2', [['class', 'aav__item-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Academic rollover'])), (_l()(), core_es5["ɵeld"](31, 0, null, null, 2, 'div', [['class', 'aav__item-description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Increment all student contacts by 1 year.'])), (_l()(), core_es5["ɵeld"](34, 0, null, null, 10, 'li', [['class', 'aav__item-wrapper']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 35).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](35, 16384, null, 0, router_es5["l" /* RouterLink */], [router_es5["k" /* Router */], router_es5["a" /* ActivatedRoute */], [8, null], core_es5["Renderer2"], core_es5["ElementRef"]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](36, 1), (_l()(), core_es5["ɵeld"](37, 0, null, null, 7, 'div', [['class', 'aav__item']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](38, 0, null, null, 1, 'h2', [['class', 'aav__item-label']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Workshop rollover'])), (_l()(), core_es5["ɵeld"](40, 0, null, null, 4, 'div', [['class', 'aav__item-description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](41, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Copy Workshops, Tutor Allocations and their Windows over to another term.'])),
        (_l()(), core_es5["ɵeld"](43, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Make sure you have already created the target Term via the Calendar.']))], function (_ck, _v) {
        var currVal_0 = _ck(_v, 7, 0, '/class-rollover');
        _ck(_v, 6, 0, currVal_0);
        var currVal_1 = _ck(_v, 18, 0, '/enrolment-rollover');
        _ck(_v, 17, 0, currVal_1);
        var currVal_2 = _ck(_v, 27, 0, '/academic-rollover');
        _ck(_v, 26, 0, currVal_2);
        var currVal_3 = _ck(_v, 36, 0, '/workshops-rollover');
        _ck(_v, 35, 0, currVal_3);
    }, null);
}
function View_AdminAreaViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'admin-area-view', [], null, null, null, View_AdminAreaViewComponent_0, RenderType_AdminAreaViewComponent)), core_es5["ɵdid"](1, 114688, null, 0, admin_area_view_AdminAreaViewComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AdminAreaViewComponentNgFactory = core_es5["ɵccf"]('admin-area-view', admin_area_view_AdminAreaViewComponent, View_AdminAreaViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=admin-area-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/class-rollover-view.ts




var class_rollover_view_ClassRolloverViewComponent = (function () {
    function ClassRolloverViewComponent(store, completerService, actions) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.isSuccessMessageVisible = false;
        this.isFailureMessageVisible = false;
        this.classesTermFrom = [];
        this.classesTermTo = [];
    }
    ClassRolloverViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.constantsSubscription =
            this.store.select('constantsReducer').subscribe(function (s) { return _this.terms = s.constants.terms; });
        this.classesSubscription =
            this.store.select('matrixClassesReducer').subscribe(function (s) {
                _this.classesTermFrom = s.classesRolloverTermFrom;
                _this.classesTermTo = s.classesRolloverTermTo;
            });
        this.setupCompleters();
    };
    ClassRolloverViewComponent.prototype.setupCompleters = function () {
        this.termsFromCompleter =
            this.completerService.local(this.terms, "name", "name");
        this.termsToCompleter =
            this.completerService.local(this.terms, "name", "name");
    };
    ClassRolloverViewComponent.prototype.selectedTermFrom = function (e) {
        if (e) {
            this.termFrom = e.originalObject;
        }
        else {
            this.termFrom = null;
        }
        this.refreshTerm('from');
    };
    ClassRolloverViewComponent.prototype.selectedTermTo = function (e) {
        if (e) {
            this.termTo = e.originalObject;
        }
        else {
            this.termTo = null;
        }
        this.refreshTerm('to');
    };
    ClassRolloverViewComponent.prototype.refreshTerm = function (termType) {
        var actionType;
        var targetTermId;
        if (termType == "from") {
            actionType = FETCH_CLASSSES_FOR_FROM_TERM;
            targetTermId = this.termFrom.id;
        }
        else if (termType == "to") {
            actionType = FETCH_CLASSSES_FOR_TO_TERM;
            targetTermId = this.termTo.id;
        }
        this.store.dispatch({ type: actionType, payload: targetTermId });
    };
    ClassRolloverViewComponent.prototype.clickedRollover = function () {
        this.setupResultSubscriptions();
        var params = {
            from_term_id: this.termFrom.id,
            to_term_id: this.termTo.id,
        };
        this.store.dispatch({ type: CLASS_ROLLOVER, payload: params });
    };
    ClassRolloverViewComponent.prototype.setupResultSubscriptions = function () {
        var _this = this;
        this.actions
            .ofType(POPULATE_CLASS_ROLLOVER_RESULT, CLASS_ROLLOVER_FAILURE)
            .take(1)
            .subscribe(function (a) {
            if (a.type == POPULATE_CLASS_ROLLOVER_RESULT) {
                _this.isSuccessMessageVisible = true;
            }
            else if (a.type == CLASS_ROLLOVER_FAILURE) {
                _this.isFailureMessageVisible = true;
            }
        });
    };
    ClassRolloverViewComponent.prototype.ngOnDestroy = function () {
        this.constantsSubscription.unsubscribe();
        this.classesSubscription.unsubscribe();
    };
    ClassRolloverViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }]; };
    return ClassRolloverViewComponent;
}());

//# sourceMappingURL=class-rollover-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/class-rollover-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_ClassRolloverViewComponent = [];
var RenderType_ClassRolloverViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ClassRolloverViewComponent, data: {} });
function View_ClassRolloverViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'crv__failure-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Class rollover failed. Consult IT before going further.']))], null, null);
}
function View_ClassRolloverViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'crv__success-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Class rollover was successful']))], null, null);
}
function View_ClassRolloverViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'li', [['class',
                'crv__class']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.code;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ClassRolloverViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'crv__classes']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_5)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.classesTermFrom;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_ClassRolloverViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'div', [['class',
                'crv__result from']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['This will take the the following classes from...'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ':'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_4)), core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.classesTermFrom.length > 0);
        _ck(_v, 6, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.termFrom.name;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_ClassRolloverViewComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'crv__result arrow']], null, null, null, null, null))], null, null);
}
function View_ClassRolloverViewComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'li', [['class',
                'crv__class']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.code;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ClassRolloverViewComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'crv__already-allocated']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['The target term already has classes allocated to it.'])),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'crv__classes']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_9)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.classesTermTo;
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_ClassRolloverViewComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'div', [['class',
                'crv__transfer-actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'p', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['...to the term:'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(),
            core_es5["ɵeld"](5, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.clickedRollover() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Rollover classes now']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.termTo.name;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_ClassRolloverViewComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'crv__result to']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_8)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_10)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.classesTermTo.length > 0);
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = (_co.classesTermTo.length == 0);
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_ClassRolloverViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 40, 'div', [['class',
                'class-rollover-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class',
                'crv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Class rollover'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 37, 'div', [['class', 'crv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 25, 'div', [['class', 'crv__term-select-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 11, 'div', [['class', 'crv__term-select from']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 9, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['From term...'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 5, 'ng2-completer', [['id', 'term-from'], ['name', 'term-from']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termFromSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTermFrom($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](16, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](18, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](20, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](21, 0, null, null, 0, 'div', [['class', 'crv__term-select arrow']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](22, 0, null, null, 11, 'div', [['class', 'crv__term-select to']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](23, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 9, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['... to term...'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 5, 'ng2-completer', [['id', 'term-to'], ['name', 'term-to']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termToSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTermTo($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](29, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](31, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](33, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](34, 0, null, null, 6, 'div', [['class', 'crv__results']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_3)),
        core_es5["ɵdid"](36, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_6)), core_es5["ɵdid"](38, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ClassRolloverViewComponent_7)), core_es5["ɵdid"](40, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFailureMessageVisible;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isSuccessMessageVisible;
        _ck(_v, 7, 0, currVal_1);
        var currVal_9 = 0;
        var currVal_10 = true;
        var currVal_11 = _co.termsFromCompleter;
        _ck(_v, 16, 0, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'term-from';
        var currVal_13 = _co.termFromSearchStr;
        _ck(_v, 18, 0, currVal_12, currVal_13);
        var currVal_21 = 0;
        var currVal_22 = true;
        var currVal_23 = _co.termsToCompleter;
        _ck(_v, 29, 0, currVal_21, currVal_22, currVal_23);
        var currVal_24 = 'term-to';
        var currVal_25 = _co.termToSearchStr;
        _ck(_v, 31, 0, currVal_24, currVal_25);
        var currVal_26 = _co.termFrom;
        _ck(_v, 36, 0, currVal_26);
        var currVal_27 = _co.termFrom;
        _ck(_v, 38, 0, currVal_27);
        var currVal_28 = (_co.termTo && _co.termFrom);
        _ck(_v, 40, 0, currVal_28);
    }, function (_ck, _v) {
        var currVal_2 = core_es5["ɵnov"](_v, 20).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 20).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 20).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 20).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 20).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 20).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 20).ngClassPending;
        _ck(_v, 15, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_14 = core_es5["ɵnov"](_v, 33).ngClassUntouched;
        var currVal_15 = core_es5["ɵnov"](_v, 33).ngClassTouched;
        var currVal_16 = core_es5["ɵnov"](_v, 33).ngClassPristine;
        var currVal_17 = core_es5["ɵnov"](_v, 33).ngClassDirty;
        var currVal_18 = core_es5["ɵnov"](_v, 33).ngClassValid;
        var currVal_19 = core_es5["ɵnov"](_v, 33).ngClassInvalid;
        var currVal_20 = core_es5["ɵnov"](_v, 33).ngClassPending;
        _ck(_v, 28, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
    });
}
function View_ClassRolloverViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'class-rollover-view', [], null, null, null, View_ClassRolloverViewComponent_0, RenderType_ClassRolloverViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, class_rollover_view_ClassRolloverViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ClassRolloverViewComponentNgFactory = core_es5["ɵccf"]('class-rollover-view', class_rollover_view_ClassRolloverViewComponent, View_ClassRolloverViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=class-rollover-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/enrolment-rollover-view.ts



var enrolment_rollover_view_EnrolmentRolloverViewComponent = (function () {
    function EnrolmentRolloverViewComponent(store, actions) {
        this.store = store;
        this.actions = actions;
        this.isConfirming = false;
        this.isLoading = false;
        this.isSuccessMessageVisible = false;
        this.isFailureMessageVisible = false;
    }
    EnrolmentRolloverViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enrolmentsSubscription =
            this.store.select("enrolmentsReducer").subscribe(function (s) { _this.enrolments = s.enrolmentsToRollover; });
        this.populateEnrolmentsToRollover();
    };
    EnrolmentRolloverViewComponent.prototype.populateEnrolmentsToRollover = function () {
        var payload = {
            for_rollover_view: true,
        };
        this.store.dispatch({ type: FETCH_ENROLMENTS_TO_ROLLOVER, payload: payload });
    };
    EnrolmentRolloverViewComponent.prototype.clickedRollover = function () {
        this.isConfirming = true;
    };
    EnrolmentRolloverViewComponent.prototype.clickedConfirm = function () {
        var _this = this;
        this.isConfirming = false;
        this.isLoading = true;
        this.actions
            .ofType(ROLLOVER_ENROLMENTS_SUCCESS, ROLLOVER_ENROLMENTS_FAILURE)
            .take(1)
            .subscribe(function (a) {
            _this.isLoading = false;
            if (a.type == ROLLOVER_ENROLMENTS_SUCCESS) {
                _this.isSuccessMessageVisible = true;
            }
            else if (a.type == ROLLOVER_ENROLMENTS_FAILURE) {
                _this.isFailureMessageVisible = true;
            }
        });
        this.store.dispatch({ type: ROLLOVER_ENROLMENTS });
    };
    EnrolmentRolloverViewComponent.prototype.clickedCancel = function () {
        this.isConfirming = false;
    };
    EnrolmentRolloverViewComponent.prototype.ngOnDestroy = function () {
        this.enrolmentsSubscription.unsubscribe();
    };
    EnrolmentRolloverViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return EnrolmentRolloverViewComponent;
}());

//# sourceMappingURL=enrolment-rollover-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/enrolment-rollover-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_EnrolmentRolloverViewComponent = [];
var RenderType_EnrolmentRolloverViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_EnrolmentRolloverViewComponent, data: {} });
function View_EnrolmentRolloverViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'erv__failure-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enrolment rollover failed. Consult IT before going further.']))], null, null);
}
function View_EnrolmentRolloverViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'erv__success-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enrolment rollover was successful']))], null, null);
}
function View_EnrolmentRolloverViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['To '])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', ''])),
        (_l()(), core_es5["ɵted"](-1, null, [' from '])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.pendingEnrolment.matrixClass.code;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _v.parent.context.$implicit.matrixClass.code;
        _ck(_v, 6, 0, currVal_1);
    });
}
function View_EnrolmentRolloverViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Cancelling '])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.matrixClass.code;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_EnrolmentRolloverViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'li', [['class',
                'erv__enrolment']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'erv__enrolment-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 7, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'li', [['class', 'name']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 4, 'li', [['class',
                'action']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_4)),
        core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_5)), core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.pendingEnrolment;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.isCancelling;
        _ck(_v, 9, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.contact.fullName;
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_EnrolmentRolloverViewComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRollover() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Perform enrolment rollover']))], null, null);
}
function View_EnrolmentRolloverViewComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No, cancel']))], null, null);
}
function View_EnrolmentRolloverViewComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedConfirm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Yes, I am sure']))], null, null);
}
function View_EnrolmentRolloverViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 19, 'div', [['class',
                'enrolment-rollover-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 18, 'div', [['class',
                'erv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'erv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Enrolment rollover'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'p', [['class', 'erv__blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Clicking the Proceed button at the bottom of this list will activate all the following pending enrolment rollovers which have been set:'])),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'ul', [['class', 'erv__enrolments']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_3)),
        core_es5["ɵdid"](12, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](13, 0, null, null, 6, 'div', [['class', 'erv__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_6)),
        core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_7)), core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentRolloverViewComponent_8)), core_es5["ɵdid"](19, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFailureMessageVisible;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isSuccessMessageVisible;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.enrolments;
        _ck(_v, 12, 0, currVal_2);
        var currVal_3 = !_co.isConfirming;
        _ck(_v, 15, 0, currVal_3);
        var currVal_4 = _co.isConfirming;
        _ck(_v, 17, 0, currVal_4);
        var currVal_5 = _co.isConfirming;
        _ck(_v, 19, 0, currVal_5);
    }, null);
}
function View_EnrolmentRolloverViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'enrolment-rollover-view', [], null, null, null, View_EnrolmentRolloverViewComponent_0, RenderType_EnrolmentRolloverViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, enrolment_rollover_view_EnrolmentRolloverViewComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var EnrolmentRolloverViewComponentNgFactory = core_es5["ɵccf"]('enrolment-rollover-view', enrolment_rollover_view_EnrolmentRolloverViewComponent, View_EnrolmentRolloverViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9lbnJvbG1lbnQtcm9sbG92ZXItdmlldy5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZW5yb2xtZW50LXJvbGxvdmVyLXZpZXcudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZW5yb2xtZW50LXJvbGxvdmVyLXZpZXcucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2Vucm9sbWVudC1yb2xsb3Zlci12aWV3LnRzLkVucm9sbWVudFJvbGxvdmVyVmlld0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJlbnJvbG1lbnQtcm9sbG92ZXItdmlld1wiPjxkaXYgY2xhc3M9XCJlcnZfX2NvbnRlbnQtd3JhcHBlclwiPjxoMSBjbGFzcz1cImVydl9faGVhZGVyXCI+RW5yb2xtZW50IHJvbGxvdmVyPC9oMT48ZGl2IGNsYXNzPVwiZXJ2X19mYWlsdXJlLW1lc3NhZ2VcIiAqbmdJZj1cImlzRmFpbHVyZU1lc3NhZ2VWaXNpYmxlXCI+RW5yb2xtZW50IHJvbGxvdmVyIGZhaWxlZC4gQ29uc3VsdCBJVCBiZWZvcmUgZ29pbmcgZnVydGhlci48L2Rpdj48ZGl2IGNsYXNzPVwiZXJ2X19zdWNjZXNzLW1lc3NhZ2VcIiAqbmdJZj1cImlzU3VjY2Vzc01lc3NhZ2VWaXNpYmxlXCI+RW5yb2xtZW50IHJvbGxvdmVyIHdhcyBzdWNjZXNzZnVsPC9kaXY+PHAgY2xhc3M9XCJlcnZfX2JsdXJiXCI+Q2xpY2tpbmcgdGhlIFByb2NlZWQgYnV0dG9uIGF0IHRoZSBib3R0b20gb2YgdGhpcyBsaXN0IHdpbGwgYWN0aXZhdGUgYWxsIHRoZSBmb2xsb3dpbmcgcGVuZGluZyBlbnJvbG1lbnQgcm9sbG92ZXJzIHdoaWNoIGhhdmUgYmVlbiBzZXQ6PC9wPjx1bCBjbGFzcz1cImVydl9fZW5yb2xtZW50c1wiPjxsaSBjbGFzcz1cImVydl9fZW5yb2xtZW50XCIgKm5nRm9yPVwibGV0IGUgb2YgZW5yb2xtZW50c1wiPjxkaXYgY2xhc3M9XCJlcnZfX2Vucm9sbWVudC13cmFwcGVyXCI+PHVsPjxsaSBjbGFzcz1cIm5hbWVcIj57eyBlLmNvbnRhY3QuZnVsbE5hbWUgfX08L2xpPjxsaSBjbGFzcz1cImFjdGlvblwiPjxuZy1jb250YWluZXIgKm5nSWY9XCJlLnBlbmRpbmdFbnJvbG1lbnRcIj5UbyA8c3Bhbj57eyBlLnBlbmRpbmdFbnJvbG1lbnQubWF0cml4Q2xhc3MuY29kZSB9fTwvc3Bhbj4gZnJvbSA8c3Bhbj57eyBlLm1hdHJpeENsYXNzLmNvZGUgfX08L3NwYW4+PC9uZy1jb250YWluZXI+PG5nLWNvbnRhaW5lciAqbmdJZj1cImUuaXNDYW5jZWxsaW5nXCI+Q2FuY2VsbGluZyA8c3Bhbj57eyBlLm1hdHJpeENsYXNzLmNvZGUgfX08L3NwYW4+PC9uZy1jb250YWluZXI+PC9saT48L3VsPjwvZGl2PjwvbGk+PC91bD48ZGl2IGNsYXNzPVwiZXJ2X19hY3Rpb25zXCI+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwXCIgKm5nSWY9XCIhaXNDb25maXJtaW5nXCI+PGRpdiBjbGFzcz1cImlnX19jb250ZW50LXdyYXBwZXJcIj48YnV0dG9uIChjbGljayk9XCJjbGlja2VkUm9sbG92ZXIoKVwiPlBlcmZvcm0gZW5yb2xtZW50IHJvbGxvdmVyPC9idXR0b24+PC9kaXY+PC9kaXY+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwXCIgKm5nSWY9XCJpc0NvbmZpcm1pbmdcIj48ZGl2IGNsYXNzPVwiaWdfX2NvbnRlbnQtd3JhcHBlclwiPjxidXR0b24gKGNsaWNrKT1cImNsaWNrZWRDYW5jZWwoKVwiPk5vLCBjYW5jZWw8L2J1dHRvbj48L2Rpdj48L2Rpdj48ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIiAqbmdJZj1cImlzQ29uZmlybWluZ1wiPjxkaXYgY2xhc3M9XCJpZ19fY29udGVudC13cmFwcGVyXCI+PGJ1dHRvbiAoY2xpY2spPVwiY2xpY2tlZENvbmZpcm0oKVwiPlllcywgSSBhbSBzdXJlPC9idXR0b24+PC9kaXY+PC9kaXY+PC9kaXY+PC9kaXY+PC9kaXY+IiwiPGVucm9sbWVudC1yb2xsb3Zlci12aWV3PjwvZW5yb2xtZW50LXJvbGxvdmVyLXZpZXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXNIO01BQUE7TUFBQSxnQkFBa0U7Ozs7b0JBQWlFO01BQUE7TUFBQSxnQkFBa0U7Ozs7b0JBQXFZO01BQUE7TUFBeUMsMkNBQUc7VUFBQTtVQUFBLDhCQUFNO01BQWdELDhDQUFNO1VBQUE7VUFBQSw4QkFBTTs7UUFBNUQ7UUFBQTtRQUE0RDtRQUFBOzs7O29CQUE4QztNQUFBO01BQXFDLG1EQUFXO1VBQUE7VUFBQSw4QkFBTTs7UUFBQTtRQUFBOzs7O29CQUFuWDtNQUFBO01BQXdEO1VBQUE7TUFBb0M7VUFBQSwwREFBSTtVQUFBO1VBQUEsNENBQWlCO1VBQUEsVUFBNkI7VUFBQTtNQUFtQjthQUFBO1VBQUEsaUNBQTRKO1VBQUEsNkVBQUE7VUFBQTtjQUFBO0lBQTlJO0lBQWQsV0FBYyxTQUFkO0lBQTBLO0lBQWQsV0FBYyxTQUFkOztJQUE1TTtJQUFBOzs7O29CQUFvVztNQUFBO01BQStDO1VBQUE7TUFBaUM7VUFBQTtZQUFBO1lBQUE7WUFBUTtjQUFBO2NBQUE7WUFBQTtZQUFSO1VBQUEsZ0NBQW9DOzs7O29CQUErQztNQUFBO01BQThDO1VBQUE7TUFBaUM7VUFBQTtZQUFBO1lBQUE7WUFBUTtjQUFBO2NBQUE7WUFBQTtZQUFSO1VBQUEsZ0NBQWtDOzs7O29CQUErQjtNQUFBO01BQThDO1VBQUE7TUFBaUM7VUFBQTtZQUFBO1lBQUE7WUFBUTtjQUFBO2NBQUE7WUFBQTtZQUFSO1VBQUEsZ0NBQW1DOzs7O29CQUF6NUM7TUFBQTtNQUFBLGdCQUFxQztNQUFBO01BQUEsZ0JBQWtDO01BQUE7TUFBd0IsMERBQXVCO1VBQUE7YUFBQTtVQUFBLGlDQUFtSTtVQUFBLDZFQUFBO1VBQUE7Y0FBQSx3QkFBeUc7VUFBQTtVQUFBLDhCQUFzQjtNQUEySTtVQUFBO01BQTRCO2FBQUE7NEJBQUEseUNBQTJiO1VBQUE7VUFBQSwwREFBMEI7VUFBQTthQUFBO1VBQUEsaUNBQW1LO1VBQUEsNkVBQUE7VUFBQTtjQUFBLHdCQUFnSjtVQUFBLCtEQUFBO1VBQUE7VUFBQTs7SUFBL29DO0lBQWxDLFdBQWtDLFNBQWxDO0lBQXFLO0lBQWxDLFdBQWtDLFNBQWxDO0lBQWlVO0lBQTNCLFlBQTJCLFNBQTNCO0lBQThlO0lBQXpCLFlBQXlCLFNBQXpCO0lBQTRMO0lBQXpCLFlBQXlCLFNBQXpCO0lBQXlLO0lBQXpCLFlBQXlCLFNBQXpCOzs7O29CQ0F2eUM7TUFBQTsrQ0FBQSxVQUFBO3dDQUFBOztRQUFBOzs7OzsifQ==
//# sourceMappingURL=enrolment-rollover-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/academic-rollover-view.ts



var academic_rollover_view_AcademicRolloverViewComponent = (function () {
    function AcademicRolloverViewComponent(store, actions) {
        this.store = store;
        this.actions = actions;
        this.isConfirming = false;
        this.isLoading = false;
        this.isSuccessMessageVisible = false;
        this.isFailureMessageVisible = false;
    }
    AcademicRolloverViewComponent.prototype.ngOnInit = function () {
    };
    AcademicRolloverViewComponent.prototype.clickedRollover = function () {
        this.isConfirming = true;
    };
    AcademicRolloverViewComponent.prototype.clickedConfirm = function () {
        var _this = this;
        this.isConfirming = false;
        this.isLoading = true;
        this.actions
            .ofType(PERFORMED_ACADEMIC_ROLLOVER, ACADEMIC_ROLLOVER_FAILURE)
            .take(1)
            .subscribe(function (a) {
            _this.isLoading = false;
            if (a.type == PERFORMED_ACADEMIC_ROLLOVER) {
                _this.isSuccessMessageVisible = true;
            }
            else if (a.type == ACADEMIC_ROLLOVER_FAILURE) {
                _this.isFailureMessageVisible = true;
            }
        });
        this.store.dispatch({ type: PERFORM_ACADEMIC_ROLLOVER });
    };
    AcademicRolloverViewComponent.prototype.clickedCancel = function () {
        this.isConfirming = false;
    };
    AcademicRolloverViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return AcademicRolloverViewComponent;
}());

//# sourceMappingURL=academic-rollover-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/academic-rollover-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_AcademicRolloverViewComponent = [];
var RenderType_AcademicRolloverViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AcademicRolloverViewComponent, data: {} });
function View_AcademicRolloverViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'arv__failure-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Academic rollover failed. Consult IT before going further.']))], null, null);
}
function View_AcademicRolloverViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'arv__success-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Academic rollover was successful']))], null, null);
}
function View_AcademicRolloverViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRollover() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](4, { 'loading': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Perform academic rollover']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 4, 0, _co.isLoading);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_AcademicRolloverViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No, cancel'])),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedConfirm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Yes, I am sure']))], null, null);
}
function View_AcademicRolloverViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'div', [['class',
                'academic-rollover-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 13, 'div', [['class',
                'arv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'arv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Academic Rollover'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AcademicRolloverViewComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AcademicRolloverViewComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'div', [['class', 'arv__notice']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This will increment all student Contacts grade attributes by 1 year.'])),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 4, 'div', [['class', 'arv__actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AcademicRolloverViewComponent_3)),
        core_es5["ɵdid"](12, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AcademicRolloverViewComponent_4)), core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFailureMessageVisible;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isSuccessMessageVisible;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = !_co.isConfirming;
        _ck(_v, 12, 0, currVal_2);
        var currVal_3 = _co.isConfirming;
        _ck(_v, 14, 0, currVal_3);
    }, null);
}
function View_AcademicRolloverViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'academic-rollover-view', [], null, null, null, View_AcademicRolloverViewComponent_0, RenderType_AcademicRolloverViewComponent)), core_es5["ɵdid"](1, 114688, null, 0, academic_rollover_view_AcademicRolloverViewComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AcademicRolloverViewComponentNgFactory = core_es5["ɵccf"]('academic-rollover-view', academic_rollover_view_AcademicRolloverViewComponent, View_AcademicRolloverViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=academic-rollover-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshops-rollover-view.ts




var workshops_rollover_view_WorkshopsRolloverViewComponent = (function () {
    function WorkshopsRolloverViewComponent(store, completerService, actions) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.isRollingOver = false;
        this.isSuccessMessageVisible = false;
        this.isFailureMessageVisible = false;
    }
    WorkshopsRolloverViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.constantsSubscription =
            this.store.select('constantsReducer').subscribe(function (s) { return _this.terms = s.constants.terms.filter(function (t) { return !t.isHoliday; }); });
        this.setupCompleters();
    };
    WorkshopsRolloverViewComponent.prototype.setupCompleters = function () {
        this.termsFromCompleter =
            this.completerService.local(this.terms, "name", "name");
        this.termsToCompleter =
            this.completerService.local(this.terms, "name", "name");
    };
    WorkshopsRolloverViewComponent.prototype.selectedTermFrom = function (e) {
        if (e) {
            this.termFrom = e.originalObject;
        }
        else {
            this.termFrom = null;
        }
    };
    WorkshopsRolloverViewComponent.prototype.selectedTermTo = function (e) {
        if (e) {
            this.termTo = e.originalObject;
        }
        else {
            this.termTo = null;
        }
    };
    WorkshopsRolloverViewComponent.prototype.clickedRollover = function () {
        var _this = this;
        this.isRollingOver = true;
        this.isFailureMessageVisible = false;
        this.isSuccessMessageVisible = false;
        this.actions
            .ofType(WORKSHOPS_ROLLOVER_SUCCESS, WORKSHOPS_ROLLOVER_FAILURE)
            .take(1)
            .subscribe(function (a) {
            _this.isRollingOver = false;
            switch (a.type) {
                case WORKSHOPS_ROLLOVER_SUCCESS: {
                    _this.isSuccessMessageVisible = true;
                    break;
                }
                case WORKSHOPS_ROLLOVER_SUCCESS: {
                    _this.isFailureMessageVisible = true;
                    break;
                }
            }
        });
        var params = {
            from_term_id: this.termFrom.id,
            to_term_id: this.termTo.id,
        };
        this.store.dispatch({ type: WORKSHOPS_ROLLOVER, payload: params });
    };
    WorkshopsRolloverViewComponent.prototype.ngOnDestroy = function () {
        this.constantsSubscription.unsubscribe();
    };
    WorkshopsRolloverViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }]; };
    return WorkshopsRolloverViewComponent;
}());

//# sourceMappingURL=workshops-rollover-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshops-rollover-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_WorkshopsRolloverViewComponent = [];
var RenderType_WorkshopsRolloverViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopsRolloverViewComponent, data: {} });
function View_WorkshopsRolloverViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'wrv__failure-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Workshops rollover failed. Consult IT before going further.']))], null, null);
}
function View_WorkshopsRolloverViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'wrv__success-message']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Workshops rollover was successful']))], null, null);
}
function View_WorkshopsRolloverViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRollover() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](6, { 'loading': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Rollover workshops now']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 6, 0, _co.isRollingOver);
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_WorkshopsRolloverViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 35, 'div', [['class',
                'workshops-rollover-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class',
                'wrv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Workshops rollover'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 32, 'div', [['class', 'wrv__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsRolloverViewComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsRolloverViewComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 25, 'div', [['class', 'wrv__term-select-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 11, 'div', [['class', 'wrv__term-select from']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 9, 'div', [['class', 'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['From term...'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 5, 'ng2-completer', [['id', 'term-from'], ['name', 'term-from']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termFromSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTermFrom($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](16, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](18, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](20, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](21, 0, null, null, 0, 'div', [['class', 'wrv__term-select arrow']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](22, 0, null, null, 11, 'div', [['class', 'wrv__term-select to']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](23, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 9, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['... to term...'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 5, 'ng2-completer', [['id', 'term-to'], ['name', 'term-to']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.termToSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTermTo($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](29, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](31, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](33, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopsRolloverViewComponent_3)),
        core_es5["ɵdid"](35, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFailureMessageVisible;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isSuccessMessageVisible;
        _ck(_v, 7, 0, currVal_1);
        var currVal_9 = 0;
        var currVal_10 = true;
        var currVal_11 = _co.termsFromCompleter;
        _ck(_v, 16, 0, currVal_9, currVal_10, currVal_11);
        var currVal_12 = 'term-from';
        var currVal_13 = _co.termFromSearchStr;
        _ck(_v, 18, 0, currVal_12, currVal_13);
        var currVal_21 = 0;
        var currVal_22 = true;
        var currVal_23 = _co.termsToCompleter;
        _ck(_v, 29, 0, currVal_21, currVal_22, currVal_23);
        var currVal_24 = 'term-to';
        var currVal_25 = _co.termToSearchStr;
        _ck(_v, 31, 0, currVal_24, currVal_25);
        var currVal_26 = (_co.termFrom && _co.termTo);
        _ck(_v, 35, 0, currVal_26);
    }, function (_ck, _v) {
        var currVal_2 = core_es5["ɵnov"](_v, 20).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 20).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 20).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 20).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 20).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 20).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 20).ngClassPending;
        _ck(_v, 15, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_14 = core_es5["ɵnov"](_v, 33).ngClassUntouched;
        var currVal_15 = core_es5["ɵnov"](_v, 33).ngClassTouched;
        var currVal_16 = core_es5["ɵnov"](_v, 33).ngClassPristine;
        var currVal_17 = core_es5["ɵnov"](_v, 33).ngClassDirty;
        var currVal_18 = core_es5["ɵnov"](_v, 33).ngClassValid;
        var currVal_19 = core_es5["ɵnov"](_v, 33).ngClassInvalid;
        var currVal_20 = core_es5["ɵnov"](_v, 33).ngClassPending;
        _ck(_v, 28, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
    });
}
function View_WorkshopsRolloverViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshops-rollover-view', [], null, null, null, View_WorkshopsRolloverViewComponent_0, RenderType_WorkshopsRolloverViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, workshops_rollover_view_WorkshopsRolloverViewComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopsRolloverViewComponentNgFactory = core_es5["ɵccf"]('workshops-rollover-view', workshops_rollover_view_WorkshopsRolloverViewComponent, View_WorkshopsRolloverViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshops-rollover-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/direct-debit-summary-view.ts


var direct_debit_summary_view_DirectDebitSummaryViewComponent = (function () {
    function DirectDebitSummaryViewComponent(store, router) {
        this.store = store;
        this.router = router;
    }
    DirectDebitSummaryViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.transactionsSubscription =
            this.store.select("transactionsReducer")
                .subscribe(function (s) {
                _this.dds = s.activeDirectDebitSummary;
            });
    };
    DirectDebitSummaryViewComponent.prototype.clickedViewAll = function (target) {
        this.router.navigate(['direct-debit-summaries', this.dds.id, target]);
    };
    DirectDebitSummaryViewComponent.prototype.ngOnDestroy = function () {
        this.transactionsSubscription.unsubscribe();
    };
    DirectDebitSummaryViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }]; };
    return DirectDebitSummaryViewComponent;
}());

//# sourceMappingURL=direct-debit-summary-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/direct-debit-summary-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_DirectDebitSummaryViewComponent = [];
var RenderType_DirectDebitSummaryViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DirectDebitSummaryViewComponent, data: {} });
function View_DirectDebitSummaryViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 156, 'div', [['class', 'direct-debit-summary-view']], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](2, 0, null, null, 3, 'h1', [['class', 'ddsv__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Direct Debit Summary'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 59, 'div', [['class', 'ddsv__summary-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 58, 'table', [['class', 'ddsv__summary']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 57, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 18, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 8, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 7, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'dt', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Batched'])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 4, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](15, null, ['', ''])),
        core_es5["ɵppd"](16, 4), (_l()(), core_es5["ɵeld"](17, 0, null, null, 1, 'span', [['class',
                'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](18, null, ['', ' transactions'])),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 8, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 7, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Unbatched'])),
        (_l()(), core_es5["ɵeld"](23, 0, null, null, 4, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](24, null, ['', ''])), core_es5["ɵppd"](25, 4), (_l()(), core_es5["ɵeld"](26, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](27, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 18, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 8, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 7, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Approved'])), (_l()(), core_es5["ɵeld"](33, 0, null, null, 4, 'dd', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](34, null, ['', ''])), core_es5["ɵppd"](35, 4), (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](37, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 8, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 7, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](40, 0, null, null, 1, 'dt', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Unprocessable'])), (_l()(), core_es5["ɵeld"](42, 0, null, null, 4, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](43, null, ['', ''])),
        core_es5["ɵppd"](44, 4), (_l()(), core_es5["ɵeld"](45, 0, null, null, 1, 'span', [['class',
                'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](46, null, ['', ' transactions'])),
        (_l()(), core_es5["ɵeld"](47, 0, null, null, 18, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](48, 0, null, null, 8, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](49, 0, null, null, 7, 'dl', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](50, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Declined'])), (_l()(),
            core_es5["ɵeld"](52, 0, null, null, 4, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](53, null, ['', ''])), core_es5["ɵppd"](54, 4), (_l()(), core_es5["ɵeld"](55, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](56, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](57, 0, null, null, 8, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](58, 0, null, null, 7, 'dl', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](59, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Processable'])), (_l()(), core_es5["ɵeld"](61, 0, null, null, 4, 'dd', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](62, null, ['', ''])), core_es5["ɵppd"](63, 4),
        (_l()(), core_es5["ɵeld"](64, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](65, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](66, 0, null, null, 91, 'ul', [['class', 'ddsv__dynamic-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](67, 0, null, null, 30, 'li', [['class', 'ddsv__dynamic unbatched']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](68, 0, null, null, 3, 'h2', [['class', 'ddsv__dynamic-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Unbatched'])), (_l()(), core_es5["ɵeld"](70, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedViewAll('unbatched') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['View all'])),
        (_l()(), core_es5["ɵeld"](72, 0, null, null, 25, 'table', [['class', 'ddsv__dynamic-table']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](73, 0, null, null, 24, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](74, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](75, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Recovered'])),
        (_l()(), core_es5["ɵeld"](77, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](78, null, ['', ''])), core_es5["ɵppd"](79, 4), (_l()(), core_es5["ɵeld"](80, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](81, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](82, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](83, 0, null, null, 1, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Outstanding'])), (_l()(), core_es5["ɵeld"](85, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](86, null, ['', ''])),
        core_es5["ɵppd"](87, 4), (_l()(), core_es5["ɵeld"](88, 0, null, null, 1, 'span', [['class',
                'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](89, null, ['', ' transactions'])),
        (_l()(), core_es5["ɵeld"](90, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](91, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Disenroled'])), (_l()(), core_es5["ɵeld"](93, 0, null, null, 4, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](94, null, ['', ''])), core_es5["ɵppd"](95, 4), (_l()(), core_es5["ɵeld"](96, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](97, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](98, 0, null, null, 30, 'li', [['class', 'ddsv__dynamic declined']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](99, 0, null, null, 3, 'h2', [['class', 'ddsv__dynamic-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Declined'])), (_l()(), core_es5["ɵeld"](101, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedViewAll('declined') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['View all'])),
        (_l()(), core_es5["ɵeld"](103, 0, null, null, 25, 'table', [['class', 'ddsv__dynamic-table']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](104, 0, null, null, 24, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](105, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](106, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Recovered'])),
        (_l()(), core_es5["ɵeld"](108, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](109, null, ['', ''])), core_es5["ɵppd"](110, 4), (_l()(), core_es5["ɵeld"](111, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](112, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](113, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](114, 0, null, null, 1, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Outstanding'])), (_l()(), core_es5["ɵeld"](116, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](117, null, ['', ''])),
        core_es5["ɵppd"](118, 4), (_l()(), core_es5["ɵeld"](119, 0, null, null, 1, 'span', [['class',
                'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](120, null, ['', ' transactions'])),
        (_l()(), core_es5["ɵeld"](121, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](122, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Disenroled'])), (_l()(), core_es5["ɵeld"](124, 0, null, null, 4, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](125, null, ['', ''])), core_es5["ɵppd"](126, 4), (_l()(), core_es5["ɵeld"](127, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](128, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](129, 0, null, null, 28, 'li', [['class', 'ddsv__dynamic approved']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](130, 0, null, null, 1, 'h2', [['class', 'ddsv__dynamic-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Approved'])), (_l()(), core_es5["ɵeld"](132, 0, null, null, 25, 'table', [['class', 'ddsv__dynamic-table']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](133, 0, null, null, 24, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](134, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](135, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Received'])), (_l()(),
            core_es5["ɵeld"](137, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](138, null, ['', ''])), core_es5["ɵppd"](139, 4), (_l()(), core_es5["ɵeld"](140, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](141, null, ['', ' transactions'])), (_l()(), core_es5["ɵeld"](142, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](143, 0, null, null, 1, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Refunded'])), (_l()(), core_es5["ɵeld"](145, 0, null, null, 4, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](146, null, ['', ''])),
        core_es5["ɵppd"](147, 4), (_l()(), core_es5["ɵeld"](148, 0, null, null, 1, 'span', [['class',
                'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](149, null, ['', ' transactions'])),
        (_l()(), core_es5["ɵeld"](150, 0, null, null, 7, 'tr', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](151, 0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Disenroled'])), (_l()(), core_es5["ɵeld"](153, 0, null, null, 4, 'td', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](154, null, ['', ''])), core_es5["ɵppd"](155, 4), (_l()(), core_es5["ɵeld"](156, 0, null, null, 1, 'span', [['class', 'ddsv__tx-no']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](157, null, ['', ' transactions']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.dds.description;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵunv"](_v, 15, 0, _ck(_v, 16, 0, core_es5["ɵnov"](_v, 0), _co.dds.batched, 'USD', true, '1.2-2'));
        _ck(_v, 15, 0, currVal_1);
        var currVal_2 = _co.dds.batchedCount;
        _ck(_v, 18, 0, currVal_2);
        var currVal_3 = core_es5["ɵunv"](_v, 24, 0, _ck(_v, 25, 0, core_es5["ɵnov"](_v, 0), _co.dds.unbatched, 'USD', true, '1.2-2'));
        _ck(_v, 24, 0, currVal_3);
        var currVal_4 = _co.dds.unbatchedCount;
        _ck(_v, 27, 0, currVal_4);
        var currVal_5 = core_es5["ɵunv"](_v, 34, 0, _ck(_v, 35, 0, core_es5["ɵnov"](_v, 0), _co.dds.batchedApproved, 'USD', true, '1.2-2'));
        _ck(_v, 34, 0, currVal_5);
        var currVal_6 = _co.dds.batchedApprovedCount;
        _ck(_v, 37, 0, currVal_6);
        var currVal_7 = core_es5["ɵunv"](_v, 43, 0, _ck(_v, 44, 0, core_es5["ɵnov"](_v, 0), _co.dds.unprocessable, 'USD', true, '1.2-2'));
        _ck(_v, 43, 0, currVal_7);
        var currVal_8 = _co.dds.unprocessableCount;
        _ck(_v, 46, 0, currVal_8);
        var currVal_9 = core_es5["ɵunv"](_v, 53, 0, _ck(_v, 54, 0, core_es5["ɵnov"](_v, 0), _co.dds.batchedDeclined, 'USD', true, '1.2-2'));
        _ck(_v, 53, 0, currVal_9);
        var currVal_10 = _co.dds.batchedDeclinedCount;
        _ck(_v, 56, 0, currVal_10);
        var currVal_11 = core_es5["ɵunv"](_v, 62, 0, _ck(_v, 63, 0, core_es5["ɵnov"](_v, 0), _co.dds.processable, 'USD', true, '1.2-2'));
        _ck(_v, 62, 0, currVal_11);
        var currVal_12 = _co.dds.processableCount;
        _ck(_v, 65, 0, currVal_12);
        var currVal_13 = core_es5["ɵunv"](_v, 78, 0, _ck(_v, 79, 0, core_es5["ɵnov"](_v, 0), _co.dds.unbatchedRecovered, 'USD', true, '1.2-2'));
        _ck(_v, 78, 0, currVal_13);
        var currVal_14 = _co.dds.unbatchedRecoveredCount;
        _ck(_v, 81, 0, currVal_14);
        var currVal_15 = core_es5["ɵunv"](_v, 86, 0, _ck(_v, 87, 0, core_es5["ɵnov"](_v, 0), _co.dds.unbatchedOutstanding, 'USD', true, '1.2-2'));
        _ck(_v, 86, 0, currVal_15);
        var currVal_16 = _co.dds.unbatchedOutstandingCount;
        _ck(_v, 89, 0, currVal_16);
        var currVal_17 = core_es5["ɵunv"](_v, 94, 0, _ck(_v, 95, 0, core_es5["ɵnov"](_v, 0), 0, 'USD', true, '1.2-2'));
        _ck(_v, 94, 0, currVal_17);
        var currVal_18 = _co.dds.unbatchedDisenroledCount;
        _ck(_v, 97, 0, currVal_18);
        var currVal_19 = core_es5["ɵunv"](_v, 109, 0, _ck(_v, 110, 0, core_es5["ɵnov"](_v, 0), _co.dds.declinedRecovered, 'USD', true, '1.2-2'));
        _ck(_v, 109, 0, currVal_19);
        var currVal_20 = _co.dds.declinedRecoveredCount;
        _ck(_v, 112, 0, currVal_20);
        var currVal_21 = core_es5["ɵunv"](_v, 117, 0, _ck(_v, 118, 0, core_es5["ɵnov"](_v, 0), _co.dds.declinedOutstanding, 'USD', true, '1.2-2'));
        _ck(_v, 117, 0, currVal_21);
        var currVal_22 = _co.dds.declinedOutstandingCount;
        _ck(_v, 120, 0, currVal_22);
        var currVal_23 = core_es5["ɵunv"](_v, 125, 0, _ck(_v, 126, 0, core_es5["ɵnov"](_v, 0), _co.dds.declinedDisenroled, 'USD', true, '1.2-2'));
        _ck(_v, 125, 0, currVal_23);
        var currVal_24 = _co.dds.declinedDisenroledCount;
        _ck(_v, 128, 0, currVal_24);
        var currVal_25 = core_es5["ɵunv"](_v, 138, 0, _ck(_v, 139, 0, core_es5["ɵnov"](_v, 0), _co.dds.approvedReceived, 'USD', true, '1.2-2'));
        _ck(_v, 138, 0, currVal_25);
        var currVal_26 = _co.dds.approvedReceivedCount;
        _ck(_v, 141, 0, currVal_26);
        var currVal_27 = core_es5["ɵunv"](_v, 146, 0, _ck(_v, 147, 0, core_es5["ɵnov"](_v, 0), _co.dds.approvedRefunded, 'USD', true, '1.2-2'));
        _ck(_v, 146, 0, currVal_27);
        var currVal_28 = _co.dds.approvedRefundedCount;
        _ck(_v, 149, 0, currVal_28);
        var currVal_29 = core_es5["ɵunv"](_v, 154, 0, _ck(_v, 155, 0, core_es5["ɵnov"](_v, 0), _co.dds.approvedDisenroled, 'USD', true, '1.2-2'));
        _ck(_v, 154, 0, currVal_29);
        var currVal_30 = _co.dds.approvedDisenroledCount;
        _ck(_v, 157, 0, currVal_30);
    });
}
function View_DirectDebitSummaryViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'direct-debit-summary-view', [], null, null, null, View_DirectDebitSummaryViewComponent_0, RenderType_DirectDebitSummaryViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, direct_debit_summary_view_DirectDebitSummaryViewComponent, [src_store["a" /* Store */], router_es5["k" /* Router */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DirectDebitSummaryViewComponentNgFactory = core_es5["ɵccf"]('direct-debit-summary-view', direct_debit_summary_view_DirectDebitSummaryViewComponent, View_DirectDebitSummaryViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=direct-debit-summary-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/store/transactions.ts
var TransactionsStore = (function () {
    function TransactionsStore(transactions, activeDebtor, potentialTransactions, activeTransaction, directDebitSummaries, activeDirectDebitSummary) {
        if (transactions === void 0) { transactions = []; }
        if (activeDebtor === void 0) { activeDebtor = null; }
        if (potentialTransactions === void 0) { potentialTransactions = []; }
        if (activeTransaction === void 0) { activeTransaction = null; }
        if (directDebitSummaries === void 0) { directDebitSummaries = []; }
        if (activeDirectDebitSummary === void 0) { activeDirectDebitSummary = null; }
        this.transactions = transactions;
        this.activeDebtor = activeDebtor;
        this.potentialTransactions = potentialTransactions;
        this.activeTransaction = activeTransaction;
        this.directDebitSummaries = directDebitSummaries;
        this.activeDirectDebitSummary = activeDirectDebitSummary;
    }
    TransactionsStore.clone = function (store) {
        var result = new this();
        result.transactions = store.transactions.slice();
        result.activeDebtor = store.activeDebtor;
        result.potentialTransactions = store.potentialTransactions.slice();
        result.activeTransaction = store.activeTransaction;
        result.directDebitSummaries = store.directDebitSummaries.slice();
        result.activeDirectDebitSummary = store.activeDirectDebitSummary;
        return result;
    };
    return TransactionsStore;
}());

//# sourceMappingURL=transactions.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/transactions.ts

var transactionsReducer = function (state, action) {
    if (state === void 0) { state = new TransactionsStore(); }
    var s = TransactionsStore.clone(state);
    switch (action.type) {
        case POPULATE_TRANSCATIONS:
            s.transactions = action.payload;
            return s;
        case POPULATE_ACTIVE_DEBTOR:
            s.activeDebtor = action.payload;
            return s;
        case POPULATE_POTENTIAL_TRANSACTIONS:
            s.potentialTransactions = action.payload;
            return s;
        case POPULATE_ACTIVE_TRANSACTION:
            s.activeTransaction = action.payload;
            return s;
        case POPULATE_DIRECT_DEBIT_SUMMARIES:
            s.directDebitSummaries = action.payload;
            return s;
        case POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY:
            s.activeDirectDebitSummary = action.payload;
            return s;
        case TOGGLE_TRANSACTIONS_CHECKED:
            s.transactions.forEach(function (t) { return t.isChecked = action.payload; });
            return s;
        default:
            return state;
    }
};
var FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS";
var POPULATE_TRANSCATIONS = "POPULATE_TRANSCATIONS";
var FETCH_TRANSACTIONS_FAILURE = "FETCH_TRANSACTIONS_FAILURE";
var FETCH_POTENTIAL_TRANSACTIONS = "FETCH_POTENTIAL_TRANSACTIONS";
var POPULATE_POTENTIAL_TRANSACTIONS = "POPULATE_POTENTIAL_TRANSACTIONS";
var FETCH_POTENTIAL_TRANSACTIONS_FAILURE = "FETCH_POTENTIAL_TRANSACTIONS_FAILURE";
var POPULATE_ACTIVE_DEBTOR = "POPULATE_ACTIVE_DEBTOR";
var POPULATE_ACTIVE_TRANSACTION = "POPULATE_ACTIVE_TRANSACTION";
var FETCH_DEBTOR = "FETCH_DEBTOR";
var FETCH_DEBTOR_FAILURE = "FETCH_DEBTOR_FAILURE";
var CREATE_TRANSACTION = "CREATE_TRANSACTION";
var CREATED_TRANSACTION = "CREATED_TRANSACTION";
var CREATE_TRANSACTION_FAILURE = "CREATE_TRANSACTION_FAILURE";
var CREATE_TRANSACTION_TRANSFER = "CREATE_TRANSACTION_TRANSFER";
var CREATED_TRANSACTION_TRANSFER = "CREATED_TRANSACTION_TRANSFER";
var CREATE_TRANSACTION_TRANSFER_FAILURE = "CREATE_TRANSACTION_TRANSFER_FAILURE";
var RECHARGE_TRANSACTION = "RECHARGE_TRANSACTION";
var RECHARGED_TRANSACTION = "RECHARGED_TRANSACTION";
var RECHARGE_TRANSACTION_FAILURE = "RECHARGE_TRANSACTION_FAILURE";
var RECORD_OTHER_PAYMENT = "RECORD_OTHER_PAYMENT";
var RECORDED_OTHER_PAYMENT = "RECORDED_OTHER_PAYMENT";
var RECORD_OTHER_PAYMENT_FAILURE = "RECORD_OTHER_PAYMENT_FAILURE";
var FETCH_DIRECT_DEBIT_SUMMARIES = "FETCH_DIRECT_DEBIT_SUMMARIES";
var POPULATE_DIRECT_DEBIT_SUMMARIES = "POPULATE_DIRECT_DEBIT_SUMMARIES";
var FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE = "FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE";
var FETCH_DIRECT_DEBIT_SUMMARY = "FETCH_DIRECT_DEBIT_SUMMARY";
var POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY = "POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY";
var FETCH_DIRECT_DEBIT_SUMMARY_FAILURE = "FETCH_DIRECT_DEBIT_SUMMARY_FAILURE";
var FETCH_DDS_TRANSACTIONS = "FETCH_DDS_TRANSACTIONS";
var FETCH_DDS_TRANSACTIONS_FAILURE = "FETCH_DDS_TRANSACTIONS_FAILURE";
var TOGGLE_TRANSACTIONS_CHECKED = "TOGGLE_TRANSACTIONS_CHECKED";
var RECHARGE_TRANSACTIONS = "RECHARGE_TRANSACTIONS";
//# sourceMappingURL=transactions.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/transactions-by-debtor-view.ts




var transactions_by_debtor_view_TransactionsByDebtorViewComponent = (function () {
    function TransactionsByDebtorViewComponent(store, route, router, actions) {
        this.store = store;
        this.route = route;
        this.router = router;
        this.actions = actions;
        this.transactionsByDebtorList = [];
        this.areAllToggled = false;
    }
    TransactionsByDebtorViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.viewType = this.route.snapshot.params["type"];
        this.transactionsSubscription =
            this.store.select("transactionsReducer")
                .subscribe(function (s) {
                _this.transactions = s.transactions;
                _this.dds = s.activeDirectDebitSummary;
                _this.generateTransactionsByDebtor();
            });
    };
    TransactionsByDebtorViewComponent.prototype.generateTransactionsByDebtor = function () {
        var _this = this;
        if (this.transactionsByDebtorList.length > 0) {
            return;
        }
        this.transactionsByDebtorList = [];
        var uniqueDebtorIds = [];
        this.transactions.forEach(function (t) {
            if (uniqueDebtorIds.indexOf(t.debtorId) < 0) {
                uniqueDebtorIds.push(t.debtorId);
            }
        });
        uniqueDebtorIds.forEach(function (id) {
            var targetTransactions = _this.transactions.filter(function (t) {
                return t.debtorId == id;
            });
            var transactionByDebtor = {
                debtor: targetTransactions[0].debtor,
                transactions: targetTransactions,
            };
            _this.transactionsByDebtorList.push(transactionByDebtor);
        });
    };
    TransactionsByDebtorViewComponent.prototype.clickedToggleAll = function () {
        this.areAllToggled = !this.areAllToggled;
        this.store.dispatch({ type: TOGGLE_TRANSACTIONS_CHECKED, payload: this.areAllToggled });
    };
    TransactionsByDebtorViewComponent.prototype.isActionsVisible = function () {
        return this.viewType == "declined";
    };
    TransactionsByDebtorViewComponent.prototype.isRechargable = function (t) {
        return t.cycleMetadata.cycleTransactionType == "Declined" &&
            t.cycleMetadata.amountProcessedSince == 0;
    };
    TransactionsByDebtorViewComponent.prototype.areAnyRechargesSelected = function () {
        var _this = this;
        return !!this.transactions.find(function (t) { return t.isChecked && _this.isRechargable(t); });
    };
    TransactionsByDebtorViewComponent.prototype.calcAmountToRecharge = function (t) {
        return t.cycleMetadata.originalAmountToRecover - t.cycleMetadata.amountProcessedSince;
    };
    TransactionsByDebtorViewComponent.prototype.clickedRechargeSelected = function () {
        var _this = this;
        this.actions
            .ofType(RECHARGED_TRANSACTION)
            .take(1)
            .subscribe(function () { return _this.router.navigate([
            'direct-debit-summaries',
            _this.route.snapshot.params["id"]
        ]); });
        var ids = this
            .transactions
            .filter(function (t) { return t.isChecked && _this.isRechargable(t); })
            .map(function (t) { return t.id; });
        this.store.dispatch({ type: RECHARGE_TRANSACTIONS, payload: ids });
    };
    TransactionsByDebtorViewComponent.prototype.ngOnDestroy = function () {
        this.transactionsSubscription.unsubscribe();
    };
    TransactionsByDebtorViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: router_es5["k" /* Router */] }, { type: effects["a" /* Actions */] }]; };
    return TransactionsByDebtorViewComponent;
}());

//# sourceMappingURL=transactions-by-debtor-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/transactions-by-debtor-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_TransactionsByDebtorViewComponent = [];
var RenderType_TransactionsByDebtorViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TransactionsByDebtorViewComponent, data: {} });
function View_TransactionsByDebtorViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'tbdv__actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 3, 'button', [], [[8,
                'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRechargeSelected() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](5, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Recharge selected'])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedToggleAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Toggle all']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _ck(_v, 5, 0, !_co.areAnyRechargesSelected());
        _ck(_v, 4, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.areAnyRechargesSelected();
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_TransactionsByDebtorViewComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'div', [['class',
                'input-group checkbox tbdv__recharge-checkbox']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'input', [['type', 'checkbox']], [[8, 'id', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_v.parent.parent.parent.context.$implicit.isChecked = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 0, 'label', [], [[8, 'htmlFor', 0]], null, null, null, null))], function (_ck, _v) {
        var currVal_8 = _v.parent.parent.parent.context.$implicit.isChecked;
        _ck(_v, 5, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = ((('recharge_' + _v.parent.parent.parent.context.index) + '_') + _v.parent.parent.parent.context.$implicit.id);
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_9 = ((('recharge_' + _v.parent.parent.parent.context.index) + '_') + _v.parent.parent.parent.context.$implicit.id);
        _ck(_v, 8, 0, currVal_9);
    });
}
function View_TransactionsByDebtorViewComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'td', [['class',
                'row-actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_6)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isRechargable(_v.parent.parent.context.$implicit);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TransactionsByDebtorViewComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'is-disenroled']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Disernoled']))], null, null);
}
function View_TransactionsByDebtorViewComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'td', [['class',
                'amount to-recharge']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', ''])), core_es5["ɵppd"](2, 4)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _co.calcAmountToRecharge(_v.parent.parent.context.$implicit), 'USD', true, '1.2-2'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TransactionsByDebtorViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 16, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_5)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](3, 0, null, null, 3, 'td', [['class', 'root-description']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_7)),
        core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'td', [['class', 'amount original-to-recover']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](8, null, ['', ''])), core_es5["ɵppd"](9, 4), (_l()(), core_es5["ɵeld"](10, 0, null, null, 4, 'td', [['class', 'amount processed-since']], null, null, null, null, null)), core_es5["ɵdid"](11, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](12, { 'negative': 0,
            'positive': 1 }), (_l()(), core_es5["ɵted"](13, null, ['', ''])), core_es5["ɵppd"](14, 4),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_8)),
        core_es5["ɵdid"](16, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isActionsVisible();
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = _v.parent.context.$implicit.cycleMetadata.isDisenroled;
        _ck(_v, 6, 0, currVal_2);
        var currVal_4 = 'amount processed-since';
        var currVal_5 = _ck(_v, 12, 0, (_v.parent.context.$implicit.cycleMetadata.amountProcessedSince == 0), (_v.parent.context.$implicit.cycleMetadata.amountProcessedSince >= _v.parent.context.$implicit.cycleMetadata.originalAmountToRecover));
        _ck(_v, 11, 0, currVal_4, currVal_5);
        var currVal_7 = _co.isActionsVisible();
        _ck(_v, 16, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_1 = _v.parent.context.$implicit.cycleMetadata.rootTransactionDescription;
        _ck(_v, 4, 0, currVal_1);
        var currVal_3 = core_es5["ɵunv"](_v, 8, 0, _ck(_v, 9, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.parent.context.$implicit.cycleMetadata.originalAmountToRecover, 'USD', true, '1.2-2'));
        _ck(_v, 8, 0, currVal_3);
        var currVal_6 = core_es5["ɵunv"](_v, 13, 0, _ck(_v, 14, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.parent.context.$implicit.cycleMetadata.amountProcessedSince, 'USD', true, '1.2-2'));
        _ck(_v, 13, 0, currVal_6);
    });
}
function View_TransactionsByDebtorViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'tr', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_4)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.cycleMetadata;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TransactionsByDebtorViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'li', [['class',
                'tbdv__tbd-item']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class', 'tbdv__tbd-debtor']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'div', [['class', 'tbdv__tbd-transactions-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'table', [['class', 'tbdv__tbd-transactions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 2, 'tbody', [], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_3)),
        core_es5["ɵdid"](7, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.transactions;
        _ck(_v, 7, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.debtor.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TransactionsByDebtorViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class', 'transactions-by-debtor-view']], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](2, 0, null, null, 3, 'h1', [['class', 'tbdv__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', ' (for ', ')'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Transactions by debtor'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_1)),
        core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 3, 'div', [['class', 'tbdv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 2, 'ul', [['class', 'tbdv__tbd-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TransactionsByDebtorViewComponent_2)),
        core_es5["ɵdid"](11, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.isActionsVisible();
        _ck(_v, 7, 0, currVal_2);
        var currVal_3 = _co.transactionsByDebtorList;
        _ck(_v, 11, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.dds.description;
        var currVal_1 = _co.viewType;
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_TransactionsByDebtorViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'transactions-by-debtor-view', [], null, null, null, View_TransactionsByDebtorViewComponent_0, RenderType_TransactionsByDebtorViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, transactions_by_debtor_view_TransactionsByDebtorViewComponent, [src_store["a" /* Store */], router_es5["a" /* ActivatedRoute */], router_es5["k" /* Router */],
            src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TransactionsByDebtorViewComponentNgFactory = core_es5["ɵccf"]('transactions-by-debtor-view', transactions_by_debtor_view_TransactionsByDebtorViewComponent, View_TransactionsByDebtorViewComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=transactions-by-debtor-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/contact.ts
var contact___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var contact___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var contact_ContactEffects = (function () {
    function ContactEffects(actions, contactService, enrolmentService) {
        var _this = this;
        this.actions = actions;
        this.contactService = contactService;
        this.enrolmentService = enrolmentService;
        this.fetchContacts = this.actions
            .ofType(FETCH_CONTACTS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.contactService.index(params)
            .map(function (contacts) { return ({ type: POPULATE_CONTACTS, payload: contacts }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_CONTACTS_FAILURE }); }); })
            .share();
        this.fetchContact = this.actions
            .ofType(FETCH_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.fetch(payload)
            .map(function (contact) { return ({ type: POPULATE_ACTIVE_CONTACT, payload: contact }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_CONTACT_FAILURE, payload: response }); }); })
            .share();
        this.fetchActiveContactEnrolments = this.actions
            .ofType(FETCH_ACTIVE_CONTACT_ENROLMENTS)
            .throttleTime(200)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.enrolmentService.fetchEnrolments(params)
            .map(function (es) { return ({ type: POPULATE_ACTIVE_CONTACT_ENROLMENTS, payload: es }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ACTIVE_CONTACT_ENROLMENTS_FAILURE }); }); })
            .share();
        this.createContact = this.actions
            .ofType(CREATE_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.create(payload.serializeForRails())
            .map(function (contact) { return ({ type: ADD_CONTACT, payload: contact }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_CONTACT_FAILURE, payload: response }); }); })
            .share();
        this.updateContact = this.actions
            .ofType(UPDATE_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.update(payload.serializeForRails())
            .map(function (contact) { return ({ type: REPLACE_CONTACT, payload: contact }); })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_CONTACT_FAILURE, payload: response }); }); })
            .share();
        this.classesBetween = this.actions
            .ofType(FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.classesBetween(payload)
            .map(function (classesBetween) {
            return { type: UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT, payload: classesBetween };
        }); })
            .share();
        this.createAbsence = this.actions
            .ofType(CREATE_ABSENCE)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.createAbsence(payload)
            .map(function (a) { return ({ type: FETCH_CONTACT, payload: a.contactId }); }); })
            .share();
        this.deleteAbsence = this.actions
            .ofType(DELETE_ABSENCE)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.contactService.deleteAbsence(payload)
            .map(function (contactId) { return ({ type: FETCH_CONTACT, payload: contactId }); }); })
            .share();
        this.fetchStudents = this.actions
            .ofType(FETCH_STUDENTS)
            .switchMap(function () { return _this.contactService.students()
            .map(function (students) { return ({ type: POPULATE_STUDENTS, payload: students }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_STUDENTS_FAILURE }); }); })
            .share();
        this.createDocument = this.actions
            .ofType(CREATE_DOCUMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (doc) { return _this.contactService.createDocument(doc.serializeForRails())
            .map(function (doc) { return ({ type: CREATED_DOCUMENT, payload: doc }); })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_DOCUMENT_FAILURE }); }); })
            .share();
        this.deleteDocument = this.actions
            .ofType(DELETE_DOCUMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.deleteDocument(id)
            .map(function (id) { return ({ type: DELETED_DOCUMENT, payload: id }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_DOCUMENT_FAILURE }); }); })
            .share();
        this.createNote = this.actions
            .ofType(CREATE_NOTE)
            .map(function (action) { return action.payload; })
            .switchMap(function (note) { return _this.contactService.createNote(note.serializeForRails())
            .map(function (note) { return ({ type: CREATED_NOTE, payload: note }); })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_NOTE_FAILURE }); }); })
            .share();
        this.deleteNote = this.actions
            .ofType(DELETE_NOTE)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.deleteNote(id)
            .map(function (id) { return ({ type: DELETED_NOTE, payload: id }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_NOTE_FAILURE }); }); })
            .share();
        this.deleteAddress = this.actions
            .ofType(DELETE_ADDRESS)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.deleteAddress(id)
            .map(function (id) { return ({ type: DELETED_ADDRESS, payload: id }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_ADDRESS_FAILURE }); }); })
            .share();
        this.deletePhone = this.actions
            .ofType(DELETE_PHONE)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.deletePhone(id)
            .map(function (id) { return ({ type: DELETED_PHONE, payload: id }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_PHONE_FAILURE }); }); })
            .share();
        this.academicRollover = this.actions
            .ofType(PERFORM_ACADEMIC_ROLLOVER)
            .switchMap(function () { return _this.contactService.academicRollover()
            .map(function () { return ({ type: PERFORMED_ACADEMIC_ROLLOVER }); })
            .catch(function () { return Observable["Observable"].of({ type: ACADEMIC_ROLLOVER_FAILURE }); }); });
        this.applyDiscount = this.actions
            .ofType(APPLY_DISCOUNT)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.contactService.applyDiscount(params)
            .map(function () { return ({ type: APPLIED_DISCOUNT }); })
            .catch(function () { return Observable["Observable"].of({ type: APPLY_DISCOUNT_FAILURE }); }); });
        this.removeDiscount = this.actions
            .ofType(REMOVE_DISCOUNT)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.contactService.removeDiscount(params)
            .map(function () { return ({ type: REMOVE_DISCOUNT_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: REMOVE_DISCOUNT_FAILURE }); }); });
    }
    ContactEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: contact_ContactService }, { type: enrolment_EnrolmentService }]; };
    return ContactEffects;
}());

contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "fetchContacts", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", typeof (contact__a = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && contact__a || Object)
], contact_ContactEffects.prototype, "fetchContact", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "fetchActiveContactEnrolments", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "createContact", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "updateContact", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "classesBetween", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "createAbsence", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "deleteAbsence", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "fetchStudents", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "createDocument", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "deleteDocument", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "createNote", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "deleteNote", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "deleteAddress", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "deletePhone", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "academicRollover", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "applyDiscount", void 0);
contact___decorate([
    Object(effects["b" /* Effect */])(),
    contact___metadata("design:type", Object)
], contact_ContactEffects.prototype, "removeDiscount", void 0);
var contact__a;
//# sourceMappingURL=contact.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/contacts.ts
var CONTACT_TYPES = [
    { title: "Student", value: 0 },
    { title: "Parent", value: 1 },
    { title: "Staff", value: 2 },
];
var CONTACT_INSTALMENTS = [
    { title: "Quarterly", value: 0 },
    { title: "Monthly", value: 1 },
];
var CONTACT_GRADES = [
    { title: "Year 6", value: 6 },
    { title: "Year 7", value: 7 },
    { title: "Year 8", value: 8 },
    { title: "Year 9", value: 9 },
    { title: "Year 10", value: 10 },
    { title: "Year 11", value: 11 },
    { title: "Year 12", value: 12 },
    { title: "Alumnus", value: 13 },
];
var CONTACT_GENDERS = [
    { title: "Male", value: 0 },
    { title: "Female", value: 1 },
    { title: "Other", value: 2 },
];
var CONTACT_SALUTATIONS = [
    { title: "Mr", value: "Mr" },
    { title: "Mrs", value: "Mrs" },
    { title: "Miss", value: "Miss" },
];
var CONTACT_MARKETING_SOURCES = [
    { title: "Shopping Centre", value: "Shopping Centre" },
    { title: "Train Billboard", value: "Train Billboard" },
    { title: "Friend/Family", value: "Friend/Family" },
    { title: "Newspaper", value: "Newspaper" },
    { title: "School", value: "School" },
    { title: "Facebook", value: "Facebook" },
    { title: "Google Advertisement", value: "Google Advertisement" },
    { title: "Internet Search Engine", value: "Internet Search Engine" },
    { title: "Other", value: "Other" },
];
var CONTACT_STATES = [
    { title: "New South Wales", value: "NSW" },
    { title: "Victoria", value: "VIC" },
    { title: "ACT", value: "ACT" },
    { title: "South Australia", value: "SA" },
    { title: "Queensland", value: "QLD" },
    { title: "Western Australia", value: "WA" },
    { title: "Northern Territory", value: "NT" },
];
var CONTACT_PHONE_LABELS = [
    { title: "Mobile", value: "mobile" },
    { title: "Home", value: "home" },
    { title: "Work", value: "work" },
];
//# sourceMappingURL=contacts.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/contact-form.ts












var contact_form_ContactFormComponent = (function () {
    function ContactFormComponent(store, contactEffects, modalService, completerService, constantsHelpers) {
        this.store = store;
        this.contactEffects = contactEffects;
        this.modalService = modalService;
        this.completerService = completerService;
        this.constantsHelpers = constantsHelpers;
        this.guardianUrl = "guardians?query=";
        this.isInEditMode = false;
        this.salutations = CONTACT_SALUTATIONS;
        this.genders = CONTACT_GENDERS;
        this.stateSearchStr = [];
        this.states = CONTACT_STATES;
        this.phoneLabelSearchStr = [];
        this.phoneLabels = CONTACT_PHONE_LABELS;
        this.types = CONTACT_TYPES;
        this.instalments = CONTACT_INSTALMENTS;
        this.grades = CONTACT_GRADES;
        this.schools = SCHOOLS;
        this.marketingSources = CONTACT_MARKETING_SOURCES;
    }
    ContactFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.contactsStore = this.store.select("contactsReducer");
        this.contactsStore.subscribe(function (s) {
            _this.contact = s.editableContact;
        });
        this.setupEffectEvents();
        this.salutationCompleter =
            this.completerService.local(this.salutations, "title", "title");
        this.gendersCompleter =
            this.completerService.local(this.genders, "title", "title");
        this.stateCompleter =
            this.completerService.local(this.states, "title", "title");
        this.phoneLabelCompleter =
            this.completerService.local(this.phoneLabels, "title", "title");
        this.typesCompleter =
            this.completerService.local(this.types, "title", "title");
        this.instalmentsCompleter =
            this.completerService.local(this.instalments, "title", "title");
        this.gradeCompleter =
            this.completerService.local(this.grades, "title", "title");
        this.schoolCompleter =
            this.completerService.local(this.schools, "title", "title");
        this.marketingSourceCompleter =
            this.completerService.local(this.marketingSources, "title", "title");
        this.guardianCompleter =
            this.completerService.remote(this.guardianUrl, "fullName", "fullName");
    };
    ContactFormComponent.prototype.clickedSubmitForm = function (e) {
        e.preventDefault();
        this.store.dispatch({ type: RESET_CONTACT_ERRORS, payload: this.contact });
        if (this.isInEditMode) {
            this.store.dispatch({ type: UPDATE_CONTACT, payload: this.contact });
        }
        else {
            this.store.dispatch({ type: CREATE_CONTACT, payload: this.contact });
        }
    };
    ContactFormComponent.prototype.clickedAddPhone = function () {
        this.contact.phones.push(new Phone());
    };
    ContactFormComponent.prototype.clickedAddAddress = function () {
        this.contact.addresses.push(new address_Address());
    };
    ContactFormComponent.prototype.clickedDeleteAddress = function (address) {
        this.contact.addresses.splice(this.contact.addresses.indexOf(address), 1);
    };
    ContactFormComponent.prototype.clickedDeletePhone = function (phone) {
        this.contact.phones.splice(this.contact.phones.indexOf(phone), 1);
    };
    ContactFormComponent.prototype.isAddressPersisted = function (address) {
        return !!address.id;
    };
    ContactFormComponent.prototype.isPhonePersisted = function (phone) {
        return !!phone.id;
    };
    ContactFormComponent.prototype.selectedSalutation = function (e) {
        if (e) {
            this.contact.salutation = e.originalObject.value;
        }
    };
    ContactFormComponent.prototype.selectedGender = function (e) {
        if (e) {
            this.contact.gender = parseInt(e.originalObject.value);
        }
    };
    ContactFormComponent.prototype.selectedState = function (address, e) {
        if (e) {
            address.state = e.originalObject.value;
        }
    };
    ContactFormComponent.prototype.selectedPhoneLabel = function (phone, e) {
        if (e) {
            phone.label = e.originalObject.value;
        }
    };
    ContactFormComponent.prototype.selectedType = function (e) {
        if (e) {
            this.contact.contactType = parseInt(e.originalObject.value);
        }
    };
    ContactFormComponent.prototype.selectedInstalments = function (e) {
        if (e) {
            this.contact.instalments = parseInt(e.originalObject.value);
        }
    };
    ContactFormComponent.prototype.selectedGrade = function (e) {
        if (e) {
            this.contact.grade = parseInt(e.originalObject.value);
        }
    };
    ContactFormComponent.prototype.selectedSchool = function (e) {
        if (e) {
            this.contact.school = e.originalObject.value;
        }
    };
    ContactFormComponent.prototype.selectedMarketingSource = function (e) {
        if (e) {
            this.contact.marketingSource = e.originalObject.value;
        }
    };
    ContactFormComponent.prototype.selectedGuardian = function (e) {
        if (e && e.originalObject) {
            var guardian = contact_Contact.clone(e.originalObject);
            this.contact.guardianId = guardian.id;
        }
    };
    ContactFormComponent.prototype.isContactType = function (contactType) {
        return this.contact.contactType === contactType;
    };
    ContactFormComponent.prototype.setupEffectEvents = function () {
        var _this = this;
        Observable["Observable"].merge(this.contactEffects.createContact, this.contactEffects.updateContact)
            .subscribe(function (action) {
            switch (action.type) {
                case ADD_CONTACT:
                    _this.modalService.closeModal();
                    break;
                case REPLACE_CONTACT:
                    _this.modalService.closeModal();
                    break;
            }
        });
    };
    ContactFormComponent.prototype.getHeader = function () {
        return this.isInEditMode ? "Editing " + this.contact.fullName : "New contact";
    };
    ContactFormComponent.prototype.ngOnDestroy = function () {
    };
    ContactFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: contact_ContactEffects }, { type: modal_ModalService }, { type: ng2_completer["a" /* CompleterService */] }, { type: helpers_ConstantsHelpers }]; };
    return ContactFormComponent;
}());

//# sourceMappingURL=contact-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/contact-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_ContactFormComponent = [];
var RenderType_ContactFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ContactFormComponent, data: {} });
function View_ContactFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.salutation;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 13, 'div', [['class',
                'input-group salutation']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'error': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'ng2-completer', [['id', 'salutation'], ['name', 'salutation']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.salutationSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedSalutation($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](5, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'label', [['for', 'salutation']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Sal.'])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_2)),
        core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'input-group salutation';
        var currVal_1 = _ck(_v, 2, 0, _co.contact.errors.salutation);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_9 = 0;
        var currVal_10 = true;
        var currVal_11 = _co.constantsHelpers.getObject(_co.contact.salutation, _co.salutations);
        var currVal_12 = _co.salutationCompleter;
        _ck(_v, 5, 0, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = 'salutation';
        var currVal_14 = _co.salutationSearchStr;
        _ck(_v, 7, 0, currVal_13, currVal_14);
        var currVal_15 = _co.contact.errors.salutation;
        _ck(_v, 13, 0, currVal_15);
    }, function (_ck, _v) {
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_ContactFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.firstName;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.lastName;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.gender;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.dob;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'div', [['class',
                'input-group dob icon']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'error': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 6, 'input', [['id', 'dob'], ['name', 'dob'], ['type', 'date'], ['useValueAsDate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null, 'blur'],
            [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 6).onChange($event.target.valueAsDate) !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.contact.dob = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵdid"](6, 16384, null, 0, date_value_accessor["DateValueAccessor"], [core_es5["Renderer"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], date_value_accessor["DateValueAccessor"]]), core_es5["ɵdid"](8, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](10, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'label', [['for', 'dob']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Date of birth'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_7)), core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'input-group dob icon';
        var currVal_1 = _ck(_v, 2, 0, _co.contact.errors.dob);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_9 = 'dob';
        var currVal_10 = _co.contact.dob;
        _ck(_v, 8, 0, currVal_9, currVal_10);
        var currVal_11 = _co.contact.errors.dob;
        _ck(_v, 14, 0, currVal_11);
    }, function (_ck, _v) {
        var currVal_2 = core_es5["ɵnov"](_v, 10).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 10).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 10).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 10).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 10).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 10).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 10).ngClassPending;
        _ck(_v, 4, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_ContactFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors.email;
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'span', [['class',
                'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['school'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 40, 'div', [['class',
                'cf__form-for-type student']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'input-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Student details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 27, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 13, 'div', [['class', 'input-group school half icon']], null, null, null, null, null)), core_es5["ɵdid"](5, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](6, { 'error': 0 }), (_l()(), core_es5["ɵeld"](7, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 5, 'ng2-completer', [['inputId', 'school'], ['name', 'school']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.schoolSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedSchool($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](9, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { inputId: [0, 'inputId'], minSearchLength: [1, 'minSearchLength'], openOnFocus: [2,
                'openOnFocus'], initialValue: [3, 'initialValue'], datasource: [4, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](11, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](13, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](14, 0, null, null, 1, 'label', [['for', 'school']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['School'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_10)), core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 12, 'div', [['class', 'input-group grade icon']], null, null, null, null, null)),
        core_es5["ɵdid"](19, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](20, { 'error': 0 }), (_l()(), core_es5["ɵeld"](21, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](22, 0, null, null, 5, 'ng2-completer', [['id', 'grade'], ['name', 'grade']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.gradeSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGrade($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](23, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](25, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](27, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](28, 0, null, null, 1, 'label', [['for', 'grade']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Grade'])), (_l()(), core_es5["ɵeld"](30, 0, null, null, 0, 'span', [['class', 'ig__error']], [[8, 'innerHTML', 1]], null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 9, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 8, 'div', [['class', 'input-group guardian']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](33, 0, null, null, 5, 'ng2-completer', [['id', 'guardian'], ['name', 'guardian']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.guardianSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGuardian($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](34, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { pause: [0, 'pause'], minSearchLength: [1, 'minSearchLength'], openOnFocus: [2,
                'openOnFocus'], initialValue: [3, 'initialValue'], datasource: [4, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](36, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](38, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](39, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Guardian']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'input-group school half icon';
        var currVal_1 = _ck(_v, 6, 0, _co.contact.errors['school']);
        _ck(_v, 5, 0, currVal_0, currVal_1);
        var currVal_9 = 'school';
        var currVal_10 = 0;
        var currVal_11 = true;
        var currVal_12 = _co.constantsHelpers.getObject(_co.contact.school, _co.schools);
        var currVal_13 = _co.schoolCompleter;
        _ck(_v, 9, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_14 = 'school';
        var currVal_15 = _co.schoolSearchStr;
        _ck(_v, 11, 0, currVal_14, currVal_15);
        var currVal_16 = _co.contact.errors['school'];
        _ck(_v, 17, 0, currVal_16);
        var currVal_17 = 'input-group grade icon';
        var currVal_18 = _ck(_v, 20, 0, _co.contact.errors['grade']);
        _ck(_v, 19, 0, currVal_17, currVal_18);
        var currVal_26 = 0;
        var currVal_27 = true;
        var currVal_28 = _co.grades[0];
        var currVal_29 = _co.gradeCompleter;
        _ck(_v, 23, 0, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'grade';
        var currVal_31 = _co.gradeSearchStr;
        _ck(_v, 25, 0, currVal_30, currVal_31);
        var currVal_40 = 500;
        var currVal_41 = 0;
        var currVal_42 = true;
        var currVal_43 = _co.contact.guardian;
        var currVal_44 = _co.guardianCompleter;
        _ck(_v, 34, 0, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44);
        var currVal_45 = 'guardian';
        var currVal_46 = _co.guardianSearchStr;
        _ck(_v, 36, 0, currVal_45, currVal_46);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_19 = core_es5["ɵnov"](_v, 27).ngClassUntouched;
        var currVal_20 = core_es5["ɵnov"](_v, 27).ngClassTouched;
        var currVal_21 = core_es5["ɵnov"](_v, 27).ngClassPristine;
        var currVal_22 = core_es5["ɵnov"](_v, 27).ngClassDirty;
        var currVal_23 = core_es5["ɵnov"](_v, 27).ngClassValid;
        var currVal_24 = core_es5["ɵnov"](_v, 27).ngClassInvalid;
        var currVal_25 = core_es5["ɵnov"](_v, 27).ngClassPending;
        _ck(_v, 22, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25);
        var currVal_32 = _co.contact.errors['grade'];
        _ck(_v, 30, 0, currVal_32);
        var currVal_33 = core_es5["ɵnov"](_v, 38).ngClassUntouched;
        var currVal_34 = core_es5["ɵnov"](_v, 38).ngClassTouched;
        var currVal_35 = core_es5["ɵnov"](_v, 38).ngClassPristine;
        var currVal_36 = core_es5["ɵnov"](_v, 38).ngClassDirty;
        var currVal_37 = core_es5["ɵnov"](_v, 38).ngClassValid;
        var currVal_38 = core_es5["ɵnov"](_v, 38).ngClassInvalid;
        var currVal_39 = core_es5["ɵnov"](_v, 38).ngClassPending;
        _ck(_v, 33, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39);
    });
}
function View_ContactFormComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['addresses'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error subtle']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['addresses.lineOne'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error subtle']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['addresses.suburb'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error subtle']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['addresses.postcode'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error subtle']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['addresses.state'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_17(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cf__no-addresses']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No addresses']))], null, null);
}
function View_ContactFormComponent_20(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'tiny cf__btn-delete-address']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDeleteAddress(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Cancel add']))], null, null);
}
function View_ContactFormComponent_19(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 60, 'li', [['class',
                'cf__address']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'h4', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['Address ', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_20)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 9, 'div', [['class', 'input-group half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Line one'])), (_l()(), core_es5["ɵeld"](10, 0, null, null, 5, 'input', [['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 11)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 11)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.lineOne = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](11, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](13, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](15, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 9, 'div', [['class', 'input-group half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Line two'])), (_l()(), core_es5["ɵeld"](21, 0, null, null, 5, 'input', [['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.lineTwo = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](22, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](24, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](26, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](27, 0, null, null, 33, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, [' '])), (_l()(), core_es5["ɵeld"](30, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Suburb'])),
        (_l()(), core_es5["ɵeld"](33, 0, null, null, 5, 'input', [['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 34)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 34).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 34)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 34)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.suburb = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](34, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](36, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](38, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, [' '])), (_l()(), core_es5["ɵeld"](41, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 5, 'ng2-completer', [['id', 'state']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.stateSearchStr[_v.context.index] = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedState(_v.context.$implicit, $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](43, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](45, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](47, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](48, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['State'])), (_l()(), core_es5["ɵeld"](50, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, [' '])), (_l()(),
            core_es5["ɵeld"](52, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](53, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Postcode'])), (_l()(), core_es5["ɵeld"](55, 0, null, null, 5, 'input', [['name', 'postcode'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 56)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 56).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 56)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 56)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.postcode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](56, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](58, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](60, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = !_co.isAddressPersisted(_v.context.$implicit);
        _ck(_v, 4, 0, currVal_1);
        var currVal_9 = (_v.context.index + '_lineOne');
        var currVal_10 = _v.context.$implicit.lineOne;
        _ck(_v, 13, 0, currVal_9, currVal_10);
        var currVal_18 = (_v.context.index + '_lineTwo');
        var currVal_19 = _v.context.$implicit.lineTwo;
        _ck(_v, 24, 0, currVal_18, currVal_19);
        var currVal_27 = (_v.context.index + '_suburb');
        var currVal_28 = _v.context.$implicit.suburb;
        _ck(_v, 36, 0, currVal_27, currVal_28);
        var currVal_36 = 0;
        var currVal_37 = true;
        var currVal_38 = (_co.constantsHelpers.getObject(_v.context.$implicit.state, _co.states) || _co.states[0]);
        var currVal_39 = _co.stateCompleter;
        _ck(_v, 43, 0, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = (_v.context.index + '_state');
        var currVal_41 = _co.stateSearchStr[_v.context.index];
        _ck(_v, 45, 0, currVal_40, currVal_41);
        var currVal_49 = 'postcode';
        var currVal_50 = _v.context.$implicit.postcode;
        _ck(_v, 58, 0, currVal_49, currVal_50);
    }, function (_ck, _v) {
        var currVal_0 = (_v.context.index + 1);
        _ck(_v, 2, 0, currVal_0);
        var currVal_2 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 10, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_11 = core_es5["ɵnov"](_v, 26).ngClassUntouched;
        var currVal_12 = core_es5["ɵnov"](_v, 26).ngClassTouched;
        var currVal_13 = core_es5["ɵnov"](_v, 26).ngClassPristine;
        var currVal_14 = core_es5["ɵnov"](_v, 26).ngClassDirty;
        var currVal_15 = core_es5["ɵnov"](_v, 26).ngClassValid;
        var currVal_16 = core_es5["ɵnov"](_v, 26).ngClassInvalid;
        var currVal_17 = core_es5["ɵnov"](_v, 26).ngClassPending;
        _ck(_v, 21, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_20 = core_es5["ɵnov"](_v, 38).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 38).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 38).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 38).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 38).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 38).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 38).ngClassPending;
        _ck(_v, 33, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_29 = core_es5["ɵnov"](_v, 47).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 47).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 47).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 47).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 47).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 47).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 47).ngClassPending;
        _ck(_v, 42, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_42 = core_es5["ɵnov"](_v, 60).ngClassUntouched;
        var currVal_43 = core_es5["ɵnov"](_v, 60).ngClassTouched;
        var currVal_44 = core_es5["ɵnov"](_v, 60).ngClassPristine;
        var currVal_45 = core_es5["ɵnov"](_v, 60).ngClassDirty;
        var currVal_46 = core_es5["ɵnov"](_v, 60).ngClassValid;
        var currVal_47 = core_es5["ɵnov"](_v, 60).ngClassInvalid;
        var currVal_48 = core_es5["ɵnov"](_v, 60).ngClassPending;
        _ck(_v, 55, 0, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48);
    });
}
function View_ContactFormComponent_18(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'cf__addresses']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_19)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.addresses;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_ContactFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 33, 'div', [['class',
                'cf__form-for-type student']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'input-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Parent details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 9, 'div', [['class', 'input-group instalments half icon']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'ng2-completer', [['id', 'instalments'],
            ['name', 'instalments']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.instalmentsSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedInstalments($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](7, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](9, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](11, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](12, 0, null, null, 1, 'label', [['for', 'instalments']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Instalment'])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 0, 'div', [['class', 'input-break']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](15, 0, null, null, 18, 'div', [['class', 'cf__addresses-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](16, 0, null, null, 3, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Address Details'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedAddAddress() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add address'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_12)),
        core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_13)), core_es5["ɵdid"](23, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_14)), core_es5["ɵdid"](25, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_15)),
        core_es5["ɵdid"](27, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_16)), core_es5["ɵdid"](29, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_17)), core_es5["ɵdid"](31, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_18)),
        core_es5["ɵdid"](33, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.constantsHelpers.getObject(_co.contact.instalments, _co.instalments);
        var currVal_10 = _co.instalmentsCompleter;
        _ck(_v, 7, 0, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_11 = 'instalments';
        var currVal_12 = _co.instalmentsSearchStr;
        _ck(_v, 9, 0, currVal_11, currVal_12);
        var currVal_13 = _co.contact.errors.addresses;
        _ck(_v, 21, 0, currVal_13);
        var currVal_14 = _co.contact.errors['addresses.lineOne'];
        _ck(_v, 23, 0, currVal_14);
        var currVal_15 = _co.contact.errors['addresses.suburb'];
        _ck(_v, 25, 0, currVal_15);
        var currVal_16 = _co.contact.errors['addresses.postcode'];
        _ck(_v, 27, 0, currVal_16);
        var currVal_17 = _co.contact.errors['addresses.state'];
        _ck(_v, 29, 0, currVal_17);
        var currVal_18 = (_co.contact.addresses.length == 0);
        _ck(_v, 31, 0, currVal_18);
        var currVal_19 = (_co.contact.addresses.length > 0);
        _ck(_v, 33, 0, currVal_19);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 11).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 11).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 11).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 11).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 11).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 11).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 11).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_ContactFormComponent_21(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'div', [['class',
                'cf__form-for-type student']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'input-header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Staff details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 11, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 10, 'div', [['class', 'input-group employment-start icon']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 6, 'input', [['id', 'employmentStart'],
            ['name', 'employmentStart'], ['type', 'date'], ['useValueAsDate', '']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('input' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 8).onChange($event.target.valueAsDate) !== false);
                ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.contact.employmentStart = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](8, 16384, null, 0, date_value_accessor["DateValueAccessor"], [core_es5["Renderer"],
            core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], date_value_accessor["DateValueAccessor"]]), core_es5["ɵdid"](10, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](12, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'label', [['for', 'employmentStart']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Employment start']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'employmentStart';
        var currVal_8 = _co.contact.employmentStart;
        _ck(_v, 10, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_ContactFormComponent_22(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['phones'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_23(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 0, 'div', [['class',
                'form-error subtle']], [[8, 'innerHTML', 1]], null, null, null, null))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.errors['phones.value'];
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ContactFormComponent_24(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'cf__no-phones']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['No phones']))], null, null);
}
function View_ContactFormComponent_27(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'tiny cf__btn-delete-phone']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDeletePhone(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Cancel add']))], null, null);
}
function View_ContactFormComponent_26(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 23, 'li', [['class',
                'cf__phone']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_27)),
        core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](3, 0, null, null, 20, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Type'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 5, 'ng2-completer', [['id', 'phone']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.phoneLabelSearchStr[_v.context.index] = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedPhoneLabel(_v.context.$implicit, $event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](9, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](11, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](13, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](14, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'label', [['for', 'i + \'_phoneValue\'']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Number'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 5, 'input', [['id', 'i + \'_phoneValue\''], ['type', 'text']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_v.context.$implicit.value = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](19, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](21, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isPhonePersisted(_v.context.$implicit);
        _ck(_v, 2, 0, currVal_0);
        var currVal_8 = 0;
        var currVal_9 = true;
        var currVal_10 = (_co.constantsHelpers.getObject(_v.context.$implicit.label, _co.phoneLabels) || _co.phoneLabels[0]);
        var currVal_11 = _co.phoneLabelCompleter;
        _ck(_v, 9, 0, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_12 = (_v.context.index + '_phone-label');
        var currVal_13 = _co.phoneLabelSearchStr[_v.context.index];
        _ck(_v, 11, 0, currVal_12, currVal_13);
        var currVal_21 = (_v.context.index + '_phoneValue');
        var currVal_22 = _v.context.$implicit.value;
        _ck(_v, 21, 0, currVal_21, currVal_22);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 8, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_14 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_15 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_16 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_17 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_18 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_19 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_20 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 18, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20);
    });
}
function View_ContactFormComponent_25(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'cf__phones']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_26)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.contact.phones;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_ContactFormComponent_28(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group full medical-condition icon']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Medical condition'])), (_l()(),
            core_es5["ɵeld"](4, 0, null, null, 5, 'input', [['name', 'medicalCondition'],
                ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
                [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                    null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                    'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (core_es5["ɵnov"](_v, 5)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (core_es5["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_4 = ((_co.contact.medicalCondition = $event) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'medicalCondition';
        var currVal_8 = _co.contact.medicalCondition;
        _ck(_v, 7, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_ContactFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 149, 'div', [['class',
                'contact-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 148, 'div', [['class', 'cf__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'cf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 145, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'div', [['class',
                'input-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Personal details'])),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 30, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_1)),
        core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](14, 0, null, null, 13, 'div', [['class', 'input-group first-name']], null, null, null, null, null)), core_es5["ɵdid"](15, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](16, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 5, 'input', [['id', 'first-name'],
            ['name', 'firstName'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.contact.firstName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](19, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](21, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 1, 'label', [['for', 'first-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_3)), core_es5["ɵdid"](27, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](28, 0, null, null, 13, 'div', [['class', 'input-group last-name']], null, null, null, null, null)), core_es5["ɵdid"](29, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](30, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](32, 0, null, null, 5, 'input', [['id', 'last-name'],
            ['name', 'lastName'], ['type', 'text']], [[2, 'ng-untouched', null], [2,
                'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 33)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 33).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 33)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 33)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.contact.lastName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](33, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](35, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](37, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](38, 0, null, null, 1, 'label', [['for', 'last-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_4)), core_es5["ɵdid"](41, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](42, 0, null, null, 16, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](43, 0, null, null, 13, 'div', [['class', 'input-group gender']], null, null, null, null, null)), core_es5["ɵdid"](44, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](45, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](46, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](47, 0, null, null, 5, 'ng2-completer', [['id', 'gender'],
            ['name', 'gender']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.genderSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGender($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](48, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](50, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](52, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](53, 0, null, null, 1, 'label', [['for', 'gender']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Gender'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_5)), core_es5["ɵdid"](56, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_6)),
        core_es5["ɵdid"](58, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](59, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](60, 0, null, null, 13, 'div', [['class', 'input-group email half icon']], null, null, null, null, null)), core_es5["ɵdid"](61, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](62, { 'error': 0 }),
        (_l()(), core_es5["ɵeld"](63, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](64, 0, null, null, 5, 'input', [['id', 'email'], ['name',
                'email'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 65)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 65).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 65)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 65)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.contact.email = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](65, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](67, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](69, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](70, 0, null, null, 1, 'label', [['for', 'email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_8)), core_es5["ɵdid"](73, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](74, 0, null, null, 0, 'div', [['class', 'input-break']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](75, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](76, 0, null, null, 9, 'div', [['class', 'input-group contact-type icon']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](77, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](78, 0, null, null, 5, 'ng2-completer', [['id', 'contact-type'], ['name', 'contact-type']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.typeSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedType($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](79, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](81, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](83, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](84, 0, null, null, 1, 'label', [['for', 'contact-type']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Contact type'])), (_l()(), core_es5["ɵeld"](86, 0, null, null, 0, 'div', [['class', 'input-break']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_9)), core_es5["ɵdid"](88, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_11)), core_es5["ɵdid"](90, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_21)),
        core_es5["ɵdid"](92, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](93, 0, null, null, 0, 'div', [['class', 'input-break']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](94, 0, null, null, 12, 'div', [['class', 'cf__phones-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](95, 0, null, null, 3, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Phone contact details'])),
        (_l()(), core_es5["ɵeld"](97, 0, null, null, 1, 'button', [['class', 'tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedAddPhone() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add phone'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_22)),
        core_es5["ɵdid"](100, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_23)), core_es5["ɵdid"](102, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_24)), core_es5["ɵdid"](104, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_25)),
        core_es5["ɵdid"](106, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](107, 0, null, null, 0, 'div', [['class', 'input-break']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](108, 0, null, null, 1, 'div', [['class', 'input-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Other details'])),
        (_l()(), core_es5["ɵeld"](110, 0, null, null, 22, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ContactFormComponent_28)),
        core_es5["ɵdid"](112, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](113, 0, null, null, 9, 'div', [['class', 'input-group marketing-source half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](114, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](115, 0, null, null, 5, 'ng2-completer', [['id', 'marketing-source'], ['name', 'marketing-source']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.marketingSourceSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedMarketingSource($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](116, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](118, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](120, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](121, 0, null, null, 1, 'label', [['for', 'marketing-source']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Marketing sources'])), (_l()(), core_es5["ɵeld"](123, 0, null, null, 9, 'div', [['class', 'input-group promo-code half icon']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](124, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](125, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Promo code'])), (_l()(), core_es5["ɵeld"](127, 0, null, null, 5, 'input', [['name', 'promoCode'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 128)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 128).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 128)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 128)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.contact.promoCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](128, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](130, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](132, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](133, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](134, 0, null, null, 9, 'div', [['class', 'input-group checkbox newsletter-subscription']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](135, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](136, 0, null, null, 5, 'input', [['id', 'newsletter-subscription'],
            ['name', 'newsletterSubscription'], ['type', 'checkbox']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 137).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 137).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.contact.newsletterSubscription = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](137, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](139, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](141, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](142, 0, null, null, 1, 'label', [['for', 'newsletter-subscription']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Subscribe to newsletter'])), (_l()(), core_es5["ɵeld"](144, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](145, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](146, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](147, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](148, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitForm($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](149, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = (_co.isContactType(1) || _co.isContactType(2));
        _ck(_v, 13, 0, currVal_8);
        var currVal_9 = 'input-group first-name';
        var currVal_10 = _ck(_v, 16, 0, _co.contact.errors.firstName);
        _ck(_v, 15, 0, currVal_9, currVal_10);
        var currVal_18 = 'firstName';
        var currVal_19 = _co.contact.firstName;
        _ck(_v, 21, 0, currVal_18, currVal_19);
        var currVal_20 = _co.contact.errors.firstName;
        _ck(_v, 27, 0, currVal_20);
        var currVal_21 = 'input-group last-name';
        var currVal_22 = _ck(_v, 30, 0, _co.contact.errors.lastName);
        _ck(_v, 29, 0, currVal_21, currVal_22);
        var currVal_30 = 'lastName';
        var currVal_31 = _co.contact.lastName;
        _ck(_v, 35, 0, currVal_30, currVal_31);
        var currVal_32 = _co.contact.errors.lastName;
        _ck(_v, 41, 0, currVal_32);
        var currVal_33 = 'input-group gender';
        var currVal_34 = _ck(_v, 45, 0, _co.contact.errors.gender);
        _ck(_v, 44, 0, currVal_33, currVal_34);
        var currVal_42 = 0;
        var currVal_43 = true;
        var currVal_44 = _co.constantsHelpers.getObject(_co.contact.gender, _co.genders);
        var currVal_45 = _co.gendersCompleter;
        _ck(_v, 48, 0, currVal_42, currVal_43, currVal_44, currVal_45);
        var currVal_46 = 'gender';
        var currVal_47 = _co.genderSearchStr;
        _ck(_v, 50, 0, currVal_46, currVal_47);
        var currVal_48 = _co.contact.errors.gender;
        _ck(_v, 56, 0, currVal_48);
        var currVal_49 = (_co.isContactType(0) || _co.isContactType(2));
        _ck(_v, 58, 0, currVal_49);
        var currVal_50 = 'input-group email half icon';
        var currVal_51 = _ck(_v, 62, 0, _co.contact.errors.email);
        _ck(_v, 61, 0, currVal_50, currVal_51);
        var currVal_59 = 'email';
        var currVal_60 = _co.contact.email;
        _ck(_v, 67, 0, currVal_59, currVal_60);
        var currVal_61 = _co.contact.errors.email;
        _ck(_v, 73, 0, currVal_61);
        var currVal_69 = 0;
        var currVal_70 = true;
        var currVal_71 = _co.constantsHelpers.getObject(_co.contact.contactType, _co.types);
        var currVal_72 = _co.typesCompleter;
        _ck(_v, 79, 0, currVal_69, currVal_70, currVal_71, currVal_72);
        var currVal_73 = 'contact-type';
        var currVal_74 = _co.typeSearchStr;
        _ck(_v, 81, 0, currVal_73, currVal_74);
        var currVal_75 = _co.isContactType(0);
        _ck(_v, 88, 0, currVal_75);
        var currVal_76 = _co.isContactType(1);
        _ck(_v, 90, 0, currVal_76);
        var currVal_77 = _co.isContactType(2);
        _ck(_v, 92, 0, currVal_77);
        var currVal_78 = _co.contact.errors.phones;
        _ck(_v, 100, 0, currVal_78);
        var currVal_79 = _co.contact.errors['phones.value'];
        _ck(_v, 102, 0, currVal_79);
        var currVal_80 = (_co.contact.phones.length == 0);
        _ck(_v, 104, 0, currVal_80);
        var currVal_81 = (_co.contact.phones.length > 0);
        _ck(_v, 106, 0, currVal_81);
        var currVal_82 = (_co.isContactType(0) || _co.isContactType(2));
        _ck(_v, 112, 0, currVal_82);
        var currVal_90 = 0;
        var currVal_91 = true;
        var currVal_92 = _co.constantsHelpers.getObject(_co.contact.marketingSource, _co.marketingSources);
        var currVal_93 = _co.marketingSourceCompleter;
        _ck(_v, 116, 0, currVal_90, currVal_91, currVal_92, currVal_93);
        var currVal_94 = 'marketing-source';
        var currVal_95 = _co.marketingSourceSearchStr;
        _ck(_v, 118, 0, currVal_94, currVal_95);
        var currVal_103 = 'promoCode';
        var currVal_104 = _co.contact.promoCode;
        _ck(_v, 130, 0, currVal_103, currVal_104);
        var currVal_112 = 'newsletterSubscription';
        var currVal_113 = _co.contact.newsletterSubscription;
        _ck(_v, 139, 0, currVal_112, currVal_113);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getHeader();
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_11 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_12 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_13 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_14 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_15 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_16 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_17 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 18, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_23 = core_es5["ɵnov"](_v, 37).ngClassUntouched;
        var currVal_24 = core_es5["ɵnov"](_v, 37).ngClassTouched;
        var currVal_25 = core_es5["ɵnov"](_v, 37).ngClassPristine;
        var currVal_26 = core_es5["ɵnov"](_v, 37).ngClassDirty;
        var currVal_27 = core_es5["ɵnov"](_v, 37).ngClassValid;
        var currVal_28 = core_es5["ɵnov"](_v, 37).ngClassInvalid;
        var currVal_29 = core_es5["ɵnov"](_v, 37).ngClassPending;
        _ck(_v, 32, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_35 = core_es5["ɵnov"](_v, 52).ngClassUntouched;
        var currVal_36 = core_es5["ɵnov"](_v, 52).ngClassTouched;
        var currVal_37 = core_es5["ɵnov"](_v, 52).ngClassPristine;
        var currVal_38 = core_es5["ɵnov"](_v, 52).ngClassDirty;
        var currVal_39 = core_es5["ɵnov"](_v, 52).ngClassValid;
        var currVal_40 = core_es5["ɵnov"](_v, 52).ngClassInvalid;
        var currVal_41 = core_es5["ɵnov"](_v, 52).ngClassPending;
        _ck(_v, 47, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41);
        var currVal_52 = core_es5["ɵnov"](_v, 69).ngClassUntouched;
        var currVal_53 = core_es5["ɵnov"](_v, 69).ngClassTouched;
        var currVal_54 = core_es5["ɵnov"](_v, 69).ngClassPristine;
        var currVal_55 = core_es5["ɵnov"](_v, 69).ngClassDirty;
        var currVal_56 = core_es5["ɵnov"](_v, 69).ngClassValid;
        var currVal_57 = core_es5["ɵnov"](_v, 69).ngClassInvalid;
        var currVal_58 = core_es5["ɵnov"](_v, 69).ngClassPending;
        _ck(_v, 64, 0, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58);
        var currVal_62 = core_es5["ɵnov"](_v, 83).ngClassUntouched;
        var currVal_63 = core_es5["ɵnov"](_v, 83).ngClassTouched;
        var currVal_64 = core_es5["ɵnov"](_v, 83).ngClassPristine;
        var currVal_65 = core_es5["ɵnov"](_v, 83).ngClassDirty;
        var currVal_66 = core_es5["ɵnov"](_v, 83).ngClassValid;
        var currVal_67 = core_es5["ɵnov"](_v, 83).ngClassInvalid;
        var currVal_68 = core_es5["ɵnov"](_v, 83).ngClassPending;
        _ck(_v, 78, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_83 = core_es5["ɵnov"](_v, 120).ngClassUntouched;
        var currVal_84 = core_es5["ɵnov"](_v, 120).ngClassTouched;
        var currVal_85 = core_es5["ɵnov"](_v, 120).ngClassPristine;
        var currVal_86 = core_es5["ɵnov"](_v, 120).ngClassDirty;
        var currVal_87 = core_es5["ɵnov"](_v, 120).ngClassValid;
        var currVal_88 = core_es5["ɵnov"](_v, 120).ngClassInvalid;
        var currVal_89 = core_es5["ɵnov"](_v, 120).ngClassPending;
        _ck(_v, 115, 0, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89);
        var currVal_96 = core_es5["ɵnov"](_v, 132).ngClassUntouched;
        var currVal_97 = core_es5["ɵnov"](_v, 132).ngClassTouched;
        var currVal_98 = core_es5["ɵnov"](_v, 132).ngClassPristine;
        var currVal_99 = core_es5["ɵnov"](_v, 132).ngClassDirty;
        var currVal_100 = core_es5["ɵnov"](_v, 132).ngClassValid;
        var currVal_101 = core_es5["ɵnov"](_v, 132).ngClassInvalid;
        var currVal_102 = core_es5["ɵnov"](_v, 132).ngClassPending;
        _ck(_v, 127, 0, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102);
        var currVal_105 = core_es5["ɵnov"](_v, 141).ngClassUntouched;
        var currVal_106 = core_es5["ɵnov"](_v, 141).ngClassTouched;
        var currVal_107 = core_es5["ɵnov"](_v, 141).ngClassPristine;
        var currVal_108 = core_es5["ɵnov"](_v, 141).ngClassDirty;
        var currVal_109 = core_es5["ɵnov"](_v, 141).ngClassValid;
        var currVal_110 = core_es5["ɵnov"](_v, 141).ngClassInvalid;
        var currVal_111 = core_es5["ɵnov"](_v, 141).ngClassPending;
        _ck(_v, 136, 0, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111);
        var currVal_114 = (_co.isInEditMode ? 'Update Contact' : 'Create Contact');
        _ck(_v, 149, 0, currVal_114);
    });
}
function View_ContactFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'contact-form', [], null, null, null, View_ContactFormComponent_0, RenderType_ContactFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, contact_form_ContactFormComponent, [src_store["a" /* Store */], contact_ContactEffects, modal_ModalService, completer_service["a" /* CompleterService */], helpers_ConstantsHelpers], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ContactFormComponentNgFactory = core_es5["ɵccf"]('contact-form', contact_form_ContactFormComponent, View_ContactFormComponent_Host_0, { isInEditMode: 'isInEditMode' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=contact-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/enquiry.ts





var enquiry_EnquiryService = (function () {
    function EnquiryService(http, actionCableService, store) {
        this.http = http;
        this.actionCableService = actionCableService;
        this.store = store;
        this.enquiriesUrl = 'enquiries';
    }
    EnquiryService.prototype.index = function () {
        return this.http.get(this.enquiriesUrl)
            .map(function (res) { return res.json().map(function (e) { return enquiry_Enquiry.clone(e); }); })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.prototype.fetch = function (id) {
        return this.http.get(this.enquiriesUrl + "/" + id)
            .map(function (res) { return enquiry_Enquiry.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.prototype.fetchByGuid = function (guid) {
        return this.http.get(this.enquiriesUrl + "/by_guid/" + guid)
            .map(function (res) { return enquiry_Enquiry.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.prototype.create = function (enquiry) {
        return this.http.post(this.enquiriesUrl, enquiry)
            .map(function (res) { return enquiry_Enquiry.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.prototype.update = function (enquiry) {
        return this.http.patch(this.enquiriesUrl + "/" + enquiry.id, enquiry)
            .map(function (res) { return enquiry_Enquiry.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.prototype.convertEnquiryToContact = function (id, contactType) {
        return this.http.patch(this.enquiriesUrl + "/" + id + "/convert_to_contact/" + contactType, {})
            .map(function (res) { return res.json().result; })
            .catch(function (error) { return Observable["Observable"].throw(error); });
    };
    EnquiryService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: ActionCableService }, { type: _ngrx_store["f" /* Store */] }]; };
    return EnquiryService;
}());

//# sourceMappingURL=enquiry.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/enquiry.ts
var enquiry___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var enquiry___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var enquiry_EnquiryEffects = (function () {
    function EnquiryEffects(actions, enquiryService, matrixClassService) {
        var _this = this;
        this.actions = actions;
        this.enquiryService = enquiryService;
        this.matrixClassService = matrixClassService;
        this.fetchEnquiries = this.actions
            .ofType(FETCH_ENQUIRIES)
            .switchMap(function () { return _this.enquiryService.index()
            .map(function (enquiries) { return ({ type: POPULATE_ENQUIRIES, payload: enquiries }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ENQUIRIES_FAILURE }); }); })
            .share();
        this.fetchEnquiry = this.actions
            .ofType(FETCH_ENQUIRY)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enquiryService.fetch(payload)
            .map(function (enquiries) { return ({ type: POPULATE_ACTIVE_ENQUIRY, payload: enquiries }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_ENQUIRY_FAILURE }); }); })
            .share();
        this.fetchEnquiryByGuid = this.actions
            .ofType(FETCH_ENQUIRY_BY_GUID)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enquiryService.fetchByGuid(payload)
            .map(function (enquiries) { return ({ type: POPULATE_ACTIVE_ENQUIRY, payload: enquiries }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_ENQUIRY_FAILURE }); }); })
            .share();
        this.updateEnquiry = this.actions
            .ofType(UPDATE_ENQUIRY)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enquiryService.update(payload.serializeForRails())
            .map(function (enquiry) { return ({ type: REPLACE_ENQUIRY, payload: enquiry }); })
            .catch(function (response) { return Observable["Observable"].of({ type: UPDATE_ENQUIRY_FAILURE, payload: response }); }); })
            .share();
        this.createEnquiry = this.actions
            .ofType(CREATE_ENQUIRY)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.enquiryService.create(payload.serializeForRails())
            .map(function (enquiry) { return ({ type: ADD_ENQUIRY, payload: enquiry }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_ENQUIRY_FAILURE, payload: response }); }); })
            .share();
        this.fetchPotentialClasses = this.actions
            .ofType(FETCH_ENQUIRY_CLASSES)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.matrixClassService.index(params)
            .map(function (classes) { return ({ type: POPULATE_ENQUIRY_CLASSES, payload: classes }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_ENQUIRY_CLASSES_FAILURE, payload: response }); }); })
            .share();
        this.convertEnquiryToContact = this.actions
            .ofType(CONVERT_ENQUIRY_TO_CONTACT)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.enquiryService.convertEnquiryToContact(params.id, params.contactType)
            .map(function (classes) { return ({ type: CONVERTED_ENQUIRY_TO_CONTACT }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CONVERT_ENQUIRY_TO_CONTACT_FAILURE, payload: response }); }); })
            .share();
    }
    EnquiryEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: enquiry_EnquiryService }, { type: matrix_class_MatrixClassService }]; };
    return EnquiryEffects;
}());

enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "fetchEnquiries", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "fetchEnquiry", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "fetchEnquiryByGuid", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "updateEnquiry", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "createEnquiry", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "fetchPotentialClasses", void 0);
enquiry___decorate([
    Object(effects["b" /* Effect */])(),
    enquiry___metadata("design:type", Object)
], enquiry_EnquiryEffects.prototype, "convertEnquiryToContact", void 0);
//# sourceMappingURL=enquiry.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/enquiries.ts
var ENQUIRY_STATUSES = [
    { title: "Received", value: 0 },
    { title: "Follow up", value: 1 },
    { title: "Pending DDR", value: 2 },
    { title: "Unreachable", value: 3 },
    { title: "Declined", value: 4 },
    { title: "Duplicate", value: 5 },
    { title: "Enrolled", value: 6 },
    { title: "Invalid", value: 7 },
];
//# sourceMappingURL=enquiries.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/enquiry-form.ts











var enquiry_form_EnquiryFormComponent = (function () {
    function EnquiryFormComponent(store, enquiryEffects, modalService, completerService, constantsHelpers) {
        this.store = store;
        this.enquiryEffects = enquiryEffects;
        this.modalService = modalService;
        this.completerService = completerService;
        this.constantsHelpers = constantsHelpers;
        this.isInEditMode = false;
        this.enquiry = new enquiry_Enquiry();
        this.genders = CONTACT_GENDERS;
        this.contactTypes = CONTACT_TYPES.filter(function (c) { return c.value !== 2; });
        this.grades = CONTACT_GRADES;
        this.schools = SCHOOLS;
        this.enquiryStatuses = ENQUIRY_STATUSES;
        this.gendersCompleter =
            this.completerService.local(this.genders, "title", "title");
        this.contactTypesCompleter =
            this.completerService.local(this.contactTypes, "title", "title");
        this.gradeCompleter =
            this.completerService.local(this.grades, "title", "title");
        this.schoolCompleter =
            this.completerService.local(this.schools, "title", "title");
        this.enquiryStatusesCompleter =
            this.completerService.local(this.enquiryStatuses, "title", "title");
    }
    EnquiryFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enquiriesStore = this.store.select("enquiriesReducer");
        this.enquiriesStore.subscribe(function (s) { return _this.enquiry = s.editableEnquiry; });
        this.setupEffectEvents();
    };
    EnquiryFormComponent.prototype.setupEffectEvents = function () {
        var _this = this;
        Observable["Observable"].merge(this.enquiryEffects.updateEnquiry, this.enquiryEffects.createEnquiry)
            .subscribe(function (action) {
            switch (action.type) {
                case ADD_ENQUIRY:
                    _this.modalService.closeModal();
                    break;
                case REPLACE_ENQUIRY:
                    _this.modalService.closeModal();
                    break;
            }
        });
    };
    EnquiryFormComponent.prototype.clickedSubmitForm = function (e) {
        e.preventDefault();
        this.store.dispatch({ type: RESET_ENQUIRY_ERRORS, payload: this.enquiry });
        if (this.isInEditMode) {
            this.store.dispatch({ type: UPDATE_ENQUIRY, payload: this.enquiry });
        }
        else {
            this.store.dispatch({ type: CREATE_ENQUIRY, payload: this.enquiry });
        }
    };
    EnquiryFormComponent.prototype.getHeader = function () {
        return this.isInEditMode ? "Editing " + this.enquiry.studentFirstName : "New enquiry";
    };
    EnquiryFormComponent.prototype.isTypeSelected = function (contactType) {
        return this.enquiry.quickContactType == contactType;
    };
    EnquiryFormComponent.prototype.clickedTypeOption = function (contactType) {
        return this.enquiry.quickContactType = contactType;
    };
    EnquiryFormComponent.prototype.selectedStudentGender = function (e) {
        if (e) {
            this.enquiry.studentGender = e.originalObject.value || "0";
        }
    };
    EnquiryFormComponent.prototype.selectedParentGender = function (e) {
        if (e) {
            this.enquiry.parentGender = e.originalObject.value || "0";
        }
    };
    EnquiryFormComponent.prototype.selectedPreferredContact = function (e) {
        if (e) {
            this.enquiry.preferredContact = e.originalObject.value;
        }
    };
    EnquiryFormComponent.prototype.selectedGrade = function (e) {
        if (e) {
            this.enquiry.grade = e.originalObject.value;
        }
    };
    EnquiryFormComponent.prototype.selectedSchool = function (e) {
        if (e) {
            this.enquiry.school = e.originalObject.value;
        }
    };
    EnquiryFormComponent.prototype.selectedEnquiryStatus = function (e) {
        if (e) {
            this.enquiry.enquiryStatus = e.originalObject.value;
        }
    };
    EnquiryFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: enquiry_EnquiryEffects }, { type: modal_ModalService }, { type: ng2_completer["a" /* CompleterService */] }, { type: helpers_ConstantsHelpers }]; };
    return EnquiryFormComponent;
}());

//# sourceMappingURL=enquiry-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/enquiry-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_EnquiryFormComponent = [];
var RenderType_EnquiryFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_EnquiryFormComponent, data: {} });
function View_EnquiryFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'form-error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enquiry.errors['base'];
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_EnquiryFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 46, 'div', [['class',
                'ef__form-area-quick']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Quick contact details'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 43, 'div', [['class', 'ef__quick-contact-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 9, 'div', [['class', 'input-group quick-full-name']], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](5, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Full name'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 5, 'input', [['name', 'quickFullName'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.quickFullName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](11, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](13, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 9, 'div', [['class', 'input-group quick-email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 5, 'input', [['name', 'quickEmail'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.quickEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](19, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](21, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 9, 'div', [['class', 'input-group quick-mobile']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Mobile'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 5, 'input', [['name', 'quickMobile'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 29)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 29).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 29)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 29)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.quickMobile = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](29, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](31, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](33, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](34, 0, null, null, 12, 'div', [['class', 'input-group quick-contact-type']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](35, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Contact type'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 8, 'div', [['class', 'ef__contact-type-picker']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 3, 'div', [['class', 'ef__contact-type']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTypeOption('parent') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](40, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](41, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['...parent'])), (_l()(), core_es5["ɵeld"](43, 0, null, null, 3, 'div', [['class', 'ef__contact-type']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTypeOption('student') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](44, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](45, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['...student']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'quickFullName';
        var currVal_8 = _co.enquiry.quickFullName;
        _ck(_v, 11, 0, currVal_7, currVal_8);
        var currVal_16 = 'quickEmail';
        var currVal_17 = _co.enquiry.quickEmail;
        _ck(_v, 21, 0, currVal_16, currVal_17);
        var currVal_25 = 'quickMobile';
        var currVal_26 = _co.enquiry.quickMobile;
        _ck(_v, 31, 0, currVal_25, currVal_26);
        var currVal_27 = 'ef__contact-type';
        var currVal_28 = _ck(_v, 41, 0, _co.isTypeSelected('parent'));
        _ck(_v, 40, 0, currVal_27, currVal_28);
        var currVal_29 = 'ef__contact-type';
        var currVal_30 = _ck(_v, 45, 0, _co.isTypeSelected('student'));
        _ck(_v, 44, 0, currVal_29, currVal_30);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 13).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 13).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 13).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 13).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 13).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 13).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 13).ngClassPending;
        _ck(_v, 8, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 18, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_18 = core_es5["ɵnov"](_v, 33).ngClassUntouched;
        var currVal_19 = core_es5["ɵnov"](_v, 33).ngClassTouched;
        var currVal_20 = core_es5["ɵnov"](_v, 33).ngClassPristine;
        var currVal_21 = core_es5["ɵnov"](_v, 33).ngClassDirty;
        var currVal_22 = core_es5["ɵnov"](_v, 33).ngClassValid;
        var currVal_23 = core_es5["ɵnov"](_v, 33).ngClassInvalid;
        var currVal_24 = core_es5["ɵnov"](_v, 33).ngClassPending;
        _ck(_v, 28, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
    });
}
function View_EnquiryFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 201, 'div', [['class',
                'enquiry-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 200, 'div', [['class', 'ef__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'ef__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 197, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 6).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 6).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgForm"], [[8,
                null], [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnquiryFormComponent_1)), core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnquiryFormComponent_2)),
        core_es5["ɵdid"](12, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](13, 0, null, null, 118, 'div', [['class', 'ef__form-area-main']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](14, 0, null, null, 63, 'div', [['class', 'ef__column lhs student-details']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'div', [['class', 'input-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student details'])), (_l()(), core_es5["ɵeld"](17, 0, null, null, 60, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](18, 0, null, null, 9, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 5, 'input', [['id', 'student-first-name'], ['name', 'studentFirstName'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 21)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 21).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 21)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 21)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.studentFirstName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](21, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](23, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](25, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 1, 'label', [['for', 'student-first-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 9, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 5, 'input', [['id', 'student-last-name'],
            ['name', 'studentLastName'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.studentLastName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](31, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](33, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](35, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'label', [['for', 'student-last-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 9, 'div', [['class', 'input-group gender full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](40, 0, null, null, 5, 'ng2-completer', [['id', 'student-gender'],
            ['name', 'studentGender']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.studentGenderSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedStudentGender($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](41, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](43, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](45, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](46, 0, null, null, 1, 'label', [['for', 'student-gender']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Gender'])), (_l()(), core_es5["ɵeld"](48, 0, null, null, 9, 'div', [['class', 'input-group dob icon full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](49, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](50, 0, null, null, 5, 'input', [['id', 'student-dob'],
            ['name', 'studentDob'], ['type', 'date']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.studentDob = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](51, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](53, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](55, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](56, 0, null, null, 1, 'label', [['for', 'student-dob']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Date of birth'])), (_l()(), core_es5["ɵeld"](58, 0, null, null, 9, 'div', [['class', 'input-group phone icon full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](59, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](60, 0, null, null, 5, 'input', [['id', 'student-phone'],
            ['name', 'studentPhone'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 61)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 61).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 61)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 61)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.studentPhone = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](61, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](63, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](65, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](66, 0, null, null, 1, 'label', [['for', 'student-phone']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Phone'])), (_l()(), core_es5["ɵeld"](68, 0, null, null, 9, 'div', [['class', 'input-group email icon full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](69, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](70, 0, null, null, 5, 'input', [['id', 'student-email'],
            ['name', 'studentEmail'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 71)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 71).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 71)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 71)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.studentEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](71, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](73, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](75, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](76, 0, null, null, 1, 'label', [['for', 'student-phone']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](78, 0, null, null, 53, 'div', [['class', 'ef__column rhs parent-details']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](79, 0, null, null, 1, 'div', [['class', 'input-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Parent details'])), (_l()(), core_es5["ɵeld"](81, 0, null, null, 50, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](82, 0, null, null, 9, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](83, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](84, 0, null, null, 5, 'input', [['id', 'parent-first-name'], ['name', 'parentFirstName'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 85)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 85).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 85)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 85)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.parentFirstName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](85, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](87, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](89, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](90, 0, null, null, 1, 'label', [['for', 'parent-first-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['First name'])), (_l()(), core_es5["ɵeld"](92, 0, null, null, 9, 'div', [['class', 'input-group first-name half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](93, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](94, 0, null, null, 5, 'input', [['id', 'parent-last-name'],
            ['name', 'parentLastName'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 95)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 95).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 95)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 95)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.parentLastName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](95, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](97, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](99, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](100, 0, null, null, 1, 'label', [['for', 'parent-last-name']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Last name'])), (_l()(), core_es5["ɵeld"](102, 0, null, null, 9, 'div', [['class', 'input-group gender full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](103, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](104, 0, null, null, 5, 'ng2-completer', [['id', 'parent-gender'],
            ['name', 'parentGender']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.parentGenderSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedParentGender($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](105, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](107, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](109, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](110, 0, null, null, 1, 'label', [['for', 'parent-gender']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Gender'])), (_l()(), core_es5["ɵeld"](112, 0, null, null, 9, 'div', [['class', 'input-group phone icon full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](113, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](114, 0, null, null, 5, 'input', [['id', 'parent-phone'],
            ['name', 'parentPhone'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 115)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 115).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 115)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 115)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.parentPhone = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](115, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](117, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](119, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](120, 0, null, null, 1, 'label', [['for', 'parent-phone']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Phone'])), (_l()(), core_es5["ɵeld"](122, 0, null, null, 9, 'div', [['class', 'input-group email icon full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](123, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](124, 0, null, null, 5, 'input', [['id', 'parent-email'],
            ['name', 'parentEmail'], ['type', 'text']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 125)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 125).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 125)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 125)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.parentEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](125, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](127, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](129, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](130, 0, null, null, 1, 'label', [['for', 'parent-email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](132, 0, null, null, 1, 'div', [['class', 'input-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enquiry details'])), (_l()(), core_es5["ɵeld"](134, 0, null, null, 20, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](135, 0, null, null, 9, 'div', [['class', 'input-group email icon half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](136, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](137, 0, null, null, 5, 'input', [['id', 'email'], ['name', 'email'], ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 138)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 138).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 138)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 138)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.enquiry.quickEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](138, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](140, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](142, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](143, 0, null, null, 1, 'label', [['for', 'email']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Email'])), (_l()(), core_es5["ɵeld"](145, 0, null, null, 9, 'div', [['class', 'input-group preferred-contact half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](146, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](147, 0, null, null, 5, 'ng2-completer', [['id', 'preferred-contact'],
            ['name', 'preferredContact']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.contactTypesSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedPreferredContact($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](148, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](150, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](152, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](153, 0, null, null, 1, 'label', [['for', 'preferred-contact']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Preferred contact'])), (_l()(), core_es5["ɵeld"](155, 0, null, null, 40, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](156, 0, null, null, 9, 'div', [['class', 'input-group grade half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](157, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](158, 0, null, null, 5, 'ng2-completer', [['id', 'grade'],
            ['name', 'grade']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.gradeSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedGrade($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](159, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](161, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](163, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](164, 0, null, null, 1, 'label', [['for', 'grade']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Grade'])), (_l()(), core_es5["ɵeld"](166, 0, null, null, 9, 'div', [['class', 'input-group school half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](167, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](168, 0, null, null, 5, 'ng2-completer', [['id', 'school'], ['name', 'school']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.schoolSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedSchool($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](169, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](171, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](173, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](174, 0, null, null, 1, 'label', [['for', 'school']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['School'])), (_l()(), core_es5["ɵeld"](176, 0, null, null, 9, 'div', [['class', 'input-group is-on-waiting-list half checkbox']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](177, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](178, 0, null, null, 5, 'input', [['id', 'is-on-waiting-list'],
            ['name', 'is-on-waiting-list'], ['type', 'checkbox']], [[1, 'checked', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 179).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 179).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.enquiry.isOnWaitingList = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](179, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](181, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null],
            [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }),
        core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](183, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](184, 0, null, null, 1, 'label', [['for', 'is-on-waiting-list']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Waiting list?'])), (_l()(), core_es5["ɵeld"](186, 0, null, null, 9, 'div', [['class', 'input-group enquiry-status half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](187, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](188, 0, null, null, 5, 'ng2-completer', [['id', 'enquiry-status'],
            ['name', 'enquiryStatus']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.enquiryStatusSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedEnquiryStatus($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](189, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](191, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](193, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](194, 0, null, null, 1, 'label', [['for', 'enquiry-status']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Enquiry status'])), (_l()(), core_es5["ɵeld"](196, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](197, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](198, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](199, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](200, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitForm($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](201, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = _co.enquiry.errors['base'];
        _ck(_v, 10, 0, currVal_8);
        var currVal_9 = !_co.enquiry.isInternal;
        _ck(_v, 12, 0, currVal_9);
        var currVal_17 = 'studentFirstName';
        var currVal_18 = _co.enquiry.studentFirstName;
        _ck(_v, 23, 0, currVal_17, currVal_18);
        var currVal_26 = 'studentLastName';
        var currVal_27 = _co.enquiry.studentLastName;
        _ck(_v, 33, 0, currVal_26, currVal_27);
        var currVal_35 = 0;
        var currVal_36 = true;
        var currVal_37 = _co.constantsHelpers.getObject(_co.enquiry.studentGender, _co.genders);
        var currVal_38 = _co.gendersCompleter;
        _ck(_v, 41, 0, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_39 = 'studentGender';
        var currVal_40 = _co.studentGenderSearchStr;
        _ck(_v, 43, 0, currVal_39, currVal_40);
        var currVal_48 = 'studentDob';
        var currVal_49 = _co.enquiry.studentDob;
        _ck(_v, 53, 0, currVal_48, currVal_49);
        var currVal_57 = 'studentPhone';
        var currVal_58 = _co.enquiry.studentPhone;
        _ck(_v, 63, 0, currVal_57, currVal_58);
        var currVal_66 = 'studentEmail';
        var currVal_67 = _co.enquiry.studentEmail;
        _ck(_v, 73, 0, currVal_66, currVal_67);
        var currVal_75 = 'parentFirstName';
        var currVal_76 = _co.enquiry.parentFirstName;
        _ck(_v, 87, 0, currVal_75, currVal_76);
        var currVal_84 = 'parentLastName';
        var currVal_85 = _co.enquiry.parentLastName;
        _ck(_v, 97, 0, currVal_84, currVal_85);
        var currVal_93 = 0;
        var currVal_94 = true;
        var currVal_95 = _co.constantsHelpers.getObject(_co.enquiry.parentGender, _co.genders);
        var currVal_96 = _co.gendersCompleter;
        _ck(_v, 105, 0, currVal_93, currVal_94, currVal_95, currVal_96);
        var currVal_97 = 'parentGender';
        var currVal_98 = _co.parentGenderSearchStr;
        _ck(_v, 107, 0, currVal_97, currVal_98);
        var currVal_106 = 'parentPhone';
        var currVal_107 = _co.enquiry.parentPhone;
        _ck(_v, 117, 0, currVal_106, currVal_107);
        var currVal_115 = 'parentEmail';
        var currVal_116 = _co.enquiry.parentEmail;
        _ck(_v, 127, 0, currVal_115, currVal_116);
        var currVal_124 = 'email';
        var currVal_125 = _co.enquiry.quickEmail;
        _ck(_v, 140, 0, currVal_124, currVal_125);
        var currVal_133 = 0;
        var currVal_134 = true;
        var currVal_135 = _co.constantsHelpers.getObject(_co.enquiry.preferredContact, _co.contactTypes);
        var currVal_136 = _co.contactTypesCompleter;
        _ck(_v, 148, 0, currVal_133, currVal_134, currVal_135, currVal_136);
        var currVal_137 = 'preferredContact';
        var currVal_138 = _co.contactTypesSearchStr;
        _ck(_v, 150, 0, currVal_137, currVal_138);
        var currVal_146 = 0;
        var currVal_147 = true;
        var currVal_148 = _co.constantsHelpers.getObject(_co.enquiry.grade, _co.grades);
        var currVal_149 = _co.gradeCompleter;
        _ck(_v, 159, 0, currVal_146, currVal_147, currVal_148, currVal_149);
        var currVal_150 = 'grade';
        var currVal_151 = _co.gradeSearchStr;
        _ck(_v, 161, 0, currVal_150, currVal_151);
        var currVal_159 = 0;
        var currVal_160 = true;
        var currVal_161 = _co.constantsHelpers.getObject(_co.enquiry.school, _co.schools);
        var currVal_162 = _co.schoolCompleter;
        _ck(_v, 169, 0, currVal_159, currVal_160, currVal_161, currVal_162);
        var currVal_163 = 'school';
        var currVal_164 = _co.schoolSearchStr;
        _ck(_v, 171, 0, currVal_163, currVal_164);
        var currVal_173 = 'is-on-waiting-list';
        var currVal_174 = _co.enquiry.isOnWaitingList;
        _ck(_v, 181, 0, currVal_173, currVal_174);
        var currVal_182 = 0;
        var currVal_183 = true;
        var currVal_184 = _co.constantsHelpers.getObject(_co.enquiry.enquiryStatus, _co.enquiryStatuses);
        var currVal_185 = _co.enquiryStatusesCompleter;
        _ck(_v, 189, 0, currVal_182, currVal_183, currVal_184, currVal_185);
        var currVal_186 = 'enquiryStatus';
        var currVal_187 = _co.enquiryStatusSearchStr;
        _ck(_v, 191, 0, currVal_186, currVal_187);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getHeader();
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_10 = core_es5["ɵnov"](_v, 25).ngClassUntouched;
        var currVal_11 = core_es5["ɵnov"](_v, 25).ngClassTouched;
        var currVal_12 = core_es5["ɵnov"](_v, 25).ngClassPristine;
        var currVal_13 = core_es5["ɵnov"](_v, 25).ngClassDirty;
        var currVal_14 = core_es5["ɵnov"](_v, 25).ngClassValid;
        var currVal_15 = core_es5["ɵnov"](_v, 25).ngClassInvalid;
        var currVal_16 = core_es5["ɵnov"](_v, 25).ngClassPending;
        _ck(_v, 20, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16);
        var currVal_19 = core_es5["ɵnov"](_v, 35).ngClassUntouched;
        var currVal_20 = core_es5["ɵnov"](_v, 35).ngClassTouched;
        var currVal_21 = core_es5["ɵnov"](_v, 35).ngClassPristine;
        var currVal_22 = core_es5["ɵnov"](_v, 35).ngClassDirty;
        var currVal_23 = core_es5["ɵnov"](_v, 35).ngClassValid;
        var currVal_24 = core_es5["ɵnov"](_v, 35).ngClassInvalid;
        var currVal_25 = core_es5["ɵnov"](_v, 35).ngClassPending;
        _ck(_v, 30, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25);
        var currVal_28 = core_es5["ɵnov"](_v, 45).ngClassUntouched;
        var currVal_29 = core_es5["ɵnov"](_v, 45).ngClassTouched;
        var currVal_30 = core_es5["ɵnov"](_v, 45).ngClassPristine;
        var currVal_31 = core_es5["ɵnov"](_v, 45).ngClassDirty;
        var currVal_32 = core_es5["ɵnov"](_v, 45).ngClassValid;
        var currVal_33 = core_es5["ɵnov"](_v, 45).ngClassInvalid;
        var currVal_34 = core_es5["ɵnov"](_v, 45).ngClassPending;
        _ck(_v, 40, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_41 = core_es5["ɵnov"](_v, 55).ngClassUntouched;
        var currVal_42 = core_es5["ɵnov"](_v, 55).ngClassTouched;
        var currVal_43 = core_es5["ɵnov"](_v, 55).ngClassPristine;
        var currVal_44 = core_es5["ɵnov"](_v, 55).ngClassDirty;
        var currVal_45 = core_es5["ɵnov"](_v, 55).ngClassValid;
        var currVal_46 = core_es5["ɵnov"](_v, 55).ngClassInvalid;
        var currVal_47 = core_es5["ɵnov"](_v, 55).ngClassPending;
        _ck(_v, 50, 0, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47);
        var currVal_50 = core_es5["ɵnov"](_v, 65).ngClassUntouched;
        var currVal_51 = core_es5["ɵnov"](_v, 65).ngClassTouched;
        var currVal_52 = core_es5["ɵnov"](_v, 65).ngClassPristine;
        var currVal_53 = core_es5["ɵnov"](_v, 65).ngClassDirty;
        var currVal_54 = core_es5["ɵnov"](_v, 65).ngClassValid;
        var currVal_55 = core_es5["ɵnov"](_v, 65).ngClassInvalid;
        var currVal_56 = core_es5["ɵnov"](_v, 65).ngClassPending;
        _ck(_v, 60, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56);
        var currVal_59 = core_es5["ɵnov"](_v, 75).ngClassUntouched;
        var currVal_60 = core_es5["ɵnov"](_v, 75).ngClassTouched;
        var currVal_61 = core_es5["ɵnov"](_v, 75).ngClassPristine;
        var currVal_62 = core_es5["ɵnov"](_v, 75).ngClassDirty;
        var currVal_63 = core_es5["ɵnov"](_v, 75).ngClassValid;
        var currVal_64 = core_es5["ɵnov"](_v, 75).ngClassInvalid;
        var currVal_65 = core_es5["ɵnov"](_v, 75).ngClassPending;
        _ck(_v, 70, 0, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65);
        var currVal_68 = core_es5["ɵnov"](_v, 89).ngClassUntouched;
        var currVal_69 = core_es5["ɵnov"](_v, 89).ngClassTouched;
        var currVal_70 = core_es5["ɵnov"](_v, 89).ngClassPristine;
        var currVal_71 = core_es5["ɵnov"](_v, 89).ngClassDirty;
        var currVal_72 = core_es5["ɵnov"](_v, 89).ngClassValid;
        var currVal_73 = core_es5["ɵnov"](_v, 89).ngClassInvalid;
        var currVal_74 = core_es5["ɵnov"](_v, 89).ngClassPending;
        _ck(_v, 84, 0, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74);
        var currVal_77 = core_es5["ɵnov"](_v, 99).ngClassUntouched;
        var currVal_78 = core_es5["ɵnov"](_v, 99).ngClassTouched;
        var currVal_79 = core_es5["ɵnov"](_v, 99).ngClassPristine;
        var currVal_80 = core_es5["ɵnov"](_v, 99).ngClassDirty;
        var currVal_81 = core_es5["ɵnov"](_v, 99).ngClassValid;
        var currVal_82 = core_es5["ɵnov"](_v, 99).ngClassInvalid;
        var currVal_83 = core_es5["ɵnov"](_v, 99).ngClassPending;
        _ck(_v, 94, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83);
        var currVal_86 = core_es5["ɵnov"](_v, 109).ngClassUntouched;
        var currVal_87 = core_es5["ɵnov"](_v, 109).ngClassTouched;
        var currVal_88 = core_es5["ɵnov"](_v, 109).ngClassPristine;
        var currVal_89 = core_es5["ɵnov"](_v, 109).ngClassDirty;
        var currVal_90 = core_es5["ɵnov"](_v, 109).ngClassValid;
        var currVal_91 = core_es5["ɵnov"](_v, 109).ngClassInvalid;
        var currVal_92 = core_es5["ɵnov"](_v, 109).ngClassPending;
        _ck(_v, 104, 0, currVal_86, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92);
        var currVal_99 = core_es5["ɵnov"](_v, 119).ngClassUntouched;
        var currVal_100 = core_es5["ɵnov"](_v, 119).ngClassTouched;
        var currVal_101 = core_es5["ɵnov"](_v, 119).ngClassPristine;
        var currVal_102 = core_es5["ɵnov"](_v, 119).ngClassDirty;
        var currVal_103 = core_es5["ɵnov"](_v, 119).ngClassValid;
        var currVal_104 = core_es5["ɵnov"](_v, 119).ngClassInvalid;
        var currVal_105 = core_es5["ɵnov"](_v, 119).ngClassPending;
        _ck(_v, 114, 0, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103, currVal_104, currVal_105);
        var currVal_108 = core_es5["ɵnov"](_v, 129).ngClassUntouched;
        var currVal_109 = core_es5["ɵnov"](_v, 129).ngClassTouched;
        var currVal_110 = core_es5["ɵnov"](_v, 129).ngClassPristine;
        var currVal_111 = core_es5["ɵnov"](_v, 129).ngClassDirty;
        var currVal_112 = core_es5["ɵnov"](_v, 129).ngClassValid;
        var currVal_113 = core_es5["ɵnov"](_v, 129).ngClassInvalid;
        var currVal_114 = core_es5["ɵnov"](_v, 129).ngClassPending;
        _ck(_v, 124, 0, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114);
        var currVal_117 = core_es5["ɵnov"](_v, 142).ngClassUntouched;
        var currVal_118 = core_es5["ɵnov"](_v, 142).ngClassTouched;
        var currVal_119 = core_es5["ɵnov"](_v, 142).ngClassPristine;
        var currVal_120 = core_es5["ɵnov"](_v, 142).ngClassDirty;
        var currVal_121 = core_es5["ɵnov"](_v, 142).ngClassValid;
        var currVal_122 = core_es5["ɵnov"](_v, 142).ngClassInvalid;
        var currVal_123 = core_es5["ɵnov"](_v, 142).ngClassPending;
        _ck(_v, 137, 0, currVal_117, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123);
        var currVal_126 = core_es5["ɵnov"](_v, 152).ngClassUntouched;
        var currVal_127 = core_es5["ɵnov"](_v, 152).ngClassTouched;
        var currVal_128 = core_es5["ɵnov"](_v, 152).ngClassPristine;
        var currVal_129 = core_es5["ɵnov"](_v, 152).ngClassDirty;
        var currVal_130 = core_es5["ɵnov"](_v, 152).ngClassValid;
        var currVal_131 = core_es5["ɵnov"](_v, 152).ngClassInvalid;
        var currVal_132 = core_es5["ɵnov"](_v, 152).ngClassPending;
        _ck(_v, 147, 0, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132);
        var currVal_139 = core_es5["ɵnov"](_v, 163).ngClassUntouched;
        var currVal_140 = core_es5["ɵnov"](_v, 163).ngClassTouched;
        var currVal_141 = core_es5["ɵnov"](_v, 163).ngClassPristine;
        var currVal_142 = core_es5["ɵnov"](_v, 163).ngClassDirty;
        var currVal_143 = core_es5["ɵnov"](_v, 163).ngClassValid;
        var currVal_144 = core_es5["ɵnov"](_v, 163).ngClassInvalid;
        var currVal_145 = core_es5["ɵnov"](_v, 163).ngClassPending;
        _ck(_v, 158, 0, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143, currVal_144, currVal_145);
        var currVal_152 = core_es5["ɵnov"](_v, 173).ngClassUntouched;
        var currVal_153 = core_es5["ɵnov"](_v, 173).ngClassTouched;
        var currVal_154 = core_es5["ɵnov"](_v, 173).ngClassPristine;
        var currVal_155 = core_es5["ɵnov"](_v, 173).ngClassDirty;
        var currVal_156 = core_es5["ɵnov"](_v, 173).ngClassValid;
        var currVal_157 = core_es5["ɵnov"](_v, 173).ngClassInvalid;
        var currVal_158 = core_es5["ɵnov"](_v, 173).ngClassPending;
        _ck(_v, 168, 0, currVal_152, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158);
        var currVal_165 = _co.enquiry.isOnWaitingList;
        var currVal_166 = core_es5["ɵnov"](_v, 183).ngClassUntouched;
        var currVal_167 = core_es5["ɵnov"](_v, 183).ngClassTouched;
        var currVal_168 = core_es5["ɵnov"](_v, 183).ngClassPristine;
        var currVal_169 = core_es5["ɵnov"](_v, 183).ngClassDirty;
        var currVal_170 = core_es5["ɵnov"](_v, 183).ngClassValid;
        var currVal_171 = core_es5["ɵnov"](_v, 183).ngClassInvalid;
        var currVal_172 = core_es5["ɵnov"](_v, 183).ngClassPending;
        _ck(_v, 178, 0, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171, currVal_172);
        var currVal_175 = core_es5["ɵnov"](_v, 193).ngClassUntouched;
        var currVal_176 = core_es5["ɵnov"](_v, 193).ngClassTouched;
        var currVal_177 = core_es5["ɵnov"](_v, 193).ngClassPristine;
        var currVal_178 = core_es5["ɵnov"](_v, 193).ngClassDirty;
        var currVal_179 = core_es5["ɵnov"](_v, 193).ngClassValid;
        var currVal_180 = core_es5["ɵnov"](_v, 193).ngClassInvalid;
        var currVal_181 = core_es5["ɵnov"](_v, 193).ngClassPending;
        _ck(_v, 188, 0, currVal_175, currVal_176, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181);
        var currVal_188 = (_co.isInEditMode ? 'Update enquiry' : 'Create enquiry');
        _ck(_v, 201, 0, currVal_188);
    });
}
function View_EnquiryFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'enquiry-form', [], null, null, null, View_EnquiryFormComponent_0, RenderType_EnquiryFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, enquiry_form_EnquiryFormComponent, [src_store["a" /* Store */], enquiry_EnquiryEffects, modal_ModalService, completer_service["a" /* CompleterService */], helpers_ConstantsHelpers], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var EnquiryFormComponentNgFactory = core_es5["ɵccf"]('enquiry-form', enquiry_form_EnquiryFormComponent, View_EnquiryFormComponent_Host_0, { isInEditMode: 'isInEditMode' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=enquiry-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/set-class-form.ts










var set_class_form_SetClassFormComponent = (function () {
    function SetClassFormComponent(store, modalService, completerService, constantsHelpers, matrixClassesEffects, actions) {
        this.store = store;
        this.modalService = modalService;
        this.completerService = completerService;
        this.constantsHelpers = constantsHelpers;
        this.matrixClassesEffects = matrixClassesEffects;
        this.actions = actions;
        this.teacherSearchStr = "";
        this.originalHolidayWeekValue = 1;
    }
    SetClassFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.matrixClassesStore = this.store.select("matrixClassesReducer");
        this.constantsStore = this.store.select("constantsReducer");
        Observable["Observable"].merge(this.matrixClassesStore, this.constantsStore).subscribe(function (s) {
            if (s instanceof matrix_classes_MatrixClassesStore) {
                _this.teachers = s.teachers;
                _this.matrixClass = s.editableClass;
                _this.originalHolidayWeekValue = s.editableClass.holidayWeek;
            }
            if (s instanceof ConstantsStore) {
                _this.constants = s.constants;
                _this.courses = s.constants.courses;
                _this.createCourseCompleter();
            }
        });
    };
    SetClassFormComponent.prototype.createCourseCompleter = function () {
        this.courseCompleter =
            this.completerService.local(this.courses, "humanised, code, name", "humanised");
        this.teacherCompleter =
            this.completerService.local(this.teachers, "fullName", "fullName");
    };
    SetClassFormComponent.prototype.setDefaultTopicIdForCourse = function (matrixClass) {
        var term = this.constants.terms.find(function (t) {
            return t.id === matrixClass.termId;
        });
        var course = this.courses.find(function (c) {
            return c.id === matrixClass.courseId;
        });
        this.matrixClass.topicId = course.topics[term.number - 1].id;
    };
    SetClassFormComponent.prototype.clickedIsTwoWeeksToggle = function (e) {
        var isChecked = e.target.checked;
        this.matrixClass.holidayWeek = isChecked ?
            0 : this.originalHolidayWeekValue;
    };
    SetClassFormComponent.prototype.clickedIsOpenToggle = function (e) {
        this.matrixClass.open = !this.matrixClass.open;
    };
    SetClassFormComponent.prototype.clickedIsTopicTestToggle = function (e) {
        this.matrixClass.topicTest = !this.matrixClass.topicTest;
    };
    SetClassFormComponent.prototype.clickedSubmitForm = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.matrixClass.id) {
            this.store.dispatch({ type: UPDATE_CLASS, payload: this.matrixClass });
        }
        else {
            this.store.dispatch({ type: CREATE_CLASS, payload: this.matrixClass });
        }
        this.actions
            .ofType(ADD_CLASS, REPLACE_CLASS)
            .take(1)
            .subscribe(function () { return _this.modalService.closeModal(); });
    };
    SetClassFormComponent.prototype.selectedCourse = function (e) {
        if (e && e.originalObject) {
            var course = e.originalObject;
            this.courseForTopics = course;
            this.matrixClass.courseId = course.id;
            this.setDefaultTopicIdForCourse(this.matrixClass);
        }
    };
    SetClassFormComponent.prototype.selectedTeacher = function (e) {
        if (e && e.originalObject) {
            var teacher = e.originalObject;
            this.matrixClass.contactId = teacher.id;
        }
    };
    SetClassFormComponent.prototype.selectedTopic = function (e, topic) {
        this.matrixClass.topicId = topic.id;
    };
    SetClassFormComponent.prototype.isHolidayTerm = function () {
        return this.matrixClass.term.isHoliday;
    };
    SetClassFormComponent.prototype.getTermName = function () {
        var _this = this;
        return this.constants.terms.find(function (t) {
            return t.id === _this.matrixClass.termId;
        }).name;
    };
    SetClassFormComponent.prototype.getDayNameOrHolidayWeek = function () {
        var _this = this;
        var result;
        if (!this.matrixClass.term.isHoliday) {
            result = this.constants.days.find(function (d) {
                return d.id === _this.matrixClass.dayId;
            }).name;
        }
        else {
            result = this.matrixClass.holidayWeek == 0 ?
                "Both weeks" : "Week " + this.matrixClass.holidayWeek;
        }
        return result;
    };
    SetClassFormComponent.prototype.getCampusTitle = function () {
        var _this = this;
        return this.constants.campuses.find(function (c) {
            return c.id === _this.matrixClass.campusId;
        }).name;
    };
    SetClassFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: modal_ModalService }, { type: ng2_completer["a" /* CompleterService */] }, { type: helpers_ConstantsHelpers }, { type: matrix_class_MatrixClassEffects }, { type: effects["a" /* Actions */] }]; };
    return SetClassFormComponent;
}());

//# sourceMappingURL=set-class-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/set-class-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_SetClassFormComponent = [];
var RenderType_SetClassFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_SetClassFormComponent, data: {} });
function View_SetClassFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'input-row scf__toggle-wrapper two-week']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 3, 'div', [['class', 'input-group checkbox full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 0, 'input', [['id', 'is-two-weeks'], ['name', 'is-two-weeks'], ['type',
                'checkbox']], [[8, 'checked', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.clickedIsTwoWeeksToggle($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'label', [['for', 'is-two-weeks']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Does this course span two weeks?']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.matrixClass.holidayWeek == 0);
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_SetClassFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'input-group topic radio-option full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 0, 'input', [['name', 'topic'], ['type', 'radio']], [[8, 'id', 0], [8, 'value', 0], [8, 'checked',
                0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.selectedTopic($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [], [[8, 'htmlFor', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ('topic_' + _v.context.$implicit.id);
        var currVal_1 = _v.context.$implicit.id;
        var currVal_2 = (_v.context.$implicit.id == _co.matrixClass.topicId);
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = ('topic_' + _v.context.$implicit.id);
        _ck(_v, 2, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.name;
        _ck(_v, 3, 0, currVal_4);
    });
}
function View_SetClassFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetClassFormComponent_3)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.courseForTopics.topics;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_SetClassFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 63, 'div', [['class',
                'set-class-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 62, 'div', [['class', 'scf__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'scf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 15, 'p', [['class', 'scf__set-details']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Class for '])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](7, null, ['', ' '])), (_l()(), core_es5["ɵted"](-1, null, ['on '])), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](10, null, ['', ' '])), (_l()(), core_es5["ɵted"](-1, null, ['during '])), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](13, null, ['period ', ' '])), (_l()(), core_es5["ɵted"](-1, null, ['at '])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](16, null, ['', ' '])), (_l()(), core_es5["ɵted"](-1, null, ['in '])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](19, null, ['room ', ''])), (_l()(), core_es5["ɵeld"](20, 0, null, null, 43, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 22).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 22).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](21, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](22, 16384, null, 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](24, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetClassFormComponent_1)), core_es5["ɵdid"](26, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵeld"](27, 0, null, null, 4, 'div', [['class', 'input-row scf__toggle-wrapper is-open']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 3, 'div', [['class', 'input-group checkbox full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](29, 0, null, null, 0, 'input', [['id', 'is-open'],
            ['name', 'is-open'], ['type', 'checkbox']], [[8, 'checked', 0]], [[null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.clickedIsOpenToggle($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](30, 0, null, null, 1, 'label', [['for', 'is-open']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Open for enrolment?'])),
        (_l()(), core_es5["ɵeld"](32, 0, null, null, 4, 'div', [['class', 'input-row scf__toggle-wrapper is-topic-test']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](33, 0, null, null, 3, 'div', [['class', 'input-group checkbox full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](34, 0, null, null, 0, 'input', [['id', 'is-topic-test'],
            ['name', 'is-topic-test'], ['type', 'checkbox']], [[8, 'checked', 0]], [[null,
                'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.clickedIsTopicTestToggle($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](35, 0, null, null, 1, 'label', [['for', 'is-topic-test']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Is topic test lesson?'])),
        (_l()(), core_es5["ɵeld"](37, 0, null, null, 18, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](38, 0, null, null, 8, 'div', [['class', 'input-group course half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 5, 'ng2-completer', [['id', 'course'],
            ['name', 'course']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.courseSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCourse($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](40, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](42, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](44, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](45, 0, null, null, 1, 'label', [['for', 'course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select course'])), (_l()(), core_es5["ɵeld"](47, 0, null, null, 8, 'div', [['class', 'input-group teacher half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](48, 0, null, null, 5, 'ng2-completer', [['id', 'teacher'], ['name', 'teacher']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.teacherSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTeacher($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](49, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2,
                'initialValue'], datasource: [3, 'datasource'] }, { selected: 'selected' }),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](51, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](53, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](54, 0, null, null, 1, 'label', [['for', 'teacher']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select teacher'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetClassFormComponent_2)), core_es5["ɵdid"](57, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](58, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](59, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](60, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](61, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](62, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitForm($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](63, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_13 = _co.isHolidayTerm();
        _ck(_v, 26, 0, currVal_13);
        var currVal_23 = 0;
        var currVal_24 = true;
        var currVal_25 = (_co.matrixClass.course || '');
        var currVal_26 = _co.courseCompleter;
        _ck(_v, 40, 0, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_27 = 'course';
        var currVal_28 = _co.courseSearchStr;
        _ck(_v, 42, 0, currVal_27, currVal_28);
        var currVal_36 = 0;
        var currVal_37 = true;
        var currVal_38 = (_co.matrixClass.contact || '');
        var currVal_39 = _co.teacherCompleter;
        _ck(_v, 49, 0, currVal_36, currVal_37, currVal_38, currVal_39);
        var currVal_40 = 'teacher';
        var currVal_41 = _co.teacherSearchStr;
        _ck(_v, 51, 0, currVal_40, currVal_41);
        var currVal_42 = _co.courseForTopics;
        _ck(_v, 57, 0, currVal_42);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.matrixClass.id ? 'Editing class' : 'Set a class');
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.getTermName();
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.getDayNameOrHolidayWeek();
        _ck(_v, 10, 0, currVal_2);
        var currVal_3 = _co.matrixClass.period;
        _ck(_v, 13, 0, currVal_3);
        var currVal_4 = _co.getCampusTitle();
        _ck(_v, 16, 0, currVal_4);
        var currVal_5 = _co.matrixClass.room;
        _ck(_v, 19, 0, currVal_5);
        var currVal_6 = core_es5["ɵnov"](_v, 24).ngClassUntouched;
        var currVal_7 = core_es5["ɵnov"](_v, 24).ngClassTouched;
        var currVal_8 = core_es5["ɵnov"](_v, 24).ngClassPristine;
        var currVal_9 = core_es5["ɵnov"](_v, 24).ngClassDirty;
        var currVal_10 = core_es5["ɵnov"](_v, 24).ngClassValid;
        var currVal_11 = core_es5["ɵnov"](_v, 24).ngClassInvalid;
        var currVal_12 = core_es5["ɵnov"](_v, 24).ngClassPending;
        _ck(_v, 20, 0, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_14 = _co.matrixClass.open;
        _ck(_v, 29, 0, currVal_14);
        var currVal_15 = _co.matrixClass.topicTest;
        _ck(_v, 34, 0, currVal_15);
        var currVal_16 = core_es5["ɵnov"](_v, 44).ngClassUntouched;
        var currVal_17 = core_es5["ɵnov"](_v, 44).ngClassTouched;
        var currVal_18 = core_es5["ɵnov"](_v, 44).ngClassPristine;
        var currVal_19 = core_es5["ɵnov"](_v, 44).ngClassDirty;
        var currVal_20 = core_es5["ɵnov"](_v, 44).ngClassValid;
        var currVal_21 = core_es5["ɵnov"](_v, 44).ngClassInvalid;
        var currVal_22 = core_es5["ɵnov"](_v, 44).ngClassPending;
        _ck(_v, 39, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
        var currVal_29 = core_es5["ɵnov"](_v, 53).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 53).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 53).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 53).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 53).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 53).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 53).ngClassPending;
        _ck(_v, 48, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_43 = (_co.matrixClass.id ? 'Update class' : 'Set class');
        _ck(_v, 63, 0, currVal_43);
    });
}
function View_SetClassFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'set-class-form', [], null, null, null, View_SetClassFormComponent_0, RenderType_SetClassFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, set_class_form_SetClassFormComponent, [src_store["a" /* Store */], modal_ModalService, completer_service["a" /* CompleterService */], helpers_ConstantsHelpers, matrix_class_MatrixClassEffects,
            src_actions["a" /* Actions */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SetClassFormComponentNgFactory = core_es5["ɵccf"]('set-class-form', set_class_form_SetClassFormComponent, View_SetClassFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=set-class-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/enrolment-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_EnrolmentFormComponent = [];
var RenderType_EnrolmentFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_EnrolmentFormComponent, data: {} });
function View_EnrolmentFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'li', [['class',
                's__point']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSliderPoint(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getStyleForSliderPoint(_v.context.index);
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_EnrolmentFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 69, 'div', [['class', 'enrolment-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'ef__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['Enrolment for ', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 66, 'div', [['class', 'ef__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 23, 'div', [['class', 'ef__class-details']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 4, 'div', [['class', 'ef__class-blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['You\'re about to enrol '])),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](9, null, ['', ''])), (_l()(), core_es5["ɵted"](-1, null, [' in the following class'])),
        (_l()(), core_es5["ɵeld"](11, 0, null, null, 10, 'div', [['class', 'ef__class-info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](12, null, ['', ''])), (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](14, null, ['', ''])),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](16, null, ['Taught by ', ''])), (_l()(), core_es5["ɵeld"](17, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](18, null, ['Enrolments: ', ' / ', ''])),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](20, null, ['Cost: ', ''])), core_es5["ɵppd"](21, 4), (_l()(), core_es5["ɵeld"](22, 0, null, null, 6, 'div', [['class', 'ef__class-meta']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](23, 0, null, null, 1, 'div', [['class', 'ef__class-course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](24, null, ['', ''])), (_l()(), core_es5["ɵeld"](25, 0, null, null, 1, 'div', [['class',
                'ef__class-campus']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](26, null, ['', ''])), (_l()(), core_es5["ɵeld"](27, 0, null, null, 1, 'div', [['class', 'ef__class-time']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](28, null, ['Period ', ', Room ', ''])), (_l()(), core_es5["ɵeld"](29, 0, null, null, 41, 'div', [['class', 'form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](30, 0, null, null, 34, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](31, 0, null, null, 13, 'div', [['class', 'input-group full number-of-classes']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](33, 0, null, null, 7, 'div', [['class', 'slider']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](34, 0, null, null, 6, 'div', [['class', 's__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](35, 0, null, null, 5, 'div', [['class', 's__bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'div', [['class', 's__bar-highlight']], null, null, null, null, null)),
        core_es5["ɵdid"](37, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵeld"](38, 0, null, null, 2, 'ul', [['class', 's__points']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_EnrolmentFormComponent_1)),
        core_es5["ɵdid"](40, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](41, 0, null, null, 3, 'label', [['for', 'number-of-periods']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Number of classes to enrol in: '])), (_l()(), core_es5["ɵeld"](43, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](44, null, ['', ''])), (_l()(), core_es5["ɵeld"](45, 0, null, null, 9, 'div', [['class',
                'input-group half start-date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](46, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](47, 0, null, null, 5, 'input', [['id', 'start-date'], ['name', 'startDate'], ['type', 'date']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 48)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 48).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 48)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 48)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.startDateInputString = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](48, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](50, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](52, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](53, 0, null, null, 1, 'label', [['for', 'start-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Start date'])), (_l()(), core_es5["ɵeld"](55, 0, null, null, 9, 'div', [['class', 'input-group half transaction-date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](56, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](57, 0, null, null, 5, 'input', [['id', 'transaction-date'],
            ['name', 'transactionDate'], ['type', 'date']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.transactionDateInputString = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](58, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](60, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](62, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](63, 0, null, null, 1, 'label', [['for', 'transaction-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Transaction date'])), (_l()(), core_es5["ɵeld"](65, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](66, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](67, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](68, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](69, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitForm($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add Enrolment']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_12 = _co.getStyleForSliderBarHighlight();
        _ck(_v, 37, 0, currVal_12);
        var currVal_13 = _co.numOfClassesArray;
        _ck(_v, 40, 0, currVal_13);
        var currVal_22 = 'startDate';
        var currVal_23 = _co.startDateInputString;
        _ck(_v, 50, 0, currVal_22, currVal_23);
        var currVal_31 = 'transactionDate';
        var currVal_32 = _co.transactionDateInputString;
        _ck(_v, 60, 0, currVal_31, currVal_32);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.selectedContact.fullName;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.selectedContact.firstName;
        _ck(_v, 9, 0, currVal_1);
        var currVal_2 = _co.selectedClass.code;
        _ck(_v, 12, 0, currVal_2);
        var currVal_3 = _co.selectedClass.topic.name;
        _ck(_v, 14, 0, currVal_3);
        var currVal_4 = _co.selectedClass.contact.fullName;
        _ck(_v, 16, 0, currVal_4);
        var currVal_5 = _co.selectedClass.enrolments.length;
        var currVal_6 = _co.getMaxEnrolmentsForClass(_co.selectedClass);
        _ck(_v, 18, 0, currVal_5, currVal_6);
        var currVal_7 = core_es5["ɵunv"](_v, 20, 0, _ck(_v, 21, 0, core_es5["ɵnov"](_v, 0), _co.enrolment.cost, 'USD', true, '1.2-2'));
        _ck(_v, 20, 0, currVal_7);
        var currVal_8 = _co.selectedClass.course.name;
        _ck(_v, 24, 0, currVal_8);
        var currVal_9 = _co.selectedClass.campus.name;
        _ck(_v, 26, 0, currVal_9);
        var currVal_10 = _co.selectedClass.period;
        var currVal_11 = _co.selectedClass.room;
        _ck(_v, 28, 0, currVal_10, currVal_11);
        var currVal_14 = _co.enrolment.numberOfClasses;
        _ck(_v, 44, 0, currVal_14);
        var currVal_15 = core_es5["ɵnov"](_v, 52).ngClassUntouched;
        var currVal_16 = core_es5["ɵnov"](_v, 52).ngClassTouched;
        var currVal_17 = core_es5["ɵnov"](_v, 52).ngClassPristine;
        var currVal_18 = core_es5["ɵnov"](_v, 52).ngClassDirty;
        var currVal_19 = core_es5["ɵnov"](_v, 52).ngClassValid;
        var currVal_20 = core_es5["ɵnov"](_v, 52).ngClassInvalid;
        var currVal_21 = core_es5["ɵnov"](_v, 52).ngClassPending;
        _ck(_v, 47, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21);
        var currVal_24 = core_es5["ɵnov"](_v, 62).ngClassUntouched;
        var currVal_25 = core_es5["ɵnov"](_v, 62).ngClassTouched;
        var currVal_26 = core_es5["ɵnov"](_v, 62).ngClassPristine;
        var currVal_27 = core_es5["ɵnov"](_v, 62).ngClassDirty;
        var currVal_28 = core_es5["ɵnov"](_v, 62).ngClassValid;
        var currVal_29 = core_es5["ɵnov"](_v, 62).ngClassInvalid;
        var currVal_30 = core_es5["ɵnov"](_v, 62).ngClassPending;
        _ck(_v, 57, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30);
    });
}
function View_EnrolmentFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'enrolment-form', [], null, null, null, View_EnrolmentFormComponent_0, RenderType_EnrolmentFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, enrolment_form_EnrolmentFormComponent, [router_es5["k" /* Router */], src_store["a" /* Store */], modal_ModalService, enrolment_EnrolmentEffects], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var EnrolmentFormComponentNgFactory = core_es5["ɵccf"]('enrolment-form', enrolment_form_EnrolmentFormComponent, View_EnrolmentFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=enrolment-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/calendar-day-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_CalendarDayFormComponent = [];
var RenderType_CalendarDayFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CalendarDayFormComponent, data: {} });
function View_CalendarDayFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'li', [['class',
                'cdf__event']], null, null, null, null, null)),
        core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        (_l()(), core_es5["ɵted"](2, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'cdf__event';
        var currVal_1 = _co.getEventClassNames(_v.context.$implicit.meta.type);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.title;
        _ck(_v, 2, 0, currVal_2);
    });
}
function View_CalendarDayFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'cdf__events']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_2)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.day.events;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CalendarDayFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'form-error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['You appear to be starting a term on a day which isn\'t Monday. Please be certain this is your intent.']))], null, null);
}
function View_CalendarDayFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['9 Days (', ')'])), core_es5["ɵppd"](2, 2)], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent, 0), _co.getCalculatedEndDate(), 'shortDate'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CalendarDayFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['9 Weeks']))], null, null);
}
function View_CalendarDayFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'div', [['class',
                'input-group checkbox half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'input', [['id',
                'is-matrix-holiday'], ['name', 'isMatrixHoliday'], ['type', 'checkbox']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 2).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.publicHoliday.isMatrixHoliday = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](2, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](4, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](6, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'label', [['for', 'is-matrix-holiday']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This public holiday will fall within a current term. Should it push out the term by a day?']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 'isMatrixHoliday';
        var currVal_8 = _co.publicHoliday.isMatrixHoliday;
        _ck(_v, 4, 0, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 6).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 6).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 6).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 6).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 6).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 6).ngClassPending;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CalendarDayFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'negative']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDeletePublicHoliday() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Delete']))], null, null);
}
function View_CalendarDayFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 121, 'div', [['class', 'calendar-day-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 2, 'h1', [['class', 'cdf__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['Showing: ', ''])),
        core_es5["ɵppd"](4, 2), (_l()(), core_es5["ɵeld"](5, 0, null, null, 117, 'div', [['class',
                'cdf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](6, 0, null, null, 4, 'div', [['class', 'cdf__current-events']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](8, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_1)),
        core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](11, 0, null, null, 80, 'div', [['class', 'cdf__subcontent-wrapper add-term']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 1, 'h3', [['class', 'cdf__subheader']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](13, null, ['', ''])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 77, 'form', [['novalidate',
                '']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'submit'], [null, 'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 16).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 16).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](15, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](16, 16384, null, 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](18, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_3)), core_es5["ɵdid"](20, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵeld"](21, 0, null, null, 31, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](22, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](23, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 5, 'input', [['name', 'termName'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 25)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 25).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 25)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 25)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.term.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](25, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](27, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](29, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Name'])), (_l()(), core_es5["ɵeld"](32, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](33, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](34, 0, null, null, 6, 'input', [['name', 'termNumber'], ['type', 'number']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 35)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 35).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 35)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 35)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.term.number = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](35, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](36, 16384, null, 0, forms_es5["ɵbc"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["ɵbc"]]), core_es5["ɵdid"](38, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](40, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](41, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Term number'])), (_l()(), core_es5["ɵeld"](43, 0, null, null, 9, 'div', [['class', 'input-group checkbox']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](44, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](45, 0, null, null, 5, 'input', [['id', 'term-is-holiday'], ['name', 'termIsHoliday'], ['type', 'checkbox']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 46).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 46).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.term.isHoliday = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](46, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](48, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](50, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](51, 0, null, null, 1, 'label', [['for', 'term-is-holiday']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Is holiday term?'])), (_l()(), core_es5["ɵeld"](53, 0, null, null, 12, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](54, 0, null, null, 11, 'div', [['class', 'input-group checkbox full cdf__online-enrolments-enabled']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](55, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](56, 0, null, null, 5, 'input', [['id', 'is-online-enrolment-enabled'],
            ['name', 'isOnlineEnrolmentEnabled'], ['type', 'checkbox']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 57).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 57).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.term.isOnlineEnrolmentEnabled = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](57, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](59, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](61, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](62, 0, null, null, 3, 'label', [['for', 'is-online-enrolment-enabled']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Is this term open for online enrolments?'])),
        (_l()(), core_es5["ɵeld"](64, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](65, null, ['Warning: This will turn off online enrolments for all other ',
            ' terms.'])), (_l()(), core_es5["ɵeld"](66, 0, null, null, 19, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](67, 0, null, null, 10, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](68, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](69, 0, null, null, 6, 'input', [['name', 'termStartDate'], ['type', 'date']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 70)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 70).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 70)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 70)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.term.startDate = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](70, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](72, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](73, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](75, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](76, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Start date'])), (_l()(), core_es5["ɵeld"](78, 0, null, null, 7, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](79, 0, null, null, 6, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](80, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Term length'])), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_4)),
        core_es5["ɵdid"](83, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_5)), core_es5["ɵdid"](85, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](86, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](87, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](88, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](89, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](90, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitTerm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](91, null, ['', ''])),
        (_l()(), core_es5["ɵeld"](92, 0, null, null, 30, 'div', [['class', 'cdf__subcontent-wrapper add-public-holiday']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](93, 0, null, null, 1, 'h3', [['class', 'cdf__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](94, null, ['', ''])), (_l()(), core_es5["ɵeld"](95, 0, null, null, 27, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 97).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 97).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](96, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](97, 16384, null, 0, forms_es5["NgForm"], [[8, null], [8, null]], null, null),
        core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](99, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](100, 0, null, null, 12, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](101, 0, null, null, 9, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](102, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](103, 0, null, null, 5, 'input', [['name', 'publicHoliday.name'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 104)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 104).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 104)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 104)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.publicHoliday.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](104, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](106, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](108, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](109, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Public holiday name'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_6)), core_es5["ɵdid"](112, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](113, 0, null, null, 9, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](114, 0, null, null, 8, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](115, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](116, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CalendarDayFormComponent_7)), core_es5["ɵdid"](118, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵeld"](119, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](120, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](121, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitPublicHoliday() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](122, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_co.day.events.length > 0);
        _ck(_v, 10, 0, currVal_2);
        var currVal_11 = (_co.getDayOfStartDate() != 1);
        _ck(_v, 20, 0, currVal_11);
        var currVal_19 = 'termName';
        var currVal_20 = _co.term.name;
        _ck(_v, 27, 0, currVal_19, currVal_20);
        var currVal_28 = 'termNumber';
        var currVal_29 = _co.term.number;
        _ck(_v, 38, 0, currVal_28, currVal_29);
        var currVal_37 = 'termIsHoliday';
        var currVal_38 = _co.term.isHoliday;
        _ck(_v, 48, 0, currVal_37, currVal_38);
        var currVal_46 = 'isOnlineEnrolmentEnabled';
        var currVal_47 = _co.term.isOnlineEnrolmentEnabled;
        _ck(_v, 59, 0, currVal_46, currVal_47);
        var currVal_56 = 'termStartDate';
        var currVal_57 = core_es5["ɵunv"](_v, 72, 1, _ck(_v, 73, 0, core_es5["ɵnov"](_v, 0), _co.term.startDate, 'yyyy-MM-dd'));
        _ck(_v, 72, 0, currVal_56, currVal_57);
        var currVal_58 = _co.term.isHoliday;
        _ck(_v, 83, 0, currVal_58);
        var currVal_59 = !_co.term.isHoliday;
        _ck(_v, 85, 0, currVal_59);
        var currVal_76 = 'publicHoliday.name';
        var currVal_77 = _co.publicHoliday.name;
        _ck(_v, 106, 0, currVal_76, currVal_77);
        var currVal_78 = (!_co.isEditingPublicHoliday() && _co.isEditingTerm());
        _ck(_v, 112, 0, currVal_78);
        var currVal_79 = _co.isEditingPublicHoliday();
        _ck(_v, 118, 0, currVal_79);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, core_es5["ɵnov"](_v, 0), _co.day.date, 'fullDate'));
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = ((_co.day.events.length > 0) ? 'Currently on this day: ' : 'This day does not yet have any events');
        _ck(_v, 8, 0, currVal_1);
        var currVal_3 = (_co.isEditingTerm() ? 'Edit term' : ' Add a new term');
        _ck(_v, 13, 0, currVal_3);
        var currVal_4 = core_es5["ɵnov"](_v, 18).ngClassUntouched;
        var currVal_5 = core_es5["ɵnov"](_v, 18).ngClassTouched;
        var currVal_6 = core_es5["ɵnov"](_v, 18).ngClassPristine;
        var currVal_7 = core_es5["ɵnov"](_v, 18).ngClassDirty;
        var currVal_8 = core_es5["ɵnov"](_v, 18).ngClassValid;
        var currVal_9 = core_es5["ɵnov"](_v, 18).ngClassInvalid;
        var currVal_10 = core_es5["ɵnov"](_v, 18).ngClassPending;
        _ck(_v, 14, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10);
        var currVal_12 = core_es5["ɵnov"](_v, 29).ngClassUntouched;
        var currVal_13 = core_es5["ɵnov"](_v, 29).ngClassTouched;
        var currVal_14 = core_es5["ɵnov"](_v, 29).ngClassPristine;
        var currVal_15 = core_es5["ɵnov"](_v, 29).ngClassDirty;
        var currVal_16 = core_es5["ɵnov"](_v, 29).ngClassValid;
        var currVal_17 = core_es5["ɵnov"](_v, 29).ngClassInvalid;
        var currVal_18 = core_es5["ɵnov"](_v, 29).ngClassPending;
        _ck(_v, 24, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18);
        var currVal_21 = core_es5["ɵnov"](_v, 40).ngClassUntouched;
        var currVal_22 = core_es5["ɵnov"](_v, 40).ngClassTouched;
        var currVal_23 = core_es5["ɵnov"](_v, 40).ngClassPristine;
        var currVal_24 = core_es5["ɵnov"](_v, 40).ngClassDirty;
        var currVal_25 = core_es5["ɵnov"](_v, 40).ngClassValid;
        var currVal_26 = core_es5["ɵnov"](_v, 40).ngClassInvalid;
        var currVal_27 = core_es5["ɵnov"](_v, 40).ngClassPending;
        _ck(_v, 34, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27);
        var currVal_30 = core_es5["ɵnov"](_v, 50).ngClassUntouched;
        var currVal_31 = core_es5["ɵnov"](_v, 50).ngClassTouched;
        var currVal_32 = core_es5["ɵnov"](_v, 50).ngClassPristine;
        var currVal_33 = core_es5["ɵnov"](_v, 50).ngClassDirty;
        var currVal_34 = core_es5["ɵnov"](_v, 50).ngClassValid;
        var currVal_35 = core_es5["ɵnov"](_v, 50).ngClassInvalid;
        var currVal_36 = core_es5["ɵnov"](_v, 50).ngClassPending;
        _ck(_v, 45, 0, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36);
        var currVal_39 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_40 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_41 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_42 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_43 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_44 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_45 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 56, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45);
        var currVal_48 = (_co.term.isHoliday ? 'holiday' : 'normal');
        _ck(_v, 65, 0, currVal_48);
        var currVal_49 = core_es5["ɵnov"](_v, 75).ngClassUntouched;
        var currVal_50 = core_es5["ɵnov"](_v, 75).ngClassTouched;
        var currVal_51 = core_es5["ɵnov"](_v, 75).ngClassPristine;
        var currVal_52 = core_es5["ɵnov"](_v, 75).ngClassDirty;
        var currVal_53 = core_es5["ɵnov"](_v, 75).ngClassValid;
        var currVal_54 = core_es5["ɵnov"](_v, 75).ngClassInvalid;
        var currVal_55 = core_es5["ɵnov"](_v, 75).ngClassPending;
        _ck(_v, 69, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55);
        var currVal_60 = (_co.isEditingTerm() ? 'Update term' : 'Add term');
        _ck(_v, 91, 0, currVal_60);
        var currVal_61 = (_co.isEditingPublicHoliday() ? 'Edit public holiday' : ' Add a new public holiday');
        _ck(_v, 94, 0, currVal_61);
        var currVal_62 = core_es5["ɵnov"](_v, 99).ngClassUntouched;
        var currVal_63 = core_es5["ɵnov"](_v, 99).ngClassTouched;
        var currVal_64 = core_es5["ɵnov"](_v, 99).ngClassPristine;
        var currVal_65 = core_es5["ɵnov"](_v, 99).ngClassDirty;
        var currVal_66 = core_es5["ɵnov"](_v, 99).ngClassValid;
        var currVal_67 = core_es5["ɵnov"](_v, 99).ngClassInvalid;
        var currVal_68 = core_es5["ɵnov"](_v, 99).ngClassPending;
        _ck(_v, 95, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68);
        var currVal_69 = core_es5["ɵnov"](_v, 108).ngClassUntouched;
        var currVal_70 = core_es5["ɵnov"](_v, 108).ngClassTouched;
        var currVal_71 = core_es5["ɵnov"](_v, 108).ngClassPristine;
        var currVal_72 = core_es5["ɵnov"](_v, 108).ngClassDirty;
        var currVal_73 = core_es5["ɵnov"](_v, 108).ngClassValid;
        var currVal_74 = core_es5["ɵnov"](_v, 108).ngClassInvalid;
        var currVal_75 = core_es5["ɵnov"](_v, 108).ngClassPending;
        _ck(_v, 103, 0, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75);
        var currVal_80 = (_co.isEditingPublicHoliday() ? 'Update public holiday' : 'Add public holiday');
        _ck(_v, 122, 0, currVal_80);
    });
}
function View_CalendarDayFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'calendar-day-form', [], null, null, null, View_CalendarDayFormComponent_0, RenderType_CalendarDayFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, calendar_day_form_CalendarDayFormComponent, [src_store["a" /* Store */], calendar_CalendarEffects, modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CalendarDayFormComponentNgFactory = core_es5["ɵccf"]('calendar-day-form', calendar_day_form_CalendarDayFormComponent, View_CalendarDayFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=calendar-day-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/absence-form.ts










var absence_form_AbsenceFormComponent = (function () {
    function AbsenceFormComponent(store, contactEffects, matrixClassEffects, completerService, modalService) {
        this.store = store;
        this.contactEffects = contactEffects;
        this.matrixClassEffects = matrixClassEffects;
        this.completerService = completerService;
        this.modalService = modalService;
        this.isEditing = false;
        this.currentStep = 1;
    }
    AbsenceFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.select("contactsReducer").subscribe(function (c) {
            _this.teacher = c.activeContact;
            _this.absence = c.editableAbsence;
            _this.absence.contactId = _this.teacher.id;
        });
        this.store.select("matrixClassesReducer").subscribe(function (mc) {
            _this.teachers = mc.teachers;
            _this.setupTeacherAutocompleter();
        });
        if (!this.isEditing) {
            this.setSensibleDefaultDateTimes();
        }
    };
    AbsenceFormComponent.prototype.setupTeacherAutocompleter = function () {
        this.replacementTeacherCompleter =
            this.completerService.local(this.teachers, "fullName", "fullName");
    };
    AbsenceFormComponent.prototype.setupAbsenceWithNewModifiedClasses = function () {
        var _this = this;
        this.absence.modifiedClasses = [];
        this.absence.classesBetween.forEach(function (cb) {
            var modifiedClass = new modified_class_ModifiedClass();
            modifiedClass.matrixClassId = cb.matrixClassId;
            _this.absence.modifiedClasses.push(modifiedClass);
        });
    };
    AbsenceFormComponent.prototype.setSensibleDefaultDateTimes = function () {
        this.absence.startDateTime = moment(new Date()).toDate();
        this.absence.endDateTime = moment(new Date()).add(1, "days").toDate();
    };
    AbsenceFormComponent.prototype.clickedSubmitAbsenceDateTimes = function () {
        var _this = this;
        var params = {
            contactId: this.teacher.id,
            startDateTime: this.absence.startDateTime.toString(),
            endDateTime: this.absence.endDateTime.toString()
        };
        var a = this.contactEffects.classesBetween;
        var b = this.matrixClassEffects.fetchTeachers;
        Observable["Observable"].zip(a, b).take(1).subscribe(function (actions) {
            if (actions[0].type === UPDATE_ABSENCE_DATE_TIME_CHECK_CONTACT &&
                actions[1].type === POPULATE_TEACHERS) {
                _this.setupAbsenceWithNewModifiedClasses();
                _this.nextStep();
            }
        });
        this.store.dispatch({ type: FETCH_ABSENCE_DATE_TIME_CHECK_CONTACT, payload: params });
        this.store.dispatch({ type: FETCH_TEACHERS });
    };
    AbsenceFormComponent.prototype.clickedCreateAbsence = function () {
        var _this = this;
        this.contactEffects.createAbsence.take(1).subscribe(function (a) {
            if (a.type == FETCH_CONTACT) {
                _this.modalService.closeModal();
            }
        });
        this.store.dispatch({ type: CREATE_ABSENCE, payload: this.absence });
    };
    AbsenceFormComponent.prototype.selectedReplacementTeacher = function (e, classBetween) {
        var modifiedClass = this.absence.modifiedClasses.find(function (mc) {
            return mc.matrixClassId === classBetween.matrixClassId;
        });
        if (e && e.originalObject) {
            var teacher = e.originalObject;
            modifiedClass.contactId = this.teacher.id;
            modifiedClass.date = this.absence.classesBetween.find(function (cb) {
                return cb.matrixClassId === modifiedClass.matrixClassId;
            }).date;
        }
        else {
            modifiedClass.contactId = null;
            modifiedClass.date = null;
        }
    };
    AbsenceFormComponent.prototype.changedStartDateTime = function (inputVal) {
        this.absence.startDateTime = new Date(inputVal);
    };
    AbsenceFormComponent.prototype.changedEndDateTime = function (inputVal) {
        this.absence.endDateTime = new Date(inputVal);
    };
    AbsenceFormComponent.prototype.nextStep = function () { this.currentStep++; };
    AbsenceFormComponent.prototype.previousStep = function () { this.currentStep--; };
    AbsenceFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: contact_ContactEffects }, { type: matrix_class_MatrixClassEffects }, { type: ng2_completer["a" /* CompleterService */] }, { type: modal_ModalService }]; };
    return AbsenceFormComponent;
}());

//# sourceMappingURL=absence-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/absence-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_AbsenceFormComponent = [];
var RenderType_AbsenceFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AbsenceFormComponent, data: {} });
function View_AbsenceFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 29, 'div', [['class',
                'af__step one']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 22, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 10, 'div', [['class', 'input-group half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Start'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 6, 'input', [['type', 'datetime-local']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedStartDateTime($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](9, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](10, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](12, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 10, 'div', [['class', 'input-group half']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['End'])), (_l()(), core_es5["ɵeld"](17, 0, null, null, 6, 'input', [['type', 'datetime-local']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 18)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 18).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 18)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 18)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedEndDateTime($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](18, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](20, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](21, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](25, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](26, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](27, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmitAbsenceDateTimes() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Next']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = core_es5["ɵunv"](_v, 9, 0, _ck(_v, 10, 0, core_es5["ɵnov"](_v.parent, 0), _co.absence.startDateTime, 'yyyy-MM-ddTHH:mm'));
        _ck(_v, 9, 0, currVal_7);
        var currVal_15 = core_es5["ɵunv"](_v, 20, 0, _ck(_v, 21, 0, core_es5["ɵnov"](_v.parent, 0), _co.absence.endDateTime, 'yyyy-MM-ddTHH:mm'));
        _ck(_v, 20, 0, currVal_15);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 12).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 12).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 12).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 12).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 12).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 12).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 12).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = core_es5["ɵnov"](_v, 23).ngClassUntouched;
        var currVal_9 = core_es5["ɵnov"](_v, 23).ngClassTouched;
        var currVal_10 = core_es5["ɵnov"](_v, 23).ngClassPristine;
        var currVal_11 = core_es5["ɵnov"](_v, 23).ngClassDirty;
        var currVal_12 = core_es5["ɵnov"](_v, 23).ngClassValid;
        var currVal_13 = core_es5["ɵnov"](_v, 23).ngClassInvalid;
        var currVal_14 = core_es5["ɵnov"](_v, 23).ngClassPending;
        _ck(_v, 17, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14);
    });
}
function View_AbsenceFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 16, 'li', [['class',
                'af__class-between']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 5, 'div', [['class',
                'af__cb-meta']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [['class', 'af__cb-code']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'label', [['class', 'af__cb-date']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', ''])), core_es5["ɵppd"](6, 2), (_l()(), core_es5["ɵeld"](7, 0, null, null, 9, 'div', [['class', 'af__cb-options']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 8, 'div', [['class', 'af__cb-replacement-teacher']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](10, null, ['Replacement Teacher for ',
            ''])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 5, 'ng2-completer', [['id', 'replacement-teacher'], ['name', 'replacement-teacher']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.replacementTeacherSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedReplacementTeacher($event, _v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](12, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](14, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_10 = 0;
        var currVal_11 = true;
        var currVal_12 = _co.replacementTeacherCompleter;
        _ck(_v, 12, 0, currVal_10, currVal_11, currVal_12);
        var currVal_13 = 'replacement-teacher';
        var currVal_14 = _co.replacementTeacherSearchStr;
        _ck(_v, 14, 0, currVal_13, currVal_14);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.code;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵunv"](_v, 5, 0, _ck(_v, 6, 0, core_es5["ɵnov"](_v.parent.parent, 0), _v.context.$implicit.date, 'dd/MM/yyyy'));
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = _v.context.$implicit.code;
        _ck(_v, 10, 0, currVal_2);
        var currVal_3 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_4 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9);
    });
}
function View_AbsenceFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 16, 'div', [['class',
                'af__step two']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h3', [['class', 'af__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Potentially affected classes'])), (_l()(),
            core_es5["ɵeld"](3, 0, null, null, 4, 'div', [['class', 'af__replacement-blurb']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['If you don\'t select a replacement teacher for an affected class, the class will be moved to the next available spot outside its Matrix Term.'])),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['For example: Without a replacement teacher, a Monday class would be moved to the next available Monday after Matrix Term. The replacement class would appear in the Calendar.'])),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 2, 'ul', [['class', 'af__classes-between']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AbsenceFormComponent_3)),
        core_es5["ɵdid"](10, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](11, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](13, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](14, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCreateAbsence() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Create absence']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.absence.classesBetween;
        _ck(_v, 10, 0, currVal_0);
    }, null);
}
function View_AbsenceFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class', 'absence-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'af__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['Create absence for: ',
            ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 4, 'div', [['class', 'af__content-wrapper']], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_AbsenceFormComponent_1)),
        core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AbsenceFormComponent_2)), core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.currentStep == 1);
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (_co.currentStep == 2);
        _ck(_v, 8, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.teacher.fullName;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_AbsenceFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'absence-form', [], null, null, null, View_AbsenceFormComponent_0, RenderType_AbsenceFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, absence_form_AbsenceFormComponent, [src_store["a" /* Store */], contact_ContactEffects, matrix_class_MatrixClassEffects, completer_service["a" /* CompleterService */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AbsenceFormComponentNgFactory = core_es5["ɵccf"]('absence-form', absence_form_AbsenceFormComponent, View_AbsenceFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=absence-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/window-form.ts




var window_form_WindowFormComponent = (function () {
    function WindowFormComponent(store, completerService) {
        this.store = store;
        this.completerService = completerService;
        this.submitted = new core_es5["EventEmitter"]();
        this.closed = new core_es5["EventEmitter"]();
    }
    WindowFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.constantsStore = this.store.select("constantsReducer");
        this.constantsStore.subscribe(function (s) {
            _this.days = s.constants.days;
        });
        this.dayCompleter =
            this.completerService.local(this.days, "name", "name");
    };
    WindowFormComponent.prototype.clickedSubmit = function (e) {
        e.preventDefault();
        this.submitted.emit(this.window);
    };
    WindowFormComponent.prototype.clickedCancel = function (e) {
        e.preventDefault();
        this.closed.emit(this.window);
    };
    WindowFormComponent.prototype.selectedDay = function (e) {
        if (e && e.originalObject) {
            this.window.dayId = e.originalObject.id;
        }
    };
    WindowFormComponent.prototype.changedStartTime = function (timeString, window) {
        window.startTime = this.getDateFromTimeString(timeString);
    };
    WindowFormComponent.prototype.changedEndTime = function (timeString, window) {
        window.endTime = this.getDateFromTimeString(timeString);
    };
    WindowFormComponent.prototype.changedLunchStartTime = function (timeString, window) {
        window.lunchStartTime = this.getDateFromTimeString(timeString);
        window.lunchEndTime = moment(window.lunchStartTime).add(1, "h").toDate();
    };
    WindowFormComponent.prototype.getDateFromTimeString = function (timeString) {
        var parts = timeString.split(":");
        var mDateTime = moment();
        return mDateTime
            .hour(parseInt(parts[0]))
            .minute(parseInt(parts[1]))
            .second(0)
            .toDate();
    };
    WindowFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }]; };
    return WindowFormComponent;
}());

//# sourceMappingURL=window-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/window-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








var styles_WindowFormComponent = [];
var RenderType_WindowFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WindowFormComponent, data: {} });
function View_WindowFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCancel($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Cancel']))], null, null);
}
function View_WindowFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 68, 'div', [['class', 'window-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 67, 'div', [['class', 'wf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 66, 'form', [['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 16384, null, 0, forms_es5["ɵbf"], [], null, null), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["NgForm"], [[8, null],
            [8, null]], null, null), core_es5["ɵprd"](2048, null, forms_es5["ControlContainer"], null, [forms_es5["NgForm"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatusGroup"], [forms_es5["ControlContainer"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 53, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 9, 'div', [['class', 'input-group day']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 5, 'ng2-completer', [['id', 'day'], ['name', 'day']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.daySearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedDay($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](12, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], initialValue: [2, 'initialValue'],
            datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](14, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](17, 0, null, null, 1, 'label', [['for', 'day']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Day'])), (_l()(),
            core_es5["ɵeld"](19, 0, null, null, 10, 'div', [['class', 'input-group start-time']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Start time'])), (_l()(), core_es5["ɵeld"](23, 0, null, null, 6, 'input', [['name', 'startTime'], ['step', '1800'], ['type', 'time']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedStartTime($event, _co.window) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](24, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](26, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](27, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](29, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 10, 'div', [['class', 'input-group end-time']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](32, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['End time'])), (_l()(), core_es5["ɵeld"](34, 0, null, null, 6, 'input', [['name', 'endTime'], ['type', 'time']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 35)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 35).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 35)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 35)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedEndTime($event, _co.window) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](35, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](37, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](38, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](40, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](41, 0, null, null, 20, 'div', [['class', 'input-group lunch-start-time']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](42, 0, null, null, 7, 'div', [['class', 'input-group checkbox has-lunchtime']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](43, 0, null, null, 5, 'input', [['id', 'has-lunchtime'],
            ['name', 'hasLunchtime'], ['type', 'checkbox']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 44).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 44).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.window.hasLunchtime = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](44, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](46, 671744, null, 0, forms_es5["NgModel"], [[2, forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](48, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](49, 0, null, null, 0, 'label', [['for', 'has-lunchtime']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](50, 0, null, null, 11, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        core_es5["ɵdid"](51, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](52, { 'dim': 0 }), (_l()(), core_es5["ɵeld"](53, 0, null, null, 1, 'label', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Lunch hour'])), (_l()(), core_es5["ɵeld"](55, 0, null, null, 6, 'input', [['name', 'lunchStartTime'], ['type', 'time']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 56)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 56).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 56)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 56)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedLunchStartTime($event, _co.window) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](56, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](58, 671744, null, 0, forms_es5["NgModel"], [[2,
                forms_es5["ControlContainer"]], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](59, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](61, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](62, 0, null, null, 7, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](63, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WindowFormComponent_1)),
        core_es5["ɵdid"](65, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](66, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](67, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](68, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](69, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_14 = 0;
        var currVal_15 = true;
        var currVal_16 = (_co.window.day || _co.days[0]);
        var currVal_17 = _co.dayCompleter;
        _ck(_v, 12, 0, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_18 = 'day';
        var currVal_19 = _co.daySearchStr;
        _ck(_v, 14, 0, currVal_18, currVal_19);
        var currVal_27 = 'startTime';
        var currVal_28 = core_es5["ɵunv"](_v, 26, 1, _ck(_v, 27, 0, core_es5["ɵnov"](_v, 0), _co.window.startTime, 'HH:mm'));
        _ck(_v, 26, 0, currVal_27, currVal_28);
        var currVal_36 = 'endTime';
        var currVal_37 = core_es5["ɵunv"](_v, 37, 1, _ck(_v, 38, 0, core_es5["ɵnov"](_v, 0), _co.window.endTime, 'HH:mm'));
        _ck(_v, 37, 0, currVal_36, currVal_37);
        var currVal_45 = 'hasLunchtime';
        var currVal_46 = _co.window.hasLunchtime;
        _ck(_v, 46, 0, currVal_45, currVal_46);
        var currVal_47 = 'ig__content-wrapper';
        var currVal_48 = _ck(_v, 52, 0, !_co.window.hasLunchtime);
        _ck(_v, 51, 0, currVal_47, currVal_48);
        var currVal_56 = 'lunchStartTime';
        var currVal_57 = core_es5["ɵunv"](_v, 58, 1, _ck(_v, 59, 0, core_es5["ɵnov"](_v, 0), _co.window.lunchStartTime, 'HH:mm'));
        _ck(_v, 58, 0, currVal_56, currVal_57);
        var currVal_58 = _co.window.isEditing;
        _ck(_v, 65, 0, currVal_58);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_9 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_10 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_11 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_12 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_13 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13);
        var currVal_20 = core_es5["ɵnov"](_v, 29).ngClassUntouched;
        var currVal_21 = core_es5["ɵnov"](_v, 29).ngClassTouched;
        var currVal_22 = core_es5["ɵnov"](_v, 29).ngClassPristine;
        var currVal_23 = core_es5["ɵnov"](_v, 29).ngClassDirty;
        var currVal_24 = core_es5["ɵnov"](_v, 29).ngClassValid;
        var currVal_25 = core_es5["ɵnov"](_v, 29).ngClassInvalid;
        var currVal_26 = core_es5["ɵnov"](_v, 29).ngClassPending;
        _ck(_v, 23, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_29 = core_es5["ɵnov"](_v, 40).ngClassUntouched;
        var currVal_30 = core_es5["ɵnov"](_v, 40).ngClassTouched;
        var currVal_31 = core_es5["ɵnov"](_v, 40).ngClassPristine;
        var currVal_32 = core_es5["ɵnov"](_v, 40).ngClassDirty;
        var currVal_33 = core_es5["ɵnov"](_v, 40).ngClassValid;
        var currVal_34 = core_es5["ɵnov"](_v, 40).ngClassInvalid;
        var currVal_35 = core_es5["ɵnov"](_v, 40).ngClassPending;
        _ck(_v, 34, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_38 = core_es5["ɵnov"](_v, 48).ngClassUntouched;
        var currVal_39 = core_es5["ɵnov"](_v, 48).ngClassTouched;
        var currVal_40 = core_es5["ɵnov"](_v, 48).ngClassPristine;
        var currVal_41 = core_es5["ɵnov"](_v, 48).ngClassDirty;
        var currVal_42 = core_es5["ɵnov"](_v, 48).ngClassValid;
        var currVal_43 = core_es5["ɵnov"](_v, 48).ngClassInvalid;
        var currVal_44 = core_es5["ɵnov"](_v, 48).ngClassPending;
        _ck(_v, 43, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44);
        var currVal_49 = core_es5["ɵnov"](_v, 61).ngClassUntouched;
        var currVal_50 = core_es5["ɵnov"](_v, 61).ngClassTouched;
        var currVal_51 = core_es5["ɵnov"](_v, 61).ngClassPristine;
        var currVal_52 = core_es5["ɵnov"](_v, 61).ngClassDirty;
        var currVal_53 = core_es5["ɵnov"](_v, 61).ngClassValid;
        var currVal_54 = core_es5["ɵnov"](_v, 61).ngClassInvalid;
        var currVal_55 = core_es5["ɵnov"](_v, 61).ngClassPending;
        _ck(_v, 55, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55);
        var currVal_59 = (_co.window.isEditing ? 'Update' : 'Add');
        _ck(_v, 69, 0, currVal_59);
    });
}
function View_WindowFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'window-form', [], null, null, null, View_WindowFormComponent_0, RenderType_WindowFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, window_form_WindowFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WindowFormComponentNgFactory = core_es5["ɵccf"]('window-form', window_form_WindowFormComponent, View_WindowFormComponent_Host_0, { window: 'window' }, { submitted: 'submitted',
    closed: 'closed' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=window-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshop-campus-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_WorkshopCampusFormComponent = [];
var RenderType_WorkshopCampusFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopCampusFormComponent, data: {} });
function View_WorkshopCampusFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['(Lunch: ', '\n-\n', ')'])), core_es5["ɵppd"](2, 2), core_es5["ɵppd"](3, 2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.parent.parent.context.$implicit.lunchStartTime, 'shortTime'));
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.parent.parent.context.$implicit.lunchEndTime, 'shortTime'));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_WorkshopCampusFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', '\n- \n', '\n- \n', ''])), core_es5["ɵppd"](2, 2), core_es5["ɵppd"](3, 2), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_3)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵeld"](6, 0, null, null, 1, 'button', [['class', 'wcf__side-btn edit-window tiny']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.clickedEditWindow(_v.parent.context.$implicit) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Edit']))], function (_ck, _v) {
        var currVal_3 = _v.parent.context.$implicit.hasLunchtime;
        _ck(_v, 5, 0, currVal_3);
    }, function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.day.name;
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent, 0), _v.parent.context.$implicit.startTime, 'shortTime'));
        var currVal_2 = core_es5["ɵunv"](_v, 1, 2, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent, 0), _v.parent.context.$implicit.endTime, 'shortTime'));
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    });
}
function View_WorkshopCampusFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'window-form', [], null, [[null, 'submitted'], [null, 'closed']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submitted' === en)) {
                var pd_0 = (_co.submittedExistingWindow($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('closed' === en)) {
                var pd_1 = (_co.closedEditWindowForm($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_WindowFormComponent_0, RenderType_WindowFormComponent)), core_es5["ɵdid"](2, 114688, null, 0, window_form_WindowFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */]], { window: [0, 'window'] }, { submitted: 'submitted', closed: 'closed' })], function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_WorkshopCampusFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'li', [['class',
                'wcf__window']], null, null, null, null, null)),
        core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        core_es5["ɵpod"](2, { 'editing': 0 }), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_2)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_4)),
        core_es5["ɵdid"](6, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var currVal_0 = 'wcf__window';
        var currVal_1 = _ck(_v, 2, 0, _v.context.$implicit.isEditing);
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = !_v.context.$implicit.isEditing;
        _ck(_v, 4, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.isEditing;
        _ck(_v, 6, 0, currVal_3);
    }, null);
}
function View_WorkshopCampusFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'div', [['class',
                'wcf__window-form new']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'div', [['class',
                'wcf__close']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCloseNewWindowForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['× '])), (_l()(),
            core_es5["ɵeld"](3, 0, null, null, 1, 'h4', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['New schedule window'])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'window-form', [], null, [[null, 'submitted']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('submitted' === en)) {
                var pd_0 = (_co.submittedNewWindow($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_WindowFormComponent_0, RenderType_WindowFormComponent)), core_es5["ɵdid"](6, 114688, null, 0, window_form_WindowFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */]], { window: [0, 'window'] }, { submitted: 'submitted' })], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.newWindow;
        _ck(_v, 6, 0, currVal_0);
    }, null);
}
function View_WorkshopCampusFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'wcf__side-btn delete-course tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRemoveCourse(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Remove']))], null, null);
}
function View_WorkshopCampusFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'wcf__side-btn delete-course-cancel tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCancelRemoveCourse(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No, cancel']))], null, null);
}
function View_WorkshopCampusFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'wcf__side-btn delete-course-confirm tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedConfirmRemoveCourse(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Confirm removal']))], null, null);
}
function View_WorkshopCampusFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'li', [['class',
                'wcf__course']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', ' - Year ', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_7)),
        core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_8)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_9)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var currVal_2 = !_v.context.$implicit.isConfirmingRemove;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.isConfirmingRemove;
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.isConfirmingRemove;
        _ck(_v, 7, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.name;
        var currVal_1 = _v.context.$implicit.grade;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_WorkshopCampusFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 28, 'div', [['class', 'workshop-campus-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'wcf__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['Workshop: ',
            ' (', ')'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 25, 'div', [['class',
                'wcf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 9, 'div', [['class',
                'wcf__lhs']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 3, 'h3', [['class', 'wcf__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Schedule windows'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'button', [['class', 'wcf__show-windows tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedNewWindow() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add window'])),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'ul', [['class', 'wcf__windows']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_1)),
        core_es5["ɵdid"](12, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_5)),
        core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](15, 0, null, null, 14, 'div', [['class', 'wcf__rhs']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](16, 0, null, null, 1, 'h3', [['class', 'wcf__subheader']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Associated courses (For workshop as a whole)'])),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 2, 'ul', [['class', 'wcf__courses']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopCampusFormComponent_6)),
        core_es5["ɵdid"](20, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](21, 0, null, null, 8, 'div', [['class', 'wcf__add-course-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](22, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add course'])), (_l()(), core_es5["ɵeld"](24, 0, null, null, 5, 'ng2-completer', [['id', 'add-course'], ['name', 'addCourse'], ['placeholder',
                'Select a course']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.courseSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCourse($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](25, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], placeholder: [1, 'placeholder'], openOnFocus: [2,
                'openOnFocus'], datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](27, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](29, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.windowsForCampus();
        _ck(_v, 12, 0, currVal_2);
        var currVal_3 = _co.isNewWindowFormVisible;
        _ck(_v, 14, 0, currVal_3);
        var currVal_4 = _co.workshop.courses;
        _ck(_v, 20, 0, currVal_4);
        var currVal_12 = 0;
        var currVal_13 = 'Select a course';
        var currVal_14 = true;
        var currVal_15 = _co.courseCompleter;
        _ck(_v, 25, 0, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_16 = 'addCourse';
        var currVal_17 = _co.courseSearchStr;
        _ck(_v, 27, 0, currVal_16, currVal_17);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.workshop.displayName;
        var currVal_1 = _co.campus.name;
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_5 = core_es5["ɵnov"](_v, 29).ngClassUntouched;
        var currVal_6 = core_es5["ɵnov"](_v, 29).ngClassTouched;
        var currVal_7 = core_es5["ɵnov"](_v, 29).ngClassPristine;
        var currVal_8 = core_es5["ɵnov"](_v, 29).ngClassDirty;
        var currVal_9 = core_es5["ɵnov"](_v, 29).ngClassValid;
        var currVal_10 = core_es5["ɵnov"](_v, 29).ngClassInvalid;
        var currVal_11 = core_es5["ɵnov"](_v, 29).ngClassPending;
        _ck(_v, 24, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
    });
}
function View_WorkshopCampusFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshop-campus-form', [], null, null, null, View_WorkshopCampusFormComponent_0, RenderType_WorkshopCampusFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, workshop_campus_form_WorkshopCampusFormComponent, [src_store["a" /* Store */], modal_ModalService, completer_service["a" /* CompleterService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopCampusFormComponentNgFactory = core_es5["ɵccf"]('workshop-campus-form', workshop_campus_form_WorkshopCampusFormComponent, View_WorkshopCampusFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshop-campus-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/tutor-allocation-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_TutorAllocationFormComponent = [];
var RenderType_TutorAllocationFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TutorAllocationFormComponent, data: {} });
function View_TutorAllocationFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['for ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ta.contact.fullName;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TutorAllocationFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'ig__error']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select a contact']))], null, null);
}
function View_TutorAllocationFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'taf__none courses']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This Tutor Allocation has no courses.']))], null, null);
}
function View_TutorAllocationFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'li', [['class',
                'taf__course']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, ['', ' - Year ', ''])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'button', [['class', 'taf__btn-side delete tiny']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedRemoveCourse(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Remove']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.name;
        var currVal_1 = _v.context.$implicit.grade;
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_TutorAllocationFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'taf__courses']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_5)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ta.courses;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TutorAllocationFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['In fact, this allocation has none. Add some courses above.']))], null, null);
}
function View_TutorAllocationFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'taf__none potential-windows']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This set of courses has no available time windows. '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_7)),
        core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.ta.courses.length == 0);
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_TutorAllocationFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'span', [['class',
                'taf__lunch-time-range']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['(Lunch:\n', '\n- \n', ') '])),
        core_es5["ɵppd"](2, 2), core_es5["ɵppd"](3, 2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.parent.context.$implicit.lunchStartTime, 'shortTime'));
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 3, 0, core_es5["ɵnov"](_v.parent.parent.parent.parent, 0), _v.parent.context.$implicit.lunchEndTime, 'shortTime'));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_TutorAllocationFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 13, 'li', [['class',
                'taf__potential-window input-group full checkbox']], null, null, null, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](2, { 'active': 0 }),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 10, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 0, 'input', [['type', 'checkbox']], [[8, 'id', 0], [8, 'checked', 0]], [[null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (_co.clickedWindowCheckbox($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 8, 'label', [], [[8, 'htmlFor', 0]], null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', '\n- '])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 3, 'span', [['class', 'taf__window-time-range']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](8, null, ['', '\n- \n', ' '])), core_es5["ɵppd"](9, 2), core_es5["ɵppd"](10, 2), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_11)), core_es5["ɵdid"](12, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](13, null, ['- \n', ' ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'taf__potential-window input-group full checkbox';
        var currVal_1 = _ck(_v, 2, 0, _co.isWindowInAllocation(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_8 = _v.context.$implicit.hasLunchtime;
        _ck(_v, 12, 0, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = ('window_' + _v.context.$implicit.id);
        var currVal_3 = _co.isWindowInAllocation(_v.context.$implicit);
        _ck(_v, 4, 0, currVal_2, currVal_3);
        var currVal_4 = ('window_' + _v.context.$implicit.id);
        _ck(_v, 5, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.day.name;
        _ck(_v, 6, 0, currVal_5);
        var currVal_6 = core_es5["ɵunv"](_v, 8, 0, _ck(_v, 9, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.context.$implicit.startTime, 'shortTime'));
        var currVal_7 = core_es5["ɵunv"](_v, 8, 1, _ck(_v, 10, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.context.$implicit.endTime, 'shortTime'));
        _ck(_v, 8, 0, currVal_6, currVal_7);
        var currVal_9 = _co.getWorkshopForWindow(_v.context.$implicit).displayName;
        _ck(_v, 13, 0, currVal_9);
    });
}
function View_TutorAllocationFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'taf__pw-by-campus']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'label', [['class',
                'taf__pw-by-campus-header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'ul', [['class', 'taf__potential-windows']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_10)),
        core_es5["ɵdid"](5, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var currVal_1 = _v.context.$implicit.windows;
        _ck(_v, 5, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.campus.name;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TutorAllocationFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'taf__potential-windows-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'ul', [['class', 'taf__pw-by-campus-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_9)), core_es5["ɵdid"](3, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getPotentialWindowsByCampus();
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_TutorAllocationFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 48, 'div', [['class', 'tutor-allocation-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'h1', [['class', 'taf__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Tutor Allocation '])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](6, 0, null, null, 43, 'div', [['class', 'taf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 11, 'div', [['class', 'taf__tutor-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 10, 'div', [['class', 'input-group tutor']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 5, 'ng2-completer', [['id', 'tutor'], ['name', 'tutor'], ['placeholder',
                'Select a tutor']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null,
                'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.tutorSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedTutor($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](10, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], placeholder: [1, 'placeholder'], openOnFocus: [2,
                'openOnFocus'], initialValue: [3, 'initialValue'], datasource: [4, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](12, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](14, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](15, 0, null, null, 1, 'label', [['for', 'tutor']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select tutor'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_2)), core_es5["ɵdid"](18, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](19, 0, null, null, 15, 'div', [['class', 'taf__courses-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 1, 'h3', [['class', 'taf__subheader courses']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Courses'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_3)), core_es5["ɵdid"](23, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_4)),
        core_es5["ɵdid"](25, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](26, 0, null, null, 8, 'div', [['class', 'taf__add-course-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](27, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Add course'])),
        (_l()(), core_es5["ɵeld"](29, 0, null, null, 5, 'ng2-completer', [['id', 'add-course'],
            ['name', 'addCourse'], ['placeholder', 'Select a course']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.courseSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCourse($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](30, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], clearSelected: [1, 'clearSelected'], placeholder: [2,
                'placeholder'], openOnFocus: [3, 'openOnFocus'], datasource: [4, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](32, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](34, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](35, 0, null, null, 8, 'div', [['class', 'taf__windows-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](36, 0, null, null, 3, 'h3', [['class', 'taf__subheader windows']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Workshop windows'])), (_l()(), core_es5["ɵeld"](38, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](39, null, ['(Available for ', ')'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_6)), core_es5["ɵdid"](41, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TutorAllocationFormComponent_8)),
        core_es5["ɵdid"](43, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](44, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](45, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](46, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](47, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](48, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Save']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ta.contactId;
        _ck(_v, 5, 0, currVal_0);
        var currVal_8 = 0;
        var currVal_9 = 'Select a tutor';
        var currVal_10 = true;
        var currVal_11 = (_co.ta.contact || '');
        var currVal_12 = _co.tutorCompleter;
        _ck(_v, 10, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = 'tutor';
        var currVal_14 = _co.tutorSearchStr;
        _ck(_v, 12, 0, currVal_13, currVal_14);
        var currVal_15 = ((_co.errors == null) ? null : ((_co.errors.contact == null) ? null : _co.errors.contact.required));
        _ck(_v, 18, 0, currVal_15);
        var currVal_16 = (_co.ta.courses.length == 0);
        _ck(_v, 23, 0, currVal_16);
        var currVal_17 = (_co.ta.courses.length > 0);
        _ck(_v, 25, 0, currVal_17);
        var currVal_25 = 0;
        var currVal_26 = true;
        var currVal_27 = 'Select a course';
        var currVal_28 = true;
        var currVal_29 = _co.courseCompleter;
        _ck(_v, 30, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29);
        var currVal_30 = 'addCourse';
        var currVal_31 = _co.courseSearchStr;
        _ck(_v, 32, 0, currVal_30, currVal_31);
        var currVal_33 = (_co.potentialWindows.length == 0);
        _ck(_v, 41, 0, currVal_33);
        var currVal_34 = (_co.potentialWindows.length > 0);
        _ck(_v, 43, 0, currVal_34);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵnov"](_v, 14).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 14).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 14).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 14).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 14).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 14).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 14).ngClassPending;
        _ck(_v, 9, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_18 = core_es5["ɵnov"](_v, 34).ngClassUntouched;
        var currVal_19 = core_es5["ɵnov"](_v, 34).ngClassTouched;
        var currVal_20 = core_es5["ɵnov"](_v, 34).ngClassPristine;
        var currVal_21 = core_es5["ɵnov"](_v, 34).ngClassDirty;
        var currVal_22 = core_es5["ɵnov"](_v, 34).ngClassValid;
        var currVal_23 = core_es5["ɵnov"](_v, 34).ngClassInvalid;
        var currVal_24 = core_es5["ɵnov"](_v, 34).ngClassPending;
        _ck(_v, 29, 0, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_32 = (_co.ta.windows.length || 0);
        _ck(_v, 39, 0, currVal_32);
    });
}
function View_TutorAllocationFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'tutor-allocation-form', [], null, null, null, View_TutorAllocationFormComponent_0, RenderType_TutorAllocationFormComponent)), core_es5["ɵdid"](1, 114688, null, 0, tutor_allocation_form_TutorAllocationFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], tutor_allocation_TutorAllocationEffects, modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TutorAllocationFormComponentNgFactory = core_es5["ɵccf"]('tutor-allocation-form', tutor_allocation_form_TutorAllocationFormComponent, View_TutorAllocationFormComponent_Host_0, { isEditing: 'isEditing' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=tutor-allocation-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/booking-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_BookingFormComponent = [];
var RenderType_BookingFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_BookingFormComponent, data: {} });
function View_BookingFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'ng2-completer', [['id', 'student'], ['name', 'student']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.studentSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedStudent($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](1, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0,
                'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](3, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.studentCompleter;
        _ck(_v, 1, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'student';
        var currVal_11 = _co.studentSearchStr;
        _ck(_v, 3, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 5).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 5).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 5).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 5).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 5).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 5).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 5).ngClassPending;
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_BookingFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.booking.contact.fullName;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_BookingFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'bf__info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select a student.']))], null, null);
}
function View_BookingFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'ng2-completer', [['id', 'course'],
            ['name', 'course']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.courseSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedCourse($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](3, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [['for', 'course']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select course']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.courseCompleter;
        _ck(_v, 3, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'course';
        var currVal_11 = _co.courseSearchStr;
        _ck(_v, 5, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_BookingFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'bf__info']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Please select a course.']))], null, null);
}
function View_BookingFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Note'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'input', [['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange'], [null, 'input'],
            [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.booking.note = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.booking.note;
        _ck(_v, 7, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_BookingFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'button', [['class', 'positive']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = ((_co.mode == 'new') ? 'Create' : 'Update');
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_BookingFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 26, 'div', [['class',
                'bf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 23, 'div', [['class',
                'bf__form-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 12, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 7, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 6, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'label', [['for', 'student']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Student'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_2)), core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_3)), core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](11, 0, null, null, 3, 'div', [['class', 'input-group info']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_4)), core_es5["ɵdid"](14, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](15, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_5)), core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](18, 0, null, null, 3, 'div', [['class', 'input-group info']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_6)), core_es5["ɵdid"](21, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](22, 0, null, null, 2, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_7)), core_es5["ɵdid"](24, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_8)),
        core_es5["ɵdid"](26, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.mode == 'new');
        _ck(_v, 8, 0, currVal_0);
        var currVal_1 = (_co.mode == 'edit');
        _ck(_v, 10, 0, currVal_1);
        var currVal_2 = !_co.booking.contactId;
        _ck(_v, 14, 0, currVal_2);
        var currVal_3 = _co.booking.contact;
        _ck(_v, 17, 0, currVal_3);
        var currVal_4 = (_co.booking.contactId && !_co.booking.courseId);
        _ck(_v, 21, 0, currVal_4);
        var currVal_5 = (_co.booking.contactId && _co.booking.courseId);
        _ck(_v, 24, 0, currVal_5);
        var currVal_6 = (_co.booking.contactId && _co.booking.courseId);
        _ck(_v, 26, 0, currVal_6);
    }, null);
}
function View_BookingFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'booking-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class', 'bf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['Booking - Period ', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_BookingFormComponent_1)),
        core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = (_co.students.length > 0);
        _ck(_v, 4, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.period;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_BookingFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'booking-form', [], null, null, null, View_BookingFormComponent_0, RenderType_BookingFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, booking_form_BookingFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var BookingFormComponentNgFactory = core_es5["ɵccf"]('booking-form', booking_form_BookingFormComponent, View_BookingFormComponent_Host_0, { timeslot: 'timeslot',
    tutor: 'tutor', period: 'period', mode: 'mode' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=booking-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/workshop-absence-form.ts








var workshop_absence_form_WorkshopAbsenceFormComponent = (function () {
    function WorkshopAbsenceFormComponent(store, completerService, actions, modalService) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.modalService = modalService;
        this.replacementTutors = [];
        this.affectedBookings = [];
        this.dateTimeSubject$ = new Subject["Subject"]();
    }
    WorkshopAbsenceFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bookingsSubscription =
            this.store.select("bookingsReducer").subscribe(function (s) {
                _this.wa = s.editableWorkshopAbsence;
                _this.affectedBookings = s.affectedBookings;
                _this.replacementTutors = s.replacementTutors;
                _this.populateReplacementTutorAutocompleter();
            });
        if (!this.isEditing) {
            this.setSensibleDefaultDateTimes();
        }
        this.setupSubjectForOverlappingBookings();
        this.refreshAffectedBookings(this.wa);
        this.fetchReplacementTutors();
    };
    WorkshopAbsenceFormComponent.prototype.fetchReplacementTutors = function () {
        this.store.dispatch({ type: FETCH_REPLACEMENT_TUTORS });
    };
    WorkshopAbsenceFormComponent.prototype.populateReplacementTutorAutocompleter = function () {
        this.replacementTutorCompleter =
            this.completerService.local(this.replacementTutors, "fullName", "fullName");
    };
    WorkshopAbsenceFormComponent.prototype.setSensibleDefaultDateTimes = function () {
        this.wa.startDateTime = moment(new Date()).toDate();
        this.wa.endDateTime = moment(new Date()).add(1, "days").toDate();
    };
    WorkshopAbsenceFormComponent.prototype.changedStartDateTime = function (inputVal) {
        var newDate = new Date(inputVal);
        if (!isNaN(newDate.getTime())) {
            this.wa.startDateTime = newDate;
            this.dateTimeSubject$.next(this.wa);
        }
    };
    WorkshopAbsenceFormComponent.prototype.changedEndDateTime = function (inputVal) {
        var newDate = new Date(inputVal);
        if (!isNaN(newDate.getTime())) {
            this.wa.endDateTime = newDate;
            this.dateTimeSubject$.next(this.wa);
        }
    };
    WorkshopAbsenceFormComponent.prototype.clickedCreate = function () {
        var _this = this;
        this.actions
            .ofType(ADD_WORKSHOP_ABSENCE)
            .take(1)
            .subscribe(function () { return _this.modalService.closeModal(); });
        this.store.dispatch({ type: CREATE_WORKSHOP_ABSENCE, payload: this.wa });
    };
    WorkshopAbsenceFormComponent.prototype.selectedReplacementTutor = function (e) {
        if (e && e.originalObject) {
            this.wa.replacementTutor = e.originalObject;
            this.wa.replacementTutorId = e.originalObject.id;
        }
        else {
            this.wa.replacementTutor = null;
            this.wa.replacementTutorId = null;
        }
    };
    WorkshopAbsenceFormComponent.prototype.setupSubjectForOverlappingBookings = function () {
        var _this = this;
        this.dateTimeSubscription = this.dateTimeSubject$
            .debounceTime(1000)
            .subscribe(function (wa) {
            _this.refreshAffectedBookings(wa);
        });
    };
    WorkshopAbsenceFormComponent.prototype.refreshAffectedBookings = function (wa) {
        if (!wa.startDateTime || !wa.endDateTime) {
            return;
        }
        var params = {
            startDateTime: wa.startDateTime,
            endDateTime: wa.endDateTime,
            tutorAllocationId: wa.contact.tutorAllocationId,
        };
        this.store.dispatch({ type: FETCH_AFFECTED_BOOKINGS, payload: params });
    };
    WorkshopAbsenceFormComponent.prototype.ngOnDestroy = function () {
        this.bookingsSubscription.unsubscribe();
        this.dateTimeSubscription.unsubscribe();
    };
    WorkshopAbsenceFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }, { type: modal_ModalService }]; };
    return WorkshopAbsenceFormComponent;
}());

//# sourceMappingURL=workshop-absence-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshop-absence-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_WorkshopAbsenceFormComponent = [];
var RenderType_WorkshopAbsenceFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_WorkshopAbsenceFormComponent, data: {} });
function View_WorkshopAbsenceFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Replacement tutor'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'ng2-completer', [['id', 'replacement-tutor'], ['name', 'replacement-tutor']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.replacementTutorSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedReplacementTutor($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](5, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.replacementTutorCompleter;
        _ck(_v, 5, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'replacement-tutor';
        var currVal_11 = _co.replacementTutorSearchStr;
        _ck(_v, 7, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_WorkshopAbsenceFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'waf__no-affected-bookings']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No affected bookings']))], null, null);
}
function View_WorkshopAbsenceFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'waf__affected-booking']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', ' \n- \n', ' Period ', ' '])),
        core_es5["ɵppd"](2, 2), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](4, null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.contact.fullName;
        var currVal_1 = core_es5["ɵunv"](_v, 1, 1, _ck(_v, 2, 0, core_es5["ɵnov"](_v.parent.parent, 0), _v.context.$implicit.date, 'shortDate'));
        var currVal_2 = _v.context.$implicit.period;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = ((_v.context.$implicit.window.workshop == null) ? null : _v.context.$implicit.window.workshop.displayName);
        _ck(_v, 4, 0, currVal_3);
    });
}
function View_WorkshopAbsenceFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'waf__affected-bookings']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopAbsenceFormComponent_4)), core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.affectedBookings;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_WorkshopAbsenceFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 42, 'div', [['class', 'workshop-absence-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class', 'waf__header']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](3, null, ['Workshop Absence for ',
            ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 39, 'div', [['class', 'waf__content-wrapper']], null, null, null, null, null)), (_l()(),
            core_es5["ɵeld"](5, 0, null, null, 25, 'div', [['class', 'waf__form-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 24, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Start'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 6, 'input', [['type', 'datetime-local']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 12)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 12)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 12)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedStartDateTime($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](12, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](14, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](15, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](17, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['End'])), (_l()(), core_es5["ɵeld"](22, 0, null, null, 6, 'input', [['type', 'datetime-local']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 23)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 23)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 23)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.changedEndDateTime($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](23, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](25, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵppd"](26, 2), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](28, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopAbsenceFormComponent_1)),
        core_es5["ɵdid"](30, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](31, 0, null, null, 6, 'div', [['class', 'waf__affected-bookings-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](32, 0, null, null, 1, 'h3', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Current bookings affected by this absence'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopAbsenceFormComponent_2)),
        core_es5["ɵdid"](35, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_WorkshopAbsenceFormComponent_3)), core_es5["ɵdid"](37, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵeld"](38, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](39, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](40, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](41, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedCreate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Create']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_8 = core_es5["ɵunv"](_v, 14, 0, _ck(_v, 15, 0, core_es5["ɵnov"](_v, 0), _co.wa.startDateTime, 'yyyy-MM-ddTHH:mm'));
        _ck(_v, 14, 0, currVal_8);
        var currVal_16 = core_es5["ɵunv"](_v, 25, 0, _ck(_v, 26, 0, core_es5["ɵnov"](_v, 0), _co.wa.endDateTime, 'yyyy-MM-ddTHH:mm'));
        _ck(_v, 25, 0, currVal_16);
        var currVal_17 = (_co.replacementTutors.length > 0);
        _ck(_v, 30, 0, currVal_17);
        var currVal_18 = (_co.affectedBookings.length == 0);
        _ck(_v, 35, 0, currVal_18);
        var currVal_19 = (_co.affectedBookings.length > 0);
        _ck(_v, 37, 0, currVal_19);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.wa.contact.fullName;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = core_es5["ɵnov"](_v, 17).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 17).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 17).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 17).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 17).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 17).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 17).ngClassPending;
        _ck(_v, 11, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_9 = core_es5["ɵnov"](_v, 28).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 28).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 28).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 28).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 28).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 28).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 28).ngClassPending;
        _ck(_v, 22, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
    });
}
function View_WorkshopAbsenceFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'workshop-absence-form', [], null, null, null, View_WorkshopAbsenceFormComponent_0, RenderType_WorkshopAbsenceFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, workshop_absence_form_WorkshopAbsenceFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var WorkshopAbsenceFormComponentNgFactory = core_es5["ɵccf"]('workshop-absence-form', workshop_absence_form_WorkshopAbsenceFormComponent, View_WorkshopAbsenceFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=workshop-absence-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/booking-removal-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */





var styles_BookingRemovalFormComponent = [];
var RenderType_BookingRemovalFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_BookingRemovalFormComponent, data: {} });
function View_BookingRemovalFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 43, 'div', [['class',
                'booking-removal-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'h1', [['class',
                'brf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['Booking for ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 40, 'div', [['class', 'brf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 39, 'ul', [['class', 'brf__options']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](5, 0, null, null, 13, 'li', [['class', 'brf__option delete-and-ban']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 4, 'h3', [['class', 'brf__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Delete '])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['without'])),
        (_l()(), core_es5["ɵted"](-1, null, [' 2 week ban'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This will not cause a 2 week ban for the student and the booking will be available to be rebooked.'])),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDeleteWithoutBan() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Delete without ban'])),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 13, 'li', [['class', 'brf__option delete-and-not-ban']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 4, 'h3', [['class', 'brf__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Delete '])), (_l()(), core_es5["ɵeld"](22, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['with'])),
        (_l()(), core_es5["ɵted"](-1, null, [' 2 week ban'])), (_l()(), core_es5["ɵeld"](25, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This will cause a 2 week ban for the student and the booking will be available to be rebooked.'])),
        (_l()(), core_es5["ɵeld"](27, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](29, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDeleteWithBan() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Delete with ban'])),
        (_l()(), core_es5["ɵeld"](33, 0, null, null, 10, 'li', [['class', 'brf__option same-day-cancellation']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](34, 0, null, null, 1, 'h3', [['class', 'brf__subheader']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Perform a "Same day cancellation"'])), (_l()(),
            core_es5["ɵeld"](36, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['This will cause cause a 2 week ban for the student and the booking will not be available to be rebooked.'])),
        (_l()(), core_es5["ɵeld"](38, 0, null, null, 5, 'div', [['class', 'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](40, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](41, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](42, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSameDayCancellation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Same day cancellation']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.booking.contact.fullName;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_BookingRemovalFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'booking-removal-form', [], null, null, null, View_BookingRemovalFormComponent_0, RenderType_BookingRemovalFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, booking_removal_form_BookingRemovalFormComponent, [src_store["a" /* Store */], booking_BookingEffects, modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var BookingRemovalFormComponentNgFactory = core_es5["ɵccf"]('booking-removal-form', booking_removal_form_BookingRemovalFormComponent, View_BookingRemovalFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=booking-removal-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/set-rollover-form.ts





var SelectedNonClassOptions;
(function (SelectedNonClassOptions) {
    SelectedNonClassOptions[SelectedNonClassOptions["NONE"] = 0] = "NONE";
})(SelectedNonClassOptions || (SelectedNonClassOptions = {}));
var set_rollover_form_SetRolloverFormComponent = (function () {
    function SetRolloverFormComponent(store, actions, modalService) {
        this.store = store;
        this.actions = actions;
        this.modalService = modalService;
        this.maxPerCampus = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS;
    }
    SetRolloverFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enrolmentsSubscription = this.store.select("enrolmentsReducer").subscribe(function (s) {
            _this.enrolment = s.editableEnrolment;
            _this.classes = s.potentialClasses;
        });
        this.constantsSubscription = this.store.select("constantsReducer").subscribe(function (s) {
            _this.terms = s.constants.terms;
            _this.setRelevantTerm();
            _this.refreshAvailableClasses();
        });
        this.setInitialState();
    };
    SetRolloverFormComponent.prototype.setInitialState = function () {
        if (this.enrolment.isCancelling) {
            this.selectedItem = SelectedNonClassOptions.NONE;
        }
        else if (this.enrolment.pendingEnrolment) {
            this.selectedItem = this.enrolment.pendingEnrolment.matrixClass.id;
        }
    };
    SetRolloverFormComponent.prototype.setRelevantTerm = function () {
        var _this = this;
        var targetTerm = null;
        var currentTerm = this.terms.find(function (t) {
            return _this.enrolment.matrixClass.termId == t.id;
        });
        var sortedTerms = this.terms.slice().sort(function (ta, tb) {
            var a = new Date(ta.startDate);
            var b = new Date(tb.startDate);
            return a < b ? -1 : a > b ? 1 : 0;
        });
        var targetTermIndex = sortedTerms.indexOf(currentTerm) + 1;
        if (sortedTerms.length >= targetTermIndex - 1) {
            targetTerm = sortedTerms[targetTermIndex];
        }
        console.log(targetTerm);
        this.term = targetTerm;
    };
    SetRolloverFormComponent.prototype.refreshAvailableClasses = function () {
        if (this.term) {
            var payload = { termId: this.term.id };
            this.store.dispatch({ type: FETCH_POTENTIAL_CLASSES, payload: payload });
        }
    };
    SetRolloverFormComponent.prototype.getPotentialCssClass = function (c) {
        return c.code.toLowerCase() + " " + (this.isClassSelected(c) ? 'selected' : '');
    };
    SetRolloverFormComponent.prototype.clickedNone = function () {
        this.selectedItem = SelectedNonClassOptions.NONE;
    };
    SetRolloverFormComponent.prototype.clickedClass = function (c) {
        this.selectedItem = c.id;
    };
    SetRolloverFormComponent.prototype.clickedSetRollover = function () {
        var _this = this;
        var targetAction;
        if (this.selectedItem == SelectedNonClassOptions.NONE) {
            targetAction = "none";
        }
        else {
            // is a MatrixClass id...
            targetAction = this.selectedItem;
        }
        var payload = {
            enrolment_id: this.enrolment.id,
            target_action: targetAction
        };
        this.actions
            .ofType(SET_ROLLOVER_SUCCESS)
            .take(1)
            .subscribe(function () {
            _this.modalService.closeModal();
        });
        this.store.dispatch({ type: SET_ROLLOVER, payload: payload });
    };
    SetRolloverFormComponent.prototype.isClassSelected = function (c) {
        return this.selectedItem == c.id;
    };
    SetRolloverFormComponent.prototype.isNoneSelected = function () {
        return this.selectedItem == SelectedNonClassOptions.NONE;
    };
    SetRolloverFormComponent.prototype.getPendingEnrolments = function (mc) {
        return mc.enrolments.filter(function (n) { return n.isPending; }).length;
    };
    SetRolloverFormComponent.prototype.getActiveEnrolments = function (mc) {
        return mc.enrolments.filter(function (n) { return !n.isPending; }).length;
    };
    SetRolloverFormComponent.prototype.getTakenSpots = function (mc) {
        return this.getActiveEnrolments(mc) + this.getPendingEnrolments(mc);
    };
    SetRolloverFormComponent.prototype.ngOnDestroy = function () {
        this.enrolmentsSubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
    };
    SetRolloverFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: modal_ModalService }]; };
    return SetRolloverFormComponent;
}());

//# sourceMappingURL=set-rollover-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/set-rollover-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_SetRolloverFormComponent = [];
var RenderType_SetRolloverFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_SetRolloverFormComponent, data: {} });
function View_SetRolloverFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'srf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['There\'s no term to rollover to from ',
            '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enrolment.matrixClass.term.name;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_SetRolloverFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'li', [['class',
                'srf__potential matrix-class']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClass(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(),
            core_es5["ɵeld"](3, 0, null, null, 1, 'label', [['class', 'srf__current-enrolments']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](4, null, ['Spots taken: ', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'srf__potential matrix-class';
        var currVal_1 = _co.getPotentialCssClass(_v.context.$implicit);
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.code;
        _ck(_v, 2, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.getEffectiveEnrolmentsCount();
        _ck(_v, 4, 0, currVal_3);
    });
}
function View_SetRolloverFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 29, 'div', [['class',
                'srf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'h1', [['class',
                'srf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](2, null, ['Set rollover for ', ''])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Going from '])), (_l()(), core_es5["ɵeld"](5, 0, null, null, 1, 'label', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](6, null, ['', ''])), (_l()(), core_es5["ɵted"](-1, null, [' to '])),
        (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](9, null, ['', ''])), (_l()(), core_es5["ɵeld"](10, 0, null, null, 6, 'div', [['class', 'srf__blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Please select a specific class to roll this Enrolment over to.'])),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['The initial state of all rollovers is to be automagically set to the equivalent class in the upcoming term.'])),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Selecting "None" will mean this enrolment is not rolled over at all.'])),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 7, 'div', [['class', 'srf__potentials-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 6, 'ul', [['class', 'srf__potentials']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 3, 'li', [['class', 'srf__potential none']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedNone() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](20, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](21, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['None'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetRolloverFormComponent_3)), core_es5["ɵdid"](24, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](25, 0, null, null, 4, 'div', [['class', 'srf__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](26, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](27, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](28, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSetRollover() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Set rollover']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = 'srf__potential none';
        var currVal_4 = _ck(_v, 21, 0, _co.isNoneSelected());
        _ck(_v, 20, 0, currVal_3, currVal_4);
        var currVal_5 = _co.classes;
        _ck(_v, 24, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enrolment.matrixClass.code;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.enrolment.matrixClass.term.name;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.term.name;
        _ck(_v, 9, 0, currVal_2);
    });
}
function View_SetRolloverFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'div', [['class',
                'set-rollover-form']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetRolloverFormComponent_1)), core_es5["ɵdid"](2, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_SetRolloverFormComponent_2)), core_es5["ɵdid"](4, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.term;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = _co.term;
        _ck(_v, 4, 0, currVal_1);
    }, null);
}
function View_SetRolloverFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'set-rollover-form', [], null, null, null, View_SetRolloverFormComponent_0, RenderType_SetRolloverFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, set_rollover_form_SetRolloverFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SetRolloverFormComponentNgFactory = core_es5["ɵccf"]('set-rollover-form', set_rollover_form_SetRolloverFormComponent, View_SetRolloverFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=set-rollover-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/change-class-form.ts




var change_class_form_ChangeClassFormComponent = (function () {
    function ChangeClassFormComponent(store, actions, modalService) {
        this.store = store;
        this.actions = actions;
        this.modalService = modalService;
    }
    ChangeClassFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enrolmentsSubscription =
            this.store.select("enrolmentsReducer").subscribe(function (s) {
                _this.enrolment = s.editableEnrolment;
                _this.potentialClasses = s.potentialClasses;
            });
        this.setAvailableClasses();
        this.setInitialState();
    };
    ChangeClassFormComponent.prototype.setAvailableClasses = function () {
        var payload = {
            termId: this.enrolment.matrixClass.termId,
            courseId: this.enrolment.matrixClass.courseId
        };
        this.store.dispatch({ type: FETCH_POTENTIAL_CLASSES, payload: payload });
    };
    ChangeClassFormComponent.prototype.setInitialState = function () {
        return this.selectedClassId == this.enrolment.matrixClassId;
    };
    ChangeClassFormComponent.prototype.getFilteredPotentialClasses = function () {
        var _this = this;
        return this.potentialClasses.filter(function (mc) {
            return mc.id != _this.enrolment.matrixClassId;
        });
    };
    ChangeClassFormComponent.prototype.clickedClass = function (mc) {
        this.selectedClassId = mc.id;
    };
    ChangeClassFormComponent.prototype.clickedChangeClass = function () {
        var _this = this;
        var payload = {
            enrolment_id: this.enrolment.id,
            matrix_class_id: this.selectedClassId
        };
        this.actions
            .ofType(CHANGE_CLASS_ON_ENROLMENT_SUCCESS, CHANGE_CLASS_ON_ENROLMENT_FAILURE)
            .take(1)
            .subscribe(function (a) {
            if (a.type == CHANGE_CLASS_ON_ENROLMENT_SUCCESS) {
                _this.modalService.closeModal();
            }
        });
        this.store.dispatch({ type: CHANGE_CLASS_ON_ENROLMENT, payload: payload });
    };
    ChangeClassFormComponent.prototype.getPendingEnrolments = function (mc) {
        return mc.enrolments.filter(function (n) { return n.isPending; }).length;
    };
    ChangeClassFormComponent.prototype.getActiveEnrolments = function (mc) {
        return mc.enrolments.filter(function (n) { return !n.isPending; }).length;
    };
    ChangeClassFormComponent.prototype.isClassSelected = function (mc) {
        return this.selectedClassId == mc.id;
    };
    ChangeClassFormComponent.prototype.ngOnDestroy = function () {
        this.enrolmentsSubscription.unsubscribe();
    };
    ChangeClassFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: src_actions["a" /* Actions */] }, { type: modal_ModalService }]; };
    return ChangeClassFormComponent;
}());

//# sourceMappingURL=change-class-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/change-class-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_ChangeClassFormComponent = [];
var RenderType_ChangeClassFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ChangeClassFormComponent, data: {} });
function View_ChangeClassFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'li', [['class',
                'ccf__potential']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedClass(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'label', [['class',
                'ccf__current-enrolments']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['Spots taken: ', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'ccf__potential';
        var currVal_1 = _ck(_v, 2, 0, _co.isClassSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.code;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = _v.context.$implicit.getEffectiveEnrolmentsCount();
        _ck(_v, 5, 0, currVal_3);
    });
}
function View_ChangeClassFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'div', [['class',
                'change-class-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 13, 'div', [['class',
                'ccf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'ccf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Change class'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'div', [['class', 'ccf__blurb']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select a Class to switch this Enrolment to...'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 3, 'div', [['class', 'ccf__potentials-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'ul', [['class', 'ccf__potentials']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ChangeClassFormComponent_1)),
        core_es5["ɵdid"](9, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](10, 0, null, null, 4, 'div', [['class', 'ccf__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 3, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](12, 0, null, null, 2, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedChangeClass() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Change class']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getFilteredPotentialClasses();
        _ck(_v, 9, 0, currVal_0);
    }, null);
}
function View_ChangeClassFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'change-class-form', [], null, null, null, View_ChangeClassFormComponent_0, RenderType_ChangeClassFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, change_class_form_ChangeClassFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ChangeClassFormComponentNgFactory = core_es5["ɵccf"]('change-class-form', change_class_form_ChangeClassFormComponent, View_ChangeClassFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9jaGFuZ2UtY2xhc3MtZm9ybS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvY2hhbmdlLWNsYXNzLWZvcm0udHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvY2hhbmdlLWNsYXNzLWZvcm0ucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2NoYW5nZS1jbGFzcy1mb3JtLnRzLkNoYW5nZUNsYXNzRm9ybUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjaGFuZ2UtY2xhc3MtZm9ybVwiPjxkaXYgY2xhc3M9XCJjY2ZfX2NvbnRlbnQtd3JhcHBlclwiPjxoMSBjbGFzcz1cImNjZl9faGVhZGVyXCI+Q2hhbmdlIGNsYXNzPC9oMT48ZGl2IGNsYXNzPVwiY2NmX19ibHVyYlwiPlNlbGVjdCBhIENsYXNzIHRvIHN3aXRjaCB0aGlzIEVucm9sbWVudCB0by4uLjwvZGl2PjxkaXYgY2xhc3M9XCJjY2ZfX3BvdGVudGlhbHMtd3JhcHBlclwiPjx1bCBjbGFzcz1cImNjZl9fcG90ZW50aWFsc1wiPjxsaSBjbGFzcz1cImNjZl9fcG90ZW50aWFsXCIgKm5nRm9yPVwibGV0IGMgb2YgZ2V0RmlsdGVyZWRQb3RlbnRpYWxDbGFzc2VzKClcIiAoY2xpY2spPVwiY2xpY2tlZENsYXNzKGMpXCIgW25nQ2xhc3NdPVwieyAnc2VsZWN0ZWQnOiBpc0NsYXNzU2VsZWN0ZWQoYykgfVwiPnt7IGMuY29kZSB9fTxsYWJlbCBjbGFzcz1cImNjZl9fY3VycmVudC1lbnJvbG1lbnRzXCI+U3BvdHMgdGFrZW46IHt7IGMuZ2V0RWZmZWN0aXZlRW5yb2xtZW50c0NvdW50KCkgfX08L2xhYmVsPjwvbGk+PC91bD48L2Rpdj48ZGl2IGNsYXNzPVwiY2NmX19hY3Rpb25zXCI+PGRpdiBjbGFzcz1cImlucHV0LWdyb3VwXCI+PGRpdiBjbGFzcz1cImlnX19jb250ZW50LXdyYXBwZXJcIj48YnV0dG9uIChjbGljayk9XCJjbGlja2VkQ2hhbmdlQ2xhc3MoKVwiPkNoYW5nZSBjbGFzczwvYnV0dG9uPjwvZGl2PjwvZGl2PjwvZGl2PjwvZGl2PjwvZGl2PiIsIjxjaGFuZ2UtY2xhc3MtZm9ybT48L2NoYW5nZS1jbGFzcy1mb3JtPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBc1A7TUFBQTtJQUFBO0lBQUE7SUFBMkU7TUFBQTtNQUFBO0lBQUE7SUFBM0U7RUFBQSx1Q0FBQTtrREFBQTtNQUFBLGtDQUFxRyxtQkFBK0M7TUFBQSxVQUFZO01BQUE7TUFBQSxnQkFBdUM7OztJQUFuTTtJQUFpRztJQUFyRyxXQUFJLFVBQWlHLFNBQXJHOztJQUFvSjtJQUFBO0lBQW1EO0lBQUE7Ozs7b0JBQTdiO01BQUE7TUFBQSxnQkFBK0I7TUFBQTtNQUFBLGdCQUFrQztNQUFBO01BQXdCLG9EQUFpQjtVQUFBO1VBQUEsNENBQXdCO1VBQUEsb0RBQW1EO1VBQUE7VUFBQTtNQUFxQztVQUFBO01BQTRCO2FBQUE7NEJBQUEseUNBQWlSO1VBQUE7VUFBQSwwREFBMEI7VUFBQTtVQUFBLDBEQUF5QjtVQUFBO1VBQUE7TUFBaUM7VUFBQTtZQUFBO1lBQUE7WUFBUTtjQUFBO2NBQUE7WUFBQTtZQUFSO1VBQUEsZ0NBQXVDOzs7UUFBalg7UUFBM0IsV0FBMkIsU0FBM0I7Ozs7b0JDQXRQO01BQUE7eUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=change-class-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/disenrolment-form.ts





var disenrolment_form_DisenrolmentFormComponent = (function () {
    function DisenrolmentFormComponent(store, actions, modalService) {
        this.store = store;
        this.actions = actions;
        this.modalService = modalService;
        this.numOfClassesArray = [];
        this.numOfClasses = 0;
        this.numOfClassesToRefund = 0;
        this.selectedReason = null;
        var i = 0;
        while (i < NUMBER_OF_CLASSES_PER_TERM) {
            var target = i + 1;
            this.numOfClassesArray.push(target);
            i += 1;
        }
    }
    DisenrolmentFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enrolmentsSubscription =
            this.store.select("enrolmentsReducer").subscribe(function (s) {
                _this.enrolment = s.editableEnrolment;
            });
        this.setInitialState();
    };
    DisenrolmentFormComponent.prototype.getAmountToRefund = function () {
        return this.enrolment.matrixClass.course.cost / this.numOfClassesArray.length * this.numOfClassesToRefund;
    };
    DisenrolmentFormComponent.prototype.setInitialState = function () {
        // TODO: Calculate this from how many weeks we are into the term.
        this.numOfClassesToRefund = 9;
    };
    DisenrolmentFormComponent.prototype.getStyleForSliderPoint = function (i) {
        return { 'left': 100 / (this.numOfClassesArray.length - 1) * i + "%" };
    };
    DisenrolmentFormComponent.prototype.getStyleForSliderBarHighlight = function () {
        return { 'width': 100 / (this.numOfClassesArray.length - 1) * (this.numOfClassesToRefund - 1) + "%" };
    };
    DisenrolmentFormComponent.prototype.setReasonTo = function (reason) {
        this.selectedReason = reason;
    };
    DisenrolmentFormComponent.prototype.isReasonSelected = function (reason) {
        return this.selectedReason == reason;
    };
    DisenrolmentFormComponent.prototype.clickedSliderPoint = function (i) {
        this.numOfClassesToRefund = this.numOfClassesArray.length - i;
    };
    DisenrolmentFormComponent.prototype.clickedDisenrol = function () {
        var _this = this;
        var payload = {
            enrolment_id: this.enrolment.id,
            refund_amount: this.getAmountToRefund(),
            reason: this.selectedReason,
        };
        this.actions
            .ofType(PERFORM_DISENROLMENT_SUCCESS)
            .take(1)
            .subscribe(function () { return _this.modalService.closeModal(); });
        this.store.dispatch({ type: PERFORM_DISENROLMENT, payload: payload });
    };
    DisenrolmentFormComponent.prototype.ngOnDestroy = function () {
        this.enrolmentsSubscription.unsubscribe();
    };
    DisenrolmentFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: modal_ModalService }]; };
    return DisenrolmentFormComponent;
}());

//# sourceMappingURL=disenrolment-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/disenrolment-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */






var styles_DisenrolmentFormComponent = [];
var RenderType_DisenrolmentFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_DisenrolmentFormComponent, data: {} });
function View_DisenrolmentFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'li', [['class',
                's__point']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSliderPoint(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"],
            core_es5["ElementRef"], core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getStyleForSliderPoint(_v.context.index);
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_DisenrolmentFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](2, 0, null, null, 82, 'div', [['class',
                'disenrolment-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 81, 'div', [['class',
                'df__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'h1', [['class',
                'df__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](5, null, ['Disenrolment for ', ''])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 71, 'div', [['class', 'df__form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](7, 0, null, null, 7, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 6, 'div', [['class', 'input-group full end-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](9, 0, null, null, 5, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](11, null, ['', ''])), core_es5["ɵppd"](12, 2), (_l()(), core_es5["ɵeld"](13, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['End date of original term (check Calendar for effective end date including extra days)'])),
        (_l()(), core_es5["ɵeld"](15, 0, null, null, 14, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 13, 'div', [['class', 'input-group full number-of-classes']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](17, 0, null, null, 12, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](18, 0, null, null, 7, 'div', [['class', 'slider']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](19, 0, null, null, 6, 'div', [['class', 's__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](20, 0, null, null, 5, 'div', [['class', 's__bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'div', [['class', 's__bar-highlight']], null, null, null, null, null)),
        core_es5["ɵdid"](22, 278528, null, 0, common_es5["NgStyle"], [core_es5["KeyValueDiffers"], core_es5["ElementRef"],
            core_es5["Renderer"]], { ngStyle: [0, 'ngStyle'] }, null), (_l()(), core_es5["ɵeld"](23, 0, null, null, 2, 'ul', [['class', 's__points']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DisenrolmentFormComponent_1)),
        core_es5["ɵdid"](25, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](26, 0, null, null, 3, 'label', [['for', 'number-of-periods']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Number of classes to refund: '])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](29, null, ['', ''])),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](31, 0, null, null, 5, 'div', [['class', 'input-group full amount']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](32, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](33, null, ['', ''])), core_es5["ɵppd"](34, 4), (_l()(), core_es5["ɵeld"](35, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Amount to refund'])),
        (_l()(), core_es5["ɵeld"](37, 0, null, null, 40, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](38, 0, null, null, 39, 'div', [['class', 'input-group full reason']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Reason for disenrolment'])), (_l()(), core_es5["ɵeld"](41, 0, null, null, 36, 'ul', [['class', 'df__reasons two-column']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('price') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](43, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](44, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Price'])), (_l()(), core_es5["ɵeld"](46, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('location') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](47, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](48, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Location'])), (_l()(), core_es5["ɵeld"](50, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('class') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](51, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](52, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Class'])), (_l()(), core_es5["ɵeld"](54, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('teacher') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](55, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](56, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Teacher'])), (_l()(), core_es5["ɵeld"](58, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('courseRelevancy') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](59, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](60, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Course relevancy'])), (_l()(), core_es5["ɵeld"](62, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('tooBusy') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](63, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](64, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Too busy'])), (_l()(), core_es5["ɵeld"](66, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('droppedSubject') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](67, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](68, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Dropped subject'])), (_l()(), core_es5["ɵeld"](70, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('workshop') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](71, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](72, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Workshop'])), (_l()(), core_es5["ɵeld"](74, 0, null, null, 3, 'li', [['class', 'df__reason']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.setReasonTo('resources') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](75, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](76, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['Resources'])), (_l()(), core_es5["ɵeld"](78, 0, null, null, 6, 'div', [['class', 'df__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](79, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](80, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](81, 0, null, null, 3, 'button', [], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDisenrol() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](82, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](83, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Disenrol']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.getStyleForSliderBarHighlight();
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = _co.numOfClassesArray;
        _ck(_v, 25, 0, currVal_3);
        var currVal_6 = 'df__reason';
        var currVal_7 = _ck(_v, 44, 0, _co.isReasonSelected('price'));
        _ck(_v, 43, 0, currVal_6, currVal_7);
        var currVal_8 = 'df__reason';
        var currVal_9 = _ck(_v, 48, 0, _co.isReasonSelected('location'));
        _ck(_v, 47, 0, currVal_8, currVal_9);
        var currVal_10 = 'df__reason';
        var currVal_11 = _ck(_v, 52, 0, _co.isReasonSelected('class'));
        _ck(_v, 51, 0, currVal_10, currVal_11);
        var currVal_12 = 'df__reason';
        var currVal_13 = _ck(_v, 56, 0, _co.isReasonSelected('teacher'));
        _ck(_v, 55, 0, currVal_12, currVal_13);
        var currVal_14 = 'df__reason';
        var currVal_15 = _ck(_v, 60, 0, _co.isReasonSelected('courseRelevancy'));
        _ck(_v, 59, 0, currVal_14, currVal_15);
        var currVal_16 = 'df__reason';
        var currVal_17 = _ck(_v, 64, 0, _co.isReasonSelected('tooBusy'));
        _ck(_v, 63, 0, currVal_16, currVal_17);
        var currVal_18 = 'df__reason';
        var currVal_19 = _ck(_v, 68, 0, _co.isReasonSelected('droppedSubject'));
        _ck(_v, 67, 0, currVal_18, currVal_19);
        var currVal_20 = 'df__reason';
        var currVal_21 = _ck(_v, 72, 0, _co.isReasonSelected('workshop'));
        _ck(_v, 71, 0, currVal_20, currVal_21);
        var currVal_22 = 'df__reason';
        var currVal_23 = _ck(_v, 76, 0, _co.isReasonSelected('resources'));
        _ck(_v, 75, 0, currVal_22, currVal_23);
        var currVal_25 = _ck(_v, 83, 0, !_co.selectedReason);
        _ck(_v, 82, 0, currVal_25);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.enrolment.matrixClass.code;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = core_es5["ɵunv"](_v, 11, 0, _ck(_v, 12, 0, core_es5["ɵnov"](_v, 0), _co.enrolment.matrixClass.term.endDate, 'shortDate'));
        _ck(_v, 11, 0, currVal_1);
        var currVal_4 = _co.numOfClassesToRefund;
        _ck(_v, 29, 0, currVal_4);
        var currVal_5 = core_es5["ɵunv"](_v, 33, 0, _ck(_v, 34, 0, core_es5["ɵnov"](_v, 1), _co.getAmountToRefund(), 'USD', true, '1.2-2'));
        _ck(_v, 33, 0, currVal_5);
        var currVal_24 = !_co.selectedReason;
        _ck(_v, 81, 0, currVal_24);
    });
}
function View_DisenrolmentFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'disenrolment-form', [], null, null, null, View_DisenrolmentFormComponent_0, RenderType_DisenrolmentFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, disenrolment_form_DisenrolmentFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DisenrolmentFormComponentNgFactory = core_es5["ɵccf"]('disenrolment-form', disenrolment_form_DisenrolmentFormComponent, View_DisenrolmentFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=disenrolment-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/transaction-cycle-metadata.ts
var transaction_cycle_metadata___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TransactionCycleMetadata = (function (_super) {
    transaction_cycle_metadata___extends(TransactionCycleMetadata, _super);
    function TransactionCycleMetadata(cycleTransactionType, originalAmountToRecover, amountProcessedSince, rootTransactionDescription, isDisenroled) {
        if (cycleTransactionType === void 0) { cycleTransactionType = null; }
        if (originalAmountToRecover === void 0) { originalAmountToRecover = null; }
        if (amountProcessedSince === void 0) { amountProcessedSince = null; }
        if (rootTransactionDescription === void 0) { rootTransactionDescription = null; }
        if (isDisenroled === void 0) { isDisenroled = false; }
        var _this = _super.call(this) || this;
        _this.cycleTransactionType = cycleTransactionType;
        _this.originalAmountToRecover = originalAmountToRecover;
        _this.amountProcessedSince = amountProcessedSince;
        _this.rootTransactionDescription = rootTransactionDescription;
        _this.isDisenroled = isDisenroled;
        return _this;
    }
    TransactionCycleMetadata.clone = function (obj) {
        var t = new this();
        if (obj.cycleTransactionType) {
            t.cycleTransactionType = obj.cycleTransactionType;
        }
        if (obj.originalAmountToRecover != undefined) {
            t.originalAmountToRecover = obj.originalAmountToRecover;
        }
        if (obj.amountProcessedSince != undefined) {
            t.amountProcessedSince = obj.amountProcessedSince;
        }
        if (obj.rootTransactionDescription) {
            t.rootTransactionDescription = obj.rootTransactionDescription;
        }
        if (obj.isDisenroled) {
            t.isDisenroled = obj.isDisenroled;
        }
        return t;
    };
    return TransactionCycleMetadata;
}(Model));

//# sourceMappingURL=transaction-cycle-metadata.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/transaction.ts
var transaction___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var transaction_Transaction = (function (_super) {
    transaction___extends(Transaction, _super);
    function Transaction(id, studentId, debtorId, enrolmentId, discountId, parentId, description, amount, transactionType, paymentType, transactionDate, paymentReference, status, statusMessage, processedAt, parent, debtor, cycleMetadata, isMenuOpen, isChecked, createdAt, updatedAt) {
        if (description === void 0) { description = null; }
        if (amount === void 0) { amount = 0; }
        if (transactionType === void 0) { transactionType = 0; }
        if (paymentType === void 0) { paymentType = null; }
        if (transactionDate === void 0) { transactionDate = null; }
        if (paymentReference === void 0) { paymentReference = null; }
        if (status === void 0) { status = 0; }
        if (statusMessage === void 0) { statusMessage = null; }
        if (processedAt === void 0) { processedAt = null; }
        if (parent === void 0) { parent = null; }
        if (debtor === void 0) { debtor = null; }
        if (cycleMetadata === void 0) { cycleMetadata = null; }
        if (isMenuOpen === void 0) { isMenuOpen = false; }
        if (isChecked === void 0) { isChecked = false; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.studentId = studentId;
        _this.debtorId = debtorId;
        _this.enrolmentId = enrolmentId;
        _this.discountId = discountId;
        _this.parentId = parentId;
        _this.description = description;
        _this.amount = amount;
        _this.transactionType = transactionType;
        _this.paymentType = paymentType;
        _this.transactionDate = transactionDate;
        _this.paymentReference = paymentReference;
        _this.status = status;
        _this.statusMessage = statusMessage;
        _this.processedAt = processedAt;
        _this.parent = parent;
        _this.debtor = debtor;
        _this.cycleMetadata = cycleMetadata;
        _this.isMenuOpen = isMenuOpen;
        _this.isChecked = isChecked;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    Transaction.clone = function (obj) {
        var t = new this();
        if (obj.id) {
            t.id = obj.id;
        }
        if (obj.studentId) {
            t.studentId = obj.studentId;
        }
        if (obj.debtorId) {
            t.debtorId = obj.debtorId;
        }
        if (obj.enrolmentId) {
            t.enrolmentId = obj.enrolmentId;
        }
        if (obj.discountId) {
            t.discountId = obj.discountId;
        }
        if (obj.parentId) {
            t.parentId = obj.parentId;
        }
        if (obj.description) {
            t.description = obj.description;
        }
        if (obj.amount) {
            t.amount = parseFloat(obj.amount);
        }
        if (obj.transactionType) {
            t.transactionType = obj.transactionType;
        }
        if (obj.paymentType) {
            t.paymentType = obj.paymentType;
        }
        if (obj.transactionDate) {
            t.transactionDate = Utilities.makeDate(obj.transactionDate);
        }
        if (obj.paymentReference) {
            t.paymentReference = obj.paymentReference;
        }
        if (obj.status) {
            t.status = obj.status;
        }
        if (obj.statusMessage) {
            t.statusMessage = obj.statusMessage;
        }
        if (obj.processedAt) {
            t.processedAt = new Date(obj.processedAt);
        }
        if (obj.parent) {
            t.parent = Transaction.clone(obj.parent);
        }
        if (obj.debtor) {
            t.debtor = contact_Contact.clone(obj.debtor);
        }
        if (obj.cycleMetadata) {
            t.cycleMetadata = TransactionCycleMetadata.clone(obj.cycleMetadata);
        }
        if (obj.createdAt) {
            t.createdAt = new Date(obj.createdAt);
        }
        if (obj.updatedAt) {
            t.updatedAt = new Date(obj.updatedAt);
        }
        return t;
    };
    Transaction.prototype.serializeForRails = function () {
        var response = Object.assign({}, this);
        if (this.id === 0) {
            response.id = null;
        }
        return response;
    };
    return Transaction;
}(Model));

//# sourceMappingURL=transaction.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/constants/transactions.ts
var TRANSACTION_TYPES = [
    { title: "Direct Debit", value: 0 },
    { title: "Enrolment Fee", value: 1 },
    { title: "Late Fee", value: 2 },
    { title: "Custom", value: 3 },
    { title: "Record Payment", value: 4 },
    { title: "Record Credit", value: 5 },
    { title: "Waive", value: 6 },
    { title: "Refund", value: 7 },
    { title: "Transfer", value: 8 },
    { title: "Record Other Payment", value: 9 },
    { title: "Discount", value: 10 },
];
var PAYMENT_TYPES = [
    { title: "Direct Debit", value: 0 },
    { title: "Other Payment", value: 1 },
    { title: "Do Not Charge", value: 2 },
    { title: "Discount", value: 3 },
];
var TRANSACTION_STATUSES = [
    { title: "Unattempted", value: 0 },
    { title: "Failure", value: 1 },
    { title: "Success", value: 2 },
    { title: "Moved To Next Installment", value: 3 },
];
var DISCOUNT_REMOVE_TYPE = [
    { title: "Undo", value: 0 },
    { title: "Terminate", value: 1 },
];
//# sourceMappingURL=transactions.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/create-transaction-form.ts








var create_transaction_form_CreateTransactionFormComponent = (function () {
    function CreateTransactionFormComponent(store, actions, completerService, modalService) {
        this.store = store;
        this.actions = actions;
        this.completerService = completerService;
        this.modalService = modalService;
        this.transaction = new transaction_Transaction();
        this.potentialTransactions = [];
        this.preselectedTransaction = null;
        this.amount = 0;
        this.transferTransactionParams = {};
        this.isLoading = false;
    }
    CreateTransactionFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.transactionsSubscription =
            this.store.select("transactionsReducer")
                .subscribe(function (s) {
                _this.debtor = s.activeDebtor;
                _this.potentialTransactions = s.potentialTransactions;
                _this.preselectedTransaction = s.activeTransaction;
            });
        var feeTypes = TRANSACTION_TYPES.filter(function (t) { return [1, 2, 3].includes(t.value); });
        this.feeTypesCompleter =
            this.completerService.local(feeTypes, "title", "title");
        this.setInitialState();
    };
    CreateTransactionFormComponent.prototype.setInitialState = function () {
        this.transaction.debtorId = this.debtor.id;
        this.transaction.transactionDate = new Date();
        this.transactionDateInputStr =
            Utilities.getDateInInputStringFormat(this.transaction.transactionDate);
        switch (this.recordType) {
            case 'fee':
                this.transaction.studentId = this.debtor.students[0].id;
                this.transaction.paymentType =
                    PAYMENT_TYPES.find(function (t) { return t.title == "Direct Debit"; }).value;
                break;
            case 'payment':
                this.transaction.transactionType =
                    TRANSACTION_TYPES.find(function (t) { return t.title == "Record Payment"; }).value;
                this.transaction.paymentType =
                    PAYMENT_TYPES.find(function (t) { return t.title == "Direct Debit"; }).value;
                this.fetchPotentialTransactions();
                break;
            case 'credit':
                this.transaction.transactionType =
                    TRANSACTION_TYPES.find(function (t) { return t.title == "Record Credit"; }).value;
                this.fetchPotentialTransactions();
                break;
            case 'waive':
                this.transaction.transactionType =
                    TRANSACTION_TYPES.find(function (t) { return t.title == "Waive"; }).value;
                this.transaction.amount = this.preselectedTransaction.amount;
                this.transaction.parentId = this.preselectedTransaction.id;
                break;
            case 'refund':
                this.transaction.transactionType =
                    TRANSACTION_TYPES.find(function (t) { return t.title == "Refund"; }).value;
                this.transaction.amount = this.preselectedTransaction.amount * -1;
                this.transaction.parentId = this.preselectedTransaction.id;
                break;
            case 'transfer':
                this.transaction.transactionType =
                    TRANSACTION_TYPES.find(function (t) { return t.title == "Transfer"; }).value;
                this.transaction.amount = this.preselectedTransaction.amount * -1;
                this.transferTransactionParams.amount = this.preselectedTransaction.amount * -1;
                this.transferTransactionParams.from_tx_id = this.preselectedTransaction.id;
                this.fetchPotentialTransactions();
                break;
            case 'record-other-payment':
                this.transaction.amount = this.preselectedTransaction.amount * -1;
                this.transaction.parentId = this.preselectedTransaction.id;
                break;
        }
    };
    CreateTransactionFormComponent.prototype.fetchPotentialTransactions = function () {
        var payload = {
            debtor_id: this.debtor.id,
            has_owing: true,
        };
        this.store.dispatch({ type: FETCH_POTENTIAL_TRANSACTIONS, payload: payload });
    };
    CreateTransactionFormComponent.prototype.getPaymentTypes = function () {
        var _this = this;
        return PAYMENT_TYPES.filter(function (pt) {
            switch (_this.recordType) {
                case 'fee':
                    return [0, 1, 2].includes(pt.value);
                case 'payment':
                    return [0, 1].includes(pt.value);
                default:
                    return [];
            }
        });
    };
    CreateTransactionFormComponent.prototype.selectedFeeType = function (e) {
        if (e) {
            var v = parseInt(e.originalObject.value);
            this.transaction.transactionType = v;
            switch (v) {
                case 1:
                    this.setDescriptionForEnrolmentFee();
                    this.transaction.amount = 55;
                    break;
                case 2:
                    this.transaction.description = "Late Fee";
                    this.transaction.amount = 55;
                    break;
                case 3:
                    this.transaction.description = "Custom Fee";
                    this.transaction.amount = 0;
                    break;
                default:
                    this.transaction.description = null;
                    this.transaction.amount = 0;
                    break;
            }
        }
        else {
            this.transaction.paymentType = null;
            this.transaction.description = null;
            this.transaction.amount = 0;
        }
    };
    CreateTransactionFormComponent.prototype.setDescriptionForEnrolmentFee = function () {
        var _this = this;
        var s = this.debtor.students.find(function (s) {
            return s.id == _this.transaction.studentId;
        });
        this.transaction.description = "Enrolment Fee (" + s.fullName + ")";
    };
    CreateTransactionFormComponent.prototype.selectedTransactionDate = function (dateString) {
        this.transaction.transactionDate = new Date(dateString);
    };
    CreateTransactionFormComponent.prototype.isStudentSelected = function (student) {
        return this.transaction.studentId == student.id;
    };
    CreateTransactionFormComponent.prototype.isPaymentTypeSelected = function (pt) {
        return this.transaction.paymentType == pt.value;
    };
    CreateTransactionFormComponent.prototype.isPotentialTransactionSelected = function (t) {
        return this.transaction.parentId == t.id ||
            this.transferTransactionParams.to_tx_id == t.id;
    };
    CreateTransactionFormComponent.prototype.isPaymentReferenceVisible = function () {
        return this.transaction.paymentType == PAYMENT_TYPES.find(function (pt) {
            return pt.title == 'Other Payment';
        }).value;
    };
    CreateTransactionFormComponent.prototype.changedAmount = function (e) {
        if (this.recordType == 'transfer') {
            this.transferTransactionParams.amount = e;
        }
    };
    CreateTransactionFormComponent.prototype.clickedStudent = function (student) {
        this.transaction.studentId = student.id;
        if (this.recordType == 'fee') {
            this.setDescriptionForEnrolmentFee();
        }
    };
    CreateTransactionFormComponent.prototype.clickedPaymentType = function (pt) {
        this.transaction.paymentType = pt.value;
        if (pt != PAYMENT_TYPES.find(function (pt) { return pt.title == 'Other Payment'; })) {
            this.transaction.paymentReference = null;
        }
    };
    CreateTransactionFormComponent.prototype.clickedPotentialTransaction = function (t) {
        if (this.recordType == 'transfer') {
            this.transferTransactionParams.to_tx_id = t.id;
        }
        else {
            this.transaction.parentId = t.id;
            this.transaction.amount = t.amount;
        }
    };
    CreateTransactionFormComponent.prototype.isFormSectionVisible = function (section) {
        switch (section) {
            case 'fee-type':
                return ['fee'].includes(this.recordType);
            case 'student':
                return ['fee'].includes(this.recordType);
            case 'transactions':
                return ['payment', 'credit', 'transfer'].includes(this.recordType);
            case 'description':
                return ['fee', 'credit'].includes(this.recordType);
            case 'amount':
                return ['fee', 'payment', 'credit', 'waive', 'refund', 'transfer', 'record-other-payment'].includes(this.recordType);
            case 'date':
                return ['fee', 'payment', 'credit'].includes(this.recordType);
            case 'payment-type':
                return ['fee', 'payment'].includes(this.recordType);
            case 'standalone-payment-reference':
                return ['record-other-payment'].includes(this.recordType);
            default:
                return false;
        }
    };
    CreateTransactionFormComponent.prototype.isFormValid = function () {
        var e = this.potentialTransactions.find(function (t) { return t.id == t.parentId; });
        var t = this.transaction;
        var r = true;
        switch (this.recordType) {
            case 'fee':
                if (![1, 2, 3].includes(t.transactionType)) {
                    r = false;
                }
                if (!t.description) {
                    r = false;
                }
                break;
            case 'payment':
                if (e && t.amount > e.amount) {
                    r = false;
                }
                if (!t.parentId) {
                    r = false;
                }
                if (!t.amount) {
                    r = false;
                }
                break;
            case 'credit':
                if (e && t.amount > e.amount) {
                    r = false;
                }
                if (!t.amount) {
                    r = false;
                }
                if (!t.parentId) {
                    r = false;
                }
                if (!t.description) {
                    r = false;
                }
                break;
            case 'waive':
                if (!t.amount) {
                    r = false;
                }
                if (t.amount > this.preselectedTransaction.amount) {
                    r = false;
                }
                break;
            case 'refund':
                if (!t.amount) {
                    r = false;
                }
                if (t.amount > this.preselectedTransaction.amount * -1) {
                    r = false;
                }
                break;
            case 'transfer':
                if (!this.transferTransactionParams.from_tx_id) {
                    r = false;
                }
                if (!this.transferTransactionParams.to_tx_id) {
                    r = false;
                }
                if (!this.transferTransactionParams.amount) {
                    r = false;
                }
                if (this.transferTransactionParams.amount > this.preselectedTransaction.amount * -1) {
                    r = false;
                }
                break;
            case 'record-other-payment':
                if (!t.amount) {
                    r = false;
                }
                if (t.amount > this.preselectedTransaction.amount * -1) {
                    r = false;
                }
                if (!t.paymentReference) {
                    r = false;
                }
                if (!t.parentId) {
                    r = false;
                }
                break;
        }
        if (t.paymentType == PAYMENT_TYPES.find(function (pt) { return pt.title == "Other Payment"; }).value
            && !t.paymentReference) {
            r = false;
        }
        return r;
    };
    CreateTransactionFormComponent.prototype.submitForm = function () {
        var _this = this;
        var callback = function () {
            _this.isLoading = false;
            _this.modalService.closeModal();
        };
        switch (this.recordType) {
            case 'transfer':
                this.actions
                    .ofType(CREATED_TRANSACTION_TRANSFER)
                    .take(1)
                    .subscribe(function (a) { callback(); });
                this.isLoading = true;
                this.store.dispatch({ type: CREATE_TRANSACTION_TRANSFER, payload: this.transferTransactionParams });
                break;
            case 'record-other-payment':
                this.actions
                    .ofType(RECORDED_OTHER_PAYMENT)
                    .take(1)
                    .subscribe(function (a) { callback(); });
                this.isLoading = true;
                this.store.dispatch({ type: RECORD_OTHER_PAYMENT, payload: this.transaction });
                break;
            default:
                this.actions
                    .ofType(CREATED_TRANSACTION)
                    .take(1)
                    .subscribe(function (a) { callback(); });
                this.isLoading = true;
                this.store.dispatch({ type: CREATE_TRANSACTION, payload: this.transaction });
                break;
        }
    };
    CreateTransactionFormComponent.prototype.ngOnDestroy = function () {
        this.transactionsSubscription.unsubscribe();
    };
    CreateTransactionFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: modal_ModalService }]; };
    return CreateTransactionFormComponent;
}());

//# sourceMappingURL=create-transaction-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/create-transaction-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_CreateTransactionFormComponent = [];
var RenderType_CreateTransactionFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CreateTransactionFormComponent, data: {} });
function View_CreateTransactionFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['class',
                'ctf__form-section fee-type']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'ng2-completer', [['id', 'fee-type'],
            ['name', 'fee-type']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.feeTypeSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedFeeType($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](5, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { minSearchLength: [0, 'minSearchLength'], openOnFocus: [1, 'openOnFocus'], datasource: [2,
                'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'label', [['for', 'fee-type']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Fee type']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = 0;
        var currVal_8 = true;
        var currVal_9 = _co.feeTypesCompleter;
        _ck(_v, 5, 0, currVal_7, currVal_8, currVal_9);
        var currVal_10 = 'fee-type';
        var currVal_11 = _co.feeTypeSearchStr;
        _ck(_v, 7, 0, currVal_10, currVal_11);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['class',
                'ctf__warning no-potential-transactions']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['No potential transactions']))], null, null);
}
function View_CreateTransactionFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 6, 'li', [['class',
                'ctf__option potential-transaction']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPotentialTransaction(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0,
                'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }),
        (_l()(), core_es5["ɵted"](3, null, ['', ''])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](5, null, ['', ''])),
        core_es5["ɵppd"](6, 4)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'ctf__option potential-transaction';
        var currVal_1 = _ck(_v, 2, 0, _co.isPotentialTransactionSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.description;
        _ck(_v, 3, 0, currVal_2);
        var currVal_3 = core_es5["ɵunv"](_v, 5, 0, _ck(_v, 6, 0, core_es5["ɵnov"](_v.parent.parent.parent, 0), _v.context.$implicit.amount, 'USD', true, '1.2-2'));
        _ck(_v, 5, 0, currVal_3);
    });
}
function View_CreateTransactionFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'ul', [['class',
                'ctf__options potential-transactions']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_5)), core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.potentialTransactions;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CreateTransactionFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'ctf__form-section transactions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 7, 'div', [['class',
                'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Target transaction'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_3)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_4)), core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.potentialTransactions.length == 0);
        _ck(_v, 7, 0, currVal_0);
        var currVal_1 = (_co.potentialTransactions.length > 0);
        _ck(_v, 9, 0, currVal_1);
    }, null);
}
function View_CreateTransactionFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'li', [['class',
                'ctf__option student']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedStudent(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'ctf__option student';
        var currVal_1 = _ck(_v, 2, 0, _co.isStudentSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.fullName;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_CreateTransactionFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'div', [['class',
                'ctf__form-section student']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'div', [['class', 'input-group full']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Select student'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 2, 'ul', [['class', 'ctf__options students']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_7)), core_es5["ɵdid"](8, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.debtor.students;
        _ck(_v, 8, 0, currVal_0);
    }, null);
}
function View_CreateTransactionFormComponent_9(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group half description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'input', [['type',
                'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.transaction.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Description']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.transaction.description;
        _ck(_v, 5, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_10(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'input-group half description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 9, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'input', [['type',
                'number']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend'], [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 4).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 4).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.transaction.amount = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_8 = (_co.changedAmount($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵdid"](4, 16384, null, 0, forms_es5["ɵbc"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["ɵbc"]]), core_es5["ɵdid"](6, 671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Amount ($)']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.transaction.amount;
        _ck(_v, 6, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, 'div', [['class',
                'ctf__form-section description-and-amount']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 4, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_9)), core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_10)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFormSectionVisible('description');
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.isFormSectionVisible('amount');
        _ck(_v, 5, 0, currVal_1);
    }, null);
}
function View_CreateTransactionFormComponent_12(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'input-group half description']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'input', [['type',
                'date']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2,
                'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'input'], [null, 'blur'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.selectedTransactionDate($event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](3, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](5, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](8, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Transaction Date']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.transactionDateInputStr;
        _ck(_v, 5, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 7).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 7).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 7).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 7).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 7).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 7).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_11(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [['class',
                'ctf__form-section date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 2, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_12)),
        core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFormSectionVisible('date');
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
function View_CreateTransactionFormComponent_14(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'li', [['class',
                'ctf__optionpayment-type']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPaymentType(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'ctf__optionpayment-type';
        var currVal_1 = _ck(_v, 2, 0, _co.isPaymentTypeSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.title;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_CreateTransactionFormComponent_15(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 9, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'input', [['id', 'payment-reference'],
            ['type', 'text']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.transaction.paymentReference = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](6, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](8, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 1, 'label', [['for', 'payment-reference']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Payment reference']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.transaction.paymentReference;
        _ck(_v, 6, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 8).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 8).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 8).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 8).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 8).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 8).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 8).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_13(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 10, 'div', [['class',
                'ctf__form-section payment-type']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'div', [['class',
                'input-group full']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 5, 'div', [['class',
                'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Charge type'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 2, 'ul', [['class', 'ctf__options payment-types']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_14)),
        core_es5["ɵdid"](8, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_15)),
        core_es5["ɵdid"](10, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getPaymentTypes();
        _ck(_v, 8, 0, currVal_0);
        var currVal_1 = _co.isPaymentReferenceVisible();
        _ck(_v, 10, 0, currVal_1);
    }, null);
}
function View_CreateTransactionFormComponent_16(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['class',
                'ctf__form-section standalone-payment-reference']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 9, 'div', [['class', 'input-group half']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 5, 'input', [['id', 'stadnalone-payment-reference'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.transaction.paymentReference = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null),
        core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'label', [['for', 'payment-reference']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Payment reference']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.transaction.paymentReference;
        _ck(_v, 7, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_CreateTransactionFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](1, 0, null, null, 23, 'div', [['class', 'create-transaction-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 22, 'div', [['class', 'ctf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 14, 'div', [['class', 'form']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_1)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_2)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_6)),
        core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_8)), core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_11)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_13)), core_es5["ɵdid"](15, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionFormComponent_16)),
        core_es5["ɵdid"](17, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](18, 0, null, null, 6, 'div', [['class', 'ctf__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](21, 0, null, null, 3, 'button', [], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.submitForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](22, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](23, { 'disabled': 0, 'loading': 1 }), (_l()(),
            core_es5["ɵted"](-1, null, ['Submit']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.isFormSectionVisible('fee-type');
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.isFormSectionVisible('transactions');
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.isFormSectionVisible('student');
        _ck(_v, 9, 0, currVal_2);
        var currVal_3 = (_co.isFormSectionVisible('description') || _co.isFormSectionVisible('amount'));
        _ck(_v, 11, 0, currVal_3);
        var currVal_4 = _co.isFormSectionVisible('date');
        _ck(_v, 13, 0, currVal_4);
        var currVal_5 = _co.isFormSectionVisible('payment-type');
        _ck(_v, 15, 0, currVal_5);
        var currVal_6 = _co.isFormSectionVisible('standalone-payment-reference');
        _ck(_v, 17, 0, currVal_6);
        var currVal_8 = _ck(_v, 23, 0, !_co.isFormValid(), _co.isLoading);
        _ck(_v, 22, 0, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = !_co.isFormValid();
        _ck(_v, 21, 0, currVal_7);
    });
}
function View_CreateTransactionFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'create-transaction-form', [], null, null, null, View_CreateTransactionFormComponent_0, RenderType_CreateTransactionFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, create_transaction_form_CreateTransactionFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], completer_service["a" /* CompleterService */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CreateTransactionFormComponentNgFactory = core_es5["ɵccf"]('create-transaction-form', create_transaction_form_CreateTransactionFormComponent, View_CreateTransactionFormComponent_Host_0, { recordType: 'recordType' }, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=create-transaction-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/create-transaction-view.ts

var create_transaction_view_CreateTransactionViewComponent = (function () {
    function CreateTransactionViewComponent(store) {
        this.store = store;
        this.recordTypeOfTransaction = null;
    }
    CreateTransactionViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.transactionSubscription =
            this.store.select("transactionsReducer")
                .subscribe(function (s) {
                _this.debtor = s.activeDebtor;
            });
    };
    CreateTransactionViewComponent.prototype.clickedSelectTypeOfTransaction = function (targetType) {
        this.recordTypeOfTransaction = targetType;
    };
    CreateTransactionViewComponent.prototype.clickedBackToTransactionTypeSelection = function () {
        this.recordTypeOfTransaction = null;
    };
    CreateTransactionViewComponent.prototype.isTypeSelected = function (targetType) {
        return this.recordTypeOfTransaction == targetType;
    };
    CreateTransactionViewComponent.prototype.isBackButtonVisible = function () {
        return ["payment", "credit", "fee"].includes(this.recordTypeOfTransaction);
    };
    CreateTransactionViewComponent.prototype.ngOnDestroy = function () {
        this.transactionSubscription.unsubscribe();
    };
    CreateTransactionViewComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }]; };
    return CreateTransactionViewComponent;
}());

//# sourceMappingURL=create-transaction-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/create-transaction-view.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_CreateTransactionViewComponent = [];
var RenderType_CreateTransactionViewComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_CreateTransactionViewComponent, data: {} });
function View_CreateTransactionViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'button', [['class',
                'tiny ctv__back']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedBackToTransactionTypeSelection() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Back to select type...']))], null, null);
}
function View_CreateTransactionViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](1, null, [' (', ')'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionViewComponent_2)), core_es5["ɵdid"](3, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.isBackButtonVisible();
        _ck(_v, 3, 0, currVal_1);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.recordTypeOfTransaction;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_CreateTransactionViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 16, 'div', [['class',
                'ctv__record-options-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 15, 'ul', [['class',
                'ctv__record-options']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 4, 'li', [['class',
                'ctv__record-option fee']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSelectTypeOfTransaction('fee') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](4, 0, null, null, 0, 'span', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['Record Fee'])), (_l()(), core_es5["ɵted"](-1, null, ['For recording a new receivable amount'])),
        (_l()(), core_es5["ɵeld"](7, 0, null, null, 4, 'li', [['class', 'ctv__record-option payment']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSelectTypeOfTransaction('payment') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 2, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 0, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Record Payment'])), (_l()(), core_es5["ɵted"](-1, null, ['For recording a new received payment'])), (_l()(), core_es5["ɵeld"](12, 0, null, null, 4, 'li', [['class', 'ctv__record-option credit']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSelectTypeOfTransaction('credit') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵeld"](13, 0, null, null, 2, 'h2', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](14, 0, null, null, 0, 'span', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Record Credit'])), (_l()(), core_es5["ɵted"](-1, null, ['Fore recording a new creditable amount']))], null, null);
}
function View_CreateTransactionViewComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'ctv__form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'create-transaction-form', [], null, null, null, View_CreateTransactionFormComponent_0, RenderType_CreateTransactionFormComponent)), core_es5["ɵdid"](2, 245760, null, 0, create_transaction_form_CreateTransactionFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], completer_service["a" /* CompleterService */],
            modal_ModalService], { recordType: [0, 'recordType'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.recordTypeOfTransaction;
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_CreateTransactionViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['class',
                'create-transaction-view']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 8, 'div', [['class',
                'ctv__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 3, 'h1', [['class',
                'ctv__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Record Transaction'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionViewComponent_1)),
        core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionViewComponent_3)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_CreateTransactionViewComponent_4)), core_es5["ɵdid"](9, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.recordTypeOfTransaction;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = !_co.recordTypeOfTransaction;
        _ck(_v, 7, 0, currVal_1);
        var currVal_2 = _co.recordTypeOfTransaction;
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
function View_CreateTransactionViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'create-transaction-view', [], null, null, null, View_CreateTransactionViewComponent_0, RenderType_CreateTransactionViewComponent)), core_es5["ɵdid"](1, 245760, null, 0, create_transaction_view_CreateTransactionViewComponent, [src_store["a" /* Store */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var CreateTransactionViewComponentNgFactory = core_es5["ɵccf"]('create-transaction-view', create_transaction_view_CreateTransactionViewComponent, View_CreateTransactionViewComponent_Host_0, { recordTypeOfTransaction: 'recordTypeOfTransaction' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9jcmVhdGUtdHJhbnNhY3Rpb24tdmlldy5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvY3JlYXRlLXRyYW5zYWN0aW9uLXZpZXcudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvY3JlYXRlLXRyYW5zYWN0aW9uLXZpZXcucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2NyZWF0ZS10cmFuc2FjdGlvbi12aWV3LnRzLkNyZWF0ZVRyYW5zYWN0aW9uVmlld0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjcmVhdGUtdHJhbnNhY3Rpb24tdmlld1wiPjxkaXYgY2xhc3M9XCJjdHZfX2NvbnRlbnQtd3JhcHBlclwiPjxoMSBjbGFzcz1cImN0dl9faGVhZGVyXCI+UmVjb3JkIFRyYW5zYWN0aW9uPG5nLWNvbnRhaW5lciAqbmdJZj1cInJlY29yZFR5cGVPZlRyYW5zYWN0aW9uXCI+ICh7eyByZWNvcmRUeXBlT2ZUcmFuc2FjdGlvbiB9fSk8YnV0dG9uIGNsYXNzPVwidGlueSBjdHZfX2JhY2tcIiAoY2xpY2spPVwiY2xpY2tlZEJhY2tUb1RyYW5zYWN0aW9uVHlwZVNlbGVjdGlvbigpXCIgKm5nSWY9XCJpc0JhY2tCdXR0b25WaXNpYmxlKClcIj5CYWNrIHRvIHNlbGVjdCB0eXBlLi4uPC9idXR0b24+PC9uZy1jb250YWluZXI+PC9oMT48ZGl2IGNsYXNzPVwiY3R2X19yZWNvcmQtb3B0aW9ucy13cmFwcGVyXCIgKm5nSWY9XCIhcmVjb3JkVHlwZU9mVHJhbnNhY3Rpb25cIj48dWwgY2xhc3M9XCJjdHZfX3JlY29yZC1vcHRpb25zXCI+PGxpIGNsYXNzPVwiY3R2X19yZWNvcmQtb3B0aW9uIGZlZVwiIChjbGljayk9XCJjbGlja2VkU2VsZWN0VHlwZU9mVHJhbnNhY3Rpb24oJ2ZlZScpXCI+PGgyPjxzcGFuPjwvc3Bhbj5SZWNvcmQgRmVlPC9oMj5Gb3IgcmVjb3JkaW5nIGEgbmV3IHJlY2VpdmFibGUgYW1vdW50PC9saT48bGkgY2xhc3M9XCJjdHZfX3JlY29yZC1vcHRpb24gcGF5bWVudFwiIChjbGljayk9XCJjbGlja2VkU2VsZWN0VHlwZU9mVHJhbnNhY3Rpb24oJ3BheW1lbnQnKVwiPjxoMj48c3Bhbj48L3NwYW4+UmVjb3JkIFBheW1lbnQ8L2gyPkZvciByZWNvcmRpbmcgYSBuZXcgcmVjZWl2ZWQgcGF5bWVudDwvbGk+PGxpIGNsYXNzPVwiY3R2X19yZWNvcmQtb3B0aW9uIGNyZWRpdFwiIChjbGljayk9XCJjbGlja2VkU2VsZWN0VHlwZU9mVHJhbnNhY3Rpb24oJ2NyZWRpdCcpXCI+PGgyPjxzcGFuPjwvc3Bhbj5SZWNvcmQgQ3JlZGl0PC9oMj5Gb3JlIHJlY29yZGluZyBhIG5ldyBjcmVkaXRhYmxlIGFtb3VudDwvbGk+PC91bD48L2Rpdj48ZGl2IGNsYXNzPVwiY3R2X19mb3JtXCIgKm5nSWY9XCJyZWNvcmRUeXBlT2ZUcmFuc2FjdGlvblwiPjxjcmVhdGUtdHJhbnNhY3Rpb24tZm9ybSBbcmVjb3JkVHlwZV09XCJyZWNvcmRUeXBlT2ZUcmFuc2FjdGlvblwiPjwvY3JlYXRlLXRyYW5zYWN0aW9uLWZvcm0+PC9kaXY+PC9kaXY+PC9kaXY+IiwiPGNyZWF0ZS10cmFuc2FjdGlvbi12aWV3PjwvY3JlYXRlLXRyYW5zYWN0aW9uLXZpZXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0ErTDtNQUFBO0lBQUE7SUFBQTtJQUErQjtNQUFBO01BQUE7SUFBQTtJQUEvQjtFQUFBLGdDQUErRzs7OztvQkFBN0w7TUFBQTtNQUE4Qyw2Q0FBZ0M7VUFBQSw2RUFBQTtVQUFBO2NBQUE7OztJQUFpRjtJQUFqRixXQUFpRixTQUFqRjs7O0lBQWhDO0lBQUE7Ozs7b0JBQWtNO01BQUE7TUFBQSxnQkFBMEU7TUFBQTtNQUFBLGdCQUFnQztNQUFBO0lBQUE7SUFBQTtJQUFtQztNQUFBO01BQUE7SUFBQTtJQUFuQztFQUFBLGdDQUFtRjtNQUFBO01BQUEsZ0JBQUk7TUFBQSx3RUFBYTthQUFBLG1DQUFlO01BQTBDO1VBQUE7WUFBQTtZQUFBO1lBQXVDO2NBQUE7Y0FBQTtZQUFBO1lBQXZDO1VBQUEsZ0NBQTJGO1VBQUE7VUFBQSxnQkFBSTtVQUFBO01BQWEsc0RBQW1CO1VBQUEsMkNBQXlDO1VBQUE7VUFBQTtZQUFBO1lBQUE7WUFBc0M7Y0FBQTtjQUFBO1lBQUE7WUFBdEM7VUFBQSxnQ0FBeUY7VUFBQTtVQUFBLGdCQUFJO1VBQUE7TUFBYSxxREFBa0I7VUFBQTs7O29CQUFzRDtNQUFBO01BQXVEO1VBQUE7c0RBQUEsVUFBQTtVQUFBOzZCQUFBOzs7SUFBeUI7SUFBekIsV0FBeUIsU0FBekI7Ozs7b0JBQXovQjtNQUFBO01BQUEsZ0JBQXFDO01BQUE7TUFBQSxnQkFBa0M7TUFBQTtNQUF3QiwwREFBa0I7VUFBQTthQUFBO1VBQUEsaUNBQWdQO1VBQUEsNkVBQUE7VUFBQTtjQUFBLHdCQUFpbUI7VUFBQSwrREFBQTtVQUFBO1VBQUE7O0lBQW4wQjtJQUFkLFdBQWMsU0FBZDtJQUF5UjtJQUF6QyxXQUF5QyxTQUF6QztJQUF3bkI7SUFBdkIsV0FBdUIsU0FBdkI7Ozs7b0JDQWw4QjtNQUFBOytDQUFBLFVBQUE7d0NBQUE7O0lBQUE7Ozs7OyJ9
//# sourceMappingURL=create-transaction-view.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/add-discount-form.ts






var add_discount_form_AddDiscountFormComponent = (function () {
    function AddDiscountFormComponent(store, actions, modalService) {
        this.store = store;
        this.actions = actions;
        this.modalService = modalService;
    }
    AddDiscountFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.contactsSubscription =
            this.store.select("contactsReducer")
                .subscribe(function (s) {
                _this.student = s.activeContact;
            });
        this.constantsSubscription =
            this.store.select("constantsReducer")
                .subscribe(function (s) {
                _this.discountTypes = s.constants.discountTypes;
                _this.campuses = s.constants.campuses;
            });
        this.setupInitialState();
    };
    AddDiscountFormComponent.prototype.setupInitialState = function () {
        var endDate = moment(new Date()).add(9, "weeks").toDate();
        this.transactionDateStr =
            Utilities.getDateInInputStringFormat(new Date());
        this.startDateStr =
            Utilities.getDateInInputStringFormat(new Date());
        this.endDateStr =
            Utilities.getDateInInputStringFormat(endDate);
        this.params = {
            studentId: this.student.id,
            discountType: this.discountTypes[0].discountType,
            transactionDate: new Date(),
            startDate: new Date(),
            endDate: endDate,
            fixedAmount: 0,
        };
    };
    AddDiscountFormComponent.prototype.getCampus = function (id) {
        return this.campuses.find(function (c) { return c.id == id; });
    };
    AddDiscountFormComponent.prototype.clickedDiscountType = function (dt) {
        this.params.discountType = dt.discountType;
        this.params.fixedAmount = 0;
    };
    AddDiscountFormComponent.prototype.setDate = function (target, dateStr) {
        this.params[target] = new Date(dateStr);
    };
    AddDiscountFormComponent.prototype.isDiscountTypeSelected = function (dt) {
        return this.params.discountType == dt.discountType;
    };
    AddDiscountFormComponent.prototype.isFixedDiscountSelected = function () {
        var fixedDt = this.discountTypes.find(function (dt) {
            return dt.description == "Fixed Discount";
        });
        return this.params.discountType == fixedDt.discountType;
    };
    AddDiscountFormComponent.prototype.isFormValid = function () {
        var result = true;
        if (this.isFixedDiscountSelected() && this.params.fixedAmount <= 0) {
            result = false;
        }
        if (this.params.startDate > this.params.endDate) {
            result = false;
        }
        return result;
    };
    AddDiscountFormComponent.prototype.clickedSubmit = function () {
        var _this = this;
        if (this.isFormValid()) {
            this.actions
                .ofType(APPLIED_DISCOUNT)
                .take(1)
                .subscribe(function () { return _this.modalService.closeModal(); });
            this.store.dispatch({ type: APPLY_DISCOUNT, payload: this.params });
        }
    };
    AddDiscountFormComponent.prototype.ngOnDestroy = function () {
        this.contactsSubscription.unsubscribe();
        this.constantsSubscription.unsubscribe();
    };
    AddDiscountFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: modal_ModalService }]; };
    return AddDiscountFormComponent;
}());

//# sourceMappingURL=add-discount-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/add-discount-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_AddDiscountFormComponent = [];
var RenderType_AddDiscountFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_AddDiscountFormComponent, data: {} });
function View_AddDiscountFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'adf__type-attr multiplier']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '% ']))], null, function (_ck, _v) {
        var currVal_0 = (_v.parent.context.$implicit.multiplier * 100);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AddDiscountFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'span', [['class',
                'adf__type-attr campus']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['(', ')']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getCampus(_v.parent.context.$implicit.campusId).name;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AddDiscountFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'li', [['class',
                'adf__type']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedDiscountType(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵted"](3, null, ['', ' '])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AddDiscountFormComponent_2)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AddDiscountFormComponent_3)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'adf__type';
        var currVal_1 = _ck(_v, 2, 0, _co.isDiscountTypeSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_3 = _v.context.$implicit.multiplier;
        _ck(_v, 5, 0, currVal_3);
        var currVal_4 = _v.context.$implicit.campusId;
        _ck(_v, 7, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.description;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_AddDiscountFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['class',
                'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 10, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 9, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 6, 'input', [['id', 'fixed-amount'],
            ['type', 'number']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend'],
            [null, 'change']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 5).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (('input' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 5).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.params.fixedAmount = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](4, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵdid"](5, 16384, null, 0, forms_es5["ɵbc"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [forms_es5["DefaultValueAccessor"], forms_es5["ɵbc"]]), core_es5["ɵdid"](7, 671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](9, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(), core_es5["ɵeld"](10, 0, null, null, 1, 'label', [['for', 'fixed-amount']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Fixed amount']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.params.fixedAmount;
        _ck(_v, 7, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 9).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 9).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 9).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 9).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 9).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 9).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 9).ngClassPending;
        _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
function View_AddDiscountFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 46, 'div', [['class',
                'add-discount-form']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](1, 0, null, null, 45, 'div', [['class',
                'adf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'h1', [['class',
                'adf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Add discount'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 2, 'ul', [['class', 'adf__types two-column']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AddDiscountFormComponent_1)), core_es5["ɵdid"](6, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](7, 0, null, null, 30, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](8, 0, null, null, 9, 'div', [['class', 'input-group start-date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](10, 0, null, null, 5, 'input', [['id', 'start-date'],
            ['type', 'date']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 11)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 11)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 11)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.setDate('startDate', $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](11, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](13, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](15, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](16, 0, null, null, 1, 'label', [['for', 'start-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Start date'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 9, 'div', [['class', 'input-group end-date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](19, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](20, 0, null, null, 5, 'input', [['id', 'end-date'], ['type', 'date']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 21)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 21).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 21)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 21)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.setDate('endDate', $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](21, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](23, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](25, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](26, 0, null, null, 1, 'label', [['for', 'end-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['End date'])), (_l()(), core_es5["ɵeld"](28, 0, null, null, 9, 'div', [['class', 'input-group transaction-date']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](29, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 5, 'input', [['id', 'transaction-date'],
            ['type', 'date']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null, 'input'], [null,
                'blur'], [null, 'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = (_co.setDate('transactionDate', $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](31, 16384, null, 0, forms_es5["DefaultValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["COMPOSITION_BUFFER_MODE"]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["DefaultValueAccessor"]]), core_es5["ɵdid"](33, 671744, null, 0, forms_es5["NgModel"], [[8,
                null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](35, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](36, 0, null, null, 1, 'label', [['for', 'transaction-date']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Transaction date'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AddDiscountFormComponent_4)),
        core_es5["ɵdid"](39, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](40, 0, null, null, 6, 'div', [['class', 'adf__actions']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](41, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](42, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](43, 0, null, null, 3, 'button', [], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedSubmit() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](44, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](45, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Apply discount']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.discountTypes;
        _ck(_v, 6, 0, currVal_0);
        var currVal_8 = _co.startDateStr;
        _ck(_v, 13, 0, currVal_8);
        var currVal_16 = _co.endDateStr;
        _ck(_v, 23, 0, currVal_16);
        var currVal_24 = _co.transactionDateStr;
        _ck(_v, 33, 0, currVal_24);
        var currVal_25 = _co.isFixedDiscountSelected();
        _ck(_v, 39, 0, currVal_25);
        var currVal_27 = _ck(_v, 45, 0, !_co.isFormValid());
        _ck(_v, 44, 0, currVal_27);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = core_es5["ɵnov"](_v, 15).ngClassUntouched;
        var currVal_2 = core_es5["ɵnov"](_v, 15).ngClassTouched;
        var currVal_3 = core_es5["ɵnov"](_v, 15).ngClassPristine;
        var currVal_4 = core_es5["ɵnov"](_v, 15).ngClassDirty;
        var currVal_5 = core_es5["ɵnov"](_v, 15).ngClassValid;
        var currVal_6 = core_es5["ɵnov"](_v, 15).ngClassInvalid;
        var currVal_7 = core_es5["ɵnov"](_v, 15).ngClassPending;
        _ck(_v, 10, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7);
        var currVal_9 = core_es5["ɵnov"](_v, 25).ngClassUntouched;
        var currVal_10 = core_es5["ɵnov"](_v, 25).ngClassTouched;
        var currVal_11 = core_es5["ɵnov"](_v, 25).ngClassPristine;
        var currVal_12 = core_es5["ɵnov"](_v, 25).ngClassDirty;
        var currVal_13 = core_es5["ɵnov"](_v, 25).ngClassValid;
        var currVal_14 = core_es5["ɵnov"](_v, 25).ngClassInvalid;
        var currVal_15 = core_es5["ɵnov"](_v, 25).ngClassPending;
        _ck(_v, 20, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15);
        var currVal_17 = core_es5["ɵnov"](_v, 35).ngClassUntouched;
        var currVal_18 = core_es5["ɵnov"](_v, 35).ngClassTouched;
        var currVal_19 = core_es5["ɵnov"](_v, 35).ngClassPristine;
        var currVal_20 = core_es5["ɵnov"](_v, 35).ngClassDirty;
        var currVal_21 = core_es5["ɵnov"](_v, 35).ngClassValid;
        var currVal_22 = core_es5["ɵnov"](_v, 35).ngClassInvalid;
        var currVal_23 = core_es5["ɵnov"](_v, 35).ngClassPending;
        _ck(_v, 30, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23);
        var currVal_26 = !_co.isFormValid();
        _ck(_v, 43, 0, currVal_26);
    });
}
function View_AddDiscountFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'add-discount-form', [], null, null, null, View_AddDiscountFormComponent_0, RenderType_AddDiscountFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, add_discount_form_AddDiscountFormComponent, [src_store["a" /* Store */], src_actions["a" /* Actions */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AddDiscountFormComponentNgFactory = core_es5["ɵccf"]('add-discount-form', add_discount_form_AddDiscountFormComponent, View_AddDiscountFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=add-discount-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/ticket-form.ts









var ticket_form_TicketFormComponent = (function () {
    function TicketFormComponent(store, completerService, actions, http, modalService) {
        this.store = store;
        this.completerService = completerService;
        this.actions = actions;
        this.http = http;
        this.modalService = modalService;
        this.contactsUrl = "api/v1/contacts?contact_type=0&has_debtor_with_cc=true&name=";
        this.students = [];
        this.totalPrice = 0;
        this.loading = false;
    }
    TicketFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventsSubscription = this.store.select("eventsReducer")
            .subscribe(function (s) {
            _this.event = s.activeEvent;
            _this.errors = s.errors;
            _this.loading = s.loading;
        });
        this.studentsCompleter =
            this.completerService.remote(this.contactsUrl, "email", "email");
        this.studentsCompleter.requestOptions(new http_es5["i" /* RequestOptions */]({
            headers: this.http.currentAuthHeaders,
        }));
        this.params = {
            ticket_allocation_ids: [],
            student_id: null,
            skip_payment: false,
        };
    };
    TicketFormComponent.prototype.fetchPotentialStudents = function () {
        var payload = {
            contact_type: 0,
            has_debtor_with_cc: true,
        };
        this.store.dispatch({ type: FETCH_CONTACTS, payload: payload });
    };
    TicketFormComponent.prototype.selectedStudent = function (e) {
        if (e && e.originalObject) {
            var student = contact_Contact.clone(e.originalObject);
            this.params.student_id = student.id;
        }
        else {
            this.params.student_id = null;
        }
    };
    TicketFormComponent.prototype.isTicketAllocationSelected = function (ta) {
        return this.params.ticket_allocation_ids.includes(ta.id);
    };
    TicketFormComponent.prototype.clickedTicketAllocation = function (ta) {
        var isPresent = this.params.ticket_allocation_ids.includes(ta.id);
        if (isPresent) {
            this.params.ticket_allocation_ids =
                this.params.ticket_allocation_ids.filter(function (n) { return n != ta.id; });
        }
        else {
            this.params.ticket_allocation_ids.push(ta.id);
        }
        this.setPrice();
    };
    TicketFormComponent.prototype.setPrice = function () {
        var _this = this;
        var tas = this.event.ticketAllocations.filter(function (ta) { return _this.params.ticket_allocation_ids.includes(ta.id); });
        this.totalPrice = tas.map(function (ta) { return ta.price; }).reduce(function (n, p) { return n + p; }, 0);
    };
    TicketFormComponent.prototype.isFormValid = function () {
        return this.params.student_id && (this.params.ticket_allocation_ids.length > 0);
    };
    TicketFormComponent.prototype.clickedPurchase = function () {
        var _this = this;
        this.actions
            .ofType(PURCHASED_TICKET_AS_STAFF)
            .take(1)
            .subscribe(function (a) {
            _this.store.dispatch({ type: CLEAR_EVENT_ERRORS });
            switch (a.type) {
                case PURCHASED_TICKET_AS_STAFF: {
                    _this.modalService.closeModal();
                    break;
                }
                case PURCHASE_TICKET_AS_STAFF_FAILURE: {
                    break;
                }
            }
        });
        this.store.dispatch({ type: PURCHASE_TICKET_AS_STAFF, payload: this.params });
    };
    TicketFormComponent.prototype.getKeys = function (errors) { return Object.keys(errors); };
    TicketFormComponent.prototype.ngOnDestroy = function () {
        this.eventsSubscription.unsubscribe();
    };
    TicketFormComponent.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: ng2_completer["a" /* CompleterService */] }, { type: effects["a" /* Actions */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: modal_ModalService }]; };
    return TicketFormComponent;
}());

//# sourceMappingURL=ticket-form.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/ticket-form.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_TicketFormComponent = [];
var RenderType_TicketFormComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_TicketFormComponent, data: {} });
function View_TicketFormComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'dd', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](1, null, [' ', '']))], null, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_TicketFormComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'dt', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](2, null, ['', ''])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_4)), core_es5["ɵdid"](4, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0,
                'ngForOf'] }, null), (_l()(), core_es5["ɵand"](0, null, null, 0))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.errors[_v.parent.context.$implicit][_v.context.$implicit];
        _ck(_v, 4, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_0 = _v.context.$implicit;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_TicketFormComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'dl', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_3)),
        core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors[_v.context.$implicit]);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TicketFormComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'div', [['class',
                'tf__server-errors']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_2)), core_es5["ɵdid"](2, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getKeys(_co.errors);
        _ck(_v, 2, 0, currVal_0);
    }, null);
}
function View_TicketFormComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['From'])), (_l()(), core_es5["ɵted"](3, null, ['\n(', ')\n', ''])),
        core_es5["ɵppd"](4, 2), core_es5["ɵppd"](5, 2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, core_es5["ɵnov"](_v.parent.parent, 1), _v.parent.context.$implicit.startDateTime, 'EEEE'));
        var currVal_1 = core_es5["ɵunv"](_v, 3, 1, _ck(_v, 5, 0, core_es5["ɵnov"](_v.parent.parent, 1), _v.parent.context.$implicit.startDateTime, 'medium'));
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_TicketFormComponent_7(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Until'])), (_l()(), core_es5["ɵted"](3, null, ['\n(', ')\n', ''])),
        core_es5["ɵppd"](4, 2), core_es5["ɵppd"](5, 2)], null, function (_ck, _v) {
        var currVal_0 = core_es5["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, core_es5["ɵnov"](_v.parent.parent, 1), _v.parent.context.$implicit.endDateTime, 'EEEE'));
        var currVal_1 = core_es5["ɵunv"](_v, 3, 1, _ck(_v, 5, 0, core_es5["ɵnov"](_v.parent.parent, 1), _v.parent.context.$implicit.endDateTime, 'medium'));
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_TicketFormComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 14, 'li', [['class',
                'tf__ticket-allocation']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedTicketAllocation(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"],
            core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1,
                'ngClass'] }, null), core_es5["ɵpod"](2, { 'selected': 0 }), (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](4, null, ['', ''])), (_l()(),
            core_es5["ɵeld"](5, 0, null, null, 2, 'span', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](6, null, ['', ''])), core_es5["ɵppd"](7, 4), (_l()(), core_es5["ɵeld"](8, 0, null, null, 6, 'ul', [], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](9, 0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_6)),
        core_es5["ɵdid"](11, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_7)), core_es5["ɵdid"](13, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](14, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'tf__ticket-allocation';
        var currVal_1 = _ck(_v, 2, 0, _co.isTicketAllocationSelected(_v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_4 = _v.context.$implicit.startDateTime;
        _ck(_v, 11, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.endDateTime;
        _ck(_v, 13, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = (_v.context.$implicit.title || _co.event.title);
        _ck(_v, 4, 0, currVal_2);
        var currVal_3 = core_es5["ɵunv"](_v, 6, 0, _ck(_v, 7, 0, core_es5["ɵnov"](_v.parent, 0), _v.context.$implicit.price, 'USD', true, '1.2-2'));
        _ck(_v, 6, 0, currVal_3);
        var currVal_6 = _v.context.$implicit.whenDisplay;
        _ck(_v, 14, 0, currVal_6);
    });
}
function View_TicketFormComponent_8(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 7, 'div', [['class',
                'actions']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](1, 0, null, null, 6, 'div', [['class', 'input-row']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'div', [['class', 'input-group']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 4, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](4, 0, null, null, 3, 'button', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.clickedPurchase() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](5, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { ngClass: [0,
                'ngClass'] }, null), core_es5["ɵpod"](6, { 'disabled': 0 }), (_l()(), core_es5["ɵted"](-1, null, ['Purchase ticket']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 6, 0, _co.loading);
        _ck(_v, 5, 0, currVal_0);
    }, null);
}
function View_TicketFormComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵpid"](0, common_es5["CurrencyPipe"], [core_es5["LOCALE_ID"]]), core_es5["ɵpid"](0, common_es5["DatePipe"], [core_es5["LOCALE_ID"]]), (_l()(), core_es5["ɵeld"](2, 0, null, null, 31, 'div', [['class',
                'ticket-form']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](3, 0, null, null, 2, 'h1', [['class', 'tf__header']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](4, null, ['Register for event: Total price:\n', ''])),
        core_es5["ɵppd"](5, 4), (_l()(), core_es5["ɵeld"](6, 0, null, null, 27, 'div', [['class',
                'tf__content-wrapper']], null, null, null, null, null)), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_1)), core_es5["ɵdid"](8, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵeld"](9, 0, null, null, 9, 'div', [['class', 'input-row']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](10, 0, null, null, 8, 'div', [['class', 'input-group students']], null, null, null, null, null)), (_l()(), core_es5["ɵeld"](11, 0, null, null, 5, 'ng2-completer', [['id', 'students'], ['name', 'student']], [[2,
                'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'selected']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.studentsSearchStr = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
                var pd_1 = (_co.selectedStudent($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, completer_cmp_ngfactory["b" /* View_CompleterCmp_0 */], completer_cmp_ngfactory["a" /* RenderType_CompleterCmp */])), core_es5["ɵdid"](12, 12697600, null, 0, completer_cmp["a" /* CompleterCmp */], [completer_service["a" /* CompleterService */], core_es5["ChangeDetectorRef"]], { pause: [0, 'pause'], minSearchLength: [1, 'minSearchLength'], openOnFocus: [2,
                'openOnFocus'], datasource: [3, 'datasource'] }, { selected: 'selected' }), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [completer_cmp["a" /* CompleterCmp */]]), core_es5["ɵdid"](14, 671744, null, 0, forms_es5["NgModel"], [[8, null],
            [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](16, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null), (_l()(),
            core_es5["ɵeld"](17, 0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Student (with a card holding guardian)'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 2, 'ul', [['class', 'tf__ticket-allocations']], null, null, null, null, null)),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_5)),
        core_es5["ɵdid"](21, 802816, null, 0, common_es5["NgForOf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵeld"](22, 0, null, null, 9, 'div', [['class', 'input-group checkbox']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](23, 0, null, null, 8, 'div', [['class', 'ig__content-wrapper']], null, null, null, null, null)),
        (_l()(), core_es5["ɵeld"](24, 0, null, null, 5, 'input', [['id', 'skip-payment'],
            ['name', 'skipPayment'], ['type', 'checkbox']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'change'], [null, 'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 25).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 25).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.params.skip_payment = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](25, 16384, null, 0, forms_es5["CheckboxControlValueAccessor"], [core_es5["Renderer2"], core_es5["ElementRef"]], null, null), core_es5["ɵprd"](1024, null, forms_es5["NG_VALUE_ACCESSOR"], function (p0_0) {
            return [p0_0];
        }, [forms_es5["CheckboxControlValueAccessor"]]), core_es5["ɵdid"](27, 671744, null, 0, forms_es5["NgModel"], [[8, null], [8, null], [8, null], [2, forms_es5["NG_VALUE_ACCESSOR"]]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["NgControl"], null, [forms_es5["NgModel"]]), core_es5["ɵdid"](29, 16384, null, 0, forms_es5["NgControlStatus"], [forms_es5["NgControl"]], null, null),
        (_l()(), core_es5["ɵeld"](30, 0, null, null, 1, 'label', [['for', 'skip-payment']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Skip credit card charge?'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_TicketFormComponent_8)),
        core_es5["ɵdid"](33, 16384, null, 0, common_es5["NgIf"], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.errors;
        _ck(_v, 8, 0, currVal_1);
        var currVal_9 = 500;
        var currVal_10 = 0;
        var currVal_11 = true;
        var currVal_12 = _co.studentsCompleter;
        _ck(_v, 12, 0, currVal_9, currVal_10, currVal_11, currVal_12);
        var currVal_13 = 'student';
        var currVal_14 = _co.studentsSearchStr;
        _ck(_v, 14, 0, currVal_13, currVal_14);
        var currVal_15 = _co.event.ticketAllocations;
        _ck(_v, 21, 0, currVal_15);
        var currVal_23 = 'skipPayment';
        var currVal_24 = _co.params.skip_payment;
        _ck(_v, 27, 0, currVal_23, currVal_24);
        var currVal_25 = _co.isFormValid();
        _ck(_v, 33, 0, currVal_25);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵunv"](_v, 4, 0, _ck(_v, 5, 0, core_es5["ɵnov"](_v, 0), _co.totalPrice, 'USD', true, '1.2-2'));
        _ck(_v, 4, 0, currVal_0);
        var currVal_2 = core_es5["ɵnov"](_v, 16).ngClassUntouched;
        var currVal_3 = core_es5["ɵnov"](_v, 16).ngClassTouched;
        var currVal_4 = core_es5["ɵnov"](_v, 16).ngClassPristine;
        var currVal_5 = core_es5["ɵnov"](_v, 16).ngClassDirty;
        var currVal_6 = core_es5["ɵnov"](_v, 16).ngClassValid;
        var currVal_7 = core_es5["ɵnov"](_v, 16).ngClassInvalid;
        var currVal_8 = core_es5["ɵnov"](_v, 16).ngClassPending;
        _ck(_v, 11, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
        var currVal_16 = core_es5["ɵnov"](_v, 29).ngClassUntouched;
        var currVal_17 = core_es5["ɵnov"](_v, 29).ngClassTouched;
        var currVal_18 = core_es5["ɵnov"](_v, 29).ngClassPristine;
        var currVal_19 = core_es5["ɵnov"](_v, 29).ngClassDirty;
        var currVal_20 = core_es5["ɵnov"](_v, 29).ngClassValid;
        var currVal_21 = core_es5["ɵnov"](_v, 29).ngClassInvalid;
        var currVal_22 = core_es5["ɵnov"](_v, 29).ngClassPending;
        _ck(_v, 24, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22);
    });
}
function View_TicketFormComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'ticket-form', [], null, null, null, View_TicketFormComponent_0, RenderType_TicketFormComponent)), core_es5["ɵdid"](1, 245760, null, 0, ticket_form_TicketFormComponent, [src_store["a" /* Store */], completer_service["a" /* CompleterService */], src_actions["a" /* Actions */], angular2_token_es5["a" /* Angular2TokenService */], modal_ModalService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var TicketFormComponentNgFactory = core_es5["ɵccf"]('ticket-form', ticket_form_TicketFormComponent, View_TicketFormComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=ticket-form.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/components/modal.ts


var modal_ModalComponent = (function () {
    function ModalComponent(modalService, componentFactoryResolver) {
        this.modalService = modalService;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ModalComponent.prototype.ngOnInit = function () {
        this.susbcribeToComponents();
    };
    ModalComponent.prototype.susbcribeToComponents = function () {
        var _this = this;
        this.modalService.component$.subscribe(function (modalInputObject) {
            if (modalInputObject)
                _this.showModal(modalInputObject.component, modalInputObject.componentInputs);
            else
                _this.closeModal();
        });
    };
    ModalComponent.prototype.showModal = function (component, data) {
        var componentFactory;
        var componentRef;
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        this.placeholderVcr.clear();
        componentRef = this.placeholderVcr.createComponent(componentFactory);
        if (Object.keys(data).length > 0) {
            this.assignDataToComponentInputs(componentRef, data);
        }
        this.isVisible = true;
    };
    ModalComponent.prototype.closeModal = function () {
        this.placeholderVcr.clear();
        this.isVisible = false;
    };
    ModalComponent.prototype.assignDataToComponentInputs = function (componentRef, data) {
        Object.keys(data).forEach(function (k) { return componentRef.instance[k] = data[k]; });
        return componentRef;
    };
    ModalComponent.ctorParameters = function () { return [{ type: modal_ModalService }, { type: core_es5["ComponentFactoryResolver"] }]; };
    return ModalComponent;
}());

//# sourceMappingURL=modal.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/components/modal.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_ModalComponent = [];
var RenderType_ModalComponent = core_es5["ɵcrt"]({ encapsulation: 2,
    styles: styles_ModalComponent, data: {} });
function View_ModalComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { placeholderVcr: 0 }), (_l()(), core_es5["ɵted"](-1, null, ['\n    '])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 16, 'div', [['class',
                'modal']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n      '])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 13, 'div', [['class', 'm__content-wrapper']], null, null, null, null, null)), core_es5["ɵdid"](5, 278528, null, 0, common_es5["NgClass"], [core_es5["IterableDiffers"], core_es5["KeyValueDiffers"], core_es5["ElementRef"], core_es5["Renderer"]], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null), core_es5["ɵpod"](6, { 'is-visible': 0 }),
        (_l()(), core_es5["ɵted"](-1, null, ['\n        '])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 0, 'div', [['class', 'm__white-wash']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n        '])), (_l()(), core_es5["ɵeld"](10, 0, null, null, 6, 'div', [['class', 'm__modal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n          '])), (_l()(),
            core_es5["ɵeld"](12, 16777216, [[1, 3], ['placeholder', 1]], null, 0, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n          '])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 1, 'div', [['class', 'm__close']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.closeModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['×'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n        '])), (_l()(), core_es5["ɵted"](-1, null, ['\n      '])), (_l()(), core_es5["ɵted"](-1, null, ['\n    '])), (_l()(), core_es5["ɵted"](-1, null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'm__content-wrapper';
        var currVal_1 = _ck(_v, 6, 0, _co.isVisible);
        _ck(_v, 5, 0, currVal_0, currVal_1);
    }, null);
}
function View_ModalComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'modal', [], null, null, null, View_ModalComponent_0, RenderType_ModalComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, modal_ModalComponent, [modal_ModalService, core_es5["ComponentFactoryResolver"]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ModalComponentNgFactory = core_es5["ɵccf"]('modal', modal_ModalComponent, View_ModalComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWwudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWwudHMuTW9kYWxDb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbC50cy5Nb2RhbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJtb2RhbFwiPlxuICAgICAgPGRpdiBjbGFzcz1cIm1fX2NvbnRlbnQtd3JhcHBlclwiIFtuZ0NsYXNzXT1cInsgJ2lzLXZpc2libGUnOiBpc1Zpc2libGUgfVwiPlxuICAgICAgICA8ZGl2IGNsYXNzPVwibV9fd2hpdGUtd2FzaFwiPjwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzPVwibV9fbW9kYWxcIj5cbiAgICAgICAgICA8ZGl2ICNwbGFjZWhvbGRlcj48L2Rpdj5cbiAgICAgICAgICA8ZGl2IGNsYXNzPVwibV9fY2xvc2VcIiAoY2xpY2spPVwiY2xvc2VNb2RhbCgpXCI+JnRpbWVzOzwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAiLCI8bW9kYWw+PC9tb2RhbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OzREQ0FBO01BQUEsYUFDSTtNQUFBO01BQW1CLGdEQUNqQjtVQUFBO1VBQUEsbURBQUE7VUFBQTtVQUFBLGdFQUFnQztNQUF3QyxrREFDdEU7VUFBQTtVQUFBLDRDQUFpQztVQUFBLGlCQUNqQztVQUFBO1VBQUEsZ0JBQXNCLG9EQUNwQjtpQkFBQTtjQUFBO01BQXdCLG9EQUN4QjtVQUFBO2NBQUE7WUFBQTtZQUFBO1lBQXNCO2NBQUE7Y0FBQTtZQUFBO1lBQXRCO1VBQUEsZ0NBQTZDO01BQWEsa0RBQ3REO1VBQUEsZUFDRiw4Q0FDRjtVQUFBOztJQVBDO0lBQTJCO0lBQWhDLFdBQUssVUFBMkIsU0FBaEM7Ozs7b0JDRk47TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==
//# sourceMappingURL=modal.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/app.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_AppComponent = [];
var RenderType_AppComponent = core_es5["ɵcrt"]({ encapsulation: 2, styles: styles_AppComponent,
    data: {} });
function View_AppComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](-1, null, ['\n    '])), (_l()(), core_es5["ɵeld"](1, 0, null, null, 1, 'modal', [], null, null, null, View_ModalComponent_0, RenderType_ModalComponent)), core_es5["ɵdid"](2, 114688, null, 0, modal_ModalComponent, [modal_ModalService, core_es5["ComponentFactoryResolver"]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n    '])), (_l()(),
            core_es5["ɵeld"](4, 16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        core_es5["ɵdid"](5, 212992, null, 0, router_es5["p" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */],
            core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"], [8, null], core_es5["ChangeDetectorRef"]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n  ']))], function (_ck, _v) {
        _ck(_v, 2, 0);
        _ck(_v, 5, 0);
    }, null);
}
function View_AppComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'my-app', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        core_es5["ɵdid"](1, 49152, null, 0, app_component_AppComponent, [angular2_token_es5["a" /* Angular2TokenService */]], null, null)], null, null);
}
var AppComponentNgFactory = core_es5["ɵccf"]('my-app', app_component_AppComponent, View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG1vZGFsPjwvbW9kYWw+XG4gICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICAiLCI8bXktYXBwPjwvbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsOENBQ0k7TUFBQTtNQUFBLDZFQUFBO01BQUE7TUFBQSw2QkFBZSw4Q0FDZjthQUFBO1VBQUE7YUFBQTswREFBQTtVQUFBLDZCQUErQjs7UUFEL0I7UUFDQTs7OztvQkNGSjtNQUFBO2FBQUE7VUFBQTs7OyJ9
//# sourceMappingURL=app.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/animations/@angular/animations/browser.es5.js
var browser_es5 = __webpack_require__("f9zQ");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/platform-browser/@angular/platform-browser/animations.es5.js
var animations_es5 = __webpack_require__("fL27");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store-devtools/src/extension.js
var extension = __webpack_require__("M/iR");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store-devtools/src/devtools.js + 1 modules
var devtools = __webpack_require__("ooAe");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store-devtools/src/config.js
var config = __webpack_require__("CcDZ");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store-devtools/src/instrument.js
var instrument = __webpack_require__("PbkN");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/src/dispatcher.js
var dispatcher = __webpack_require__("ymMb");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/src/reducer.js
var reducer = __webpack_require__("b2X0");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/src/ng2.js
var ng2 = __webpack_require__("gOQ9");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/effects/src/bootstrap-listener.js
var bootstrap_listener = __webpack_require__("5Ewt");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/effects/src/effects-subscription.js
var effects_subscription = __webpack_require__("BYzQ");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@angular/animations/@angular/animations.es5.js
var _angular_animations_es5 = __webpack_require__("EyWH");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/services/local-data.js
var local_data = __webpack_require__("oQZj");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/services/completer-data-factory.js
var completer_data_factory = __webpack_require__("QcKS");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/services/remote-data.js
var remote_data = __webpack_require__("VeFf");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ngx-order-pipe/ngx-order-pipe.es5.js
var ngx_order_pipe_es5 = __webpack_require__("6vDJ");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-draggable-droppable/dist/esm/src/draggable-helper.provider.js
var draggable_helper_provider = __webpack_require__("lWZI");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/providers/calendarEventTitleFormatter.provider.js
var calendarEventTitleFormatter_provider = __webpack_require__("NZem");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/router-guard.ts


var router_guard_SignInIffNotAuthorisedGuard = (function () {
    function SignInIffNotAuthorisedGuard(_tokenService, router) {
        this._tokenService = _tokenService;
        this.router = router;
    }
    SignInIffNotAuthorisedGuard.prototype.canActivate = function (route, state) {
        if (this._tokenService.userSignedIn()) {
            return true;
        }
        location.reload();
        return false;
    };
    SignInIffNotAuthorisedGuard.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: router_es5["k" /* Router */] }]; };
    return SignInIffNotAuthorisedGuard;
}());

var router_guard_RedirectToMainIfSignedIn = (function () {
    function RedirectToMainIfSignedIn(_tokenService, router) {
        this._tokenService = _tokenService;
        this.router = router;
    }
    RedirectToMainIfSignedIn.prototype.canActivate = function (route, state) {
        if (this._tokenService.userSignedIn()) {
            this.router.navigate(['contacts']);
            return false;
        }
        return true;
    };
    RedirectToMainIfSignedIn.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: router_es5["k" /* Router */] }]; };
    return RedirectToMainIfSignedIn;
}());

//# sourceMappingURL=router-guard.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/constants.ts
var constants___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var constants_Constants = (function (_super) {
    constants___extends(Constants, _super);
    function Constants(publicHolidays, days, terms, campuses, courses, discountTypes) {
        if (publicHolidays === void 0) { publicHolidays = []; }
        if (days === void 0) { days = []; }
        if (terms === void 0) { terms = []; }
        if (campuses === void 0) { campuses = []; }
        if (courses === void 0) { courses = []; }
        if (discountTypes === void 0) { discountTypes = []; }
        var _this = _super.call(this) || this;
        _this.publicHolidays = publicHolidays;
        _this.days = days;
        _this.terms = terms;
        _this.campuses = campuses;
        _this.courses = courses;
        _this.discountTypes = discountTypes;
        return _this;
    }
    Constants.clone = function (obj) {
        var constants = new this();
        if (obj.publicHolidays && obj.publicHolidays.length > 0) {
            obj.publicHolidays.forEach(function (ph) {
                constants.publicHolidays.push(public_holiday_PublicHoliday.clone(ph));
            });
        }
        if (obj.days && obj.days.length > 0) {
            obj.days.forEach(function (d) {
                constants.days.push(Day.clone(d));
            });
        }
        if (obj.terms && obj.terms.length > 0) {
            obj.terms.forEach(function (t) {
                constants.terms.push(term_Term.clone(t));
            });
        }
        if (obj.campuses && obj.campuses.length > 0) {
            obj.campuses.forEach(function (c) {
                constants.campuses.push(Campus.clone(c));
            });
        }
        if (obj.courses && obj.courses.length > 0) {
            obj.courses.forEach(function (c) {
                constants.courses.push(course_Course.clone(c));
            });
        }
        if (obj.discountTypes && obj.discountTypes.length > 0) {
            obj.discountTypes.forEach(function (dt) {
                constants.discountTypes.push(DiscountType.clone(dt));
            });
        }
        return constants;
    };
    return Constants;
}(Model));

//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/constant.ts







var constant_ConstantService = (function () {
    function ConstantService(http, store) {
        this.http = http;
        this.store = store;
        this.constantsUrl = 'constants';
        this.termsUrl = 'terms';
    }
    ConstantService.prototype.all = function () {
        return this.http.get(this.constantsUrl)
            .map(function (res) {
            return constants_Constants.clone(res.json());
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ConstantService.prototype.upcomingTerm = function () {
        return this.http.get(this.termsUrl + "/upcoming_term")
            .map(function (res) {
            return term_Term.clone(res.json());
        })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    ConstantService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return ConstantService;
}());

//# sourceMappingURL=constant.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/constants.ts
var constants___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var constants___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var constants_ConstantsEffects = (function () {
    function ConstantsEffects(actions, constantsService) {
        var _this = this;
        this.actions = actions;
        this.constantsService = constantsService;
        this.fetch = this.actions
            .ofType(FETCH_CONSTANTS)
            .switchMap(function (action) { return _this.constantsService.all()
            .map(function (constants) { return ({ type: POPULATE_CONSTANTS, payload: constants }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_CONSTANTS_FAILURE }); }); })
            .share();
        this.fetchUpcomingTerm = this.actions
            .ofType(FETCH_UPCOMING_TERM)
            .switchMap(function (action) { return _this.constantsService.upcomingTerm()
            .map(function (term) { return ({ type: POPULATE_UPCOMING_TERM, payload: term }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_UPCOMING_TERM_FAILURE }); }); })
            .share();
    }
    ConstantsEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: constant_ConstantService }]; };
    return ConstantsEffects;
}());

constants___decorate([
    Object(effects["b" /* Effect */])(),
    constants___metadata("design:type", Object)
], constants_ConstantsEffects.prototype, "fetch", void 0);
constants___decorate([
    Object(effects["b" /* Effect */])(),
    constants___metadata("design:type", Object)
], constants_ConstantsEffects.prototype, "fetchUpcomingTerm", void 0);
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/initial.ts





var initial_InitialResolver = (function () {
    function InitialResolver(constantsEffects, router, store) {
        this.constantsEffects = constantsEffects;
        this.router = router;
        this.store = store;
    }
    InitialResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var result = Observable["Observable"].create(function (observer) {
            _this.constantsEffects.fetch.take(1).subscribe(function (a) {
                if (a.type == POPULATE_CONSTANTS) {
                    observer.next(true);
                    observer.complete();
                }
            });
        });
        this.store.dispatch({ type: FETCH_CONSTANTS });
        return result;
    };
    InitialResolver.ctorParameters = function () { return [{ type: constants_ConstantsEffects }, { type: router_es5["k" /* Router */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return InitialResolver;
}());

//# sourceMappingURL=initial.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/contact-view.ts







var contact_view_ContactViewResolver = (function () {
    function ContactViewResolver(contactEffects, matrixClassEffects, router, store) {
        this.contactEffects = contactEffects;
        this.matrixClassEffects = matrixClassEffects;
        this.router = router;
        this.store = store;
    }
    ContactViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var result = Observable["Observable"].create(function (observer) {
            var a = _this.matrixClassEffects.fetchTeachers;
            var b = _this.contactEffects.fetchContact;
            return Observable["Observable"].zip(a, b).take(1).subscribe(function (actions) {
                if (actions[0].type === POPULATE_TEACHERS &&
                    actions[1].type === POPULATE_ACTIVE_CONTACT) {
                    observer.next(true);
                    observer.complete();
                }
            });
        });
        this.store.dispatch({ type: FETCH_CONTACT, payload: route.params['id'] });
        this.store.dispatch({ type: FETCH_TEACHERS });
        return result;
    };
    ContactViewResolver.ctorParameters = function () { return [{ type: contact_ContactEffects }, { type: matrix_class_MatrixClassEffects }, { type: router_es5["k" /* Router */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return ContactViewResolver;
}());

//# sourceMappingURL=contact-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/enquiry-view.ts




var enquiry_view_EnquiryViewResolver = (function () {
    function EnquiryViewResolver(store, enquiryEffects) {
        this.store = store;
        this.enquiryEffects = enquiryEffects;
    }
    EnquiryViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var result = Observable["Observable"].create(function (observer) {
            _this.enquiryEffects.fetchEnquiry.take(1).subscribe(function (a) {
                if (a.type == POPULATE_ACTIVE_ENQUIRY) {
                    observer.next(true);
                    observer.complete();
                }
            });
        });
        this.store.dispatch({ type: FETCH_ENQUIRY, payload: route.params['id'] });
        return result;
    };
    EnquiryViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: enquiry_EnquiryEffects }]; };
    return EnquiryViewResolver;
}());

//# sourceMappingURL=enquiry-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/class-manager-view.ts




var class_manager_view_ClassManagerViewResolver = (function () {
    function ClassManagerViewResolver(classEffects, router, store) {
        this.classEffects = classEffects;
        this.router = router;
        this.store = store;
    }
    ClassManagerViewResolver.prototype.resolve = function (route, state) {
        var result = Observable["Observable"].create(function (observer) {
            // Add Resolves here as necessary.
            observer.next(true);
            observer.complete();
        });
        return result;
    };
    ClassManagerViewResolver.ctorParameters = function () { return [{ type: matrix_class_MatrixClassEffects }, { type: router_es5["k" /* Router */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return ClassManagerViewResolver;
}());

//# sourceMappingURL=class-manager-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/class-view.ts



var class_view_ClassViewResolver = (function () {
    function ClassViewResolver(store, actions) {
        this.store = store;
        this.actions = actions;
    }
    ClassViewResolver.prototype.resolve = function (route, state) {
        this.store.dispatch({ type: FETCH_CLASS, payload: route.params['id'] });
        return this
            .actions
            .ofType(POPULATE_ACTIVE_CLASS)
            .take(1)
            .mapTo(true);
    };
    ClassViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return ClassViewResolver;
}());

//# sourceMappingURL=class-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/enrolment-timetable-view.ts






var enrolment_timetable_view_EnrolmentTimetableViewResolver = (function () {
    function EnrolmentTimetableViewResolver(contactEffects, store) {
        this.contactEffects = contactEffects;
        this.store = store;
    }
    EnrolmentTimetableViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var result = Observable["Observable"].create(function (observer) {
            _this.contactEffects.fetchContact.take(1).subscribe(function (a) {
                if (a.type == POPULATE_ACTIVE_CONTACT) {
                    observer.next(true);
                    observer.complete();
                }
            });
        });
        var enrolment = new enrolment_Enrolment();
        var contactId = route.params['id'];
        enrolment.contactId = contactId;
        this.store.dispatch({ type: POPULATE_EDITABLE_ENROLMENT, payload: enrolment });
        this.store.dispatch({ type: FETCH_CONTACT, payload: route.params['id'] });
        return result;
    };
    EnrolmentTimetableViewResolver.ctorParameters = function () { return [{ type: contact_ContactEffects }, { type: _ngrx_store["f" /* Store */] }]; };
    return EnrolmentTimetableViewResolver;
}());

//# sourceMappingURL=enrolment-timetable-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/workshops-view.ts



var workshops_view_WorkshopsViewResolver = (function () {
    function WorkshopsViewResolver(actions, store) {
        this.actions = actions;
        this.store = store;
    }
    WorkshopsViewResolver.prototype.resolve = function (route, state) {
        var termId = 0;
        this.store.select("constantsReducer").take(1).subscribe(function (s) {
            termId = s.constants.terms.filter(function (t) { return !t.isHoliday; })[0].id;
        });
        this.store.dispatch({ type: FETCH_WORKSHOPS, payload: termId });
        return this.actions
            .ofType(POPULATE_WORKSHOPS)
            .take(1)
            .mapTo(true);
    };
    WorkshopsViewResolver.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return WorkshopsViewResolver;
}());

//# sourceMappingURL=workshops-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/event.ts




var event_EventService = (function () {
    function EventService(http) {
        this.http = http;
        this.eventsUrl = 'events';
        this.ticketsUrl = 'tickets';
    }
    EventService.prototype.index = function () {
        return this.http.get(this.eventsUrl)
            .map(function (res) { return res.json().map(function (e) { return event_Event.clone(e); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    EventService.prototype.fetch = function (id) {
        return this.http.get(this.eventsUrl + "/" + id)
            .map(function (res) { return event_Event.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    EventService.prototype.create = function (e) {
        return this.http.post(this.eventsUrl, e.serializeForRails())
            .map(function (res) { return event_Event.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    EventService.prototype.update = function (e) {
        return this.http.patch(this.eventsUrl + "/" + e.id, e.serializeForRails())
            .map(function (res) { return event_Event.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    EventService.prototype.purchaseTicketAsGuest = function (data) {
        return this.http.post(this.ticketsUrl, data)
            .map(function (res) { return res.json().map(function (t) { return ticket_Ticket.clone(t); }); })
            .catch(function (err) { return Observable["Observable"].throw(err.json()); });
    };
    EventService.prototype.purchaseTicketAsExisting = function (data) {
        return this.http.post("students/" + this.ticketsUrl, data)
            .map(function (res) { return res.json().map(function (t) { return ticket_Ticket.clone(t); }); })
            .catch(function (err) { return Observable["Observable"].throw(err.json()); });
    };
    EventService.prototype.purchaseTicketAsStaff = function (data) {
        return this.http.post("" + this.ticketsUrl, data)
            .map(function (res) { return res.json().map(function (t) { return ticket_Ticket.clone(t); }); })
            .catch(function (err) { return Observable["Observable"].throw(err.json()); });
    };
    EventService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return EventService;
}());

//# sourceMappingURL=event.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/internal-event-view.ts





var internal_event_view_InternalEventViewResolver = (function () {
    function InternalEventViewResolver(store, actions, eventService) {
        this.store = store;
        this.actions = actions;
        this.eventService = eventService;
    }
    InternalEventViewResolver.prototype.resolve = function (route, state) {
        var id = parseInt(route.params.id);
        var actionTypes = [];
        actionTypes.push(POPULATE_TEACHERS);
        if (id) {
            actionTypes.push(POPULATE_ACTIVE_EVENT);
        }
        var result = (_a = this.actions).ofType.apply(_a, actionTypes).take(actionTypes.length)
            .skip(actionTypes.length - 1)
            .mapTo(true);
        if (id) {
            this.store.dispatch({ type: FETCH_EVENT, payload: id });
        }
        this.store.dispatch({ type: FETCH_TEACHERS });
        return result;
        var _a;
    };
    InternalEventViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }, { type: event_EventService }]; };
    return InternalEventViewResolver;
}());

//# sourceMappingURL=internal-event-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/events-view.ts



var events_view_EventsViewResolver = (function () {
    function EventsViewResolver(store, actions) {
        this.store = store;
        this.actions = actions;
    }
    EventsViewResolver.prototype.resolve = function (route, state) {
        var result = this.actions
            .ofType(POPULATE_EVENTS)
            .take(1)
            .map(function () { return true; });
        this.store.dispatch({ type: FETCH_EVENTS });
        return result;
    };
    EventsViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: src_actions["a" /* Actions */] }]; };
    return EventsViewResolver;
}());

//# sourceMappingURL=events-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/ticket.ts


var ticket_TicketService = (function () {
    function TicketService(http) {
        this.http = http;
        this.ticketsUrl = 'tickets';
    }
    TicketService.prototype.delete = function (id) {
        return this.http.delete(this.ticketsUrl + "/" + id)
            .map(function () { return id; })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    TicketService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return TicketService;
}());

//# sourceMappingURL=ticket.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/event.ts
var event___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var event_EventEffects = (function () {
    function EventEffects(actions, eventService, ticketService) {
        var _this = this;
        this.actions = actions;
        this.eventService = eventService;
        this.ticketService = ticketService;
        this.index = this.actions
            .ofType(FETCH_EVENTS)
            .map(function (action) { return action.payload; })
            .switchMap(function (e) { return _this.eventService.index()
            .map(function (e) { return ({ type: POPULATE_EVENTS, payload: e }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_EVENTS_FAILURE }); }); })
            .share();
        this.fetch = this.actions
            .ofType(FETCH_EVENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.eventService.fetch(id)
            .map(function (e) { return ({ type: POPULATE_ACTIVE_EVENT, payload: e }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_EVENT_FAILURE }); }); })
            .share();
        this.create = this.actions
            .ofType(CREATE_EVENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (e) { return _this.eventService.create(e)
            .map(function (e) { return ({ type: CREATED_EVENT, payload: e }); })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_EVENT_FAILURE }); }); })
            .share();
        this.update = this.actions
            .ofType(UPDATE_EVENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (e) { return _this.eventService.update(e)
            .map(function (e) { return ({ type: UPDATED_EVENT, payload: e }); })
            .catch(function () { return Observable["Observable"].of({ type: UPDATE_EVENT_FAILURE }); }); })
            .share();
        this.deleteTicket = this.actions
            .ofType(DELETE_TICKET_FROM_EVENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (t) { return _this.ticketService.delete(t.ticket.id)
            .map(function (ticketId) { return ({
            type: DELETED_TICKET_FROM_EVENT,
            payload: t,
        }); })
            .catch(function () { return Observable["Observable"].of({
            type: DELETE_TICKET_FROM_EVENT_FAILURE,
            payload: t,
        }); }); })
            .share();
        this.purchaseTicketsAsGuest = this.actions
            .ofType(PURCHASE_TICKETS_AS_GUEST)
            .switchMap(function (a) { return _this.eventService.purchaseTicketAsGuest(a.payload)
            .map(function (tickets) { return ({ type: PURCHASED_TICKETS_AS_GUEST, payload: tickets }); })
            .catch(function (err) { return Observable["Observable"].of({
            type: PURCHASE_TICKETS_AS_GUEST_FAILURE,
            payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
        }); }); })
            .share();
        this.purchaseTicketsAsExisting = this.actions
            .ofType(PURCHASE_TICKETS_AS_EXISTING)
            .switchMap(function (a) { return _this.eventService.purchaseTicketAsExisting(a.payload)
            .map(function (tickets) { return ({ type: PURCHASED_TICKETS_AS_EXISTING, payload: tickets }); })
            .catch(function (err) { return Observable["Observable"].of({
            type: PURCHASE_TICKETS_AS_EXISTING_FAILURE,
            payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
        }); }); })
            .share();
        this.purchaseTicketsAsStaff = this.actions
            .ofType(PURCHASE_TICKET_AS_STAFF)
            .switchMap(function (a) { return _this.eventService.purchaseTicketAsStaff(a.payload)
            .map(function (tickets) { return ({ type: PURCHASED_TICKET_AS_STAFF, payload: tickets }); })
            .catch(function (err) { return Observable["Observable"].of({
            type: PURCHASE_TICKET_AS_STAFF_FAILURE,
            payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
        }); }); })
            .share();
    }
    EventEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: event_EventService }, { type: ticket_TicketService }]; };
    return EventEffects;
}());

event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "index", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "fetch", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "create", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "update", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "deleteTicket", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "purchaseTicketsAsGuest", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "purchaseTicketsAsExisting", void 0);
event___decorate([
    Object(effects["b" /* Effect */])(),
    event___metadata("design:type", Object)
], event_EventEffects.prototype, "purchaseTicketsAsStaff", void 0);
//# sourceMappingURL=event.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/event-view.ts








var event_view_EventViewResolver = (function () {
    function EventViewResolver(store, eventEffects, userEffects, router, tokenService) {
        this.store = store;
        this.eventEffects = eventEffects;
        this.userEffects = userEffects;
        this.router = router;
        this.tokenService = tokenService;
    }
    EventViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        if (!route.params.id) {
            this.router.navigate(["events"]);
        }
        this.store.dispatch({ type: FETCH_EVENTS });
        this.store.dispatch({ type: FETCH_EVENT, payload: route.params.id });
        var event = this.eventEffects.fetch
            .take(1)
            .filter(function (a) { return a.type == POPULATE_ACTIVE_EVENT; })
            .map(function () { return true; });
        var user = this.tokenService.validateToken()
            .take(1)
            .switchMap(function (res) {
            var user = user_User.initFromCurrentUserData(_this.tokenService.currentUserData);
            return Observable["Observable"].of(true);
        })
            .catch(function (err) {
            return Observable["Observable"].of(true);
        });
        return Observable["Observable"].zip(event, user).take(1).map(function () { return true; });
    };
    EventViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: event_EventEffects }, { type: user_UserEffects }, { type: router_es5["k" /* Router */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return EventViewResolver;
}());

//# sourceMappingURL=event-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/role.ts
var role___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var role___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var role_RoleEffects = (function () {
    function RoleEffects(actions, roleService) {
        var _this = this;
        this.actions = actions;
        this.roleService = roleService;
        this.index = this.actions
            .ofType(FETCH_ROLES)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.roleService.index(params)
            .map(function (roles) { return ({ type: POPULATE_ROLES, payload: roles }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_ROLES_FAILURE, payload: response }); }); })
            .share();
        this.roleUsers = this.actions
            .ofType(FETCH_ROLE_USERS)
            .map(function (a) { return a.payload; })
            .switchMap(function (roleId) { return _this.roleService.roleUsers(roleId)
            .map(function (users) { return ({ type: POPULATE_ROLE_USERS, payload: users }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_ROLE_USERS_FAILURE, payload: response }); }); })
            .share();
    }
    RoleEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: role_RoleService }]; };
    return RoleEffects;
}());

role___decorate([
    Object(effects["b" /* Effect */])(),
    role___metadata("design:type", Object)
], role_RoleEffects.prototype, "index", void 0);
role___decorate([
    Object(effects["b" /* Effect */])(),
    role___metadata("design:type", Object)
], role_RoleEffects.prototype, "roleUsers", void 0);
//# sourceMappingURL=role.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/roles-view.ts




var roles_view_RolesViewResolver = (function () {
    function RolesViewResolver(roleEffects, store, actions) {
        this.roleEffects = roleEffects;
        this.store = store;
        this.actions = actions;
    }
    RolesViewResolver.prototype.resolve = function (route, state) {
        var result = this.actions
            .ofType(POPULATE_ROLES)
            .take(1)
            .mapTo(true);
        this.store.dispatch({ type: FETCH_ROLES });
        return result;
    };
    RolesViewResolver.ctorParameters = function () { return [{ type: role_RoleEffects }, { type: _ngrx_store["f" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return RolesViewResolver;
}());

//# sourceMappingURL=roles-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/calendar-view.ts



var calendar_view_CalendarViewResolver = (function () {
    function CalendarViewResolver(store, actions) {
        this.store = store;
        this.actions = actions;
    }
    CalendarViewResolver.prototype.resolve = function (route, state) {
        this.store.dispatch({ type: FETCH_CALENDAR_TERMS });
        return this.actions.ofType(POPULATE_CALENDAR_TERMS)
            .take(1)
            .mapTo(true);
    };
    CalendarViewResolver.ctorParameters = function () { return [{ type: src_store["a" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return CalendarViewResolver;
}());

//# sourceMappingURL=calendar-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/online-enrolment-view.ts










var online_enrolment_view_OnlineEnrolmentViewResolver = (function () {
    function OnlineEnrolmentViewResolver(store, actions, router, tokenService) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.tokenService = tokenService;
    }
    OnlineEnrolmentViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var user = this.tokenService.validateToken()
            .take(1)
            .switchMap(function (res) {
            var user = user_User.initFromCurrentUserData(_this.tokenService.currentUserData);
            if (user.contactId) {
                _this.store.dispatch({ type: FETCH_CURRENT_USER_CONTACT, payload: user.contactId });
                return _this.actions
                    .ofType(POPULATE_CURRENT_USER_CONTACT)
                    .take(1)
                    .mapTo(true);
            }
            else {
                return Observable["Observable"].of(true);
            }
        })
            .catch(function (err) { return Observable["Observable"].of(true); });
        var enquiry;
        if (route.queryParams.guid) {
            this.store.dispatch({ type: FETCH_ENQUIRY_BY_GUID, payload: route.queryParams.guid });
            enquiry = this.actions
                .ofType(POPULATE_ACTIVE_ENQUIRY)
                .take(1)
                .mapTo(true);
        }
        else {
            this.store.dispatch({ type: POPULATE_ACTIVE_ENQUIRY, payload: new enquiry_Enquiry() });
            enquiry = Observable["Observable"].of(true);
        }
        var constants = this.actions
            .ofType(POPULATE_CONSTANTS)
            .take(1)
            .mapTo(true);
        this.store.dispatch({ type: FETCH_CONSTANTS });
        return Observable["Observable"].zip(user, enquiry, constants).take(1).mapTo(true);
    };
    OnlineEnrolmentViewResolver.ctorParameters = function () { return [{ type: src_store["a" /* Store */] }, { type: effects["a" /* Actions */] }, { type: router_es5["k" /* Router */] }, { type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return OnlineEnrolmentViewResolver;
}());

//# sourceMappingURL=online-enrolment-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/direct-debit-summary-view.ts




var direct_debit_summary_view_DirectDebitSummaryViewResolver = (function () {
    function DirectDebitSummaryViewResolver(store, router, actions) {
        this.store = store;
        this.router = router;
        this.actions = actions;
    }
    DirectDebitSummaryViewResolver.prototype.resolve = function (route, state) {
        var result = this.actions
            .ofType(POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY)
            .take(1)
            .mapTo(true);
        var payload = {
            id: route.params['id'],
        };
        this.store.dispatch({ type: FETCH_DIRECT_DEBIT_SUMMARY, payload: payload });
        return result;
    };
    DirectDebitSummaryViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }, { type: effects["a" /* Actions */] }]; };
    return DirectDebitSummaryViewResolver;
}());

//# sourceMappingURL=direct-debit-summary-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/transactions-by-debtor-view.ts




var transactions_by_debtor_view_TransactionsByDebtorViewResolver = (function () {
    function TransactionsByDebtorViewResolver(store, router, actions) {
        this.store = store;
        this.router = router;
        this.actions = actions;
    }
    TransactionsByDebtorViewResolver.prototype.resolve = function (route, state) {
        var _this = this;
        this.actions
            .ofType(POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY)
            .take(1)
            .subscribe(function (action) {
            var payloadTs = {
                dds_id: action.payload.id,
                view_type: route.params["type"],
            };
            _this.store.dispatch({ type: FETCH_DDS_TRANSACTIONS, payload: payloadTs });
        });
        var payloadDds = {
            id: route.params['id'],
            shallow: true,
        };
        this.store.dispatch({ type: FETCH_DIRECT_DEBIT_SUMMARY, payload: payloadDds });
        return this.actions
            .ofType(POPULATE_TRANSCATIONS)
            .take(1)
            .mapTo(true);
    };
    TransactionsByDebtorViewResolver.ctorParameters = function () { return [{ type: _ngrx_store["f" /* Store */] }, { type: router_es5["k" /* Router */] }, { type: effects["a" /* Actions */] }]; };
    return TransactionsByDebtorViewResolver;
}());

//# sourceMappingURL=transactions-by-debtor-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/resolvers/comms-view.ts



var comms_view_CommsViewResolver = (function () {
    function CommsViewResolver(store, actions) {
        this.store = store;
        this.actions = actions;
    }
    CommsViewResolver.prototype.resolve = function (route, state) {
        var result = this.actions.ofType(POPULATE_TEMPLATES)
            .take(1)
            .mapTo(true);
        this.store.dispatch({ type: FETCH_TEMPLATES });
        return result;
    };
    CommsViewResolver.ctorParameters = function () { return [{ type: src_store["a" /* Store */] }, { type: effects["a" /* Actions */] }]; };
    return CommsViewResolver;
}());

//# sourceMappingURL=comms-view.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/combined-reducer.ts















var reducers = {
    constantsReducer: constantsReducer,
    userReducer: userReducer,
    contactsReducer: contactsReducer,
    enquiriesReducer: enquiriesReducer,
    matrixClassesReducer: matrixClassesReducer,
    enrolmentsReducer: enrolmentsReducer,
    calendarReducer: calendarReducer,
    workshopsReducer: workshopsReducer,
    tutorAllocationsReducer: tutorAllocationsReducer,
    bookingsReducer: bookingsReducer,
    eventsReducer: eventsReducer,
    rolesReducer: rolesReducer,
    transactionsReducer: transactionsReducer,
    commsReducer: commsReducer,
};
var combinedReducers = Object(_ngrx_store["h" /* combineReducers */])(reducers);
function rootReducer(state, action) {
    return combinedReducers(state, action);
}
//# sourceMappingURL=combined-reducer.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/store/src/state.js
var src_state = __webpack_require__("8LMS");

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/workshop.ts





var workshop_WorkshopService = (function () {
    function WorkshopService(http) {
        this.http = http;
        this.workshopsUrl = 'workshops';
        this.workshopsAbsenceUrl = 'workshop_absences';
    }
    WorkshopService.prototype.index = function (termId) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        searchParams.set("termId", termId.toString());
        return this.http.get(this.workshopsUrl, options)
            .map(function (res) { return res.json().map(function (w) { return workshop_Workshop.clone(w); }); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    WorkshopService.prototype.update = function (workshop) {
        return this.http.put(this.workshopsUrl + "/" + workshop.id, workshop.serializeForRails())
            .map(function (res) { return workshop_Workshop.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    WorkshopService.prototype.createWorkshopAbsence = function (wa) {
        return this.http.post(this.workshopsAbsenceUrl, wa.serializeForRails())
            .map(function (res) { return workshop_absence_WorkshopAbsence.clone(res.json()); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    WorkshopService.prototype.deleteWorkshopAbsence = function (wa) {
        return this.http.delete(this.workshopsAbsenceUrl + "/" + wa.id)
            .map(function (res) { return res.json(); })
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    WorkshopService.prototype.rollover = function (params) {
        return this.http.get(this.workshopsUrl + "/rollover/" + params.from_term_id + "/" + params.to_term_id)
            .mapTo(true)
            .catch(function (error) { return Observable["Observable"].throw(error.json()); });
    };
    WorkshopService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }]; };
    return WorkshopService;
}());

//# sourceMappingURL=workshop.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/workshop.ts
var workshop___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var workshop___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var workshop_WorkshopEffects = (function () {
    function WorkshopEffects(actions, workshopService) {
        var _this = this;
        this.actions = actions;
        this.workshopService = workshopService;
        this.index = this.actions
            .ofType(FETCH_WORKSHOPS)
            .map(function (action) { return action.payload; })
            .switchMap(function (termId) { return _this.workshopService.index(termId)
            .map(function (workshops) { return ({ type: POPULATE_WORKSHOPS, payload: workshops }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_WORKSHOPS_FAILURE }); }); })
            .share();
        this.update = this.actions
            .ofType(UPDATE_WORKSHOP)
            .map(function (action) { return action.payload; })
            .switchMap(function (workshop) { return _this.workshopService.update(workshop)
            .map(function (workshop) { return ({ type: REPLACE_WORKSHOP, payload: workshop }); })
            .catch(function () { return Observable["Observable"].of({ type: UPDATE_WORKSHOP_FAILURE }); }); })
            .share();
        this.createWorkshopAbsence = this.actions
            .ofType(CREATE_WORKSHOP_ABSENCE)
            .map(function (action) { return action.payload; })
            .switchMap(function (wa) { return _this.workshopService.createWorkshopAbsence(wa)
            .map(function (wa) { return ({ type: ADD_WORKSHOP_ABSENCE, payload: wa }); })
            .catch(function () { return Observable["Observable"].of({ type: CREATE_WORKSHOP_ABSENCE_FAILURE }); }); })
            .share();
        this.deleteWorkshopAbsence = this.actions
            .ofType(DELETE_WORKSHOP_ABSENCE)
            .map(function (action) { return action.payload; })
            .switchMap(function (wa) { return _this.workshopService.deleteWorkshopAbsence(wa)
            .map(function (wa) { return ({ type: REMOVE_WORKSHOP_ABSENCE, payload: wa }); })
            .catch(function () { return Observable["Observable"].of({ type: DELETE_WORKSHOP_ABSENCE_FAILURE }); }); })
            .share();
        this.rollover = this.actions
            .ofType(WORKSHOPS_ROLLOVER)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.workshopService.rollover(params)
            .map(function (wa) { return ({ type: WORKSHOPS_ROLLOVER_SUCCESS, payload: wa }); })
            .catch(function () { return Observable["Observable"].of({ type: WORKSHOPS_ROLLOVER_FAILURE }); }); })
            .share();
    }
    WorkshopEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: workshop_WorkshopService }]; };
    return WorkshopEffects;
}());

workshop___decorate([
    Object(effects["b" /* Effect */])(),
    workshop___metadata("design:type", Object)
], workshop_WorkshopEffects.prototype, "index", void 0);
workshop___decorate([
    Object(effects["b" /* Effect */])(),
    workshop___metadata("design:type", Object)
], workshop_WorkshopEffects.prototype, "update", void 0);
workshop___decorate([
    Object(effects["b" /* Effect */])(),
    workshop___metadata("design:type", Object)
], workshop_WorkshopEffects.prototype, "createWorkshopAbsence", void 0);
workshop___decorate([
    Object(effects["b" /* Effect */])(),
    workshop___metadata("design:type", Object)
], workshop_WorkshopEffects.prototype, "deleteWorkshopAbsence", void 0);
workshop___decorate([
    Object(effects["b" /* Effect */])(),
    workshop___metadata("design:type", Object)
], workshop_WorkshopEffects.prototype, "rollover", void 0);
//# sourceMappingURL=workshop.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/models/direct-debit-summary.ts
var direct_debit_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DirectDebitSummary = (function (_super) {
    direct_debit_summary___extends(DirectDebitSummary, _super);
    function DirectDebitSummary(id, termId, instalment, description, batched, batchedApproved, batchedDeclined, unbatched, unprocessable, processable, batchedCount, batchedApprovedCount, batchedDeclinedCount, unbatchedCount, unprocessableCount, processableCount, unbatchedRecovered, unbatchedOutstanding, unbatchedDisenroled, declinedRecovered, declinedOutstanding, declinedDisenroled, approvedReceived, approvedRefunded, approvedDisenroled, unbatchedRecoveredCount, unbatchedOutstandingCount, unbatchedDisenroledCount, declinedRecoveredCount, declinedOutstandingCount, declinedDisenroledCount, approvedReceivedCount, approvedRefundedCount, approvedDisenroledCount, createdAt, updatedAt) {
        if (instalment === void 0) { instalment = null; }
        if (description === void 0) { description = null; }
        if (batched === void 0) { batched = null; }
        if (batchedApproved === void 0) { batchedApproved = null; }
        if (batchedDeclined === void 0) { batchedDeclined = null; }
        if (unbatched === void 0) { unbatched = null; }
        if (unprocessable === void 0) { unprocessable = null; }
        if (processable === void 0) { processable = null; }
        if (batchedCount === void 0) { batchedCount = null; }
        if (batchedApprovedCount === void 0) { batchedApprovedCount = null; }
        if (batchedDeclinedCount === void 0) { batchedDeclinedCount = null; }
        if (unbatchedCount === void 0) { unbatchedCount = null; }
        if (unprocessableCount === void 0) { unprocessableCount = null; }
        if (processableCount === void 0) { processableCount = null; }
        if (unbatchedRecovered === void 0) { unbatchedRecovered = null; }
        if (unbatchedOutstanding === void 0) { unbatchedOutstanding = null; }
        if (unbatchedDisenroled === void 0) { unbatchedDisenroled = null; }
        if (declinedRecovered === void 0) { declinedRecovered = null; }
        if (declinedOutstanding === void 0) { declinedOutstanding = null; }
        if (declinedDisenroled === void 0) { declinedDisenroled = null; }
        if (approvedReceived === void 0) { approvedReceived = null; }
        if (approvedRefunded === void 0) { approvedRefunded = null; }
        if (approvedDisenroled === void 0) { approvedDisenroled = null; }
        if (unbatchedRecoveredCount === void 0) { unbatchedRecoveredCount = null; }
        if (unbatchedOutstandingCount === void 0) { unbatchedOutstandingCount = null; }
        if (unbatchedDisenroledCount === void 0) { unbatchedDisenroledCount = null; }
        if (declinedRecoveredCount === void 0) { declinedRecoveredCount = null; }
        if (declinedOutstandingCount === void 0) { declinedOutstandingCount = null; }
        if (declinedDisenroledCount === void 0) { declinedDisenroledCount = null; }
        if (approvedReceivedCount === void 0) { approvedReceivedCount = null; }
        if (approvedRefundedCount === void 0) { approvedRefundedCount = null; }
        if (approvedDisenroledCount === void 0) { approvedDisenroledCount = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (updatedAt === void 0) { updatedAt = null; }
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.termId = termId;
        _this.instalment = instalment;
        _this.description = description;
        _this.batched = batched;
        _this.batchedApproved = batchedApproved;
        _this.batchedDeclined = batchedDeclined;
        _this.unbatched = unbatched;
        _this.unprocessable = unprocessable;
        _this.processable = processable;
        _this.batchedCount = batchedCount;
        _this.batchedApprovedCount = batchedApprovedCount;
        _this.batchedDeclinedCount = batchedDeclinedCount;
        _this.unbatchedCount = unbatchedCount;
        _this.unprocessableCount = unprocessableCount;
        _this.processableCount = processableCount;
        _this.unbatchedRecovered = unbatchedRecovered;
        _this.unbatchedOutstanding = unbatchedOutstanding;
        _this.unbatchedDisenroled = unbatchedDisenroled;
        _this.declinedRecovered = declinedRecovered;
        _this.declinedOutstanding = declinedOutstanding;
        _this.declinedDisenroled = declinedDisenroled;
        _this.approvedReceived = approvedReceived;
        _this.approvedRefunded = approvedRefunded;
        _this.approvedDisenroled = approvedDisenroled;
        _this.unbatchedRecoveredCount = unbatchedRecoveredCount;
        _this.unbatchedOutstandingCount = unbatchedOutstandingCount;
        _this.unbatchedDisenroledCount = unbatchedDisenroledCount;
        _this.declinedRecoveredCount = declinedRecoveredCount;
        _this.declinedOutstandingCount = declinedOutstandingCount;
        _this.declinedDisenroledCount = declinedDisenroledCount;
        _this.approvedReceivedCount = approvedReceivedCount;
        _this.approvedRefundedCount = approvedRefundedCount;
        _this.approvedDisenroledCount = approvedDisenroledCount;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        return _this;
    }
    DirectDebitSummary.clone = function (obj) {
        var o = new this();
        if (obj.id) {
            o.id = obj.id;
        }
        if (obj.termId) {
            o.termId = obj.termId;
        }
        if (obj.instalment != undefined) {
            o.instalment = obj.instalment;
        }
        if (obj.description) {
            o.description = obj.description;
        }
        if (obj.batched != undefined) {
            o.batched = obj.batched;
        }
        if (obj.batchedApproved != undefined) {
            o.batchedApproved = obj.batchedApproved;
        }
        if (obj.batchedDeclined != undefined) {
            o.batchedDeclined = obj.batchedDeclined;
        }
        if (obj.unbatched != undefined) {
            o.unbatched = obj.unbatched;
        }
        if (obj.unprocessable != undefined) {
            o.unprocessable = obj.unprocessable;
        }
        if (obj.processable != undefined) {
            o.processable = obj.processable;
        }
        if (obj.batchedCount != undefined) {
            o.batchedCount = obj.batchedCount;
        }
        if (obj.batchedApprovedCount != undefined) {
            o.batchedApprovedCount = obj.batchedApprovedCount;
        }
        if (obj.batchedDeclinedCount != undefined) {
            o.batchedDeclinedCount = obj.batchedDeclinedCount;
        }
        if (obj.unbatchedCount != undefined) {
            o.unbatchedCount = obj.unbatchedCount;
        }
        if (obj.unprocessableCount != undefined) {
            o.unprocessableCount = obj.unprocessableCount;
        }
        if (obj.processableCount != undefined) {
            o.processableCount = obj.processableCount;
        }
        if (obj.unbatchedRecovered != undefined) {
            o.unbatchedRecovered = obj.unbatchedRecovered;
        }
        if (obj.unbatchedOutstanding != undefined) {
            o.unbatchedOutstanding = obj.unbatchedOutstanding;
        }
        if (obj.unbatchedDisenroled != undefined) {
            o.unbatchedDisenroled = obj.unbatchedDisenroled;
        }
        if (obj.declinedRecovered != undefined) {
            o.declinedRecovered = obj.declinedRecovered;
        }
        if (obj.declinedOutstanding != undefined) {
            o.declinedOutstanding = obj.declinedOutstanding;
        }
        if (obj.declinedDisenroled != undefined) {
            o.declinedDisenroled = obj.declinedDisenroled;
        }
        if (obj.approvedReceived != undefined) {
            o.approvedReceived = obj.approvedReceived;
        }
        if (obj.approvedRefunded != undefined) {
            o.approvedRefunded = obj.approvedRefunded;
        }
        if (obj.approvedDisenroled != undefined) {
            o.approvedDisenroled = obj.approvedDisenroled;
        }
        if (obj.unbatchedRecoveredCount != undefined) {
            o.unbatchedRecoveredCount = obj.unbatchedRecoveredCount;
        }
        if (obj.unbatchedOutstandingCount != undefined) {
            o.unbatchedOutstandingCount = obj.unbatchedOutstandingCount;
        }
        if (obj.unbatchedDisenroledCount != undefined) {
            o.unbatchedDisenroledCount = obj.unbatchedDisenroledCount;
        }
        if (obj.declinedRecoveredCount != undefined) {
            o.declinedRecoveredCount = obj.declinedRecoveredCount;
        }
        if (obj.declinedOutstandingCount != undefined) {
            o.declinedOutstandingCount = obj.declinedOutstandingCount;
        }
        if (obj.declinedDisenroledCount != undefined) {
            o.declinedDisenroledCount = obj.declinedDisenroledCount;
        }
        if (obj.approvedReceivedCount != undefined) {
            o.approvedReceivedCount = obj.approvedReceivedCount;
        }
        if (obj.approvedRefundedCount != undefined) {
            o.approvedRefundedCount = obj.approvedRefundedCount;
        }
        if (obj.approvedDisenroledCount != undefined) {
            o.approvedDisenroledCount = obj.approvedDisenroledCount;
        }
        return o;
    };
    return DirectDebitSummary;
}(Model));

//# sourceMappingURL=direct-debit-summary.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/services/transaction.ts






var transaction_TransactionService = (function () {
    function TransactionService(http, store) {
        this.http = http;
        this.store = store;
        this.transactionsUrl = 'transactions';
        this.directDebitSummariesUrl = 'direct_debit_summaries';
    }
    TransactionService.prototype.index = function (params) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        for (var key in params) {
            searchParams.set(key, params[key]);
        }
        return this.http.get(this.transactionsUrl, options)
            .map(function (res) { return res.json().map(function (r) { return transaction_Transaction.clone(r); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.create = function (t) {
        return this.http.post(this.transactionsUrl, t.serializeForRails())
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.transfer = function (params) {
        return this.http.post(this.transactionsUrl + "/transfer", params)
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.recharge = function (id) {
        return this.http.patch(this.transactionsUrl + "/" + id + "/recharge", {})
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.batchRecharge = function (ids) {
        return this.http.patch(this.transactionsUrl + "/batch_recharge", { ids: ids })
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.recordOtherPayment = function (t) {
        return this.http.patch(this.transactionsUrl + "/" + t.parentId + "/record_other_payment", t)
            .mapTo(true)
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.directDebitSummaryFetch = function (params) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        for (var key in params) {
            searchParams.set(key, params[key]);
        }
        return this.http.get(this.directDebitSummariesUrl + "/" + params.id, options)
            .map(function (res) { return DirectDebitSummary.clone(res.json()); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.directDebitSummariesIndex = function () {
        return this.http.get(this.directDebitSummariesUrl)
            .map(function (res) { return res.json().map(function (d) { return DirectDebitSummary.clone(d); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.prototype.fetchDdsTransactions = function (params) {
        var searchParams = new http_es5["k" /* URLSearchParams */]();
        var options = { search: searchParams };
        for (var key in params) {
            searchParams.set(key, params[key]);
        }
        return this.http.get(this.directDebitSummariesUrl + "/" + params.dds_id + "/transactions", options)
            .map(function (res) { return res.json().map(function (t) { return transaction_Transaction.clone(t); }); })
            .catch(function (error) { return Rx["Observable"].throw(error.json()); });
    };
    TransactionService.ctorParameters = function () { return [{ type: angular2_token_es5["a" /* Angular2TokenService */] }, { type: _ngrx_store["f" /* Store */] }]; };
    return TransactionService;
}());

//# sourceMappingURL=transaction.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/transaction.ts
var transaction___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transaction___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var transaction_TransactionEffects = (function () {
    function TransactionEffects(actions, transactionService, contactService) {
        var _this = this;
        this.actions = actions;
        this.transactionService = transactionService;
        this.contactService = contactService;
        this.index = this.actions
            .ofType(FETCH_TRANSACTIONS, FETCH_POTENTIAL_TRANSACTIONS)
            .switchMap(function (action) { return _this.transactionService.index(action.payload)
            .map(function (payload) {
            switch (action.type) {
                case FETCH_TRANSACTIONS:
                    return { type: POPULATE_TRANSCATIONS, payload: payload };
                case FETCH_POTENTIAL_TRANSACTIONS:
                    return { type: POPULATE_POTENTIAL_TRANSACTIONS, payload: payload };
            }
        })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_TRANSACTIONS_FAILURE }); }); })
            .share();
        this.fetchDebtor = this.actions
            .ofType(FETCH_DEBTOR)
            .map(function (action) { return action.payload; })
            .switchMap(function (id) { return _this.contactService.fetch(id)
            .map(function (payload) { return ({ type: POPULATE_ACTIVE_DEBTOR, payload: payload }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_DEBTOR_FAILURE }); }); })
            .share();
        this.create = this.actions
            .ofType(CREATE_TRANSACTION)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.create(payload)
            .map(function () { return ({ type: CREATED_TRANSACTION }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_TRANSACTION_FAILURE }); }); })
            .share();
        this.transfer = this.actions
            .ofType(CREATE_TRANSACTION_TRANSFER)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.transfer(payload)
            .map(function () { return ({ type: CREATED_TRANSACTION_TRANSFER }); })
            .catch(function (response) { return Observable["Observable"].of({ type: CREATE_TRANSACTION_TRANSFER_FAILURE }); }); })
            .share();
        this.recharge = this.actions
            .ofType(RECHARGE_TRANSACTION)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.recharge(payload)
            .map(function () { return ({ type: RECHARGED_TRANSACTION }); })
            .catch(function (response) { return Observable["Observable"].of({ type: RECHARGE_TRANSACTION_FAILURE }); }); })
            .share();
        this.batchRecharge = this.actions
            .ofType(RECHARGE_TRANSACTIONS)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.batchRecharge(payload)
            .map(function () { return ({ type: RECHARGED_TRANSACTION }); })
            .catch(function (response) { return Observable["Observable"].of({ type: RECHARGE_TRANSACTION_FAILURE }); }); })
            .share();
        this.recordOtherPayment = this.actions
            .ofType(RECORD_OTHER_PAYMENT)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.recordOtherPayment(payload)
            .map(function () { return ({ type: RECORDED_OTHER_PAYMENT }); })
            .catch(function (response) { return Observable["Observable"].of({ type: RECORD_OTHER_PAYMENT_FAILURE }); }); })
            .share();
        this.fetchDirectDebitSummary = this.actions
            .ofType(FETCH_DIRECT_DEBIT_SUMMARY)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.transactionService.directDebitSummaryFetch(payload)
            .map(function (payload) { return ({ type: POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY, payload: payload }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_DIRECT_DEBIT_SUMMARY_FAILURE }); }); })
            .share();
        this.fetchDirectDebitSummaries = this.actions
            .ofType(FETCH_DIRECT_DEBIT_SUMMARIES)
            .switchMap(function () { return _this.transactionService.directDebitSummariesIndex()
            .map(function (payload) { return ({ type: POPULATE_DIRECT_DEBIT_SUMMARIES, payload: payload }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE }); }); })
            .share();
        this.fetchDdsTransactions = this.actions
            .ofType(FETCH_DDS_TRANSACTIONS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.transactionService.fetchDdsTransactions(params)
            .map(function (payload) { return ({ type: POPULATE_TRANSCATIONS, payload: payload }); })
            .catch(function (response) { return Observable["Observable"].of({ type: FETCH_DDS_TRANSACTIONS_FAILURE }); }); })
            .share();
    }
    TransactionEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: transaction_TransactionService }, { type: contact_ContactService }]; };
    return TransactionEffects;
}());

transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "index", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "fetchDebtor", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "create", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "transfer", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "recharge", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "batchRecharge", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "recordOtherPayment", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "fetchDirectDebitSummary", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "fetchDirectDebitSummaries", void 0);
transaction___decorate([
    Object(effects["b" /* Effect */])(),
    transaction___metadata("design:type", Object)
], transaction_TransactionEffects.prototype, "fetchDdsTransactions", void 0);
//# sourceMappingURL=transaction.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/app/reducers/effects/comm.ts
var comm___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var comm___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var comm_CommEffects = (function () {
    function CommEffects(actions, commService) {
        var _this = this;
        this.actions = actions;
        this.commService = commService;
        this.index = this.actions
            .ofType(FETCH_TEMPLATES)
            .map(function (action) { return action.payload; })
            .switchMap(function () { return _this.commService.templatesIndex()
            .map(function (payload) { return ({ type: POPULATE_TEMPLATES, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_TEMPLATES_FAILURE }); }); });
        this.commSendsIndex = this.actions
            .ofType(FETCH_COMM_SENDS)
            .map(function (action) { return action.payload; })
            .switchMap(function (payload) { return _this.commService.commSendsIndex(payload)
            .map(function (payload) { return ({ type: POPULATE_COMM_SENDS, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_COMM_SENDS_FAILURE }); }); });
        this.commReceiptsIndex = this.actions
            .ofType(FETCH_COMM_RECEIPTS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.commService.commReceiptsIndex(params)
            .map(function (payload) { return ({ type: POPULATE_COMM_RECEIPTS, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_COMM_RECEIPTS_FAILURE }); }); });
        this.emailPreview = this.actions
            .ofType(FETCH_EMAIL_PREVIEW)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.commService.emailPreview(params)
            .map(function (payload) { return ({ type: POPULATE_EMAIL_PREVIEW, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: FETCH_EMAIL_PREVIEW_FAILURE }); }); });
        this.numberOfRecipients = this.actions
            .ofType(GET_NUMBER_OF_RECIPIENTS)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.commService.numberOfRecipients(params)
            .map(function (payload) { return ({ type: POPULATE_NUMBER_OF_RECIPIENTS, payload: payload }); })
            .catch(function () { return Observable["Observable"].of({ type: GET_NUMBER_OF_RECIPIENTS_FAILURE }); }); });
        this.reloadEmailTemplates = this.actions
            .ofType(RELOAD_EMAIL_TEMPLATES)
            .switchMap(function () { return _this.commService.reloadEmailTemplates()
            .map(function () { return ({ type: RELOAD_EMAIL_TEMPLATES_SUCCESS }); })
            .catch(function () { return Observable["Observable"].of({ type: RELOAD_EMAIL_TEMPLATES_FAILURE }); }); });
        this.sendComm = this.actions
            .ofType(SEND_COMM)
            .map(function (action) { return action.payload; })
            .switchMap(function (params) { return _this.commService.sendComm(params)
            .map(function () { return ({ type: SENT_COMM }); })
            .catch(function () { return Observable["Observable"].of({ type: SEND_COMM_FAILURE }); }); });
    }
    CommEffects.ctorParameters = function () { return [{ type: effects["a" /* Actions */] }, { type: comm_CommService }]; };
    return CommEffects;
}());

comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "index", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "commSendsIndex", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "commReceiptsIndex", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "emailPreview", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "numberOfRecipients", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "reloadEmailTemplates", void 0);
comm___decorate([
    Object(effects["b" /* Effect */])(),
    comm___metadata("design:type", Object)
], comm_CommEffects.prototype, "sendComm", void 0);
//# sourceMappingURL=comm.js.map
// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/@ngrx/effects/src/effects.module.js
var effects_module = __webpack_require__("Wgxb");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-resizable-element/dist/esm/src/resizable.module.js
var resizable_module = __webpack_require__("7wjn");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-draggable-droppable/dist/esm/src/drag-and-drop.module.js
var drag_and_drop_module = __webpack_require__("g6o0");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-calendar/dist/esm/src/calendar.module.js + 13 modules
var calendar_module = __webpack_require__("YP0E");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng2-completer/ng2-completer.module.js
var ng2_completer_module = __webpack_require__("hko3");

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/angular-date-value-accessor/module.js
var angular_date_value_accessor_module = __webpack_require__("CJCw");
var module_default = /*#__PURE__*/__webpack_require__.n(angular_date_value_accessor_module);

// EXTERNAL MODULE: /Users/jason/src/matrix/client/node_modules/ng-click-outside/lib/click-outside.module.js
var click_outside_module = __webpack_require__("GhE0");
var click_outside_module_default = /*#__PURE__*/__webpack_require__.n(click_outside_module);

// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/$$_gendir/app/app.module.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














































































































































var AppModuleNgFactory = core_es5["ɵcmf"](AppModule, [app_component_AppComponent], function (_l) {
    return core_es5["ɵmod"]([core_es5["ɵmpd"](512, core_es5["ComponentFactoryResolver"], core_es5["ɵCodegenComponentFactoryResolver"], [[8, [calendarTooltip_directive_ngfactory["a" /* CalendarTooltipWindowComponentNgFactory */], PurchaseTicketComponentNgFactory,
                    OnlineEnrolmentViewComponentNgFactory, MainComponentNgFactory, EnrolmentTimetableViewComponentNgFactory,
                    WorkshopsViewComponentNgFactory, CalendarViewComponentNgFactory,
                    CommsViewComponentNgFactory, RolesViewComponentNgFactory, AdminAreaViewComponentNgFactory,
                    ClassRolloverViewComponentNgFactory, EnrolmentRolloverViewComponentNgFactory,
                    AcademicRolloverViewComponentNgFactory, WorkshopsRolloverViewComponentNgFactory,
                    DirectDebitSummaryViewComponentNgFactory, TransactionsByDebtorViewComponentNgFactory,
                    ContactFormComponentNgFactory, EnquiryFormComponentNgFactory,
                    SetClassFormComponentNgFactory, EnrolmentFormComponentNgFactory,
                    CalendarDayFormComponentNgFactory, AbsenceFormComponentNgFactory,
                    WorkshopCampusFormComponentNgFactory, WindowFormComponentNgFactory,
                    TutorAllocationFormComponentNgFactory, BookingFormComponentNgFactory,
                    WorkshopAbsenceFormComponentNgFactory, BookingRemovalFormComponentNgFactory,
                    SetRolloverFormComponentNgFactory, ChangeClassFormComponentNgFactory,
                    DisenrolmentFormComponentNgFactory, CreateTransactionViewComponentNgFactory,
                    CreateTransactionFormComponentNgFactory, AddDiscountFormComponentNgFactory,
                    TicketFormComponentNgFactory, AppComponentNgFactory]], [3, core_es5["ComponentFactoryResolver"]],
            core_es5["NgModuleRef"]]), core_es5["ɵmpd"](5120, core_es5["LOCALE_ID"], core_es5["ɵm"], [[3, core_es5["LOCALE_ID"]]]),
        core_es5["ɵmpd"](4608, common_es5["NgLocalization"], common_es5["NgLocaleLocalization"], [core_es5["LOCALE_ID"]]),
        core_es5["ɵmpd"](5120, core_es5["APP_ID"], core_es5["ɵf"], []), core_es5["ɵmpd"](5120, core_es5["IterableDiffers"], core_es5["ɵk"], []), core_es5["ɵmpd"](5120, core_es5["KeyValueDiffers"], core_es5["ɵl"], []),
        core_es5["ɵmpd"](4608, platform_browser_es5["c" /* DomSanitizer */], platform_browser_es5["t" /* ɵe */], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](6144, core_es5["Sanitizer"], null, [platform_browser_es5["c" /* DomSanitizer */]]), core_es5["ɵmpd"](4608, platform_browser_es5["f" /* HAMMER_GESTURE_CONFIG */], platform_browser_es5["g" /* HammerGestureConfig */], []), core_es5["ɵmpd"](5120, platform_browser_es5["d" /* EVENT_MANAGER_PLUGINS */], function (p0_0, p1_0, p2_0, p2_1) {
            return [new platform_browser_es5["l" /* ɵDomEventsPlugin */](p0_0), new platform_browser_es5["p" /* ɵKeyEventsPlugin */](p1_0),
                new platform_browser_es5["o" /* ɵHammerGesturesPlugin */](p2_0, p2_1)];
        }, [common_es5["DOCUMENT"], common_es5["DOCUMENT"], common_es5["DOCUMENT"], platform_browser_es5["f" /* HAMMER_GESTURE_CONFIG */]]),
        core_es5["ɵmpd"](4608, platform_browser_es5["e" /* EventManager */], platform_browser_es5["e" /* EventManager */], [platform_browser_es5["d" /* EVENT_MANAGER_PLUGINS */],
            core_es5["NgZone"]]), core_es5["ɵmpd"](135680, platform_browser_es5["n" /* ɵDomSharedStylesHost */], platform_browser_es5["n" /* ɵDomSharedStylesHost */], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, platform_browser_es5["m" /* ɵDomRendererFactory2 */], platform_browser_es5["m" /* ɵDomRendererFactory2 */], [platform_browser_es5["e" /* EventManager */], platform_browser_es5["n" /* ɵDomSharedStylesHost */]]), core_es5["ɵmpd"](5120, browser_es5["a" /* AnimationDriver */], animations_es5["d" /* ɵc */], []), core_es5["ɵmpd"](5120, browser_es5["c" /* ɵAnimationStyleNormalizer */], animations_es5["e" /* ɵd */], []), core_es5["ɵmpd"](4608, browser_es5["b" /* ɵAnimationEngine */], animations_es5["c" /* ɵb */], [browser_es5["a" /* AnimationDriver */],
            browser_es5["c" /* ɵAnimationStyleNormalizer */]]), core_es5["ɵmpd"](5120, core_es5["RendererFactory2"], animations_es5["f" /* ɵe */], [platform_browser_es5["m" /* ɵDomRendererFactory2 */], browser_es5["b" /* ɵAnimationEngine */], core_es5["NgZone"]]), core_es5["ɵmpd"](6144, platform_browser_es5["q" /* ɵSharedStylesHost */], null, [platform_browser_es5["n" /* ɵDomSharedStylesHost */]]), core_es5["ɵmpd"](4608, core_es5["Testability"], core_es5["Testability"], [core_es5["NgZone"]]), core_es5["ɵmpd"](4608, platform_browser_es5["h" /* Meta */], platform_browser_es5["h" /* Meta */], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, platform_browser_es5["j" /* Title */], platform_browser_es5["j" /* Title */], [common_es5["DOCUMENT"]]), core_es5["ɵmpd"](4608, extension["a" /* DevtoolsExtension */], extension["a" /* DevtoolsExtension */], [extension["b" /* REDUX_DEVTOOLS_EXTENSION */]]),
        core_es5["ɵmpd"](4608, devtools["a" /* DevtoolsDispatcher */], devtools["a" /* DevtoolsDispatcher */], []),
        core_es5["ɵmpd"](5120, config["b" /* STORE_DEVTOOLS_CONFIG */], instrument["b" /* _createOptions */], [config["a" /* INITIAL_OPTIONS */]]),
        core_es5["ɵmpd"](4608, devtools["b" /* StoreDevtools */], devtools["b" /* StoreDevtools */], [devtools["a" /* DevtoolsDispatcher */],
            dispatcher["a" /* Dispatcher */], reducer["a" /* Reducer */], extension["a" /* DevtoolsExtension */], ng2["b" /* INITIAL_STATE */], config["b" /* STORE_DEVTOOLS_CONFIG */]]),
        core_es5["ɵmpd"](5120, router_es5["h" /* ROUTER_INITIALIZER */], router_es5["B" /* ɵi */], [router_es5["z" /* ɵg */]]), core_es5["ɵmpd"](5120, core_es5["APP_BOOTSTRAP_LISTENER"], function (p0_0, p0_1, p1_0) {
            return [bootstrap_listener["b" /* runAfterBootstrapEffects */](p0_0, p0_1), p1_0];
        }, [core_es5["Injector"], effects_subscription["a" /* EffectsSubscription */], router_es5["h" /* ROUTER_INITIALIZER */]]), core_es5["ɵmpd"](4608, forms_es5["ɵi"], forms_es5["ɵi"], []), core_es5["ɵmpd"](4608, forms_es5["FormBuilder"], forms_es5["FormBuilder"], []), core_es5["ɵmpd"](4608, _angular_animations_es5["b" /* AnimationBuilder */], animations_es5["b" /* ɵBrowserAnimationBuilder */], [core_es5["RendererFactory2"], platform_browser_es5["b" /* DOCUMENT */]]), core_es5["ɵmpd"](5120, local_data["a" /* LocalData */], completer_data_factory["c" /* localDataFactory */], []), core_es5["ɵmpd"](5120, remote_data["a" /* RemoteData */], completer_data_factory["d" /* remoteDataFactory */], [http_es5["e" /* Http */]]),
        core_es5["ɵmpd"](4608, completer_service["a" /* CompleterService */], completer_service["a" /* CompleterService */], [local_data["a" /* LocalData */], remote_data["a" /* RemoteData */]]),
        core_es5["ɵmpd"](4608, ngx_order_pipe_es5["b" /* OrderPipe */], ngx_order_pipe_es5["b" /* OrderPipe */], []), core_es5["ɵmpd"](4608, router_es5["d" /* NoPreloading */], router_es5["d" /* NoPreloading */], []), core_es5["ɵmpd"](6144, router_es5["f" /* PreloadingStrategy */], null, [router_es5["d" /* NoPreloading */]]), core_es5["ɵmpd"](135680, router_es5["q" /* RouterPreloader */], router_es5["q" /* RouterPreloader */], [router_es5["k" /* Router */], core_es5["NgModuleFactoryLoader"], core_es5["Compiler"],
            core_es5["Injector"], router_es5["f" /* PreloadingStrategy */]]), core_es5["ɵmpd"](4608, router_es5["e" /* PreloadAllModules */], router_es5["e" /* PreloadAllModules */], []), core_es5["ɵmpd"](4608, draggable_helper_provider["a" /* DraggableHelper */], draggable_helper_provider["a" /* DraggableHelper */], []), core_es5["ɵmpd"](4608, calendarEventTitleFormatter_provider["a" /* CalendarEventTitleFormatter */], calendarEventTitleFormatter_provider["a" /* CalendarEventTitleFormatter */], []), core_es5["ɵmpd"](4608, calendarDateFormatter_provider["a" /* CalendarDateFormatter */], calendarDateFormatter_provider["a" /* CalendarDateFormatter */], []), core_es5["ɵmpd"](4608, calendarUtils_provider["a" /* CalendarUtils */], calendarUtils_provider["a" /* CalendarUtils */], []), core_es5["ɵmpd"](4608, router_guard_SignInIffNotAuthorisedGuard, router_guard_SignInIffNotAuthorisedGuard, [angular2_token_es5["a" /* Angular2TokenService */], router_es5["k" /* Router */]]),
        core_es5["ɵmpd"](4608, router_guard_RedirectToMainIfSignedIn, router_guard_RedirectToMainIfSignedIn, [angular2_token_es5["a" /* Angular2TokenService */],
            router_es5["k" /* Router */]]), core_es5["ɵmpd"](4608, helpers_ConstantsHelpers, helpers_ConstantsHelpers, []), core_es5["ɵmpd"](4608, initial_InitialResolver, initial_InitialResolver, [constants_ConstantsEffects, router_es5["k" /* Router */], src_store["a" /* Store */]]), core_es5["ɵmpd"](4608, contact_view_ContactViewResolver, contact_view_ContactViewResolver, [contact_ContactEffects, matrix_class_MatrixClassEffects, router_es5["k" /* Router */],
            src_store["a" /* Store */]]), core_es5["ɵmpd"](4608, enquiry_view_EnquiryViewResolver, enquiry_view_EnquiryViewResolver, [src_store["a" /* Store */], enquiry_EnquiryEffects]), core_es5["ɵmpd"](4608, class_manager_view_ClassManagerViewResolver, class_manager_view_ClassManagerViewResolver, [matrix_class_MatrixClassEffects, router_es5["k" /* Router */], src_store["a" /* Store */]]),
        core_es5["ɵmpd"](4608, class_view_ClassViewResolver, class_view_ClassViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */]]),
        core_es5["ɵmpd"](4608, enrolment_timetable_view_EnrolmentTimetableViewResolver, enrolment_timetable_view_EnrolmentTimetableViewResolver, [contact_ContactEffects, src_store["a" /* Store */]]), core_es5["ɵmpd"](4608, workshops_view_WorkshopsViewResolver, workshops_view_WorkshopsViewResolver, [src_actions["a" /* Actions */], src_store["a" /* Store */]]), core_es5["ɵmpd"](4608, internal_event_view_InternalEventViewResolver, internal_event_view_InternalEventViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */], event_EventService]),
        core_es5["ɵmpd"](4608, events_view_EventsViewResolver, events_view_EventsViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */]]),
        core_es5["ɵmpd"](4608, event_view_EventViewResolver, event_view_EventViewResolver, [src_store["a" /* Store */], event_EventEffects,
            user_UserEffects, router_es5["k" /* Router */], angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](4608, roles_view_RolesViewResolver, roles_view_RolesViewResolver, [role_RoleEffects, src_store["a" /* Store */], src_actions["a" /* Actions */]]), core_es5["ɵmpd"](4608, calendar_view_CalendarViewResolver, calendar_view_CalendarViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */]]),
        core_es5["ɵmpd"](4608, online_enrolment_view_OnlineEnrolmentViewResolver, online_enrolment_view_OnlineEnrolmentViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */], router_es5["k" /* Router */], angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](4608, direct_debit_summary_view_DirectDebitSummaryViewResolver, direct_debit_summary_view_DirectDebitSummaryViewResolver, [src_store["a" /* Store */], router_es5["k" /* Router */], src_actions["a" /* Actions */]]), core_es5["ɵmpd"](4608, transactions_by_debtor_view_TransactionsByDebtorViewResolver, transactions_by_debtor_view_TransactionsByDebtorViewResolver, [src_store["a" /* Store */], router_es5["k" /* Router */], src_actions["a" /* Actions */]]),
        core_es5["ɵmpd"](4608, comms_view_CommsViewResolver, comms_view_CommsViewResolver, [src_store["a" /* Store */], src_actions["a" /* Actions */]]),
        core_es5["ɵmpd"](4608, modal_ModalService, modal_ModalService, []), core_es5["ɵmpd"](4608, unique_email_async_UniqueEmailAsyncValidation, unique_email_async_UniqueEmailAsyncValidation, [contact_ContactService]),
        core_es5["ɵmpd"](512, common_es5["CommonModule"], common_es5["CommonModule"], []), core_es5["ɵmpd"](1024, core_es5["ErrorHandler"], platform_browser_es5["r" /* ɵa */], []), core_es5["ɵmpd"](1024, core_es5["NgProbeToken"], function () {
            return [router_es5["u" /* ɵb */]()];
        }, []), core_es5["ɵmpd"](512, router_es5["z" /* ɵg */], router_es5["z" /* ɵg */], [core_es5["Injector"]]), core_es5["ɵmpd"](1024, core_es5["APP_INITIALIZER"], function (p0_0, p0_1, p1_0) {
            return [platform_browser_es5["s" /* ɵc */](p0_0, p0_1), router_es5["A" /* ɵh */](p1_0)];
        }, [[2, platform_browser_es5["i" /* NgProbeToken */]], [2, core_es5["NgProbeToken"]], router_es5["z" /* ɵg */]]), core_es5["ɵmpd"](512, core_es5["ApplicationInitStatus"], core_es5["ApplicationInitStatus"], [[2, core_es5["APP_INITIALIZER"]]]), core_es5["ɵmpd"](131584, core_es5["ɵe"], core_es5["ɵe"], [core_es5["NgZone"], core_es5["ɵConsole"], core_es5["Injector"], core_es5["ErrorHandler"], core_es5["ComponentFactoryResolver"],
            core_es5["ApplicationInitStatus"]]), core_es5["ɵmpd"](2048, core_es5["ApplicationRef"], null, [core_es5["ɵe"]]), core_es5["ɵmpd"](512, core_es5["ApplicationModule"], core_es5["ApplicationModule"], [core_es5["ApplicationRef"]]),
        core_es5["ɵmpd"](512, platform_browser_es5["a" /* BrowserModule */], platform_browser_es5["a" /* BrowserModule */], [[3, platform_browser_es5["a" /* BrowserModule */]]]),
        core_es5["ɵmpd"](512, ng2["c" /* StoreModule */], ng2["c" /* StoreModule */], []), core_es5["ɵmpd"](512, instrument["a" /* StoreDevtoolsModule */], instrument["a" /* StoreDevtoolsModule */], []), core_es5["ɵmpd"](1024, router_es5["t" /* ɵa */], router_es5["w" /* ɵd */], [[3,
                router_es5["k" /* Router */]]]), core_es5["ɵmpd"](512, router_es5["s" /* UrlSerializer */], router_es5["c" /* DefaultUrlSerializer */], []), core_es5["ɵmpd"](512, router_es5["b" /* ChildrenOutletContexts */], router_es5["b" /* ChildrenOutletContexts */], []), core_es5["ɵmpd"](256, router_es5["g" /* ROUTER_CONFIGURATION */], {}, []),
        core_es5["ɵmpd"](1024, common_es5["LocationStrategy"], router_es5["v" /* ɵc */], [common_es5["PlatformLocation"], [2, common_es5["APP_BASE_HREF"]],
            router_es5["g" /* ROUTER_CONFIGURATION */]]), core_es5["ɵmpd"](512, common_es5["Location"], common_es5["Location"], [common_es5["LocationStrategy"]]),
        core_es5["ɵmpd"](512, core_es5["Compiler"], core_es5["Compiler"], []), core_es5["ɵmpd"](512, core_es5["NgModuleFactoryLoader"], core_es5["SystemJsNgModuleLoader"], [core_es5["Compiler"], [2, core_es5["SystemJsNgModuleLoaderConfig"]]]),
        core_es5["ɵmpd"](1024, router_es5["i" /* ROUTES */], function () {
            return [[{ path: 'public/events/:id', resolve: { eventViewGuarantee: event_view_EventViewResolver },
                        component: purchase_ticket_PurchaseTicketComponent }, { path: 'online-enrolment', resolve: { onlineEnrolmentViewGuarantee: online_enrolment_view_OnlineEnrolmentViewResolver },
                        component: online_enrolment_view_OnlineEnrolmentViewComponent }, { path: '', component: main_MainComponent,
                        canActivate: [router_guard_SignInIffNotAuthorisedGuard], resolve: { initialGuarantee: initial_InitialResolver },
                        children: [{ path: 'contacts/:id/enrolments/new', component: enrolment_timetable_view_EnrolmentTimetableViewComponent,
                                resolve: { enrolmentFormGuarantee: enrolment_timetable_view_EnrolmentTimetableViewResolver } },
                            { path: 'workshops', resolve: { workshopsGuarantee: workshops_view_WorkshopsViewResolver },
                                component: workshops_view_WorkshopsViewComponent }, { path: 'calendar', resolve: { calendarViewGuarantee: calendar_view_CalendarViewResolver },
                                component: calendar_view_CalendarViewComponent }, { path: 'communications',
                                resolve: { commsViewGuarantee: comms_view_CommsViewResolver }, component: comms_view_CommsViewComponent },
                            { path: 'roles', component: roles_view_RolesViewComponent, resolve: { rolesViewGuarantee: roles_view_RolesViewResolver } },
                            { path: 'admin-area', component: admin_area_view_AdminAreaViewComponent }, { path: 'class-rollover',
                                component: class_rollover_view_ClassRolloverViewComponent }, { path: 'enrolment-rollover',
                                component: enrolment_rollover_view_EnrolmentRolloverViewComponent }, { path: 'academic-rollover',
                                component: academic_rollover_view_AcademicRolloverViewComponent }, { path: 'workshops-rollover',
                                component: workshops_rollover_view_WorkshopsRolloverViewComponent }, { path: 'direct-debit-summaries/:id',
                                component: direct_debit_summary_view_DirectDebitSummaryViewComponent, resolve: { ddsViewGuarantee: direct_debit_summary_view_DirectDebitSummaryViewResolver } },
                            { path: 'direct-debit-summaries/:id/:type', component: transactions_by_debtor_view_TransactionsByDebtorViewComponent,
                                resolve: { transactionsByDebtorViewGuarantee: transactions_by_debtor_view_TransactionsByDebtorViewResolver } }] }]];
        }, []), core_es5["ɵmpd"](1024, router_es5["k" /* Router */], router_es5["x" /* ɵe */], [core_es5["ApplicationRef"], router_es5["s" /* UrlSerializer */],
            router_es5["b" /* ChildrenOutletContexts */], common_es5["Location"], core_es5["Injector"], core_es5["NgModuleFactoryLoader"],
            core_es5["Compiler"], router_es5["i" /* ROUTES */], router_es5["g" /* ROUTER_CONFIGURATION */], [2, router_es5["r" /* UrlHandlingStrategy */]],
            [2, router_es5["j" /* RouteReuseStrategy */]]]), core_es5["ɵmpd"](512, router_es5["o" /* RouterModule */], router_es5["o" /* RouterModule */], [[2, router_es5["t" /* ɵa */]], [2, router_es5["k" /* Router */]]]), core_es5["ɵmpd"](512, dispatcher["a" /* Dispatcher */], dispatcher["a" /* Dispatcher */], []), core_es5["ɵmpd"](1024, extension["b" /* REDUX_DEVTOOLS_EXTENSION */], instrument["d" /* _createReduxDevtoolsExtension */], []), core_es5["ɵmpd"](256, ng2["d" /* _INITIAL_REDUCER */], rootReducer, []),
        core_es5["ɵmpd"](1024, ng2["a" /* INITIAL_REDUCER */], ng2["f" /* _initialReducerFactory */], [ng2["d" /* _INITIAL_REDUCER */]]),
        core_es5["ɵmpd"](1024, reducer["a" /* Reducer */], instrument["c" /* _createReducerIfExtension */], [extension["b" /* REDUX_DEVTOOLS_EXTENSION */],
            core_es5["Injector"], ng2["a" /* INITIAL_REDUCER */]]), core_es5["ɵmpd"](256, ng2["e" /* _INITIAL_STATE */], undefined, []), core_es5["ɵmpd"](1024, ng2["b" /* INITIAL_STATE */], ng2["g" /* _initialStateFactory */], [ng2["e" /* _INITIAL_STATE */], ng2["a" /* INITIAL_REDUCER */]]), core_es5["ɵmpd"](1024, src_state["a" /* State */], instrument["e" /* _createStateIfExtension */], [extension["b" /* REDUX_DEVTOOLS_EXTENSION */], core_es5["Injector"], ng2["b" /* INITIAL_STATE */]]), core_es5["ɵmpd"](1024, src_store["a" /* Store */], ng2["h" /* _storeFactory */], [dispatcher["a" /* Dispatcher */], reducer["a" /* Reducer */], src_state["a" /* State */]]),
        core_es5["ɵmpd"](512, src_actions["a" /* Actions */], src_actions["a" /* Actions */], [dispatcher["a" /* Dispatcher */]]), core_es5["ɵmpd"](512, http_es5["c" /* BrowserXhr */], http_es5["c" /* BrowserXhr */], []), core_es5["ɵmpd"](512, http_es5["j" /* ResponseOptions */], http_es5["b" /* BaseResponseOptions */], []), core_es5["ɵmpd"](1024, http_es5["m" /* XSRFStrategy */], http_es5["n" /* ɵb */], []), core_es5["ɵmpd"](512, http_es5["l" /* XHRBackend */], http_es5["l" /* XHRBackend */], [http_es5["c" /* BrowserXhr */], http_es5["j" /* ResponseOptions */], http_es5["m" /* XSRFStrategy */]]),
        core_es5["ɵmpd"](512, http_es5["i" /* RequestOptions */], http_es5["a" /* BaseRequestOptions */], []), core_es5["ɵmpd"](1024, http_es5["e" /* Http */], http_es5["o" /* ɵc */], [http_es5["l" /* XHRBackend */], http_es5["i" /* RequestOptions */]]), core_es5["ɵmpd"](1024, router_es5["a" /* ActivatedRoute */], router_es5["y" /* ɵf */], [router_es5["k" /* Router */]]), core_es5["ɵmpd"](512, angular2_token_es5["a" /* Angular2TokenService */], angular2_token_es5["a" /* Angular2TokenService */], [http_es5["e" /* Http */], [2, router_es5["a" /* ActivatedRoute */]], [2, router_es5["k" /* Router */]]]), core_es5["ɵmpd"](512, constant_ConstantService, constant_ConstantService, [angular2_token_es5["a" /* Angular2TokenService */], src_store["a" /* Store */]]), core_es5["ɵmpd"](512, constants_ConstantsEffects, constants_ConstantsEffects, [src_actions["a" /* Actions */], constant_ConstantService]),
        core_es5["ɵmpd"](512, ActionCableService, ActionCableService, []),
        core_es5["ɵmpd"](512, contact_ContactService, contact_ContactService, [angular2_token_es5["a" /* Angular2TokenService */],
            ActionCableService, src_store["a" /* Store */]]), core_es5["ɵmpd"](512, role_RoleService, role_RoleService, [angular2_token_es5["a" /* Angular2TokenService */], src_store["a" /* Store */]]), core_es5["ɵmpd"](512, user_UserEffects, user_UserEffects, [src_actions["a" /* Actions */], contact_ContactService, role_RoleService, angular2_token_es5["a" /* Angular2TokenService */]]),
        core_es5["ɵmpd"](512, enrolment_EnrolmentService, enrolment_EnrolmentService, [angular2_token_es5["a" /* Angular2TokenService */],
            ActionCableService, src_store["a" /* Store */]]), core_es5["ɵmpd"](512, contact_ContactEffects, contact_ContactEffects, [src_actions["a" /* Actions */], contact_ContactService, enrolment_EnrolmentService]), core_es5["ɵmpd"](512, enquiry_EnquiryService, enquiry_EnquiryService, [angular2_token_es5["a" /* Angular2TokenService */], ActionCableService,
            src_store["a" /* Store */]]), core_es5["ɵmpd"](512, matrix_class_MatrixClassService, matrix_class_MatrixClassService, [angular2_token_es5["a" /* Angular2TokenService */], src_store["a" /* Store */]]), core_es5["ɵmpd"](512, enquiry_EnquiryEffects, enquiry_EnquiryEffects, [src_actions["a" /* Actions */], enquiry_EnquiryService, matrix_class_MatrixClassService]),
        core_es5["ɵmpd"](512, matrix_class_MatrixClassEffects, matrix_class_MatrixClassEffects, [src_actions["a" /* Actions */], matrix_class_MatrixClassService]),
        core_es5["ɵmpd"](512, enrolment_EnrolmentEffects, enrolment_EnrolmentEffects, [src_actions["a" /* Actions */], enrolment_EnrolmentService,
            matrix_class_MatrixClassService, contact_ContactService]), core_es5["ɵmpd"](512, term_TermService, term_TermService, [angular2_token_es5["a" /* Angular2TokenService */], ActionCableService, src_store["a" /* Store */]]),
        core_es5["ɵmpd"](512, public_holiday_PublicHolidayService, public_holiday_PublicHolidayService, [angular2_token_es5["a" /* Angular2TokenService */],
            ActionCableService, src_store["a" /* Store */]]), core_es5["ɵmpd"](512, calendar_CalendarEffects, calendar_CalendarEffects, [src_actions["a" /* Actions */], term_TermService, public_holiday_PublicHolidayService]),
        core_es5["ɵmpd"](512, workshop_WorkshopService, workshop_WorkshopService, [angular2_token_es5["a" /* Angular2TokenService */]]),
        core_es5["ɵmpd"](512, workshop_WorkshopEffects, workshop_WorkshopEffects, [src_actions["a" /* Actions */], workshop_WorkshopService]),
        core_es5["ɵmpd"](512, tutor_allocation_TutorAllocationService, tutor_allocation_TutorAllocationService, [angular2_token_es5["a" /* Angular2TokenService */]]),
        core_es5["ɵmpd"](512, tutor_allocation_TutorAllocationEffects, tutor_allocation_TutorAllocationEffects, [src_actions["a" /* Actions */],
            tutor_allocation_TutorAllocationService]), core_es5["ɵmpd"](512, booking_BookingService, booking_BookingService, [angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](512, booking_BookingEffects, booking_BookingEffects, [src_actions["a" /* Actions */], booking_BookingService, contact_ContactService]), core_es5["ɵmpd"](512, event_EventService, event_EventService, [angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](512, ticket_TicketService, ticket_TicketService, [angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](512, event_EventEffects, event_EventEffects, [src_actions["a" /* Actions */], event_EventService, ticket_TicketService]),
        core_es5["ɵmpd"](512, role_RoleEffects, role_RoleEffects, [src_actions["a" /* Actions */], role_RoleService]),
        core_es5["ɵmpd"](512, transaction_TransactionService, transaction_TransactionService, [angular2_token_es5["a" /* Angular2TokenService */],
            src_store["a" /* Store */]]), core_es5["ɵmpd"](512, transaction_TransactionEffects, transaction_TransactionEffects, [src_actions["a" /* Actions */], transaction_TransactionService, contact_ContactService]), core_es5["ɵmpd"](512, comm_CommService, comm_CommService, [angular2_token_es5["a" /* Angular2TokenService */]]), core_es5["ɵmpd"](512, comm_CommEffects, comm_CommEffects, [src_actions["a" /* Actions */], comm_CommService]), core_es5["ɵmpd"](1024, effects_subscription["b" /* effects */], function (p0_0, p1_0, p2_0, p3_0, p4_0, p5_0, p6_0, p7_0, p8_0, p9_0, p10_0, p11_0, p12_0, p13_0) {
            return [p0_0, p1_0, p2_0, p3_0, p4_0, p5_0, p6_0, p7_0, p8_0, p9_0, p10_0, p11_0,
                p12_0, p13_0];
        }, [constants_ConstantsEffects, user_UserEffects, contact_ContactEffects, enquiry_EnquiryEffects,
            matrix_class_MatrixClassEffects, enrolment_EnrolmentEffects, calendar_CalendarEffects,
            workshop_WorkshopEffects, tutor_allocation_TutorAllocationEffects, booking_BookingEffects,
            event_EventEffects, role_RoleEffects, transaction_TransactionEffects, comm_CommEffects]),
        core_es5["ɵmpd"](131584, effects_subscription["a" /* EffectsSubscription */], effects_subscription["a" /* EffectsSubscription */], [src_store["a" /* Store */],
            [3, effects_subscription["a" /* EffectsSubscription */]], [2, effects_subscription["b" /* effects */]]]), core_es5["ɵmpd"](512, effects_module["a" /* EffectsModule */], effects_module["a" /* EffectsModule */], [effects_subscription["a" /* EffectsSubscription */]]), core_es5["ɵmpd"](512, forms_es5["ɵba"], forms_es5["ɵba"], []), core_es5["ɵmpd"](512, forms_es5["FormsModule"], forms_es5["FormsModule"], []),
        core_es5["ɵmpd"](512, forms_es5["ReactiveFormsModule"], forms_es5["ReactiveFormsModule"], []),
        core_es5["ɵmpd"](512, http_es5["f" /* HttpModule */], http_es5["f" /* HttpModule */], []), core_es5["ɵmpd"](512, animations_es5["a" /* BrowserAnimationsModule */], animations_es5["a" /* BrowserAnimationsModule */], []), core_es5["ɵmpd"](512, resizable_module["a" /* ResizableModule */], resizable_module["a" /* ResizableModule */], []), core_es5["ɵmpd"](512, drag_and_drop_module["a" /* DragAndDropModule */], drag_and_drop_module["a" /* DragAndDropModule */], []), core_es5["ɵmpd"](512, calendar_module["a" /* CalendarModule */], calendar_module["a" /* CalendarModule */], []), core_es5["ɵmpd"](512, ng2_completer_module["a" /* Ng2CompleterModule */], ng2_completer_module["a" /* Ng2CompleterModule */], []), core_es5["ɵmpd"](512, angular_date_value_accessor_module["DateValueAccessorModule"], angular_date_value_accessor_module["DateValueAccessorModule"], []), core_es5["ɵmpd"](512, ngx_order_pipe_es5["a" /* OrderModule */], ngx_order_pipe_es5["a" /* OrderModule */], []), core_es5["ɵmpd"](512, click_outside_module["ClickOutsideModule"], click_outside_module["ClickOutsideModule"], []), core_es5["ɵmpd"](512, AppModule, AppModule, []),
        core_es5["ɵmpd"](256, config["a" /* INITIAL_OPTIONS */], { maxAge: 30 }, [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==
//# sourceMappingURL=app.module.ngfactory.js.map
// CONCATENATED MODULE: /Users/jason/src/matrix/client/src/main.ts




if (environment.production) {
    Object(core_es5["enableProdMode"])();
}
Object(platform_browser_es5["k" /* platformBrowser */])().bootstrapModuleFactory(AppModuleNgFactory)
    .catch(function (err) { return console.log(err); });
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "gFIY":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "gFIY";

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.cf70fdce964164e2b339.bundle.js